// Hard Problems 数据集
// 涵盖数学、物理、化学、生物、计算机、哲学、工程、社会科学等
// 每条记录包含：基本信息 + 小朋友能懂的解释 + AI 求解 prompt 模板 + 视频介绍 + 用户参与方式

export const CATEGORIES = [
  { id: 'mathematics',  name: '数学',     icon: '∑', color: 'from-blue-500 to-cyan-500',     blurb: '关于数、空间、结构的奥秘' },
  { id: 'physics',      name: '物理',     icon: '⚛', color: 'from-violet-500 to-fuchsia-500', blurb: '关于宇宙和物质如何运作' },
  { id: 'chemistry',    name: '化学',     icon: '⚗', color: 'from-emerald-500 to-teal-500',  blurb: '关于分子和物质如何变化' },
  { id: 'biology',      name: '生命科学', icon: '🧬', color: 'from-lime-500 to-green-500',   blurb: '关于生命如何运作' },
  { id: 'cs',           name: '计算机',   icon: '⌘', color: 'from-orange-500 to-rose-500',  blurb: '关于算法、智能和信息' },
  { id: 'philosophy',   name: '哲学',     icon: '?',  color: 'from-amber-500 to-yellow-500',  blurb: '关于意识、意义和价值' },
  { id: 'engineering',  name: '工程',     icon: '⚙', color: 'from-slate-500 to-zinc-500',    blurb: '把想法变成现实' },
  { id: 'social',       name: '社会',     icon: '👥', color: 'from-pink-500 to-red-500',     blurb: '关于人和社会的运作' },
  { id: 'materials',     name: '材料',     icon: '🧪', color: 'from-amber-600 to-orange-500',  blurb: '关于新材料的发现、设计与性能' }
];

// 挑战者勋章（基于解题数自动发放）
export const BADGES = [
  { id: 'newcomer',     name: '新手',     icon: '🌱', min_score: 0,        min_solutions: 0,  color: 'text-emerald-300' },
  { id: 'explorer',     name: '探索者',   icon: '🔍', min_score: 100,      min_solutions: 1,  color: 'text-cyan-300' },
  { id: 'thinker',      name: '思考者',   icon: '💭', min_score: 300,      min_solutions: 3,  color: 'text-violet-300' },
  { id: 'researcher',   name: '研究员',   icon: '🔬', min_score: 800,      min_solutions: 8,  color: 'text-blue-300' },
  { id: 'solver',       name: '解题者',   icon: '🧩', min_score: 2000,     min_solutions: 20, color: 'text-amber-300' },
  { id: 'pioneer',      name: '先驱',     icon: '🚀', min_score: 5000,     min_solutions: 50, color: 'text-fuchsia-300' },
  { id: 'legend',       name: '传奇',     icon: '👑', min_score: 15000,    min_solutions: 100,color: 'text-rose-300' }
];

export function getBadgesForUser(user) {
  const score = user.totalScore || 0;
  const solCount = user.solutionCount || 0;
  return BADGES.filter(b => score >= b.min_score && solCount >= b.min_solutions);
}

// 参与方式字典（用于前端 i18n 和 UI 展示）
export const PARTICIPATE_TYPES = {
  solve:           { icon: '🧠', color: 'text-violet-300',   bg: 'bg-violet-500/10',   label: '求解/证明',    desc: '用数学/逻辑写出严格证明，或找到反例' },
  code:            { icon: '💻', color: 'text-cyan-300',     bg: 'bg-cyan-500/10',     label: '写代码/算法',  desc: '用代码实现算法、模拟或数值实验' },
  experiment:      { icon: '🔬', color: 'text-emerald-300',  bg: 'bg-emerald-500/10',  label: '动手实验',    desc: '设计并执行物理/化学/生物实验，收集数据' },
  data:            { icon: '📊', color: 'text-blue-300',     bg: 'bg-blue-500/10',     label: '数据收集/标注', desc: '收集、清洗或标注数据集' },
  survey:          { icon: '📚', color: 'text-amber-300',    bg: 'bg-amber-500/10',    label: '文献综述',    desc: '阅读并总结已有论文/书籍，写综述' },
  discuss:         { icon: '💬', color: 'text-fuchsia-300',  bg: 'bg-fuchsia-500/10',  label: '想法/讨论',   desc: '在论坛/社区发表你的思路、问题、反驳' },
  prototype:       { icon: '🛠️', color: 'text-orange-300',  bg: 'bg-orange-500/10',   label: '原型设计',    desc: '设计并搭建硬件/软件原型' },
  community:       { icon: '🤝', color: 'text-rose-300',     bg: 'bg-rose-500/10',     label: '社区/组织',   desc: '组织或参与社区活动、众包项目' },
  'citizen-science':{ icon: '🌍', color: 'text-lime-300',   bg: 'bg-lime-500/10',     label: '公民科学',    desc: '参与面向公众的科学项目' },
  'kid-project':   { icon: '🧒', color: 'text-yellow-300',   bg: 'bg-yellow-500/10',   label: '儿童项目',    desc: '和小朋友一起做适合的子项目' },
  visualize:       { icon: '🎨', color: 'text-pink-300',     bg: 'bg-pink-500/10',     label: '可视化',      desc: '制作信息图、动画或交互式可视化' },
  model:           { icon: '📐', color: 'text-indigo-300',   bg: 'bg-indigo-500/10',   label: '建模/模拟',   desc: '建立数学/计算模型，模拟真实系统' },
  analyze:         { icon: '📈', color: 'text-teal-300',     bg: 'bg-teal-500/10',     label: '数据分析',    desc: '用统计/ML 方法分析已有数据' },
  essay:           { icon: '✍️', color: 'text-sky-300',      bg: 'bg-sky-500/10',      label: '写文章/论文',  desc: '撰写研究文章、博客或论文' },
  team:            { icon: '👥', color: 'text-violet-300',   bg: 'bg-violet-500/10',   label: '组队',        desc: '找到合作者，分工合作' },
  translate:       { icon: '🌐', color: 'text-emerald-300',  bg: 'bg-emerald-500/10',  label: '翻译/本地化',  desc: '把资料翻译成你的母语' },
  teach:           { icon: '🎓', color: 'text-amber-300',    bg: 'bg-amber-500/10',    label: '教学/讲解',   desc: '给其他人讲解这个问题' },
  fund:            { icon: '💰', color: 'text-yellow-300',   bg: 'bg-yellow-500/10',   label: '资助/投资',   desc: '给研究者或项目提供资金' }
};

export const PROBLEMS = [
  {
    id: 'millennium-riemann',
    category: 'mathematics',
    title: '黎曼猜想',
    titleJa: '黎曼猜想',
    titleEs: 'Todos los ceros no triviales de la función zeta de Riemann se encuentran en la recta Re(s) = 1/2 en el plano complejo.',
    titleEn: 'Riemann Hypothesis',
    year: 1859,
    proposer: 'Bernhard Riemann',
    difficulty: 5,
    reward: 5000,
    status: 'open',
    summary: '素数在自然数中出现的规律，到底有没有完美的数学解释？',
    summaryJa: '素数在自然数中出现的规律，到底有没有完美的数学解释？',
    summaryEs: 'Todos los ceros no triviales de la función zeta de Riemann se encuentran en la recta Re(s) = 1/2 en el plano complejo.',
    summaryEn: 'Does the distribution of prime numbers have a perfect mathematical explanation?',
    kid: '想象你有无穷多个糖果罐，每个罐子装着不同数量的糖果。素数（2、3、5、7、11...）就是那些"只能被1和自己整除"的特殊罐子。数学家们相信这些罐子有一种隐藏的排列方式。黎曼猜想就是要把这个隐藏的规律用数学公式写下来。如果写对了，能拿到100万美元！',
    kidEn: 'Imagine you have infinitely many jars of candy, each jar holding a different number of candies. The \'prime\' jars are special: 2, 3, 5, 7, 11... they can only be split evenly by 1 and themselves. Mathematicians believe these jars follow a hidden pattern. The Riemann Hypothesis is about writing that hidden pattern as a clean math formula. Get it right and the Clay Foundation gives you $1 million!',
    formal: '黎曼 ζ 函数的所有非平凡零点都位于复平面 Re(s) = 1/2 这条直线上。',
    formalJa: '黎曼 ζ 函数的所有非平凡零点都位于复平面 Re(s) = 1/2 这条直线上。',
    formalEs: 'Todos los ceros no triviales de la función zeta de Riemann se encuentran en la recta Re(s) = 1/2 en el plano complejo.',
    formalEn: 'All non-trivial zeros of the Riemann zeta function ζ(s) lie on the critical line Re(s) = 1/2 in the complex plane.',
    whyHard: '它和数论中几乎所有重要猜想纠缠在一起；过去 165 年没人能证明，也没人能举出反例。',
    whyHardEn: 'It is entangled with almost every important conjecture in number theory; in 165 years no one has proven it, and no one has produced a counterexample.',
    aiPrompt: '你是一位友好的数学老师，向一个 12 岁的小朋友解释黎曼猜想。然后给出一份严谨的陈述、当前的研究状态、关键思路、关键参考文献。',
    aiPromptEn: 'You are a friendly math teacher. Explain the Riemann Hypothesis to a 12-year-old, then give a rigorous statement, current research state, key approaches, and key references.',
    tags: ['千禧年问题', '数论', '素数'],
    videoUrl: 'https://www.youtube.com/embed/zlm1axtsNIY',
    videoTitle: 'Riemann\'s Prime Numbers — 3Blue1Brown',
    videoChannel: '3Blue1Brown',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明所有非平凡零点在临界线上' }, { type: 'code', label: '写代码/算法', desc: '用 Python/SageMath 数值计算前 10¹² 个零点验证' }, { type: 'survey', label: '文献综述', desc: '阅读 Bombieri 的零点评述' }, { type: 'discuss', label: '想法/讨论', desc: '在 MathOverflow 跟踪最新讨论' }]
  },
  {
    id: 'millennium-pvsnp',
    category: 'mathematics',
    title: 'P vs NP',
    titleJa: 'P対NP',
    titleEs: '¿Se cumple P = NP? Si todo problema cuya respuesta se pueda verificar en tiempo polinomial también se pueda resolver en tiempo polinomial.',
    titleEn: 'P versus NP',
    year: 1971,
    proposer: 'Stephen Cook / Leonid Levin',
    difficulty: 5,
    reward: 5000,
    status: 'open',
    summary: '能快速"验证"的问题，是不是也一定能"快速"解出来？',
    summaryJa: '素早く「検証」できる問題は、「素早く」解決できますか？',
    summaryEs: '¿Se cumple P = NP? Si todo problema cuya respuesta se pueda verificar en tiempo polinomial también se pueda resolver en tiempo polinomial.',
    summaryEn: 'Can every problem whose solution can be quickly verified also be quickly solved?',
    kid: '想象你在玩数独。如果有人给你一个数独盘面，你可以很快判断"对不对"。但要从空白开始填出一个数独答案，可能就要花很久。P vs NP 问的是：是不是所有"容易检查答案"的问题，"找答案"也容易？如果是，那整个世界很多难题都会变得超级简单（比如设计最棒的学校课表）。',
    kidEn: 'Some puzzles are easy to check answers for but hard to solve. For example, a Sudoku: once you see a solution, you can quickly verify it is correct, but finding it took effort. P vs NP asks: does this always happen, or is there a faster way?',
    formal: 'P = NP 是否成立？如果每个答案能在多项式时间内验证的问题也能在多项式时间内求解。',
    formalJa: 'P = NPは真ですか？各回答が多項式時間で検証できる場合、問題は多項式時間で解決することもできます。',
    formalEs: '¿Se cumple P = NP? Si todo problema cuya respuesta se pueda verificar en tiempo polinomial también se pueda resolver en tiempo polinomial.',
    formalEn: 'Does P (problems solvable in polynomial time) equal NP (problems whose solutions are verifiable in polynomial time)?',
    whyHard: '这是整个计算机科学和数学的核心问题；和密码学、优化、人工智能、组合数学都有关。',
    whyHardEn: 'It is the central question in theoretical computer science. Resolving it would unlock (or prove impossible) thousands of algorithms in optimization, cryptography, AI, and biology.',
    aiPrompt: '向一个 12 岁的小朋友解释 P vs NP 问题，用数独、找路线等例子。给出严谨陈述、研究现状、可能的思路。',
    aiPromptEn: 'Explain P vs NP to a 12-year-old. Cover: what each class means, why it matters, the main approaches (relativization, natural proofs, algebrization), and the most recent breakthrough attempts.',
    tags: ['千禧年问题', '计算复杂性', '算法'],
    videoUrl: 'https://www.youtube.com/embed/YX40jAHY5b0',
    videoTitle: 'P vs NP — udacity',
    videoChannel: 'Udacity',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明 P≠NP 或 P=NP' }, { type: 'code', label: '写代码/算法', desc: '用 SAT 求解器跑基准测试' }, { type: 'survey', label: '文献综述', desc: '阅读 Aaronson 的 P vs NP 综述' }, { type: 'essay', label: '写文章/论文', desc: '写一篇面向中学生的科普' }]
  },
  {
    id: 'millennium-yangmills',
    category: 'physics',
    title: '杨-米尔斯质量间隙',
    titleJa: 'ヤン・ミルズ質量ギャップ',
    titleEs: 'En la teoría de Yang-Mills sobre ℝ⁴, se demuestra que existe una brecha de masa Δ > 0, y se proporciona una prueba matemática rigurosa de su existencia.',
    titleEn: 'Yang–Mills Existence and Mass Gap',
    year: 1954,
    proposer: 'C. N. Yang / R. Mills',
    difficulty: 5,
    reward: 5000,
    status: 'open',
    summary: '为什么承载力的粒子（如胶子）有质量，但描述它们的方程似乎预言它们应该无质量？',
    summaryJa: 'なぜ力を持つ粒子（グルーオンなど）には質量があるが、それらを記述する方程式は質量がないはずであると予測しているように見えるのか？',
    summaryEs: 'En la teoría de Yang-Mills sobre ℝ⁴, se demuestra que existe una brecha de masa Δ > 0, y se proporciona una prueba matemática rigurosa de su existencia.',
    summaryEn: 'Why can we describe the strong force with math, but cannot rigorously prove it exists?',
    kid: '想象一群小朋友手拉手围成一个圈传递皮球。球传递得很快（无质量）。但当他们拉得更紧时，球好像变重了。物理学家写下的方程（杨-米尔斯方程）说这些"球"应该没质量，但实验却发现它们有！这个矛盾就是"质量间隙"问题。',
    kidEn: 'There are 4 fundamental forces: gravity, electricity, weak force, and strong force. The strong force is what holds the nucleus together. We have a beautiful theory for it (Yang-Mills) that works perfectly, but nobody has been able to mathematically prove that the theory actually has the right answers. Strange!',
    formal: '在 ℝ⁴ 上的杨-米尔斯理论中，证明存在质量间隙 Δ > 0，并给出严格的数学存在性证明。',
    formalJa: 'φに関するヤン・ミルズ理論では、質量ギャップΔ > 0が存在することが証明され、厳密な数学的存在証明が与えられている。',
    formalEs: 'En la teoría de Yang-Mills sobre ℝ⁴, se demuestra que existe una brecha de masa Δ > 0, y se proporciona una prueba matemática rigurosa de su existencia.',
    formalEn: 'Prove that for any compact simple gauge group G, a non-trivial Yang-Mills theory on R⁴ exists and has a mass gap Δ > 0.',
    whyHard: '需要把量子场论用严格的数学语言描述，目前还没有数学工具能完全做到。',
    whyHardEn: 'It requires bridging the gap between physics intuition (which works) and rigorous mathematics (which has not yet been built). Related to the four-dimensional Yang-Mills existence and mass gap problem.',
    aiPrompt: '用形象比喻解释杨-米尔斯质量间隙，给出严谨陈述、研究进展。',
    aiPromptEn: 'Explain the Yang-Mills existence and mass gap to a 12-year-old. Cover: what is gauge theory, why mass gap matters, the Hodge structure analogy, and what progress has been made.',
    tags: ['千禧年问题', '量子场论', '规范场'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Yang-Mills & Mass Gap',
    videoChannel: 'Quanta',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '用格点规范理论证明存在 Δ>0' }, { type: 'code', label: '写代码/算法', desc: '用 Python 实现 Wilson 网格' }, { type: 'model', label: '建模/模拟', desc: '建立简化的 1+1 维模型' }, { type: 'survey', label: '文献综述', desc: '读 Witten 论文' }]
  },
  {
    id: 'millennium-navierstokes',
    category: 'mathematics',
    title: '纳维-斯托克斯方程',
    titleJa: 'Navier - Stokes方程式',
    titleEs: 'Demuestre que la solución al problema del valor inicial de la ecuación incompresible de Navier-Stokes en ℝ³ existe y es suave, o construya un contraejemplo para demostrar que existe la explosión.',
    titleEn: 'Navier–Stokes Existence and Smoothness',
    year: 1822,
    proposer: 'C. L. Navier / G. Stokes',
    difficulty: 5,
    reward: 5000,
    status: 'open',
    summary: '水为什么总是会突然变得"乱七八糟"？我们能不能预测？',
    summaryJa: 'なぜ水は突然「めちゃくちゃ」になるのでしょうか？予測できますか？',
    summaryEs: 'Demuestre que la solución al problema del valor inicial de la ecuación incompresible de Navier-Stokes en ℝ³ existe y es suave, o construya un contraejemplo para demostrar que existe la explosión.',
    summaryEn: 'Can we prove that fluid flow never spontaneously goes haywire?',
    kid: '你见过平静的河水突然变成翻滚的漩涡吗？为什么？写下来流水的方程其实很简单，但用它预测什么时候、哪里会出现湍流（混乱）——没人能做到。这是个百万美元问题。',
    kidEn: 'When you turn on a faucet, water flows smoothly. When you turn it up more, it gets turbulent. The Navier-Stokes equations describe this fluid flow. We use them to design planes, predict weather, and model oceans. But mathematically, we have not proven that the equations always have nice solutions and never \'explode\' to infinity.',
    formal: '证明 ℝ³ 上不可压缩纳维-斯托克斯方程的初值问题的解存在且光滑，或构造一个反例证明存在 blow-up。',
    formalJa: '不可圧縮Navier - Stokes方程式の初期値問題の解が存在し滑らかであることを証明するか、または爆発の存在を証明するための反例を構築する。',
    formalEs: 'Demuestre que la solución al problema del valor inicial de la ecuación incompresible de Navier-Stokes en ℝ³ existe y es suave, o construya un contraejemplo para demostrar que existe la explosión.',
    formalEn: 'Prove that smooth, globally defined solutions exist for the Navier-Stokes equations in R³ for all time, given smooth initial conditions.',
    whyHard: '湍流是物理中最难解的现象之一，涉及无穷维动力系统。',
    whyHardEn: 'It involves subtle questions about energy conservation and the regularity of fluid solutions, and the $1M prize has eluded mathematicians for 25+ years.',
    aiPrompt: '向小朋友解释流体湍流和纳维-斯托克斯问题，给出当前研究状态。',
    aiPromptEn: 'Explain the Navier-Stokes regularity problem to a 12-year-old. Cover: what the equations are, why turbulence is hard, current approaches (energy methods, blow-up candidates), and implications for weather/climate modeling.',
    tags: ['千禧年问题', '偏微分方程', '湍流'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Navier-Stokes — 3Blue1Brown',
    videoChannel: '3Blue1Brown',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '证明光滑性或构造 blow-up 解' }, { type: 'code', label: '写代码/算法', desc: '用 Lattice Boltzmann 模拟' }, { type: 'model', label: '建模/模拟', desc: '建立简化的低维模型' }, { type: 'experiment', label: '动手实验', desc: '用 PIV 测量真实流体' }]
  },
  {
    id: 'millennium-hodge',
    category: 'mathematics',
    title: '霍奇猜想',
    titleJa: 'ホッジ予想',
    titleEs: 'Para variedades proyectivas complejas suaves, las clases de Hodge son todas combinaciones lineales racionales de clases algebraicas de cadena cerrada.',
    titleEn: 'Hodge Conjecture',
    year: 1950,
    proposer: 'W. V. D. Hodge',
    difficulty: 5,
    reward: 5000,
    status: 'open',
    summary: '某些抽象的几何形状，是不是都能用具体的多项式方程描述？',
    summaryJa: '特定の抽象幾何学は、特定の多項式方程式で記述できますか？',
    summaryEs: 'Para variedades proyectivas complejas suaves, las clases de Hodge son todas combinaciones lineales racionales de clases algebraicas de cadena cerrada.',
    summaryEn: 'Are all geometric shapes decomposable into simpler building blocks?',
    kid: '想象你在玩橡皮泥，可以用各种方式捏。但有些形状你可以用具体的"配方"做出来（比如一个面团切成1cm的方块可以拼出来），有些不行。霍奇猜想问：几何世界里所有"特殊"的形状，都能用多项式方程"配方"做出来吗？',
    kidEn: 'Imagine you have a beautiful donut (torus). Can you always cut it into smaller pieces that are \'algebraic shapes\'? The Hodge conjecture says yes, but no one has proven it for all shapes.',
    formal: '对于光滑复射影簇，霍奇类都是代数闭链类的有理线性组合。',
    formalJa: '滑らかな複素反射クラスタの場合、ホッジ類は代数閉鎖類の合理的な線形組み合わせである。',
    formalEs: 'Para variedades proyectivas complejas suaves, las clases de Hodge son todas combinaciones lineales racionales de clases algebraicas de cadena cerrada.',
    formalEn: 'On a smooth complex projective variety, every Hodge class is a rational linear combination of the cohomology classes of complex algebraic subvarieties.',
    whyHard: '连接代数几何、拓扑和复分析，是数学中最抽象的猜想之一。',
    whyHardEn: 'It bridges algebraic geometry, topology, and complex analysis. The statement is elegant, but the proof requires entirely new techniques that have not yet been developed.',
    aiPrompt: '用简单比喻解释霍奇猜想，给出严谨陈述。',
    aiPromptEn: 'Explain the Hodge conjecture to a 12-year-old. Use the torus/donut analogy. Cover: algebraic cycles, cohomology, why this matters for math unification.',
    tags: ['千禧年问题', '代数几何', '拓扑'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Hodge Conjecture',
    videoChannel: 'Mathologer',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '用代数几何语言证明或反驳' }, { type: 'survey', label: '文献综述', desc: '读 Voisin 的 Hodge 综述' }, { type: 'code', label: '写代码/算法', desc: '用 SageMath/Macaulay2 计算例子' }, { type: 'discuss', label: '想法/讨论', desc: '在 MathOverflow 提问' }]
  },
  {
    id: 'millennium-bsd',
    category: 'mathematics',
    title: 'BSD 猜想',
    titleJa: 'BSD予想',
    titleEs: 'Para una curva elíptica E sobre el campo de números racionales, rango(E) = ord_{s=1} L(E,s).',
    titleEn: 'Birch and Swinnerton-Dyer Conjecture',
    year: 1960,
    proposer: 'B. Birch / P. Swinnerton-Dyer',
    difficulty: 5,
    reward: 5000,
    status: 'open',
    summary: '椭圆曲线上有多少个有理点？是不是和某种 L 函数有关？',
    summaryJa: '楕円曲線には有理数の点がいくつありますか？それは何かのL関数に関連していますか？',
    summaryEs: 'Para una curva elíptica E sobre el campo de números racionales, rango(E) = ord_{s=1} L(E,s).',
    summaryEn: 'How many rational points does an elliptic curve have?',
    kid: '想象一个甜甜圈形状的桌面（"椭圆曲线"），你想知道上面有多少个"格点"（坐标都是分数的点）。BSD 猜想说：点数和一个特殊的数学函数（L 函数）的行为有关。如果 L(1) = 0，就有无穷多个点。',
    kidEn: 'An elliptic curve is a special donut shape with a beautiful structure. The Birch and Swinnerton-Dyer conjecture predicts exactly how many \'rational points\' (points with integer coordinates) it has. The rank determines this count, but proving the conjecture is incredibly hard.',
    formal: '对于有理数域上的椭圆曲线 E，rank(E) = ord_{s=1} L(E,s)。',
    formalJa: '有理数体上の楕円曲線Ｅの場合、ランク（ Ｅ ） ＝ ｏｒｄ ＿ ｛ ｓ ＝ １ ｝ Ｌ （ Ｅ ， ｓ ）。',
    formalEs: 'Para una curva elíptica E sobre el campo de números racionales, rango(E) = ord_{s=1} L(E,s).',
    formalEn: 'For an elliptic curve E over Q, the rank of the Mordell-Weil group E(Q) equals the order of vanishing of the L-function L(E, s) at s = 1.',
    whyHard: '和数论、几何、分析都相关，Andrew Wiles 等人部分进展。',
    whyHardEn: 'It connects number theory to analysis and modular forms. Partial progress by Gross-Zagier and Kolyvag shows it is true at least sometimes, but the general case remains open.',
    aiPrompt: '解释 BSD 猜想的直观意义和研究现状。',
    aiPromptEn: 'Explain the BSD conjecture to a 12-year-old. Use the rational point analogy. Cover: L-functions, ranks, what we know from the Gross-Zagier theorem, and the 2021 lakhshme work.',
    tags: ['千禧年问题', '数论', '椭圆曲线'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'BSD Conjecture',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '对特定 rank=1 曲线证明 BSD' }, { type: 'code', label: '写代码/算法', desc: '用 PARI/GP 计算 L 函数的低阶项' }, { type: 'survey', label: '文献综述', desc: '读 Gross 的导论' }, { type: 'essay', label: '写文章/论文', desc: '写一篇大学本科水平的介绍' }]
  },
  {
    id: 'twin-primes',
    category: 'mathematics',
    title: '孪生素数猜想',
    titleJa: 'ツインプライム予想',
    titleEs: 'Si existen infinitos pares de números primos (p, p+2).',
    titleEn: 'Twin Prime Conjecture',
    year: 1849,
    proposer: 'de Polignac',
    difficulty: 4,
    reward: 1000,
    status: 'partially_solved',
    summary: '差为 2 的素数对（3&5, 5&7, 11&13...）是不是有无穷多？',
    summaryJa: '差が2の素数ペア（ 3 ＆ 5、5 ＆ 7、11 ＆ 13... ）は無限にありますか？',
    summaryEs: 'Si existen infinitos pares de números primos (p, p+2).',
    summaryEn: 'Are there infinitely many pairs of prime numbers that differ by 2?',
    kid: '素数就是只能被1和自己整除的数（2、3、5、7、11、13...）。有些素数只差2（比如3和5，5和7，11和13）。它们像双胞胎一样成对出现。孪生素数猜想说：世界上有无穷多对这样的"双胞胎素数"。',
    kidEn: 'Twin primes are pairs of primes that differ by 2, like (3,5), (5,7), (11,13), (17,19). Are there infinitely many such pairs? Most mathematicians think yes, but no one has proven it yet.',
    formal: '是否存在无穷多对素数 (p, p+2)。',
    formalJa: '素数の対が無限に多いかどうか（ p、p +2 ）。',
    formalEs: 'Si existen infinitos pares de números primos (p, p+2).',
    formalEn: 'Are there infinitely many pairs of primes (p, p+2)?',
    whyHard: '2013 年张益唐证明存在无穷多对差 ≤ 7000 万的素数，但 2 仍未达到。',
    whyHardEn: 'It is a special case of the prime tuples conjecture. The 2013 Zhang theorem and Maynard\'s later work showed the gap between consecutive primes is bounded — a huge breakthrough — but proving infinitely many gaps of exactly 2 is still open.',
    aiPrompt: '解释孪生素数猜想，包括张益唐的突破。',
    aiPromptEn: 'Explain twin primes to a 12-year-old. Cover: what they are, the Zhang/Maynard bounded gaps breakthrough, and the Hardy-Littlewood prime tuples conjecture.',
    tags: ['数论', '素数', '孪生'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Twin Primes — Numberphile',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试缩小到 2 的差距' }, { type: 'code', label: '写代码/算法', desc: '写多精度素数筛法，找更大的孪生素数对' }, { type: 'essay', label: '写文章/论文', desc: '写张益唐故事' }, { type: 'kid-project', label: '儿童项目', desc: '和小朋友一起找孪生素数' }]
  },
  {
    id: 'goldbach',
    category: 'mathematics',
    title: '哥德巴赫猜想',
    titleJa: 'ゴールドバッハ予想',
    titleEs: 'Todo número par mayor que 2 se puede expresar como la suma de dos números primos.',
    titleEn: 'Goldbach\'s Conjecture',
    year: 1742,
    proposer: 'C. Goldbach',
    difficulty: 4,
    reward: 1000,
    status: 'partially_solved',
    summary: '每个大于 2 的偶数，都能写成两个素数之和吗？',
    summaryJa: '2を超えるすべての偶数は、2つの素数の合計として書くことができますか？',
    summaryEs: 'Todo número par mayor que 2 se puede expresar como la suma de dos números primos.',
    summaryEn: 'Can every even number greater than 2 be written as the sum of two primes?',
    kid: '哥德巴赫说：4=2+2, 6=3+3, 8=3+5, 10=3+7, 12=5+7... 看起来每个偶数都能拆成两个素数相加。是真的吗？已经验证到 4 × 10¹⁸，但还是没证明。',
    kidEn: 'Take any even number: 4 = 2+2, 6 = 3+3, 8 = 3+5, 10 = 5+5, 10 = 3+7. Can every even number be written as the sum of two primes? Goldbach said yes in 1742, but no one has proven it.',
    formal: '每个大于 2 的偶数都可以表示为两个素数之和。',
    formalJa: '２より大きい各々の偶数は、２つの素数の和として表すことができる。',
    formalEs: 'Todo número par mayor que 2 se puede expresar como la suma de dos números primos.',
    formalEn: 'For every even integer n > 2, there exist primes p and q such that n = p + q.',
    whyHard: '初等陈述但极难证明；陈景润证明了"1+2"（最接近的进展）。',
    whyHardEn: 'It is an exceptionally simple statement to write down but has resisted all attempts at proof for 280+ years. The weak Goldbach conjecture (every odd number > 5 is sum of 3 primes) was proven by Helfgott in 2013.',
    aiPrompt: '解释哥德巴赫猜想，包括陈景润 1+2 的突破。',
    aiPromptEn: 'Explain the Goldbach conjecture to a 12-year-old. Cover: how to verify it for small numbers, why it is hard, the weak Goldbach proof by Helfgott, and what computational verification tells us.',
    tags: ['数论', '加法', '偶数'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Goldbach — Numberphile',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明陈氏定理"1+2"' }, { type: 'code', label: '写代码/算法', desc: '写并行筛法验证到 10²⁰' }, { type: 'kid-project', label: '儿童项目', desc: '和 10 岁孩子拆偶数为素数和' }, { type: 'essay', label: '写文章/论文', desc: '讲陈景润的人生故事' }]
  },
  {
    id: 'collatz',
    category: 'mathematics',
    title: '考拉兹猜想 (3n+1)',
    titleJa: 'カウラズ予想（ 3 n +1 ）',
    titleEs: 'Para todos los enteros positivos n, la secuencia a_k+1 = a_k/2 (par) o 3a_k+1 (impar) eventualmente llegará a 1.',
    titleEn: 'Collatz Conjecture',
    year: 1937,
    proposer: 'L. Collatz',
    difficulty: 4,
    reward: 1000,
    status: 'open',
    summary: '反复套用一个简单规则，所有正整数最终都会变成 1 吗？',
    summaryJa: '単純なルールを繰り返し適用すると、すべての正の整数は1になりますか？',
    summaryEs: 'Para todos los enteros positivos n, la secuencia a_k+1 = a_k/2 (par) o 3a_k+1 (impar) eventualmente llegará a 1.',
    summaryEn: 'Does Collatz\'s sequence always reach 1?',
    kid: '随便挑一个正整数。偶数就除以2，奇数就乘3再加1。一直重复。猜想说：不管一开始选什么数，最后都会变成 1（然后在 4→2→1 循环）。这个简单规则让数学家们抓狂了 80 多年。',
    kidEn: 'Take any number. If it\'s even, divide by 2. If it\'s odd, multiply by 3 and add 1. Keep going. Does it always reach 1? Tested up to 10²⁰ and yes, but no proof.',
    formal: '对于所有正整数 n，序列 a_{k+1} = a_k/2 (偶) 或 3a_k+1 (奇) 终将到达 1。',
    formalJa: 'すべての正の整数nについて、配列a _{ k +1} = a_k/2 （偶数）または3 a_k +1 （奇数）は最終的に1に達する。',
    formalEs: 'Para todos los enteros positivos n, la secuencia a_k+1 = a_k/2 (par) o 3a_k+1 (impar) eventualmente llegará a 1.',
    formalEn: 'For the function f(n) = n/2 if n is even, 3n+1 if n is odd, does iteration of f starting from any positive integer n eventually reach 1?',
    whyHard: '简单到小朋友都能玩，但数学家们连渐进行为都几乎完全无法证明。',
    whyHardEn: 'It is one of the simplest-to-state yet hardest-to-prove problems in mathematics. The dynamics is chaotic, and partial results (e.g., Tao 2019) show most orbits converge, but the general case is still wide open.',
    aiPrompt: '解释考拉兹猜想，包括当前的数值验证规模和未解之处。',
    aiPromptEn: 'Explain the Collatz conjecture to a 12-year-old. Cover: the rules, the stopping time distribution, why it is hard (chaos, irregular behavior), and recent partial results.',
    tags: ['数论', '动力系统', '初等'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'The Simplest Math Problem No One Can Solve',
    videoChannel: 'Veritasium',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明或构造反例' }, { type: 'code', label: '写代码/算法', desc: '用 GPU 并行验证到 10²⁰' }, { type: 'visualize', label: '可视化', desc: '画序列轨道图' }, { type: 'kid-project', label: '儿童项目', desc: '让小朋友跑小数字看轨迹' }, { type: 'essay', label: '写文章/论文', desc: '写为什么这个简单规则这么难' }]
  },
  {
    id: 'abc-conjecture',
    category: 'mathematics',
    title: 'abc 猜想',
    titleJa: 'abc予想',
    titleEs: 'Para cualquier ε>0, con excepciones finitas, c < rad(abc)^{1+ε}, donde rad(abc) es el producto de abc sin factores cuadrados.',
    titleEn: 'abc Conjecture',
    year: 1985,
    proposer: 'Joseph Oesterlé / David Masser',
    difficulty: 5,
    reward: 3000,
    status: 'open',
    summary: '三个互素整数 a+b=c 的素因子乘积，能不能大于 c？',
    summaryJa: '3つのtautoprime整数a + b = cの素因数積をcより大きくすることはできますか？',
    summaryEs: 'Para cualquier ε>0, con excepciones finitas, c < rad(abc)^{1+ε}, donde rad(abc) es el producto de abc sin factores cuadrados.',
    summaryEn: 'For any ε>0, with finite exceptions, c < rad(abc)^{1+ε}, where rad(abc) is the product of abc without square factors.',
    kid: '三个互素的数 a、b、c，满足 a+b=c。把它们各自的"素因子"乘起来，叫 rad(abc)。abc 猜想说：几乎不会有 rad(abc) 比 c 还小的情况。这是一个看似简单的命题，但能推导出 100 多个重要猜想！',
    formal: '对任意 ε>0，除有限个例外，c < rad(abc)^{1+ε}，其中 rad(abc) 是无平方因子的 abc 乘积。',
    formalJa: '任意のε > 0に対して、限られた例外を除いて、c < rad (abc )^{ 1 + ε}であり、rad (abc)は二乗因子のないabc積である。',
    formalEs: 'Para cualquier ε>0, con excepciones finitas, c < rad(abc)^{1+ε}, donde rad(abc) es el producto de abc sin factores cuadrados.',
    formalEn: 'For any ε>0, with finite exceptions, c < rad(abc)^{1+ε}, where rad(abc) is the product of abc without square factors.',
    whyHard: '2012 年望月新一给出"证明"但争议很大；8 年后仍无人能完全验证。',
    aiPrompt: '用具体例子解释 abc 猜想，说明它的"中心地位"。',
    tags: ['数论', 'Diophantine', 'Mochizuki'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'abc Conjecture',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试简化或重证' }, { type: 'code', label: '写代码/算法', desc: '用 PARI/GP 验证小例子' }, { type: 'survey', label: '文献综述', desc: '读 Mochizuki 的 IUT 论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与 abc 猜想讨论' }]
  },
  {
    id: 'beal-conjecture',
    category: 'mathematics',
    title: '比尔猜想',
    titleJa: 'ビル予想',
    titleEs: 'Si a, b, c son primos relativos y tienen factores primos comunes, x, y, z>2, entonces a^x + b^y = c^z no tiene una solución entera positiva.',
    titleEn: 'Beal Conjecture',
    year: 1993,
    proposer: 'Andrew Beal',
    difficulty: 4,
    reward: 1000000,
    status: 'open',
    summary: '如果三个互素正整数的同次幂相加，能否有非常数解？',
    summaryJa: '3つの互いに正の整数の同じ累乗が加算された場合、数値以外の解が存在する可能性がありますか？',
    summaryEs: 'Si a, b, c son primos relativos y tienen factores primos comunes, x, y, z>2, entonces a^x + b^y = c^z no tiene una solución entera positiva.',
    summaryEn: 'If a, b, c are relatively prime and have common prime factors, x, y, z>2, then a^x + b^y = c^z has no positive integer solution.',
    kid: '如果 a、b、c 三个数都至少有两个相同的素因子，比如 2 和 5，那么 a^x + b^y = c^z 能不能有正整数解？比尔猜想说：除非 a、b、c 也有公因子，否则没有。比尔悬赏 100 万美元给解决者。',
    formal: '如果 a、b、c 互素且有公共素因子，x,y,z>2，则 a^x + b^y = c^z 无正整数解。',
    formalJa: 'a, b, cが同型であり、共通の素因数x, y, z > 2を有する場合、a ^ x + b ^ y = c ^ zは正の整数解を持たない。',
    formalEs: 'Si a, b, c son primos relativos y tienen factores primos comunes, x, y, z>2, entonces a^x + b^y = c^z no tiene una solución entera positiva.',
    formalEn: 'If a, b, c are relatively prime and have common prime factors, x, y, z>2, then a^x + b^y = c^z has no positive integer solution.',
    whyHard: '方程论、椭圆曲线、模形式多种思路；目前没有思路能突破。',
    aiPrompt: '解释比尔猜想和费马大定理的关系。',
    tags: ['数论', 'Diophantine', '悬赏'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Beal Conjecture',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明或构造反例' }, { type: 'code', label: '写代码/算法', desc: '搜索满足 x,y,z>2 的解' }, { type: 'essay', label: '写文章/论文', desc: '介绍这个百万美元奖金' }, { type: 'discuss', label: '想法/讨论', desc: '在数论论坛提问' }]
  },
  {
    id: 'fermat-catalan',
    category: 'mathematics',
    title: '费马-卡塔兰猜想',
    titleJa: 'フェルマー・カタロニア語予想',
    titleEs: 'a^p + b^q = c^r Cuando min(p,q,r)>2, solo hay un número finito de conjuntos de soluciones enteras positivas relativamente primas.',
    titleEn: 'Fermat–Catalan Conjecture',
    year: 1999,
    proposer: 'P. Ribenboim',
    difficulty: 5,
    reward: 0,
    status: 'partially_solved',
    summary: 'a^p + b^q = c^r，当指数大时只有 10 个已知解？',
    summaryJa: 'a ^ p + b ^ q = c ^ r、指数が大きいときは10の既知の解しかありませんか？',
    summaryEs: 'a^p + b^q = c^r Cuando min(p,q,r)>2, solo hay un número finito de conjuntos de soluciones enteras positivas relativamente primas.',
    summaryEn: 'Are there any solutions to xᵃ + yᵇ = zᶜ with 1/a + 1/b + 1/c < 1 beyond the known ones?',
    kid: '费马大定理说 a^n+b^n=c^n（n>2）无正整数解。但当指数 p,q,r 可以不同时呢？费马-卡塔兰猜想说：这样的等式只有有限个解，目前已找到 10 个。',
    kidEn: 'Fermat\'s Last Theorem says no solutions to x³ + y³ = z³. But what about 2³ + 3² = 1 + 9 = 17, but 17 is not a perfect cube. The Catalan conjecture (now Mihailescu theorem) says 2³ + 1³ = 3² is the only such solution.',
    formal: 'a^p + b^q = c^r 当 min(p,q,r)>2 时只有有限多组互素正整数解。',
    formalJa: 'a ^ p + b ^ q = c ^ r min (p, q, r) > 2のとき、tautophile正の整数解は有限である。',
    formalEs: 'a^p + b^q = c^r Cuando min(p,q,r)>2, solo hay un número finito de conjuntos de soluciones enteras positivas relativamente primas.',
    formalEn: 'Are there any other solutions to xᵃ + yᵇ = zᶜ with x, y, z, a, b, c > 0 and 1/a + 1/b + 1/c < 1 besides 2³ + 1³ = 3²?',
    whyHard: '要把 ABC 猜想/BSD 猜想/Mordell 猜想组合起来。',
    whyHardEn: 'It is a generalization of Fermat\'s Last Theorem. Mihailescu proved the special case 1/a + 1/b + 1/c = 1 (the Catalan/Mihailescu theorem), but the general inequality case is still open.',
    aiPrompt: '列出已知的 10 个解，解释这个猜想的状态。',
    aiPromptEn: 'Explain the Fermat-Catalan conjecture to a 12-year-old. Cover: Fermat last theorem, the Catalan special case, and what 1/a + 1/b + 1/c < 1 means.',
    tags: ['数论', 'Diophantine', '费马'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Fermat-Catalan',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '找新解或证明有限性' }, { type: 'code', label: '写代码/算法', desc: '穷举搜索 100 位以内解' }, { type: 'survey', label: '文献综述', desc: '读 Darmon-Granville 综述' }, { type: 'essay', label: '写文章/论文', desc: '写已知 10 个解的故事' }]
  },
  {
    id: 'erdos-straus',
    category: 'mathematics',
    title: 'Erdős–Straus 猜想',
    titleJa: 'Erdős - Straus予想',
    titleEs: 'Para cualquier n ≥ 2, existen enteros positivos x,y,z tales que 4/n = 1/x + 1/y + 1/z.',
    titleEn: 'Erdős–Straus Conjecture',
    year: 1948,
    proposer: 'P. Erdős',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '4/n 总能写成三个单位分数之和吗？',
    summaryJa: '4/nは常に3つの単位分数の合計として書くことができますか？',
    summaryEs: 'Para cualquier n ≥ 2, existen enteros positivos x,y,z tales que 4/n = 1/x + 1/y + 1/z.',
    summaryEn: 'For any n ≥ 2, there are positive integers x,y,z such that 4/n = 1/x + 1/y + 1/z.',
    kid: '1/2 + 1/3 + 1/6 = 1。这是 1 拆成三个"单位分数"的例子。Erdős-Straus 猜想说：对每个大于 1 的 n，4/n 都能写成 1/x + 1/y + 1/z 的形式（x,y,z 是正整数）。看起来简单但没证明。',
    formal: '对任意 n ≥ 2，存在正整数 x,y,z 使 4/n = 1/x + 1/y + 1/z。',
    formalJa: '任意のｎ ≧ ２に対して、４ ／ ｎ ＝ １ ／ ｘ ＋ １ ／ ｙ ＋ １ ／ ｚとなるような正の整数ｘ、ｙ、ｚが存在する。',
    formalEs: 'Para cualquier n ≥ 2, existen enteros positivos x,y,z tales que 4/n = 1/x + 1/y + 1/z.',
    formalEn: 'For any n ≥ 2, there are positive integers x,y,z such that 4/n = 1/x + 1/y + 1/z.',
    whyHard: '小数字都验证了（n≤10^17），但仍没一般证明。',
    aiPrompt: '用具体例子说明 Erdős-Straus 猜想。',
    tags: ['数论', '单位分数', 'Erdős'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Egyptian Fractions',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明 n 是 4k+1 情况' }, { type: 'code', label: '写代码/算法', desc: '搜索 4/n 不能拆的反例' }, { type: 'kid-project', label: '儿童项目', desc: '和小朋友玩分数拆分' }, { type: 'essay', label: '写文章/论文', desc: '写 Erdős 的趣事' }]
  },
  {
    id: 'odd-perfect-number',
    category: 'mathematics',
    title: '奇完全数是否存在',
    titleJa: '奇完全数の存在',
    titleEs: '¿Existe algún n impar tal que σ(n) = 2n?',
    titleEn: 'Existence of Odd Perfect Numbers',
    year: 300,
    proposer: '古希腊',
    difficulty: 5,
    reward: 5000,
    status: 'open',
    summary: '完全数 = 真因子之和；除了 6、28、496、8128 还有别的吗？',
    summaryJa: '完全数=真の因子の合計。6、28、496、8128以外に何かありますか？',
    summaryEs: '¿Existe algún n impar tal que σ(n) = 2n?',
    summaryEn: 'Are there any odd n such that σ(n) = 2n?',
    kid: '有些数很特别：它们的"真因子"（除了自己外的约数）加起来等于自己。比如 6=1+2+3，28=1+2+4+7+14。这叫完全数。古希腊人已经知道 6, 28, 496, 8128 这 4 个；它们都是偶数。是不是还有奇完全数？',
    formal: '是否存在奇数 n 使 σ(n) = 2n？',
    formalJa: 'σ (n) = 2 nとなるような奇数nはありますか？',
    formalEs: '¿Existe algún n impar tal que σ(n) = 2n?',
    formalEn: 'Are there any odd n such that σ(n) = 2n?',
    whyHard: '似乎不可能存在，但没人能严格证明；Euler 已经证明若有必是 12k+1 形式。',
    aiPrompt: '介绍完全数历史，解释奇完全数的搜索。',
    tags: ['数论', '完全数', '古老'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Perfect Number Mystery',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明奇完全数不存在' }, { type: 'code', label: '写代码/算法', desc: '搜索 10²⁰ 范围内' }, { type: 'survey', label: '文献综述', desc: '读 Ochem-Rao 论文' }, { type: 'essay', label: '写文章/论文', desc: '写一个完整的"完全数小史"' }]
  },
  {
    id: 'mertens',
    category: 'mathematics',
    title: 'Mertens 猜想',
    titleJa: 'メルテンス予想',
    titleEs: '|M(x)| < √x para todo x > 1.',
    titleEn: 'Mertens Conjecture',
    year: 1897,
    proposer: 'F. Mertens',
    difficulty: 4,
    reward: 0,
    status: 'refuted',
    summary: 'Mertens 函数 |M(x)| 的增长比 √x 慢吗？',
    summaryJa: 'Mertens関数| M (x )|の成長は√ xより遅いですか？',
    summaryEs: '|M(x)| < √x para todo x > 1.',
    summaryEn: '|M(x)| < √x for all x > 1.',
    kid: '定义 M(x) = ∑_{n≤x} μ(n)（μ 是 Möbius 函数）。Mertens 猜想说 |M(x)| < √x。1997 年已验证到 10¹⁴，2014 年被 Odlyzko 和 te Riele 间接反驳（用 Riemann 假设矛盾）。',
    formal: '|M(x)| < √x 对所有 x > 1。',
    formalJa: '| M (x )| < √ xすべてのx > 1.',
    formalEs: '|M(x)| < √x para todo x > 1.',
    formalEn: '|M(x)| < √x for all x > 1.',
    whyHard: '等价于一些关于 Riemann 假设的强版本。',
    aiPrompt: '解释 Mertens 函数和 Riemann 假设的关系。',
    tags: ['数论', '反例', 'Möbius'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Mertens Conjecture',
    videoChannel: 'Mathologer',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '寻找反例的明确形式' }, { type: 'code', label: '写代码/算法', desc: '数值计算 M(x)' }, { type: 'essay', label: '写文章/论文', desc: '写这个猜想的兴衰史' }, { type: 'survey', label: '文献综述', desc: '读 te Riele 1985 论文' }]
  },
  {
    id: 'cramer',
    category: 'mathematics',
    title: 'Cramér 猜想',
    titleJa: 'クラメール予想',
    titleEs: 'lim sup (p_{n+1} - p_n) / (log p_n)² = 1。',
    titleEn: 'Cramér\'s Conjecture',
    year: 1936,
    proposer: 'H. Cramér',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '相邻素数之间的最大间隔，约等于 (log p)² 吗？',
    summaryJa: '隣接する素数間の最大間隔は、約(log p )²に等しいですか？',
    summaryEs: 'lim sup (p_{n+1} - p_n) / (log p_n)² = 1。',
    summaryEn: 'lim sup (p_{n+1} - p_n) / (log p_n)² = 1。',
    kid: '素数之间的距离是数论中一个基本问题。素数定理说平均间隔是 log p。但相邻素数的最大间隔有多大？Cramér 猜想：最大间隔约 (log p)²。例子：1000 内的最大间隔是 20，约等于 (log 1000)²=47。',
    formal: 'lim sup (p_{n+1} - p_n) / (log p_n)² = 1。',
    formalJa: 'lim sup (p _{ n +1 }- p_n )/( log p_n) ² = 1.',
    formalEs: 'lim sup (p_{n+1} - p_n) / (log p_n)² = 1。',
    formalEn: 'lim sup (p_{n+1} - p_n) / (log p_n)² = 1。',
    whyHard: '素数在数轴上的分布仍有未解的"集体行为"。',
    aiPrompt: '解释素数间隔和素数定理。',
    tags: ['数论', '素数', '统计'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Prime Gaps',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明上界/下界' }, { type: 'code', label: '写代码/算法', desc: '扫描 10^9 内最大素数间隔' }, { type: 'visualize', label: '可视化', desc: '画素数间隔直方图' }, { type: 'essay', label: '写文章/论文', desc: '讲素数间隔的历史' }]
  },
  {
    id: 'oppenheim',
    category: 'mathematics',
    title: 'Oppenheim 猜想',
    titleJa: 'オッペンハイム予想',
    titleEs: 'Supongamos que f es una forma homogénea irreducible en ℝⁿ. Si min f(v)=0 no es un punto aislado, entonces f es universal.',
    titleEn: 'Oppenheim\'s Conjecture',
    year: 1929,
    proposer: 'A. Oppenheim',
    difficulty: 4,
    reward: 0,
    status: 'solved',
    summary: '不可约三元型几乎都是万能型吗？',
    summaryJa: '還元不可能なトライアドはほぼ普遍的ですか？',
    summaryEs: 'Supongamos que f es una forma homogénea irreducible en ℝⁿ. Si min f(v)=0 no es un punto aislado, entonces f es universal.',
    summaryEn: 'Assume f is an irreducible homogeneous form on ℝⁿ. If min f(v)=0 is not an isolated point, then f is universal.',
    kid: '形如 f(x,y,z) = a x² + b y² + c z² + ... 的"型"。Oppenheim 猜想说：如果 f 是不可约的且不只代表 0，那它能代表几乎所有整数（即"万能型"）。2023 年被 Lindenstrauss 等人证明。',
    formal: '设 f 是 ℝⁿ 上不可约的齐次型，若 min f(v)=0 不是孤立点，则 f 万能。',
    formalJa: 'fがx上の還元不可能な均質型であり、min f (v )= 0が孤立点でない場合、fは普遍的であると仮定する。',
    formalEs: 'Supongamos que f es una forma homogénea irreducible en ℝⁿ. Si min f(v)=0 no es un punto aislado, entonces f es universal.',
    formalEn: 'Assume f is an irreducible homogeneous form on ℝⁿ. If min f(v)=0 is not an isolated point, then f is universal.',
    whyHard: '是数论中经典的型理论问题。',
    aiPrompt: '介绍 Oppenheim 猜想的最终结果。',
    tags: ['数论', '型论', '已解'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Oppenheim Conjecture Resolution',
    videoChannel: 'Quanta',
    participate: [{ type: 'survey', label: '文献综述', desc: '读证明论文' }, { type: 'essay', label: '写文章/论文', desc: '介绍这个百年猜想如何被解' }, { type: 'discuss', label: '想法/讨论', desc: '讨论它的应用' }]
  },
  {
    id: 'hilbert-10',
    category: 'mathematics',
    title: '希尔伯特第 10 问题（不可判定）',
    titleJa: 'ヒルベルト質問10 （決定不可能）',
    titleEs: 'No existe un algoritmo A tal que para cada ecuación diofántica E, A(E) = 1 si y sólo si E tiene una solución entera.',
    titleEn: 'Hilbert\'s 10th Problem',
    year: 1900,
    proposer: 'D. Hilbert',
    difficulty: 5,
    reward: 0,
    status: 'solved',
    summary: '是否存在通用算法判断丢番图方程有整数解？',
    summaryJa: 'ディオファンティン方程式が整数解を持つと判断するための一般的なアルゴリズムはありますか？',
    summaryEs: 'No existe un algoritmo A tal que para cada ecuación diofántica E, A(E) = 1 si y sólo si E tiene una solución entera.',
    summaryEn: 'There does not exist an algorithm A such that for every Diophantine equation E, A(E) = 1 if and only if E has an integer solution.',
    kid: '希尔伯特 1900 年提出 23 个大问题。第 10 个是：能不能写一个"通用"程序，输入任何整数方程（如 x²+y²=z²），输出"有/没有整数解"？1970 年 Matiyasevich 证明：不存在这样的通用算法！',
    formal: '不存在算法 A，使对每个丢番图方程 E，A(E) = 1 当且仅当 E 有整数解。',
    formalJa: '各ディオファント方程式Ｅについて、Ｅが整数解を有する場合に限り、Ａ （ Ｅ ） ＝ １となるようなアルゴリズムＡは存在しない。',
    formalEs: 'No existe un algoritmo A tal que para cada ecuación diofántica E, A(E) = 1 si y sólo si E tiene una solución entera.',
    formalEn: 'There does not exist an algorithm A such that for every Diophantine equation E, A(E) = 1 if and only if E has an integer solution.',
    whyHard: '极其巧妙的反证：利用 Fibonacci 数和 MRDP 定理构造"通用丢番图方程"。',
    aiPrompt: '解释 MRDP 定理的精髓：可计算 ↔ 丢番图。',
    tags: ['逻辑', '可计算性', '已解'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Hilbert 10',
    videoChannel: 'Numberphile',
    participate: [{ type: 'survey', label: '文献综述', desc: '读 Matiyasevich 的书' }, { type: 'code', label: '写代码/算法', desc: '实现简单的丢番图方程求解器（限定小范围）' }, { type: 'essay', label: '写文章/论文', desc: '写希尔伯特问题的故事' }, { type: 'teach', label: '教学/讲解', desc: '给中学生讲什么是"不可判定"' }]
  },
  {
    id: 'hodge-real',
    category: 'mathematics',
    title: '实代数几何的 Hodge 猜想',
    titleJa: '実代数幾何学のホッジ予想',
    titleEs: '¿Se pueden describir las partes pares e impares de algunos números de Betti de la variedad proyectiva suave real X mediante cadenas algebraicas cerradas?',
    titleEn: 'Hodge Conjecture for Real Varieties',
    year: 1970,
    proposer: 'V. I. Arnold 等',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '实系数多项式的拓扑和代数结构如何对应？',
    summaryJa: '実係数多項式の位相と代数構造はどのように対応しますか？',
    summaryEs: '¿Se pueden describir las partes pares e impares de algunos números de Betti de la variedad proyectiva suave real X mediante cadenas algebraicas cerradas?',
    summaryEn: 'Can the odd and even parts of some Betti numbers of the real smooth projective variety X be described by algebraic closed chains?',
    kid: '实系数多项式 x²+y²=0 的解集是 {(0,0)}，而 x²+y²=1 是圆。实代数几何问：什么样的形状能用实系数多项式描述？和复数情况不同，很多拓扑形状不能。',
    formal: '实光滑射影簇 X 的某些 Betti 数的奇偶部分是否能用代数闭链描述？',
    formalJa: '固体平滑射影群Xのいくつかのベッティ数の偶数部分は、代数的閉鎖で記述できますか？',
    formalEs: '¿Se pueden describir las partes pares e impares de algunos números de Betti de la variedad proyectiva suave real X mediante cadenas algebraicas cerradas?',
    formalEn: 'Can the odd and even parts of some Betti numbers of the real smooth projective variety X be described by algebraic closed chains?',
    whyHard: '实代数几何比复数情况更"丑"，但也有自己的美。',
    aiPrompt: '解释实 vs 复代数几何的差别。',
    tags: ['代数几何', '实', '拓扑'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Real Algebraic Geometry',
    videoChannel: 'MIT OCW',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '证明某些低维情形' }, { type: 'code', label: '写代码/算法', desc: '用 Bertini 实数计算' }, { type: 'survey', label: '文献综述', desc: '读 Bochnak-Coste-Roy 经典教材' }]
  },
  {
    id: 'erdos-discrepancy',
    category: 'mathematics',
    title: 'Erdős 不一致问题',
    titleJa: 'エルデシュの矛盾',
    titleEs: 'Existe una función C(d) → ∞ tal que cada secuencia ±1 tiene una subsecuencia aritmética y una inconsistencia ≥ C(d).',
    titleEn: 'Erdős Discrepancy Problem',
    year: 1932,
    proposer: 'P. Erdős',
    difficulty: 4,
    reward: 0,
    status: 'solved',
    summary: '对 ±1 序列，必存在一个长为 d 的等差子列和超过 C(d)？',
    summaryJa: '± 1つのシーケンスの場合、長さdでC （ d ）より大きい等角サブカラムが必要ですか？',
    summaryEs: 'Existe una función C(d) → ∞ tal que cada secuencia ±1 tiene una subsecuencia aritmética y una inconsistencia ≥ C(d).',
    summaryEn: 'There exists a function C(d) → ∞ such that every ±1 sequence has an arithmetic subsequence and an inconsistency ≥ C(d).',
    kid: '给一个无穷 +1/-1 序列（比如 +1,-1,+1,+1,-1,...）。Erdős 问：对每个 d，从序列中能否找到一个长为 d 的等差子列（位置 a, a+k, a+2k, ..., a+(d-1)k）使其和不小于 C？C(d) 一定存在但只随 d 增长多慢？2014 年 Terry Tao 证明 C(d) 至少随 d^(1/8) 增长。',
    formal: '存在函数 C(d) → ∞ 使每个 ±1 序列都有等差子列和不一致度 ≥ C(d)。',
    formalJa: '各± １個の配列が等角サブ→カラムを有し、矛盾度がＣ （ ｄ ）以上であるような関数Ｃ （ ｄ ）∞が存在する。',
    formalEs: 'Existe una función C(d) → ∞ tal que cada secuencia ±1 tiene una subsecuencia aritmética y una inconsistencia ≥ C(d).',
    formalEn: 'There exists a function C(d) → ∞ such that every ±1 sequence has an arithmetic subsequence and an inconsistency ≥ C(d).',
    whyHard: '看似组合初等，但需要 deep 调和分析。',
    aiPrompt: '介绍 Tao 的解法要点。',
    tags: ['组合', '调和分析', '已解'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Erdos Discrepancy',
    videoChannel: 'Numberphile',
    participate: [{ type: 'survey', label: '文献综述', desc: '读 Tao 的论文' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Erdős 与 Tao' }, { type: 'code', label: '写代码/算法', desc: '验证小 d 的具体序列' }, { type: 'teach', label: '教学/讲解', desc: '给数学系学生讲调和分析' }]
  },
  {
    id: 'inv-subgroup',
    category: 'mathematics',
    title: '逆 Galois 问题',
    titleJa: '逆ガロア問題',
    titleEs: 'Si todo grupo finito G es isomorfo al grupo de Galois de algún polinomio f ∈ ℚ[x].',
    titleEn: 'Inverse Galois Problem',
    year: 1892,
    proposer: 'D. Hilbert',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '每个有限群是否是某多项式的 Galois 群？',
    summaryJa: '各有限群は、多項式のガロア群ですか？',
    summaryEs: 'Si todo grupo finito G es isomorfo al grupo de Galois de algún polinomio f ∈ ℚ[x].',
    summaryEn: 'Whether every finite group G is isomorphic to the Galois group of some polynomial f ∈ ℚ[x].',
    kid: '多项式 x³-2 的根是 √[3]{2}，它的 Galois 群是 S₃。是不是每个有限群（比如 n=5, 6, 7, 8... 阶对称群、交错群等）都能作为某个有理系数多项式的 Galois 群？没人证明所有情况。',
    formal: '每个有限群 G 是否同构于某多项式 f ∈ ℚ[x] 的 Galois 群。',
    formalJa: '各有限群Gが多項式f ∈[ x]のガロア群に同型であるかどうか。',
    formalEs: 'Si todo grupo finito G es isomorfo al grupo de Galois de algún polinomio f ∈ ℚ[x].',
    formalEn: 'Whether every finite group G is isomorphic to the Galois group of some polynomial f ∈ ℚ[x].',
    whyHard: '无穷多种群，每种都要构造多项式；Shafarevich 解决了很多可解群情况。',
    aiPrompt: '介绍 Galois 群基础知识，举例说明。',
    tags: ['群论', 'Galois', 'Hilbert'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Inverse Galois',
    videoChannel: 'Numberphile',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '对特定群构造 Galois 多项式' }, { type: 'code', label: '写代码/算法', desc: '用 Magma 计算小群' }, { type: 'survey', label: '文献综述', desc: '读 Malle-Matzat 的书' }, { type: 'essay', label: '写文章/论文', desc: '写 Galois 群小史' }]
  },
  {
    id: 'woodall-prime',
    category: 'mathematics',
    title: 'Woodall 猜想',
    titleJa: 'ウッドオールの予想',
    titleEs: '¿Hay infinitos n tales que W_n = n·2^n - 1 es primo?',
    titleEn: 'Woodall\'s Conjecture',
    year: 1907,
    proposer: 'A. J. C. Cunningham / H. J. Woodall',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '形如 n·2^n-1 的数有无穷多素数？',
    summaryJa: 'n · 2 ^ n -1のような数は無限に多くの素数を持っていますか？',
    summaryEs: '¿Hay infinitos n tales que W_n = n·2^n - 1 es primo?',
    summaryEn: 'Are there infinitely many n such that W_n = n·2^n - 1 is prime.',
    kid: 'Woodall 数 W_n = n·2^n - 1（n=1,2,3...）。比如 W_1=1, W_2=7, W_3=23, W_4=63（不是素数）。Woodall 猜想：其中有无穷多个素数。',
    formal: '是否存在无穷多 n 使 W_n = n·2^n - 1 是素数。',
    formalJa: 'W_n = n · 2 ^ n - 1が素数であるような無限大nがあるかどうか。',
    formalEs: '¿Hay infinitos n tales que W_n = n·2^n - 1 es primo?',
    formalEn: 'Are there infinitely many n such that W_n = n·2^n - 1 is prime.',
    whyHard: '和 Mersenne 素数类似但没 GIMPS 这样的众包项目。',
    aiPrompt: '介绍 Woodall 数的搜索现状。',
    tags: ['数论', '素数', '特殊形式'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Woodall Primes',
    videoChannel: 'Numberphile',
    participate: [{ type: 'code', label: '写代码/算法', desc: '搜索 10^6 内的 Woodall 素数' }, { type: 'essay', label: '写文章/论文', desc: '和 Mersenne 素数比较' }, { type: 'kid-project', label: '儿童项目', desc: '和中小学生玩这个数列' }, { type: 'discuss', label: '想法/讨论', desc: '在 OEIS 上更新搜索进展' }]
  },
  {
    id: 'catalan-mersenne',
    category: 'mathematics',
    title: 'Catalan-Mersenne 素数',
    titleJa: 'カタルーニャ・メルセンヌ・プライム',
    titleEs: '{p : 2^p-1 es un número primo} ¿Es igual al conjunto (parte) de los números primos?',
    titleEn: 'Catalan-Mersenne Primes',
    year: 1876,
    proposer: 'E. Catalan',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '2^p-1 是素数时 p 必是素数；反过来呢？',
    summaryJa: '2 ^ p -1が素数であるとき、pは素数でなければならず、逆もまた然りである。',
    summaryEs: '{p : 2^p-1 es un número primo} ¿Es igual al conjunto (parte) de los números primos?',
    summaryEn: '{p : 2^p-1 is a prime number} Is it equal to the set (part) of prime numbers?',
    kid: '如果 2^p-1 是素数（Mersenne 素数），那 p 必然是素数。问题是：每个素数 p 都能让 2^p-1 是素数吗？目前只有 51 个 Mersenne 素数（截至 2024 年），最大 p=82589933。',
    formal: '{p : 2^p-1 是素数} 是否等于素数集（部分）？',
    formalJa: '{p: 2 ^ p -1 prime}は素数の集合（部分）に等しいですか？',
    formalEs: '{p : 2^p-1 es un número primo} ¿Es igual al conjunto (parte) de los números primos?',
    formalEn: '{p : 2^p-1 is a prime number} Is it equal to the set (part) of prime numbers?',
    whyHard: '需要新的素性测试和分布式计算。',
    aiPrompt: '介绍 GIMPS 项目和最新的 Mersenne 素数发现。',
    tags: ['数论', 'Mersenne', '众包'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Mersenne Primes',
    videoChannel: 'Numberphile',
    participate: [{ type: 'code', label: '写代码/算法', desc: '下载 GIMPS 客户端跑' }, { type: 'essay', label: '写文章/论文', desc: '写 GIMPS 25 年历史' }, { type: 'kid-project', label: '儿童项目', desc: '小学生写个 Mersenne 检查器' }, { type: 'fund', label: '资助/投资', desc: '给 GIMPS 捐机器' }]
  },
  {
    id: 'lebesgue',
    category: 'mathematics',
    title: 'Lebesgue 分解问题',
    titleJa: 'ルベーグ分解問題',
    titleEs: '¿Cuál es el área de cobertura mínima que puede cubrir cualquier forma de diámetro 1?',
    titleEn: 'Lebesgue Universal Covering Problem',
    year: 1914,
    proposer: 'H. Lebesgue',
    difficulty: 3,
    reward: 0,
    status: 'solved',
    summary: '最小能覆盖所有直径 1 形状的通用形状是什么？',
    summaryJa: '直径1のすべての形状をカバーできる最小の一般的な形状は何ですか？',
    summaryEs: '¿Cuál es el área de cobertura mínima que puede cubrir cualquier forma de diámetro 1?',
    summaryEn: 'What is the minimum coverage area that can cover any shape of diameter 1?',
    kid: '有一个直径 1 的"通用形状" U，可以放在平面任意位置，使任何直径 1 的形状都能被 U 完全覆盖。Lebesgue 问：U 的最小面积是多少？2022 年被找到最优解。',
    formal: '所有能覆盖任何直径 1 形状的最小覆盖面积是多少？',
    formalJa: '直径1をカバーできるすべての形状の最小カバレッジエリアは何ですか？',
    formalEs: '¿Cuál es el área de cobertura mínima que puede cubrir cualquier forma de diámetro 1?',
    formalEn: 'What is the minimum coverage area that can cover any shape of diameter 1?',
    whyHard: '看似几何直觉题，实际要严格证明下界。',
    aiPrompt: '介绍这个 108 年问题的解决过程。',
    tags: ['几何', '覆盖', '已解'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Lebesgue Universal Cover',
    videoChannel: 'Quanta',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍这个数学之美的故事' }, { type: 'discuss', label: '想法/讨论', desc: '在数学论坛讨论' }, { type: 'teach', label: '教学/讲解', desc: '用 PPT 给大学生讲' }]
  },
  {
    id: 'inv-modular',
    category: 'mathematics',
    title: '模形式与数论的统一',
    titleJa: 'モーダル形式と数論の統一',
    titleEs: 'Para cada n, cada representación de Galois n-dimensional ℚ_l-radical corresponde a una forma automórfica GL_n.',
    titleEn: 'Modular Forms Connection',
    year: 1995,
    proposer: 'A. Wiles',
    difficulty: 5,
    reward: 0,
    status: 'partially_solved',
    summary: 'Langlands 纲领的统一：把数论和表示论连起来',
    summaryJa: 'ラングランズ・プログラムの統一：数論と表現理論を結びつける',
    summaryEs: 'Para cada n, cada representación de Galois n-dimensional ℚ_l-radical corresponde a una forma automórfica GL_n.',
    summaryEn: 'For every n, every n-dimensional ℚ_l-radical Galois representation corresponds to a GL_n automorphic form.',
    kid: '数学家 Langlands 在 1960 年代写了一份"草图"：数论里的 Galois 表示可以和调和分析里的自守形式一一对应。Wiles 1995 年证明谷山-志村猜想的特殊情形（=费马大定理证明）。整个纲领还远未完成。',
    formal: '对每个 n，每个 n 维 ℚ_l 进 Galois 表示对应一个 GL_n 自守形式。',
    formalJa: '各ｎについて、ガロアへの各ｎ次元ｌは、ＧＬ ＿ ｎの自己完結型を表す。',
    formalEs: 'Para cada n, cada representación de Galois n-dimensional ℚ_l-radical corresponde a una forma automórfica GL_n.',
    formalEn: 'For every n, every n-dimensional ℚ_l-radical Galois representation corresponds to a GL_n automorphic form.',
    whyHard: '需要发展大量数学工具。',
    aiPrompt: '用简单例子说明 Langlands 纲领。',
    tags: ['纲领', '自守形式', '数论'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Langlands Program',
    videoChannel: 'Numberphile',
    participate: [{ type: 'survey', label: '文献综述', desc: '读 Frenkel 的 "Love and Math"' }, { type: 'essay', label: '写文章/论文', desc: '写 Langlands 故事' }, { type: 'discuss', label: '想法/讨论', desc: '在数学茶馆讨论' }]
  },
  {
    id: 'quantum-gravity',
    category: 'physics',
    title: '量子引力',
    titleJa: '量子重力',
    titleEs: 'Construya una teoría de la gravedad cuántica que sea autoconsistente en la escala de Planck (10⁻³⁵ m) y pruebe las consecuencias observables.',
    titleEn: 'Quantum Gravity',
    year: 1930,
    proposer: '多个',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '广义相对论和量子力学如何统一？',
    summaryJa: '一般相対性理論と量子力学はどのように連携しますか？',
    summaryEs: 'Construya una teoría de la gravedad cuántica que sea autoconsistente en la escala de Planck (10⁻³⁵ m) y pruebe las consecuencias observables.',
    summaryEn: 'Construct a quantum gravity theory that is self-consistent at the Planck scale (10⁻³⁵ m) and test the observable consequences.',
    kid: '物理学有两套说明书。一套管非常非常大的东西（星星、宇宙），叫广义相对论。一套管非常非常小的东西（原子、粒子），叫量子力学。这两套说明书在描述"黑洞中心"或"宇宙诞生瞬间"时打架。我们需要一本统一的说明书。',
    formal: '构造一个在普朗克尺度（10⁻³⁵ m）也自洽的量子引力理论，并检验可观测后果。',
    formalJa: 'プランクスケール（ 10 ³³ m ）で自己一貫性のある量子重力理論を構築し、観測可能な結果をテストします。',
    formalEs: 'Construya una teoría de la gravedad cuántica que sea autoconsistente en la escala de Planck (10⁻³⁵ m) y pruebe las consecuencias observables.',
    formalEn: 'Construct a quantum gravity theory that is self-consistent at the Planck scale (10⁻³⁵ m) and test the observable consequences.',
    whyHard: '需要全新的数学工具（弦论、圈量子引力、因果集等候选），且目前无法实验。',
    aiPrompt: '解释弦论 vs 圈量子引力的核心思想。',
    tags: ['基础物理', '统一', 'Planck'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Quantum Gravity',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '在弦论/圈量子/因果集中选一方向证明' }, { type: 'code', label: '写代码/算法', desc: '用格点规范理论模拟' }, { type: 'survey', label: '文献综述', desc: '读 Rovelli 的入门书' }, { type: 'discuss', label: '想法/讨论', desc: '在物理学论坛参与讨论' }, { type: 'essay', label: '写文章/论文', desc: '写一个统一的科普' }]
  },
  {
    id: 'dark-matter',
    category: 'physics',
    title: '暗物质本质',
    titleJa: 'ダークマターの欠片',
    titleEs: 'Identificar partículas específicas de materia oscura en el universo (candidatas: WIMP, axión, neutrino estéril, etc.) y detectarlas directamente.',
    titleEn: 'Nature of Dark Matter',
    year: 1933,
    proposer: 'F. Zwicky (observation)',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '宇宙 27% 是看不见的"暗物质"，它是什么？',
    summaryJa: '宇宙の27 ％は目に見えない「ダークマター」ですが、それは何ですか？',
    summaryEs: 'Identificar partículas específicas de materia oscura en el universo (candidatas: WIMP, axión, neutrino estéril, etc.) y detectarlas directamente.',
    summaryEn: 'Identify specific particles of dark matter in the universe (candidates: WIMP, axion, sterile neutrino, etc.) and detect them directly.',
    kid: '天文学家们看着星系转啊转，发现按可见的物质算，转得太快了——一定还有大量"看不见的东西"在拉着星星。这些"看不见的东西"叫暗物质。但它到底是什么？粒子？黑洞？没人知道。',
    formal: '识别宇宙中暗物质的具体粒子（候选者：WIMP, axion, sterile neutrino 等），并直接探测。',
    formalJa: '宇宙の暗黒物質の特定の粒子（候補： WIMP、AXION、滅菌ニュートリノなど）を特定し、それらを直接検出します。',
    formalEs: 'Identificar partículas específicas de materia oscura en el universo (candidatas: WIMP, axión, neutrino estéril, etc.) y detectarlas directamente.',
    formalEn: 'Identify specific particles of dark matter in the universe (candidates: WIMP, axion, sterile neutrino, etc.) and detect them directly.',
    whyHard: '不参与电磁相互作用；目前只在引力效应中"看见"它。',
    aiPrompt: '介绍主要暗物质候选粒子和探测方法。',
    tags: ['天体物理', '粒子物理', '探测'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Dark Matter',
    videoChannel: 'Veritasium',
    participate: [{ type: 'experiment', label: '动手实验', desc: '参与 XENON/LZ/PandaX 数据分析' }, { type: 'code', label: '写代码/算法', desc: '模拟暗物质晕' }, { type: 'survey', label: '文献综述', desc: '读粒子物理标准模型' }, { type: 'kid-project', label: '儿童项目', desc: '做星系旋转曲线的小演示' }, { type: 'fund', label: '资助/投资', desc: '给 XENONnT 之类的实验捐资' }]
  },
  {
    id: 'dark-energy',
    category: 'physics',
    title: '暗能量本质',
    titleJa: 'ダークエネルギーの本質',
    titleEs: 'Explique que una constante cosmológica o un campo escalar dinámico es responsable de la expansión acelerada observada.',
    titleEn: 'Nature of Dark Energy',
    year: 1998,
    proposer: 'Saul Perlmutter et al.',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '为什么宇宙在加速膨胀？',
    summaryJa: '宇宙が加速度的に膨張しているのはなぜですか？',
    summaryEs: 'Explique que una constante cosmológica o un campo escalar dinámico es responsable de la expansión acelerada observada.',
    summaryEn: 'Explain that a cosmological constant or a dynamic scalar field is responsible for the observed accelerated expansion.',
    kid: '宇宙就像一块面包，膨胀就是面包在变大。科学家本以为膨胀会变慢。结果发现：膨胀在变快！是什么在推？不知道。科学家给这种神秘力量起了个名字叫"暗能量"。',
    formal: '解释宇宙学常数或动态标量场造成观测到的加速膨胀。',
    formalJa: '宇宙定数または動的スカラー場によって引き起こされる観測された加速膨張を説明できる。',
    formalEs: 'Explique que una constante cosmológica o un campo escalar dinámico es responsable de la expansión acelerada observada.',
    formalEn: 'Explain that a cosmological constant or a dynamic scalar field is responsible for the observed accelerated expansion.',
    whyHard: '量子场论预测的真空能量比观测大 120 个数量级。',
    aiPrompt: '介绍暗能量与宇宙学常数问题。',
    tags: ['天体物理', '宇宙学', '加速'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Dark Energy',
    videoChannel: 'Veritasium',
    participate: [{ type: 'experiment', label: '动手实验', desc: '参与 DESI、Euclid 巡天' }, { type: 'code', label: '写代码/算法', desc: '拟合 ΛCDM 模型' }, { type: 'survey', label: '文献综述', desc: '读 Weinberg 1989 综述' }, { type: 'essay', label: '写文章/论文', desc: '写暗能量发现史' }]
  },
  {
    id: 'turbulence',
    category: 'physics',
    title: '湍流',
    titleJa: '乱気流',
    titleEs: 'Establecer una teoría rigurosa de la turbulencia de Navier-Stokes o proporcionar un marco matemático para la descripción estadística.',
    titleEn: 'Turbulence',
    year: 1883,
    proposer: 'O. Reynolds',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '流体为什么突然变混乱？',
    summaryJa: 'なぜ流体が突然カオスになったのか？',
    summaryEs: 'Establecer una teoría rigurosa de la turbulencia de Navier-Stokes o proporcionar un marco matemático para la descripción estadística.',
    summaryEn: 'Establish a rigorous Navier-Stokes theory of turbulence, or give a mathematical framework for statistical description.',
    kid: '你打开水龙头时，水流很平稳（层流）。开大一点，水流就乱成一片（湍流）。为什么？中间发生了什么？物理学家们吵了 100 多年，连个完整定义都给不出。',
    formal: '建立严格的纳维-斯托克斯湍流理论，或给出统计描述的数学框架。',
    formalJa: '乱流の厳密なナビエ・ストークス理論を確立するか、統計的記述のための数学的枠組みを与える。',
    formalEs: 'Establecer una teoría rigurosa de la turbulencia de Navier-Stokes o proporcionar un marco matemático para la descripción estadística.',
    formalEn: 'Establish a rigorous Navier-Stokes theory of turbulence, or give a mathematical framework for statistical description.',
    whyHard: 'Navier-Stokes 解的"奇点"和"相干结构"问题。',
    aiPrompt: '介绍 Reynolds 数和湍流的尺度级联。',
    tags: ['流体力学', '混沌', 'Navier-Stokes'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Turbulence',
    videoChannel: 'Veritasium',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 Lattice Boltzmann 模拟' }, { type: 'experiment', label: '动手实验', desc: '用 PIV 测量水槽湍流' }, { type: 'essay', label: '写文章/论文', desc: '写 Kolmogorov 故事' }, { type: 'kid-project', label: '儿童项目', desc: '中学生玩染色水流实验' }]
  },
  {
    id: 'matter-antimatter',
    category: 'physics',
    title: '物质-反物质不对称',
    titleJa: '物質-反物質の非対称性',
    titleEs: '¿En qué medida se han verificado las tres condiciones de Sajarov: violación del número bariónico, violación de C/CP y universo que se desvía del equilibrio térmico?',
    titleEn: 'Baryon Asymmetry',
    year: 1967,
    proposer: 'A. Sakharov',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '为什么宇宙物质比反物质多？',
    summaryJa: 'なぜ宇宙には反物質よりも多くの物質があるのでしょうか？',
    summaryEs: '¿En qué medida se han verificado las tres condiciones de Sajarov: violación del número bariónico, violación de C/CP y universo que se desvía del equilibrio térmico?',
    summaryEn: 'To what extent have Sakharov\'s three conditions: baryon number violation, C/CP violation, universe deviating from thermal equilibrium – been verified?',
    kid: '电影里你见过反物质飞船和物质飞船撞一下就全没了吧？宇宙诞生时本应物质和反物质一样多，但不知什么原因，物质多出来一点点，于是构成了我们看到的一切。这个"多出的一点点"是怎么来的？',
    formal: 'Sakharov 三个条件：重子数破坏、C/CP 破坏、宇宙偏离热平衡——已在多大程度上被验证？',
    formalJa: 'バリオン数の崩壊、C/CPの崩壊、熱平衡からの宇宙偏差というサハロフの3つの条件は、どの程度検証されていますか？',
    formalEs: '¿En qué medida se han verificado las tres condiciones de Sajarov: violación del número bariónico, violación de C/CP y universo que se desvía del equilibrio térmico?',
    formalEn: 'To what extent have Sakharov\'s three conditions: baryon number violation, C/CP violation, universe deviating from thermal equilibrium – been verified?',
    whyHard: '标准模型 CP 破坏不足以解释，需要新物理。',
    aiPrompt: '介绍 Sakharov 条件。',
    tags: ['宇宙学', '粒子物理', '对称'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Baryon Asymmetry',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '参与 Belle II、ATLAS 数据分析' }, { type: 'code', label: '写代码/算法', desc: '跑 B 介子衰变模拟' }, { type: 'survey', label: '文献综述', desc: '读 Sakharov 1967 论文' }, { type: 'essay', label: '写文章/论文', desc: '写大爆炸对称破缺的故事' }]
  },
  {
    id: 'high-tc-superconductor',
    category: 'physics',
    title: '高温超导机理',
    titleJa: '高温超電導機構',
    titleEs: 'Se proporciona una descripción mecanicista microscópica rigurosa de la superconductividad de la onda D en óxidos de cobre.',
    titleEn: 'High-Tc Superconductivity Mechanism',
    year: 1986,
    proposer: 'J. G. Bednorz / K. A. Müller (discovery)',
    difficulty: 5,
    reward: 0,
    status: 'partially_solved',
    summary: '为什么铜氧化物在 -135°C 也能超导？',
    summaryJa: '酸化銅が-135 ℃で超伝導するのはなぜですか？',
    summaryEs: 'Se proporciona una descripción mecanicista microscópica rigurosa de la superconductividad de la onda D en óxidos de cobre.',
    summaryEn: 'A rigorous microscopic mechanistic description of d-wave superconductivity in copper oxides is given.',
    kid: '电线通电时会发热，浪费能量。超导体可以让电通过完全没阻力，但通常需要冷到 -200°C 以下。1986年发现的新材料在"温暖"得多（-100°C）时也能超导。但物理学家们至今没完全搞懂原理。',
    formal: '对铜氧化物的 d 波超导给出严格的微观机制描述。',
    formalJa: '酸化銅のｄ波超伝導性は、顕微鏡的メカニズムの厳密な記述を与えられる。',
    formalEs: 'Se proporciona una descripción mecanicista microscópica rigurosa de la superconductividad de la onda D en óxidos de cobre.',
    formalEn: 'A rigorous microscopic mechanistic description of d-wave superconductivity in copper oxides is given.',
    whyHard: '电子关联效应让单粒子图像失效。',
    aiPrompt: '介绍 Hubbard 模型和 RVB 理论。',
    tags: ['凝聚态', '超导', '关联'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'High-Tc Superconductor',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 DMRG 模拟 Hubbard 模型' }, { type: 'experiment', label: '动手实验', desc: '测 ARPES 数据' }, { type: 'survey', label: '文献综述', desc: '读 Anderson 1987 论文' }, { type: 'essay', label: '写文章/论文', desc: '介绍 BCS vs RVB' }]
  },
  {
    id: 'room-temp-superconductor',
    category: 'physics',
    title: '室温超导',
    titleJa: '室温超電導',
    titleEs: 'Se encontraron materiales con Tc ≥ 273K y se sintetizaron de manera reproducible a presión normal.',
    titleEn: 'Room-Temperature Superconductor',
    year: 2020,
    proposer: '—',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '能在 0°C 以上工作的超导体存在吗？',
    summaryJa: '0 ℃以上で動作可能な超伝導体はありますか？',
    summaryEs: 'Se encontraron materiales con Tc ≥ 273K y se sintetizaron de manera reproducible a presión normal.',
    summaryEn: 'Materials with Tc ≥ 273K were found and synthesized reproducibly at normal pressure.',
    kid: '如果能造出"不冷也能超导"的材料，电网就不会再浪费电，磁悬浮列车会变便宜，量子计算机会更强大。LK-99 这样的发现引发过一阵热潮，但目前仍未复现。',
    formal: '找到 Tc ≥ 273K 的材料并在常压下可重复合成。',
    formalJa: 'Ｔｃが２ ７ ３ Ｋ以上の材料が見出され、大気圧で再現可能に合成された。',
    formalEs: 'Se encontraron materiales con Tc ≥ 273K y se sintetizaron de manera reproducible a presión normal.',
    formalEn: 'Materials with Tc ≥ 273K were found and synthesized reproducibly at normal pressure.',
    whyHard: '凝聚态物理的核心挑战。',
    aiPrompt: '介绍 LK-99 风波和高温超导现状。',
    tags: ['凝聚态', '超导', '材料'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Room Temp Superconductor',
    videoChannel: 'Veritasium',
    participate: [{ type: 'experiment', label: '动手实验', desc: '尝试合成新材料' }, { type: 'code', label: '写代码/算法', desc: '用 DFT 模拟晶体结构' }, { type: 'survey', label: '文献综述', desc: '读相关综述' }, { type: 'fund', label: '资助/投资', desc: '给高温超导研究捐资' }]
  },
  {
    id: 'proton-decay',
    category: 'physics',
    title: '质子衰变',
    titleJa: '陽子崩壊',
    titleEs: 'La observación de protones → e⁺ + π⁰ con detectores como Super-Kamiokande proporciona un límite inferior de vida útil.',
    titleEn: 'Proton Decay',
    year: 1973,
    proposer: '大统一理论',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '质子会不会衰变？寿命多长？',
    summaryJa: '陽子は崩壊しますか？寿命はどのくらいですか？',
    summaryEs: 'La observación de protones → e⁺ + π⁰ con detectores como Super-Kamiokande proporciona un límite inferior de vida útil.',
    summaryEn: 'Observing proton → e⁺ + π⁰ with detectors such as Super-Kamiokande gives a lower limit on the lifetime.',
    kid: '你身体里的每个质子已经存在了 138 亿年。会不会有一天它们突然变成别的粒子？大统一理论说会，而且给出了寿命。但实验迄今没看到。',
    formal: '用 Super-Kamiokande 等探测器观测 proton → e⁺ + π⁰，给出寿命下限。',
    formalJa: 'スーパーカミオカンデおよび他の検出器を使用して、陽子→e + πを観察することによって下限寿命を与えた。',
    formalEs: 'La observación de protones → e⁺ + π⁰ con detectores como Super-Kamiokande proporciona un límite inferior de vida útil.',
    formalEn: 'Observing proton → e⁺ + π⁰ with detectors such as Super-Kamiokande gives a lower limit on the lifetime.',
    whyHard: '大统一理论预测 τ > 10³⁴ 年，实验需要几千吨水几年才能验证。',
    aiPrompt: '介绍 SU(5) GUT 和超对称理论。',
    tags: ['粒子物理', '大统一', '实验'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Proton Decay',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '分析 Hyper-Kamiokande 数据' }, { type: 'code', label: '写代码/算法', desc: '模拟探测器响应' }, { type: 'survey', label: '文献综述', desc: '读大统一入门' }, { type: 'essay', label: '写文章/论文', desc: '写 Super-K 故事' }]
  },
  {
    id: 'hierarchy-problem',
    category: 'physics',
    title: '等级问题',
    titleJa: 'ランクの質問',
    titleEs: 'Calcular la dependencia de la corrección radiativa del parámetro de masa de Higgs μ²(m_Z) de la escala de corte Λ en un marco BSM como SM + supersimetría mínima (MSSM) o Higgs compuesto; requiere explicar la diferencia de 17 órdenes de magnitud entre m_h = 125,1 GeV y m_Pl/M_EW ≈ 10^17 sin la necesidad de un ajuste extremo (ajuste < 1%).',
    titleEn: 'Hierarchy Problem',
    year: 1970,
    proposer: 'E. Gildener / S. Weinberg',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '为什么 Higgs 质量比普朗克质量小 16 个数量级？',
    summaryJa: 'ヒッグス粒子の質がプランク質より16桁低いのはなぜですか？',
    summaryEs: 'Calcular la dependencia de la corrección radiativa del parámetro de masa de Higgs μ²(m_Z) de la escala de corte Λ en un marco BSM como SM + supersimetría mínima (MSSM) o Higgs compuesto; requiere explicar la diferencia de 17 órdenes de magnitud entre m_h = 125,1 GeV y m_Pl/M_EW ≈ 10^17 sin la necesidad de un ajuste extremo (ajuste < 1%).',
    summaryEn: 'Computing the dependence of the radiative correction of the Higgs mass parameter μ²(m_Z) on the cutoff scale Λ in a BSM framework such as SM + minimal supersymmetry (MSSM) or composite Higgs; requires explaining the 17 orders of magnitude difference between m_h = 125.1 GeV and m_Pl/M_EW ≈ 10^17 without the need for extreme fine-tuning (fine-tuning < 1%).',
    kid: '物理常数通常差 2-3 倍，但 Higgs 玻色子的质量 125 GeV 比普朗克质量 10¹⁹ GeV 小 16 个数量级。为什么？我们以为一定有新的对称性（超对称等）让这个差距"自然"。',
    formal: '在 SM + 最小超对称 (MSSM) 或 composite Higgs 等 BSM 框架下，计算 Higgs 质量参数μ²(m_Z) 的辐射修正对截止标度 Λ 的依赖；要求在无需极端精细调节 (fine-tuning < 1%) 的前提下解释 m_h = 125.1 GeV 与 m_Pl/M_EW ≈ 10^17 的 17 个数量级差距。',
    formalJa: 'SM +最小超対称性（ MSSM ）または複合ヒッグスのBSMフレームワークの下で、カットオフスケールφに対するヒッグス質量パラメータμ ²（ m_Z ）の放射補正の依存性を計算し、極端な微調整（微調整< 1 ％ ）なしで、m_h = 125.1 GeVとm_Pl/M_EW ≈ 10 ^ 17の間の17桁の桁差を説明する必要がある。',
    formalEs: 'Calcular la dependencia de la corrección radiativa del parámetro de masa de Higgs μ²(m_Z) de la escala de corte Λ en un marco BSM como SM + supersimetría mínima (MSSM) o Higgs compuesto; requiere explicar la diferencia de 17 órdenes de magnitud entre m_h = 125,1 GeV y m_Pl/M_EW ≈ 10^17 sin la necesidad de un ajuste extremo (ajuste < 1%).',
    formalEn: 'Computing the dependence of the radiative correction of the Higgs mass parameter μ²(m_Z) on the cutoff scale Λ in a BSM framework such as SM + minimal supersymmetry (MSSM) or composite Higgs; requires explaining the 17 orders of magnitude difference between m_h = 125.1 GeV and m_Pl/M_EW ≈ 10^17 without the need for extreme fine-tuning (fine-tuning < 1%).',
    whyHard: '需要超对称、复合 Higgs 或其他新物理。',
    aiPrompt: '解释"自然性"概念和超对称。',
    tags: ['粒子物理', 'Higgs', '自然性'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Hierarchy Problem',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '构造新物理模型' }, { type: 'experiment', label: '动手实验', desc: '分析 LHC 数据' }, { type: 'essay', label: '写文章/论文', desc: '介绍 SUSY 历史' }]
  },
  {
    id: 'strong-cp',
    category: 'physics',
    title: '强 CP 问题',
    titleJa: '強いCPの問題',
    titleEs: '¿Por qué el ángulo theta de QCD está tan cerca de 0?',
    titleEn: 'Strong CP Problem',
    year: 1975,
    proposer: 'G. \'t Hooft',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '为什么 QCD 中 CP 破坏项接近 0？',
    summaryJa: 'QCDでCPブレイク用語が0に近いのはなぜですか？',
    summaryEs: '¿Por qué el ángulo theta de QCD está tan cerca de 0?',
    summaryEn: 'Why is the theta angle of QCD so close to 0?',
    kid: '量子色动力学（QCD）描述夸克之间的强相互作用。它可以有一个"theta 项"破坏 CP 对称性。但实验测到的中子电偶极矩非常小，说明 theta 接近 0。为什么？',
    formal: '为什么 QCD 的 θ 角如此接近 0？',
    formalJa: 'QCDのシータ角が0に近いのはなぜですか？',
    formalEs: '¿Por qué el ángulo theta de QCD está tan cerca de 0?',
    formalEn: 'Why is the theta angle of QCD so close to 0?',
    whyHard: '最经济的解释是 Peccei-Quinn 对称性 + axion，但 axion 还未被直接探测到。',
    aiPrompt: '介绍 axion 假设。',
    tags: ['粒子物理', '对称', 'axion'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Strong CP',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '参与 ADMX 暗物质 axion 实验' }, { type: 'essay', label: '写文章/论文', desc: '介绍 axion 物理' }]
  },
  {
    id: 'measurement-problem',
    category: 'physics',
    title: '量子测量问题',
    titleJa: '量子測定の問題',
    titleEs: 'Dé una explicación física del "colapso de la función de onda" (Copenhague/Many Worlds/GRW/onda piloto) y verifíquela.',
    titleEn: 'Quantum Measurement Problem',
    year: 1926,
    proposer: 'E. Schrödinger / W. Heisenberg',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '为什么"测量"会让量子态从叠加变成确定？',
    summaryJa: 'なぜ「計測」は量子状態を重ね合わせから確実性に変えるのか。',
    summaryEs: 'Dé una explicación física del "colapso de la función de onda" (Copenhague/Many Worlds/GRW/onda piloto) y verifíquela.',
    summaryEn: 'Give a physical explanation of "wave function collapse" (Copenhagen/Many Worlds/GRW/pilot wave) and verify it.',
    kid: '电子在没人看的时候，是"既是这里又是那里"（叠加态）。但有人看的时候，它就"只在这里"。这中间的转变是怎么发生的？',
    formal: '给出"波函数坍缩"的物理解释（哥本哈根/多世界/GRW/pilot wave）并验证。',
    formalJa: '「波動関数崩壊」（コペンハーゲン/マルチワールド/GRW/パイロットウェーブ）の物理的な説明を与え、検証した。',
    formalEs: 'Dé una explicación física del "colapso de la función de onda" (Copenhague/Many Worlds/GRW/onda piloto) y verifíquela.',
    formalEn: 'Give a physical explanation of "wave function collapse" (Copenhagen/Many Worlds/GRW/pilot wave) and verify it.',
    whyHard: '是物理学和哲学的交叉点。',
    aiPrompt: '介绍哥本哈根/多世界/GRW/pilot wave 四大解释。',
    tags: ['量子力学', '哲学', '诠释'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Measurement Problem',
    videoChannel: 'Veritasium',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写四大解释对比' }, { type: 'discuss', label: '想法/讨论', desc: '在物理哲学论坛参与讨论' }, { type: 'teach', label: '教学/讲解', desc: '给高中生讲什么是"测量"' }]
  },
  {
    id: 'cosmological-constant',
    category: 'physics',
    title: '宇宙学常数问题',
    titleJa: '宇宙論的に絶え間ない問題',
    titleEs: '¿Por qué la constante cosmológica observada Λ es mucho menor que el valor teórico?',
    titleEn: 'Cosmological Constant Problem',
    year: 1989,
    proposer: 'S. Weinberg',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '为什么真空能量比观测值小 120 个数量级？',
    summaryJa: '真空エネルギーが観測値より120桁小さいのはなぜですか？',
    summaryEs: '¿Por qué la constante cosmológica observada Λ es mucho menor que el valor teórico?',
    summaryEn: 'Why is the observed cosmological constant Λ much smaller than the theoretical value?',
    kid: '量子场论说"空"的空间也有能量（真空能）。但观测到的暗能量又很小（10⁻⁴⁷ GeV⁴）。这比量子场论的预测小了 120 个数量级。人类历史上最大的理论与实验不符。',
    formal: '为什么观测的宇宙学常数 Λ 远小于理论值？',
    formalJa: '観測された宇宙定数pが理論値よりもはるかに小さいのはなぜですか？',
    formalEs: '¿Por qué la constante cosmológica observada Λ es mucho menor que el valor teórico?',
    formalEn: 'Why is the observed cosmological constant Λ much smaller than the theoretical value?',
    whyHard: '需要"宇宙学监督"机制，目前没有公认解决方案。',
    aiPrompt: '介绍"最差预测"。',
    tags: ['宇宙学', '真空', '常数'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Cosmological Constant',
    videoChannel: 'Quanta',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写这个 120 个数量级的故事' }, { type: 'discuss', label: '想法/讨论', desc: '在宇宙学论坛提问' }, { type: 'survey', label: '文献综述', desc: '读 Weinberg 综述' }]
  },
  {
    id: 'arrow-of-time',
    category: 'physics',
    title: '时间之箭',
    titleJa: '時間の矢',
    titleEs: 'Sin introducir condiciones de contorno, la segunda ley macroscópica de la termodinámica de la asimetría T se deriva de la ley microscópica de la simetría T (CPT); Se proporciona un mecanismo calculable (espectro CMB + asimetría bariónica) para el aumento de entropía S(t) que satisface la condición inicial de dS/dt ≥ 0 durante el período de inflación cosmológica.',
    titleEn: 'Arrow of Time',
    year: 1927,
    proposer: 'A. Eddington',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '为什么时间只往一个方向流？',
    summaryJa: 'なぜ時間は一方向にしか流れないのでしょうか？',
    summaryEs: 'Sin introducir condiciones de contorno, la segunda ley macroscópica de la termodinámica de la asimetría T se deriva de la ley microscópica de la simetría T (CPT); Se proporciona un mecanismo calculable (espectro CMB + asimetría bariónica) para el aumento de entropía S(t) que satisface la condición inicial de dS/dt ≥ 0 durante el período de inflación cosmológica.',
    summaryEn: 'Without introducing boundary conditions, the macroscopic second law of thermodynamics of T-asymmetry is derived from the microscopic law of T-symmetry (CPT); a calculable mechanism (CMB spectrum + baryon asymmetry) is given for the entropy increase S(t) satisfying the initial condition of dS/dt ≥ 0 during the cosmological inflation period.',
    kid: '物理定律（除热力学第二定律外）都是时间可逆的。但我们感受到的时间是单向的：人会变老、咖啡会冷、电影只能往前放。这个方向从哪来？',
    formal: '在不引入边界条件的前提下，从 T-对称的微观定律 (CPT) 推导出 T-不对称的宏观热力学第二定律；给出熵增 S(t) 满足 dS/dt ≥ 0 的初始条件在宇宙学暴胀时期的可计算机制（CMB 谱 + 重子不对称）。',
    formalJa: '境界条件を導入することなく、T -非対称性の巨視的熱力学の第二法則は、T -対称性（ CPT ）の微視的法則から導き出され、dS/dt ≥ 0の初期条件を満たすエントロピー増加S （ t ）は、宇宙膨張期間（ CMBスペクトル+バリオン非対称性）中にコンピュータ化することができる。',
    formalEs: 'Sin introducir condiciones de contorno, la segunda ley macroscópica de la termodinámica de la asimetría T se deriva de la ley microscópica de la simetría T (CPT); Se proporciona un mecanismo calculable (espectro CMB + asimetría bariónica) para el aumento de entropía S(t) que satisface la condición inicial de dS/dt ≥ 0 durante el período de inflación cosmológica.',
    formalEn: 'Without introducing boundary conditions, the macroscopic second law of thermodynamics of T-asymmetry is derived from the microscopic law of T-symmetry (CPT); a calculable mechanism (CMB spectrum + baryon asymmetry) is given for the entropy increase S(t) satisfying the initial condition of dS/dt ≥ 0 during the cosmological inflation period.',
    whyHard: '与宇宙学、量子力学、意识都相关。',
    aiPrompt: '介绍热力学/宇宙学/心理学三大时间箭头。',
    tags: ['哲学', '宇宙学', '时间'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Arrow of Time',
    videoChannel: 'Veritasium',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍三大箭头' }, { type: 'discuss', label: '想法/讨论', desc: '参与时间哲学讨论' }, { type: 'teach', label: '教学/讲解', desc: '给大学生讲这个' }]
  },
  {
    id: 'vacuum-decay',
    category: 'physics',
    title: '真空衰变',
    titleJa: '真空減衰',
    titleEs: 'En el marco del potencial efectivo SM V_eff(φ, T), calcule la dependencia de la vida útil del falso vacío τ de la masa de Higgs m_h y la masa del quark top m_t; se requiere que τ > 10^10 años (> la edad actual del universo) y sea consistente con la medición m_h del LHC; la predicción se puede comprobar mediante mediciones m_h de alta precisión (error < 0,1 GeV).',
    titleEn: 'Vacuum Decay',
    year: 1976,
    proposer: 'M. Stone / S. Coleman',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '我们的真空会不会衰变到更低的真空中？',
    summaryJa: '私たちの真空はより低い真空に減衰しますか？',
    summaryEs: 'En el marco del potencial efectivo SM V_eff(φ, T), calcule la dependencia de la vida útil del falso vacío τ de la masa de Higgs m_h y la masa del quark top m_t; se requiere que τ > 10^10 años (> la edad actual del universo) y sea consistente con la medición m_h del LHC; la predicción se puede comprobar mediante mediciones m_h de alta precisión (error < 0,1 GeV).',
    summaryEn: 'In the framework of the SM effective potential V_eff(φ, T), calculate the dependence of the false vacuum lifetime τ on the Higgs mass m_h and the top quark mass m_t; it is required that τ > 10^10 years (> the current age of the universe) and be consistent with the LHC m_h measurement; the prediction can be tested by high-precision m_h measurements (error < 0.1 GeV).',
    kid: '想象空间里有一个"泡泡"，里面的"真空"比外面低能量。泡泡会扩张，把所有空间变成新真空。我们目前的"假真空"会不会自发地变成"真真空"？如果是，一切就没了。',
    formal: '在 SM 有效势 V_eff(φ, T) 框架下，计算假真空寿命 τ 与 Higgs 质量 m_h、顶夸克质量 m_t 的依赖关系；要求 τ > 10^10 年（> 当前宇宙年龄）且与 LHC m_h 测量值一致；预测可由高精度 m_h 测量（误差 < 0.1 GeV）检验。',
    formalJa: 'SM有効電位V_eff （ φ、T ）の枠組みの下で、ヒッグス質量m_hとトップクォーク質量m_tに対する偽真空寿命τの依存関係を計算します。τ > 10 ^ 10年（>現在の宇宙年齢）を必要とし、LHC m_h測定と一致します。予測は、高精度m_h測定（誤差< 0.1 GeV ）によってテストすることができます。',
    formalEs: 'En el marco del potencial efectivo SM V_eff(φ, T), calcule la dependencia de la vida útil del falso vacío τ de la masa de Higgs m_h y la masa del quark top m_t; se requiere que τ > 10^10 años (> la edad actual del universo) y sea consistente con la medición m_h del LHC; la predicción se puede comprobar mediante mediciones m_h de alta precisión (error < 0,1 GeV).',
    formalEn: 'In the framework of the SM effective potential V_eff(φ, T), calculate the dependence of the false vacuum lifetime τ on the Higgs mass m_h and the top quark mass m_t; it is required that τ > 10^10 years (> the current age of the universe) and be consistent with the LHC m_h measurement; the prediction can be tested by high-precision m_h measurements (error < 0.1 GeV).',
    whyHard: '需要精确的高能物理。',
    aiPrompt: '介绍 Coleman-de Luccia 泡泡。',
    tags: ['宇宙学', '高能', '灾难'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Vacuum Decay',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写这个恐怖的可能性' }, { type: 'discuss', label: '想法/讨论', desc: '在物理论坛提问' }, { type: 'survey', label: '文献综述', desc: '读 Coleman 论文' }]
  },
  {
    id: 'emergent-spacetime',
    category: 'physics',
    title: '时空涌现',
    titleJa: '時間と空間の出現',
    titleEs: 'Construir un marco matemático claro para que "el espacio-tiempo surja de lo cuántico".',
    titleEn: 'Emergent Spacetime',
    year: 1995,
    proposer: 'T. Jacobson / E. Verlinde',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '时空是否从更基本的量子信息中涌现？',
    summaryJa: '時空はより基本的な量子情報から生まれますか？',
    summaryEs: 'Construir un marco matemático claro para que "el espacio-tiempo surja de lo cuántico".',
    summaryEn: 'Construct a clear mathematical framework for "space-time emerges from quantum".',
    kid: '广义相对论说时空是弯曲的。但弯曲从哪里来？一种观点是：时空是从量子纠缠产生的"图案"——像水中的漩涡从水流中浮现。',
    formal: '构造一个清晰的"时空从量子涌现"的数学框架。',
    formalJa: '量子から時空が出現するための明確な数学的枠組みを構築する。',
    formalEs: 'Construir un marco matemático claro para que "el espacio-tiempo surja de lo cuántico".',
    formalEn: 'Construct a clear mathematical framework for "space-time emerges from quantum".',
    whyHard: '处于引力/量子信息/凝聚态的交叉点。',
    aiPrompt: '介绍 ER=EPR、Maldacena-Susskind 思想。',
    tags: ['量子引力', '涌现', '信息'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Emergent Spacetime',
    videoChannel: 'Quanta',
    participate: [{ type: 'survey', label: '文献综述', desc: '读 Verlinde 论文' }, { type: 'essay', label: '写文章/论文', desc: '介绍 ER=EPR' }, { type: 'discuss', label: '想法/讨论', desc: '参与这个跨领域讨论' }]
  },
  {
    id: 'neutrino-mass',
    category: 'physics',
    title: '中微子质量起源',
    titleJa: 'ニュートリノ質量起源',
    titleEs: 'Explique la diminuta masa de los neutrinos (ver mecanismo de balancín/balancín).',
    titleEn: 'Origin of Neutrino Mass',
    year: 1998,
    proposer: '梶田隆章 (discovery)',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '为什么中微子这么轻（比电子还轻 50 万倍）？',
    summaryJa: 'なぜニュートリノはとても軽いのですか（電子より50万倍軽い） ？',
    summaryEs: 'Explique la diminuta masa de los neutrinos (ver mecanismo de balancín/balancín).',
    summaryEn: 'Explain the tiny mass of neutrinos (see seesaw mechanism/seesaw).',
    kid: '中微子几乎不跟任何东西作用，但它们确实有微小质量（1998 年梶田隆章发现）。比电子轻 50 万倍。为什么这么轻？可能它们是"自己的反粒子"（Majorana），或者来自高维空间。',
    formal: '解释中微子的微小质量（见跷跷板机制/seesaw）。',
    formalJa: 'ニュートリノの小さな質量を説明する（シーソーを参照）。',
    formalEs: 'Explique la diminuta masa de los neutrinos (ver mecanismo de balancín/balancín).',
    formalEn: 'Explain the tiny mass of neutrinos (see seesaw mechanism/seesaw).',
    whyHard: '需要超出标准模型的新物理。',
    aiPrompt: '介绍 seesaw 机制和 Majorana 中微子。',
    tags: ['粒子物理', '中微子', '标准模型'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Neutrino Mass',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '参与 CUORE、GERDA 数据分析' }, { type: 'essay', label: '写文章/论文', desc: '介绍梶田发现' }, { type: 'code', label: '写代码/算法', desc: '模拟中微子振荡' }]
  },
  {
    id: 'dark-photon',
    category: 'physics',
    title: '暗光子',
    titleJa: 'ダークフォトン',
    titleEs: 'Proporciona un 95 % de exclusión de CL o descubrimiento mediante experimentos con objetivos fijos (LSND/NA64), colisionador (BaBar/Belle II) u observaciones astrofísicas en un espacio de parámetros de 1 MeV < m_{A\\\'} < 100 GeV, 10^{-12} < ε < 10^{-2} (con parámetros de mezcla de fotones).',
    titleEn: 'Dark Photon',
    year: 1985,
    proposer: 'B. Holdom',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '是否有一种"看不见的光"？',
    summaryJa: '「目に見えない光」はありますか？',
    summaryEs: 'Proporciona un 95 % de exclusión de CL o descubrimiento mediante experimentos con objetivos fijos (LSND/NA64), colisionador (BaBar/Belle II) u observaciones astrofísicas en un espacio de parámetros de 1 MeV < m_{A\\\'} < 100 GeV, 10^{-12} < ε < 10^{-2} (con parámetros de mezcla de fotones).',
    summaryEn: 'Gives 95% CL exclusion or discovery by fixed target experiments (LSND/NA64), collider (BaBar/Belle II) or astrophysical observations in parameter space of 1 MeV < m_{A\\\'} < 100 GeV, 10^{-12} < ε < 10^{-2} (with photon mixing parameters).',
    kid: '光子是传递电磁力的"信使"。可能还有一种和普通光子相似的"暗光子"，只在暗物质之间传递力。如果存在，可能解释暗物质和 μ 介子 g-2 异常。',
    formal: '在 1 MeV < m_{A\'} < 100 GeV、10^{-12} < ε < 10^{-2}（与光子混合参数）参数空间内，通过固定靶实验 (LSND/NA64)、对撞机 (BaBar/Belle II) 或天体物理观测给出 95% CL 排除或发现。',
    formalJa: '１ ＭｅＶ ＜ ｍ ＿ ｛ Ａ \'｝ ＜ １ ０ ０ ＧｅＶ、１ ０ ^｛－ １ ２ ｝ ＜ ε ＜ １ ０ ^｛－ ２ ｝ （光子と混合されたパラメータ）パラメータ空間内で、９ ５ ％のＣＬ除外または発見は、静止標的実験（ ＬＳＮＤ ／ ＮＡ ６ ４ ）、コライダー（ ＢａＢａｒ ／ Ｂｅｌｌｅ Ｉ Ｉ ）、または天体物理学的観測によって与えられる。',
    whyHard: '和普通物质作用极弱，需要高灵敏度实验。',
    aiPrompt: '介绍暗光子搜索实验。',
    tags: ['粒子物理', '暗物质', '新粒子'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Dark Photon',
    videoChannel: 'Quanta',
    participate: [{ type: 'experiment', label: '动手实验', desc: '分析 LHCb/NA64 数据' }, { type: 'essay', label: '写文章/论文', desc: '介绍"力的暗扇区"概念' }]
  },
  {
    id: 'proton-spin',
    category: 'physics',
    title: '质子自旋危机',
    titleJa: '陽子スピン危機',
    titleEs: 'Descomposición completa del espín de un protón en quark/gluón/momento angular orbital.',
    titleEn: 'Proton Spin Crisis',
    year: 1987,
    proposer: 'EMC experiment',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '质子的自旋从哪来？夸克贡献怎么这么少？',
    summaryJa: '陽子のスピンはどこから来るのですか？なぜクォークへの貢献がそれほど少ないのでしょうか？',
    summaryEs: 'Descomposición completa del espín de un protón en quark/gluón/momento angular orbital.',
    summaryEn: 'Complete decomposition of proton spin into quark/gluon/orbital angular momentum.',
    kid: '质子有"自旋"（像陀螺一样转）。物理学家以为自旋来自它的 3 个价夸克。但实验发现 3 个夸克只贡献 ~30% 的自旋！剩下 70% 从哪来？可能是胶子、海夸克、或轨道角动量。',
    formal: '完整分解质子自旋到夸克/胶子/轨道角动量。',
    formalJa: 'プロトンスピンのクォーク/グルーオン/軌道角運動量への完全分解。',
    formalEs: 'Descomposición completa del espín de un protón en quark/gluón/momento angular orbital.',
    formalEn: 'Complete decomposition of proton spin into quark/gluon/orbital angular momentum.',
    whyHard: '涉及非微扰 QCD。',
    aiPrompt: '介绍 EMC 效应和 EIC 实验。',
    tags: ['粒子物理', 'QCD', '自旋'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Proton Spin',
    videoChannel: 'Quanta',
    participate: [{ type: 'experiment', label: '动手实验', desc: '参与 EIC 模拟' }, { type: 'code', label: '写代码/算法', desc: '格点 QCD 计算' }, { type: 'essay', label: '写文章/论文', desc: '介绍"自旋危机"' }]
  },
  {
    id: 'landau-pole',
    category: 'physics',
    title: 'Landau 极点问题',
    titleJa: 'ランダウの極端な問題',
    titleEs: 'Determinar si la QED sigue siendo autoconsistente en la gran escala de energía unificada.',
    titleEn: 'Landau Pole Problem',
    year: 1955,
    proposer: 'L. D. Landau',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '量子电动力学 QED 是否在某个高能标自洽？',
    summaryJa: '量子電気力学QEDは、高エネルギーレベルで自己一貫性がありますか？',
    summaryEs: 'Determinar si la QED sigue siendo autoconsistente en la gran escala de energía unificada.',
    summaryEn: 'Determine whether QED remains self-consistent under the grand unified energy scale.',
    kid: 'QED（描述电子和光子相互作用的理论）的耦合常数随能量增加而增加，到一个"Landau 极点"就变无穷大。意味着 QED 是个"有效场论"，必须在某个能量变成新理论。',
    formal: '判断 QED 是否在大统一能标下保持自洽。',
    formalJa: 'QEDが大規模な統一エネルギーラベルの下で自己一貫性があるかどうかを判断します。',
    formalEs: 'Determinar si la QED sigue siendo autoconsistente en la gran escala de energía unificada.',
    formalEn: 'Determine whether QED remains self-consistent under the grand unified energy scale.',
    whyHard: '需要超越标准模型。',
    aiPrompt: '介绍跑动耦合常数。',
    tags: ['粒子物理', 'QED', '紫外'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Landau Pole',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍有效场论' }, { type: 'survey', label: '文献综述', desc: '读相关综述' }]
  },
  {
    id: 'cmb-anomalies',
    category: 'physics',
    title: 'CMB 反常',
    titleJa: 'CMB異常',
    titleEs: 'Anomalías multipolares bajas que explican o descartan la anisotropía de temperatura del CMB.',
    titleEn: 'CMB Anomalies',
    year: 2001,
    proposer: 'WMAP/Planck',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '宇宙微波背景辐射中的"冷斑"和半球不对称',
    summaryJa: '宇宙マイクロ波背景放射のコールドスポットと半球の非対称性',
    summaryEs: 'Anomalías multipolares bajas que explican o descartan la anisotropía de temperatura del CMB.',
    summaryEn: 'Low multipole anomalies that explain or rule out CMB temperature anisotropy.',
    kid: '宇宙大爆炸的"余晖"——CMB——非常均匀，但有几个"小毛病"：有个非常大的"冷斑"，南北半球有轻微的不对称。是统计涨落还是新物理？',
    formal: '解释或排除 CMB 温度各向异性的低多极反常。',
    formalJa: 'CMB温度異方性の低い多極異常を説明または除外する。',
    formalEs: 'Anomalías multipolares bajas que explican o descartan la anisotropía de temperatura del CMB.',
    formalEn: 'Low multipole anomalies that explain or rule out CMB temperature anisotropy.',
    whyHard: '可能是统计巧合，也可能是早期宇宙新物理。',
    aiPrompt: '介绍主要 CMB 反常。',
    tags: ['宇宙学', 'CMB', '新物理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'CMB Anomalies',
    videoChannel: 'Quanta',
    participate: [{ type: 'analyze', label: '数据分析', desc: '分析 Planck 数据' }, { type: 'essay', label: '写文章/论文', desc: '介绍冷斑假说' }]
  },
  {
    id: 'b-mode',
    category: 'physics',
    title: '原初引力波',
    titleJa: '一次重力波',
    titleEs: 'Detección directa de ondas gravitacionales primordiales mediante polarización en modo B CMB.',
    titleEn: 'Primordial Gravitational Waves',
    year: 2014,
    proposer: 'BICEP2 (claim)',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '宇宙暴涨期产生的引力波能被探测到吗？',
    summaryJa: '宇宙爆発による重力波を検知できますか？',
    summaryEs: 'Detección directa de ondas gravitacionales primordiales mediante polarización en modo B CMB.',
    summaryEn: 'Direct detection of primordial gravitational waves via CMB B-mode polarization.',
    kid: '宇宙在诞生后 10⁻³⁶ 秒经历了一次"暴涨"——体积膨胀 10²⁶ 倍。这个过程会产生"原初引力波"——时空的涟漪。2014 年 BICEP2 团队宣布看到了 B 模式极化（引力波信号），后来被证明是银河系尘埃。',
    formal: '通过 CMB B 模式极化直接探测原初引力波。',
    formalJa: '元の重力波は、CMB Bモード偏波によって直接検出されます。',
    formalEs: 'Detección directa de ondas gravitacionales primordiales mediante polarización en modo B CMB.',
    formalEn: 'Direct detection of primordial gravitational waves via CMB B-mode polarization.',
    whyHard: '信号比 CMB 极化本身小几个数量级，且易被尘埃污染。',
    aiPrompt: '介绍 CMB 极化和 BICEP2 故事。',
    tags: ['宇宙学', '暴涨', 'CMB'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Primordial Gravitational Waves',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '参与 Simons Observatory' }, { type: 'essay', label: '写文章/论文', desc: '介绍 BICEP2 风波' }]
  },
  {
    id: 'holographic',
    category: 'physics',
    title: '全息原理',
    titleJa: 'ホログラフィック原理',
    titleEs: 'Para cualquier espacio-tiempo M asintóticamente plano (A)dS, se proporciona un mapeo H de volumen a límite que satisface la relación dual AdS/CFT: Bulk(M) → CFT(∂M); Se requiere que el operador local masivo O(x) corresponda al operador límite CFT O(ξ), y la función de partición Z_bulk[M] = Z_CFT[φ_0] se establece con precisión bajo todas las cargas topológicas.',
    titleEn: 'Holographic Principle',
    year: 1993,
    proposer: 'G. \'t Hooft / L. Susskind',
    difficulty: 5,
    reward: 0,
    status: 'partially_solved',
    summary: '三维世界的信息能否"装进"二维表面？',
    summaryJa: '三次元の世界の情報を二次元の表面に「取り付ける」ことはできますか？',
    summaryEs: 'Para cualquier espacio-tiempo M asintóticamente plano (A)dS, se proporciona un mapeo H de volumen a límite que satisface la relación dual AdS/CFT: Bulk(M) → CFT(∂M); Se requiere que el operador local masivo O(x) corresponda al operador límite CFT O(ξ), y la función de partición Z_bulk[M] = Z_CFT[φ_0] se establece con precisión bajo todas las cargas topológicas.',
    summaryEn: 'For any asymptotically flat (A)dS spacetime M, a bulk-to-boundary mapping H that satisfies the AdS/CFT dual relationship is given: Bulk(M) → CFT(∂M); the bulk local operator O(x) is required to correspond to the CFT boundary operator O(ξ), and the partition function Z_bulk[M] = Z_CFT[φ_0] is accurately established under all topological charges.',
    kid: '黑洞的熵和它的表面积成正比，不是体积。这意味着一个三维区域的信息量等于其二维边界的信息量——像是"全息图"。AdS/CFT 对应把这点变成严格数学。',
    formal: '对任意渐近平坦 (A)dS 时空 M，给出满足 AdS/CFT 对偶关系的 bulk-to-boundary 映射 H: Bulk(M) → CFT(∂M)；要求 bulk 局域算符 O(x) 对应 CFT 边界算主的 O(ξ)，且配分函数 Z_bulk[M] = Z_CFT[φ_0] 在所有拓扑荷下精确成立。',
    formalJa: '任意の漸近的に平坦な（ Ａ ） ｄＳ時空Ｍについて、ＡｄＳ ／ ＣＦＴ双対性を満たすバルク対境界写像Ｈ ：バルク（ Ｍ ） → ＣＦＴ （ φ Ｍ ）が与えられ、バルク局所作用素Ｏ （ ｘ ）は、ＣＦＴ境界作用素Ｏ （ φ ）に対応するように要求され、分割関数Ｚ ＿バルク［ Ｍ ］ ＝ Ｚ ＿ ＣＦＴ ［ φ ＿ ０ ］は、すべての位相的負荷の下で正確に確立される。',
    formalEs: 'Para cualquier espacio-tiempo M asintóticamente plano (A)dS, se proporciona un mapeo H de volumen a límite que satisface la relación dual AdS/CFT: Bulk(M) → CFT(∂M); Se requiere que el operador local masivo O(x) corresponda al operador límite CFT O(ξ), y la función de partición Z_bulk[M] = Z_CFT[φ_0] se establece con precisión bajo todas las cargas topológicas.',
    formalEn: 'For any asymptotically flat (A)dS spacetime M, a bulk-to-boundary mapping H that satisfies the AdS/CFT dual relationship is given: Bulk(M) → CFT(∂M); the bulk local operator O(x) is required to correspond to the CFT boundary operator O(ξ), and the partition function Z_bulk[M] = Z_CFT[φ_0] is accurately established under all topological charges.',
    whyHard: '主要在 AdS 空间成立，对我们宇宙（dS）还未严格建立。',
    aiPrompt: '介绍 AdS/CFT。',
    tags: ['量子引力', '全息', '弦论'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Holographic Principle',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'survey', label: '文献综述', desc: '读 Maldacena 论文' }, { type: 'essay', label: '写文章/论文', desc: '介绍全息原理' }]
  },
  {
    id: 'baryogenesis',
    category: 'physics',
    title: '重子生成',
    titleJa: 'バリオン生成',
    titleEs: 'Construya un mecanismo de generación de bariones específico y proporcione predicciones comprobables.',
    titleEn: 'Baryogenesis Mechanisms',
    year: 1967,
    proposer: 'A. Sakharov',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '如何在宇宙早期产生物质-反物质不对称？',
    summaryJa: '初期の宇宙では、物質と反物質の非対称性はどのように生じたのでしょうか？',
    summaryEs: 'Construya un mecanismo de generación de bariones específico y proporcione predicciones comprobables.',
    summaryEn: 'Construct a specific baryon generation mechanism and give testable predictions.',
    kid: 'Sakharov 提了 3 个条件，但具体怎么发生？候选机制：电弱重子生成（标准模型内）、GUT 重子生成、轻子生成（leptogenesis）。哪个对？',
    formal: '构造一个具体的重子生成机制并给出可检验预言。',
    formalJa: 'コンクリートバリオン生成メカニズムを構築し、テスト可能な予測を与える。',
    formalEs: 'Construya un mecanismo de generación de bariones específico y proporcione predicciones comprobables.',
    formalEn: 'Construct a specific baryon generation mechanism and give testable predictions.',
    whyHard: '需要新物理。',
    aiPrompt: '介绍 leptogenesis、electroweak baryogenesis 等。',
    tags: ['宇宙学', '粒子物理', '对称破缺'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Baryogenesis',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍主要机制' }, { type: 'survey', label: '文献综述', desc: '读相关综述' }]
  },
  {
    id: 'nitrogen-fixation',
    category: 'chemistry',
    title: '常温常压固氮',
    titleJa: '大気中の温度と圧力での窒素固定',
    titleEs: 'Desarrollar catalizadores de un solo átomo/grupo a base de hierro o molibdeno para lograr la conversión de N₂ + 3H₂ → 2NH₃ ≥ 20 % (en relación con N₂), TOF ≥ 1 s⁻¹, estabilidad ≥ 1000 horas (sin desactivación obvia) a T ≤ 100 °C, P ≤ 10 atm, y aprobar XRD/XPS/operando XAS caracteriza la estructura del sitio activo.',
    titleEn: 'Nitrogen Fixation at Ambient Conditions',
    year: 1909,
    proposer: 'F. Haber / C. Bosch',
    difficulty: 4,
    reward: 2500,
    status: 'open',
    summary: '像豆科植物一样，在常温常压下把氮气变成氨',
    summaryJa: '豆類のように、室温と圧力で窒素をアンモニアに変換します',
    summaryEs: 'Desarrollar catalizadores de un solo átomo/grupo a base de hierro o molibdeno para lograr la conversión de N₂ + 3H₂ → 2NH₃ ≥ 20 % (en relación con N₂), TOF ≥ 1 s⁻¹, estabilidad ≥ 1000 horas (sin desactivación obvia) a T ≤ 100 °C, P ≤ 10 atm, y aprobar XRD/XPS/operando XAS caracteriza la estructura del sitio activo.',
    summaryEn: 'Develop iron-based or molybdenum-based single atom/cluster catalysts to achieve conversion of N₂ + 3H₂ → 2NH₃ ≥ 20% (relative to N₂), TOF ≥ 1 s⁻¹, stability ≥ 1000 hours (no obvious deactivation) at T ≤ 100°C, P ≤ 10 atm, and pass XRD/XPS/operando XAS characterizes the active site structure.',
    kid: '空气中大部分是氮气，但植物和动物都不能直接用。工业上用 Haber-Bosch 法把氮气变成氨（化肥原料），要 400°C 高温、200 倍大气压，每年烧掉 1-2% 的全球能源。豆科植物靠根瘤菌常温常压搞定。我们能不能学会？',
    formal: '开发铁基或钼基单原子/团簇催化剂，在 T ≤ 100°C、P ≤ 10 atm 下实现 N₂ + 3H₂ → 2NH₃ 的 转化率 ≥ 20%（相对 N₂）、TOF ≥ 1 s⁻¹、稳定性 ≥ 1000 小时（无明显失活），并通过 XRD/XPS/operando XAS 表征活性位结构。',
    formalJa: '鉄系またはモリブデン系の単原子/クラスター触媒を開発して、T ≦ 100 ℃、P ≦ 10 atmでN ₂ + 3 H ₂ 2 → NH ²の変換率≧ 20 ％ （相対N ₂ ）、TOF ≧ 1 s ²¹、安定性≧ 1000時間（有意な不活性化なし）を達成し、活性部位構造をXRD/XPS/OPERANDO XASによって特徴付けた。',
    formalEs: 'Desarrollar catalizadores de un solo átomo/grupo a base de hierro o molibdeno para lograr la conversión de N₂ + 3H₂ → 2NH₃ ≥ 20 % (en relación con N₂), TOF ≥ 1 s⁻¹, estabilidad ≥ 1000 horas (sin desactivación obvia) a T ≤ 100 °C, P ≤ 10 atm, y aprobar XRD/XPS/operando XAS caracteriza la estructura del sitio activo.',
    formalEn: 'Develop iron-based or molybdenum-based single atom/cluster catalysts to achieve conversion of N₂ + 3H₂ → 2NH₃ ≥ 20% (relative to N₂), TOF ≥ 1 s⁻¹, stability ≥ 1000 hours (no obvious deactivation) at T ≤ 100°C, P ≤ 10 atm, and pass XRD/XPS/operando XAS characterizes the active site structure.',
    whyHard: 'N≡N 三键极强（945 kJ/mol），需打破再重组。',
    aiPrompt: '介绍 Haber-Bosch、铁/钌催化剂、固氮酶。',
    tags: ['催化', '能源', '化肥'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Nitrogen Fixation',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '设计新型催化剂' }, { type: 'code', label: '写代码/算法', desc: '用 DFT 模拟 N₂ 活化' }, { type: 'essay', label: '写文章/论文', desc: '介绍根瘤菌共生' }, { type: 'kid-project', label: '儿童项目', desc: '种豆子观察根瘤' }]
  },
  {
    id: 'carbon-capture',
    category: 'chemistry',
    title: '低成本碳捕集',
    titleJa: '低コストの二酸化炭素回収',
    titleEs: 'Desarrollar un proceso de captura de CO₂ con separación de MOF/a base de aminas/membrana: costo de captura ≤ 50 USD/tonelada de CO₂, consumo de energía ≤ 2 GJ/tonelada de CO₂, tasa de captura ≥ 90 % (gases de combustión 4-15 % CO₂), estabilidad del ciclo ≥ 5000 tiempos de adsorción-desorción y reducción de emisiones de GEI del ciclo de vida completo ≥ 80 % evaluado por ACV.',
    titleEn: 'Low-Cost Carbon Capture',
    year: 2005,
    proposer: '—',
    difficulty: 4,
    reward: 3000,
    status: 'open',
    summary: '从空气或烟囱中便宜地抓取 CO₂',
    summaryJa: '空気や煙突からCO ₂を安く手に入れよう',
    summaryEs: 'Desarrollar un proceso de captura de CO₂ con separación de MOF/a base de aminas/membrana: costo de captura ≤ 50 USD/tonelada de CO₂, consumo de energía ≤ 2 GJ/tonelada de CO₂, tasa de captura ≥ 90 % (gases de combustión 4-15 % CO₂), estabilidad del ciclo ≥ 5000 tiempos de adsorción-desorción y reducción de emisiones de GEI del ciclo de vida completo ≥ 80 % evaluado por ACV.',
    summaryEn: 'Develop MOF/amine-based/membrane separation CO₂ capture process: capture cost ≤ 50 USD/ton CO₂, energy consumption ≤ 2 GJ/ton CO₂, capture rate ≥ 90% (flue gas 4-15% CO₂), cycle stability ≥ 5000 adsorption-desorption times, and full life cycle GHG emission reduction ≥ 80% assessed by LCA.',
    kid: '人类每年往大气里排 400 亿吨 CO₂。能不能在排放点和大气中都把它们抓回来？目前的办法要花很多钱（每吨 100-1000 美元），我们需要便宜 10-100 倍的办法。',
    formal: '开发 MOF/胺基/膜分离 CO₂ 捕集工艺：捕集成本 ≤ 50 美元/吨 CO₂、能耗 ≤ 2 GJ/吨 CO₂、捕集率 ≥ 90%（烟气 4-15% CO₂）、循环稳定性 ≥ 5000 次吸附-脱附，并由 LCA 评估全生命周期 GHG 减排 ≥ 80%。',
    formalJa: 'MOF/アミノ/膜分離CO ₂回収プロセス：回収コスト≦ US $ 50/t CO ₂、エネルギー消費量≦ 2 GJ/t CO ₂、回収率≧ 90 ％ （排気ガス4 -15 ％ CO ₂ ）、循環安定性≧ 5000吸着-脱着、および全ライフサイクルGHG排出削減のLCA評価≧ 80 ％。',
    formalEs: 'Desarrollar un proceso de captura de CO₂ con separación de MOF/a base de aminas/membrana: costo de captura ≤ 50 USD/tonelada de CO₂, consumo de energía ≤ 2 GJ/tonelada de CO₂, tasa de captura ≥ 90 % (gases de combustión 4-15 % CO₂), estabilidad del ciclo ≥ 5000 tiempos de adsorción-desorción y reducción de emisiones de GEI del ciclo de vida completo ≥ 80 % evaluado por ACV.',
    formalEn: 'Develop MOF/amine-based/membrane separation CO₂ capture process: capture cost ≤ 50 USD/ton CO₂, energy consumption ≤ 2 GJ/ton CO₂, capture rate ≥ 90% (flue gas 4-15% CO₂), cycle stability ≥ 5000 adsorption-desorption times, and full life cycle GHG emission reduction ≥ 80% assessed by LCA.',
    whyHard: 'CO₂ 在空气中浓度仅 420 ppm，分离能耗高。',
    aiPrompt: '介绍 amine 溶液、MOF、CAOX、Climeworks。',
    tags: ['气候', '材料', '能源'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Carbon Capture',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '设计新型吸附剂' }, { type: 'prototype', label: '原型设计', desc: '搭建小型 DAC 装置' }, { type: 'essay', label: '写文章/论文', desc: '介绍主要技术路线' }]
  },
  {
    id: 'protein-design',
    category: 'chemistry',
    title: '从头设计蛋白质',
    titleJa: 'タンパク質をゼロからデザインする',
    titleEs: 'Para cualquier geometría 3D objetivo + función química (unión/catálisis), utilice métodos similares a RFdiffusion/ProteinMPNN para diseñar proteínas de novo con: (a) desviación cuadrática media de la raíz objetivo (RMSD) ≤ 1,5 Å, (b) expresión experimental ≥ 10 mg/L y soluble, (c) actividad funcional objetivo ≥ 50% nivel de la proteína nativa más conocida, (d) fusión en caliente T_m ≥ 50°C.',
    titleEn: 'De Novo Protein Design',
    year: 2003,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'partially_solved',
    summary: '从零开始设计具有特定功能的新蛋白质',
    summaryJa: '特定の機能を持つ新しいタンパク質をゼロから設計する',
    summaryEs: 'Para cualquier geometría 3D objetivo + función química (unión/catálisis), utilice métodos similares a RFdiffusion/ProteinMPNN para diseñar proteínas de novo con: (a) desviación cuadrática media de la raíz objetivo (RMSD) ≤ 1,5 Å, (b) expresión experimental ≥ 10 mg/L y soluble, (c) actividad funcional objetivo ≥ 50% nivel de la proteína nativa más conocida, (d) fusión en caliente T_m ≥ 50°C.',
    summaryEn: 'For any target 3D geometry + chemical function (binding/catalysis), use RFdiffusion/ProteinMPNN-like methods to design proteins de novo with: (a) target root mean square deviation (RMSD) ≤ 1.5 Å, (b) experimental expression ≥ 10 mg/L and soluble, (c) target functional activity ≥ 50% level of the best known native protein, (d) hot melt T_m ≥ 50°C.',
    kid: '蛋白质是身体里的"小机器"，每种蛋白质有不同形状做不同事（比如消化食物、对抗病毒）。能不能让电脑帮我们设计"全新"的蛋白质，做我们想要的事？AlphaFold 和 David Baker 的工作让这变可能了，但还有很长的路。',
    formal: '对任意目标 3D 几何 + 化学功能 (结合/催化)，用 RFdiffusion/ProteinMPNN 类方法从头设计蛋白，满足：(a) 目标均方根偏差 (RMSD) ≤ 1.5 Å，(b) 实验表达量 ≥ 10 mg/L 且可溶，(c) 目标功能活性 ≥ 已知最佳天然蛋白 50% 水平，(d) 热熔 T_m ≥ 50°C。',
    formalJa: '任意の標的３ Ｄジオメトリ＋化学機能（結合／触媒作用）について、タンパク質は、（ ａ ）標的根平均平方偏差（ ＲＭＳＤ ）≦ １ ． ５ Å、（ ｂ ）実験発現レベルが１ ０ ｍｇ ／ Ｌ以上で可溶性、（ ｃ ）標的機能活性が最もよく知られている天然タンパク質の５ ０ ％以上であり、（ ｄ ）ホットメルトＴ ＿ ｍが５ ０ ℃以上であることを満たすように、ＲＦ拡散／プロテインＭＰＮＮクラス法を使用してゼロから設計される。',
    formalEs: 'Para cualquier geometría 3D objetivo + función química (unión/catálisis), utilice métodos similares a RFdiffusion/ProteinMPNN para diseñar proteínas de novo con: (a) desviación cuadrática media de la raíz objetivo (RMSD) ≤ 1,5 Å, (b) expresión experimental ≥ 10 mg/L y soluble, (c) actividad funcional objetivo ≥ 50% nivel de la proteína nativa más conocida, (d) fusión en caliente T_m ≥ 50°C.',
    formalEn: 'For any target 3D geometry + chemical function (binding/catalysis), use RFdiffusion/ProteinMPNN-like methods to design proteins de novo with: (a) target root mean square deviation (RMSD) ≤ 1.5 Å, (b) experimental expression ≥ 10 mg/L and soluble, (c) target functional activity ≥ 50% level of the best known native protein, (d) hot melt T_m ≥ 50°C.',
    whyHard: '蛋白质设计空间巨大，序列-结构-功能关系复杂。',
    aiPrompt: '介绍 David Baker、RFdiffusion、ProteinMPNN。',
    tags: ['生物', 'AI', '药物'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Protein Design',
    videoChannel: 'Quanta',
    participate: [{ type: 'code', label: '写代码/算法', desc: '跑 RFdiffusion 设计小蛋白' }, { type: 'experiment', label: '动手实验', desc: '在大肠杆菌中表达' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Baker 实验室' }]
  },
  {
    id: 'plastic-degradation',
    category: 'chemistry',
    title: '塑料生物降解',
    titleJa: 'プラスチックの生分解',
    titleEs: 'Se diseñaron bacterias diseñadas para degradar completamente el PET en monómeros a < 24 horas y < 50 °C.',
    titleEn: 'Plastic Biodegradation',
    year: 2016,
    proposer: 'Ideonella sakaiensis',
    difficulty: 3,
    reward: 1500,
    status: 'open',
    summary: '细菌/酶能在几个月内把塑料变回单体',
    summaryJa: '細菌/酵素は数ヶ月でプラスチックをモノマーに戻すことができます',
    summaryEs: 'Se diseñaron bacterias diseñadas para degradar completamente el PET en monómeros a < 24 horas y < 50 °C.',
    summaryEn: 'Engineered bacteria were designed to completely degrade PET into monomers at < 24 hours and < 50°C.',
    kid: '塑料污染地球几百年。日本 2016 年发现一种细菌 Ideonella sakaiensis，能用 PETase 酶在 6 周内把 PET 塑料"吃掉"。能不能把这种酶工程化到工业规模？',
    formal: '设计工程菌在 < 24 小时、< 50°C 下将 PET 完全降解为单体。',
    formalJa: '操作された細菌は、< 24時間、< 50 ℃でPETをモノマーに完全に分解するように設計されている。',
    formalEs: 'Se diseñaron bacterias diseñadas para degradar completamente el PET en monómeros a < 24 horas y < 50 °C.',
    formalEn: 'Engineered bacteria were designed to completely degrade PET into monomers at < 24 hours and < 50°C.',
    whyHard: '酶活性和稳定性需要工程化改造。',
    aiPrompt: '介绍 PETase/MHETase、Carbios。',
    tags: ['环境', '酶', '循环'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Plastic Eating Bacteria',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '改造 PETase' }, { type: 'code', label: '写代码/算法', desc: '用 AlphaFold 预测新结构' }, { type: 'kid-project', label: '儿童项目', desc: '观察塑料在土里降解' }]
  },
  {
    id: 'water-splitting',
    category: 'chemistry',
    title: '水分解催化剂',
    titleJa: '水分解触媒',
    titleEs: 'Desarrollar electrocatalizadores REA/HER: sobrepotencial ≤ 100 mV a 10 mA/cm², pendiente de Tafel ≤ 30 mV/dec, caída de actividad < 10 % después de 1000 horas de prueba de estabilidad galvanostática y utilizar únicamente elementos de alto rendimiento (a base de Fe/Co/Ni/Mn).',
    titleEn: 'Efficient Water Splitting Catalysts',
    year: 1970,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '用便宜催化剂高效分解水产生氢气',
    summaryJa: '水素を生成するための安価な触媒による水の効率的な分解',
    summaryEs: 'Desarrollar electrocatalizadores REA/HER: sobrepotencial ≤ 100 mV a 10 mA/cm², pendiente de Tafel ≤ 30 mV/dec, caída de actividad < 10 % después de 1000 horas de prueba de estabilidad galvanostática y utilizar únicamente elementos de alto rendimiento (a base de Fe/Co/Ni/Mn).',
    summaryEn: 'Develop OER/HER electrocatalysts: overpotential ≤ 100 mV at 10 mA/cm², Tafel slope ≤ 30 mV/dec, activity decay < 10% after 1000 hours galvanostatic stability test, and only use high-yield elements (Fe/Co/Ni/Mn based).',
    kid: '把水变成氢气（H₂）和氧气（O₂）是清洁能源的关键。但目前最好的催化剂是铂等贵金属。能不能用镍、铁、钴等便宜金属做到同样高效？',
    formal: '开发 OER/HER 电催化剂：10 mA/cm² 下过电位 ≤ 100 mV、Tafel 斜率 ≤ 30 mV/dec、1000 小时恒电流稳定性测试后活性衰减 < 10%，且仅使用丰产元素（Fe/Co/Ni/Mn 基）。',
    formalJa: 'ＯＥＲ ／ ＨＥＲ電気触媒の開発： １ ０ ｍＡ ／ ｃｍ ²での過電位≦ １ ０ ０ ｍＶ、Ｔａｆｅｌスロープ≦ ３ ０ ｍＶ ／ ｄｅｃ、１ ０ ０ ０時間の定電流安定性試験後の１ ０ ％未満の活性減衰、及び高収率元素（ Ｆｅ ／ Ｃｏ ／ Ｎｉ ／ Ｍｎ系）のみの使用。',
    formalEs: 'Desarrollar electrocatalizadores REA/HER: sobrepotencial ≤ 100 mV a 10 mA/cm², pendiente de Tafel ≤ 30 mV/dec, caída de actividad < 10 % después de 1000 horas de prueba de estabilidad galvanostática y utilizar únicamente elementos de alto rendimiento (a base de Fe/Co/Ni/Mn).',
    formalEn: 'Develop OER/HER electrocatalysts: overpotential ≤ 100 mV at 10 mA/cm², Tafel slope ≤ 30 mV/dec, activity decay < 10% after 1000 hours galvanostatic stability test, and only use high-yield elements (Fe/Co/Ni/Mn based).',
    whyHard: '反应涉及 4 电子转移，动力学慢。',
    aiPrompt: '介绍 OER/HER 催化剂、单原子催化。',
    tags: ['催化', '能源', '氢'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Water Splitting',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '合成单原子催化剂' }, { type: 'code', label: '写代码/算法', desc: 'DFT 模拟反应路径' }, { type: 'essay', label: '写文章/论文', desc: '介绍绿氢路线' }]
  },
  {
    id: 'co2-to-fuel',
    category: 'chemistry',
    title: 'CO₂ 变燃料',
    titleJa: 'CO ₂コンバーチブル燃料',
    titleEs: 'Desarrollar un catalizador electrocatalítico de reducción de CO₂ (CO₂RR): eficiencia faradaica ≥ 50 % (para un solo producto CO/CH₃OH/C₂H₄, etc.), densidad de corriente ≥ 200 mA/cm², estabilidad ≥ 1000 horas, selectividad del producto ≥ 90 %, y la reacción se lleva a cabo en una solución acuosa a temperatura y presión normales.',
    titleEn: 'CO₂ to Fuel Conversion',
    year: 2010,
    proposer: '—',
    difficulty: 4,
    reward: 2500,
    status: 'open',
    summary: '把 CO₂ 直接变成甲醇、乙醇或液态烃',
    summaryJa: 'CO ₂をメタノール、エタノール、または液体炭化水素に直接変換',
    summaryEs: 'Desarrollar un catalizador electrocatalítico de reducción de CO₂ (CO₂RR): eficiencia faradaica ≥ 50 % (para un solo producto CO/CH₃OH/C₂H₄, etc.), densidad de corriente ≥ 200 mA/cm², estabilidad ≥ 1000 horas, selectividad del producto ≥ 90 %, y la reacción se lleva a cabo en una solución acuosa a temperatura y presión normales.',
    summaryEn: 'Develop electrocatalytic CO₂ reduction (CO₂RR) catalyst: Faradaic efficiency ≥ 50% (for single product CO/CH₃OH/C₂H₄, etc.), current density ≥ 200 mA/cm², stability ≥ 1000 hours, product selectivity ≥ 90%, and the reaction is carried out in an aqueous solution at normal temperature and pressure.',
    kid: '如果能把空气中的 CO₂ 直接变成汽油、酒精或航空燃料，碳循环就闭合了。目前电催化/光催化能转，但效率低、不稳定。',
    formal: '开发电催化 CO₂ 还原 (CO₂RR) 催化剂：法拉第效率 ≥ 50%（对单一产物 CO/CH₃OH/C₂H₄ 等）、电流密度 ≥ 200 mA/cm²、稳定性 ≥ 1000 小时、产物选择性 ≥ 90%，且反应在常温常压水溶液中进行。',
    formalJa: '電気触媒CO ₂還元（ CO ₂ RR ）触媒の開発：ファラデー効率≧ 50 ％ （単一生成物CO/CH ² OH/C ₂ H ²など）、電流密度≧ 200 mA/cm ²、安定性≧ 1000時間、生成物選択性≧ 90 ％、および常温常圧水溶液中での反応。',
    formalEs: 'Desarrollar un catalizador electrocatalítico de reducción de CO₂ (CO₂RR): eficiencia faradaica ≥ 50 % (para un solo producto CO/CH₃OH/C₂H₄, etc.), densidad de corriente ≥ 200 mA/cm², estabilidad ≥ 1000 horas, selectividad del producto ≥ 90 %, y la reacción se lleva a cabo en una solución acuosa a temperatura y presión normales.',
    formalEn: 'Develop electrocatalytic CO₂ reduction (CO₂RR) catalyst: Faradaic efficiency ≥ 50% (for single product CO/CH₃OH/C₂H₄, etc.), current density ≥ 200 mA/cm², stability ≥ 1000 hours, product selectivity ≥ 90%, and the reaction is carried out in an aqueous solution at normal temperature and pressure.',
    whyHard: 'CO₂ 稳定，C=O 难打破；多产物选择性难。',
    aiPrompt: '介绍 Cu 催化剂、CO₂RR。',
    tags: ['催化', '能源', '循环'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'CO2 to Fuel',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '尝试新型催化剂' }, { type: 'code', label: '写代码/算法', desc: 'DFT 模拟 CO₂RR 路径' }, { type: 'essay', label: '写文章/论文', desc: '介绍主要进展' }]
  },
  {
    id: 'perovskite-solar',
    category: 'chemistry',
    title: '钙钛矿太阳能电池稳定性',
    titleJa: 'ペロブスカイト太陽電池の安定性',
    titleEs: 'Los módulos de perovskita mantienen una degradación de eficiencia <10% durante 25 años bajo 1 sol de iluminación continua.',
    titleEn: 'Perovskite Solar Cell Stability',
    year: 2009,
    proposer: 'M. Miyasaka',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '把钙钛矿电池的寿命做到 25 年以上',
    summaryJa: '25年以上のペロブスカイト電池寿命を達成',
    summaryEs: 'Los módulos de perovskita mantienen una degradación de eficiencia <10% durante 25 años bajo 1 sol de iluminación continua.',
    summaryEn: 'Perovskite modules maintain <10% efficiency degradation for 25 years under 1 sun of continuous illumination.',
    kid: '钙钛矿太阳能电池效率已达 26%（比硅还高），但很容易在湿、热、光下分解。需要包封或工程化让它稳定 25 年。',
    formal: '钙钛矿组件在 1 sun 连续照射下保持 25 年 < 10% 效率衰减。',
    formalJa: 'ペロブスカイトアセンブリは、1日連続照射下で10 ％未満の効率減衰を25年間維持します。',
    formalEs: 'Los módulos de perovskita mantienen una degradación de eficiencia <10% durante 25 años bajo 1 sol de iluminación continua.',
    formalEn: 'Perovskite modules maintain <10% efficiency degradation for 25 years under 1 sun of continuous illumination.',
    whyHard: '离子迁移和分解机制。',
    aiPrompt: '介绍钙钛矿太阳能电池。',
    tags: ['能源', '材料', '光伏'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Perovskite Solar',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '尝试新型钙钛矿组分' }, { type: 'code', label: '写代码/算法', desc: 'DFT 模拟降解' }, { type: 'essay', label: '写文章/论文', desc: '介绍光伏历史' }]
  },
  {
    id: 'li-air-battery',
    category: 'chemistry',
    title: '锂空气电池',
    titleJa: 'リチウム空気電池',
    titleEs: 'Obtenga una batería Li-O₂/Li-aire: densidad de energía real ≥ 1000 Wh/kg, ciclo de vida ≥ 500 veces (tasa de retención de capacidad ≥ 80%), eficiencia de ida y vuelta ≥ 80% y producto de descarga catódica Li₂O₂ se genera de forma reversible (verificación de caracterización XRD/XPS).',
    titleEn: 'Li-Air Battery',
    year: 1996,
    proposer: 'K. Abraham',
    difficulty: 5,
    reward: 3000,
    status: 'open',
    summary: '理论能量密度接近汽油的电池',
    summaryJa: '理論エネルギー密度がガソリンに近いバッテリー',
    summaryEs: 'Obtenga una batería Li-O₂/Li-aire: densidad de energía real ≥ 1000 Wh/kg, ciclo de vida ≥ 500 veces (tasa de retención de capacidad ≥ 80%), eficiencia de ida y vuelta ≥ 80% y producto de descarga catódica Li₂O₂ se genera de forma reversible (verificación de caracterización XRD/XPS).',
    summaryEn: 'Realize Li-O₂/Li-air battery: actual energy density ≥ 1000 Wh/kg, cycle life ≥ 500 times (capacity retention rate ≥ 80%), round-trip efficiency ≥ 80%, and cathode discharge product Li₂O₂ is reversibly generated (XRD/XPS characterization verification).',
    kid: '锂空气电池用空气中的氧做正极，理论能量密度 ~3500 Wh/kg（接近汽油 13000 Wh/kg）。如果实现，电动车续航能和燃油车比。问题：副反应多、效率低、电极易堵。',
    formal: '实现 Li-O₂/Li-air 电池：实际能量密度 ≥ 1000 Wh/kg、循环寿命 ≥ 500 次（容量保持率 ≥ 80%）、往返效率 ≥ 80%，且阴极放电产物 Li₂O₂ 可逆生成（XRD/XPS 表征验证）。',
    formalJa: 'Li - O ₂/Li - airバッテリーを実現：実際のエネルギー密度は≥ 1000 Wh/kg、サイクル寿命は≥ 500回（容量保持率≥ 80 ％ ）、往復効率は≥ 80 ％、陰極放電生成物Li ₂ O ₂は可逆的に生成されます（ XRD/XPS特性検証）。',
    formalEs: 'Obtenga una batería Li-O₂/Li-aire: densidad de energía real ≥ 1000 Wh/kg, ciclo de vida ≥ 500 veces (tasa de retención de capacidad ≥ 80%), eficiencia de ida y vuelta ≥ 80% y producto de descarga catódica Li₂O₂ se genera de forma reversible (verificación de caracterización XRD/XPS).',
    formalEn: 'Realize Li-O₂/Li-air battery: actual energy density ≥ 1000 Wh/kg, cycle life ≥ 500 times (capacity retention rate ≥ 80%), round-trip efficiency ≥ 80%, and cathode discharge product Li₂O₂ is reversibly generated (XRD/XPS characterization verification).',
    whyHard: '氧还原反应复杂，过氧化锂堵塞电极。',
    aiPrompt: '介绍 Li-air 原理和挑战。',
    tags: ['电池', '能源', '材料'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Li-Air Battery',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '新型正极催化剂' }, { type: 'code', label: '写代码/算法', desc: '模拟 OER/ORR 路径' }, { type: 'essay', label: '写文章/论文', desc: '介绍锂电池发展' }]
  },
  {
    id: 'enzyme-design',
    category: 'chemistry',
    title: '从头设计酶',
    titleJa: 'ゼロから酵素を設計する',
    titleEs: 'Para cualquier reacción química que no existe en la naturaleza, diseñar enzimas (incluida la evolución dirigida) para lograr mejoras en la velocidad catalítica k_cat/k_uncat ≥ 10³, K_M ≤ 1 mM, estereoselectividad ≥ 99% ee y verificar la geometría del sitio activo a través de estructuras cristalinas (RMSD < 1 Å).',
    titleEn: 'De Novo Enzyme Design',
    year: 2008,
    proposer: 'D. Baker',
    difficulty: 5,
    reward: 3000,
    status: 'partially_solved',
    summary: '设计自然界不存在的全新酶',
    summaryJa: '自然界に存在しないまったく新しい酵素を設計する',
    summaryEs: 'Para cualquier reacción química que no existe en la naturaleza, diseñar enzimas (incluida la evolución dirigida) para lograr mejoras en la velocidad catalítica k_cat/k_uncat ≥ 10³, K_M ≤ 1 mM, estereoselectividad ≥ 99% ee y verificar la geometría del sitio activo a través de estructuras cristalinas (RMSD < 1 Å).',
    summaryEn: 'For any chemical reaction that does not exist in nature, design enzymes (including directed evolution) to achieve catalytic rate improvements k_cat/k_uncat ≥ 10³, K_M ≤ 1 mM, stereoselectivity ≥ 99% ee, and verify the active site geometry through crystal structures (RMSD < 1 Å).',
    kid: '酶是生物体内的"纳米机器"，能精确催化反应。如果我们能从零设计新酶——比如把工业上需要的高温高压反应变成室温水中的反应——化学工业将被改变。',
    formal: '对任意未在自然界存在的化学反应，设计酶（含定向进化）实现催化速率提升 k_cat/k_uncat ≥ 10³、K_M ≤ 1 mM、立体选择性 ≥ 99% ee，并通过晶体结构 (RMSD < 1 Å) 验证活性位几何。',
    formalJa: '自然界に存在しない任意の化学反応について、酵素（指向性進化を含む）は、ｋ ＿ ｃａｔ ／ ｋ ＿ ｃｏｎｃａｔ ≧ １ ０ ³、Ｋ ＿ Ｍ ≦ １ ｍ Ｍ、立体選択性≧ ９ ９ ％ ｅ ｅの触媒速度増加を達成するように設計され、活性部位の形状は、結晶構造（ ＲＭＳＤ ＜ １ Å ）によって検証される。',
    formalEs: 'Para cualquier reacción química que no existe en la naturaleza, diseñar enzimas (incluida la evolución dirigida) para lograr mejoras en la velocidad catalítica k_cat/k_uncat ≥ 10³, K_M ≤ 1 mM, estereoselectividad ≥ 99% ee y verificar la geometría del sitio activo a través de estructuras cristalinas (RMSD < 1 Å).',
    formalEn: 'For any chemical reaction that does not exist in nature, design enzymes (including directed evolution) to achieve catalytic rate improvements k_cat/k_uncat ≥ 10³, K_M ≤ 1 mM, stereoselectivity ≥ 99% ee, and verify the active site geometry through crystal structures (RMSD < 1 Å).',
    whyHard: '反应过渡态几何与活性位点的精确匹配。',
    aiPrompt: '介绍从头酶设计流程。',
    tags: ['生物', 'AI', '催化'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Enzyme Design',
    videoChannel: 'Quanta',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 RFdiffusion 设计酶骨架' }, { type: 'experiment', label: '动手实验', desc: '在酵母中表达并测活' }, { type: 'essay', label: '写文章/论文', desc: '介绍 David Baker 实验室' }]
  },
  {
    id: 'self-healing',
    category: 'chemistry',
    title: '自修复材料',
    titleJa: '自己修復素材',
    titleEs: 'Materiales de ingeniería diseñados para > 5 ciclos de autorreparación, eficiencia de reparación > 90 %.',
    titleEn: 'Self-Healing Materials',
    year: 2001,
    proposer: 'S. R. White et al.',
    difficulty: 3,
    reward: 1500,
    status: 'open',
    summary: '像生物组织一样能自我修复的材料',
    summaryJa: '生体組織などの自己修復材料',
    summaryEs: 'Materiales de ingeniería diseñados para > 5 ciclos de autorreparación, eficiencia de reparación > 90 %.',
    summaryEn: 'Engineered materials designed for > 5 self-healing cycles, repair efficiency > 90%.',
    kid: '手机屏幕裂了没法自己长好。能设计出被切开后自动愈合的材料吗？像人体皮肤一样，受损后能自我修复。',
    formal: '设计 > 5 次自修复循环、修复效率 > 90% 的工程材料。',
    formalJa: '設計> 5回の自己修復サイクル、修復効率>エンジニアリング材料の90 ％。',
    formalEs: 'Materiales de ingeniería diseñados para > 5 ciclos de autorreparación, eficiencia de reparación > 90 %.',
    formalEn: 'Engineered materials designed for > 5 self-healing cycles, repair efficiency > 90%.',
    whyHard: '化学键的可逆性 vs 强度。',
    aiPrompt: '介绍微胶囊、DA 反应、金属配位。',
    tags: ['材料', '聚合物', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Self Healing Materials',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '合成 Diels-Alder 聚合物' }, { type: 'essay', label: '写文章/论文', desc: '介绍生物启发材料' }, { type: 'kid-project', label: '儿童项目', desc: '做明胶自愈实验' }]
  },
  {
    id: 'universal-antidote',
    category: 'chemistry',
    title: '通用解毒剂',
    titleJa: '万能解毒剤',
    titleEs: 'Antídoto in vivo eficaz contra todas las clases de toxinas calibradas (agentes nerviosos, metales pesados, alcaloides, etc.).',
    titleEn: 'Universal Antidote',
    year: 2020,
    proposer: '—',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '一种能对付所有生物毒素/化学毒剂的解毒剂',
    summaryJa: 'すべてのバイオトキシン/化学物質に対する解毒剤',
    summaryEs: 'Antídoto in vivo eficaz contra todas las clases de toxinas calibradas (agentes nerviosos, metales pesados, alcaloides, etc.).',
    summaryEn: 'In vivo antidote effective against all calibrated toxin classes (nerve agents, heavy metals, alkaloids, etc.).',
    kid: '蛇咬、被毒气攻击、误食毒蘑菇——很多不同的毒需要不同的解药。能不能造一种"通用解毒剂"，把毒分子"吸住"排出体外？',
    formal: '对所有标定毒素类（神经毒剂、重金属、生物碱等）都有效的体内解毒剂。',
    formalJa: 'すべての標識された毒素（神経剤、重金属、アルカロイドなど）に対して有効なインビボ解毒剤。',
    formalEs: 'Antídoto in vivo eficaz contra todas las clases de toxinas calibradas (agentes nerviosos, metales pesados, alcaloides, etc.).',
    formalEn: 'In vivo antidote effective against all calibrated toxin classes (nerve agents, heavy metals, alkaloids, etc.).',
    whyHard: '毒素的化学结构差异大。',
    aiPrompt: '介绍环糊精、卟啉、MOF 在解毒中的应用。',
    tags: ['生物', '药物', '安全'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Universal Antidote',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '设计 MOF 吸附剂' }, { type: 'essay', label: '写文章/论文', desc: '介绍解毒剂历史' }]
  },
  {
    id: 'anti-aging-mol',
    category: 'chemistry',
    title: '抗衰老分子',
    titleJa: 'アンチエイジング分子',
    titleEs: 'Un medicamento antienvejecimiento que prolonga la vida y que ha pasado los ensayos clínicos de fase III de la FDA.',
    titleEn: 'Anti-Aging Molecules',
    year: 2010,
    proposer: '—',
    difficulty: 4,
    reward: 5000,
    status: 'open',
    summary: '能找到延缓衰老的小分子吗？',
    summaryJa: '老化を遅らせる小さな分子を見つけることができますか？',
    summaryEs: 'Un medicamento antienvejecimiento que prolonga la vida y que ha pasado los ensayos clínicos de fase III de la FDA.',
    summaryEn: 'A life-extending/anti-aging drug that has passed FDA Phase III clinical trials.',
    kid: '雷帕霉素、二甲双胍、NAD+ 补充剂在动物身上能延长寿命 10-20%。但人体证据有限。能找到一种安全、明确能延寿 5 年的分子吗？',
    formal: '通过 FDA 三期临床的延寿/抗衰药物。',
    formalJa: 'FDA Phase III Clinicalを通じた延命/アンチエイジング薬。',
    formalEs: 'Un medicamento antienvejecimiento que prolonga la vida y que ha pasado los ensayos clínicos de fase III de la FDA.',
    formalEn: 'A life-extending/anti-aging drug that has passed FDA Phase III clinical trials.',
    whyHard: '衰老通路众多，需要组合治疗。',
    aiPrompt: '介绍衰老标志（Hallmarks of Aging）。',
    tags: ['生物', '药物', '健康'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Anti Aging',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '动物试验' }, { type: 'essay', label: '写文章/论文', desc: '介绍 mTOR 通路' }]
  },
  {
    id: 'drug-delivery',
    category: 'chemistry',
    title: '精准药物递送',
    titleJa: '精密な薬物送達',
    titleEs: 'Sistema de administración de fármacos con selectividad >100:1 para cualquier tipo de órgano/célula determinado.',
    titleEn: 'Targeted Drug Delivery',
    year: 1970,
    proposer: 'P. Ehrlich (magic bullet)',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '让药物只去该去的地方',
    summaryJa: '薬は行きたい場所にだけ置いておく',
    summaryEs: 'Sistema de administración de fármacos con selectividad >100:1 para cualquier tipo de órgano/célula determinado.',
    summaryEn: 'Drug delivery system with >100:1 selectivity for any given organ/cell type.',
    kid: '化疗会杀死所有快速分裂的细胞——包括健康的。能造一种"魔法子弹"，让药物只攻击肿瘤？',
    formal: '对任何指定器官/细胞类型，选择性 > 100:1 的药物递送系统。',
    formalJa: '任意の所与の臓器／細胞タイプのための選択的＞ １ ０ ０ ： １の薬物送達システム。',
    formalEs: 'Sistema de administración de fármacos con selectividad >100:1 para cualquier tipo de órgano/célula determinado.',
    formalEn: 'Drug delivery system with >100:1 selectivity for any given organ/cell type.',
    whyHard: '生理屏障（血脑屏障、肿瘤微环境）。',
    aiPrompt: '介绍抗体偶联药物(ADC)、纳米载体、外泌体。',
    tags: ['药物', '纳米', '精准医疗'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Drug Delivery',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '设计脂质纳米颗粒' }, { type: 'essay', label: '写文章/论文', desc: '介绍 ADC 药物历史' }]
  },
  {
    id: 'cnt-bulk',
    category: 'chemistry',
    title: '碳纳米管批量生产',
    titleJa: 'カーボンナノチューブの量産',
    titleEs: 'Producción de nanotubos de carbono de grado industrial: pureza ≥ 99,9 %, tasa de defectos ≤ 5 %, distribución de diámetro σ_d/μ_d ≤ 10 %, costo de producción ≤ US$100/kg, capacidad de producción anual ≥ 100 toneladas y grado de grafitización con relación G/D ≥ 100.',
    titleEn: 'CNT Bulk Production',
    year: 1991,
    proposer: 'S. Iijima (discovery)',
    difficulty: 3,
    reward: 1000,
    status: 'open',
    summary: '廉价地大量生产高纯度碳纳米管',
    summaryJa: '高純度カーボンナノチューブを安価に量産',
    summaryEs: 'Producción de nanotubos de carbono de grado industrial: pureza ≥ 99,9 %, tasa de defectos ≤ 5 %, distribución de diámetro σ_d/μ_d ≤ 10 %, costo de producción ≤ US$100/kg, capacidad de producción anual ≥ 100 toneladas y grado de grafitización con relación G/D ≥ 100.',
    summaryEn: 'Industrial-grade carbon nanotube production: purity ≥ 99.9%, defect rate ≤ 5%, diameter distribution σ_d/μ_d ≤ 10%, production cost ≤ US$100/kg, annual production capacity ≥ 100 tons, and graphitization degree with G/D ratio ≥ 100.',
    kid: '碳纳米管是神奇材料：超轻、超强、导电导热都好。但目前价格贵、纯度低、长度不均。需要工业级批量生产工艺。',
    formal: '工业级碳纳米管生产：纯度 ≥ 99.9%、缺陷率 ≤ 5%、直径分布 σ_d/μ_d ≤ 10%、生产成本 ≤ 100 美元/公斤、年产能 ≥ 100 吨，且具备 G/D 比 ≥ 100 的石墨化度。',
    formalJa: '工業用グレードのカーボンナノチューブの生産：純度≧ 99.9 ％、欠陥率≦ 5 ％、直径分布σ_d/μ_d ≦ 10 ％、生産コスト≦ US $ 100/kg、年間生産能力≧ 100トン、およびG/D比率≧ 100のグラフィット化。',
    formalEs: 'Producción de nanotubos de carbono de grado industrial: pureza ≥ 99,9 %, tasa de defectos ≤ 5 %, distribución de diámetro σ_d/μ_d ≤ 10 %, costo de producción ≤ US$100/kg, capacidad de producción anual ≥ 100 toneladas y grado de grafitización con relación G/D ≥ 100.',
    formalEn: 'Industrial-grade carbon nanotube production: purity ≥ 99.9%, defect rate ≤ 5%, diameter distribution σ_d/μ_d ≤ 10%, production cost ≤ US$100/kg, annual production capacity ≥ 100 tons, and graphitization degree with G/D ratio ≥ 100.',
    whyHard: '生长动力学和催化剂控制。',
    aiPrompt: '介绍 CVD 法、浮动催化剂法。',
    tags: ['纳米', '材料', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Carbon Nanotube',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '优化 CVD 参数' }, { type: 'code', label: '写代码/算法', desc: '模拟生长动力学' }, { type: 'essay', label: '写文章/论文', desc: '介绍 CNT 应用' }]
  },
  {
    id: 'graphene-app',
    category: 'chemistry',
    title: '石墨烯实际应用',
    titleJa: 'グラフェンの実用化',
    titleEs: 'Producción de rollos de película de grafeno (método de deposición química de vapor): tasa de capa única ≥ 95 %, resistencia de la lámina ≤ 10 Ω/sq, costo ≤ 100 USD/m², ancho ≥ 1 m, tasa de producción continua ≥ 1 m/min y sin defectos obvios (Raman I_D/I_G < 0,1).',
    titleEn: 'Graphene Applications',
    year: 2004,
    proposer: 'A. Geim / K. Novoselov (discovery)',
    difficulty: 3,
    reward: 1000,
    status: 'open',
    summary: '让石墨烯走出实验室',
    summaryJa: 'ラボからグラフェンを取り出す',
    summaryEs: 'Producción de rollos de película de grafeno (método de deposición química de vapor): tasa de capa única ≥ 95 %, resistencia de la lámina ≤ 10 Ω/sq, costo ≤ 100 USD/m², ancho ≥ 1 m, tasa de producción continua ≥ 1 m/min y sin defectos obvios (Raman I_D/I_G < 0,1).',
    summaryEn: 'Graphene film (chemical vapor deposition method) roll production: single layer rate ≥ 95%, sheet resistance ≤ 10 Ω/sq, cost ≤ 100 USD/m², width ≥ 1 m, continuous production rate ≥ 1 m/min and no obvious defects (Raman I_D/I_G < 0.1).',
    kid: '石墨烯是单层碳原子，强度是钢的 200 倍，导电性比铜好。但 20 年过去了还没大规模商用——主要是难以廉价、批量、高质量生产。',
    formal: '石墨烯薄膜（化学气相沉积法）卷材生产：单层率 ≥ 95%、方块电阻 ≤ 10 Ω/sq、成本 ≤ 100 美元/m²、幅宽 ≥ 1 m、连续生产速率 ≥ 1 m/min 且无明显缺陷（拉曼 I_D/I_G < 0.1）。',
    formalJa: 'グラフェンフィルム（化学蒸着）コイル生産：単層レート≧ 95 ％、正方形抵抗≦ 10 Ω/sq、コスト≦ 100 USD/m ²、幅≧ 1 m、連続生産レート≧ 1 m/min、および明らかな欠陥なし（ラマンI_D/I_G < 0.1 ）。',
    formalEs: 'Producción de rollos de película de grafeno (método de deposición química de vapor): tasa de capa única ≥ 95 %, resistencia de la lámina ≤ 10 Ω/sq, costo ≤ 100 USD/m², ancho ≥ 1 m, tasa de producción continua ≥ 1 m/min y sin defectos obvios (Raman I_D/I_G < 0,1).',
    formalEn: 'Graphene film (chemical vapor deposition method) roll production: single layer rate ≥ 95%, sheet resistance ≤ 10 Ω/sq, cost ≤ 100 USD/m², width ≥ 1 m, continuous production rate ≥ 1 m/min and no obvious defects (Raman I_D/I_G < 0.1).',
    whyHard: '晶界、缺陷控制。',
    aiPrompt: '介绍 CVD 石墨烯、液相剥离法。',
    tags: ['纳米', '材料', '电子'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Graphene',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '优化 CVD' }, { type: 'essay', label: '写文章/论文', desc: '介绍石墨烯应用' }]
  },
  {
    id: 'mof-discovery',
    category: 'chemistry',
    title: 'MOF 性能突破',
    titleJa: 'MOFパフォーマンスのブレークスルー',
    titleEs: 'Diseñe MOF >10 veces el punto de referencia de la industria para aplicaciones específicas (captura de CO₂, almacenamiento de H₂, catálisis).',
    titleEn: 'MOF Performance Breakthrough',
    year: 1995,
    proposer: 'O. Yaghi',
    difficulty: 3,
    reward: 1500,
    status: 'open',
    summary: '找到性能更好的金属有机框架（MOF）',
    summaryJa: 'よりパフォーマンスの高い金属有機フレームワーク（ MOF ）を見つける',
    summaryEs: 'Diseñe MOF >10 veces el punto de referencia de la industria para aplicaciones específicas (captura de CO₂, almacenamiento de H₂, catálisis).',
    summaryEn: 'Design >10x industry benchmark MOFs for specified applications (CO₂ capture, H₂ storage, catalysis).',
    kid: 'MOF 是"海绵状"晶体，表面积惊人（1 克有 7000 m²）。可以存氢、捕 CO₂、催化反应。能不能设计 MOF 对特定任务有极致性能？',
    formal: '为指定应用（CO₂ 捕集、H₂ 存储、催化）设计 > 工业基准 10x 的 MOF。',
    formalJa: '指定された用途（ CO ₂捕捉、H ₂貯蔵、触媒）のために>業界ベンチマーク10 xのMOFを設計します。',
    formalEs: 'Diseñe MOF >10 veces el punto de referencia de la industria para aplicaciones específicas (captura de CO₂, almacenamiento de H₂, catálisis).',
    formalEn: 'Design >10x industry benchmark MOFs for specified applications (CO₂ capture, H₂ storage, catalysis).',
    whyHard: '组合空间巨大。',
    aiPrompt: '介绍 Yaghi 实验室、MOF 数据库。',
    tags: ['材料', '气体', '催化'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'MOF',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 ML 预测 MOF 性能' }, { type: 'experiment', label: '动手实验', desc: '合成目标 MOF' }, { type: 'essay', label: '写文章/论文', desc: '介绍 MOF 应用' }]
  },
  {
    id: 'synthetic-bio',
    category: 'chemistry',
    title: '合成生物学',
    titleJa: '合成生物学',
    titleEs: 'Diseñar rutas anabólicas que produzcan eficientemente cualquier molécula de interés.',
    titleEn: 'Synthetic Biology',
    year: 2000,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '把微生物改造成"细胞工厂"',
    summaryJa: '微生物を「細胞工場」に変える',
    summaryEs: 'Diseñar rutas anabólicas que produzcan eficientemente cualquier molécula de interés.',
    summaryEn: 'Design anabolic pathways that efficiently produce any molecule of interest.',
    kid: '改造大肠杆菌让它生产胰岛素、青蒿素、可降解塑料等。合成生物学让"设计生命"成为可能——但也带来伦理和安全问题。',
    formal: '设计能高效生产任意目标分子的合成代谢通路。',
    formalJa: '任意の標的分子を効率的に産生する同化経路を設計する。',
    formalEs: 'Diseñar rutas anabólicas que produzcan eficientemente cualquier molécula de interés.',
    formalEn: 'Design anabolic pathways that efficiently produce any molecule of interest.',
    whyHard: '生物系统调控复杂。',
    aiPrompt: '介绍 SynBio、iGEM、青蒿素酵母。',
    tags: ['生物', '工程', '伦理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Synthetic Biology',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 Cello/RBS 计算器设计' }, { type: 'experiment', label: '动手实验', desc: 'iGEM 团队项目' }, { type: 'essay', label: '写文章/论文', desc: '介绍青蒿素工程' }, { type: 'discuss', label: '想法/讨论', desc: '参与合成生物学伦理讨论' }]
  },
  {
    id: 'artificial-photo',
    category: 'chemistry',
    title: '人工光合作用',
    titleJa: '人工光合成',
    titleEs: 'Dispositivos fotosintéticos artificiales: eficiencia de conversión de energía solar a combustible (STF) ≥ 10 %, funcionamiento estable ≥ 1000 horas (sin degradación obvia), pureza del producto (H₂/CH₃OH, etc.) ≥ 95 %, y uso de catalizadores de metales no nobles.',
    titleEn: 'Artificial Photosynthesis',
    year: 1972,
    proposer: 'A. Fujishima / K. Honda',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '人造系统像植物一样把阳光 + 水 + CO₂ 变成燃料',
    summaryJa: '人工システムは、太陽光+水+ CO ₂を植物のような燃料に変換します',
    summaryEs: 'Dispositivos fotosintéticos artificiales: eficiencia de conversión de energía solar a combustible (STF) ≥ 10 %, funcionamiento estable ≥ 1000 horas (sin degradación obvia), pureza del producto (H₂/CH₃OH, etc.) ≥ 95 %, y uso de catalizadores de metales no nobles.',
    summaryEn: 'Artificial photosynthetic devices: Solar to fuel (STF) energy conversion efficiency ≥ 10%, stable operation ≥ 1000 hours (no obvious degradation), product (H₂/CH₃OH, etc.) purity ≥ 95%, and use non-noble metal catalysts.',
    kid: '植物用叶子把阳光、水、CO₂ 变成糖。如果我们能造"人造叶子"——一种能直接做同样事的装置——就能从太阳得到无限清洁燃料。',
    formal: '人造光合器件：太阳能到燃料 (STF) 能量转换效率 ≥ 10%、稳定运行 ≥ 1000 小时（无明显降解）、产物 (H₂/CH₃OH 等) 纯度 ≥ 95%，且使用非贵金属催化剂。',
    formalJa: '人工光合成装置：太陽光から燃料（ STF ）へのエネルギー変換効率≥ 10 ％、安定動作≥ 1000時間（有意な分解なし）、生成物（ H ₂/CH ² OHなど）純度≥ 95 ％、および非貴金属触媒の使用。',
    formalEs: 'Dispositivos fotosintéticos artificiales: eficiencia de conversión de energía solar a combustible (STF) ≥ 10 %, funcionamiento estable ≥ 1000 horas (sin degradación obvia), pureza del producto (H₂/CH₃OH, etc.) ≥ 95 %, y uso de catalizadores de metales no nobles.',
    formalEn: 'Artificial photosynthetic devices: Solar to fuel (STF) energy conversion efficiency ≥ 10%, stable operation ≥ 1000 hours (no obvious degradation), product (H₂/CH₃OH, etc.) purity ≥ 95%, and use non-noble metal catalysts.',
    whyHard: '水氧化动力学慢，催化剂易降解。',
    aiPrompt: '介绍 Honda-Fujishima 效应。',
    tags: ['能源', '催化', '仿生'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Artificial Photosynthesis',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '优化催化剂' }, { type: 'code', label: '写代码/算法', desc: 'DFT 模拟' }, { type: 'essay', label: '写文章/论文', desc: '介绍人工光合发展史' }]
  },
  {
    id: 'polymers-recycle',
    category: 'chemistry',
    title: '化学回收聚合物',
    titleJa: '化学的にリサイクルされたポリマー',
    titleEs: '< $100/tonelada proceso de recuperación química sin subproductos.',
    titleEn: 'Chemical Polymer Recycling',
    year: 2020,
    proposer: '—',
    difficulty: 3,
    reward: 1500,
    status: 'open',
    summary: '把塑料分解回单体无限循环',
    summaryJa: 'プラスチックを無限のモノマーループに分解する',
    summaryEs: '< $100/tonelada proceso de recuperación química sin subproductos.',
    summaryEn: '< $100/ton chemical recovery process with no by-products.',
    kid: '目前大多数塑料被"机械回收"（清洗、融化、再成型），多次后质量下降。化学回收把塑料分解回最初的原料——可以无限循环利用。',
    formal: '< 100 美元/吨的化学回收工艺且无副产物。',
    formalJa: '副産物のない100ドル/トン未満の化学回収プロセス。',
    formalEs: '< $100/tonelada proceso de recuperación química sin subproductos.',
    formalEn: '< $100/ton chemical recovery process with no by-products.',
    whyHard: '催化剂选择性、产物纯化。',
    aiPrompt: '介绍热解、解聚、酶回收。',
    tags: ['环境', '催化', '循环'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Chemical Recycling',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '新型解聚催化剂' }, { type: 'essay', label: '写文章/论文', desc: '介绍循环经济' }]
  },
  {
    id: 'topology-cond-mat',
    category: 'chemistry',
    title: '拓扑材料',
    titleJa: '位相材料',
    titleEs: 'Descubra nuevos materiales topológicos 3D o materiales topológicos superconductores.',
    titleEn: 'Topological Materials',
    year: 2005,
    proposer: 'C. L. Kane / E. J. Mele (theory)',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '发现新的拓扑材料（拓扑绝缘体、狄拉克半金属等）',
    summaryJa: '新しいトポロジカル材料（トポロジカル絶縁体、ディラックセミメタルなど）を発見する',
    summaryEs: 'Descubra nuevos materiales topológicos 3D o materiales topológicos superconductores.',
    summaryEn: 'Discover new 3D topological materials or topological superconducting materials.',
    kid: '有些材料的电子行为和形状有关——比如内部绝缘但表面是超导体。这些"拓扑材料"可能在量子计算、自旋电子学有重要应用。',
    formal: '发现新的 3D 拓扑材料或拓扑超导材料。',
    formalJa: '新しい3 Dトポロジカルまたはトポロジカル超伝導材料を発見してください。',
    formalEs: 'Descubra nuevos materiales topológicos 3D o materiales topológicos superconductores.',
    formalEn: 'Discover new 3D topological materials or topological superconducting materials.',
    whyHard: '材料预测和实验验证。',
    aiPrompt: '介绍拓扑绝缘体、QSH 效应。',
    tags: ['凝聚态', '材料', '拓扑'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Topological Materials',
    videoChannel: 'Quanta',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 DFT 预测新材料' }, { type: 'experiment', label: '动手实验', desc: 'ARPES 测量' }, { type: 'essay', label: '写文章/论文', desc: '介绍拓扑绝缘体' }]
  },
  {
    id: 'lithium-sulfur',
    category: 'chemistry',
    title: '锂硫电池',
    titleJa: 'リチウム硫黄電池',
    titleEs: 'Batería de litio-azufre: densidad de energía ≥ 500 Wh/kg, vida útil ≥ 1000 veces (caída de capacidad por ciclo ≤ 0,05%), carga del cátodo de azufre ≥ 4 mg/cm², relación electrolito/azufre < 5 μL/mg e inhibición de la lanzadera de polisulfuro (tasa de autodescarga < 5 %/mes).',
    titleEn: 'Lithium-Sulfur Battery',
    year: 1960,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '能量密度是锂离子 5 倍的下一代电池',
    summaryJa: 'リチウムイオン電池の5倍のエネルギー密度を持つ次世代電池',
    summaryEs: 'Batería de litio-azufre: densidad de energía ≥ 500 Wh/kg, vida útil ≥ 1000 veces (caída de capacidad por ciclo ≤ 0,05%), carga del cátodo de azufre ≥ 4 mg/cm², relación electrolito/azufre < 5 μL/mg e inhibición de la lanzadera de polisulfuro (tasa de autodescarga < 5 %/mes).',
    summaryEn: 'Lithium-sulfur battery: energy density ≥ 500 Wh/kg, cycle life ≥ 1000 times (capacity decay per cycle ≤ 0.05%), sulfur cathode loading ≥ 4 mg/cm², electrolyte/sulfur ratio < 5 μL/mg, and inhibiting polysulfide shuttle (self-discharge rate < 5%/month).',
    kid: '锂硫电池理论能量密度 2600 Wh/kg（vs 锂离子的 580 Wh/kg）。硫便宜丰富。但多硫化物"穿梭效应"让电池寿命短。',
    formal: '锂硫电池：能量密度 ≥ 500 Wh/kg、循环寿命 ≥ 1000 次（每次循环容量衰减 ≤ 0.05%）、硫正极载量 ≥ 4 mg/cm²、电解液/硫比 < 5 μL/mg，且抑制多硫化物穿梭（自放电率 < 5%/月）。',
    formalJa: 'リチウム硫黄電池：エネルギー密度≧ ５ ０ ０ Ｗｈ ／ ｋｇ、サイクル寿命≧ １ ０ ０ ０回（サイクル容量減衰当たり≦ ０ ． ０ ５ ％ ）、硫黄正荷重≧ ４ ｍｇ ／ ｃｍ ²、電解質／硫黄比＜ ５ μ Ｌ ／ ｍｇ、およびポリスルフィドシャトルを阻害する（自己放電率＜ ５ ％ ／月）。',
    formalEs: 'Batería de litio-azufre: densidad de energía ≥ 500 Wh/kg, vida útil ≥ 1000 veces (caída de capacidad por ciclo ≤ 0,05%), carga del cátodo de azufre ≥ 4 mg/cm², relación electrolito/azufre < 5 μL/mg e inhibición de la lanzadera de polisulfuro (tasa de autodescarga < 5 %/mes).',
    formalEn: 'Lithium-sulfur battery: energy density ≥ 500 Wh/kg, cycle life ≥ 1000 times (capacity decay per cycle ≤ 0.05%), sulfur cathode loading ≥ 4 mg/cm², electrolyte/sulfur ratio < 5 μL/mg, and inhibiting polysulfide shuttle (self-discharge rate < 5%/month).',
    whyHard: '多硫化物穿梭、硫体积膨胀。',
    aiPrompt: '介绍锂硫电池挑战。',
    tags: ['电池', '能源', '材料'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Lithium Sulfur',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '碳硫复合正极' }, { type: 'code', label: '写代码/算法', desc: '模拟穿梭效应' }, { type: 'essay', label: '写文章/论文', desc: '介绍锂电池未来' }]
  },
  {
    id: 'flow-battery',
    category: 'chemistry',
    title: '液流电池',
    titleJa: 'レドックスフロー電池',
    titleEs: '< Costo de almacenamiento de energía de $100/kWh, > 20 años de vida útil.',
    titleEn: 'Redox Flow Battery',
    year: 1975,
    proposer: 'L. H. Thaller',
    difficulty: 3,
    reward: 1500,
    status: 'open',
    summary: '电网级储能：把能量存在液体里',
    summaryJa: 'グリッドレベルのエネルギー貯蔵：液体にエネルギーを貯蔵する',
    summaryEs: '< Costo de almacenamiento de energía de $100/kWh, > 20 años de vida útil.',
    summaryEn: '< $100/kWh energy storage cost, > 20 year life.',
    kid: '太阳能/风能是间歇的，需要大型储能。液流电池把能量存在两个"液体罐"里，功率和容量可独立扩展。最便宜的是全钒液流电池。',
    formal: '< 100 美元/kWh 储能成本、> 20 年寿命。',
    formalJa: '<$ 100/kWhのエネルギー貯蔵コスト、> 20年の寿命。',
    formalEs: '< Costo de almacenamiento de energía de $100/kWh, > 20 años de vida útil.',
    formalEn: '< $100/kWh energy storage cost, > 20 year life.',
    whyHard: '电解液浓度与稳定性矛盾。',
    aiPrompt: '介绍全钒、Zn-Br、有机液流电池。',
    tags: ['能源', '电池', '电网'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Flow Battery',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '新型电解液' }, { type: 'essay', label: '写文章/论文', desc: '介绍电网储能' }]
  },
  {
    id: 'molecular-machine-chem',
    category: 'chemistry',
    title: '分子机器化学合成',
    titleJa: '分子機械化学合成',
    titleEs: 'Máquinas moleculares a nanoescala sintetizadas químicamente: capaces de completar más de 2 tareas independientes (movimiento/transporte/catálisis/puerta lógica) en solventes, ciclos de trabajo ≥ 1000 veces (sin fatiga obvia) y pueden verificarse mediante AFM/STM/fluorescencia de una sola molécula.',
    titleEn: 'Chemical Synthesis of Molecular Machines',
    year: 2016,
    proposer: 'J. F. Stoddart / B. L. Feringa / J.-P. Sauvage (Nobel)',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '化学合成的微型机器',
    summaryJa: '化学合成マイクロマシン',
    summaryEs: 'Máquinas moleculares a nanoescala sintetizadas químicamente: capaces de completar más de 2 tareas independientes (movimiento/transporte/catálisis/puerta lógica) en solventes, ciclos de trabajo ≥ 1000 veces (sin fatiga obvia) y pueden verificarse mediante AFM/STM/fluorescencia de una sola molécula.',
    summaryEn: 'Chemically synthesized nanoscale molecular machines: capable of completing more than 2 independent tasks (movement/transport/catalysis/logic gate) in solvents, working cycles ≥ 1000 times (no obvious fatigue), and can be verified by AFM/STM/single molecule fluorescence.',
    kid: '如果你能造出和分子一样小的机器人，让它在你血管里跑来跑去治病，会怎样？2016 年三位化学家因"分子机器"获诺贝尔化学奖——但目前还只是开关、轮子等基本元件。',
    formal: '化学合成纳米级分子机器：能在溶剂中完成 2 种以上独立任务（运动/运输/催化/逻辑门），工作循环 ≥ 1000 次（无明显疲劳），且可通过 AFM/STM/单分子荧光验证。',
    formalJa: 'ナノスケール分子機械の化学合成：溶媒中で2つ以上の独立したタスク（運動/輸送/触媒/ロジックゲート）を完了する能力、1000以上の作業サイクル（有意な疲労なし）、AFM/STM/単一分子蛍光によって検証することができます。',
    formalEs: 'Máquinas moleculares a nanoescala sintetizadas químicamente: capaces de completar más de 2 tareas independientes (movimiento/transporte/catálisis/puerta lógica) en solventes, ciclos de trabajo ≥ 1000 veces (sin fatiga obvia) y pueden verificarse mediante AFM/STM/fluorescencia de una sola molécula.',
    formalEn: 'Chemically synthesized nanoscale molecular machines: capable of completing more than 2 independent tasks (movement/transport/catalysis/logic gate) in solvents, working cycles ≥ 1000 times (no obvious fatigue), and can be verified by AFM/STM/single molecule fluorescence.',
    whyHard: '原子级精度控制。',
    aiPrompt: '介绍分子开关、轮烷、分子马达。',
    tags: ['纳米', '化学', '分子'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Molecular Machines',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '合成新轮烷' }, { type: 'essay', label: '写文章/论文', desc: '介绍 2016 诺贝尔奖' }]
  },
  {
    id: 'green-chem',
    category: 'chemistry',
    title: '绿色化学 12 原则',
    titleJa: 'グリーン化学の12の原則',
    titleEs: 'Lograr que más del 90 % de las respuestas industriales cumplan con 12 principios ecológicos y a costos comparables.',
    titleEn: 'Green Chemistry 12 Principles',
    year: 1998,
    proposer: 'P. Anastas / J. Warner',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '让所有化学反应都符合 12 项绿色原则',
    summaryJa: 'すべての化学反応を12のグリーン原則に準拠させる',
    summaryEs: 'Lograr que más del 90 % de las respuestas industriales cumplan con 12 principios ecológicos y a costos comparables.',
    summaryEn: 'Make >90% of industrial responses compliant with 12 green principles and at comparable costs.',
    kid: '化学工业生产了 90% 的产品但用掉大量能源、产生大量废物。能不能让所有反应都符合 12 条绿色原则（不产生废物、用可再生原料、低毒等）？',
    formal: '让 > 90% 工业反应符合 12 项绿色原则且成本可比。',
    formalJa: '90%を超える産業界の反応は、12のグリーン原則と同等のコストを満たしています。',
    formalEs: 'Lograr que más del 90 % de las respuestas industriales cumplan con 12 principios ecológicos y a costos comparables.',
    formalEn: 'Make >90% of industrial responses compliant with 12 green principles and at comparable costs.',
    whyHard: '经济性 vs 环保。',
    aiPrompt: '介绍 12 条原则。',
    tags: ['环境', '工业', '可持续'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Green Chemistry',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 12 原则' }, { type: 'experiment', label: '动手实验', desc: '设计原子经济反应' }]
  },
  {
    id: 'origin-of-life',
    category: 'biology',
    title: '生命起源',
    titleJa: '生命の起源',
    titleEs: 'Genere sistemas moleculares autorreplicantes, evolucionables y seleccionables a partir de química inorgánica en condiciones primitivas de la Tierra.',
    titleEn: 'Origin of Life',
    year: 1924,
    proposer: 'A. Oparin / J. B. S. Haldane',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '第一个能自我复制的分子是怎么出现的？',
    summaryJa: '最初の自己複製分子はどのように出現したのですか？',
    summaryEs: 'Genere sistemas moleculares autorreplicantes, evolucionables y seleccionables a partir de química inorgánica en condiciones primitivas de la Tierra.',
    summaryEn: 'Generate self-replicating, evolvable, and selectable molecular systems from inorganic chemistry under primitive Earth conditions.',
    kid: '几十亿年前，地球只是一团岩石和海洋。但不知怎么，里面冒出了能自我复制的小东西——第一个"生命"。这是怎么发生的？科学家们还在争论。',
    formal: '在原始地球条件下从无机化学产生能自我复制、可进化、可被选择的分子系统。',
    formalJa: '原始的な地球環境の無機化学から、自己複製、進化可能、選択可能な分子系を生成します。',
    formalEs: 'Genere sistemas moleculares autorreplicantes, evolucionables y seleccionables a partir de química inorgánica en condiciones primitivas de la Tierra.',
    formalEn: 'Generate self-replicating, evolvable, and selectable molecular systems from inorganic chemistry under primitive Earth conditions.',
    whyHard: '化石记录缺失；多种假说（RNA 世界、代谢优先、硫化物世界等）难以区分。',
    aiPrompt: '介绍 RNA 世界假说、LUCA、米勒-尤里实验。',
    tags: ['生命', '演化', '化学演化'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Origin of Life',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '原始汤模拟实验' }, { type: 'code', label: '写代码/算法', desc: '分子动力学模拟' }, { type: 'essay', label: '写文章/论文', desc: '介绍主流假说' }, { type: 'discuss', label: '想法/讨论', desc: '参与生命定义讨论' }]
  },
  {
    id: 'aging',
    category: 'biology',
    title: '衰老机制',
    titleJa: 'エージング機構',
    titleEs: 'Aclarar e intervenir en mecanismos causales clave en 9-12 características del envejecimiento.',
    titleEn: 'Mechanism of Aging',
    year: 1961,
    proposer: 'L. Hayflick',
    difficulty: 4,
    reward: 3000,
    status: 'open',
    summary: '人为什么会变老？',
    summaryJa: '人はなぜ年をとるのでしょうか？',
    summaryEs: 'Aclarar e intervenir en mecanismos causales clave en 9-12 características del envejecimiento.',
    summaryEn: 'Elucidate and intervene in key causal mechanisms in 9-12 hallmarks of aging.',
    kid: '人为什么会变老？为什么小鼠只能活 2 年，乌龟能活 200 年？现代生物学发现了一些"衰老标志"（端粒、衰老细胞、线粒体……）。能不能通过干预这些机制让人类活得更久更健康？',
    formal: '阐明并干预 9-12 个衰老标志中的关键因果机制。',
    formalJa: '老化の9 -12マーカーにおける主要な因果メカニズムを解明し、介入する。',
    formalEs: 'Aclarar e intervenir en mecanismos causales clave en 9-12 características del envejecimiento.',
    formalEn: 'Elucidate and intervene in key causal mechanisms in 9-12 hallmarks of aging.',
    whyHard: '多通路相互关联。',
    aiPrompt: '介绍 Hallmarks of Aging（2013 López-Otín）。',
    tags: ['衰老', '医学', '标志'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Why We Age',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '小鼠寿命实验' }, { type: 'code', label: '写代码/算法', desc: '单细胞测序分析' }, { type: 'survey', label: '文献综述', desc: '读 Hallmarks 综述' }, { type: 'essay', label: '写文章/论文', desc: '介绍 mTOR、NAD+ 通路' }]
  },
  {
    id: 'cancer-cure',
    category: 'biology',
    title: '通用癌症疗法',
    titleJa: '万能がん治療',
    titleEs: 'Combinaciones de terapia inmune/dirigida/génica efectivas en cualquier tipo de tumor.',
    titleEn: 'Universal Cancer Therapy',
    year: 1971,
    proposer: '—',
    difficulty: 5,
    reward: 5000,
    status: 'open',
    summary: '能对付所有癌症的通用方法？',
    summaryJa: 'すべてのがんに対する普遍的なアプローチ？',
    summaryEs: 'Combinaciones de terapia inmune/dirigida/génica efectivas en cualquier tipo de tumor.',
    summaryEn: 'Immune/targeted/gene therapy combinations effective in any tumor type.',
    kid: '"癌症"其实是 200 多种病的统称，每种都不一样。有的长在肺，有的长在骨头。我们能不能找到一种方法对付所有癌症？现在有免疫疗法（让免疫系统攻击癌症）这种通用思路的雏形。',
    formal: '对任意肿瘤类型都有效的免疫/靶向/基因疗法组合。',
    formalJa: '任意の腫瘍タイプに対して有効な免疫/標的/遺伝子療法の組み合わせ。',
    formalEs: 'Combinaciones de terapia inmune/dirigida/génica efectivas en cualquier tipo de tumor.',
    formalEn: 'Immune/targeted/gene therapy combinations effective in any tumor type.',
    whyHard: '肿瘤异质性、耐药性。',
    aiPrompt: '介绍免疫检查点抑制剂、CAR-T、CRISPR 治疗。',
    tags: ['医学', '肿瘤', '免疫'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Cancer Cure',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: 'CAR-T 设计' }, { type: 'code', label: '写代码/算法', desc: 'TCGA 数据分析' }, { type: 'essay', label: '写文章/论文', desc: '介绍免疫治疗史' }, { type: 'fund', label: '资助/投资', desc: '给癌症研究捐资' }]
  },
  {
    id: 'alzheimer',
    category: 'biology',
    title: '阿尔茨海默病',
    titleJa: 'アルツハイマー病',
    titleEs: 'Aclarar la relación causal entre el depósito de Aβ/tau y la neurodegeneración y desarrollar tratamientos causales.',
    titleEn: 'Alzheimer\'s Disease',
    year: 1906,
    proposer: 'A. Alzheimer',
    difficulty: 4,
    reward: 3000,
    status: 'open',
    summary: '为什么老人会忘记一切？',
    summaryJa: '高齢者はなぜすべてを忘れてしまうのでしょうか？',
    summaryEs: 'Aclarar la relación causal entre el depósito de Aβ/tau y la neurodegeneración y desarrollar tratamientos causales.',
    summaryEn: 'Elucidate the causal relationship between Aβ/tau deposition and neurodegeneration and develop causal treatments.',
    kid: '很多爷爷奶奶记不住事情，会迷路、忘记亲人名字。这种病叫阿尔茨海默病（俗称老年痴呆）。科学家发现大脑里有些"垃圾蛋白"堆积，但到底是垃圾导致疾病，还是疾病产生垃圾？还吵不清。',
    formal: '阐明 Aβ/tau 沉积与神经退行的因果关系并开发对因治疗。',
    formalJa: 'A β/tau沈着と神経変性との因果関係を解明し、因果療法を開発する。',
    formalEs: 'Aclarar la relación causal entre el depósito de Aβ/tau y la neurodegeneración y desarrollar tratamientos causales.',
    formalEn: 'Elucidate the causal relationship between Aβ/tau deposition and neurodegeneration and develop causal treatments.',
    whyHard: '临床试验失败率高（>99%）。',
    aiPrompt: '介绍 amyloid cascade 假说、tau 假说。',
    tags: ['神经', '医学', '蛋白'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Alzheimer',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '动物模型' }, { type: 'code', label: '写代码/算法', desc: '多组学分析' }, { type: 'essay', label: '写文章/论文', desc: '介绍临床失败史' }]
  },
  {
    id: 'whole-brain-emulation',
    category: 'biology',
    title: '全脑模拟',
    titleJa: '全脳シミュレーション',
    titleEs: 'Cerebro completo de mamífero (302 neuronas en C. elegans → 10⁵ en Drosophila → 7×10⁷ en ratón → 8,6×10¹⁰ en humanos), (a) reconstrucción del conectoma mediante microscopía electrónica (resolución < 4 nm, error < 5%), (b) transcriptoma unicelular (validación genómica 10x), (c) simulación de su comportamiento en silicio (consistente con el comportamiento del organismo bajo estímulos N) ≥ 90%).',
    titleEn: 'Whole Brain Emulation',
    year: 2005,
    proposer: '—',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '把大脑完整复制到电脑里',
    summaryJa: '脳をコンピュータに完全に複製する',
    summaryEs: 'Cerebro completo de mamífero (302 neuronas en C. elegans → 10⁵ en Drosophila → 7×10⁷ en ratón → 8,6×10¹⁰ en humanos), (a) reconstrucción del conectoma mediante microscopía electrónica (resolución < 4 nm, error < 5%), (b) transcriptoma unicelular (validación genómica 10x), (c) simulación de su comportamiento en silicio (consistente con el comportamiento del organismo bajo estímulos N) ≥ 90%).',
    summaryEn: 'Complete mammalian brain (302 neurons in C. elegans → 10⁵ in Drosophila → 7×10⁷ in mouse → 8.6×10¹⁰ in human), (a) electron microscopy reconstruction of the connectome (resolution < 4 nm, error < 5%), (b) single-cell transcriptome (10x Genomics validation), (c) simulation of its behavioral output in silicon (consistent with the behavior of the organism under N stimuli) ≥ 90%).',
    kid: '如果能扫描一个真实大脑的每一个连接和分子，然后在电脑里"重新播放"，我们就能在计算机上运行一个数字版的"人"。听起来像科幻，但前沿神经科学正在朝这个方向走。',
    formal: '对完整哺乳动物大脑（线虫 302 神经元 → 果蝇 10⁵ → 小鼠 7×10⁷ → 人 8.6×10¹⁰），完成 (a) 连接组电子显微镜重建 (分辨率 < 4 nm, 误差 < 5%)，(b) 单细胞转录组 (10x Genomics 验证)，(c) 在硅上模拟其行为输出 (与生物体在 N 种刺激下行为一致度 ≥ 90%)。',
    formalJa: '無傷の哺乳類脳（線虫３ ０ ２神経→フライ１ ０→マウス７ × １ ０ ²→ヒト８ ． ６ × １ ０ ²）について、（ ａ ）コネクトーム電子顕微鏡再構築（分解能＜ ４ ｎｍ、誤差＜ ５ ％ ）、（ ｂ ）単一細胞トランスクリプトーム（ １ ０ ×ゲノミクス検証）、及び（ ｃ ）シリコン上でのその行動出力をシミュレートした（ Ｎ刺激下での生物の行動と９ ０ ％以上一致）。',
    formalEs: 'Cerebro completo de mamífero (302 neuronas en C. elegans → 10⁵ en Drosophila → 7×10⁷ en ratón → 8,6×10¹⁰ en humanos), (a) reconstrucción del conectoma mediante microscopía electrónica (resolución < 4 nm, error < 5%), (b) transcriptoma unicelular (validación genómica 10x), (c) simulación de su comportamiento en silicio (consistente con el comportamiento del organismo bajo estímulos N) ≥ 90%).',
    formalEn: 'Complete mammalian brain (302 neurons in C. elegans → 10⁵ in Drosophila → 7×10⁷ in mouse → 8.6×10¹⁰ in human), (a) electron microscopy reconstruction of the connectome (resolution < 4 nm, error < 5%), (b) single-cell transcriptome (10x Genomics validation), (c) simulation of its behavioral output in silicon (consistent with the behavior of the organism under N stimuli) ≥ 90%).',
    whyHard: '人脑有 860 亿神经元、100 万亿突触。',
    aiPrompt: '介绍 Human Connectome、Blue Brain。',
    tags: ['神经', '计算', '哲学'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Whole Brain Emulation',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '神经元网络模拟' }, { type: 'data', label: '数据收集/标注', desc: '贡献连接组数据' }, { type: 'essay', label: '写文章/论文', desc: '介绍蓝脑计划' }, { type: 'discuss', label: '想法/讨论', desc: '参与上传意识讨论' }]
  },
  {
    id: 'antibiotic-resistance',
    category: 'biology',
    title: '抗生素耐药性',
    titleJa: '抗生物質耐性',
    titleEs: 'Descubrir o desarrollar nuevos mecanismos antibióticos que puedan hacer frente a todas las bacterias resistentes a "ESKAPE".',
    titleEn: 'Antibiotic Resistance',
    year: 1928,
    proposer: 'A. Fleming (penicillin)',
    difficulty: 4,
    reward: 3000,
    status: 'open',
    summary: '细菌在变强，我们的药在变弱',
    summaryJa: '細菌は強くなり、私たちの薬は弱くなっています。',
    summaryEs: 'Descubrir o desarrollar nuevos mecanismos antibióticos que puedan hacer frente a todas las bacterias resistentes a "ESKAPE".',
    summaryEn: 'Discover or develop new mechanism antibiotics that can deal with all "ESKAPE" resistant bacteria.',
    kid: '过去 100 年我们靠抗生素打败了很多感染。但细菌会"学习"，一代代进化出耐药性。WHO 说，到 2050 年耐药菌每年可能杀死 1000 万人，超过癌症。我们需要新一代武器。',
    formal: '发现或开发能对付所有"ESKAPE"耐药菌的新机制抗生素。',
    formalJa: 'すべての「ESKAPE」耐性菌に対する新しいメカニズム抗生物質を発見または開発します。',
    formalEs: 'Descubrir o desarrollar nuevos mecanismos antibióticos que puedan hacer frente a todas las bacterias resistentes a "ESKAPE".',
    formalEn: 'Discover or develop new mechanism antibiotics that can deal with all "ESKAPE" resistant bacteria.',
    whyHard: '细菌进化速度快，新药研发周期长。',
    aiPrompt: '介绍 Teixobactin、噬菌体、抗菌肽。',
    tags: ['医学', '进化', '药物'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Antibiotic Resistance',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '土壤微生物筛选' }, { type: 'code', label: '写代码/算法', desc: '用 ML 预测新抗生素' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Fleming 故事' }]
  },
  {
    id: 'cell-reprogramming',
    category: 'biology',
    title: '细胞重编程',
    titleJa: '細胞リプログラミング',
    titleEs: 'Reprograme de forma segura y reversible células somáticas en iPSC u otros tipos de células mediante métodos químicos o genéticos.',
    titleEn: 'Cell Reprogramming',
    year: 2006,
    proposer: 'S. Yamanaka',
    difficulty: 4,
    reward: 2000,
    status: 'partially_solved',
    summary: '把皮肤细胞变回干细胞',
    summaryJa: '皮膚細胞を幹細胞に戻す',
    summaryEs: 'Reprograme de forma segura y reversible células somáticas en iPSC u otros tipos de células mediante métodos químicos o genéticos.',
    summaryEn: 'Safely and reversibly reprogram somatic cells into iPSCs or other cell types using chemical or genetic methods.',
    kid: '你身上的皮肤细胞、心脏细胞、神经细胞都来自同一个受精卵，但后来变得不一样。Yamanaka 发现只要开几个"开关"（Yamanaka 因子），就能把皮肤细胞变回"小婴儿"状态，再变能任何细胞。这给再生医学打开了一扇门。',
    formal: '用化学或遗传学方法安全、可逆地将体细胞重编程为 iPSC 或其他细胞类型。',
    formalJa: '体細胞は、化学的または遺伝的方法によって、iPSCまたは他の細胞型に安全かつ可逆的に再プログラムされる。',
    formalEs: 'Reprograme de forma segura y reversible células somáticas en iPSC u otros tipos de células mediante métodos químicos o genéticos.',
    formalEn: 'Safely and reversibly reprogram somatic cells into iPSCs or other cell types using chemical or genetic methods.',
    whyHard: '效率和安全性。',
    aiPrompt: '介绍 OSKM 因子、化学重编程。',
    tags: ['再生医学', '干细胞', 'Yamanaka'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Cell Reprogramming',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '重编程小鼠细胞' }, { type: 'code', label: '写代码/算法', desc: '单细胞测序分析' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Yamanaka 故事' }]
  },
  {
    id: 'microbiome',
    category: 'biology',
    title: '微生物组功能',
    titleJa: 'マイクロバイオーム機能',
    titleEs: 'Construya un mapa causal de las funciones metabólicas, inmunes y neurológicas de cada cepa del microbioma humano.',
    titleEn: 'Microbiome Function',
    year: 2007,
    proposer: 'NIH Human Microbiome Project',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '你身上的 100 万亿细菌是干什么的？',
    summaryJa: '100兆個のバクテリアをどうしますか？',
    summaryEs: 'Construya un mapa causal de las funciones metabólicas, inmunes y neurológicas de cada cepa del microbioma humano.',
    summaryEn: 'Build a causal map of the metabolic, immune, and neurological functions of each strain in the human microbiome.',
    kid: '你身体里（主要在肠道）有 100 万亿细菌，基因数是人类的 100 倍。它们帮你消化、训练免疫、甚至影响心情。但到底哪些菌做什么？我们大部分不知道。',
    formal: '对人类微生物组中每种菌株的代谢、免疫、神经功能建立因果图谱。',
    formalJa: 'ヒトマイクロバイオーム内の各株の代謝、免疫、および神経学的機能の因果マップを確立する。',
    formalEs: 'Construya un mapa causal de las funciones metabólicas, inmunes y neurológicas de cada cepa del microbioma humano.',
    formalEn: 'Build a causal map of the metabolic, immune, and neurological functions of each strain in the human microbiome.',
    whyHard: '种间互作复杂。',
    aiPrompt: '介绍 HMP、Germ-free mice。',
    tags: ['微生物', '医学', '肠脑轴'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Microbiome',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '无菌小鼠实验' }, { type: 'code', label: '写代码/算法', desc: '16S rRNA 分析' }, { type: 'essay', label: '写文章/论文', desc: '介绍肠脑轴' }]
  },
  {
    id: 'gene-drive',
    category: 'biology',
    title: '基因驱动',
    titleJa: '遺伝子ドライブ',
    titleEs: 'Diseñar un sistema de impulso genético que cumpla con (a) una tasa de transmisión de ≥ 95% en la población objetivo, (b) reversibilidad dentro de 100 generaciones (en cadena o anti-drive), (c) una tasa de transferencia horizontal de <0,1% dentro de un rango de 1000 kilómetros, (d) revisión ética y de bioseguridad (Protocolo de Cartagena/OMS).',
    titleEn: 'Gene Drive',
    year: 2003,
    proposer: 'A. Burt',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '让基因"入侵"整个物种',
    summaryJa: '遺伝子に種全体を「侵略」させる',
    summaryEs: 'Diseñar un sistema de impulso genético que cumpla con (a) una tasa de transmisión de ≥ 95% en la población objetivo, (b) reversibilidad dentro de 100 generaciones (en cadena o anti-drive), (c) una tasa de transferencia horizontal de <0,1% dentro de un rango de 1000 kilómetros, (d) revisión ética y de bioseguridad (Protocolo de Cartagena/OMS).',
    summaryEn: 'Design a gene drive system that meets (a) a transmission rate of ≥ 95% in the target population, (b) reversibility within 100 generations (daisy-chain or anti-drive), (c) a horizontal transfer rate of < 0.1% within a range of 1000 kilometers, (d) ethical and biosafety review (WHO/Cartagena Protocol).',
    kid: 'CRISPR 让修改基因变便宜。能不能做一个"基因驱动"——让某个特定基因在物种中以 100% 概率遗传（不是通常的 50%），从而改造整个物种？比如让蚊子不再传播疟疾。',
    formal: '设计基因驱动系统：满足 (a) 目标种群中传递率 ≥ 95%，(b) 100 代内可逆（daisy-chain 或 anti-drive），(c) 1000 公里范围内水平转移率 < 0.1%，(d) 伦理与生物安全审查通过 (WHO/ Cartagena Protocol)。',
    formalJa: '遺伝子駆動システムを、（ ａ ）標的集団における移動速度≧ ９ ５ ％、（ ｂ ） １ ０ ０世代以内に可逆的（デイジーチェーンまたはアンチドライブ）、（ ｃ ） １ ０ ０ ０ ｋｍ以内に水平移動速度＜ ０ ． １ ％、及び（ ｄ ）倫理的及びバイオセーフティレビューに合格（ ＷＨＯ ／ Ｃａｒｔａｇｅｎａプロトコル）の基準を満たすように設計する。',
    formalEs: 'Diseñar un sistema de impulso genético que cumpla con (a) una tasa de transmisión de ≥ 95% en la población objetivo, (b) reversibilidad dentro de 100 generaciones (en cadena o anti-drive), (c) una tasa de transferencia horizontal de <0,1% dentro de un rango de 1000 kilómetros, (d) revisión ética y de bioseguridad (Protocolo de Cartagena/OMS).',
    formalEn: 'Design a gene drive system that meets (a) a transmission rate of ≥ 95% in the target population, (b) reversibility within 100 generations (daisy-chain or anti-drive), (c) a horizontal transfer rate of < 0.1% within a range of 1000 kilometers, (d) ethical and biosafety review (WHO/Cartagena Protocol).',
    whyHard: '生态风险、抗性演化。',
    aiPrompt: '介绍 Target Malaria、daisy drive。',
    tags: ['基因', 'CRISPR', '生态'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Gene Drive',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '果蝇基因驱动' }, { type: 'essay', label: '写文章/论文', desc: '介绍生态伦理' }, { type: 'discuss', label: '想法/讨论', desc: '参与治理讨论' }]
  },
  {
    id: 'xenotransplant',
    category: 'biology',
    title: '异种器官移植',
    titleJa: '異種移植',
    titleEs: 'Lograr un corazón/riñón de cerdo genéticamente modificado → xenotrasplante humano: ≥ 5 casos de supervivencia a 5 años en primates no humanos, ≥ 50 casos de supervivencia a 5 años en ensayos clínicos en humanos (sin infección por PERV, rechazo hiperagudo <1%, rechazo crónico <10%), y aprobación de producto biológico aprobada por la FDA/EMA.',
    titleEn: 'Xenotransplantation',
    year: 1984,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '把猪心移植到人身上',
    summaryJa: 'ブタの心臓を人に移植する',
    summaryEs: 'Lograr un corazón/riñón de cerdo genéticamente modificado → xenotrasplante humano: ≥ 5 casos de supervivencia a 5 años en primates no humanos, ≥ 50 casos de supervivencia a 5 años en ensayos clínicos en humanos (sin infección por PERV, rechazo hiperagudo <1%, rechazo crónico <10%), y aprobación de producto biológico aprobada por la FDA/EMA.',
    summaryEn: 'Achieve genetically modified pig heart/kidney → human xenotransplantation: ≥ 5 cases of 5-year survival in non-human primates, ≥ 50 cases of 5-year survival in human clinical trials (no PERV infection, hyperacute rejection < 1%, chronic rejection < 10%), and passed FDA/EMA biological product approval.',
    kid: '需要器官移植的人很多，但捐献器官远远不够。能不能用转基因猪心代替？2022 年已经有人移植猪心活了 2 个月。',
    formal: '实现基因改造猪心/肾 → 人异种移植：在非人灵长类 ≥ 5 例 5 年存活、人临床试验 ≥ 50 例 5 年存活（无 PERV 感染、超急性排斥 < 1%、慢性排斥 < 10%），并通过 FDA/EMA 生物制品审批。',
    formalJa: '遺伝子組み換えブタ心臓／腎臓→ヒト異種移植：非ヒト霊長類で5年生存5例以上、ヒト臨床試験で5年生存50例以上（ PERV感染なし、超急性拒絶反応< 1 ％、慢性拒絶反応< 10 ％ ）、およびFDA/EMA生物製剤の承認。',
    formalEs: 'Lograr un corazón/riñón de cerdo genéticamente modificado → xenotrasplante humano: ≥ 5 casos de supervivencia a 5 años en primates no humanos, ≥ 50 casos de supervivencia a 5 años en ensayos clínicos en humanos (sin infección por PERV, rechazo hiperagudo <1%, rechazo crónico <10%), y aprobación de producto biológico aprobada por la FDA/EMA.',
    formalEn: 'Achieve genetically modified pig heart/kidney → human xenotransplantation: ≥ 5 cases of 5-year survival in non-human primates, ≥ 50 cases of 5-year survival in human clinical trials (no PERV infection, hyperacute rejection < 1%, chronic rejection < 10%), and passed FDA/EMA biological product approval.',
    whyHard: '免疫排斥、病毒风险。',
    aiPrompt: '介绍 PERV、CRISPR 改造猪。',
    tags: ['医学', '移植', '基因'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Xenotransplant',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '转基因猪' }, { type: 'essay', label: '写文章/论文', desc: '介绍首例猪心移植' }, { type: 'discuss', label: '想法/讨论', desc: '参与伦理讨论' }]
  },
  {
    id: 'epigenetic-inherit',
    category: 'biology',
    title: '表观遗传跨代遗传',
    titleJa: 'エピジェネティックな世代間継承',
    titleEs: 'Demostrar o descartar la universalidad de la herencia epigenética transgeneracional en mamíferos.',
    titleEn: 'Transgenerational Epigenetic Inheritance',
    year: 1999,
    proposer: '—',
    difficulty: 3,
    reward: 1000,
    status: 'open',
    summary: '祖父母的经历能传给孙辈吗？',
    summaryJa: '祖父母の経験を孫に伝えることはできますか？',
    summaryEs: 'Demostrar o descartar la universalidad de la herencia epigenética transgeneracional en mamíferos.',
    summaryEn: 'Demonstrate or rule out the universality of transgenerational epigenetic inheritance in mammals.',
    kid: '孟德尔遗传说 DNA 决定一切。但近年发现：荷兰饥饿冬天的孕妇，其孙辈也有代谢问题。看起来经历能通过 DNA 修饰跨代传递。这是真的普遍机制还是个别现象？',
    formal: '证明或排除哺乳动物跨代表观遗传的普遍性。',
    formalJa: '哺乳類におけるトランス表現遺伝学の普遍性を証明または排除する。',
    formalEs: 'Demostrar o descartar la universalidad de la herencia epigenética transgeneracional en mamíferos.',
    formalEn: 'Demonstrate or rule out the universality of transgenerational epigenetic inheritance in mammals.',
    whyHard: '区分直接效应（子宫内）和真正的跨代。',
    aiPrompt: '介绍 Dutch Hunger Winter、Agouti mouse。',
    tags: ['遗传', '表观', '演化'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Epigenetics',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '小鼠跨代实验' }, { type: 'code', label: '写代码/算法', desc: '甲基化数据分析' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Lamarck 复兴' }]
  },
  {
    id: 'rna-world',
    category: 'biology',
    title: 'RNA 世界假说',
    titleJa: 'RNAワールド仮説',
    titleEs: 'Se ha demostrado que las moléculas de ARN se replican y evolucionan en condiciones de laboratorio.',
    titleEn: 'RNA World Hypothesis',
    year: 1986,
    proposer: 'W. Gilbert',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '生命起源于 RNA 而不是 DNA？',
    summaryJa: '生命はDNAではなくRNAから生まれますか？',
    summaryEs: 'Se ha demostrado que las moléculas de ARN se replican y evolucionan en condiciones de laboratorio.',
    summaryEn: 'RNA molecules have been shown to replicate and evolve themselves under laboratory conditions.',
    kid: '现代生命用 DNA 存信息、蛋白质做功能、RNA 当信使。但 RNA 也能"做"事（ribozyme）。一种理论是：早期生命是纯 RNA 的，RNA 同时是信息和催化剂。后来才分工给 DNA 和蛋白质。',
    formal: '在实验室条件下证明 RNA 分子能自我复制并进化。',
    formalJa: 'ＲＮＡ分子は、実験室条件の下で自己複製及び進化することが示されている。',
    formalEs: 'Se ha demostrado que las moléculas de ARN se replican y evolucionan en condiciones de laboratorio.',
    formalEn: 'RNA molecules have been shown to replicate and evolve themselves under laboratory conditions.',
    whyHard: '目前没有能让 RNA 自我复制 > 200 nt 的 ribozyme。',
    aiPrompt: '介绍 Spiegelman monster、ribozyme 进化。',
    tags: ['生命起源', 'RNA', '演化'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'RNA World',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: 'ribozyme 体外进化' }, { type: 'essay', label: '写文章/论文', desc: '介绍 RNA 世界证据' }, { type: 'discuss', label: '想法/讨论', desc: '参与生命起源讨论' }]
  },
  {
    id: 'universal-flu',
    category: 'biology',
    title: '通用流感疫苗',
    titleJa: 'ユニバーサルインフルエンザワクチン',
    titleEs: 'Desarrollar una vacuna que sea eficaz contra todos los subtipos de influenza A HA (H1-H18) y tenga protección cruzada contra los tipos B y C: ≥ 90% de tasa de seroconversión, ≥ 80% de eficacia de protección clínica, ≥ 3 años de protección en personas de 6 meses a 80 años y el costo de actualización anual es ≤ 1,5 veces el de las vacunas contra la influenza existentes.',
    titleEn: 'Universal Flu Vaccine',
    year: 1933,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '一针管所有流感变种',
    summaryJa: 'すべてのインフルエンザ変異型用の1つのシリンジ',
    summaryEs: 'Desarrollar una vacuna que sea eficaz contra todos los subtipos de influenza A HA (H1-H18) y tenga protección cruzada contra los tipos B y C: ≥ 90% de tasa de seroconversión, ≥ 80% de eficacia de protección clínica, ≥ 3 años de protección en personas de 6 meses a 80 años y el costo de actualización anual es ≤ 1,5 veces el de las vacunas contra la influenza existentes.',
    summaryEn: 'Develop a vaccine that is effective against all influenza A HA subtypes (H1-H18) and has cross-protection against types B and C: ≥ 90% seroconversion rate, ≥ 80% clinical protection efficacy, ≥ 3 years of protection in people aged 6 months to 80 years old, and the annual update cost is ≤ 1.5 times that of existing influenza vaccines.',
    kid: '每年都要打新的流感疫苗，因为病毒在变。能不能打一针就管所有变种（甚至跨物种）？',
    formal: '开发对所有甲型流感 HA 亚型 (H1-H18) 有效、且对乙型、丙型亦有交叉保护的疫苗：在 6 月龄-80 岁人群 ≥ 90% 血清转化率、≥ 80% 临床保护效力、保护期 ≥ 3 年，且每年更新成本 ≤ 现有流感疫苗 1.5 倍。',
    formalJa: 'すべてのインフルエンザA HAサブタイプ（ H 1 - H 18 ）に有効であり、B型およびC型に対して交差保護を有するワクチンを開発する：セロコンバージョン率90 ％以上、臨床的保護有効性80 ％以上、6ヶ月～ 80歳の集団における保護期間3年以上、および既存のインフルエンザワクチンの1.5倍以下の年間更新コスト。',
    formalEs: 'Desarrollar una vacuna que sea eficaz contra todos los subtipos de influenza A HA (H1-H18) y tenga protección cruzada contra los tipos B y C: ≥ 90% de tasa de seroconversión, ≥ 80% de eficacia de protección clínica, ≥ 3 años de protección en personas de 6 meses a 80 años y el costo de actualización anual es ≤ 1,5 veces el de las vacunas contra la influenza existentes.',
    formalEn: 'Develop a vaccine that is effective against all influenza A HA subtypes (H1-H18) and has cross-protection against types B and C: ≥ 90% seroconversion rate, ≥ 80% clinical protection efficacy, ≥ 3 years of protection in people aged 6 months to 80 years old, and the annual update cost is ≤ 1.5 times that of existing influenza vaccines.',
    whyHard: '病毒表面血凝素变异性高。',
    aiPrompt: '介绍 stalk 抗体、mRNA 疫苗、HA 保守区。',
    tags: ['疫苗', '病毒', '免疫'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Universal Flu Vaccine',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '小鼠挑战实验' }, { type: 'code', label: '写代码/算法', desc: '病毒序列分析' }, { type: 'essay', label: '写文章/论文', desc: '介绍流感史' }]
  },
  {
    id: 'hiv-cure',
    category: 'biology',
    title: 'HIV 治愈',
    titleJa: 'HIV治療',
    titleEs: 'No se requieren medicamentos para eliminar los reservorios latentes del VIH o para mantener un control sostenido del virus.',
    titleEn: 'HIV Cure',
    year: 1983,
    proposer: 'L. Montagnier / R. Gallo',
    difficulty: 5,
    reward: 3000,
    status: 'open',
    summary: '能彻底治好艾滋吗？',
    summaryJa: 'エイズを完全に治すことができるでしょうか？',
    summaryEs: 'No se requieren medicamentos para eliminar los reservorios latentes del VIH o para mantener un control sostenido del virus.',
    summaryEn: 'Medication is not required to clear HIV latent reservoirs or to maintain sustained control of the virus.',
    kid: 'HIV 感染免疫细胞并把 DNA 整合进基因组。鸡尾酒疗法能压住病毒但不能根治。柏林病人 2008 年被治愈（骨髓移植），但不能推广。能不能找到"功能性治愈"？',
    formal: '清除 HIV 潜伏库或持续控制病毒不需用药。',
    formalJa: 'HIVの潜伏リザーバを除去したり、ウイルスを制御したりするために薬は必要ありません。',
    formalEs: 'No se requieren medicamentos para eliminar los reservorios latentes del VIH o para mantener un control sostenido del virus.',
    formalEn: 'Medication is not required to clear HIV latent reservoirs or to maintain sustained control of the virus.',
    whyHard: '潜伏库难以清除。',
    aiPrompt: '介绍 Berlin Patient、shock & kill、bNAb。',
    tags: ['医学', '病毒', '免疫'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'HIV Cure',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '潜伏库研究' }, { type: 'essay', label: '写文章/论文', desc: '介绍柏林病人' }, { type: 'fund', label: '资助/投资', desc: '给艾滋病研究捐资' }]
  },
  {
    id: 'malaria-eradication',
    category: 'biology',
    title: '疟疾根除',
    titleJa: 'マラリア撲滅',
    titleEs: 'La incidencia anual mundial de malaria se reduce a 0 y se mantiene durante ≥ 5 años: mediante la estrategia de combinación RTS, vacuna S/R21 + MTI + ACT, certificación de eliminación a nivel regional de la OMS, sensibilidad del sistema de vigilancia ≥ 1 caso/100.000 habitantes y riesgo de retransmisión de casos importados < 5%.',
    titleEn: 'Malaria Eradication',
    year: 1955,
    proposer: 'WHO',
    difficulty: 4,
    reward: 3000,
    status: 'partially_solved',
    summary: '彻底消灭疟疾',
    summaryJa: 'マラリアの完全な撲滅',
    summaryEs: 'La incidencia anual mundial de malaria se reduce a 0 y se mantiene durante ≥ 5 años: mediante la estrategia de combinación RTS, vacuna S/R21 + MTI + ACT, certificación de eliminación a nivel regional de la OMS, sensibilidad del sistema de vigilancia ≥ 1 caso/100.000 habitantes y riesgo de retransmisión de casos importados < 5%.',
    summaryEn: 'The global annual incidence of malaria is reduced to 0 and maintained for ≥ 5 years: through the RTS, S/R21 vaccine + ITN + ACT combination strategy, WHO regional level certification for elimination, surveillance system sensitivity ≥ 1 case/100,000 population, and risk of re-transmission of imported cases < 5%.',
    kid: '疟疾每年杀 60 万人（多数是 5 岁以下非洲儿童）。WHO 1955 年第一次根除计划失败（耐药、资助中断）。现在又启动新计划，但 RTS,S 疫苗只有 30% 效率。',
    formal: '全球疟疾年发病数降至 0 并维持 ≥ 5 年：通过 RTS,S/R21 疫苗 + ITN + ACT 组合策略，WHO 区域级别认证消除、监测系统灵敏度 ≥ 1 例/10 万人口、输入病例再传播风险 < 5%。',
    formalJa: 'マラリアの世界的な年間発生率は0に減少し、5年間以上維持されました。RTS、S/R 21ワクチン+ ITN + ACTの組み合わせ戦略、WHO地域レベルの認証の排除、サーベイランスシステムの感度が100,000人の集団あたり1人以上、入ってくる症例の再感染のリスク< 5%。',
    formalEs: 'La incidencia anual mundial de malaria se reduce a 0 y se mantiene durante ≥ 5 años: mediante la estrategia de combinación RTS, vacuna S/R21 + MTI + ACT, certificación de eliminación a nivel regional de la OMS, sensibilidad del sistema de vigilancia ≥ 1 caso/100.000 habitantes y riesgo de retransmisión de casos importados < 5%.',
    formalEn: 'The global annual incidence of malaria is reduced to 0 and maintained for ≥ 5 years: through the RTS, S/R21 vaccine + ITN + ACT combination strategy, WHO regional level certification for elimination, surveillance system sensitivity ≥ 1 case/100,000 population, and risk of re-transmission of imported cases < 5%.',
    whyHard: '蚊媒、贫困、政治。',
    aiPrompt: '介绍 RTS,S、R21、基因驱动。',
    tags: ['医学', '公共健康', '蚊'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Malaria',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'fund', label: '资助/投资', desc: '给 Malaria No More 捐' }, { type: 'essay', label: '写文章/论文', desc: '介绍疟疾史' }, { type: 'discuss', label: '想法/讨论', desc: '参与全球卫生治理' }]
  },
  {
    id: 'telomere-extend',
    category: 'biology',
    title: '端粒延长与衰老',
    titleJa: 'テロメアの伸びと老化',
    titleEs: 'Alarga de forma segura los telómeros en ≥20% en células humanas/ratón (sin riesgo carcinogénico), muestra una reversión de ≥3 años en 3 relojes epigenéticos/envejecimiento independientes (Horvath/PhenoAge/GlycanAge) y no aumenta la incidencia de tumores en ≥5 años de seguimiento.',
    titleEn: 'Telomere Extension and Aging',
    year: 2009,
    proposer: 'E. Blackburn / C. Greider / J. Szostak (Nobel)',
    difficulty: 3,
    reward: 2000,
    status: 'open',
    summary: '延长端粒能让人更长寿吗？',
    summaryJa: 'テロメアの延長は人の寿命を延ばしますか？',
    summaryEs: 'Alarga de forma segura los telómeros en ≥20% en células humanas/ratón (sin riesgo carcinogénico), muestra una reversión de ≥3 años en 3 relojes epigenéticos/envejecimiento independientes (Horvath/PhenoAge/GlycanAge) y no aumenta la incidencia de tumores en ≥5 años de seguimiento.',
    summaryEn: 'Safely lengthens telomeres by ≥20% in human cells/mouse (without carcinogenic risk), exhibits ≥3 year reversal on 3 independent epigenetic/aging clocks (Horvath/PhenoAge/GlycanAge), and does not increase tumor incidence at ≥5 years of follow-up.',
    kid: '染色体末端有"帽子"叫端粒，每次细胞分裂会缩短一截。缩短到一定程度细胞就死亡。能不能延长端粒来延缓衰老？',
    formal: '在人类细胞/小鼠中安全延长端粒 ≥ 20%（无致癌风险），在 3 项独立表观遗传/衰老时钟 (Horvath/PhenoAge/GlycanAge) 上呈现 ≥ 3 年逆转，且 ≥ 5 年随访不增加肿瘤发生率。',
    formalJa: 'ヒト細胞／マウスにおける安全に延長されたテロメア≧ ２ ０ ％ （発がん性リスクなし）、３つの独立したエピジェネティック／老化時計（ Ｈｏｒｖａｔｈ ／ ＰｈｅｎｏＡｇｅ ／ ＧｌｙｃａｎＡｇｅ ）で３年以上逆転し、５年以上の追跡時に腫瘍発生率を増加させなかった。',
    formalEs: 'Alarga de forma segura los telómeros en ≥20% en células humanas/ratón (sin riesgo carcinogénico), muestra una reversión de ≥3 años en 3 relojes epigenéticos/envejecimiento independientes (Horvath/PhenoAge/GlycanAge) y no aumenta la incidencia de tumores en ≥5 años de seguimiento.',
    formalEn: 'Safely lengthens telomeres by ≥20% in human cells/mouse (without carcinogenic risk), exhibits ≥3 year reversal on 3 independent epigenetic/aging clocks (Horvath/PhenoAge/GlycanAge), and does not increase tumor incidence at ≥5 years of follow-up.',
    whyHard: '端粒延长可能增加癌症风险。',
    aiPrompt: '介绍 telomerase、TA-65。',
    tags: ['衰老', '端粒', '细胞'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Telomere',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '小鼠端粒延长' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Blackburn 工作' }]
  },
  {
    id: 'stem-cell-therapy',
    category: 'biology',
    title: '干细胞治疗',
    titleJa: '幹細胞療法',
    titleEs: 'iPSC/terapia con células madre adultas para tejidos designados (nervios/corazón/islotes pancreáticos/retina): en los ensayos clínicos de fase III, ≥ 70 % de los pacientes lograron una mejora funcional significativa (mRS/HbA1c/visión y otros indicadores), una tasa de tumorigenicidad <0,1 % y no hubo reacciones adversas graves durante el seguimiento de 5 años.',
    titleEn: 'Stem Cell Therapy',
    year: 1998,
    proposer: 'J. Thomson (hESC)',
    difficulty: 4,
    reward: 3000,
    status: 'partially_solved',
    summary: '用干细胞修复任何组织',
    summaryJa: '幹細胞で組織を修復する',
    summaryEs: 'iPSC/terapia con células madre adultas para tejidos designados (nervios/corazón/islotes pancreáticos/retina): en los ensayos clínicos de fase III, ≥ 70 % de los pacientes lograron una mejora funcional significativa (mRS/HbA1c/visión y otros indicadores), una tasa de tumorigenicidad <0,1 % y no hubo reacciones adversas graves durante el seguimiento de 5 años.',
    summaryEn: 'iPSC/adult stem cell therapy for designated tissues (nerves/heart/pancreatic islets/retina): In phase III clinical trials, ≥ 70% of patients achieved significant functional improvement (mRS/HbA1c/vision and other indicators), tumorigenicity rate < 0.1%, and no serious adverse reactions during 5-year follow-up.',
    kid: '干细胞能变成任何细胞。如果能用病人自己的干细胞修复心脏、神经、胰岛……大部分退行性疾病就能治。',
    formal: '对指定组织（神经/心脏/胰岛/视网膜）实现 iPSC/成体干细胞治疗：在 III 期临床试验中 ≥ 70% 患者显著功能改善 (mRS/HbA1c/视力等指标)、致瘤率 < 0.1%、5 年随访无严重不良反应。',
    formalJa: '選択された組織（神経/心臓/膵臓/網膜）に対するiPSC/成人幹細胞療法：第III相臨床試験の患者の70 ％以上で機能（ mRS/HbA 1 c/視力など）の有意な改善、腫瘍発生率< 0.1 ％、5年フォローアップ時に重篤な有害反応なし。',
    formalEs: 'iPSC/terapia con células madre adultas para tejidos designados (nervios/corazón/islotes pancreáticos/retina): en los ensayos clínicos de fase III, ≥ 70 % de los pacientes lograron una mejora funcional significativa (mRS/HbA1c/visión y otros indicadores), una tasa de tumorigenicidad <0,1 % y no hubo reacciones adversas graves durante el seguimiento de 5 años.',
    formalEn: 'iPSC/adult stem cell therapy for designated tissues (nerves/heart/pancreatic islets/retina): In phase III clinical trials, ≥ 70% of patients achieved significant functional improvement (mRS/HbA1c/vision and other indicators), tumorigenicity rate < 0.1%, and no serious adverse reactions during 5-year follow-up.',
    whyHard: '细胞分化和整合控制。',
    aiPrompt: '介绍 iPSC、CAR-T、organoid。',
    tags: ['再生', '细胞', '医学'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Stem Cell',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: 'iPSC 分化' }, { type: 'essay', label: '写文章/论文', desc: '介绍诱导多能干细胞' }, { type: 'fund', label: '资助/投资', desc: '给研究捐资' }]
  },
  {
    id: 'organoid-intelligence',
    category: 'biology',
    title: '类器官智能',
    titleJa: 'オルガノイドインテリジェンス',
    titleEs: 'Demuestre que los organoides cerebrales: (a) exhiben curvas de aprendizaje cuantificables en paradigmas de aprendizaje clásicos (Pavlov/operante), (b) los patrones de activación neuronal contienen entropía de información ≥ 0,5 bits/pico, (c) son controlables dentro de marcos éticos (aprobación del IBC, consentimiento informado).',
    titleEn: 'Organoid Intelligence',
    year: 2022,
    proposer: 'T. Hartung (Johns Hopkins)',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '脑类器官能学会玩游戏吗？',
    summaryJa: '脳オルガノイドはゲームを学ぶことができますか？',
    summaryEs: 'Demuestre que los organoides cerebrales: (a) exhiben curvas de aprendizaje cuantificables en paradigmas de aprendizaje clásicos (Pavlov/operante), (b) los patrones de activación neuronal contienen entropía de información ≥ 0,5 bits/pico, (c) son controlables dentro de marcos éticos (aprobación del IBC, consentimiento informado).',
    summaryEn: 'Demonstrate that brain organoids: (a) exhibit quantifiable learning curves in classical learning paradigms (Pavlov/operant), (b) neuronal firing patterns contain information entropy ≥ 0.5 bit/spike, (c) are controllable within ethical frameworks (IBC approval, informed consent).',
    kid: '科学家把人脑干细胞培养成"脑类器官"（直径几毫米的迷你大脑），有神经活动。能不能让它们学会简单任务？',
    formal: '证明脑类器官：(a) 在经典学习范式 (Pavlov/operant) 中表现出可量化学习曲线，(b) 神经元放电模式包含信息熵 ≥ 0.5 bit/spike，(c) 伦理框架（IBC 审批、知情同意）可控。',
    formalJa: '脳オルガノイド： （ a ）古典的な学習パラダイム（パブロフ/オペラント）で定量化可能な学習曲線を示し、（ b ）ニューロン放電パターンに0.5ビット/スパイク以上の情報エントロピーが含まれており、（ c ）倫理的枠組み（ IBC承認、インフォームドコンセント）が制御可能であることを証明する。',
    formalEs: 'Demuestre que los organoides cerebrales: (a) exhiben curvas de aprendizaje cuantificables en paradigmas de aprendizaje clásicos (Pavlov/operante), (b) los patrones de activación neuronal contienen entropía de información ≥ 0,5 bits/pico, (c) son controlables dentro de marcos éticos (aprobación del IBC, consentimiento informado).',
    formalEn: 'Demonstrate that brain organoids: (a) exhibit quantifiable learning curves in classical learning paradigms (Pavlov/operant), (b) neuronal firing patterns contain information entropy ≥ 0.5 bit/spike, (c) are controllable within ethical frameworks (IBC approval, informed consent).',
    whyHard: '伦理和生物复杂性。',
    aiPrompt: '介绍 Cortical Labs、CL1。',
    tags: ['神经', '伦理', '计算'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Organoid Intelligence',
    videoChannel: 'Quanta',
    participate: [{ type: 'experiment', label: '动手实验', desc: '培养脑类器官' }, { type: 'essay', label: '写文章/论文', desc: '介绍伦理争议' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'biolocomotion',
    category: 'biology',
    title: '生物运动原理',
    titleJa: 'バイオキネシスの原理',
    titleEs: 'Establecer una teoría unificada del movimiento a través de escalas: motor molecular (cinesina/miosina) → célula (flagelos) → órgano → conjunto. Utilice el marco ODE/PDE para reconstruir el circuito cerrado de energía-información-mecánica en una escala espacio-temporal de 10 órdenes de magnitud y puede predecir ≥ 3 fenómenos de movimiento verificados no experimentalmente.',
    titleEn: 'Principles of Biological Locomotion',
    year: 2000,
    proposer: 'M. H. Dickinson',
    difficulty: 3,
    reward: 1000,
    status: 'open',
    summary: '动物/细胞如何高效运动？',
    summaryJa: '動物/細胞はどのように効率的に移動しますか？',
    summaryEs: 'Establecer una teoría unificada del movimiento a través de escalas: motor molecular (cinesina/miosina) → célula (flagelos) → órgano → conjunto. Utilice el marco ODE/PDE para reconstruir el circuito cerrado de energía-información-mecánica en una escala espacio-temporal de 10 órdenes de magnitud y puede predecir ≥ 3 fenómenos de movimiento verificados no experimentalmente.',
    summaryEn: 'Establish a unified theory of cross-scale motion: molecular motor (kinesin/myosin) → cell (flagella) → organ → whole. Use the ODE/PDE framework to reconstruct the energy-information-mechanics closed loop on 10 orders of magnitude time-space scale, and can predict ≥ 3 unexperimentally verified motion phenomena.',
    kid: '苍蝇能悬停飞行、细菌能用鞭毛推进、章鱼能用触手爬行。这些运动模式背后的物理原理和能量优化策略是什么？',
    formal: '建立跨尺度运动统一理论：分子马达 (kinesin/myosin) → 细胞 (鞭毛) → 器官 → 整体，用 ODE/PDE 框架在 10 个数量级时间-空间尺度上重构能量-信息-力学闭环，且能预测 ≥ 3 个未实验验证的运动现象。',
    formalJa: 'クロススケール運動の統一理論を確立する：キネシン/ミオシン→細胞（鞭毛）→器官を→全体として、ODE/PDEフレームワークを使用してエネルギー-情報-機械的閉ループを10桁の時間空間スケールで再構築し、実験的に検証されていない3つ以上の運動現象を予測することができる。',
    formalEs: 'Establecer una teoría unificada del movimiento a través de escalas: motor molecular (cinesina/miosina) → célula (flagelos) → órgano → conjunto. Utilice el marco ODE/PDE para reconstruir el circuito cerrado de energía-información-mecánica en una escala espacio-temporal de 10 órdenes de magnitud y puede predecir ≥ 3 fenómenos de movimiento verificados no experimentalmente.',
    formalEn: 'Establish a unified theory of cross-scale motion: molecular motor (kinesin/myosin) → cell (flagella) → organ → whole. Use the ODE/PDE framework to reconstruct the energy-information-mechanics closed loop on 10 orders of magnitude time-space scale, and can predict ≥ 3 unexperimentally verified motion phenomena.',
    whyHard: '多尺度耦合。',
    aiPrompt: '介绍 Purcell "Life at Low Reynolds Number"。',
    tags: ['运动', '物理', '演化'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Locomotion',
    videoChannel: 'Veritasium',
    participate: [{ type: 'experiment', label: '动手实验', desc: '机器人模拟' }, { type: 'code', label: '写代码/算法', desc: '物理仿真' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Purcell 论文' }]
  },
  {
    id: 'bioluminescence',
    category: 'biology',
    title: '生物发光工程',
    titleJa: '生物発光工学',
    titleEs: 'Toda la planta (como el tabaco/Arabidopsis thaliana) puede modificarse genéticamente para emitir continuamente luz visible ≥ 1 μmol de fotones/m²/s (visible para el ojo humano) sin una reducción significativa en la tasa de crecimiento y la capacidad reproductiva (< 10% de diferencia). La luz proviene del sistema endógeno Luciferasa/luciferina sin suministro de sustrato externo.',
    titleEn: 'Bioluminescence Engineering',
    year: 2010,
    proposer: '—',
    difficulty: 2,
    reward: 500,
    status: 'partially_solved',
    summary: '让植物像灯泡一样发光',
    summaryJa: '植物を電球のように輝かせる',
    summaryEs: 'Toda la planta (como el tabaco/Arabidopsis thaliana) puede modificarse genéticamente para emitir continuamente luz visible ≥ 1 μmol de fotones/m²/s (visible para el ojo humano) sin una reducción significativa en la tasa de crecimiento y la capacidad reproductiva (< 10% de diferencia). La luz proviene del sistema endógeno Luciferasa/luciferina sin suministro de sustrato externo.',
    summaryEn: 'The whole plant (such as tobacco/Arabidopsis thaliana) can be genetically modified to continuously emit visible light ≥ 1 μmol photons/m²/s (visible to the human eye) without significant reduction in growth rate and reproductive capacity (< 10% difference). The light comes from the endogenous Luciferase/luciferin system without external substrate supply.',
    kid: '萤火虫、深海鱼会发光。如果让植物也发光，城市街道上种树就能代替路灯——多浪漫！',
    formal: '通过转基因使整株植物（如烟草/拟南芥）持续可见光发光 ≥ 1 μmol photons/m²/s （人眼可见），且生长速率、生殖能力无显著降低（< 10% 差异），光照来自内源 Luciferase/luciferin 系统，无外部底物供应。',
    formalJa: '植物全体（タバコ／アラビドプスタリアナなど）は、トランスジェニック可視光放射≧ １ μ ｍｏｌ光子／ ｍ ²／ ｓ （ヒトの目に見える）によって維持され、成長速度、生殖能力（ １ ０ ％未満の差）、内因性ルシフェラーゼ／ルシフェリン系からの照明に有意な低下はなく、外部基質供給もなかった。',
    formalEs: 'Toda la planta (como el tabaco/Arabidopsis thaliana) puede modificarse genéticamente para emitir continuamente luz visible ≥ 1 μmol de fotones/m²/s (visible para el ojo humano) sin una reducción significativa en la tasa de crecimiento y la capacidad reproductiva (< 10% de diferencia). La luz proviene del sistema endógeno Luciferasa/luciferina sin suministro de sustrato externo.',
    formalEn: 'The whole plant (such as tobacco/Arabidopsis thaliana) can be genetically modified to continuously emit visible light ≥ 1 μmol photons/m²/s (visible to the human eye) without significant reduction in growth rate and reproductive capacity (< 10% difference). The light comes from the endogenous Luciferase/luciferin system without external substrate supply.',
    whyHard: '光强与代谢平衡。',
    aiPrompt: '介绍 luciferase 通路、Plantae 项目。',
    tags: ['合成生物', '工程', '光'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Glowing Plants',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '转入荧光基因' }, { type: 'kid-project', label: '儿童项目', desc: '种转基因荧光植物' }, { type: 'essay', label: '写文章/论文', desc: '介绍生物发光' }]
  },
  {
    id: 'synthetic-genome',
    category: 'biology',
    title: '合成基因组',
    titleJa: '合成ゲノム',
    titleEs: 'Diseñar completamente y sintetizar químicamente el genoma de cualquier organismo eucariota (como levadura de 12 Mb) con una precisión ≥ 99,999%, un costo de síntesis ≤ US$ 0,10/base, una consistencia entre el fenotipo trasplantado y el diseño ≥ 95% y secuenciación del genoma completo para verificar que no haya sesgos.',
    titleEn: 'Synthetic Genome',
    year: 2010,
    proposer: 'C. Venter (Synthia)',
    difficulty: 5,
    reward: 0,
    status: 'partially_solved',
    summary: '从零合成一个完整基因组',
    summaryJa: 'ゼロから完全なゲノムを合成する',
    summaryEs: 'Diseñar completamente y sintetizar químicamente el genoma de cualquier organismo eucariota (como levadura de 12 Mb) con una precisión ≥ 99,999%, un costo de síntesis ≤ US$ 0,10/base, una consistencia entre el fenotipo trasplantado y el diseño ≥ 95% y secuenciación del genoma completo para verificar que no haya sesgos.',
    summaryEn: 'Completely design and chemically synthesize the genome of any eukaryotic organism (such as yeast 12 Mb) with an accuracy ≥ 99.999%, a synthesis cost ≤ US$0.10/base, a consistency between the transplanted phenotype and the design ≥ 95%, and whole-genome sequencing to verify that there is no bias.',
    kid: '2010 年 Venter 团队合成了第一个细菌基因组并植入细胞。2017 年合成酵母 5 号染色体（最大的人工真核染色体）。能不能合成完整的人类基因组？这涉及巨大伦理问题。',
    formal: '完整设计并化学合成任意真核生物（如酵母 12 Mb）基因组，准确率 ≥ 99.999%、合成成本 ≤ 0.10 美元/碱基、移植后表型与设计一致度 ≥ 95%、且全基因组测序验证无偏移。',
    formalJa: '任意の真核生物（酵母１ ２ Ｍｂなど）のゲノムの完全な設計及び化学合成、９ ９ ． ９ ９ ９ ％以上の精度、０ ． １ ０ ＵＳＤ ／塩基以下の合成コスト、９ ５ ％以上の移植後表現型及び設計一貫性、ならびに全ゲノム配列決定検証からのオフセットなし。',
    formalEs: 'Diseñar completamente y sintetizar químicamente el genoma de cualquier organismo eucariota (como levadura de 12 Mb) con una precisión ≥ 99,999%, un costo de síntesis ≤ US$ 0,10/base, una consistencia entre el fenotipo trasplantado y el diseño ≥ 95% y secuenciación del genoma completo para verificar que no haya sesgos.',
    formalEn: 'Completely design and chemically synthesize the genome of any eukaryotic organism (such as yeast 12 Mb) with an accuracy ≥ 99.999%, a synthesis cost ≤ US$0.10/base, a consistency between the transplanted phenotype and the design ≥ 95%, and whole-genome sequencing to verify that there is no bias.',
    whyHard: '基因组规模大、表观遗传复杂。',
    aiPrompt: '介绍 GP-write、Sc2.0。',
    tags: ['合成生物', '伦理', '基因组'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Synthetic Genome',
    videoChannel: 'Quanta',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 Synthia 和 GP-write' }, { type: 'discuss', label: '想法/讨论', desc: '参与伦理讨论' }, { type: 'fund', label: '资助/投资', desc: '给相关研究捐资' }]
  },
  {
    id: 'plant-intelligence',
    category: 'biology',
    title: '植物智能',
    titleJa: 'プラントインテリジェンス',
    titleEs: 'Establecer un modelo "inteligente" computable para el comportamiento de raíz/hoja/captura de insectos de la planta: capaz de predecir (a) selección de ruta de alimentación ≥ 80% de precisión, (b) umbral de activación de plantas carnívoras ±10%, (c) retraso de señalización grupal < 30 segundos; El modelo ha sido verificado por un grupo experimental independiente.',
    titleEn: 'Plant Intelligence',
    year: 2005,
    proposer: 'S. Mancuso / A. Trewavas',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '植物会"思考"吗？',
    summaryJa: '植物は「考える」のか？',
    summaryEs: 'Establecer un modelo "inteligente" computable para el comportamiento de raíz/hoja/captura de insectos de la planta: capaz de predecir (a) selección de ruta de alimentación ≥ 80% de precisión, (b) umbral de activación de plantas carnívoras ±10%, (c) retraso de señalización grupal < 30 segundos; El modelo ha sido verificado por un grupo experimental independiente.',
    summaryEn: 'Establish a computable "intelligent" model for plant root/leaf/insect-catching behavior: able to predict (a) foraging path selection ≥ 80% accuracy, (b) carnivorous plant triggering threshold ±10%, (c) group signaling delay < 30 seconds; the model has been verified by an independent experimental group.',
    kid: '植物没有大脑，但它们能感知环境、计算资源、做出复杂决策（比如竞争光）。它们是某种意义上的"智能"吗？',
    formal: '对植物根/叶/捕虫行为建立可计算的「智能」模型：能预测 (a) 觅食路径选择 ≥ 80% 准确率，(b) 食虫植物触发阈值 ±10%，(c) 群体信号传导延迟 < 30 秒；模型通过独立实验组验证。',
    formalJa: '植物の根／葉／害虫の挙動の計算可能な「スマート」モデルを構築する： （ ａ ）狩猟経路選択≧ ８ ０ ％の精度、（ ｂ ）肉食植物トリガー閾値± １ ０ ％、（ ｃ ）集団シグナル伝達遅延＜ ３ ０秒、独立した実験グループによって検証されたモデルを予測する。',
    formalEs: 'Establecer un modelo "inteligente" computable para el comportamiento de raíz/hoja/captura de insectos de la planta: capaz de predecir (a) selección de ruta de alimentación ≥ 80% de precisión, (b) umbral de activación de plantas carnívoras ±10%, (c) retraso de señalización grupal < 30 segundos; El modelo ha sido verificado por un grupo experimental independiente.',
    formalEn: 'Establish a computable "intelligent" model for plant root/leaf/insect-catching behavior: able to predict (a) foraging path selection ≥ 80% accuracy, (b) carnivorous plant triggering threshold ±10%, (c) group signaling delay < 30 seconds; the model has been verified by an independent experimental group.',
    whyHard: '智能概念本身有争议。',
    aiPrompt: '介绍 Mancuso 实验室。',
    tags: ['植物', '智能', '哲学'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Plant Intelligence',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '观察植物行为' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Mancuso 工作' }, { type: 'discuss', label: '想法/讨论', desc: '参与智能定义讨论' }]
  },
  {
    id: 'photosynthesis-eff',
    category: 'biology',
    title: '光合效率提升',
    titleJa: '光合成効率の向上',
    titleEs: 'A través de la ingeniería RuBisCO/introducción de la vía C4/derivación de la rama de fotorrespiración, la eficiencia cuántica fotosintética de los cultivos C3 (como el arroz) aumenta de ~3% a ≥6%, y el rendimiento del campo aumenta en ≥30% (prueba de 3 años en varios sitios) sin efectos secundarios ecológicos significativos.',
    titleEn: 'Improving Photosynthesis Efficiency',
    year: 2016,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '让光合作用效率翻倍',
    summaryJa: '光合成の効率を2倍に',
    summaryEs: 'A través de la ingeniería RuBisCO/introducción de la vía C4/derivación de la rama de fotorrespiración, la eficiencia cuántica fotosintética de los cultivos C3 (como el arroz) aumenta de ~3% a ≥6%, y el rendimiento del campo aumenta en ≥30% (prueba de 3 años en varios sitios) sin efectos secundarios ecológicos significativos.',
    summaryEn: 'Through RuBisCO engineering/C4 pathway introduction/photorespiration branch bypass, the photosynthetic quantum efficiency of C3 crops (such as rice) is increased from ~3% to ≥6%, and field yield is increased by ≥30% (3-year multi-site trial) without significant ecological side effects.',
    kid: '植物光合作用把光能变成糖，但效率只有 1-2%（远低于太阳能电池的 20%）。如果提升到 5%，粮食产量能大幅提高。',
    formal: '通过 RuBisCO 工程 / C4 通路引入 / 光呼吸支路绕过，将 C3 作物（如水稻）光合量子效率从 ~3% 提升至 ≥ 6%，田间产量提升 ≥ 30%（3 年多地点试验），且无显著生态副作用。',
    formalJa: 'RuBisCO ENGINEERING/C 4経路導入/光呼吸分岐バイパスにより、C 3作物（米など）の光合成量子効率は約3 ％から6 ％以上に増加し、畑収量は30 ％以上増加した（ 3年以上のサイトトライアル）。',
    formalEs: 'A través de la ingeniería RuBisCO/introducción de la vía C4/derivación de la rama de fotorrespiración, la eficiencia cuántica fotosintética de los cultivos C3 (como el arroz) aumenta de ~3% a ≥6%, y el rendimiento del campo aumenta en ≥30% (prueba de 3 años en varios sitios) sin efectos secundarios ecológicos significativos.',
    formalEn: 'Through RuBisCO engineering/C4 pathway introduction/photorespiration branch bypass, the photosynthetic quantum efficiency of C3 crops (such as rice) is increased from ~3% to ≥6%, and field yield is increased by ≥30% (3-year multi-site trial) without significant ecological side effects.',
    whyHard: '多基因协调。',
    aiPrompt: '介绍 RIPE、Realizing Increased Photosynthetic Efficiency。',
    tags: ['农业', '基因', '光合'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Photosynthesis',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: 'RuBisCO 工程' }, { type: 'code', label: '写代码/算法', desc: '代谢通量分析' }, { type: 'essay', label: '写文章/论文', desc: '介绍 RIPE 项目' }]
  },
  {
    id: 'climate-crops',
    category: 'biology',
    title: '气候适应作物',
    titleJa: '気候変動に強い作物',
    titleEs: 'La edición genética permite que los cultivos básicos mantengan un rendimiento superior al 80 % en condiciones de sequía/salino-álcali/alta temperatura.',
    titleEn: 'Climate-Resilient Crops',
    year: 2010,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '让作物耐受极端气候',
    summaryJa: '作物を極端な気候に耐えられるようにする',
    summaryEs: 'La edición genética permite que los cultivos básicos mantengan un rendimiento superior al 80 % en condiciones de sequía/salino-álcali/alta temperatura.',
    summaryEn: 'Gene editing allows staple crops to maintain >80% yield under drought/saline-alkali/high temperature conditions.',
    kid: '气候变化让干旱、洪水、热浪更频繁。需要能扛住这些的作物品种。CRISPR 让基因编辑变便宜。',
    formal: '通过基因编辑让主粮作物在干旱/盐碱/高温下保持 > 80% 产量。',
    formalJa: '遺伝子編集により、主食作物は、干ばつ/生理食塩水/高温下で80 ％を超える収量を維持することができます。',
    formalEs: 'La edición genética permite que los cultivos básicos mantengan un rendimiento superior al 80 % en condiciones de sequía/salino-álcali/alta temperatura.',
    formalEn: 'Gene editing allows staple crops to maintain >80% yield under drought/saline-alkali/high temperature conditions.',
    whyHard: '多基因性状。',
    aiPrompt: '介绍 Golden Rice、Drought-tolerant maize。',
    tags: ['农业', 'CRISPR', '气候'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Climate Crops',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: 'CRISPR 改造水稻' }, { type: 'essay', label: '写文章/论文', desc: '介绍气候农业' }]
  },
  {
    id: 'agi',
    category: 'cs',
    title: '通用人工智能 (AGI)',
    titleJa: '一般的な人工知能（ AGI ）',
    titleEs: 'Construya un sistema de inteligencia artificial que pueda realizar cualquier tarea de inteligencia humana.',
    titleEn: 'Artificial General Intelligence',
    year: 1956,
    proposer: '—',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '一个 AI 能像人一样做任何事？',
    summaryJa: 'AIは人間のように何かをすることができますか？',
    summaryEs: 'Construya un sistema de inteligencia artificial que pueda realizar cualquier tarea de inteligencia humana.',
    summaryEn: 'Construct an AI system that can accomplish any human intelligence task.',
    kid: '现在的 AI 都很"专"：下棋的 AI 不能开车，写文章的 AI 不能画画。AGI 想要一个 AI 像人一样，什么都能学、什么都能想。这件事能不能做到、什么时候做到，没人知道。',
    formal: '构造一个能完成任何人类智能任务的 AI 系统。',
    formalJa: 'ヒューマンインテリジェンスのタスクを達成できるAIシステムを構築します。',
    formalEs: 'Construya un sistema de inteligencia artificial que pueda realizar cualquier tarea de inteligencia humana.',
    formalEn: 'Construct an AI system that can accomplish any human intelligence task.',
    whyHard: '人类智能的原理仍不清楚。',
    aiPrompt: '讨论 AGI 的定义、可能时间表、风险。',
    tags: ['AI', '智能', '哲学'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'AGI',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'code', label: '写代码/算法', desc: '实现 AGI 系统' }, { type: 'essay', label: '写文章/论文', desc: '讨论 AGI 时间表' }, { type: 'discuss', label: '想法/讨论', desc: '参与 AI 安全论坛' }, { type: 'fund', label: '资助/投资', desc: '给 AI 研究捐资' }]
  },
  {
    id: 'alignment',
    category: 'cs',
    title: 'AI 对齐',
    titleJa: 'AIアライメント',
    titleEs: 'Construir un sistema de IA que pueda comportarse de manera sólida de acuerdo con las intenciones humanas y superar a los humanos en capacidades.',
    titleEn: 'AI Alignment',
    year: 2003,
    proposer: 'N. Bostrom / S. Russell',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '怎么让超级智能的 AI 听人的话？',
    summaryJa: '超インテリジェントなAIに耳を傾けるにはどうすればよいですか？',
    summaryEs: 'Construir un sistema de IA que pueda comportarse de manera sólida de acuerdo con las intenciones humanas y superar a los humanos en capacidades.',
    summaryEn: 'Construct an AI system that can robustly behave according to human intentions and surpass humans in capabilities.',
    kid: '如果你有一只能听懂"做事"的魔法精灵，你怎么确保它做的事真的是你想的？比如你说"给我倒杯水"，它可能把家里所有水都倒完。AI 比精灵更危险——因为它可能比你还聪明。',
    formal: '构造一个能稳健地按人类意图行事、且在能力上超过人类的 AI 系统。',
    formalJa: '人間の意図にしっかりと対応し、人間の能力を凌駕するAIシステムを構築する。',
    formalEs: 'Construir un sistema de IA que pueda comportarse de manera sólida de acuerdo con las intenciones humanas y superar a los humanos en capacidades.',
    formalEn: 'Construct an AI system that can robustly behave according to human intentions and surpass humans in capabilities.',
    whyHard: '人类的意图很难形式化。',
    aiPrompt: '介绍 RLHF、Constitutional AI、可解释性。',
    tags: ['AI', '安全', '伦理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'AI Alignment',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'code', label: '写代码/算法', desc: '实现对齐算法' }, { type: 'essay', label: '写文章/论文', desc: '讨论对齐问题' }, { type: 'discuss', label: '想法/讨论', desc: '参与 AI 安全研究' }, { type: 'fund', label: '资助/投资', desc: '给 MIRI/ARC 捐资' }]
  },
  {
    id: 'software-verification',
    category: 'cs',
    title: '软件形式化验证',
    titleJa: 'ソフトウェアの正式な検証',
    titleEs: 'Verificación formal totalmente automatizada de 10⁵-10⁷ líneas de código industrial (C/SystemC/Python): coincidencia de especificaciones en ≤ 4 horas/32 GB de memoria, < 5 % de tasa de falsos positivos y ≥ 1 falla equivalente a CVE encontrada en al menos 2 grandes proyectos de código abierto (módulo del kernel de Linux, OpenSSL).',
    titleEn: 'Software Verification',
    year: 1970,
    proposer: 'E. W. Dijkstra / C. A. R. Hoare',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '让电脑证明程序没有 bug',
    summaryJa: 'プログラムにバグがないことをコンピューターに証明してもらう',
    summaryEs: 'Verificación formal totalmente automatizada de 10⁵-10⁷ líneas de código industrial (C/SystemC/Python): coincidencia de especificaciones en ≤ 4 horas/32 GB de memoria, < 5 % de tasa de falsos positivos y ≥ 1 falla equivalente a CVE encontrada en al menos 2 grandes proyectos de código abierto (módulo del kernel de Linux, OpenSSL).',
    summaryEn: 'Fully automated formal verification of 10⁵-10⁷ lines of industry code (C/SystemC/Python): spec matching in ≤ 4 hours / 32 GB of memory, < 5% false positive rate, and ≥ 1 CVE-equivalent flaw found on at least 2 large open source projects (Linux kernel module, OpenSSL).',
    kid: '手机上的 app、医院里的核磁共振机、银行系统——都有 bug 风险。能不能让电脑"读"一段代码，告诉你"这段代码绝对没 bug"？现在只能验证非常小的程序，对真实软件完全不行。',
    formal: '对 10⁵-10⁷ 行业代码行（C/SystemC/Python）实现全自动形式验证：在 ≤ 4 小时 / 32 GB 内存内完成 spec 匹配，误报率 < 5%，且至少在 2 个开源大型项目 (Linux kernel module, OpenSSL) 上发现 ≥ 1 个 CVE 等价缺陷。',
    formalJa: '10〜10行の業界コード（ C/SystemC/Python ）の完全に自動化された正式な検証：少なくとも2つの大規模なオープンソースプロジェクト（ Linuxカーネルモジュール、OpenSSL ）で見つかった偽陽性率< 5 ％および≥ 1 CVE同等の欠陥で、4時間/32 GBのメモリでスペックマッチングが完了します。',
    formalEs: 'Verificación formal totalmente automatizada de 10⁵-10⁷ líneas de código industrial (C/SystemC/Python): coincidencia de especificaciones en ≤ 4 horas/32 GB de memoria, < 5 % de tasa de falsos positivos y ≥ 1 falla equivalente a CVE encontrada en al menos 2 grandes proyectos de código abierto (módulo del kernel de Linux, OpenSSL).',
    formalEn: 'Fully automated formal verification of 10⁵-10⁷ lines of industry code (C/SystemC/Python): spec matching in ≤ 4 hours / 32 GB of memory, < 5% false positive rate, and ≥ 1 CVE-equivalent flaw found on at least 2 large open source projects (Linux kernel module, OpenSSL).',
    whyHard: '状态空间爆炸。',
    aiPrompt: '介绍 Coq、Lean、Isabelle、Dafny。',
    tags: ['程序', '形式化', 'PL'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Software Verification',
    videoChannel: 'MIT OCW',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 Lean 形式化定理' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Coq 历史' }, { type: 'teach', label: '教学/讲解', desc: '给 PL 学生讲' }]
  },
  {
    id: 'homomorphic-encryption',
    category: 'cs',
    title: '全同态加密',
    titleJa: '完全同型暗号化',
    titleEs: 'Cifrado totalmente homomórfico construido de manera eficiente que admite profundidad arbitraria para todos los circuitos.',
    titleEn: 'Fully Homomorphic Encryption',
    year: 2009,
    proposer: 'C. Gentry',
    difficulty: 4,
    reward: 2000,
    status: 'partially_solved',
    summary: '在加密数据上直接计算',
    summaryJa: '暗号化されたデータを直接計算',
    summaryEs: 'Cifrado totalmente homomórfico construido de manera eficiente que admite profundidad arbitraria para todos los circuitos.',
    summaryEn: 'Efficiently constructed, fully homomorphic encryption supporting arbitrary depth for all circuits.',
    kid: '你想让医院 AI 帮你看病，但不想把病历给 AI。同态加密可以让你"加密"的病历送到 AI，AI 直接在"乱码"上计算，把结果给你，你解密后看到诊断。AI 看不到你的隐私。',
    formal: '构造高效、对所有电路支持任意深度的全同态加密。',
    formalJa: '効率的に構築し、すべての回路の任意の深さで完全な同型暗号化をサポートします。',
    formalEs: 'Cifrado totalmente homomórfico construido de manera eficiente que admite profundidad arbitraria para todos los circuitos.',
    formalEn: 'Efficiently constructed, fully homomorphic encryption supporting arbitrary depth for all circuits.',
    whyHard: '噪声管理和性能。',
    aiPrompt: '介绍 BGV、BFV、CKKS 方案。',
    tags: ['密码', '隐私', '数学'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Homomorphic Encryption',
    videoChannel: 'Quanta',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 SEAL 或 OpenFHE 实现' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Gentry 突破' }, { type: 'fund', label: '资助/投资', desc: '给 IBM/PALISADE 捐资' }]
  },
  {
    id: 'quantum-internet',
    category: 'cs',
    title: '量子互联网',
    titleJa: '量子インターネット',
    titleEs: 'Realice una red cuántica de múltiples nodos: distribución de entrelazamiento de ≥ 1000 nodos, fidelidad F ≥ 0,9, distancia ≥ 1000 km (basada en un repetidor cuántico), retraso <100 ms y corrección de errores sólida para fallas de nodos y decoherencia de entrelazamiento.',
    titleEn: 'Quantum Internet',
    year: 2018,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '用量子比特通信的网络',
    summaryJa: 'キュービットと通信するネットワーク',
    summaryEs: 'Realice una red cuántica de múltiples nodos: distribución de entrelazamiento de ≥ 1000 nodos, fidelidad F ≥ 0,9, distancia ≥ 1000 km (basada en un repetidor cuántico), retraso <100 ms y corrección de errores sólida para fallas de nodos y decoherencia de entrelazamiento.',
    summaryEn: 'Realize multi-node quantum network: ≥ 1000 node entanglement distribution, fidelity F ≥ 0.9, distance ≥ 1000 km (based on quantum repeater), delay < 100 ms, and robust error correction to node failure and entanglement decoherence.',
    kid: '现在的网络发的是经典比特（0 或 1）。量子互联网发的是"量子比特"——一种"既是0又是1"的神奇状态。它能做不能被偷听的安全通信，连远程量子计算机一起工作。',
    formal: '实现多节点量子网络：≥ 1000 节点纠缠分发、保真度 F ≥ 0.9、距离 ≥ 1000 km (基于 quantum repeater)、延迟 < 100 ms、且对节点故障、纠缠退相干有鲁棒错误纠正。',
    formalJa: '多ノード量子ネットワークを実現する： ≥ 1000ノードのもつれ分布、忠実度F ≥ 0.9、距離≥ 1000 km （量子リピーターに基づく）、遅延< 100ミリ秒、およびノード障害およびもつれ退干渉に対するロバストエラー訂正。',
    formalEs: 'Realice una red cuántica de múltiples nodos: distribución de entrelazamiento de ≥ 1000 nodos, fidelidad F ≥ 0,9, distancia ≥ 1000 km (basada en un repetidor cuántico), retraso <100 ms y corrección de errores sólida para fallas de nodos y decoherencia de entrelazamiento.',
    formalEn: 'Realize multi-node quantum network: ≥ 1000 node entanglement distribution, fidelity F ≥ 0.9, distance ≥ 1000 km (based on quantum repeater), delay < 100 ms, and robust error correction to node failure and entanglement decoherence.',
    whyHard: '量子纠缠保持和放大。',
    aiPrompt: '介绍量子隐形传态、量子中继。',
    tags: ['量子', '网络', '安全'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Quantum Internet',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '量子纠缠分发' }, { type: 'code', label: '写代码/算法', desc: '量子网络模拟' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Quantum Internet Alliance' }]
  },
  {
    id: 'translation-parity',
    category: 'cs',
    title: '通用机器翻译',
    titleJa: 'ユニバーサル機械翻訳',
    titleEs: 'Según BLEU/chrF/evaluación de expertos humanos, lograr: ≥ 95% de nivel de traductor experto (Adecuación), ≥ 90% (Fluidez) y una tasa de comprensión correcta de metáforas/alusiones culturales ≥ 80% (evaluación humana) para cualquier par de idiomas (incluidos los de bajos recursos) en cualquier campo (derecho/medicina/tecnología/literatura).',
    titleEn: 'Universal Machine Translation',
    year: 1954,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'partially_solved',
    summary: 'AI 像专业翻译家一样工作',
    summaryJa: 'AIはプロの翻訳者のように機能します',
    summaryEs: 'Según BLEU/chrF/evaluación de expertos humanos, lograr: ≥ 95% de nivel de traductor experto (Adecuación), ≥ 90% (Fluidez) y una tasa de comprensión correcta de metáforas/alusiones culturales ≥ 80% (evaluación humana) para cualquier par de idiomas (incluidos los de bajos recursos) en cualquier campo (derecho/medicina/tecnología/literatura).',
    summaryEn: 'Under BLEU/chrF/human expert evaluation, achieve: ≥ 95% expert translator level (Adequacy), ≥ 90% (Fluency), and a correct understanding rate of cultural metaphors/allusions ≥ 80% (human evaluation) for any language pair (including low resources) in any field (law/medicine/technology/literature).',
    kid: '现在 Google 翻译已经能做基本翻译了，但在俚语、专业内容、文化背景上还是不行。如果 AI 能像专业翻译家一样工作，世界会变得更小。',
    formal: '在 BLEU/chrF/人类专家评估下，对任何语言对 (含低资源) 任何领域 (法律/医学/技术/文学) 达到：≥ 95% 专家译者水平 (Adequacy)、≥ 90% (Fluency)、且文化隐喻/典故正确理解率 ≥ 80%（人类评估）。',
    formalJa: 'BLEU/chrF/ヒューマンエキスパートアセスメントの下で、あらゆる分野（法律/医学/技術/文学）のあらゆる言語ペア（低リソースを含む）が達成した：エキスパート翻訳者レベル（適切性）が95 ％以上、（流暢性）が90 ％以上、文化的メタファー/アリュージョンの正しい理解率が80 ％以上（ヒューマンアセスメント）。',
    formalEs: 'Según BLEU/chrF/evaluación de expertos humanos, lograr: ≥ 95% de nivel de traductor experto (Adecuación), ≥ 90% (Fluidez) y una tasa de comprensión correcta de metáforas/alusiones culturales ≥ 80% (evaluación humana) para cualquier par de idiomas (incluidos los de bajos recursos) en cualquier campo (derecho/medicina/tecnología/literatura).',
    formalEn: 'Under BLEU/chrF/human expert evaluation, achieve: ≥ 95% expert translator level (Adequacy), ≥ 90% (Fluency), and a correct understanding rate of cultural metaphors/allusions ≥ 80% (human evaluation) for any language pair (including low resources) in any field (law/medicine/technology/literature).',
    whyHard: '文化背景和隐含知识。',
    aiPrompt: '介绍 NMT、PaLM、Context-aware translation。',
    tags: ['NLP', 'AI', '语言'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Translation AI',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: 'fine-tune 翻译模型' }, { type: 'data', label: '数据收集/标注', desc: '标注平行语料' }, { type: 'essay', label: '写文章/论文', desc: '介绍机器翻译 70 年史' }]
  },
  {
    id: 'crypto-scale',
    category: 'cs',
    title: '可扩展区块链',
    titleJa: 'スケーラブルなブロックチェーン',
    titleEs: 'Bajo la premisa de mantener una resistencia a los ataques del 51%, la cadena de bloques descentralizada tiene: TPS continuo ≥ 10,000, retraso de confirmación <10 s, número de nodos ≥ 10,000 y ningún incidente de seguridad importante después de 3 años de pruebas de combate reales.',
    titleEn: 'Scalable Blockchain',
    year: 2017,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '让区块链处理 VISA 级别的交易',
    summaryJa: 'ブロックチェーンにビザレベルのトランザクションを処理させる',
    summaryEs: 'Bajo la premisa de mantener una resistencia a los ataques del 51%, la cadena de bloques descentralizada tiene: TPS continuo ≥ 10,000, retraso de confirmación <10 s, número de nodos ≥ 10,000 y ningún incidente de seguridad importante después de 3 años de pruebas de combate reales.',
    summaryEn: 'On the premise of maintaining 51% attack resistance, the decentralized blockchain has: continuous TPS ≥ 10,000, confirmation delay < 10 s, number of nodes ≥ 10,000, and no major security incidents after 3 years of actual combat testing.',
    kid: 'VISA 每秒处理 24000 笔交易。比特币每秒 7 笔，以太坊 30 笔。要让区块链普及，必须解决扩展性。',
    formal: '去中心化区块链在保持 51% 抗攻击性前提下：持续 TPS ≥ 10000、确认延迟 < 10 s、节点数 ≥ 10000，且经 3 年实战考验无重大安全事件。',
    formalJa: '分散型ブロックチェーンは、51 ％の攻撃抵抗力を維持します。継続的なTPS ≥ 10000、確認遅延< 10秒、ノード数≥ 10000、3年間の実用的なテスト後に重大なセキュリティインシデントは発生しません。',
    formalEs: 'Bajo la premisa de mantener una resistencia a los ataques del 51%, la cadena de bloques descentralizada tiene: TPS continuo ≥ 10,000, retraso de confirmación <10 s, número de nodos ≥ 10,000 y ningún incidente de seguridad importante después de 3 años de pruebas de combate reales.',
    formalEn: 'On the premise of maintaining 51% attack resistance, the decentralized blockchain has: continuous TPS ≥ 10,000, confirmation delay < 10 s, number of nodes ≥ 10,000, and no major security incidents after 3 years of actual combat testing.',
    whyHard: '去中心化、安全、可扩展的不可能三角。',
    aiPrompt: '介绍 L2、sharding、Solana、Aptos。',
    tags: ['区块链', '分布式', '扩容'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Blockchain Scaling',
    videoChannel: 'a16z',
    participate: [{ type: 'code', label: '写代码/算法', desc: '跑 L2 测试网' }, { type: 'essay', label: '写文章/论文', desc: '介绍不可能三角' }, { type: 'fund', label: '资助/投资', desc: '给加密项目投资' }]
  },
  {
    id: 'consensus',
    category: 'cs',
    title: '分布式共识',
    titleJa: '分散コンセンサス',
    titleEs: 'Minimización del consenso tolerante a fallas para n > 3f cuando hay f nodos bizantinos de n nodos.',
    titleEn: 'Distributed Consensus',
    year: 1982,
    proposer: 'L. Lamport / R. Shostak / M. Pease',
    difficulty: 3,
    reward: 0,
    status: 'partially_solved',
    summary: '在不可靠网络中达成一致',
    summaryJa: '信頼性の低いネットワークで同意する',
    summaryEs: 'Minimización del consenso tolerante a fallas para n > 3f cuando hay f nodos bizantinos de n nodos.',
    summaryEn: 'Minimization of fault-tolerant consensus for n > 3f when there are f Byzantine nodes out of n nodes.',
    kid: '一群计算机中有的是叛徒，它们怎么投票选出一个共同决定？1982 年的"拜占庭将军问题"提出这个问题。比特币的工作量证明是答案之一，但不是唯一的。',
    formal: '在 n 个节点中有 f 个拜占庭节点时容错共识的 n > 3f 最小化。',
    formalJa: 'フォールトトレラントコンセンサスのｎ ＞ ３ ｆは、ｎ個のノードにｆ個のビザンチンノードがあるときに最小化される。',
    formalEs: 'Minimización del consenso tolerante a fallas para n > 3f cuando hay f nodos bizantinos de n nodos.',
    formalEn: 'Minimization of fault-tolerant consensus for n > 3f when there are f Byzantine nodes out of n nodes.',
    whyHard: '网络延迟、节点动态。',
    aiPrompt: '介绍 PBFT、Tendermint、HotStuff。',
    tags: ['分布式', '算法', '一致性'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Distributed Consensus',
    videoChannel: 'MIT OCW',
    participate: [{ type: 'code', label: '写代码/算法', desc: '实现 PBFT' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Lamport 故事' }, { type: 'teach', label: '教学/讲解', desc: '给分布式系统学生讲' }]
  },
  {
    id: 'privacy-ml',
    category: 'cs',
    title: '隐私保护机器学习',
    titleJa: 'プライバシーを守る機械学習',
    titleEs: 'Entrene modelos de ML sin exponer datos individuales y con estrictas garantías de privacidad.',
    titleEn: 'Privacy-Preserving ML',
    year: 2016,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '用隐私数据训练 AI',
    summaryJa: 'プライベートデータでAIをトレーニングする',
    summaryEs: 'Entrene modelos de ML sin exponer datos individuales y con estrictas garantías de privacidad.',
    summaryEn: 'Train ML models without exposing individual data and with strict privacy guarantees.',
    kid: '医院、银行想用 AI，但数据不能共享。能不能不直接看数据就训练 AI？',
    formal: '在不暴露个体数据的前提下训练 ML 模型并提供严格隐私保证。',
    formalJa: '個々のデータを公開せずにMLモデルをトレーニングし、厳格なプライバシー保証を提供します。',
    formalEs: 'Entrene modelos de ML sin exponer datos individuales y con estrictas garantías de privacidad.',
    formalEn: 'Train ML models without exposing individual data and with strict privacy guarantees.',
    whyHard: '隐私-效用权衡。',
    aiPrompt: '介绍差分隐私、联邦学习、安全多方计算。',
    tags: ['ML', '隐私', '加密'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Privacy ML',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 Opacus 训练 DP 模型' }, { type: 'essay', label: '写文章/论文', desc: '介绍 DP 历史' }]
  },
  {
    id: 'federated-learning',
    category: 'cs',
    title: '联邦学习',
    titleJa: 'フェデラルラーニング',
    titleEs: 'Sistema de aprendizaje federado: sobrecarga de comunicación <1% de la capacitación centralizada, resistente a la desconexión del cliente (<50% aún se puede capacitar en línea), satisface (ε, δ)-privacidad diferencial (ε ≤ 1, δ ≤ 10⁻⁵), pérdida de precisión del modelo <2% y admite hardware heterogéneo (teléfono móvil/integrado).',
    titleEn: 'Federated Learning',
    year: 2017,
    proposer: 'H. B. McMahan (Google)',
    difficulty: 3,
    reward: 1000,
    status: 'partially_solved',
    summary: 'AI 在你的手机上学习，数据不出本机',
    summaryJa: 'AIはあなたの携帯電話で学習し、データはマシンから出ません',
    summaryEs: 'Sistema de aprendizaje federado: sobrecarga de comunicación <1% de la capacitación centralizada, resistente a la desconexión del cliente (<50% aún se puede capacitar en línea), satisface (ε, δ)-privacidad diferencial (ε ≤ 1, δ ≤ 10⁻⁵), pérdida de precisión del modelo <2% y admite hardware heterogéneo (teléfono móvil/integrado).',
    summaryEn: 'Federated learning system: communication overhead < 1% of centralized training, robust to client disconnection (< 50% can still be trained online), satisfies (ε, δ)-differential privacy (ε ≤ 1, δ ≤ 10⁻⁵), model accuracy loss < 2%, and supports heterogeneous hardware (mobile phone/embedded).',
    kid: '如果你的手机能训练 AI，但数据永远不离开手机呢？联邦学习让很多设备联合训练一个模型，每台设备只贡献模型更新，不贡献数据。',
    formal: '联邦学习系统：通信开销 < 中心化训练 1%、对客户端掉线鲁棒（< 50% 在线仍可训练）、满足 (ε, δ)-差分隐私 (ε ≤ 1, δ ≤ 10⁻⁵)、模型精度损失 < 2%，且支持异构硬件 (手机/嵌入式)。',
    formalJa: 'フェデラルラーニングシステム：集中トレーニングの通信オーバーヘッド< 1 ％、クライアントの切断に対する堅牢性（< 50 ％は依然としてオンラインでトレーニング可能）、満足のいく（ ε、δ ）-微分プライバシー（ ε ≦ 1、δ ≦ 10 ）、モデル精度の損失< 2 ％、および異種ハードウェア（モバイル/組み込み）のサポート。',
    formalEs: 'Sistema de aprendizaje federado: sobrecarga de comunicación <1% de la capacitación centralizada, resistente a la desconexión del cliente (<50% aún se puede capacitar en línea), satisface (ε, δ)-privacidad diferencial (ε ≤ 1, δ ≤ 10⁻⁵), pérdida de precisión del modelo <2% y admite hardware heterogéneo (teléfono móvil/integrado).',
    formalEn: 'Federated learning system: communication overhead < 1% of centralized training, robust to client disconnection (< 50% can still be trained online), satisfies (ε, δ)-differential privacy (ε ≤ 1, δ ≤ 10⁻⁵), model accuracy loss < 2%, and supports heterogeneous hardware (mobile phone/embedded).',
    whyHard: '非独立同分布、通信开销。',
    aiPrompt: '介绍 FedAvg、FedProx、TFF。',
    tags: ['ML', '隐私', '分布式'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Federated Learning',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 Flower 框架跑 FL' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Google Gboard' }]
  },
  {
    id: 'ai-code',
    category: 'cs',
    title: 'AI 写代码',
    titleJa: 'AIコードを書く',
    titleEs: 'La IA puede generar una base de código completa que se puede implementar en producción a partir de los requisitos del lenguaje natural.',
    titleEn: 'AI for Code',
    year: 2021,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'partially_solved',
    summary: 'AI 写完整应用',
    summaryJa: 'AI Writeフルアプリ',
    summaryEs: 'La IA puede generar una base de código completa que se puede implementar en producción a partir de los requisitos del lenguaje natural.',
    summaryEn: 'AI can generate a complete production-deployable code base from natural language requirements.',
    kid: 'Copilot、Cursor、Devin 这样的 AI 工具已经能写代码片段、调试、生成测试。能不能让 AI 从头写一个完整应用？',
    formal: 'AI 能从自然语言需求生成可生产部署的完整代码库。',
    formalJa: 'AIは、自然言語の要件から完全な本番デプロイ可能なコードベースを生成します。',
    formalEs: 'La IA puede generar una base de código completa que se puede implementar en producción a partir de los requisitos del lenguaje natural.',
    formalEn: 'AI can generate a complete production-deployable code base from natural language requirements.',
    whyHard: '复杂需求和长程一致性。',
    aiPrompt: '介绍 Copilot、Cursor、Devin、Claude Code。',
    tags: ['AI', '编程', '工具'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'AI for Code',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 Cursor 写 app' }, { type: 'essay', label: '写文章/论文', desc: '讨论 AI 对程序员的影响' }]
  },
  {
    id: 'ai-math',
    category: 'cs',
    title: 'AI 证明数学',
    titleJa: 'AI証明数学',
    titleEs: 'Los sistemas de inteligencia artificial presentan pruebas o contraejemplos originales para resolver problemas matemáticos abiertos.',
    titleEn: 'AI for Mathematics',
    year: 2024,
    proposer: '—',
    difficulty: 5,
    reward: 5000,
    status: 'partially_solved',
    summary: 'AI 自动证明数学猜想',
    summaryJa: 'AIが自動的に数学的推測を証明',
    summaryEs: 'Los sistemas de inteligencia artificial presentan pruebas o contraejemplos originales para resolver problemas matemáticos abiertos.',
    summaryEn: 'AI systems come up with original proofs or counterexamples to open mathematical problems.',
    kid: '2024 年 DeepMind 的 AlphaProof 在 IMO 拿到银牌。AI 能不能成为数学家的合作者，发现新定理？',
    formal: 'AI 系统对开放数学问题提出原创证明或反例。',
    formalJa: 'AIシステムは、数学的問題を開くためのオリジナルの証明または反例を提示します。',
    formalEs: 'Los sistemas de inteligencia artificial presentan pruebas o contraejemplos originales para resolver problemas matemáticos abiertos.',
    formalEn: 'AI systems come up with original proofs or counterexamples to open mathematical problems.',
    whyHard: '需要深度推理和创造性。',
    aiPrompt: '介绍 Lean、AlphaProof、FunSearch。',
    tags: ['AI', '数学', '证明'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'AI for Math',
    videoChannel: 'Quanta',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 Lean 形式化定理' }, { type: 'essay', label: '写文章/论文', desc: '介绍 IMO 银牌故事' }]
  },
  {
    id: 'self-improve-ai',
    category: 'cs',
    title: '自我改进的 AI',
    titleJa: '自己改善AI',
    titleEs: 'Construya un sistema de IA que mejore sólidamente sus capacidades.',
    titleEn: 'Self-Improving AI',
    year: 2010,
    proposer: '—',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: 'AI 改进自己的代码',
    summaryJa: 'AIが独自のコードを改善',
    summaryEs: 'Construya un sistema de IA que mejore sólidamente sus capacidades.',
    summaryEn: 'Build an AI system that robustly improves its capabilities.',
    kid: '如果 AI 能读自己的代码并优化它，且改进后的 AI 更聪明——它会进入"智能爆炸"。这是 Bostrom 的"递归自我改进"假说。可能导致奇点。',
    formal: '构造一个能稳健地改进自身能力的 AI 系统。',
    formalJa: '着実に能力を向上させるAIシステムを構築する。',
    formalEs: 'Construya un sistema de IA que mejore sólidamente sus capacidades.',
    formalEn: 'Build an AI system that robustly improves its capabilities.',
    whyHard: '递归改进可能失控。',
    aiPrompt: '介绍 AutoML、AutoGPT、Singularity。',
    tags: ['AI', '奇点', '安全'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Self Improving AI',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '讨论奇点' }, { type: 'discuss', label: '想法/讨论', desc: '参与 AI 治理' }, { type: 'fund', label: '资助/投资', desc: '给 AI 安全研究捐资' }]
  },
  {
    id: 'neuromorphic',
    category: 'cs',
    title: '神经形态计算',
    titleJa: 'ニューロモーフィック計算',
    titleEs: 'Chip neuromórfico: relación de eficiencia energética ≥ 10 TOPS/W (precisión INT8), capaz de ejecutar modelos LLM/visión modernos (inferencia Llama-7B) con respuesta en tiempo real (< 100 ms token) y resistencia a la radiación/bajo consumo de energía (< 1 W).',
    titleEn: 'Neuromorphic Computing',
    year: 1980,
    proposer: 'C. Mead',
    difficulty: 4,
    reward: 2000,
    status: 'partially_solved',
    summary: '像大脑一样工作的芯片',
    summaryJa: '脳のように働くチップ',
    summaryEs: 'Chip neuromórfico: relación de eficiencia energética ≥ 10 TOPS/W (precisión INT8), capaz de ejecutar modelos LLM/visión modernos (inferencia Llama-7B) con respuesta en tiempo real (< 100 ms token) y resistencia a la radiación/bajo consumo de energía (< 1 W).',
    summaryEn: 'Neuromorphic chip: energy efficiency ratio ≥ 10 TOPS/W (INT8 accuracy), capable of running modern LLM/vision models (Llama-7B inference) with real-time response (< 100ms token), and radiation resistance/low power consumption (< 1 W).',
    kid: '现在 GPU 跑 AI 很费电（训练 GPT-4 用掉一个核电站一天的电量）。能不能造像大脑一样省电（人脑 20 瓦）的芯片？',
    formal: '神经形态芯片：能效比 ≥ 10 TOPS/W（INT8 精度），能跑现代 LLM/视觉模型 (Llama-7B 推理) 实时响应 (< 100ms token)、且抗辐射/低功耗 (< 1 W)。',
    formalJa: 'ニューロモーフィックチップ：エネルギー効率比≧ 10 TOPS/W （ INT 8精度）、最新のLLM/ビジュアルモデル（ Llama -7 B推論）リアルタイム応答（< 100 msトークン）、および抗放射線/低消費電力（< 1 W ）を実行できます。',
    formalEs: 'Chip neuromórfico: relación de eficiencia energética ≥ 10 TOPS/W (precisión INT8), capaz de ejecutar modelos LLM/visión modernos (inferencia Llama-7B) con respuesta en tiempo real (< 100 ms token) y resistencia a la radiación/bajo consumo de energía (< 1 W).',
    formalEn: 'Neuromorphic chip: energy efficiency ratio ≥ 10 TOPS/W (INT8 accuracy), capable of running modern LLM/vision models (Llama-7B inference) with real-time response (< 100ms token), and radiation resistance/low power consumption (< 1 W).',
    whyHard: '硬件和软件协同设计。',
    aiPrompt: '介绍 Intel Loihi、IBM TrueNorth、SpiNNaker。',
    tags: ['硬件', 'AI', '神经'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Neuromorphic',
    videoChannel: 'Veritasium',
    participate: [{ type: 'experiment', label: '动手实验', desc: 'Loihi 编程' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Mead 工作' }]
  },
  {
    id: 'photonic-compute',
    category: 'cs',
    title: '光子计算',
    titleJa: '光子計算',
    titleEs: 'Sistema de computación fotónica: eficiencia energética ≥ 100 TOPS/W con < 1 % de pérdida de precisión (FP16/INT8), rendimiento ≥ 10x GPU en modelos de clase ResNet-50/BERT, latencia < 1 ms y escalable a ≥ 1024 conjuntos de procesadores ópticos.',
    titleEn: 'Photonic Computing',
    year: 2017,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '用光代替电做 AI 推理',
    summaryJa: '電気ではなく光によるAI推論',
    summaryEs: 'Sistema de computación fotónica: eficiencia energética ≥ 100 TOPS/W con < 1 % de pérdida de precisión (FP16/INT8), rendimiento ≥ 10x GPU en modelos de clase ResNet-50/BERT, latencia < 1 ms y escalable a ≥ 1024 conjuntos de procesadores ópticos.',
    summaryEn: 'Photonic Computing System: Energy efficiency ≥ 100 TOPS/W with < 1% accuracy loss (FP16/INT8), throughput ≥ 10x GPU on ResNet-50/BERT class models, latency < 1 ms, and scalable to ≥ 1024 optical processor arrays.',
    kid: '光子计算用光波代替电信号，速度快、能耗低。Lightmatter、Lightelligence 等公司在做 AI 推理光子芯片。',
    formal: '光子计算系统：能效比 ≥ 100 TOPS/W 且精度损失 < 1% (FP16/INT8)、在 ResNet-50/BERT 类模型上吞吐 ≥ 10x GPU、延迟 < 1 ms，且可扩展到 ≥ 1024 光学处理器阵列。',
    formalJa: 'フォトニックコンピューティングシステム：精度損失< 1 ％ （ FP 16/INT 8 ）、ResNet -50/BERTクラスモデルでのスループット≥ 10 x GPU、レイテンシ< 1ミリ秒、および≥ 1024の光学プロセッサアレイへのスケーラビリティを備えた効率比≥ 100 TOPS/W。',
    formalEs: 'Sistema de computación fotónica: eficiencia energética ≥ 100 TOPS/W con < 1 % de pérdida de precisión (FP16/INT8), rendimiento ≥ 10x GPU en modelos de clase ResNet-50/BERT, latencia < 1 ms y escalable a ≥ 1024 conjuntos de procesadores ópticos.',
    formalEn: 'Photonic Computing System: Energy efficiency ≥ 100 TOPS/W with < 1% accuracy loss (FP16/INT8), throughput ≥ 10x GPU on ResNet-50/BERT class models, latency < 1 ms, and scalable to ≥ 1024 optical processor arrays.',
    whyHard: '模拟计算和数字计算的精度。',
    aiPrompt: '介绍 Lightmatter、Lightelligence。',
    tags: ['硬件', '光子', 'AI'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Photonic Computing',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'experiment', label: '动手实验', desc: '用光子加速器' }, { type: 'essay', label: '写文章/论文', desc: '介绍光学计算历史' }]
  },
  {
    id: '3d-chip',
    category: 'cs',
    title: '3D 堆叠芯片',
    titleJa: '3 Dスタックチップ',
    titleEs: 'Chip apilado 3D: ancho de banda de memoria ≥ 100 TB/s, densidad TSV ≥ 10⁶/cm², densidad térmica ≤ 100 W/cm² (la refrigeración líquida es factible) y pasa 1000 horas de pruebas de confiabilidad sin fallas.',
    titleEn: '3D Stacked Chips',
    year: 2014,
    proposer: 'AMD (HBM)',
    difficulty: 3,
    reward: 1000,
    status: 'partially_solved',
    summary: '垂直堆叠芯片提升性能',
    summaryJa: 'パフォーマンスを向上させるために垂直に積み重ねられたチップ',
    summaryEs: 'Chip apilado 3D: ancho de banda de memoria ≥ 100 TB/s, densidad TSV ≥ 10⁶/cm², densidad térmica ≤ 100 W/cm² (la refrigeración líquida es factible) y pasa 1000 horas de pruebas de confiabilidad sin fallas.',
    summaryEn: '3D stacked chip: memory bandwidth ≥ 100 TB/s, TSV density ≥ 10⁶/cm², thermal density ≤ 100 W/cm² (liquid cooling is feasible), and passes 1000 hours of reliability testing without failure.',
    kid: '现在芯片的瓶颈是数据传输（"内存墙"）。3D 堆叠把内存和计算单元垂直堆在一起，数据传输距离缩短 1000 倍。',
    formal: '3D 堆叠芯片：内存带宽 ≥ 100 TB/s、TSV 密度 ≥ 10⁶/cm²、热密度 ≤ 100 W/cm²（液冷可行）、且通过 1000 小时可靠性测试无失效。',
    formalJa: '3 Dスタックチップ：メモリ帯域幅≥ 100 TB/s、TSV密度≥ 10 ²/ cm ²、熱密度≤ 100 W/cm ²（液体冷却可能）、および1000時間の信頼性テスト後に障害はありません。',
    formalEs: 'Chip apilado 3D: ancho de banda de memoria ≥ 100 TB/s, densidad TSV ≥ 10⁶/cm², densidad térmica ≤ 100 W/cm² (la refrigeración líquida es factible) y pasa 1000 horas de pruebas de confiabilidad sin fallas.',
    formalEn: '3D stacked chip: memory bandwidth ≥ 100 TB/s, TSV density ≥ 10⁶/cm², thermal density ≤ 100 W/cm² (liquid cooling is feasible), and passes 1000 hours of reliability testing without failure.',
    whyHard: '散热和良率。',
    aiPrompt: '介绍 AMD 3D V-Cache、TSMC SoIC。',
    tags: ['硬件', '芯片', '架构'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: '3D Chip',
    videoChannel: 'a16z',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 AMD 3D V-Cache' }, { type: 'experiment', label: '动手实验', desc: '跑性能基准' }]
  },
  {
    id: 'energy-ai',
    category: 'cs',
    title: '能源高效 AI',
    titleJa: 'エネルギー効率の高いAI',
    titleEs: 'Hardware de inferencia/entrenamiento de IA: eficiencia energética ≥ 100 veces SOTA actual (medida por FLOP/J), capaz de ejecutar entrenamiento LLaMA-70B, compatible con pilas de software GPU existentes (PyTorch/TF) y costo por tarjeta <$10,000.',
    titleEn: 'Energy-Efficient AI',
    year: 2023,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '让 AI 训练和推理节能 100 倍',
    summaryJa: 'AIトレーニングと推論を100倍エネルギー効率に',
    summaryEs: 'Hardware de inferencia/entrenamiento de IA: eficiencia energética ≥ 100 veces SOTA actual (medida por FLOP/J), capaz de ejecutar entrenamiento LLaMA-70B, compatible con pilas de software GPU existentes (PyTorch/TF) y costo por tarjeta <$10,000.',
    summaryEn: 'AI training/inference hardware: energy efficiency ≥ 100x current SOTA (measured by FLOP/J), capable of running LLaMA-70B training, compatible with existing GPU software stacks (PyTorch/TF), and cost per card < $10,000.',
    kid: '训练 GPT-4 用了多少电？传闻 50 GWh。如果 AI 持续指数级发展，能源将成为硬约束。需要让 AI 节能 100 倍。',
    formal: 'AI 训练/推理硬件：能效 ≥ 100x 当前 SOTA (按 FLOP/J 测量)、能跑 LLaMA-70B 训练、与现有 GPU 软件栈兼容 (PyTorch/TF)、且单卡成本 < 10000 美元。',
    formalJa: 'AIトレーニング/推論ハードウェア：エネルギー効率≥ 100倍電流SOTA （ FLOP/Jで測定）、LLaMA -70 Bトレーニングを実行可能、既存のGPUソフトウェアスタック（ PyTorch/TF ）と互換性があり、カードあたりのコストは10,000ドル未満。',
    formalEs: 'Hardware de inferencia/entrenamiento de IA: eficiencia energética ≥ 100 veces SOTA actual (medida por FLOP/J), capaz de ejecutar entrenamiento LLaMA-70B, compatible con pilas de software GPU existentes (PyTorch/TF) y costo por tarjeta <$10,000.',
    formalEn: 'AI training/inference hardware: energy efficiency ≥ 100x current SOTA (measured by FLOP/J), capable of running LLaMA-70B training, compatible with existing GPU software stacks (PyTorch/TF), and cost per card < $10,000.',
    whyHard: '架构、算法、硬件协同。',
    aiPrompt: '介绍 MoE、sparsity、量子化。',
    tags: ['AI', '能源', '可持续'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Energy AI',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '模型量化' }, { type: 'essay', label: '写文章/论文', desc: '介绍 AI 能源消耗' }]
  },
  {
    id: 'memory-hard',
    category: 'cs',
    title: 'Memory-Hard 算法',
    titleJa: 'メモリハードアルゴリズム',
    titleEs: 'Diseñe el algoritmo PoW para que la aceleración óptima de ASIC sea <100x.',
    titleEn: 'Memory-Hard Algorithms',
    year: 2009,
    proposer: 'C. Percival',
    difficulty: 3,
    reward: 1000,
    status: 'partially_solved',
    summary: '让密码学对 ASIC 也不划算',
    summaryJa: 'ASICにとって暗号化を費用対効果の高いものにしない',
    summaryEs: 'Diseñe el algoritmo PoW para que la aceleración óptima de ASIC sea <100x.',
    summaryEn: 'Design the PoW algorithm so that the optimal ASIC speedup is < 100x.',
    kid: '比特币挖矿用 ASIC 矿机，速度比普通显卡快 100 万倍。需要设计"memory-hard"的算法（比如 Argon2id、Equihash），让即使有专用硬件也难以规模化。',
    formal: '设计 PoW 算法使最优 ASIC 加速比 < 100x。',
    formalJa: '最適なASIC加速度比が100倍未満になるようにPoWアルゴリズムを設計します。',
    formalEs: 'Diseñe el algoritmo PoW para que la aceleración óptima de ASIC sea <100x.',
    formalEn: 'Design the PoW algorithm so that the optimal ASIC speedup is < 100x.',
    whyHard: '算法 vs 硬件的军备竞赛。',
    aiPrompt: '介绍 Argon2、Equihash、ASIC 抗性。',
    tags: ['密码', '挖矿', '内存'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Memory Hard',
    videoChannel: 'a16z',
    participate: [{ type: 'code', label: '写代码/算法', desc: '实现 Argon2' }, { type: 'essay', label: '写文章/论文', desc: '介绍 PoW 历史' }]
  },
  {
    id: 'post-quantum',
    category: 'cs',
    title: '后量子密码',
    titleJa: 'ポスト量子暗号',
    titleEs: 'Cifrado resistente a cuánticos: longitud de clave ≤ 1 KB, velocidad de cifrado/descifrado ≥ RSA-2048 clásico, seguro contra algoritmos Shor/Grover a 10⁶ qubits (estándar NIST PQC) y admite protocolos existentes (TLS/IKE).',
    titleEn: 'Post-Quantum Cryptography',
    year: 1994,
    proposer: 'P. Shor',
    difficulty: 4,
    reward: 2000,
    status: 'partially_solved',
    summary: '对抗量子计算机的加密',
    summaryJa: '量子コンピュータに対する暗号化',
    summaryEs: 'Cifrado resistente a cuánticos: longitud de clave ≤ 1 KB, velocidad de cifrado/descifrado ≥ RSA-2048 clásico, seguro contra algoritmos Shor/Grover a 10⁶ qubits (estándar NIST PQC) y admite protocolos existentes (TLS/IKE).',
    summaryEn: 'Quantum-resistant encryption: key length ≤ 1 KB, encryption/decryption speed ≥ classic RSA-2048, secure against Shor/Grover algorithms at 10⁶ qubits (NIST PQC standard) and supports existing protocols (TLS/IKE).',
    kid: '量子计算机能破解 RSA、ECC。我们需要新的密码系统能扛住量子攻击。NIST 2024 年刚标准化了 ML-KEM、ML-DSA、SLH-DSA。',
    formal: '抗量子加密：密钥长度 ≤ 1 KB、加密/解密速度 ≥ 经典 RSA-2048、对 Shor/Grover 算法在 10⁶ 量子比特上也安全（NIST PQC 标准）且支持现有协议 (TLS/IKE)。',
    formalJa: '量子暗号化に耐性：キー長≤ 1 KB、暗号化/復号化速度≥古典的なRSA -2048、10キュービット（ NIST PQC標準）のShor/Groverアルゴリズムにも安全で、既存のプロトコル（ TLS/IKE ）をサポートしています。',
    formalEs: 'Cifrado resistente a cuánticos: longitud de clave ≤ 1 KB, velocidad de cifrado/descifrado ≥ RSA-2048 clásico, seguro contra algoritmos Shor/Grover a 10⁶ qubits (estándar NIST PQC) y admite protocolos existentes (TLS/IKE).',
    formalEn: 'Quantum-resistant encryption: key length ≤ 1 KB, encryption/decryption speed ≥ classic RSA-2048, secure against Shor/Grover algorithms at 10⁶ qubits (NIST PQC standard) and supports existing protocols (TLS/IKE).',
    whyHard: '需要新数学、新实现。',
    aiPrompt: '介绍格密码、编码密码、多变量。',
    tags: ['密码', '量子', '安全'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Post Quantum',
    videoChannel: 'a16z',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 liboqs 实现' }, { type: 'essay', label: '写文章/论文', desc: '介绍 NIST PQC 标准化' }]
  },
  {
    id: 'zkp-scale',
    category: 'cs',
    title: '可扩展零知识证明',
    titleJa: '拡張可能なゼロ知識証明',
    titleEs: 'Sistema de prueba de conocimiento cero: generación de prueba ≥ 10⁶ pruebas/segundo (servidor único), tamaño de prueba ≤ 1 KB (las constantes no crecen con el tamaño del circuito), tiempo de verificación ≤ 1 ms y compatible con circuitos aritméticos (≥ 2²⁰ puertas).',
    titleEn: 'Scalable ZKP',
    year: 2013,
    proposer: 'E. Ben-Sasson et al. (zk-SNARK)',
    difficulty: 4,
    reward: 2000,
    status: 'partially_solved',
    summary: '证明"我知道"而不暴露"我知道什么"',
    summaryJa: '「知っていること」を暴露せずに「知っている」ことを証明する',
    summaryEs: 'Sistema de prueba de conocimiento cero: generación de prueba ≥ 10⁶ pruebas/segundo (servidor único), tamaño de prueba ≤ 1 KB (las constantes no crecen con el tamaño del circuito), tiempo de verificación ≤ 1 ms y compatible con circuitos aritméticos (≥ 2²⁰ puertas).',
    summaryEn: 'Zero-knowledge proof system: proof generation ≥ 10⁶ proofs/second (single server), proof size ≤ 1 KB (constants do not grow with circuit size), verification time ≤ 1 ms, and friendly to arithmetic circuits (≥ 2²⁰ gates).',
    kid: '零知识证明让一方能向另一方证明"我知道密码"但不暴露密码本身。能不能让 ZKP 足够快、可大规模部署？',
    formal: '零知识证明系统：证明生成 ≥ 10⁶ 证明/秒 (单服务器)、证明大小 ≤ 1 KB (常数不随电路大小增长)、验证时间 ≤ 1 ms、且对算术电路 (≥ 2²⁰ gates) 友好。',
    formalJa: 'ゼロ知識証明システム：証明生成≥ 10 ²プルーフ/秒（単一サーバー）、証明サイズ≤ 1 KB （定数は回路サイズとともに増加しません）、検証時間≤ 1ミリ秒、算術回路に優しい（≥ 2 ² ²ゲート）。',
    formalEs: 'Sistema de prueba de conocimiento cero: generación de prueba ≥ 10⁶ pruebas/segundo (servidor único), tamaño de prueba ≤ 1 KB (las constantes no crecen con el tamaño del circuito), tiempo de verificación ≤ 1 ms y compatible con circuitos aritméticos (≥ 2²⁰ puertas).',
    formalEn: 'Zero-knowledge proof system: proof generation ≥ 10⁶ proofs/second (single server), proof size ≤ 1 KB (constants do not grow with circuit size), verification time ≤ 1 ms, and friendly to arithmetic circuits (≥ 2²⁰ gates).',
    whyHard: '计算开销。',
    aiPrompt: '介绍 zk-SNARK、zk-STARK、PLONK。',
    tags: ['密码', '零知识', '扩容'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'ZKP',
    videoChannel: 'a16z',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 circom 写电路' }, { type: 'essay', label: '写文章/论文', desc: '介绍 ZK 历史' }]
  },
  {
    id: 'decentralized-id',
    category: 'cs',
    title: '去中心化身份',
    titleJa: '分散型アイデンティティ',
    titleEs: 'Control total del usuario, protección de la privacidad y sistema de identidad verificable.',
    titleEn: 'Decentralized Identity',
    year: 2017,
    proposer: '—',
    difficulty: 3,
    reward: 1000,
    status: 'open',
    summary: '让你真正拥有自己的身份',
    summaryJa: 'あなたを真のあなたにする',
    summaryEs: 'Control total del usuario, protección de la privacidad y sistema de identidad verificable.',
    summaryEn: 'Full user control, privacy protection, and verifiable identity system.',
    kid: '现在你的身份被 Google、Apple、Facebook 控制。能不能用密码学让身份真正属于你？',
    formal: '用户完全控制、隐私保护、可验证的身份系统。',
    formalJa: '完全なユーザーコントロール、プライバシー保護、検証可能なIDシステム。',
    formalEs: 'Control total del usuario, protección de la privacidad y sistema de identidad verificable.',
    formalEn: 'Full user control, privacy protection, and verifiable identity system.',
    whyHard: '密钥管理和恢复。',
    aiPrompt: '介绍 DID、Verifiable Credentials、Spruce。',
    tags: ['密码', '身份', '隐私'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Decentralized ID',
    videoChannel: 'a16z',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 DID 协议' }, { type: 'essay', label: '写文章/论文', desc: '介绍自我主权身份' }]
  },
  {
    id: 'ai-for-science',
    category: 'cs',
    title: 'AI for Science',
    titleJa: '科学のためのAI',
    titleEs: 'La IA hace descubrimientos de nivel Nobel en más de 10 disciplinas.',
    titleEn: 'AI for Science',
    year: 2020,
    proposer: '—',
    difficulty: 4,
    reward: 3000,
    status: 'partially_solved',
    summary: 'AI 加速科学发现',
    summaryJa: 'AIが科学的発見を加速',
    summaryEs: 'La IA hace descubrimientos de nivel Nobel en más de 10 disciplinas.',
    summaryEn: 'AI makes Nobel-level discoveries in >10 disciplines.',
    kid: 'AlphaFold 解决了蛋白质折叠；GNoME 发现了 220 万种新晶体；AI 正在改变科学。能否让 AI 成为科学家的"加速器"？',
    formal: 'AI 在 > 10 个学科做出诺贝尔级发现。',
    formalJa: 'AIは、10以上の分野でノーベルレベルの発見を行います。',
    formalEs: 'La IA hace descubrimientos de nivel Nobel en más de 10 disciplinas.',
    formalEn: 'AI makes Nobel-level discoveries in >10 disciplines.',
    whyHard: '需要可解释性和验证。',
    aiPrompt: '介绍 AlphaFold、GNoME、FunSearch。',
    tags: ['AI', '科学', '加速'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'AI for Science',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'code', label: '写代码/算法', desc: '跑 AlphaFold' }, { type: 'essay', label: '写文章/论文', desc: '介绍 AI 改变科研' }]
  },
  {
    id: 'explainable-ai',
    category: 'cs',
    title: '可解释 AI',
    titleJa: '解釈可能なAI',
    titleEs: 'Brinde explicaciones fieles, comprensibles y verificables de las decisiones de la IA.',
    titleEn: 'Explainable AI (XAI)',
    year: 2017,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '让 AI 解释自己的决定',
    summaryJa: 'AIに決定を説明させる',
    summaryEs: 'Brinde explicaciones fieles, comprensibles y verificables de las decisiones de la IA.',
    summaryEn: 'Give faithful, understandable, and verifiable explanations of AI decisions.',
    kid: '深度学习是黑盒——它说"这张图是猫"，但不知道为什么。如果 AI 拒绝给你贷款、推荐治疗，法官和医生需要知道为什么。',
    formal: '对 AI 决策给出忠实、可理解、可验证的解释。',
    formalJa: 'AIの意思決定に忠実で、理解しやすく、検証可能な説明を提供します。',
    formalEs: 'Brinde explicaciones fieles, comprensibles y verificables de las decisiones de la IA.',
    formalEn: 'Give faithful, understandable, and verifiable explanations of AI decisions.',
    whyHard: '深度模型本身就不可解释。',
    aiPrompt: '介绍 SHAP、LIME、Attention。',
    tags: ['AI', 'XAI', '伦理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Explainable AI',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 SHAP 分析模型' }, { type: 'essay', label: '写文章/论文', desc: '介绍 XAI 历史' }]
  },
  {
    id: 'causal-ai',
    category: 'cs',
    title: '因果 AI',
    titleJa: '因果AI',
    titleEs: 'Los sistemas de inteligencia artificial pueden responder "¿qué pasa si sucede algo?" y "¿por qué?".',
    titleEn: 'Causal AI',
    year: 2009,
    proposer: 'J. Pearl',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: 'AI 学会"为什么"',
    summaryJa: 'AIが「なぜ」を学ぶ',
    summaryEs: 'Los sistemas de inteligencia artificial pueden responder "¿qué pasa si sucede algo?" y "¿por qué?".',
    summaryEn: 'AI systems can answer "what if A happens" and "why".',
    kid: '现在的 AI 只能学关联（"冰淇淋销量高时溺水多"），不能学因果（"其实是夏天"）。Judea Pearl 提出因果阶梯，让 AI 真正能推理因果。',
    formal: 'AI 系统能回答"如果 A 发生会怎样"和"为什么"。',
    formalJa: 'AIシステムは、「Aが発生した場合はどうなりますか」と「なぜ」と答えることができます。',
    formalEs: 'Los sistemas de inteligencia artificial pueden responder "¿qué pasa si sucede algo?" y "¿por qué?".',
    formalEn: 'AI systems can answer "what if A happens" and "why".',
    whyHard: '因果结构从数据中学习。',
    aiPrompt: '介绍 Pearl 的"因果阶梯"。',
    tags: ['AI', '因果', '推理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Causal AI',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 DoWhy 库' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Pearl 工作' }]
  },
  {
    id: 'consciousness',
    category: 'philosophy',
    title: '意识的难问题',
    titleJa: '意識障害',
    titleEs: 'Explicar por qué los procesos físicos producen experiencias subjetivas (qualia).',
    titleEn: 'Hard Problem of Consciousness',
    year: 1995,
    proposer: 'D. Chalmers',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '为什么会有"感受"？',
    summaryJa: 'なぜ「感じる」のか？',
    summaryEs: 'Explicar por qué los procesos físicos producen experiencias subjetivas (qualia).',
    summaryEn: 'Explain why physical processes produce subjective experiences (qualia).',
    kid: '你看到红色、闻到咖啡香、感到疼痛——这些"主观感受"是怎么从一堆原子和电信号里冒出来的？为什么不是像机器人一样"处理信息"而没有"感觉"？哲学家 David Chalmers 把这叫"难问题"。',
    formal: '解释为什么物理过程产生主观体验（qualia）。',
    formalJa: '物理的プロセスがクオリアを生み出す理由を説明する。',
    formalEs: 'Explicar por qué los procesos físicos producen experiencias subjetivas (qualia).',
    formalEn: 'Explain why physical processes produce subjective experiences (qualia).',
    whyHard: '可能永远无法从第三人称描述还原第一人称体验。',
    aiPrompt: '讨论功能主义、IIT、GWT、泛心论。',
    tags: ['心灵', '哲学', 'qualia'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Hard Problem of Consciousness',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写一篇哲学论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与意识研究' }, { type: 'teach', label: '教学/讲解', desc: '给哲学学生讲' }]
  },
  {
    id: 'free-will',
    category: 'philosophy',
    title: '自由意志',
    titleJa: '自由意志',
    titleEs: '¿Es el libre albedrío compatible con el determinismo físico/indeterminación cuántica?',
    titleEn: 'Free Will',
    year: -350,
    proposer: '亚里士多德 / B. Spinoza',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '你能"选择"吗？',
    summaryJa: '「選ぶ」ことはできますか？',
    summaryEs: '¿Es el libre albedrío compatible con el determinismo físico/indeterminación cuántica?',
    summaryEn: 'Is free will compatible with physical determinism/quantum indeterminacy?',
    kid: '你以为是"你"决定吃冰淇淋还是苹果。但每个神经元的放电都遵循物理定律。如果宇宙的初始状态定好了，所有未来就定好了。这是决定论。那"你"在做什么？',
    formal: '自由意志与物理决定论/量子不确定性是否相容？',
    formalJa: '自由意志は物理的決定論/量子不確実性と互換性がありますか？',
    formalEs: '¿Es el libre albedrío compatible con el determinismo físico/indeterminación cuántica?',
    formalEn: 'Is free will compatible with physical determinism/quantum indeterminacy?',
    whyHard: '物理学似乎不支持非因果。',
    aiPrompt: '介绍 compatibilism、libertarianism、hard determinism。',
    tags: ['哲学', '心灵', '伦理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Free Will',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写哲学论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与辩论' }, { type: 'teach', label: '教学/讲解', desc: '给哲学系学生讲' }]
  },
  {
    id: 'meaning-of-life',
    category: 'philosophy',
    title: '生命的意义',
    titleJa: '人生の意味',
    titleEs: '¿Se puede definir razonablemente el significado de la vida desde una perspectiva objetiva o subjetiva?',
    titleEn: 'Meaning of Life',
    year: -500,
    proposer: '孔子 / 佛陀 / 萨特',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '我为什么活着？',
    summaryJa: 'なぜ私は生きているのか？',
    summaryEs: '¿Se puede definir razonablemente el significado de la vida desde una perspectiva objetiva o subjetiva?',
    summaryEn: 'Can the meaning of life be reasonably defined from an objective or subjective perspective?',
    kid: '宇宙在不在意我们呢？大概不在意。但我们能不能自己"造"出意义？很多大哲学家（孔子、佛陀、萨特、维特根斯坦）都想过这个问题。',
    formal: '生命的意义是否能从客观或主观角度被合理定义？',
    formalJa: '人生の意味は、客観的または主観的な観点から合理的に定義されていますか？',
    formalEs: '¿Se puede definir razonablemente el significado de la vida desde una perspectiva objetiva o subjetiva?',
    formalEn: 'Can the meaning of life be reasonably defined from an objective or subjective perspective?',
    whyHard: '意义似乎是主观的，但又希望是客观的。',
    aiPrompt: '比较存在主义、佛教、儒家、虚无主义。',
    tags: ['哲学', '意义', '存在'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Meaning of Life',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写你自己的看法' }, { type: 'discuss', label: '想法/讨论', desc: '在论坛讨论' }, { type: 'teach', label: '教学/讲解', desc: '教给中学生' }]
  },
  {
    id: 'moral-objectivity',
    category: 'philosophy',
    title: '道德客观性',
    titleJa: '道徳的客観性',
    titleEs: 'Si los hechos morales son objetivos, hay convergencia de juicios morales entre culturas y épocas; operacionalización: (a) medir el acuerdo de intuición moral r ≥ 0,8 en N ≥ 30 culturas, ≥ 100 dilemas morales (Trolley/Footbridge, etc.); (b) diseñar contrafactuales: predecir que el desacuerdo aumentará si la moralidad no es objetiva: verificación empírica (acuerdo transcultural de resonancia magnética funcional).',
    titleEn: 'Moral Objectivity',
    year: -400,
    proposer: '苏格拉底 / 柏拉图',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '道德是真实的还是人定的？',
    summaryJa: '道徳は本物ですか、それとも決まっていますか？',
    summaryEs: 'Si los hechos morales son objetivos, hay convergencia de juicios morales entre culturas y épocas; operacionalización: (a) medir el acuerdo de intuición moral r ≥ 0,8 en N ≥ 30 culturas, ≥ 100 dilemas morales (Trolley/Footbridge, etc.); (b) diseñar contrafactuales: predecir que el desacuerdo aumentará si la moralidad no es objetiva: verificación empírica (acuerdo transcultural de resonancia magnética funcional).',
    summaryEn: 'If moral facts are objective, there is convergence of moral judgments across cultures and times; operationalization: (a) measure moral intuition agreement r ≥ 0.8 on N ≥ 30 cultures, ≥ 100 moral dilemmas (Trolley/Footbridge, etc.); (b) design counterfactuals: predict disagreement to rise if morality is non-objective - empirical verification (cross-cultural fMRI agreement).',
    kid: '你说"杀人是错的"。但凭什么？这是真实的"事实"，还是人类的"约定"？哲学家们吵了 2500 年。',
    formal: '若道德事实是客观的，则存在跨文化、跨时代的道德判断会聚；操作性化：(a) 在 N≥30 文化、≥100 道德困境 (Trolley/Footbridge 等) 上测量道德直觉一致度 r ≥ 0.8；(b) 设计反事实：如果道德非客观，预测分歧度会上升 — 实证验证 (跨文化 fMRI 一致性)。',
    formalJa: '道徳的事実が客観的である場合、文化や時代を超えた倫理的判断の収束があります。運用化： （ a ） N ≥ 30の文化、≥ 100の道徳的ジレンマで道徳的直観の一貫性r ≥ 0.8を測定する（ Trolley/Footbridgeら）。（ b ）反事実を設計する：道徳が客観的でない場合、予測的発散が上昇する—経験的検証（異文化fMRI一貫性）。',
    formalEs: 'Si los hechos morales son objetivos, hay convergencia de juicios morales entre culturas y épocas; operacionalización: (a) medir el acuerdo de intuición moral r ≥ 0,8 en N ≥ 30 culturas, ≥ 100 dilemas morales (Trolley/Footbridge, etc.); (b) diseñar contrafactuales: predecir que el desacuerdo aumentará si la moralidad no es objetiva: verificación empírica (acuerdo transcultural de resonancia magnética funcional).',
    formalEn: 'If moral facts are objective, there is convergence of moral judgments across cultures and times; operationalization: (a) measure moral intuition agreement r ≥ 0.8 on N ≥ 30 cultures, ≥ 100 moral dilemmas (Trolley/Footbridge, etc.); (b) design counterfactuals: predict disagreement to rise if morality is non-objective - empirical verification (cross-cultural fMRI agreement).',
    whyHard: '自然主义谬误、is-ought 问题。',
    aiPrompt: '介绍元伦理学三大流派。',
    tags: ['伦理', '哲学', 'meta'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Moral Objectivity',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写元伦理论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与道德辩论' }]
  },
  {
    id: 'zombie-thought',
    category: 'philosophy',
    title: '哲学僵尸',
    titleJa: '哲学ゾンビ',
    titleEs: 'Si los zombis filosóficos son conceptualmente posibles, existe una brecha explicativa entre el fisicalismo y la conciencia fenoménica (qualia); operacionalización: (a) dar un criterio falsificable de "equivalencia observable pero los fenómenos no son equivalentes", (b) diseñar la verificación experimental de equivalencia en el sistema de IA (agente LLM/RL).',
    titleEn: 'Philosophical Zombies',
    year: 1974,
    proposer: 'R. Kirk',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '有没有"没有意识"的人？',
    summaryJa: '「意識不明」の人はいますか？',
    summaryEs: 'Si los zombis filosóficos son conceptualmente posibles, existe una brecha explicativa entre el fisicalismo y la conciencia fenoménica (qualia); operacionalización: (a) dar un criterio falsificable de "equivalencia observable pero los fenómenos no son equivalentes", (b) diseñar la verificación experimental de equivalencia en el sistema de IA (agente LLM/RL).',
    summaryEn: 'If philosophical zombies are conceptually possible, there is an explanatory gap between physicalism and phenomenal consciousness (qualia); operationalization: (a) give a falsifiable criterion of "observable equivalence but phenomena are not equivalent", (b) design equivalence experimental verification on the AI ​​system (LLM/RL agent).',
    kid: '有没有一种"僵尸"——长得和你一模一样，会说话会笑会哭，但里面是空的，没有任何"感受"？如果可能，那意识就不是物理可以解释的。',
    formal: '如果哲学僵尸在概念上可能，则物理主义 (physicalism) 与现象意识 (qualia) 存在解释鸿沟；操作化：(a) 给出「可观测等价但现象不等同」的可证伪判据，(b) 在 AI 系统 (LLM/RL agent) 上设计等价实验验证。',
    formalJa: '哲学的ゾンビが概念的に可能である場合、物理主義と現象意識（クオリア）の間に説明のギャップがあります。運用： （ a ）「観察可能な等価性があるが同じ現象ではない」という反証可能な基準を与え、（ b ） AIシステム（ LLM/RLエージェント）で等価な実験検証を設計する。',
    formalEs: 'Si los zombis filosóficos son conceptualmente posibles, existe una brecha explicativa entre el fisicalismo y la conciencia fenoménica (qualia); operacionalización: (a) dar un criterio falsificable de "equivalencia observable pero los fenómenos no son equivalentes", (b) diseñar la verificación experimental de equivalencia en el sistema de IA (agente LLM/RL).',
    formalEn: 'If philosophical zombies are conceptually possible, there is an explanatory gap between physicalism and phenomenal consciousness (qualia); operationalization: (a) give a falsifiable criterion of "observable equivalence but phenomena are not equivalent", (b) design equivalence experimental verification on the AI ​​system (LLM/RL agent).',
    whyHard: '意识是否是必要的还是偶然的。',
    aiPrompt: '介绍 Chalmers 的僵尸论证。',
    tags: ['心灵', '哲学', 'qualia'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Zombies',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写一篇反驳或支持' }, { type: 'discuss', label: '想法/讨论', desc: '参与心灵哲学讨论' }]
  },
  {
    id: 'simulation-arg',
    category: 'philosophy',
    title: '模拟论证',
    titleJa: 'シミュレーションデモンストレーション',
    titleEs: 'Una de tres posibilidades debe ser cierta: (1) la humanidad muere antes de extinguirse; (2) las civilizaciones avanzadas no están interesadas en hacer simulaciones; (3) lo más probable es que estemos en una simulación.',
    titleEn: 'Simulation Argument',
    year: 2003,
    proposer: 'N. Bostrom',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '我们是被模拟出来的吗？',
    summaryJa: '私たちはシミュレーションされていましたか？',
    summaryEs: 'Una de tres posibilidades debe ser cierta: (1) la humanidad muere antes de extinguirse; (2) las civilizaciones avanzadas no están interesadas en hacer simulaciones; (3) lo más probable es que estemos en una simulación.',
    summaryEn: 'One of three possibilities must be true: (1) humanity dies before extinction; (2) advanced civilizations are not interested in doing simulations; (3) we are most likely in a simulation.',
    kid: '玩过电子游戏吗？游戏里的角色不知道自己是"游戏里的"。如果未来人类能做出包含意识的模拟，那我们很可能就是"被模拟出来的"。',
    formal: '三种可能性之一必须为真：(1) 人类灭绝前灭亡；(2) 高级文明不感兴趣做模拟；(3) 我们极可能在模拟中。',
    formalJa: '（ 1 ）人類滅亡前、（ 2 ）高度な文明はシミュレーションを行うことに興味がない、（ 3 ）私たちはシミュレーションに最も関心がある、という3つの可能性のうちの1つが真実でなければなりません。',
    formalEs: 'Una de tres posibilidades debe ser cierta: (1) la humanidad muere antes de extinguirse; (2) las civilizaciones avanzadas no están interesadas en hacer simulaciones; (3) lo más probable es que estemos en una simulación.',
    formalEn: 'One of three possibilities must be true: (1) humanity dies before extinction; (2) advanced civilizations are not interested in doing simulations; (3) we are most likely in a simulation.',
    whyHard: '没有可证伪性。',
    aiPrompt: '介绍 Bostrom 三难推理。',
    tags: ['形而上', '哲学', '模拟'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Simulation Argument',
    videoChannel: 'Lex Fridman',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写反驳或支持论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与模拟假设讨论' }]
  },
  {
    id: 'personal-identity',
    category: 'philosophy',
    title: '人格同一性',
    titleJa: 'パーソナリティアイデンティティ',
    titleEs: '¿La naturaleza de la identidad personal es física, psicológica o algo más profundo?',
    titleEn: 'Personal Identity',
    year: 1690,
    proposer: 'J. Locke',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '"你"真的是"你"吗？',
    summaryJa: '「あなた」は本当に「あなた」ですか？',
    summaryEs: '¿La naturaleza de la identidad personal es física, psicológica o algo más profundo?',
    summaryEn: 'Is the nature of personal identity physical, psychological, or something deeper?',
    kid: '早上醒来的你和昨晚睡前的你，是同一个人吗？克隆一个一模一样的你，他是你吗？把你传送到火星上死了再复制一个，那"你"还活着吗？',
    formal: '人格同一性的本质是身体、心理、还是某种更深的东西？',
    formalJa: '人格アイデンティティの本質は、身体的、精神的、またはより深いものですか？',
    formalEs: '¿La naturaleza de la identidad personal es física, psicológica o algo más profundo?',
    formalEn: 'Is the nature of personal identity physical, psychological, or something deeper?',
    whyHard: '涉及时间、物质、意识的根本。',
    aiPrompt: '介绍洛克、帕菲特、动物主义。',
    tags: ['心灵', '哲学', '形而上'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Personal Identity',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写哲学论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与心灵哲学讨论' }]
  },
  {
    id: 'knowledge-epistemology',
    category: 'philosophy',
    title: '知识论',
    titleJa: '知識の理論',
    titleEs: '¿Cuál es la naturaleza del conocimiento? ¿Es suficiente creencia + verdad + justificación (creencia verdadera justificada)?',
    titleEn: 'Epistemology (Theory of Knowledge)',
    year: -350,
    proposer: '柏拉图',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '我们真的能"知道"什么？',
    summaryJa: '私たちは本当に何を「知る」ことができますか？',
    summaryEs: '¿Cuál es la naturaleza del conocimiento? ¿Es suficiente creencia + verdad + justificación (creencia verdadera justificada)?',
    summaryEn: 'What is the nature of knowledge? Is belief + truth + justification (justified true belief) enough?',
    kid: '你看到桌上有个红苹果——你"知道"它在吗？怎么"知道"的？也许你正在做梦？也许你是缸中之脑？也许你的"红"和别人看到的"红"不一样？',
    formal: '知识的本质是什么？信念 + 真理 + 辩护（justified true belief）够吗？',
    formalJa: '知識の性質は何ですか？信念+真理+正当化された真の信念で十分ですか？',
    formalEs: '¿Cuál es la naturaleza del conocimiento? ¿Es suficiente creencia + verdad + justificación (creencia verdadera justificada)?',
    formalEn: 'What is the nature of knowledge? Is belief + truth + justification (justified true belief) enough?',
    whyHard: 'Gettier 案例揭示传统定义不完备。',
    aiPrompt: '介绍 Gettier、可靠主义、外部主义。',
    tags: ['哲学', '认识', 'Gettier'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Epistemology',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写认识论论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与哲学论坛' }]
  },
  {
    id: 'truth',
    category: 'philosophy',
    title: '真理的本质',
    titleJa: '真実の本質',
    titleEs: 'Si la verdad tiene una esencia unificada (la de la teoría de la correspondencia/teoría de la coherencia/pragmatismo), entonces todas las teorías de la verdad razonables deben poder explicar: (a) la verdad matemática (completitud de Gödel), (b) la verdad científica empírica (Quine-Duhem), (c) la verdad normativa (ética/estética); dar un esquema formal unificado falsificable (como la jerarquía de Tarski + incrustación pragmática).',
    titleEn: 'Nature of Truth',
    year: -300,
    proposer: '亚里士多德',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '什么是真的？',
    summaryJa: '何が真実ですか？',
    summaryEs: 'Si la verdad tiene una esencia unificada (la de la teoría de la correspondencia/teoría de la coherencia/pragmatismo), entonces todas las teorías de la verdad razonables deben poder explicar: (a) la verdad matemática (completitud de Gödel), (b) la verdad científica empírica (Quine-Duhem), (c) la verdad normativa (ética/estética); dar un esquema formal unificado falsificable (como la jerarquía de Tarski + incrustación pragmática).',
    summaryEn: 'If truth has a unified essence (one of correspondence theory/coherence theory/pragmatism), then all reasonable truth theories must be able to explain: (a) mathematical truth (Gödel completeness), (b) empirical scientific truth (Quine-Duhem), (c) normative truth (ethics/aesthetics); give a falsifiable unified formal scheme (such as Tarski hierarchy + pragmatic embedding).',
    kid: '"雪是白的"是真的，因为雪确实是白的——这种"对应理论"显然。但"2+2=4"也是真的，难道数学对象"在"某个地方？逻辑真理、道德真理、美学真理各自是哪种？',
    formal: '若真理有统一本质（对应论/融贯论/实用论之一），则所有合理真理理论须能解释：(a) 数学真理 (Gödel 完备性)、(b) 经验科学真理 (Quine-Duhem)、(c) 规范性真理 (伦理学/美学)；给出可证伪的统一形式化方案（如 Tarski 层级 + 实用嵌入）。',
    formalJa: '真理が統一された性質（対応/コヒーレンス/プラグマティズムの1つ）を持つ場合、すべての合理的真理理論は、（ a ）数学的真理（ゲーデル完全性）、（ b ）経験的科学的真理（ Quine - Duhem ）、（ c ）規範的真理（倫理/美学）を説明できる必要があります。反証可能な統一された形式的スキーム（タルスキ階層+実用的埋め込みなど）を与える。',
    formalEs: 'Si la verdad tiene una esencia unificada (la de la teoría de la correspondencia/teoría de la coherencia/pragmatismo), entonces todas las teorías de la verdad razonables deben poder explicar: (a) la verdad matemática (completitud de Gödel), (b) la verdad científica empírica (Quine-Duhem), (c) la verdad normativa (ética/estética); dar un esquema formal unificado falsificable (como la jerarquía de Tarski + incrustación pragmática).',
    formalEn: 'If truth has a unified essence (one of correspondence theory/coherence theory/pragmatism), then all reasonable truth theories must be able to explain: (a) mathematical truth (Gödel completeness), (b) empirical scientific truth (Quine-Duhem), (c) normative truth (ethics/aesthetics); give a falsifiable unified formal scheme (such as Tarski hierarchy + pragmatic embedding).',
    whyHard: '候选理论都有反例。',
    aiPrompt: '介绍对应论、一致论、实用主义、紧缩论。',
    tags: ['形而上', '逻辑', '哲学'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Truth',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写一篇真理理论论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与形而上学讨论' }]
  },
  {
    id: 'beauty',
    category: 'philosophy',
    title: '美的本质',
    titleJa: '美しさの本質',
    titleEs: 'Si la belleza tiene características objetivas, entonces los juicios estéticos transculturales deberían tener una coherencia no trivial; operacionalización: estadísticas (a) puntuación Pearson r ≥ 0,6, (b) similitud del patrón de resonancia magnética funcional neuroestética ≥ 70% (independiente de la cultura) en N ≥ 30 culturas, ≥ 100 objetos visuales/musicales/matemáticos.',
    titleEn: 'Nature of Beauty',
    year: -350,
    proposer: '柏拉图',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '美是客观的还是主观的？',
    summaryJa: '美しさは客観的ですか、それとも主観的ですか？',
    summaryEs: 'Si la belleza tiene características objetivas, entonces los juicios estéticos transculturales deberían tener una coherencia no trivial; operacionalización: estadísticas (a) puntuación Pearson r ≥ 0,6, (b) similitud del patrón de resonancia magnética funcional neuroestética ≥ 70% (independiente de la cultura) en N ≥ 30 culturas, ≥ 100 objetos visuales/musicales/matemáticos.',
    summaryEn: 'If beauty has objective characteristics, then cross-cultural aesthetic judgments should have non-trivial consistency; operationalization: statistics (a) score Pearson r ≥ 0.6, (b) neuroaesthetic fMRI pattern similarity ≥ 70% (independent of culture) on N ≥ 30 cultures, ≥ 100 visual/musical/mathematical objects.',
    kid: '为什么人们觉得日落、贝多芬、公式 E=mc² 都很美？美是客观存在的（柏拉图）还是人类大脑的产物（休谟）？还是两者都不是？',
    formal: '若美有客观特征，则跨文化的审美判断应有非平凡一致性；操作化：在 N≥30 文化、≥100 视觉/音乐/数学对象上，统计 (a) 评分 Pearson r ≥ 0.6，(b) 神经美学 fMRI 模式相似度 ≥ 70%（独立于文化）。',
    formalJa: '美の客観的な特徴がある場合、異文化間の審美的判断に自明ではない一貫性があるはずです。運用： N ≥ 30文化、≥ 100視覚的/音楽的/数学的オブジェクト、統計（ a ）スコアピアソンr ≥ 0.6、（ b ）神経審美的fMRIモデル類似性≥ 70 ％ （文化とは無関係）。',
    formalEs: 'Si la belleza tiene características objetivas, entonces los juicios estéticos transculturales deberían tener una coherencia no trivial; operacionalización: estadísticas (a) puntuación Pearson r ≥ 0,6, (b) similitud del patrón de resonancia magnética funcional neuroestética ≥ 70% (independiente de la cultura) en N ≥ 30 culturas, ≥ 100 objetos visuales/musicales/matemáticos.',
    formalEn: 'If beauty has objective characteristics, then cross-cultural aesthetic judgments should have non-trivial consistency; operationalization: statistics (a) score Pearson r ≥ 0.6, (b) neuroaesthetic fMRI pattern similarity ≥ 70% (independent of culture) on N ≥ 30 cultures, ≥ 100 visual/musical/mathematical objects.',
    whyHard: '跨文化差异 vs 普遍倾向。',
    aiPrompt: '介绍柏拉图、休谟、Kant 的美学。',
    tags: ['美学', '哲学', '主观'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Beauty',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写美学论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与美学讨论' }]
  },
  {
    id: 'time-philosophy',
    category: 'philosophy',
    title: '时间的本质',
    titleJa: '時間の性質',
    titleEs: '¿Es la serie temporal A (presente dinámico) o la serie B (secuencia estática de eventos)?',
    titleEn: 'Nature of Time',
    year: -400,
    proposer: 'Parmenides / Zeno',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '时间是真实流动的吗？',
    summaryJa: '時間は本当に流れているのでしょうか？',
    summaryEs: '¿Es la serie temporal A (presente dinámico) o la serie B (secuencia estática de eventos)?',
    summaryEn: 'Is time series A (dynamic present) or series B (static sequence of events)?',
    kid: '物理学说时间是一个维度（和空间一样）。但你感受到的"现在"是特殊的。哲学家 McTaggart 说时间是虚幻的——如果是这样，为什么我们感觉它在流？',
    formal: '时间是 A 系列（动态现在）还是 B 系列（静态事件序列）？',
    formalJa: '時系列A （ Dynamic Now ）またはB （ Static Event Sequence ）ですか？',
    formalEs: '¿Es la serie temporal A (presente dinámico) o la serie B (secuencia estática de eventos)?',
    formalEn: 'Is time series A (dynamic present) or series B (static sequence of events)?',
    whyHard: 'A 系列被许多物理学家认为不真实。',
    aiPrompt: '介绍 McTaggart、Presentism、Eternalism。',
    tags: ['形而上', '时间', '哲学'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Time',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写时间哲学论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与形而上学讨论' }]
  },
  {
    id: 'death-philosophy',
    category: 'philosophy',
    title: '死亡哲学',
    titleJa: '死の哲学',
    titleEs: 'Si la muerte es algo malo, entonces: (a) la tesis de Epicuro (no hay experiencia después de la muerte) significa que la muerte no es intrínsecamente mala; (b) operacionalización: la correlación entre la medición de la evaluación de las personas sobre su propia muerte (escala de descuento de tiempo/existencialismo) y el indicador objetivo de muerte (AVAD) es r ≥ 0,7.',
    titleEn: 'Philosophy of Death',
    year: -350,
    proposer: '柏拉图 / 伊壁鸠鲁',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '死亡是坏事吗？',
    summaryJa: '死は悪いことなのか？',
    summaryEs: 'Si la muerte es algo malo, entonces: (a) la tesis de Epicuro (no hay experiencia después de la muerte) significa que la muerte no es intrínsecamente mala; (b) operacionalización: la correlación entre la medición de la evaluación de las personas sobre su propia muerte (escala de descuento de tiempo/existencialismo) y el indicador objetivo de muerte (AVAD) es r ≥ 0,7.',
    summaryEn: 'If death is a bad thing, then: (a) the Epicurus thesis (no experience after death) means that death is not intrinsically evil; (b) operationalization: the correlation between measuring people\'s evaluation of their own death (time discounting/existentialism scale) and the objective death indicator (DALY) is r ≥ 0.7.',
    kid: '伊壁鸠鲁说："死亡与我无关——因为我死后就不在了。"听起来像诡辩。但人们为什么怕死？怕的是"不存在"本身，还是"失去现在的自己"？',
    formal: '若死亡是坏事，则：(a) Epicurus 论题 (死后无体验) 意味着死亡非 intrinsic 恶；(b) 操作化：测量人对自己死亡的评价 (时间贴现/存在主义量表) 与客观死亡指标 (DALY) 的相关性 r ≥ 0.7。',
    formalJa: '死が悪いことであれば、（ a ）エピクロスのトピック（死後の経験なし）は、死が本質的な悪ではないことを意味します。（ b ）操作：自分の死に対する人の評価（時間割引/実存的尺度）と客観的な死の指標（ DALY ） r ≥ 0.7との間の相関を測定します。',
    formalEs: 'Si la muerte es algo malo, entonces: (a) la tesis de Epicuro (no hay experiencia después de la muerte) significa que la muerte no es intrínsecamente mala; (b) operacionalización: la correlación entre la medición de la evaluación de las personas sobre su propia muerte (escala de descuento de tiempo/existencialismo) y el indicador objetivo de muerte (AVAD) es r ≥ 0,7.',
    formalEn: 'If death is a bad thing, then: (a) the Epicurus thesis (no experience after death) means that death is not intrinsically evil; (b) operationalization: the correlation between measuring people\'s evaluation of their own death (time discounting/existentialism scale) and the objective death indicator (DALY) is r ≥ 0.7.',
    whyHard: '不存在似乎不是坏事。',
    aiPrompt: '介绍 Epicurus、Lucretius、Bernard Williams。',
    tags: ['哲学', '死亡', '形而上'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Death',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写一篇关于死亡的论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与生死哲学讨论' }]
  },
  {
    id: 'mind-body',
    category: 'philosophy',
    title: '心物关系',
    titleJa: '心身関係',
    titleEs: 'Si la mente es independiente del cuerpo (dualismo de interacción), entonces: (a) la entidad mental no participa en la causalidad física; (b) Operacionalización: todas las actividades cognitivas pueden predecirse completamente mediante actividades neuronales; de lo contrario, si la mente es irreductible (dualismo de propiedad de Chalmers), hay un "problema difícil" Conciencia fenomenal → Diseño de distinción experimental AI/IIT.',
    titleEn: 'Mind-Body Problem',
    year: -400,
    proposer: '笛卡尔',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '心灵和身体是什么关系？',
    summaryJa: '心と体の関係は何ですか？',
    summaryEs: 'Si la mente es independiente del cuerpo (dualismo de interacción), entonces: (a) la entidad mental no participa en la causalidad física; (b) Operacionalización: todas las actividades cognitivas pueden predecirse completamente mediante actividades neuronales; de lo contrario, si la mente es irreductible (dualismo de propiedad de Chalmers), hay un "problema difícil" Conciencia fenomenal → Diseño de distinción experimental AI/IIT.',
    summaryEn: 'If the mind is independent of the body (interaction dualism), then: (a) the mental entity does not participate in physical causation; (b) Operationalization: all cognitive activities can be completely predicted by neural activities; otherwise, if the mind is irreducible (Chalmers property dualism), there is a "difficult problem" Phenomenal consciousness → Design AI/IIT experimental distinction.',
    kid: '笛卡尔说心灵是非物质的"思维实体"，身体是物质"广延实体"。但非物质的心灵怎么推动物质的身体？二元论、心物一元论、物理主义、泛心论各有说法。',
    formal: '若心灵独立于身体（交互二元论），则：(a) 心灵实体不参与物理因果；(b) 操作化：所有认知活动可由神经活动完全预测；反之若心灵不可还原 (Chalmers 性质二元论)，则存在「困难问题」现象意识 → 设计 AI/IIT 实验区分。',
    formalJa: '心が身体から独立している場合（対話的二元論）、（ a ）心の実体が物理的因果関係に参加していない場合、（ b ）操作性：すべての認知活動は神経活動によって完全に予測することができます。逆に、心が還元不能である場合（チャルマーズ自然二元論）、意識→設計AI/IIT実験区別の「困難な問題」現象があります。',
    formalEs: 'Si la mente es independiente del cuerpo (dualismo de interacción), entonces: (a) la entidad mental no participa en la causalidad física; (b) Operacionalización: todas las actividades cognitivas pueden predecirse completamente mediante actividades neuronales; de lo contrario, si la mente es irreductible (dualismo de propiedad de Chalmers), hay un "problema difícil" Conciencia fenomenal → Diseño de distinción experimental AI/IIT.',
    formalEn: 'If the mind is independent of the body (interaction dualism), then: (a) the mental entity does not participate in physical causation; (b) Operationalization: all cognitive activities can be completely predicted by neural activities; otherwise, if the mind is irreducible (Chalmers property dualism), there is a "difficult problem" Phenomenal consciousness → Design AI/IIT experimental distinction.',
    whyHard: '涉及意识本质。',
    aiPrompt: '介绍笛卡尔、二元论、物理主义、双面论。',
    tags: ['心灵', '哲学', '意识'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Mind Body',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写一篇心灵论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'is-ought',
    category: 'philosophy',
    title: '休谟法则',
    titleJa: 'ヒュームの法則',
    titleEs: 'Si el valor puede deducirse de hechos puros (la refutación de la ley de Hume), es necesario dar reglas formales (como la universalización de Hare); operacionalización: prueba (a) si la conclusión normativa puede deducirse lógicamente a partir de premisas fácticas puras, y (b) si se excluyen los contraejemplos (falacia naturalista de Moore).',
    titleEn: 'Hume\'s Law (Is-Ought Problem)',
    year: 1739,
    proposer: 'D. Hume',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '从"是"能推出"应该"吗？',
    summaryJa: '「はい」から「べき」を起動することは可能ですか？',
    summaryEs: 'Si el valor puede deducirse de hechos puros (la refutación de la ley de Hume), es necesario dar reglas formales (como la universalización de Hare); operacionalización: prueba (a) si la conclusión normativa puede deducirse lógicamente a partir de premisas fácticas puras, y (b) si se excluyen los contraejemplos (falacia naturalista de Moore).',
    summaryEn: 'If the value can be deduced from pure facts (Hume\'s law refutation), formal rules (such as Hare\'s universalization) need to be given; operationalization: test (a) whether the normative conclusion can be logically deduced from pure factual premises, and (b) whether counterexamples (Moore\'s naturalistic fallacy) are excluded.',
    kid: '休谟说：不能从"是什么"（事实）推出"应该是什么"（价值）。比如"人杀人"是事实，不能直接推出"人杀人是错的"。但很多伦理学家觉得这太绝对了。',
    formal: '若能从纯事实推出价值 (Hume 律则反驳)，则需给出形式化规则 (如 Hare 普遍化)；操作化：测试 (a) 规范性结论能否从纯事实前提逻辑推出，(b) 反例 (Moore 自然主义谬误) 是否被排除。',
    formalJa: '純粋な事実（ヒュームの法則の反論）から価値を導き出すことができる場合、形式的な規則（ヘアの一般化など）を与える必要があります。操作性： （ a ）純粋な事実的前提論理から規範的結論を導き出すことができるかどうか、および（ b ）反例（ムーアの自然主義的誤謬）が除外されるかどうかをテストします。',
    formalEs: 'Si el valor puede deducirse de hechos puros (la refutación de la ley de Hume), es necesario dar reglas formales (como la universalización de Hare); operacionalización: prueba (a) si la conclusión normativa puede deducirse lógicamente a partir de premisas fácticas puras, y (b) si se excluyen los contraejemplos (falacia naturalista de Moore).',
    formalEn: 'If the value can be deduced from pure facts (Hume\'s law refutation), formal rules (such as Hare\'s universalization) need to be given; operationalization: test (a) whether the normative conclusion can be logically deduced from pure factual premises, and (b) whether counterexamples (Moore\'s naturalistic fallacy) are excluded.',
    whyHard: '直觉上对但又显得太严格。',
    aiPrompt: '介绍休谟、摩尔自然主义谬误。',
    tags: ['伦理', '逻辑', '哲学'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Is Ought',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写关于休谟法则的论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与元伦理学讨论' }]
  },
  {
    id: 'justice',
    category: 'philosophy',
    title: '正义理论',
    titleJa: '正義の理論',
    titleEs: 'Si el principio de distribución justa es uno de (Rawls/Libertario/Utilitario/Igualitario/Suficiencia), los demás pueden falsificarse en N escenarios de distribución; Operacionalización: En ≥ 10 dilemas de distribución clásicos (distribución de órganos/cuota de refugiados/presupuesto de carbono), cinco teorías dan predicciones diferentes → utilizan experimentos de economía conductual + distinción moral de consenso.',
    titleEn: 'Theory of Justice',
    year: -350,
    proposer: '柏拉图 / J. Rawls',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '什么是公平？',
    summaryJa: '公平性とは何ですか？',
    summaryEs: 'Si el principio de distribución justa es uno de (Rawls/Libertario/Utilitario/Igualitario/Suficiencia), los demás pueden falsificarse en N escenarios de distribución; Operacionalización: En ≥ 10 dilemas de distribución clásicos (distribución de órganos/cuota de refugiados/presupuesto de carbono), cinco teorías dan predicciones diferentes → utilizan experimentos de economía conductual + distinción moral de consenso.',
    summaryEn: 'If the fair distribution principle is one of (Rawls/Libertarian/Utilitarian/Egalitarian/Sufficiency), the others can be falsified under N distribution scenarios; Operationalization: On ≥ 10 classic distribution dilemmas (organ distribution/refugee quota/carbon budget), five theories give different predictions → use behavioral economics experiments + consensus moral distinction.',
    kid: '罗尔斯 1971 年提出"无知之幕"思想实验：如果你不知道自己将来是富人还是穷人，你会设计什么样的社会？',
    formal: '若公平的分配原则是 (罗尔斯/自由至上/功利/平等主义/足够主义) 之一，则可在 N 种分配场景下证伪其他；操作化：在 ≥ 10 个经典分配困境 (器官分配/难民配额/碳预算) 上，五种理论给出不同预测 → 用行为经济学实验 + 共识道德区分。',
    formalJa: '衡平分配原理が（ Rolls/Liberty First/Utilitarianism/Egalitarianism/Sufficiencyism ）の1つである場合、他のものはN分布シナリオで偽造される可能性があります。運用： 10以上の古典的な分配ジレンマ（臓器割り当て/難民クォータ/炭素予算）では、5つの理論が行動経済学実験+コンセンサス道徳的区別を→使用して異なる予測を与えます。',
    formalEs: 'Si el principio de distribución justa es uno de (Rawls/Libertario/Utilitario/Igualitario/Suficiencia), los demás pueden falsificarse en N escenarios de distribución; Operacionalización: En ≥ 10 dilemas de distribución clásicos (distribución de órganos/cuota de refugiados/presupuesto de carbono), cinco teorías dan predicciones diferentes → utilizan experimentos de economía conductual + distinción moral de consenso.',
    formalEn: 'If the fair distribution principle is one of (Rawls/Libertarian/Utilitarian/Egalitarian/Sufficiency), the others can be falsified under N distribution scenarios; Operationalization: On ≥ 10 classic distribution dilemmas (organ distribution/refugee quota/carbon budget), five theories give different predictions → use behavioral economics experiments + consensus moral distinction.',
    whyHard: '不同分配原则（平等、效用、需要）相互冲突。',
    aiPrompt: '介绍 Rawls、Nozick、Sen。',
    tags: ['政治', '哲学', '公平'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Justice',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写一篇正义论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与政治哲学讨论' }]
  },
  {
    id: 'liberty',
    category: 'philosophy',
    title: '自由与权威',
    titleJa: '自由と権威',
    titleEs: 'Si la libertad tiene un límite razonable, entonces hay un criterio de (Principio de daño de Mill/Principio de restricción de la libertad/Paternalismo legal); operacionalización: (a) Enumerar 100 bibliotecas de casos de libertad versus autoridad, (b) Usar métodos estadísticos para verificar la consistencia r ≥ 0.8, (c) Dar una función límite formalizable f (comportamiento, consecuencia) → legalidad de la acción.',
    titleEn: 'Liberty and Authority',
    year: 1859,
    proposer: 'J. S. Mill',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '国家能管你多少？',
    summaryJa: '州はどの程度あなたを気遣うことができますか？',
    summaryEs: 'Si la libertad tiene un límite razonable, entonces hay un criterio de (Principio de daño de Mill/Principio de restricción de la libertad/Paternalismo legal); operacionalización: (a) Enumerar 100 bibliotecas de casos de libertad versus autoridad, (b) Usar métodos estadísticos para verificar la consistencia r ≥ 0.8, (c) Dar una función límite formalizable f (comportamiento, consecuencia) → legalidad de la acción.',
    summaryEn: 'If freedom has a reasonable boundary, then there is one criterion of (Mill\'s Harm Principle/Freedom Restriction Principle/Legal Paternalism); operationalization: (a) List 100 case libraries of freedom vs authority, (b) Use statistical methods to verify the consistency r ≥ 0.8, (c) Give a formalizable boundary function f (behavior, consequence) → action legality.',
    kid: 'Mill 说：除非你的行为伤害到别人，否则社会和国家没有权力管你（伤害原则）。但在新冠疫情这样的情况下，这个原则够用吗？',
    formal: '若自由有合理边界，则存在 (Mill 伤害原则/限制自由原则/法律家长制) 之一的判据；操作化：(a) 列出自由 vs 权威 100 个 case 库，(b) 用统计方法验证一致性 r ≥ 0.8，(c) 给出可形式化的边界函数 f(行为, 后果) → 行动合法性。',
    formalJa: '自由に合理的な境界がある場合、基準（ミルハーム原理/制限された自由原理/法的家父長制）の1つがあります。運用： （ a ）自由と権威100ケースライブラリをリストアップし、（ b ）統計的方法を使用して整合性r ≥ 0.8を検証し、（ c ）形式化可能な境界関数f （行動、結果）→アクションの正当性を与える。',
    formalEs: 'Si la libertad tiene un límite razonable, entonces hay un criterio de (Principio de daño de Mill/Principio de restricción de la libertad/Paternalismo legal); operacionalización: (a) Enumerar 100 bibliotecas de casos de libertad versus autoridad, (b) Usar métodos estadísticos para verificar la consistencia r ≥ 0.8, (c) Dar una función límite formalizable f (comportamiento, consecuencia) → legalidad de la acción.',
    formalEn: 'If freedom has a reasonable boundary, then there is one criterion of (Mill\'s Harm Principle/Freedom Restriction Principle/Legal Paternalism); operationalization: (a) List 100 case libraries of freedom vs authority, (b) Use statistical methods to verify the consistency r ≥ 0.8, (c) Give a formalizable boundary function f (behavior, consequence) → action legality.',
    whyHard: '公共卫生、安全、文化冲突。',
    aiPrompt: '介绍 Mill、柏林（积极/消极自由）、Hart。',
    tags: ['政治', '哲学', '自由'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Liberty',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写政治哲学论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与自由讨论' }]
  },
  {
    id: 'property',
    category: 'philosophy',
    title: '财产理论',
    titleJa: '特性理論',
    titleEs: 'Si la propiedad privada tiene una base de legitimidad (teoría del trabajo/utilidad/derechos/convenciones), puede explicar: (a) propiedad intelectual versus propiedad material, (b) pública versus privada, (c) el estatus moral de los impuestos forzosos; Operacionalización: Construya una biblioteca de 100 casos, realice un análisis estadístico sobre la divergencia de cuatro predicciones teóricas y verifíquelo mediante el equilibrio reflexivo de Rawls + el experimento mental.',
    titleEn: 'Theory of Property',
    year: 1690,
    proposer: 'J. Locke',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '为什么你能"拥有"一块地？',
    summaryJa: '土地を「所有」できるのはなぜですか？',
    summaryEs: 'Si la propiedad privada tiene una base de legitimidad (teoría del trabajo/utilidad/derechos/convenciones), puede explicar: (a) propiedad intelectual versus propiedad material, (b) pública versus privada, (c) el estatus moral de los impuestos forzosos; Operacionalización: Construya una biblioteca de 100 casos, realice un análisis estadístico sobre la divergencia de cuatro predicciones teóricas y verifíquelo mediante el equilibrio reflexivo de Rawls + el experimento mental.',
    summaryEn: 'If private property has a legitimacy basis (labor/utility/rights/convention theory), it can explain: (a) intellectual property vs. material property, (b) public vs. private, (c) the moral status of forced taxation; operationalization: Construct a 100 case library, perform statistical analysis on the divergence of four theoretical predictions, and verify it through Rawls reflective equilibrium + thought experiment.',
    kid: '洛克说：你混合了你的劳动，所以那块地是你的（劳动混合理论）。但如果你不劳动（比如继承），还有这个权利吗？',
    formal: '若私有财产有正当性基础（劳动/效用/权利/约定论），则可解释：(a) 知识产权 vs 物质财产，(b) 公有 vs 私有，(c) 强征税收的道德地位；操作化：构建 100 案例库，对四种理论预测分歧度做统计分析，通过 Rawls 反思平衡 + 思想实验验证。',
    formalJa: '私有財産が正当性の基礎（労働/効用/権利/慣習）を有する場合、それは次のように解釈することができる： （ a ）知的財産対物質財産、（ b ）公的対私的、（ c ）強制課税の道徳的地位、運用化： 100ケースライブラリを構築し、4つの理論的予測差の統計分析を行い、ロールズ反射バランス+イデオロギー実験検証に合格する。',
    formalEs: 'Si la propiedad privada tiene una base de legitimidad (teoría del trabajo/utilidad/derechos/convenciones), puede explicar: (a) propiedad intelectual versus propiedad material, (b) pública versus privada, (c) el estatus moral de los impuestos forzosos; Operacionalización: Construya una biblioteca de 100 casos, realice un análisis estadístico sobre la divergencia de cuatro predicciones teóricas y verifíquelo mediante el equilibrio reflexivo de Rawls + el experimento mental.',
    formalEn: 'If private property has a legitimacy basis (labor/utility/rights/convention theory), it can explain: (a) intellectual property vs. material property, (b) public vs. private, (c) the moral status of forced taxation; operationalization: Construct a 100 case library, perform statistical analysis on the divergence of four theoretical predictions, and verify it through Rawls reflective equilibrium + thought experiment.',
    whyHard: '劳动 vs 效用 vs 平等。',
    aiPrompt: '介绍 Locke、Nozick、Rawls。',
    tags: ['政治', '哲学', '财产'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Property',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写财产论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'authority-phil',
    category: 'philosophy',
    title: '国家权威',
    titleJa: '州の権限',
    titleEs: 'Si la autoridad estatal está justificada (consentimiento/justicia/deber/utilidad), puede falsificarse de otro modo; operacionalización: (a) Tasa de obediencia ciudadana versus correlación de satisfacción institucional r ≥ 0,7, (b) La simulación de anarquía muestra una probabilidad de colapso del orden ≥ umbral; (c) Prueba empírica de obediencia al derecho internacional en la cooperación en materia de gobernanza transnacional.',
    titleEn: 'Political Authority',
    year: 1651,
    proposer: 'T. Hobbes',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '为什么我们必须服从国家？',
    summaryJa: 'なぜ私たちは国家に従わなければならないのですか？',
    summaryEs: 'Si la autoridad estatal está justificada (consentimiento/justicia/deber/utilidad), puede falsificarse de otro modo; operacionalización: (a) Tasa de obediencia ciudadana versus correlación de satisfacción institucional r ≥ 0,7, (b) La simulación de anarquía muestra una probabilidad de colapso del orden ≥ umbral; (c) Prueba empírica de obediencia al derecho internacional en la cooperación en materia de gobernanza transnacional.',
    summaryEn: 'If state authority is justified (consent/fairness/duty/utility), it can be falsified otherwise; operationalization: (a) Citizen obedience rate vs institutional satisfaction correlation r ≥ 0.7, (b) Anarchy simulation shows order collapse probability ≥ threshold; (c) Empirical test of obedience to international law in transnational governance cooperation.',
    kid: '霍布斯说：在自然状态人人互相残杀，所以大家签社会契约让渡一部分自由给国家。但无政府主义者认为这是不必要的。',
    formal: '若国家权威正当 (同意/公平/职责/功利)，则可证伪其他；操作化：(a) 公民服从率 vs 制度满意度相关性 r ≥ 0.7，(b) 无政府状态模拟显示秩序崩溃概率 ≥ 阈值；(c) 跨国治理合作中服从国际法的实证检验。',
    formalJa: '国家権限が正当である場合（同意/公平性/義務/有用性）、他者を偽造することができます。運用： （ a ）市民コンプライアンス率とシステム満足度の相関r ≥ 0.7、（ b ）アナーキーシミュレーションは、秩序崩壊の確率が閾値以上であることを示します。（ c ）国境を越えたガバナンス協力における国際法の遵守の実証テスト。',
    formalEs: 'Si la autoridad estatal está justificada (consentimiento/justicia/deber/utilidad), puede falsificarse de otro modo; operacionalización: (a) Tasa de obediencia ciudadana versus correlación de satisfacción institucional r ≥ 0,7, (b) La simulación de anarquía muestra una probabilidad de colapso del orden ≥ umbral; (c) Prueba empírica de obediencia al derecho internacional en la cooperación en materia de gobernanza transnacional.',
    formalEn: 'If state authority is justified (consent/fairness/duty/utility), it can be falsified otherwise; operationalization: (a) Citizen obedience rate vs institutional satisfaction correlation r ≥ 0.7, (b) Anarchy simulation shows order collapse probability ≥ threshold; (c) Empirical test of obedience to international law in transnational governance cooperation.',
    whyHard: '同意 vs 公平 vs 自然义务。',
    aiPrompt: '介绍 Hobbes、Locke、Rousseau。',
    tags: ['政治', '哲学', '国家'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Authority',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写政治哲学论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'equality',
    category: 'philosophy',
    title: '平等',
    titleJa: '平等',
    titleEs: 'Si la igualdad es una de oportunidades/resultados/recursos/bienestar/capacidades (Sen/Nussbaum), se puede distinguir: Operacionalización: predecir desacuerdos en 100 escenarios políticos; Empírico: Análisis del indicador "Igualdad de Oportunidades" (IEO) y correlación PIB-per cápita en países nórdicos Gini < 0,3.',
    titleEn: 'Equality',
    year: 1971,
    proposer: 'J. Rawls / R. Dworkin',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '什么样的平等才公平？',
    summaryJa: 'どのような平等が公平なのでしょうか？',
    summaryEs: 'Si la igualdad es una de oportunidades/resultados/recursos/bienestar/capacidades (Sen/Nussbaum), se puede distinguir: Operacionalización: predecir desacuerdos en 100 escenarios políticos; Empírico: Análisis del indicador "Igualdad de Oportunidades" (IEO) y correlación PIB-per cápita en países nórdicos Gini < 0,3.',
    summaryEn: 'If equality is one of opportunities/outcomes/resources/well-being/capabilities (Sen/Nussbaum), it can be distinguished: Operationalization: predicting disagreements in 100 policy scenarios; Empirical: Analysis of the "Equality of Opportunities" indicator (IEO) and GDP-per capita correlation in Nordic Gini < 0.3 countries.',
    kid: 'Dworkin 说：平等是"敏于抱负、不敏于禀赋"——只要你的资源够，是"懒"还是"不努力"决定结果。但每个人出生时的天赋不同，这公平吗？',
    formal: '若平等是机会/结果/资源/福祉/能力 (Sen/Nussbaum) 之一，则可区分：操作化：在 100 个政策场景中预测分歧；经验上：北欧 Gini < 0.3 国家的「机会平等」指标 (IEO) 与 GDP-人均相关性分析。',
    formalJa: '平等が機会/結果/リソース/ウェルビーイング/キャパシティ（ SEN/Nussbaum ）の1つである場合、次のものと区別できます。運用化： 100の政策シナリオでの相違を予測する。経験的：北欧ジニ< 0.3諸国の「機会均等」指標（ IEO ）と一人当たりGDP相関分析。',
    formalEs: 'Si la igualdad es una de oportunidades/resultados/recursos/bienestar/capacidades (Sen/Nussbaum), se puede distinguir: Operacionalización: predecir desacuerdos en 100 escenarios políticos; Empírico: Análisis del indicador "Igualdad de Oportunidades" (IEO) y correlación PIB-per cápita en países nórdicos Gini < 0,3.',
    formalEn: 'If equality is one of opportunities/outcomes/resources/well-being/capabilities (Sen/Nussbaum), it can be distinguished: Operationalization: predicting disagreements in 100 policy scenarios; Empirical: Analysis of the "Equality of Opportunities" indicator (IEO) and GDP-per capita correlation in Nordic Gini < 0.3 countries.',
    whyHard: '三个标准相互冲突。',
    aiPrompt: '介绍 Rawls、Dworkin、Cohen。',
    tags: ['政治', '哲学', '平等'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Equality',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写平等论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'punishment',
    category: 'philosophy',
    title: '惩罚理论',
    titleJa: '罰則理論',
    titleEs: 'Si el castigo está justificado (retribución/utilidad/corrección/disuasión), puede ser falsificado; operacionalización: (a) tasa de reincidencia (tasa de reincidencia <30% como punto de referencia para el éxito de la corrección), (b) coeficiente de adaptación al crimen-castigo r ≥ 0,7, (c) el análisis de regresión del efecto disuasivo marginal es significativo (p <0,05).',
    titleEn: 'Theory of Punishment',
    year: 1764,
    proposer: 'C. Beccaria',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '为什么我们要把坏人关进监狱？',
    summaryJa: 'なぜ悪人を刑務所に入れるのですか？',
    summaryEs: 'Si el castigo está justificado (retribución/utilidad/corrección/disuasión), puede ser falsificado; operacionalización: (a) tasa de reincidencia (tasa de reincidencia <30% como punto de referencia para el éxito de la corrección), (b) coeficiente de adaptación al crimen-castigo r ≥ 0,7, (c) el análisis de regresión del efecto disuasivo marginal es significativo (p <0,05).',
    summaryEn: 'If the punishment is justified (retribution/utility/correction/deterrence), it can be falsified; operationalization: (a) recidivism rate (recidivism rate < 30% as the benchmark for correction success), (b) crime-punishment adaptation coefficient r ≥ 0.7, (c) marginal deterrent effect regression analysis is significant (p < 0.05).',
    kid: '惩罚有四个目的：报应（你伤了别人，所以你也该受伤）、威慑（让你不敢再犯）、改造（让你变好）、隔离（防止再伤人）。哪个最重要？',
    formal: '若惩罚正当 (报应/功利/矫正/威慑)，则可证伪其他；操作化：(a) 累犯率 (再犯率 < 30% 作为矫正成功基准)，(b) 罪刑相适应系数 r ≥ 0.7，(c) 边际威慑效应回归分析显著 (p < 0.05)。',
    formalJa: '処罰が正当化された場合（報復/功利主義/修正/抑止）、他方は偽造される可能性があります。運用： （ a ）再犯率（修正成功ベンチマークとして再犯率< 30 ％ ）、（ b ）犯罪適応係数r ≥ 0.7、（ c ）限界抑止効果回帰分析が有意であった（ p < 0.05 ）。',
    formalEs: 'Si el castigo está justificado (retribución/utilidad/corrección/disuasión), puede ser falsificado; operacionalización: (a) tasa de reincidencia (tasa de reincidencia <30% como punto de referencia para el éxito de la corrección), (b) coeficiente de adaptación al crimen-castigo r ≥ 0,7, (c) el análisis de regresión del efecto disuasivo marginal es significativo (p <0,05).',
    formalEn: 'If the punishment is justified (retribution/utility/correction/deterrence), it can be falsified; operationalization: (a) recidivism rate (recidivism rate < 30% as the benchmark for correction success), (b) crime-punishment adaptation coefficient r ≥ 0.7, (c) marginal deterrent effect regression analysis is significant (p < 0.05).',
    whyHard: '不同理论导致不同的司法政策。',
    aiPrompt: '介绍 retributivism、consequentialism、Duff。',
    tags: ['政治', '哲学', '法'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Punishment',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写一篇惩罚论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'marriage-phil',
    category: 'philosophy',
    title: '婚姻哲学',
    titleJa: '結婚哲学',
    titleEs: 'Si la esencia del matrimonio es (fertilidad/amor/compañía/ley/economía/religión), entonces las formas de matrimonio transcultural pueden clasificarse razonablemente; operacionalización: (a) agrupación estadística (k-medias) de la definición de "matrimonio" en 100 culturas, (b) correlación entre la tasa de divorcios y los indicadores básicos del matrimonio, (c) el consenso de filosofía moral transcultural r ≥ 0,7 puede falsificar la relatividad cultural pura.',
    titleEn: 'Philosophy of Marriage',
    year: 1949,
    proposer: 'S. de Beauvoir',
    difficulty: 2,
    reward: 0,
    status: 'open',
    summary: '婚姻为什么存在？',
    summaryJa: '結婚が存在するのはなぜですか？',
    summaryEs: 'Si la esencia del matrimonio es (fertilidad/amor/compañía/ley/economía/religión), entonces las formas de matrimonio transcultural pueden clasificarse razonablemente; operacionalización: (a) agrupación estadística (k-medias) de la definición de "matrimonio" en 100 culturas, (b) correlación entre la tasa de divorcios y los indicadores básicos del matrimonio, (c) el consenso de filosofía moral transcultural r ≥ 0,7 puede falsificar la relatividad cultural pura.',
    summaryEn: 'If the essence of marriage is one of (fertility/love/companionship/law/economy/religion), then cross-cultural marriage forms can be reasonably classified; operationalization: (a) statistical clustering (k-means) of the definition of "marriage" in 100 cultures, (b) correlation between divorce rate and basic indicators of marriage, (c) cross-cultural moral philosophy consensus r ≥ 0.7 can falsify pure cultural relativity.',
    kid: '波伏娃说：婚姻是经济安排，不是爱情。恩格斯说：婚姻是为了确定财产继承。婚姻应该是什么？',
    formal: '若婚姻本质是 (生育/爱情/陪伴/法律/经济/宗教) 之一，则跨文化婚姻形态可被合理分类；操作化：(a) 100 文化中「婚姻」定义的统计聚类 (k-means)，(b) 离婚率与婚姻基础指标相关性，(c) 跨文化道德哲学共识 r ≥ 0.7 时可证伪纯文化相对论。',
    formalJa: '結婚の性質が（不妊/愛/友情/法的/経済的/宗教的）の1つである場合、異文化間の結婚形態は合理的に分類することができます。運用化： （ a ） 100の文化における「結婚」の定義の統計的クラスタリング（ k平均）、（ b ）離婚率と結婚の基本指標との相関、（ c ）異文化間の道徳的哲学的コンセンサスr ≥ 0.7は、擬似文化相対主義を証明することができます。',
    formalEs: 'Si la esencia del matrimonio es (fertilidad/amor/compañía/ley/economía/religión), entonces las formas de matrimonio transcultural pueden clasificarse razonablemente; operacionalización: (a) agrupación estadística (k-medias) de la definición de "matrimonio" en 100 culturas, (b) correlación entre la tasa de divorcios y los indicadores básicos del matrimonio, (c) el consenso de filosofía moral transcultural r ≥ 0,7 puede falsificar la relatividad cultural pura.',
    formalEn: 'If the essence of marriage is one of (fertility/love/companionship/law/economy/religion), then cross-cultural marriage forms can be reasonably classified; operationalization: (a) statistical clustering (k-means) of the definition of "marriage" in 100 cultures, (b) correlation between divorce rate and basic indicators of marriage, (c) cross-cultural moral philosophy consensus r ≥ 0.7 can falsify pure cultural relativity.',
    whyHard: '不同文化对婚姻看法差异极大。',
    aiPrompt: '介绍 Beauvoir、Engels、Fineman。',
    tags: ['哲学', '社会', '婚姻'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Marriage',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写婚姻哲学论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'beauty-objective',
    category: 'philosophy',
    title: '审美判断',
    titleJa: '審美的判断',
    titleEs: 'Si los juicios estéticos tienen una base universal (proporción/simetría/adaptación evolutiva/estructura matemática), debería haber componentes consistentes en todas las culturas; operacionalización: (a) importancia de la proporción áurea frente a la espiral de Fibonacci en 1000 obras de arte (p <0,01), (b) puntuación transcultural r ≥ 0,6 + validación de agrupación de patrones neuronales.',
    titleEn: 'Aesthetic Judgment',
    year: 1790,
    proposer: 'I. Kant',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '美是"无利害的快感"？',
    summaryJa: '美しさは「無害な快感」？',
    summaryEs: 'Si los juicios estéticos tienen una base universal (proporción/simetría/adaptación evolutiva/estructura matemática), debería haber componentes consistentes en todas las culturas; operacionalización: (a) importancia de la proporción áurea frente a la espiral de Fibonacci en 1000 obras de arte (p <0,01), (b) puntuación transcultural r ≥ 0,6 + validación de agrupación de patrones neuronales.',
    summaryEn: 'If aesthetic judgments have a universal basis (proportion/symmetry/evolutionary adaptation/mathematical structure), there should be consistent components across cultures; operationalization: (a) significance of golden ratio vs Fibonacci spiral in 1000 artworks (p < 0.01), (b) cross-cultural score r ≥ 0.6 + neural pattern clustering validation.',
    kid: '康德说：审美判断是无利害、无概念的快感——我看到一朵花觉得美，不是因为它有用。真的是这样吗？',
    formal: '若审美判断有普遍性根据（比例/对称/进化适应/数学结构），则跨文化应有一致成分；操作化：(a) 黄金比例 vs 斐波那契螺旋在 1000 艺术品中的显著性 (p < 0.01)，(b) 跨文化评分 r ≥ 0.6 + 神经模式聚类验证。',
    formalJa: '審美的判断が普遍性（比例性/対称性/進化的適応/数学的構造）に基づいている場合、文化間に一貫性がある必要があります。運用： （ a ） 1000の芸術作品における黄金比対フィボナッチスパイラル有意性（ p < 0.01 ）、（ b ）異文化間スコアr ≥ 0.6 +神経パターンクラスター検証。',
    formalEs: 'Si los juicios estéticos tienen una base universal (proporción/simetría/adaptación evolutiva/estructura matemática), debería haber componentes consistentes en todas las culturas; operacionalización: (a) importancia de la proporción áurea frente a la espiral de Fibonacci en 1000 obras de arte (p <0,01), (b) puntuación transcultural r ≥ 0,6 + validación de agrupación de patrones neuronales.',
    formalEn: 'If aesthetic judgments have a universal basis (proportion/symmetry/evolutionary adaptation/mathematical structure), there should be consistent components across cultures; operationalization: (a) significance of golden ratio vs Fibonacci spiral in 1000 artworks (p < 0.01), (b) cross-cultural score r ≥ 0.6 + neural pattern clustering validation.',
    whyHard: '不同文化、不同时代对美的看法不同。',
    aiPrompt: '介绍康德美学。',
    tags: ['美学', '哲学', '康德'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Aesthetics',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写审美论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与美学讨论' }]
  },
  {
    id: 'trolley',
    category: 'philosophy',
    title: '电车难题',
    titleJa: '路面電車の問題',
    titleEs: 'El utilitarismo (5 vs 1) y la deontología (no instrumental) dan predicciones diferentes; operacionalizado: (a) Proporción de dos juicios en N = 1000 experimento transcultural, (b) fMRI revela conflicto moral (activación de la corteza cingulada anterior), (c) Mecanismos cognitivos que explican las diferencias en la intuición a través del modelo de proceso dual (Sistema 1 vs 2).',
    titleEn: 'Trolley Problem',
    year: 1967,
    proposer: 'P. Foot',
    difficulty: 2,
    reward: 0,
    status: 'open',
    summary: '杀 1 人救 5 人，错吗？',
    summaryJa: '1人を殺して5人を救う、それは間違っていますか？',
    summaryEs: 'El utilitarismo (5 vs 1) y la deontología (no instrumental) dan predicciones diferentes; operacionalizado: (a) Proporción de dos juicios en N = 1000 experimento transcultural, (b) fMRI revela conflicto moral (activación de la corteza cingulada anterior), (c) Mecanismos cognitivos que explican las diferencias en la intuición a través del modelo de proceso dual (Sistema 1 vs 2).',
    summaryEn: 'Utilitarianism (5 vs 1) and deontology (not instrumental) give different predictions; operationalized: (a) Proportion of two judgments in N=1000 cross-cultural experiment, (b) fMRI reveals moral conflict (anterior cingulate cortex activation), (c) Cognitive mechanisms explaining differences in intuition via dual-process model (System 1 vs 2).',
    kid: '一辆失控的电车，前面有 5 个人被绑在铁轨上。你旁边有一个拉杆，可以让电车转向另一条轨道——那上面绑着 1 个人。你拉不拉？哲学家用这个测试我们道德直觉。',
    formal: '功利主义 (5 vs 1) 与义务论 (不可作为工具) 给出不同预测；操作化：(a) N=1000 跨文化实验中两种判断的比例，(b) fMRI 显示道德冲突 (前扣带皮层激活)，(c) 通过双过程模型 (System 1 vs 2) 解释直觉差异的认知机制。',
    formalJa: '功利主義（ 5対1 ）と義務理論（ツールではない）は異なる予測を与えます。運用化： （ a ） N = 1000の異文化実験における2つの判断の比率、（ b ） fMRIは道徳的矛盾（前帯状皮質の活性化）を示し、（ c ） 2つのプロセスモデルを介して直感的な違いを説明する認知メカニズム（システム1対2 ）。',
    formalEs: 'El utilitarismo (5 vs 1) y la deontología (no instrumental) dan predicciones diferentes; operacionalizado: (a) Proporción de dos juicios en N = 1000 experimento transcultural, (b) fMRI revela conflicto moral (activación de la corteza cingulada anterior), (c) Mecanismos cognitivos que explican las diferencias en la intuición a través del modelo de proceso dual (Sistema 1 vs 2).',
    formalEn: 'Utilitarianism (5 vs 1) and deontology (not instrumental) give different predictions; operationalized: (a) Proportion of two judgments in N=1000 cross-cultural experiment, (b) fMRI reveals moral conflict (anterior cingulate cortex activation), (c) Cognitive mechanisms explaining differences in intuition via dual-process model (System 1 vs 2).',
    whyHard: '道德直觉很难统一。',
    aiPrompt: '介绍 Foot、Thomson、自动驾驶伦理。',
    tags: ['伦理', '哲学', '思想实验'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Trolley',
    videoChannel: 'CrashCourse',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写电车难题论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与自动驾驶伦理讨论' }]
  },
  {
    id: 'teleport',
    category: 'philosophy',
    title: '传送悖论',
    titleJa: 'テレポーテーション・パラドックス',
    titleEs: 'Si el teletransportador conserva la identidad de la personalidad (una de continuidad física/mental/causal), la otra puede ser falsificada; operacionalizado: (a) prueba de memoria lockeana clásica (continuidad de la memoria/personalidad/valores antes y después de la transmisión ≥ 95%), (b) prueba ciega experimental de si amigos/familiares pueden reconocerlo (tasa de reconocimiento ≥ 80% frente a hipótesis duplicada).',
    titleEn: 'Teleportation Paradox',
    year: 1977,
    proposer: 'D. Parfit',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '如果传送机杀了你再复制你，"你"还活着吗？',
    summaryJa: 'テレポーターがあなたを殺し、それからあなたをコピーした場合、「あなた」はまだ生きていますか？',
    summaryEs: 'Si el teletransportador conserva la identidad de la personalidad (una de continuidad física/mental/causal), la otra puede ser falsificada; operacionalizado: (a) prueba de memoria lockeana clásica (continuidad de la memoria/personalidad/valores antes y después de la transmisión ≥ 95%), (b) prueba ciega experimental de si amigos/familiares pueden reconocerlo (tasa de reconocimiento ≥ 80% frente a hipótesis duplicada).',
    summaryEn: 'If the teleporter retains personality identity (one of physical/mental/causal continuity), the other can be falsified; operationalized: (a) classic Lockean memory test (continuity of memory/personality/values ​​before and after transmission ≥ 95%), (b) experimental blind test of whether friends/family can recognize it (≥ 80% recognition rate vs. duplicate hypothesis).',
    kid: '科幻电影里的"传送"通常：扫描你、把你分子结构发到火星、再造一个。问题是：原版的你会被杀掉吗？那"你"算活着吗？',
    formal: '若传送机保留人格同一性 (身体/心理/因果连续性 之一)，则可证伪其他；操作化：(a) 经典 Lockean memory 测验（传送前后记忆/性格/价值观连续性 ≥ 95%），(b) 朋友/家人能否识别的实验盲测 (≥ 80% 识别率 vs 复制体假说)。',
    formalJa: 'コンベアがパーソナリティアイデンティティ（身体的/精神的/因果的連続性の1つ）を保持している場合、他方は偽造される可能性があります。運用： （ a ）古典的なロックアンメモリーテスト（伝達前後の記憶/パーソナリティ/値の連続性が95 ％以上）、（ b ）友人/家族認識のための実験的ブラインドテスト（レプリカント仮説対80 ％以上の認識率）。',
    formalEs: 'Si el teletransportador conserva la identidad de la personalidad (una de continuidad física/mental/causal), la otra puede ser falsificada; operacionalizado: (a) prueba de memoria lockeana clásica (continuidad de la memoria/personalidad/valores antes y después de la transmisión ≥ 95%), (b) prueba ciega experimental de si amigos/familiares pueden reconocerlo (tasa de reconocimiento ≥ 80% frente a hipótesis duplicada).',
    formalEn: 'If the teleporter retains personality identity (one of physical/mental/causal continuity), the other can be falsified; operationalized: (a) classic Lockean memory test (continuity of memory/personality/values ​​before and after transmission ≥ 95%), (b) experimental blind test of whether friends/family can recognize it (≥ 80% recognition rate vs. duplicate hypothesis).',
    whyHard: '心理连续性 vs 物理连续性。',
    aiPrompt: '介绍 Parfit、Reasons and Persons。',
    tags: ['心灵', '哲学', '科幻'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Teleport',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写一篇关于传送的论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'newcomb',
    category: 'philosophy',
    title: 'Newcomb 悖论',
    titleJa: 'ニューカムのパラドックス',
    titleEs: 'Si la teoría de la decisión (EV-max) tiene prioridad sobre la causalidad (dominancia), entonces deberían elegirse dos casillas en la paradoja de Newcomb; operacionalización: (a) N = 1000 distribución de elección de sujeto, (b) juegos repetidos que muestran una estrategia de "elegir una casilla" con una tasa de ganancia a largo plazo ≥ 60% (teoría de la decisión causal), (c) formalización (Lewis/Weirich) que proporciona una función de decisión unificada.',
    titleEn: 'Newcomb\'s Paradox',
    year: 1960,
    proposer: 'W. Newcomb',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '你相信"决定论"还是相信"自由意志"？',
    summaryJa: 'あなたは「決定論」または「自由意志」を信じますか？',
    summaryEs: 'Si la teoría de la decisión (EV-max) tiene prioridad sobre la causalidad (dominancia), entonces deberían elegirse dos casillas en la paradoja de Newcomb; operacionalización: (a) N = 1000 distribución de elección de sujeto, (b) juegos repetidos que muestran una estrategia de "elegir una casilla" con una tasa de ganancia a largo plazo ≥ 60% (teoría de la decisión causal), (c) formalización (Lewis/Weirich) que proporciona una función de decisión unificada.',
    summaryEn: 'If decision theory (EV-max) takes precedence over causality (dominance), then two boxes should be chosen in Newcomb\'s paradox; operationalization: (a) N=1000 subject choice distribution, (b) repeated games showing "choose one box" strategy with long-term winning rate ≥ 60% (causal decision theory), (c) formalization (Lewis/Weirich) giving a unified decision function.',
    kid: '两个盒子：A 透明（你看到里面有 1000 美元），B 不透明。预测机器说你会"只拿 B"，就放 100 万在 B；说你会"两个都拿"，就 B 里放 0。你怎么选？',
    formal: '若决策论 (EV-max) 优先于因果论 (dominance)，则 Newcomb 悖论中应选两箱；操作化：(a) N=1000 受试者选择分布，(b) 重复博弈显示「选一箱」策略 长期胜率 ≥ 60% (causal decision theory)，(c) 形式化 (Lewis/Weirich) 给出统一决策函数。',
    formalJa: '決定理論（ EV - max ）が優位性よりも優先される場合、Newcombパラドックスで2つのボックスを選択する必要があります。運用： （ a ） N = 1000件の被験者選択分布、（ b ）反復ゲームは、「ボックスを選択する」戦略の長期的な勝率が60 ％以上であることを示しています（因果決定理論）、および（ c ）形式化（ Lewis/Weirich ）は統一された決定関数を与えます。',
    formalEs: 'Si la teoría de la decisión (EV-max) tiene prioridad sobre la causalidad (dominancia), entonces deberían elegirse dos casillas en la paradoja de Newcomb; operacionalización: (a) N = 1000 distribución de elección de sujeto, (b) juegos repetidos que muestran una estrategia de "elegir una casilla" con una tasa de ganancia a largo plazo ≥ 60% (teoría de la decisión causal), (c) formalización (Lewis/Weirich) que proporciona una función de decisión unificada.',
    formalEn: 'If decision theory (EV-max) takes precedence over causality (dominance), then two boxes should be chosen in Newcomb\'s paradox; operationalization: (a) N=1000 subject choice distribution, (b) repeated games showing "choose one box" strategy with long-term winning rate ≥ 60% (causal decision theory), (c) formalization (Lewis/Weirich) giving a unified decision function.',
    whyHard: '两个看似合理的选择给出不同结果。',
    aiPrompt: '介绍 Newcomb、causal vs evidential decision theory。',
    tags: ['逻辑', '哲学', '决策'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Newcomb',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '写决策论论文' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'fusion',
    category: 'engineering',
    title: '可控核聚变',
    titleJa: '制御された核融合',
    titleEs: 'Lograr un reactor de fusión en estado estacionario con Q = P_fusion / P_input ≥ 10: confinamiento de plasma τ_E ≥ 3 s, producto triple nTτ_E ≥ 3×10²¹ keV·s/m³, operación continua ≥ 1000 horas, generación de energía anual ≥ 1 TWh, costo unitario de electricidad ≤ 0,10 dólares estadounidenses.',
    titleEn: 'Controlled Nuclear Fusion',
    year: 1950,
    proposer: '—',
    difficulty: 5,
    reward: 5000,
    status: 'open',
    summary: '在地球上造一个"小太阳"',
    summaryJa: '地球に「小さな太陽」を作りましょう',
    summaryEs: 'Lograr un reactor de fusión en estado estacionario con Q = P_fusion / P_input ≥ 10: confinamiento de plasma τ_E ≥ 3 s, producto triple nTτ_E ≥ 3×10²¹ keV·s/m³, operación continua ≥ 1000 horas, generación de energía anual ≥ 1 TWh, costo unitario de electricidad ≤ 0,10 dólares estadounidenses.',
    summaryEn: 'Achieve a steady-state fusion reactor with Q = P_fusion / P_input ≥ 10: plasma confinement τ_E ≥ 3 s, triple product nTτ_E ≥ 3×10²¹ keV·s/m³, continuous operation ≥ 1000 hours, annual power generation ≥ 1 TWh, unit cost of electricity ≤ 0.10 US dollars.',
    kid: '太阳靠"烧"氢气变成氦气来发光发热，叫核聚变。地球上能不能也这样做？如果能，能源就几乎无限了。问题是：太阳能靠巨大引力压住核聚变，地球没有。',
    formal: '实现 Q = P_fusion / P_input ≥ 10 的稳态聚变反应堆：等离子体约束 τ_E ≥ 3 s、三乘积 nTτ_E ≥ 3×10²¹ keV·s/m³、连续运行 ≥ 1000 小时、年发电量 ≥ 1 TWh、单度电成本 ≤ 0.10 美元。',
    formalJa: 'Q = P_fusion/P_input ≥ 10の定常状態融合炉：プラズマ制約τ_E ≥ 3 s、三重生成物nT τ_E ≥ 3 × 10 ²¹ keV · s/m ³、連続運転≥ 1000時間、年間発電量≥ 1 TWh、単価≤ 0.10ドル。',
    formalEs: 'Lograr un reactor de fusión en estado estacionario con Q = P_fusion / P_input ≥ 10: confinamiento de plasma τ_E ≥ 3 s, producto triple nTτ_E ≥ 3×10²¹ keV·s/m³, operación continua ≥ 1000 horas, generación de energía anual ≥ 1 TWh, costo unitario de electricidad ≤ 0,10 dólares estadounidenses.',
    formalEn: 'Achieve a steady-state fusion reactor with Q = P_fusion / P_input ≥ 10: plasma confinement τ_E ≥ 3 s, triple product nTτ_E ≥ 3×10²¹ keV·s/m³, continuous operation ≥ 1000 hours, annual power generation ≥ 1 TWh, unit cost of electricity ≤ 0.10 US dollars.',
    whyHard: '需要 1 亿度高温下约束等离子体。',
    aiPrompt: '介绍托卡马克、激光惯性约束 ITER、NIF。',
    tags: ['能源', '等离子体', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Fusion',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '参与 ITER 模拟' }, { type: 'code', label: '写代码/算法', desc: '跑等离子体模拟' }, { type: 'essay', label: '写文章/论文', desc: '介绍聚变历史' }, { type: 'fund', label: '资助/投资', desc: '给聚变研究捐资' }]
  },
  {
    id: 'space-elevator',
    category: 'engineering',
    title: '太空电梯',
    titleJa: 'スペースエレベーター',
    titleEs: 'Alcance un cable de ≥ 36000 km de longitud: resistencia a la tracción ≥ 60 GPa, densidad ≤ 1,3 g/cm³, masa total ≤ 10⁷ kg, diámetro de fibra única ≤ 1 μm y sin defectos, y puede soportar micrometeoritos + rayos + oxígeno atómico.',
    titleEn: 'Space Elevator',
    year: 1895,
    proposer: 'K. Tsiolkovsky',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '从地面到太空的"电梯"',
    summaryJa: '地上から宇宙への「エレベーター」',
    summaryEs: 'Alcance un cable de ≥ 36000 km de longitud: resistencia a la tracción ≥ 60 GPa, densidad ≤ 1,3 g/cm³, masa total ≤ 10⁷ kg, diámetro de fibra única ≤ 1 μm y sin defectos, y puede soportar micrometeoritos + rayos + oxígeno atómico.',
    summaryEn: 'Achieve ≥ 36000 km length cable: tensile strength ≥ 60 GPa, density ≤ 1.3 g/cm³, total mass ≤ 10⁷ kg, single fiber diameter ≤ 1 μm and no defects, and can withstand micrometeorites + lightning + atomic oxygen.',
    kid: '火箭运东西上太空要花很多钱（一公斤几十万美元）。能不能造一条长长的"电梯"从地球一直伸到太空，东西坐电梯上去？听着科幻，但材料学上没有根本不可能。问题是要找到能撑住自身重量的材料。',
    formal: '实现 ≥ 36000 km 长度缆绳：抗拉强度 ≥ 60 GPa、密度 ≤ 1.3 g/cm³、总质量 ≤ 10⁷ kg、单根纤维直径 ≤ 1 μm 且无缺陷、且能承受微陨石 + 雷电 + 原子氧。',
    formalJa: 'ケーブル長≥ 36000 km ：引張強度≥ 60 GPa、密度≤ 1.3 g/cm ³、総質量≤ 10 kg、単一繊維直径≤ 1 μ m、欠陥なしを達成し、微小隕石+雷+原子酸素に耐えることができます。',
    formalEs: 'Alcance un cable de ≥ 36000 km de longitud: resistencia a la tracción ≥ 60 GPa, densidad ≤ 1,3 g/cm³, masa total ≤ 10⁷ kg, diámetro de fibra única ≤ 1 μm y sin defectos, y puede soportar micrometeoritos + rayos + oxígeno atómico.',
    formalEn: 'Achieve ≥ 36000 km length cable: tensile strength ≥ 60 GPa, density ≤ 1.3 g/cm³, total mass ≤ 10⁷ kg, single fiber diameter ≤ 1 μm and no defects, and can withstand micrometeorites + lightning + atomic oxygen.',
    whyHard: '需要比钢强 50 倍的轻质材料（碳纳米管/石墨烯）。',
    aiPrompt: '介绍石墨烯、CNT、ISD（电动力学太空电梯）。',
    tags: ['太空', '材料', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Space Elevator',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: 'CNT 拉伸测试' }, { type: 'code', label: '写代码/算法', desc: '动力学模拟' }, { type: 'essay', label: '写文章/论文', desc: '介绍太空电梯历史' }]
  },
  {
    id: 'desalination',
    category: 'engineering',
    title: '廉价海水淡化',
    titleJa: '安価な海水淡水化',
    titleEs: 'Desalación con < 0,5 USD/m³ y consumo de energía < 1 kWh/m³.',
    titleEn: 'Cheap Desalination',
    year: 1950,
    proposer: '—',
    difficulty: 3,
    reward: 2000,
    status: 'open',
    summary: '把海水变饮用水，便宜到大家用得起',
    summaryJa: '海水を飲料水に変えることは、誰もが使用できるほど安価です',
    summaryEs: 'Desalación con < 0,5 USD/m³ y consumo de energía < 1 kWh/m³.',
    summaryEn: 'Desalination with < 0.5 USD/m³ and energy consumption < 1 kWh/m³.',
    kid: '地球 71% 是水，但 97% 是咸的不能喝。20 亿人缺干净水。能不能把海水变成饮用水，便宜到大家都用得起？现在能淡化海水，但每吨要 1-3 美元。',
    formal: '< 0.5 美元/m³、能耗 < 1 kWh/m³ 的海水淡化。',
    formalJa: '海水の淡水化< 0.5 USD/m ³、エネルギー消費量< 1 kWh/m ³。',
    formalEs: 'Desalación con < 0,5 USD/m³ y consumo de energía < 1 kWh/m³.',
    formalEn: 'Desalination with < 0.5 USD/m³ and energy consumption < 1 kWh/m³.',
    whyHard: '膜污染和能耗。',
    aiPrompt: '介绍反渗透、电容去离子、正渗透。',
    tags: ['水', '能源', '膜'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Desalination',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '新型膜材料' }, { type: 'essay', label: '写文章/论文', desc: '介绍水危机' }, { type: 'fund', label: '资助/投资', desc: '给水公益捐资' }]
  },
  {
    id: 'reusable-rocket',
    category: 'engineering',
    title: '完全可重复火箭',
    titleJa: '完全に繰り返し可能なロケット',
    titleEs: 'Vehículo de lanzamiento de clase orbital: costo de lanzamiento único ≤ US$ 1000/kg LEO, ≥ 100 reutilizaciones sin revisión (sólo inspección periódica < 100 horas), tiempo de respuesta de revisión ≤ 7 días, confiabilidad ≥ 99,5%.',
    titleEn: 'Fully Reusable Rocket',
    year: 2015,
    proposer: 'SpaceX',
    difficulty: 4,
    reward: 2000,
    status: 'partially_solved',
    summary: '让火箭像飞机一样重复使用',
    summaryJa: 'ロケットを飛行機のように再利用する',
    summaryEs: 'Vehículo de lanzamiento de clase orbital: costo de lanzamiento único ≤ US$ 1000/kg LEO, ≥ 100 reutilizaciones sin revisión (sólo inspección periódica < 100 horas), tiempo de respuesta de revisión ≤ 7 días, confiabilidad ≥ 99,5%.',
    summaryEn: 'Orbital-class launch vehicle: single launch cost ≤ US$1000/kg LEO, ≥ 100 reuses without overhaul (only periodic inspection < 100 hours), overhaul turnaround time ≤ 7 days, reliability ≥ 99.5%.',
    kid: '火箭现在每用一次就扔掉（像纸飞机）。SpaceX 已经在回收部分火箭了。如果整支火箭（连上面级）都能完全重复使用，进太空的成本会大幅降低。',
    formal: '轨道级运载火箭：单次发射成本 ≤ 1000 美元/公斤 LEO、≥ 100 次重复使用且无需大修（仅定期检测 < 100 小时）、翻修周转时间 ≤ 7 天、可靠性 ≥ 99.5%。',
    formalJa: '軌道クラスの打ち上げロケット：単回打ち上げコスト≤$ 1000/kg LEO、大規模なオーバーホールなしで≥ 100回の再利用（定期点検のみ< 100時間）、修理所要時間≤ 7日、信頼性≥ 99.5%。',
    formalEs: 'Vehículo de lanzamiento de clase orbital: costo de lanzamiento único ≤ US$ 1000/kg LEO, ≥ 100 reutilizaciones sin revisión (sólo inspección periódica < 100 horas), tiempo de respuesta de revisión ≤ 7 días, confiabilidad ≥ 99,5%.',
    formalEn: 'Orbital-class launch vehicle: single launch cost ≤ US$1000/kg LEO, ≥ 100 reuses without overhaul (only periodic inspection < 100 hours), overhaul turnaround time ≤ 7 days, reliability ≥ 99.5%.',
    whyHard: '热防护和发动机寿命。',
    aiPrompt: '介绍 SpaceX Starship、Raptor 引擎。',
    tags: ['太空', '工程', '火箭'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Reusable Rocket',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 SpaceX 故事' }, { type: 'fund', label: '资助/投资', desc: '关注相关公司' }]
  },
  {
    id: 'bci',
    category: 'engineering',
    title: '脑机接口',
    titleJa: 'ブレインコンピュータインターフェース',
    titleEs: 'BCI no invasivo: velocidad de transmisión de información ≥ 1 Mbps (más de 100 palabras/minuto), uso a largo plazo (≥ 5 años), estabilidad de la señal < 10% de atenuación, electrodos/sistemas inofensivos para los usuarios y puede controlar computadoras/teléfonos móviles comunes (cursor + entrada de texto).',
    titleEn: 'Brain-Computer Interface',
    year: 2016,
    proposer: 'E. Musk / Neuralink',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '用脑子直接控制电脑',
    summaryJa: '脳を使ってコンピューターを直接制御する',
    summaryEs: 'BCI no invasivo: velocidad de transmisión de información ≥ 1 Mbps (más de 100 palabras/minuto), uso a largo plazo (≥ 5 años), estabilidad de la señal < 10% de atenuación, electrodos/sistemas inofensivos para los usuarios y puede controlar computadoras/teléfonos móviles comunes (cursor + entrada de texto).',
    summaryEn: 'Non-invasive BCI: information transmission rate ≥ 1 Mbps (more than 100 words/minute), long-term use (≥ 5 years) signal stability < 10% attenuation, electrodes/systems harmless to users, and can control ordinary computers/mobile phones (cursor + text input).',
    kid: '你脑子里想的事能不能直接传到电脑？现在 Neuralink 等公司可以让你"用脑子打字"，但很慢。能不能达到"想到什么，电脑就打出什么"的速度？',
    formal: '非侵入式 BCI：信息传输率 ≥ 1 Mbps (100 字/分钟以上)、长期使用 (≥ 5 年) 信号稳定性 < 10% 衰减、电极/系统对用户无伤害、且可控制普通计算机/手机 (光标 + 文字输入)。',
    formalJa: '非侵襲的BCI ：情報伝送速度≥ 1 Mbps （ 100ワード/分以上）、長期使用（≥ 5年）信号安定性< 10 ％減衰、電極/システムのユーザーに害を与えず、通常のコンピュータ/携帯電話（カーソル+テキスト入力）を制御できます。',
    formalEs: 'BCI no invasivo: velocidad de transmisión de información ≥ 1 Mbps (más de 100 palabras/minuto), uso a largo plazo (≥ 5 años), estabilidad de la señal < 10% de atenuación, electrodos/sistemas inofensivos para los usuarios y puede controlar computadoras/teléfonos móviles comunes (cursor + entrada de texto).',
    formalEn: 'Non-invasive BCI: information transmission rate ≥ 1 Mbps (more than 100 words/minute), long-term use (≥ 5 years) signal stability < 10% attenuation, electrodes/systems harmless to users, and can control ordinary computers/mobile phones (cursor + text input).',
    whyHard: '电极寿命和带宽。',
    aiPrompt: '介绍 Neuralink、Synchron、Blackrock。',
    tags: ['神经', '工程', 'AI'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'BCI',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 BCI 伦理' }, { type: 'fund', label: '资助/投资', desc: '给相关公司投资' }]
  },
  {
    id: 'cheap-solar-fuel',
    category: 'engineering',
    title: '人造叶子',
    titleJa: '人工葉',
    titleEs: 'Dispositivo fotosintético artificial: eficiencia de energía solar a combustible (STF) ≥ 10 %, funcionamiento estable ≥ 1000 horas (atenuación < 10 %), selectividad del producto (H₂/CH₃OH) ≥ 90 %, rendimiento ≥ 1 g/kWh y solo se utilizan catalizadores de elementos de alto rendimiento.',
    titleEn: 'Artificial Leaf',
    year: 2011,
    proposer: 'D. Nocera',
    difficulty: 4,
    reward: 2000,
    status: 'partially_solved',
    summary: '用阳光直接把水变燃料',
    summaryJa: '太陽光で直接水を燃料に変換',
    summaryEs: 'Dispositivo fotosintético artificial: eficiencia de energía solar a combustible (STF) ≥ 10 %, funcionamiento estable ≥ 1000 horas (atenuación < 10 %), selectividad del producto (H₂/CH₃OH) ≥ 90 %, rendimiento ≥ 1 g/kWh y solo se utilizan catalizadores de elementos de alto rendimiento.',
    summaryEn: 'Artificial photosynthetic device: Solar-to-fuel efficiency (STF) ≥ 10%, stable operation ≥ 1000 hours (attenuation < 10%), product (H₂/CH₃OH) selectivity ≥ 90%, yield ≥ 1 g/kWh, and only high-yield element catalysts are used.',
    kid: '植物能用阳光、水和二氧化碳做糖（燃料）。我们能不能造一个"人造叶子"，用阳光直接把水变成氢气（清洁燃料）？这能让太阳能变成可储存的燃料。',
    formal: '人造光合器件：太阳能-燃料效率 (STF) ≥ 10%、稳定运行 ≥ 1000 小时（衰减 < 10%）、产物 (H₂/CH₃OH) 选择性 ≥ 90%、产率 ≥ 1 g/kWh、且仅用丰产元素催化剂。',
    formalJa: '人工光合成デバイス：太陽エネルギー燃料効率（ STF ） ≥ 10 ％、安定動作≥ 1000時間（減衰< 10 ％ ）、生成物（ H ₂/CH ² OH ）選択性≥ 90 ％、収率≥ 1 g/kWh、および高収率元素触媒のみを使用する。',
    formalEs: 'Dispositivo fotosintético artificial: eficiencia de energía solar a combustible (STF) ≥ 10 %, funcionamiento estable ≥ 1000 horas (atenuación < 10 %), selectividad del producto (H₂/CH₃OH) ≥ 90 %, rendimiento ≥ 1 g/kWh y solo se utilizan catalizadores de elementos de alto rendimiento.',
    formalEn: 'Artificial photosynthetic device: Solar-to-fuel efficiency (STF) ≥ 10%, stable operation ≥ 1000 hours (attenuation < 10%), product (H₂/CH₃OH) selectivity ≥ 90%, yield ≥ 1 g/kWh, and only high-yield element catalysts are used.',
    whyHard: '催化剂稳定性和效率。',
    aiPrompt: '介绍 Nocera 工作。',
    tags: ['能源', '催化', '仿生'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Artificial Leaf',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '优化催化剂' }, { type: 'essay', label: '写文章/论文', desc: '介绍仿生技术' }]
  },
  {
    id: 'mr-safe-mri',
    category: 'engineering',
    title: '便宜便携 MRI',
    titleJa: '安価でポータブルなMRI',
    titleEs: 'Resonancia magnética de alta calidad <$50 000, <50 kg, <5 mT de intensidad de campo.',
    titleEn: 'Cheap Portable MRI',
    year: 2020,
    proposer: '—',
    difficulty: 3,
    reward: 1000,
    status: 'open',
    summary: '让 MRI 走进基层医院',
    summaryJa: 'MRIを草の根に',
    summaryEs: 'Resonancia magnética de alta calidad <$50 000, <50 kg, <5 mT de intensidad de campo.',
    summaryEn: 'High quality MRI < $50,000, < 50 kg, < 5 mT field strength.',
    kid: '现在医院里的 MRI 又大又贵（一台几百万美元），还要用稀有的氦气。能不能做出便宜、轻便的版本，让基层医院甚至救护车都能用？',
    formal: '< 50,000 美元、< 50 kg、< 5 mT 场强的高质量 MRI。',
    formalJa: '50,000 USD未満、50 kg未満、5 mT未満の電界強度を有する高品質MRI。',
    formalEs: 'Resonancia magnética de alta calidad <$50 000, <50 kg, <5 mT de intensidad de campo.',
    formalEn: 'High quality MRI < $50,000, < 50 kg, < 5 mT field strength.',
    whyHard: '低场强下图像质量。',
    aiPrompt: '介绍 Hyperfine、Swoop。',
    tags: ['医疗', '工程', '设备'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Portable MRI',
    videoChannel: 'Veritasium',
    participate: [{ type: 'experiment', label: '动手实验', desc: '低场强成像' }, { type: 'essay', label: '写文章/论文', desc: '介绍 MRI 历史' }]
  },
  {
    id: 'hydrogen-storage',
    category: 'engineering',
    title: '常温常压储氢',
    titleJa: '大気中の温度と圧力での水素貯蔵',
    titleEs: 'Sistema de almacenamiento de hidrógeno: densidad de peso ≥ 7% en peso, densidad de volumen ≥ 70 g/L, ciclo reversible ≥ 500 veces (sin atenuación significativa), seguro (sin fugas/explosiones) en el rango de -40°C ~ 60°C, 0,1-100 atm y costo de almacenamiento de hidrógeno por kg único ≤ USD 300.',
    titleEn: 'Hydrogen Storage at Ambient Conditions',
    year: 2020,
    proposer: '—',
    difficulty: 4,
    reward: 2500,
    status: 'open',
    summary: '把氢气像汽油一样安全便宜地存起来',
    summaryJa: 'ガソリンと同じくらい安全かつ安価に水素を貯蔵する',
    summaryEs: 'Sistema de almacenamiento de hidrógeno: densidad de peso ≥ 7% en peso, densidad de volumen ≥ 70 g/L, ciclo reversible ≥ 500 veces (sin atenuación significativa), seguro (sin fugas/explosiones) en el rango de -40°C ~ 60°C, 0,1-100 atm y costo de almacenamiento de hidrógeno por kg único ≤ USD 300.',
    summaryEn: 'Hydrogen storage system: weight density ≥ 7 wt%, volume density ≥ 70 g/L, reversible cycle ≥ 500 times (no significant attenuation), safe (no leakage/explosion) in the range of -40°C ~ 60°C, 0.1-100 atm, and single kg hydrogen storage cost ≤ US$300.',
    kid: '氢是清洁能源的明星，但很难存——要 700 倍大气压或者零下 253°C 液氢。能不能像加油一样方便地存？',
    formal: '储氢系统：重量密度 ≥ 7 wt%、体积密度 ≥ 70 g/L、可逆循环 ≥ 500 次（无显著衰减）、在 -40°C ~ 60°C、0.1-100 atm 范围内安全（无泄漏/爆炸）、且单 kg 储氢成本 ≤ 300 美元。',
    formalJa: '水素貯蔵システム：重量密度≥ 7重量％、体積密度≥ 70 g/L、可逆サイクル≥ 500回（有意な減衰なし）、-40°C〜60°Cで安全、0.1〜100気圧（漏れ/爆発なし）、および水素貯蔵1 kgあたりのコスト≤ 300ドル。',
    formalEs: 'Sistema de almacenamiento de hidrógeno: densidad de peso ≥ 7% en peso, densidad de volumen ≥ 70 g/L, ciclo reversible ≥ 500 veces (sin atenuación significativa), seguro (sin fugas/explosiones) en el rango de -40°C ~ 60°C, 0,1-100 atm y costo de almacenamiento de hidrógeno por kg único ≤ USD 300.',
    formalEn: 'Hydrogen storage system: weight density ≥ 7 wt%, volume density ≥ 70 g/L, reversible cycle ≥ 500 times (no significant attenuation), safe (no leakage/explosion) in the range of -40°C ~ 60°C, 0.1-100 atm, and single kg hydrogen storage cost ≤ US$300.',
    whyHard: '需要新型 MOF、化学氢化物或纳米材料。',
    aiPrompt: '介绍 MOF、LOHC、地下储氢、DOE 2025 目标。',
    tags: ['能源', '氢', '材料'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Hydrogen Storage',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '新型 MOF' }, { type: 'code', label: '写代码/算法', desc: 'DFT 模拟储氢' }, { type: 'essay', label: '写文章/论文', desc: '介绍氢经济' }]
  },
  {
    id: 'carbon-capture-eng',
    category: 'engineering',
    title: '直接空气捕碳',
    titleJa: 'ダイレクトエアカーボンキャプチャ',
    titleEs: '< $100/tonelada sistema DAC, consumo de energía < 1,5 MWh/tonelada.',
    titleEn: 'Direct Air Capture (DAC)',
    year: 2018,
    proposer: 'Climeworks',
    difficulty: 4,
    reward: 3000,
    status: 'open',
    summary: '从空气中直接抓 CO₂',
    summaryJa: '空気中からCO ₂を直接取り込む',
    summaryEs: '< $100/tonelada sistema DAC, consumo de energía < 1,5 MWh/tonelada.',
    summaryEn: '< $100/ton DAC system, energy consumption < 1.5 MWh/ton.',
    kid: '直接空气捕碳（DAC）机已经从空气抓 CO₂。但现在每吨 CO₂ 成本 600-1000 美元。能不能降到 100 美元？',
    formal: '< 100 美元/吨的 DAC 系统，能耗 < 1.5 MWh/吨。',
    formalJa: '<$ 100/t DACシステム、エネルギー消費量< 1.5 MWh/t。',
    formalEs: '< $100/tonelada sistema DAC, consumo de energía < 1,5 MWh/tonelada.',
    formalEn: '< $100/ton DAC system, energy consumption < 1.5 MWh/ton.',
    whyHard: '空气中 CO₂ 太稀。',
    aiPrompt: '介绍 Climeworks、Carbon Engineering。',
    tags: ['气候', '工程', '能源'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'DAC',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '新型吸附剂' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Climeworks 故事' }]
  },
  {
    id: 'nuclear-waste',
    category: 'engineering',
    title: '核废料长期处置',
    titleJa: '核廃棄物の長期処分',
    titleEs: 'Eliminación de desechos nucleares (combustible gastado de alto nivel): desempeño de sellado ≥ 10⁵ años, cualquiera de las opciones geológicas/marinas/espaciales y aprobación de la revisión de seguridad a largo plazo de la OIEA, riesgo de fuga < 10⁻⁶ / 10⁵ años y costo total de eliminación ≤ 5% de los ingresos de generación de energía.',
    titleEn: 'Long-term Nuclear Waste Disposal',
    year: 1980,
    proposer: '—',
    difficulty: 3,
    reward: 1500,
    status: 'open',
    summary: '让核废料 10 万年安全',
    summaryJa: '核廃棄物を10万年にわたって安全にする',
    summaryEs: 'Eliminación de desechos nucleares (combustible gastado de alto nivel): desempeño de sellado ≥ 10⁵ años, cualquiera de las opciones geológicas/marinas/espaciales y aprobación de la revisión de seguridad a largo plazo de la OIEA, riesgo de fuga < 10⁻⁶ / 10⁵ años y costo total de eliminación ≤ 5% de los ingresos de generación de energía.',
    summaryEn: 'Nuclear waste (high-level spent fuel) disposal: sealing performance ≥ 10⁵ years, any one of the geological/marine/space options and passing the IAEA long-term safety review, leakage risk < 10⁻⁶ / 10⁵ years, and total disposal cost ≤ 5% of power generation revenue.',
    kid: '核电站产生的废料放射性可持续几十万年。需要找到方法安全隔离它们。Onkalo（芬兰）和 Yucca Mountain（美国）是尝试。',
    formal: '核废料（高放乏燃料）处置：密封性 ≥ 10⁵ 年、在地质/海洋/太空方案中任选一个且通过 IAEA 长期安全审查、泄漏风险 < 10⁻⁶ / 10⁵ 年、且处置总成本 ≤ 发电收入 5%。',
    formalJa: '核廃棄物（高使用量燃料）の廃棄： 10年以上のシール性、地質/海洋/宇宙のいずれかのオプション、およびIAEAの長期安全性レビュー、10年/10年未満の漏れリスク、および総廃棄コストが発電収益の5 ％未満。',
    formalEs: 'Eliminación de desechos nucleares (combustible gastado de alto nivel): desempeño de sellado ≥ 10⁵ años, cualquiera de las opciones geológicas/marinas/espaciales y aprobación de la revisión de seguridad a largo plazo de la OIEA, riesgo de fuga < 10⁻⁶ / 10⁵ años y costo total de eliminación ≤ 5% de los ingresos de generación de energía.',
    formalEn: 'Nuclear waste (high-level spent fuel) disposal: sealing performance ≥ 10⁵ years, any one of the geological/marine/space options and passing the IAEA long-term safety review, leakage risk < 10⁻⁶ / 10⁵ years, and total disposal cost ≤ 5% of power generation revenue.',
    whyHard: '地质长期稳定性。',
    aiPrompt: '介绍 Onkalo、Yucca Mountain。',
    tags: ['核', '工程', '环境'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Nuclear Waste',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍核废料挑战' }, { type: 'fund', label: '资助/投资', desc: '关注问题' }]
  },
  {
    id: 'asteroid-mining',
    category: 'engineering',
    title: '小行星采矿',
    titleJa: '小惑星採鉱',
    titleEs: 'Minería de recursos de asteroides: una sola misión transporta de regreso a la Tierra materiales ≥ 1000 kg, costo total < 1 millón de dólares estadounidenses/kg (incluido lanzamiento/extracción/retorno), ingresos netos (metal de alto valor Pt/Au/Co) ≥ 10 veces el costo y no viola los tratados sobre el espacio ultraterrestre.',
    titleEn: 'Asteroid Mining',
    year: 2012,
    proposer: 'Planetary Resources',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '从小行星上挖矿',
    summaryJa: '小惑星から採鉱',
    summaryEs: 'Minería de recursos de asteroides: una sola misión transporta de regreso a la Tierra materiales ≥ 1000 kg, costo total < 1 millón de dólares estadounidenses/kg (incluido lanzamiento/extracción/retorno), ingresos netos (metal de alto valor Pt/Au/Co) ≥ 10 veces el costo y no viola los tratados sobre el espacio ultraterrestre.',
    summaryEn: 'Asteroid resource mining: A single mission transports back to Earth materials ≥ 1000 kg, full cost < 1 million US dollars/kg (including launch/mining/return), net income (high-value metal Pt/Au/Co) ≥ 10x cost, and does not violate outer space treaties.',
    kid: '近地小行星含有大量铂、金、稀土。能不能派机器人去挖？已成立多家公司。',
    formal: '小行星资源开采：单次任务运回地球物质 ≥ 1000 kg、全成本 < 100 万美元/kg（含发射/采矿/返回）、净收益（高价值金属 Pt/Au/Co）≥ 10x 成本、且不违反外空条约。',
    formalJa: '小惑星資源採掘： 1000 kg以上の地球物質を返却する単一のミッション、総費用は100万ドル/kg未満（打ち上げ/採掘/返却を含む）、正味利益（高価値金属Pt/Au/Co ）は10倍以上のコストであり、宇宙条約に違反していません。',
    formalEs: 'Minería de recursos de asteroides: una sola misión transporta de regreso a la Tierra materiales ≥ 1000 kg, costo total < 1 millón de dólares estadounidenses/kg (incluido lanzamiento/extracción/retorno), ingresos netos (metal de alto valor Pt/Au/Co) ≥ 10 veces el costo y no viola los tratados sobre el espacio ultraterrestre.',
    formalEn: 'Asteroid resource mining: A single mission transports back to Earth materials ≥ 1000 kg, full cost < 1 million US dollars/kg (including launch/mining/return), net income (high-value metal Pt/Au/Co) ≥ 10x cost, and does not violate outer space treaties.',
    whyHard: '空间推进和自主机器人。',
    aiPrompt: '介绍 Planetary Resources、Asteroid Mining Corp。',
    tags: ['太空', '工程', '资源'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Asteroid Mining',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍空间采矿' }, { type: 'fund', label: '资助/投资', desc: '关注公司' }]
  },
  {
    id: 'floating-cities',
    category: 'engineering',
    title: '海上漂浮城市',
    titleJa: '海上の水上都市',
    titleEs: 'Comunidad flotante autosuficiente: residencia de larga duración ≥ 1.000 personas, 100% energía renovable (energía solar/olas/corrientes oceánicas), agua dulce autosuficiente (desalinización), resistente a olas de 10 metros + terremotos de magnitud 7, costos operativos ≤ 1,5 veces los de las ciudades terrestres.',
    titleEn: 'Floating Cities',
    year: 2019,
    proposer: '—',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '在海上建城市以应对海平面上升',
    summaryJa: '海面上昇に対抗するための海上都市づくり',
    summaryEs: 'Comunidad flotante autosuficiente: residencia de larga duración ≥ 1.000 personas, 100% energía renovable (energía solar/olas/corrientes oceánicas), agua dulce autosuficiente (desalinización), resistente a olas de 10 metros + terremotos de magnitud 7, costos operativos ≤ 1,5 veces los de las ciudades terrestres.',
    summaryEn: 'Self-sufficient floating community: ≥ 1,000 people long-term residence, 100% renewable energy (solar energy/waves/ocean currents), self-sufficient fresh water (desalination), resistant to 10-meter waves + 7-magnitude earthquakes, operating costs ≤ 1.5 times that of land cities.',
    kid: '海平面上升让一些岛国消失。能不能在海上建漂浮城市？Ocean Builders 已在建。',
    formal: '自给式海上漂浮社区：≥ 1000 人长期居住、100% 可再生能源（太阳能/波浪/海流）、淡水自给（海水淡化）、抗 10 米巨浪 + 7 级地震、运行成本 ≤ 陆地城市 1.5 倍。',
    formalJa: '自己完結型の浮遊海洋コミュニティ： 1000人以上の長期滞在、100 ％再生可能エネルギー（太陽エネルギー/波/電流）、淡水自給率（海水の淡水化）、10メートルの大波+マグニチュード7の地震への耐性、運用コストは陸上都市の1.5倍以下。',
    formalEs: 'Comunidad flotante autosuficiente: residencia de larga duración ≥ 1.000 personas, 100% energía renovable (energía solar/olas/corrientes oceánicas), agua dulce autosuficiente (desalinización), resistente a olas de 10 metros + terremotos de magnitud 7, costos operativos ≤ 1,5 veces los de las ciudades terrestres.',
    formalEn: 'Self-sufficient floating community: ≥ 1,000 people long-term residence, 100% renewable energy (solar energy/waves/ocean currents), self-sufficient fresh water (desalination), resistant to 10-meter waves + 7-magnitude earthquakes, operating costs ≤ 1.5 times that of land cities.',
    whyHard: '极端天气、合法地位。',
    aiPrompt: '介绍 Ocean Builders、Seasteading Institute。',
    tags: ['城市', '工程', '气候'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Floating City',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍海上城市' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'earthquake-pred',
    category: 'engineering',
    title: '地震预测',
    titleJa: '地震予報',
    titleEs: 'Sistema de predicción de terremotos: para terremotos con magnitud ≥ 5,0, la precisión de la predicción es ≥ 80 %, el tiempo de anticipación es ≥ 1 día, la precisión espacial es ≤ 50 km, la tasa de falsas alarmas es < 10 % y es válido para al menos 3 verificaciones diferentes de límites de placas.',
    titleEn: 'Earthquake Prediction',
    year: 1975,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '能不能在地震前几小时/几天知道？',
    summaryJa: '地震の何時間/何日前か教えていただけますか？',
    summaryEs: 'Sistema de predicción de terremotos: para terremotos con magnitud ≥ 5,0, la precisión de la predicción es ≥ 80 %, el tiempo de anticipación es ≥ 1 día, la precisión espacial es ≤ 50 km, la tasa de falsas alarmas es < 10 % y es válido para al menos 3 verificaciones diferentes de límites de placas.',
    summaryEn: 'Earthquake prediction system: For earthquakes with magnitude ≥ 5.0, the prediction accuracy is ≥ 80%, the lead time is ≥ 1 day, the spatial accuracy is ≤ 50 km, the false alarm rate is < 10%, and it is valid for at least 3 different plate boundary verifications.',
    kid: '1975 年中国海城地震被成功预测。但绝大多数地震预测都不成功。能不能找到可靠的"前兆"？',
    formal: '地震预测系统：震级 ≥ 5.0 地震的预测准确率 ≥ 80%、提前时间 ≥ 1 天、空间精度 ≤ 50 km、误报率 < 10%、且对至少 3 个不同板块边界验证有效。',
    formalJa: '地震予測システム：マグニチュード5.0以上の地震の予測精度は80 ％以上、前進時間は1日以上、空間精度は50 km以下、誤警報率は10 ％未満で、少なくとも3つの異なるプレート境界で有効です。',
    formalEs: 'Sistema de predicción de terremotos: para terremotos con magnitud ≥ 5,0, la precisión de la predicción es ≥ 80 %, el tiempo de anticipación es ≥ 1 día, la precisión espacial es ≤ 50 km, la tasa de falsas alarmas es < 10 % y es válido para al menos 3 verificaciones diferentes de límites de placas.',
    formalEn: 'Earthquake prediction system: For earthquakes with magnitude ≥ 5.0, the prediction accuracy is ≥ 80%, the lead time is ≥ 1 day, the spatial accuracy is ≤ 50 km, the false alarm rate is < 10%, and it is valid for at least 3 different plate boundary verifications.',
    whyHard: '地震是非线性混沌。',
    aiPrompt: '介绍 Haicheng、Parkfield 试验。',
    tags: ['地震', '地球', '预测'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Earthquake Prediction',
    videoChannel: 'Veritasium',
    participate: [{ type: 'experiment', label: '动手实验', desc: 'GPS 数据分析' }, { type: 'code', label: '写代码/算法', desc: 'ML 模型' }, { type: 'essay', label: '写文章/论文', desc: '介绍海城地震' }]
  },
  {
    id: 'self-healing-infra',
    category: 'engineering',
    title: '自修复基础设施',
    titleJa: '自己修復インフラストラクチャ',
    titleEs: 'Concreto/revestimiento autorreparable: Puede curar completamente grietas de ≤ 0,5 mm de ancho (recuperación de resistencia ≥ 95%), reparación completa en 28 días, prolongar la vida útil en ≥ 50% y el mecanismo de reparación sigue siendo efectivo después de ≥ 3 ciclos de congelación y descongelación.',
    titleEn: 'Self-Healing Infrastructure',
    year: 2010,
    proposer: 'H. Jonkers',
    difficulty: 3,
    reward: 1500,
    status: 'partially_solved',
    summary: '让混凝土自己修复裂缝',
    summaryJa: 'コンクリートに亀裂を自力で修正させましょう',
    summaryEs: 'Concreto/revestimiento autorreparable: Puede curar completamente grietas de ≤ 0,5 mm de ancho (recuperación de resistencia ≥ 95%), reparación completa en 28 días, prolongar la vida útil en ≥ 50% y el mecanismo de reparación sigue siendo efectivo después de ≥ 3 ciclos de congelación y descongelación.',
    summaryEn: 'Self-healing concrete/coating: Can completely heal ≤ 0.5 mm wide cracks (strength recovery ≥ 95%), complete repair within 28 days, extend life by ≥ 50%, and repair mechanism remains effective after ≥ 3 freeze-thaw cycles.',
    kid: '混凝土的裂缝很难发现也难修。如果混凝土里混入"细菌"——当裂缝出现、空气进来时细菌就开始"长出"方解石把裂缝填满——这叫自修复混凝土。',
    formal: '自修复混凝土/涂层：能完全愈合 ≤ 0.5 mm 宽裂缝（强度恢复 ≥ 95%）、在 28 天内完成修复、寿命延长 ≥ 50%、且修复机制在 ≥ 3 次冻融循环后仍有效。',
    formalJa: '自己修復コンクリート/コーティング： 0.5mm以下の幅のひび割れ（強度回復95 ％以上）を完全に治癒し、28日以内に修復、寿命延長50 ％以上、修復メカニズムは3回以上の凍結融解サイクル後も有効です。',
    formalEs: 'Concreto/revestimiento autorreparable: Puede curar completamente grietas de ≤ 0,5 mm de ancho (recuperación de resistencia ≥ 95%), reparación completa en 28 días, prolongar la vida útil en ≥ 50% y el mecanismo de reparación sigue siendo efectivo después de ≥ 3 ciclos de congelación y descongelación.',
    formalEn: 'Self-healing concrete/coating: Can completely heal ≤ 0.5 mm wide cracks (strength recovery ≥ 95%), complete repair within 28 days, extend life by ≥ 50%, and repair mechanism remains effective after ≥ 3 freeze-thaw cycles.',
    whyHard: '细菌存活和活性控制。',
    aiPrompt: '介绍 Jonkers 工作、Basilisk Concrete。',
    tags: ['材料', '工程', '建筑'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Self Healing Concrete',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '细菌自愈混凝土' }, { type: 'essay', label: '写文章/论文', desc: '介绍自修复材料' }]
  },
  {
    id: 'programmable-matter',
    category: 'engineering',
    title: '可编程物质',
    titleJa: 'プログラマブル物質',
    titleEs: 'Materia programable (catoms): tamaño de unidad ≤ 1 cm, tiempo de respuesta ≤ 1 ms, controlable independientemente ≥ 10⁶ unidades para formar cualquier forma 3D, fuerza entre unidades ≥ 1 N y consumo total de energía < 100 W.',
    titleEn: 'Programmable Matter',
    year: 1991,
    proposer: 'T. Toffoli / N. Margolus',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '物质按程序改变形状',
    summaryJa: '物質は手順に従って形状を変化させる',
    summaryEs: 'Materia programable (catoms): tamaño de unidad ≤ 1 cm, tiempo de respuesta ≤ 1 ms, controlable independientemente ≥ 10⁶ unidades para formar cualquier forma 3D, fuerza entre unidades ≥ 1 N y consumo total de energía < 100 W.',
    summaryEn: 'Programmable matter (catoms): unit size ≤ 1 cm, response time ≤ 1 ms, independently controllable ≥ 10⁶ units to form any 3D shape, inter-unit force ≥ 1 N, and total energy consumption < 100 W.',
    kid: '如果你能造出一种物质，让它根据程序变成椅子、桌子、墙……这种"可编程物质"由无数微小"catom"组成。',
    formal: '可编程物质（catoms）：单元尺寸 ≤ 1 cm、响应时间 ≤ 1 ms、可独立控制 ≥ 10⁶ 单元形成任意 3D 形状、单元间作用力 ≥ 1 N、且总能耗 < 100 W。',
    formalJa: 'プログラム可能な材料（ catoms ） ：ユニットサイズ≤ 1 cm、応答時間≤ 1 ms、任意の3 D形状を形成するために独立して制御可能な≥ 10 ³ユニット、ユニット間力≥ 1 N、および総エネルギー消費量< 100 W。',
    formalEs: 'Materia programable (catoms): tamaño de unidad ≤ 1 cm, tiempo de respuesta ≤ 1 ms, controlable independientemente ≥ 10⁶ unidades para formar cualquier forma 3D, fuerza entre unidades ≥ 1 N y consumo total de energía < 100 W.',
    formalEn: 'Programmable matter (catoms): unit size ≤ 1 cm, response time ≤ 1 ms, independently controllable ≥ 10⁶ units to form any 3D shape, inter-unit force ≥ 1 N, and total energy consumption < 100 W.',
    whyHard: '能量、计算、力学。',
    aiPrompt: '介绍 Claytronics、Smarticles。',
    tags: ['材料', '机器人', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Programmable Matter',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 Claytronics' }, { type: 'experiment', label: '动手实验', desc: '搭建 Smarticle' }]
  },
  {
    id: 'vertical-farming',
    category: 'engineering',
    title: '垂直农业规模化',
    titleJa: '大規模な垂直農業',
    titleEs: 'Granja vertical urbana: producción de alimentos ≥ 90% de la demanda urbana, retorno de la inversión energética (energía de salida/energía de entrada) ≥ 1, costo operativo ≤ 1,5 veces el de la agricultura tradicional y factibilidad demostrada en ≥ 5 zonas climáticas diferentes.',
    titleEn: 'Vertical Farming at Scale',
    year: 2012,
    proposer: '—',
    difficulty: 3,
    reward: 1500,
    status: 'partially_solved',
    summary: '用摩天大楼种粮食',
    summaryJa: '高層ビルで食材を育てよう',
    summaryEs: 'Granja vertical urbana: producción de alimentos ≥ 90% de la demanda urbana, retorno de la inversión energética (energía de salida/energía de entrada) ≥ 1, costo operativo ≤ 1,5 veces el de la agricultura tradicional y factibilidad demostrada en ≥ 5 zonas climáticas diferentes.',
    summaryEn: 'Urban vertical farm: food output ≥ 90% of urban demand, energy ROI (output energy / input energy) ≥ 1, operating cost ≤ 1.5 times that of traditional agriculture, and proven feasible in ≥ 5 different climate zones.',
    kid: '在城市里建摩天大楼，室内多层种庄稼，用 LED 灯、营养液。理论上单位面积产量比传统农业高 10-20 倍。但目前只有生菜、草本等小作物能赚钱。',
    formal: '城市垂直农场：粮食产出 ≥ 城市需求 90%、能量 ROI (产出能量 / 输入能量) ≥ 1、运营成本 ≤ 传统农业 1.5 倍、且在 ≥ 5 个不同气候带验证可行。',
    formalJa: '都市垂直農場：穀物生産量は都市需要の90 ％以上、エネルギーROI （出力エネルギー/入力エネルギー）は1以上、運用コストは従来の農業の1.5倍以下であり、5つ以上の異なる気候帯で検証可能である。',
    formalEs: 'Granja vertical urbana: producción de alimentos ≥ 90% de la demanda urbana, retorno de la inversión energética (energía de salida/energía de entrada) ≥ 1, costo operativo ≤ 1,5 veces el de la agricultura tradicional y factibilidad demostrada en ≥ 5 zonas climáticas diferentes.',
    formalEn: 'Urban vertical farm: food output ≥ 90% of urban demand, energy ROI (output energy / input energy) ≥ 1, operating cost ≤ 1.5 times that of traditional agriculture, and proven feasible in ≥ 5 different climate zones.',
    whyHard: '能源成本、传粉困难。',
    aiPrompt: '介绍 AeroFarms、Plenty。',
    tags: ['农业', '城市', 'LED'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Vertical Farming',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '小型水培' }, { type: 'essay', label: '写文章/论文', desc: '介绍 AeroFarms 故事' }]
  },
  {
    id: 'lab-meat',
    category: 'engineering',
    title: '细胞培养肉',
    titleJa: '細胞培養肉',
    titleEs: '>< 10 dólares EE.UU./kg, producción a gran escala de carne cultivada con células.',
    titleEn: 'Cultured Meat',
    year: 2013,
    proposer: 'M. Post',
    difficulty: 3,
    reward: 1500,
    status: 'partially_solved',
    summary: '不杀动物就能吃到肉',
    summaryJa: '動物を殺さずに肉を食べる',
    summaryEs: '>< 10 dólares EE.UU./kg, producción a gran escala de carne cultivada con células.',
    summaryEn: '>< US$10/kg, large-scale production of cell-cultured meat.',
    kid: '从动物身上取一小块肌肉细胞，在培养液里让它们长成肉。理论上能完全替代传统养殖业——零温室气体、零屠杀。',
    formal: '>< 10 美元/公斤、规模化生产的细胞培养肉。',
    formalJa: '>< 10米ドル/kg、細胞培養肉の大規模生産。',
    formalEs: '>< 10 dólares EE.UU./kg, producción a gran escala de carne cultivada con células.',
    formalEn: '>< US$10/kg, large-scale production of cell-cultured meat.',
    whyHard: '培养液成本、规模化。',
    aiPrompt: '介绍 Upside Foods、Good Meat。',
    tags: ['食品', '工程', '伦理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Cultured Meat',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'fund', label: '资助/投资', desc: '关注公司' }, { type: 'essay', label: '写文章/论文', desc: '介绍细胞农业' }]
  },
  {
    id: 'synthetic-meat',
    category: 'engineering',
    title: '植物肉升级',
    titleJa: '植物肉アップグレード',
    titleEs: 'Carne cultivada con células: ≥ 80% de los consumidores no pueden distinguir entre lo real y lo falso en 5 pruebas sensoriales (vista/olor/sabor/textura/masticación), costo de producción ≤ $5/kg, retorno de la inversión de energía > 1 y sin ingredientes de origen animal.',
    titleEn: 'Plant-based Meat 2.0',
    year: 2016,
    proposer: 'Beyond Meat / Impossible',
    difficulty: 2,
    reward: 500,
    status: 'partially_solved',
    summary: '让植物肉和真肉难以区分',
    summaryJa: '植物肉と本物の肉の区別がつきにくい',
    summaryEs: 'Carne cultivada con células: ≥ 80% de los consumidores no pueden distinguir entre lo real y lo falso en 5 pruebas sensoriales (vista/olor/sabor/textura/masticación), costo de producción ≤ $5/kg, retorno de la inversión de energía > 1 y sin ingredientes de origen animal.',
    summaryEn: 'Cell-cultured meat: ≥ 80% consumers cannot tell the difference between real and fake in 5 sensory tests (sight/smell/taste/texture/chew), production cost ≤ $5/kg, energy ROI > 1, and no animal-derived ingredients.',
    kid: 'Beyond Meat、Impossible Foods 已经让植物汉堡在颜色、口感上和真肉很接近。能不能做到所有类型的肉？',
    formal: '细胞培养肉：在 5 项感官测试（视觉/嗅觉/味觉/质地/咀嚼）中让 ≥ 80% 消费者无法区分真假、生产成本 ≤ 5 美元/kg、能量 ROI > 1、且无动物源成分。',
    formalJa: '細胞培養肉： 5つの感覚テスト（視覚/嗅覚/味覚/質感/咀嚼）では、消費者の80 ％以上が真と偽を区別することは不可能であり、生産コストは5米ドル/kg以下であり、エネルギーROIは> 1であり、動物由来の成分はありません。',
    formalEs: 'Carne cultivada con células: ≥ 80% de los consumidores no pueden distinguir entre lo real y lo falso en 5 pruebas sensoriales (vista/olor/sabor/textura/masticación), costo de producción ≤ $5/kg, retorno de la inversión de energía > 1 y sin ingredientes de origen animal.',
    formalEn: 'Cell-cultured meat: ≥ 80% consumers cannot tell the difference between real and fake in 5 sensory tests (sight/smell/taste/texture/chew), production cost ≤ $5/kg, energy ROI > 1, and no animal-derived ingredients.',
    whyHard: '复杂肌肉纤维结构。',
    aiPrompt: '介绍 Impossible 2.0。',
    tags: ['食品', '植物', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Plant Meat',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'fund', label: '资助/投资', desc: '关注公司' }, { type: 'essay', label: '写文章/论文', desc: '介绍植物肉发展史' }]
  },
  {
    id: 'plastic-enzyme',
    category: 'engineering',
    title: '塑料吃酶规模化',
    titleJa: 'プラスチック食用酵素スケール',
    titleEs: 'Fábrica de enzimas degradantes de PET/PE: procesamiento en una sola planta ≥ 10 toneladas/día, costo < 1 USD/kg, pureza del monómero del producto ≥ 95 % reutilizable y 1 USD de entrada y salida ≥ 1 USD en productos.',
    titleEn: 'Plastic-Degrading Enzymes at Scale',
    year: 2016,
    proposer: '—',
    difficulty: 3,
    reward: 1500,
    status: 'open',
    summary: '用酶把塑料变原料',
    summaryJa: '酵素を使用してプラスチックを原材料に変換する',
    summaryEs: 'Fábrica de enzimas degradantes de PET/PE: procesamiento en una sola planta ≥ 10 toneladas/día, costo < 1 USD/kg, pureza del monómero del producto ≥ 95 % reutilizable y 1 USD de entrada y salida ≥ 1 USD en productos.',
    summaryEn: 'PET/PE degrading enzyme factory: single plant processing ≥ 10 tons/day, cost < 1 USD/kg, product monomer purity ≥ 95% reusable, and 1 USD input output ≥ 1 USD worth of products.',
    kid: '发现能吃 PET 的酶（PETase）后，怎么把它规模化到工业级别？',
    formal: 'PET/PE 降解酶工厂：单厂处理 ≥ 10 吨/天、成本 < 1 美元/公斤、产物单体纯度 ≥ 95% 可回用、且 1 美元投入产出 ≥ 1 美元价值产品。',
    formalJa: 'PET/PE分解酵素プラント：値が10トン/日以上、コストが1ドル/kg未満、製品モノマー純度が95 ％以上再利用可能、および1ドルの入出力が1ドル以上の製品。',
    formalEs: 'Fábrica de enzimas degradantes de PET/PE: procesamiento en una sola planta ≥ 10 toneladas/día, costo < 1 USD/kg, pureza del monómero del producto ≥ 95 % reutilizable y 1 USD de entrada y salida ≥ 1 USD en productos.',
    formalEn: 'PET/PE degrading enzyme factory: single plant processing ≥ 10 tons/day, cost < 1 USD/kg, product monomer purity ≥ 95% reusable, and 1 USD input output ≥ 1 USD worth of products.',
    whyHard: '酶活性和稳定性。',
    aiPrompt: '介绍 Carbios、Protein engineering。',
    tags: ['环境', '工程', '酶'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Plastic Enzyme',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'experiment', label: '动手实验', desc: '改造 PETase' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Carbios' }]
  },
  {
    id: 'self-driving-l5',
    category: 'engineering',
    title: 'L5 自动驾驶',
    titleJa: 'レベル5の自動操縦',
    titleEs: 'Conducción autónoma L5: sin necesidad de intervención humana en todas las condiciones legales de la carretera y en cualquier clima (lluvia/nieve/niebla/noche), tasa de accidentes <1/10 de los conductores humanos y verificado por 10⁹ kilómetros de carreteras reales + 10⁹ kilómetros de simulación.',
    titleEn: 'Level 5 Self-Driving',
    year: 2004,
    proposer: '—',
    difficulty: 5,
    reward: 3000,
    status: 'open',
    summary: '完全不用人管的自动驾驶',
    summaryJa: 'まったく人間の監督なしの自動運転',
    summaryEs: 'Conducción autónoma L5: sin necesidad de intervención humana en todas las condiciones legales de la carretera y en cualquier clima (lluvia/nieve/niebla/noche), tasa de accidentes <1/10 de los conductores humanos y verificado por 10⁹ kilómetros de carreteras reales + 10⁹ kilómetros de simulación.',
    summaryEn: 'L5 autonomous driving: No need for human intervention in all legal road conditions and in all weather (rain/snow/fog/night), accident rate < 1/10 of human drivers, and verified by 10⁹ kilometers of real roads + 10⁹ kilometers of simulation.',
    kid: '想象你坐上车，告诉它"回家"，它就真的安全把你带回家——不用你碰方向盘。L5 就是这个意思。现在所有自动驾驶都还需要人盯着。',
    formal: 'L5 自动驾驶：在所有合法路况、所有天气（雨/雪/雾/夜间）下不需人接管、事故率 < 人类驾驶员 1/10、并经 10⁹ 公里真实道路 + 10⁹ 公里仿真验证。',
    formalJa: 'L 5自動運転：すべての合法的な道路状況、すべての天候（雨/雪/霧/夜）、人間のドライバーの事故率が1/10未満で、10 kmの実際の道路+ 10 kmのシミュレーションで検証されている場合、人間による乗っ取りは必要ありません。',
    formalEs: 'Conducción autónoma L5: sin necesidad de intervención humana en todas las condiciones legales de la carretera y en cualquier clima (lluvia/nieve/niebla/noche), tasa de accidentes <1/10 de los conductores humanos y verificado por 10⁹ kilómetros de carreteras reales + 10⁹ kilómetros de simulación.',
    formalEn: 'L5 autonomous driving: No need for human intervention in all legal road conditions and in all weather (rain/snow/fog/night), accident rate < 1/10 of human drivers, and verified by 10⁹ kilometers of real roads + 10⁹ kilometers of simulation.',
    whyHard: '长尾事件、伦理。',
    aiPrompt: '介绍 Waymo、Tesla FSD、Mobileye。',
    tags: ['AI', '汽车', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Self Driving',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 CARLA 仿真' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Waymo 故事' }, { type: 'fund', label: '资助/投资', desc: '关注行业' }]
  },
  {
    id: 'drone-delivery',
    category: 'engineering',
    title: '无人机物流',
    titleJa: 'ドローン物流',
    titleEs: 'Logística urbana con drones: radio ≥ 50 km, entrega en 1 hora, costo unitario < 5 USD, carga ≥ 5 kg, ruido < 60 dB y promedio diario ≥ 10⁴ sin accidentes mayores en una sola operación.',
    titleEn: 'Drone Delivery',
    year: 2014,
    proposer: 'Amazon Prime Air',
    difficulty: 2,
    reward: 500,
    status: 'partially_solved',
    summary: '让无人机送外卖',
    summaryJa: 'ドローンに配達を依頼する',
    summaryEs: 'Logística urbana con drones: radio ≥ 50 km, entrega en 1 hora, costo unitario < 5 USD, carga ≥ 5 kg, ruido < 60 dB y promedio diario ≥ 10⁴ sin accidentes mayores en una sola operación.',
    summaryEn: 'Urban drone logistics: radius ≥ 50 km, delivery within 1 hour, unit cost < 5 USD, load ≥ 5 kg, noise < 60 dB, and daily average ≥ 10⁴ with no major accidents in a single operation.',
    kid: '用无人机送 30 公里内的快递，只需要 30 分钟。Amazon、Google Wing 已经在做。',
    formal: '城市无人机物流：半径 ≥ 50 km、< 1 小时送达、单件成本 < 5 美元、载重 ≥ 5 kg、噪声 < 60 dB、且日均 ≥ 10⁴ 单次运行无重大事故。',
    formalJa: 'アーバンドローンロジスティクス：半径≥ 50 km、1時間未満の配送、単品コスト< 5ドル、負荷≥ 5 kg、騒音< 60 dB、1日平均≥ 10 ≥ 1回の操作で重大な事故は発生しません。',
    formalEs: 'Logística urbana con drones: radio ≥ 50 km, entrega en 1 hora, costo unitario < 5 USD, carga ≥ 5 kg, ruido < 60 dB y promedio diario ≥ 10⁴ sin accidentes mayores en una sola operación.',
    formalEn: 'Urban drone logistics: radius ≥ 50 km, delivery within 1 hour, unit cost < 5 USD, load ≥ 5 kg, noise < 60 dB, and daily average ≥ 10⁴ with no major accidents in a single operation.',
    whyHard: '空中管制、载荷。',
    aiPrompt: '介绍 Amazon Prime Air、Wing。',
    tags: ['物流', '无人机', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Drone Delivery',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '路径规划' }, { type: 'essay', label: '写文章/论文', desc: '介绍无人机物流' }]
  },
  {
    id: 'modular-nuclear',
    category: 'engineering',
    title: '模块化核反应堆',
    titleJa: 'モジュール式原子炉',
    titleEs: 'Reactor modular pequeño (SMR): módulo único ≤ 300 MWe, puede prefabricarse en fábrica en lotes, período de construcción ≤ 36 meses, vida útil ≥ 60 años, seguridad pasiva (no se requiere enfriamiento de emergencia) y LCOE ≤ USD 0,05.',
    titleEn: 'Small Modular Reactor (SMR)',
    year: 2010,
    proposer: '—',
    difficulty: 3,
    reward: 2000,
    status: 'partially_solved',
    summary: '小型化、工厂预制的核反应堆',
    summaryJa: '小型の工場用プレハブ原子炉',
    summaryEs: 'Reactor modular pequeño (SMR): módulo único ≤ 300 MWe, puede prefabricarse en fábrica en lotes, período de construcción ≤ 36 meses, vida útil ≥ 60 años, seguridad pasiva (no se requiere enfriamiento de emergencia) y LCOE ≤ USD 0,05.',
    summaryEn: 'Small Modular Reactor (SMR): Single module ≤ 300 MWe, can be factory prefabricated in batches, construction period ≤ 36 months, design life ≥ 60 years, passive safety (no emergency cooling required), and LCOE ≤ US$0.05.',
    kid: '传统核电站 1000 兆瓦，建设 10 年。SMR 小于 300 兆瓦，工厂预制、现场拼装、成本低、建设快。NuScale、BWRX-300 等在发展中。',
    formal: '小型模块化反应堆 (SMR)：单模块 ≤ 300 MWe、可批量工厂预制、建设周期 ≤ 36 个月、设计寿命 ≥ 60 年、被动安全（无需应急冷却）、且度电成本 ≤ 0.05 美元。',
    formalJa: '小型モジュラーリアクター（ SMR ） ：単一モジュール≤ 300 MWe、バッチ工場プレハブ、建設期間≤ 36ヶ月、設計寿命≥ 60年、パッシブセーフティ（緊急冷却なし）、および電気コスト≤ 0.05ドル。',
    formalEs: 'Reactor modular pequeño (SMR): módulo único ≤ 300 MWe, puede prefabricarse en fábrica en lotes, período de construcción ≤ 36 meses, vida útil ≥ 60 años, seguridad pasiva (no se requiere enfriamiento de emergencia) y LCOE ≤ USD 0,05.',
    formalEn: 'Small Modular Reactor (SMR): Single module ≤ 300 MWe, can be factory prefabricated in batches, construction period ≤ 36 months, design life ≥ 60 years, passive safety (no emergency cooling required), and LCOE ≤ US$0.05.',
    whyHard: '许可和供应链。',
    aiPrompt: '介绍 NuScale、TerraPower。',
    tags: ['核', '能源', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'SMR',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 NuScale' }, { type: 'fund', label: '资助/投资', desc: '关注公司' }]
  },
  {
    id: 'tidal-energy',
    category: 'engineering',
    title: '潮汐能规模化',
    titleJa: '大規模な潮汐エネルギー',
    titleEs: 'Comercialización de energía mareomotriz: unidad única ≥ 100 MWe, horas de generación de energía anual ≥ 4000 h, LCOE ≤ US$ 0,10, impacto minimizado en la ecología marina y capaz de soportar olas de 10 metros de altura + fuertes corrientes oceánicas.',
    titleEn: 'Tidal Energy',
    year: 2000,
    proposer: '—',
    difficulty: 3,
    reward: 1000,
    status: 'open',
    summary: '用潮汐发电',
    summaryJa: '潮の流れから発電',
    summaryEs: 'Comercialización de energía mareomotriz: unidad única ≥ 100 MWe, horas de generación de energía anual ≥ 4000 h, LCOE ≤ US$ 0,10, impacto minimizado en la ecología marina y capaz de soportar olas de 10 metros de altura + fuertes corrientes oceánicas.',
    summaryEn: 'Commercialization of tidal energy: single unit ≥ 100 MWe, annual power generation hours ≥ 4000 h, LCOE ≤ US$0.10, minimized impact on marine ecology, and able to withstand 10-meter wave height + strong ocean currents.',
    kid: '月球引力让海水每天涨落两次。能不能把这种力量变成电？潮汐能预测精准（不像太阳能、风能波动大）。',
    formal: '潮汐能商业化：单机组 ≥ 100 MWe、年发电小时数 ≥ 4000 h、度电成本 ≤ 0.10 美元、对海洋生态影响最小化、且能承受 10 米浪高 + 强海流。',
    formalJa: '潮汐エネルギーの商業化：単一ユニット≥ 100 MWe、年間発電時間≥ 4000時間、電力コスト≤ 0.10米ドル、海洋生態への影響が最小限で、波高10メートル+強い海流に耐えることができます。',
    formalEs: 'Comercialización de energía mareomotriz: unidad única ≥ 100 MWe, horas de generación de energía anual ≥ 4000 h, LCOE ≤ US$ 0,10, impacto minimizado en la ecología marina y capaz de soportar olas de 10 metros de altura + fuertes corrientes oceánicas.',
    formalEn: 'Commercialization of tidal energy: single unit ≥ 100 MWe, annual power generation hours ≥ 4000 h, LCOE ≤ US$0.10, minimized impact on marine ecology, and able to withstand 10-meter wave height + strong ocean currents.',
    whyHard: '海洋环境严酷。',
    aiPrompt: '介绍 MeyGen、Sabella。',
    tags: ['能源', '海洋', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Tidal Energy',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 MeyGen' }, { type: 'fund', label: '资助/投资', desc: '关注行业' }]
  },
  {
    id: 'geothermal',
    category: 'engineering',
    title: '增强型地热',
    titleJa: '強化された地熱',
    titleEs: 'Geotermia mejorada (EGS): Pozo único ≥ 5-10 MWe, vida útil ≥ 30 años, profundidad de perforación ≤ 5 km, LCOE ≤ US$ 0,05 y control sísmico inducido < M 3,0.',
    titleEn: 'Enhanced Geothermal Systems',
    year: 1970,
    proposer: '—',
    difficulty: 3,
    reward: 1500,
    status: 'open',
    summary: '从干热岩提取能源',
    summaryJa: '乾燥した高温の岩石からエネルギーを抽出する',
    summaryEs: 'Geotermia mejorada (EGS): Pozo único ≥ 5-10 MWe, vida útil ≥ 30 años, profundidad de perforación ≤ 5 km, LCOE ≤ US$ 0,05 y control sísmico inducido < M 3,0.',
    summaryEn: 'Enhanced Geothermal (EGS): Single well ≥ 5-10 MWe, life ≥ 30 years, drilling depth ≤ 5 km, LCOE ≤ US$0.05, and induced seismic control < M 3.0.',
    kid: '地表下几公里温度 200-300°C。在花岗岩里打两口井、注水、从另一口取出热水。理论上全球 99% 地点都有这种能源。',
    formal: '增强型地热 (EGS)：单井 ≥ 5-10 MWe、寿命 ≥ 30 年、钻井深度 ≤ 5 km、度电成本 ≤ 0.05 美元、且诱发地震控制 < M 3.0。',
    formalJa: '強化地熱（ EGS ） ：単一井戸≥ 5 -10 MWe、寿命≥ 30年、掘削深さ≤ 5 km、電力コスト≤ 0.05ドル、誘導地震制御< M 3.0。',
    formalEs: 'Geotermia mejorada (EGS): Pozo único ≥ 5-10 MWe, vida útil ≥ 30 años, profundidad de perforación ≤ 5 km, LCOE ≤ US$ 0,05 y control sísmico inducido < M 3,0.',
    formalEn: 'Enhanced Geothermal (EGS): Single well ≥ 5-10 MWe, life ≥ 30 years, drilling depth ≤ 5 km, LCOE ≤ US$0.05, and induced seismic control < M 3.0.',
    whyHard: '水力压裂深度。',
    aiPrompt: '介绍 EGS、Fervo。',
    tags: ['能源', '地热', '工程'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Geothermal',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 Fervo 故事' }, { type: 'fund', label: '资助/投资', desc: '关注公司' }]
  },
  {
    id: 'solar-geoengineering',
    category: 'engineering',
    title: '太阳地球工程',
    titleJa: 'ソーラージオエンジニアリング',
    titleEs: 'Geoingeniería solar (SRM): puede compensar ≥ 1°C de calentamiento, es reversible (detiene la recuperación en 1 año), tiene un impacto mínimo en las precipitaciones/ecosistemas, tiene un costo de implementación global de ≤ 10 mil millones de dólares al año y está autorizada por un marco de gobernanza internacional.',
    titleEn: 'Solar Geoengineering',
    year: 2006,
    proposer: 'P. Crutzen',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '用工程手段挡一部分阳光',
    summaryJa: 'エンジニアリング手段を使用して日光の一部を遮断する',
    summaryEs: 'Geoingeniería solar (SRM): puede compensar ≥ 1°C de calentamiento, es reversible (detiene la recuperación en 1 año), tiene un impacto mínimo en las precipitaciones/ecosistemas, tiene un costo de implementación global de ≤ 10 mil millones de dólares al año y está autorizada por un marco de gobernanza internacional.',
    summaryEn: 'Solar Geoengineering (SRM): Can offset ≥ 1°C of warming, is reversible (stops recovery within 1 year), has minimal impact on precipitation/ecosystems, has a global deployment cost of ≤ US$10 billion/year, and is authorized by an international governance framework.',
    kid: '气候变暖是确定的。能不能向平流层注入反射粒子（像火山那样）挡掉 1% 阳光？气候模拟显示这能降温，但也会改变雨量。',
    formal: '太阳地球工程 (SRM)：能抵消 ≥ 1°C 升温、可逆 (1 年内停止恢复)、对降水/生态系统影响最小、全球部署成本 ≤ 100 亿美元/年、且经国际治理框架授权。',
    formalJa: 'ソーラージオエンジニアリング（ SRM ） ： 1°C以上の温暖化をオフセットし、可逆的（ 1年以内に回復を停止）であり、降水量/生態系への影響は最小限で、年間100億ドル以下のグローバル展開コストがあり、国際ガバナンスフレームワークによって承認されています。',
    formalEs: 'Geoingeniería solar (SRM): puede compensar ≥ 1°C de calentamiento, es reversible (detiene la recuperación en 1 año), tiene un impacto mínimo en las precipitaciones/ecosistemas, tiene un costo de implementación global de ≤ 10 mil millones de dólares al año y está autorizada por un marco de gobernanza internacional.',
    formalEn: 'Solar Geoengineering (SRM): Can offset ≥ 1°C of warming, is reversible (stops recovery within 1 year), has minimal impact on precipitation/ecosystems, has a global deployment cost of ≤ US$10 billion/year, and is authorized by an international governance framework.',
    whyHard: '全球协调和副作用。',
    aiPrompt: '介绍 Crutzen 2006、SPICE 项目。',
    tags: ['气候', '工程', '伦理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Solar Geoengineering',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍气候工程' }, { type: 'discuss', label: '想法/讨论', desc: '参与治理讨论' }]
  },
  {
    id: 'poverty',
    category: 'social',
    title: '消除贫困',
    titleJa: '貧困撲滅',
    titleEs: 'Reducir la proporción de personas que viven en pobreza extrema (<$1,90/día) a menos del 1%.',
    titleEn: 'End Poverty',
    year: 2000,
    proposer: 'UN Millennium Goals',
    difficulty: 4,
    reward: 2000,
    status: 'partially_solved',
    summary: '让每个人都不再挨饿',
    summaryJa: '皆がもう飢えないようにします。',
    summaryEs: 'Reducir la proporción de personas que viven en pobreza extrema (<$1,90/día) a menos del 1%.',
    summaryEn: 'Reduce the proportion of people living in extreme poverty (< $1.90/day) to less than 1%.',
    kid: '世界上还有 7 亿小朋友每天吃不饱饭、没学上、没干净水。30 年来极端贫困比例从 36% 降到 9%，但要彻底消除需要新办法。',
    formal: '将极端贫困（< 1.90 美元/天）人口比例降到 1% 以下。',
    formalJa: '極度の貧困（ 1日1.90ドル未満）で暮らす人々の割合を1 ％未満に減らす。',
    formalEs: 'Reducir la proporción de personas que viven en pobreza extrema (<$1,90/día) a menos del 1%.',
    formalEn: 'Reduce the proportion of people living in extreme poverty (< $1.90/day) to less than 1%.',
    whyHard: '贫困有复杂多维原因。',
    aiPrompt: '介绍 GiveDirectly、有效利他主义。',
    tags: ['贫困', '发展', '公益'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'End Poverty',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'fund', label: '资助/投资', desc: '给 GiveDirectly 捐' }, { type: 'essay', label: '写文章/论文', desc: '介绍贫困经济学' }, { type: 'community', label: '社区/组织', desc: '参与社区服务' }]
  },
  {
    id: 'data-privacy',
    category: 'social',
    title: '数据隐私保护',
    titleJa: 'データプライバシー保護',
    titleEs: 'Construir un flujo de datos de extremo a extremo que cumpla con (a) privacidad diferencial ε (ε≤1), (b) cifrado homomórfico o aislamiento del entorno de ejecución confiable (TEE) y (c) autorización revocable del usuario, de modo que el 95% de la información personal no pueda ser restaurada por terceros no autorizados en toda la cadena de recopilación, transmisión, capacitación e inferencia.',
    titleEn: 'Data Privacy Protection',
    year: 2018,
    proposer: 'GDPR / 各国家立法',
    difficulty: 4,
    reward: 1500,
    status: 'open',
    summary: '让数据可用不可见',
    summaryJa: 'データを利用可能かつ非表示にする',
    summaryEs: 'Construir un flujo de datos de extremo a extremo que cumpla con (a) privacidad diferencial ε (ε≤1), (b) cifrado homomórfico o aislamiento del entorno de ejecución confiable (TEE) y (c) autorización revocable del usuario, de modo que el 95% de la información personal no pueda ser restaurada por terceros no autorizados en toda la cadena de recopilación, transmisión, capacitación e inferencia.',
    summaryEn: 'Construct an end-to-end data flow that meets (a) ε-differential privacy (ε≤1), (b) homomorphic encryption or Trusted Execution Environment (TEE) isolation, and (c) user revocable authorization, so that 95% of personal information cannot be restored by unauthorized third parties in the entire chain of collection, transmission, training, and inference.',
    kid: '你用手机、用 APP、看网站，每天都会留下"数字脚印"。这些数据被谁在看？谁在卖？怎么让你享受 AI 便利，又不让别人偷看你的隐私？',
    formal: '构建满足 (a) ε-差分隐私 (ε≤1)、(b) 同态加密或可信执行环境 (TEE) 隔离、(c) 用户可撤销授权的端到端数据流，使 95% 个人信息在采集、传输、训练、推断全链路不可被未授权第三方还原。',
    formalJa: '（ a ） ε -差分プライバシー（ ε ≦ 1 ）、（ b ）同型暗号化または信頼できる実行環境（ TEE ）分離、および（ c ）ユーザーの取り消し可能な承認を満たすエンドツーエンドのデータストリームを構築し、リンク全体の収集、送信、トレーニング、および推論において、個人情報の95 ％が許可されていない第三者によって復元されないようにします。',
    formalEs: 'Construir un flujo de datos de extremo a extremo que cumpla con (a) privacidad diferencial ε (ε≤1), (b) cifrado homomórfico o aislamiento del entorno de ejecución confiable (TEE) y (c) autorización revocable del usuario, de modo que el 95% de la información personal no pueda ser restaurada por terceros no autorizados en toda la cadena de recopilación, transmisión, capacitación e inferencia.',
    formalEn: 'Construct an end-to-end data flow that meets (a) ε-differential privacy (ε≤1), (b) homomorphic encryption or Trusted Execution Environment (TEE) isolation, and (c) user revocable authorization, so that 95% of personal information cannot be restored by unauthorized third parties in the entire chain of collection, transmission, training, and inference.',
    whyHard: '可用性 vs 隐私的数学下界；TEE 侧信道攻击；跨司法管辖的数据流动。',
    aiPrompt: '介绍差分隐私、同态加密、TEE、联邦学习、GDPR / 个人信息保护法。',
    tags: ['隐私', '密码学', 'AI'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Data Privacy',
    videoChannel: 'Computerphile',
    participate: [{ type: 'code', label: '写代码/算法', desc: '差分隐私库实现' }, { type: 'essay', label: '写文章/论文', desc: '介绍 GDPR 与个保法' }, { type: 'kid-project', label: '儿童项目', desc: '教小朋友密码学基础' }]
  },
  {
    id: 'sustainable-energy',
    category: 'social',
    title: '全球能源转型',
    titleJa: 'グローバルなエネルギー転換',
    titleEs: 'Emisiones globales netas de CO₂ cero para 2050: emisiones anuales CO₂_eq ≤ GtCO₂/año (neto negativo), y el 80% de la energía primaria proviene de fuentes libres de carbono (renovables + nuclear), lo que puede verificarse año tras año mediante el inventario de emisiones + balance energético de la AIE/CMNUCC.',
    titleEn: 'Global Energy Transition',
    year: 2015,
    proposer: 'Paris Agreement',
    difficulty: 5,
    reward: 0,
    status: 'partially_solved',
    summary: '让 80 亿人都用清洁能源',
    summaryJa: '80億人にクリーンエネルギーを届ける',
    summaryEs: 'Emisiones globales netas de CO₂ cero para 2050: emisiones anuales CO₂_eq ≤ GtCO₂/año (neto negativo), y el 80% de la energía primaria proviene de fuentes libres de carbono (renovables + nuclear), lo que puede verificarse año tras año mediante el inventario de emisiones + balance energético de la AIE/CMNUCC.',
    summaryEn: 'Global net-zero CO₂ emissions by 2050: annual emissions CO₂_eq ≤ GtCO₂/yr (net negative), and 80% of primary energy comes from carbon-free sources (renewable + nuclear), which can be verified year by year by the IEA/UNFCCC emission inventory + energy balance sheet.',
    kid: '化石能源（煤、石油、天然气）让人类进步，但也让气候变坏。能不能让全世界 80 亿人都用上太阳能、风能、核能？需要在技术、政策、基础设施上同时发力。',
    formal: '在 2050 年前全球净零 CO₂ 排放：年排放量 CO₂_eq ≤ GtCO₂/yr（净负）、且 80% 一次能源来自无碳源（可再生 + 核）、可由 IEA/UNFCCC 排放清单 + 能源平衡表逐年验证。',
    formalJa: '2050年までの世界の正味ゼロCO ₂排出量：年間CO ₂_eq ≤ GtCO ₂/年（正味マイナス）およびカーボンフリー源（再生可能+原子力）からの一次エネルギー80 ％、IEA/UNFCCC排出量インベントリ+エネルギーバランスシートによって毎年検証可能。',
    formalEs: 'Emisiones globales netas de CO₂ cero para 2050: emisiones anuales CO₂_eq ≤ GtCO₂/año (neto negativo), y el 80% de la energía primaria proviene de fuentes libres de carbono (renovables + nuclear), lo que puede verificarse año tras año mediante el inventario de emisiones + balance energético de la AIE/CMNUCC.',
    formalEn: 'Global net-zero CO₂ emissions by 2050: annual emissions CO₂_eq ≤ GtCO₂/yr (net negative), and 80% of primary energy comes from carbon-free sources (renewable + nuclear), which can be verified year by year by the IEA/UNFCCC emission inventory + energy balance sheet.',
    whyHard: '政治意愿、资本。',
    aiPrompt: '介绍 IEA NZE、Powering Past Coal Alliance。',
    tags: ['能源', '气候', '政策'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Energy Transition',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'fund', label: '资助/投资', desc: '给清洁能源投资' }, { type: 'community', label: '社区/组织', desc: '参与本地能源项目' }, { type: 'essay', label: '写文章/论文', desc: '介绍能源转型' }]
  },
  {
    id: 'education-reform',
    category: 'social',
    title: '教育规模化个性化',
    titleJa: '教育規模とパーソナライゼーション',
    titleEs: 'El sistema de enseñanza personalizado de IA alcanza o supera 1 a 1 docentes experimentados en 1 indicador de efecto principal (tamaño del efecto de ganancia de aprendizaje d ≥ 0,4, en comparación con docentes humanos 1 a 1, N ≥ 10.000 ensayos controlados aleatorios, que cubren todo el período escolar K-12) + 1 indicador social (reducción de la brecha de equidad educativa ≥ 30%).',
    titleEn: 'Personalized Education at Scale',
    year: 2020,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '每个孩子都有"AI 私教"',
    summaryJa: '子ども一人ひとりが「AI民間教育」を受けている',
    summaryEs: 'El sistema de enseñanza personalizado de IA alcanza o supera 1 a 1 docentes experimentados en 1 indicador de efecto principal (tamaño del efecto de ganancia de aprendizaje d ≥ 0,4, en comparación con docentes humanos 1 a 1, N ≥ 10.000 ensayos controlados aleatorios, que cubren todo el período escolar K-12) + 1 indicador social (reducción de la brecha de equidad educativa ≥ 30%).',
    summaryEn: 'The AI ​​personalized teaching system reaches or exceeds 1 to 1 senior teachers in 1 main effect indicator (learning gain effect size d ≥ 0.4, compared with 1-on-1 human teachers, N ≥ 10,000 randomized controlled trials, covering the entire K-12 school period) + 1 social indicator (educational equity gap reduction ≥ 30%).',
    kid: '好的家教能根据你的特点调整教学，但好家教贵、不能普及。如果 AI 老师能理解每个孩子的水平、兴趣、状态，规模化提供一对一教育？',
    formal: 'AI 个性化教学系统在 1 项主效应指标（学习收益 effect size d ≥ 0.4，与 1-on-1 人类教师对照，N≥10000 随机对照试验，覆盖 K-12 全学段）+ 1 项社会指标（教育公平差距减小 ≥ 30%）上达到或超过 1 对 1 资深教师。',
    formalJa: 'AIパーソナライズされた教育システムは、1つの主要効果指標（学習便益効果サイズd ≥ 0.4、1対1の人間教師と比較して、N ≥ 10000のランダム化比較試験、K -12クラス全体をカバー）+ 1つの社会指標（教育公平性ギャップ削減≥ 30 ％ ）で1対1のシニア教師を達成または超えています。',
    formalEs: 'El sistema de enseñanza personalizado de IA alcanza o supera 1 a 1 docentes experimentados en 1 indicador de efecto principal (tamaño del efecto de ganancia de aprendizaje d ≥ 0,4, en comparación con docentes humanos 1 a 1, N ≥ 10.000 ensayos controlados aleatorios, que cubren todo el período escolar K-12) + 1 indicador social (reducción de la brecha de equidad educativa ≥ 30%).',
    formalEn: 'The AI ​​personalized teaching system reaches or exceeds 1 to 1 senior teachers in 1 main effect indicator (learning gain effect size d ≥ 0.4, compared with 1-on-1 human teachers, N ≥ 10,000 randomized controlled trials, covering the entire K-12 school period) + 1 social indicator (educational equity gap reduction ≥ 30%).',
    whyHard: '情绪识别、知识表征。',
    aiPrompt: '介绍 Khanmigo、Squirrel AI、可汗学院。',
    tags: ['教育', 'AI', '社会'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Personalized Education',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 GPT 教学助手' }, { type: 'community', label: '社区/组织', desc: '支教' }, { type: 'essay', label: '写文章/论文', desc: '介绍教育创新' }]
  },
  {
    id: 'polarization',
    category: 'social',
    title: '社会极化',
    titleJa: '社会的分極',
    titleEs: 'Reduce significativamente el índice de polarización política: (a) la proporción de "campos hostiles" en la tipología política de Pew disminuye en ≥ 30%, (b) el consenso político entre partidos r ≥ 0,5, (c) la violencia electoral disminuye en ≥ 50%, verificado por un estudio longitudinal de 10 años en ≥ 5 países de la OCDE.',
    titleEn: 'Societal Polarization',
    year: 2016,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '让社会重新能好好讨论',
    summaryJa: '社会を議論に戻す',
    summaryEs: 'Reduce significativamente el índice de polarización política: (a) la proporción de "campos hostiles" en la tipología política de Pew disminuye en ≥ 30%, (b) el consenso político entre partidos r ≥ 0,5, (c) la violencia electoral disminuye en ≥ 50%, verificado por un estudio longitudinal de 10 años en ≥ 5 países de la OCDE.',
    summaryEn: 'Significantly reduces the political polarization index: (a) the proportion of "hostile camps" in Pew Political Typology decreases by ≥ 30%, (b) cross-party policy consensus r ≥ 0.5, (c) electoral violence decreases by ≥ 50%, verified by a 10-year longitudinal study in ≥ 5 OECD countries.',
    kid: '你可能听过爸爸妈妈因为政治观点吵架。世界上很多国家都越来越"左 vs 右"，大家越来越不愿意听对方说话。怎么让社会重新能好好讨论？',
    formal: '显著降低政治极化指数：(a) Pew Political Typology 中「敌对阵营」比例下降 ≥ 30%，(b) 跨党派政策共识度 r ≥ 0.5，(c) 选举暴力事件下降 ≥ 50%，通过 ≥ 5 个 OECD 国家 10 年纵向研究验证。',
    formalJa: '大幅に減少した政治的分極化指標： （ a ） Pew Political Typologyにおける「敵対的キャンプ」の割合が30 ％以上減少したこと、（ b ）クロスパーティーポリシーコンセンサスが0.5度以上、（ c ） OECD諸国5か国以上を対象とした10年間の縦断的研究によって検証されたように、選挙暴力が50 ％以上減少したこと。',
    formalEs: 'Reduce significativamente el índice de polarización política: (a) la proporción de "campos hostiles" en la tipología política de Pew disminuye en ≥ 30%, (b) el consenso político entre partidos r ≥ 0,5, (c) la violencia electoral disminuye en ≥ 50%, verificado por un estudio longitudinal de 10 años en ≥ 5 países de la OCDE.',
    formalEn: 'Significantly reduces the political polarization index: (a) the proportion of "hostile camps" in Pew Political Typology decreases by ≥ 30%, (b) cross-party policy consensus r ≥ 0.5, (c) electoral violence decreases by ≥ 50%, verified by a 10-year longitudinal study in ≥ 5 OECD countries.',
    whyHard: '算法推荐、回声室效应。',
    aiPrompt: '介绍 Habermas、Braver Angels。',
    tags: ['社会', '政治', '心理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Polarization',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'community', label: '社区/组织', desc: '参与对话活动' }, { type: 'essay', label: '写文章/论文', desc: '介绍极化研究' }, { type: 'discuss', label: '想法/讨论', desc: '走出回声室' }]
  },
  {
    id: 'longevity-equity',
    category: 'social',
    title: '延寿公平性',
    titleJa: '寿命延長の公平性',
    titleEs: 'Brecha de esperanza de vida global: (a) diferencia en la esperanza de vida más larga y más corta entre países ≤ 10 años (actualmente más de 30 años), (b) diferencia entre los grupos de ingresos más altos y más bajos en el mismo país ≤ 5 años, (c) verificado por datos del Observatorio Mundial de Salud de la OMS.',
    titleEn: 'Longevity Equity',
    year: 2025,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '让延寿技术惠及所有人',
    summaryJa: 'ライフエクステンションテクノロジーをすべての人に役立てる',
    summaryEs: 'Brecha de esperanza de vida global: (a) diferencia en la esperanza de vida más larga y más corta entre países ≤ 10 años (actualmente más de 30 años), (b) diferencia entre los grupos de ingresos más altos y más bajos en el mismo país ≤ 5 años, (c) verificado por datos del Observatorio Mundial de Salud de la OMS.',
    summaryEn: 'Global life expectancy gap: (a) difference in longest-shortest life expectancy between countries ≤ 10 years (currently 30+ years), (b) difference between highest-lowest income groups in the same country ≤ 5 years, (c) verified by WHO Global Health Observatory data.',
    kid: '如果有一天医学能让人活 150 岁，谁先用？富人和穷人之间的寿命差会不会变得更大？我们需要在技术成熟前就设计好制度。',
    formal: '全球预期寿命差距：(a) 国家间最长寿-最短寿差 ≤ 10 年（目前 30+ 年），(b) 同一国家最高-最低收入组差 ≤ 5 年，(c) 由 WHO Global Health Observatory 数据验证。',
    formalJa: '世界の平均余命ギャップ： （ a ） 10年未満（現在30年以上）の国々間の最長-最小寿命差、（ b ） 5年未満の同じ国の最も高い最低所得グループ差、（ c ） WHOグローバルヘルスオブザーバトリーのデータによって検証されています。',
    formalEs: 'Brecha de esperanza de vida global: (a) diferencia en la esperanza de vida más larga y más corta entre países ≤ 10 años (actualmente más de 30 años), (b) diferencia entre los grupos de ingresos más altos y más bajos en el mismo país ≤ 5 años, (c) verificado por datos del Observatorio Mundial de Salud de la OMS.',
    formalEn: 'Global life expectancy gap: (a) difference in longest-shortest life expectancy between countries ≤ 10 years (currently 30+ years), (b) difference between highest-lowest income groups in the same country ≤ 5 years, (c) verified by WHO Global Health Observatory data.',
    whyHard: '医药可及性。',
    aiPrompt: '介绍寿命不平等、有效利他主义。',
    tags: ['社会', '医学', '伦理'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Longevity',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍延寿伦理' }, { type: 'discuss', label: '想法/讨论', desc: '参与治理讨论' }]
  },
  {
    id: 'longtermism',
    category: 'social',
    title: '长期主义决策',
    titleJa: '長期的な意思決定',
    titleEs: 'Construir un marco de toma de decisiones a largo plazo que pueda formalizarse en un futuro incierto.',
    titleEn: 'Longtermist Decision-Making',
    year: 2017,
    proposer: 'W. MacAskill 等',
    difficulty: 4,
    reward: 1000,
    status: 'open',
    summary: '现在的决策如何考虑 1000 年后的人？',
    summaryJa: '今日の意思決定において、1000年後の人々についてどのように考えていますか？',
    summaryEs: 'Construir un marco de toma de decisiones a largo plazo que pueda formalizarse en un futuro incierto.',
    summaryEn: 'Construct a longtermist decision-making framework that can be formalized under an uncertain future.',
    kid: '我们今天建一个核废料仓库，要确保它 10 万年安全。10 万年后的人会怎么看我们？这种"想得很远"的思考方式叫长期主义。',
    formal: '构造一个能在不确定未来下、可形式化的 longtermist 决策框架。',
    formalJa: '不確実な未来のための公式化可能な長期的な意思決定の枠組みを構築します。',
    formalEs: 'Construir un marco de toma de decisiones a largo plazo que pueda formalizarse en un futuro incierto.',
    formalEn: 'Construct a longtermist decision-making framework that can be formalized under an uncertain future.',
    whyHard: '预测未来 1000 年几乎不可能；代际公平。',
    aiPrompt: '介绍 longtermism、MacAskill、effective altruism。',
    tags: ['伦理', '长期', '决策'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Longtermism',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 MacAskill 工作' }, { type: 'community', label: '社区/组织', desc: '参与 EA 社区' }, { type: 'fund', label: '资助/投资', desc: '给长期主义项目捐资' }]
  },
  {
    id: 'ubi',
    category: 'social',
    title: '全民基本收入',
    titleJa: 'ユニバーサル・ベーシック・インカ',
    titleEs: 'RBU Ensayo a gran escala a largo plazo: Cubierto ≥ 1000 personas, ≥ 5 años aleatorizado controlado; medido (a) cambio en las tasas de empleo ≥ -5% (disminución no significativa), (b) mejora en el bienestar subjetivo (SWLS) ≥ 10%, (c) mejora en la salud mental (PHQ-9) ≥ 15%; replicado en 3 estudios independientes.',
    titleEn: 'Universal Basic Income (UBI)',
    year: 1960,
    proposer: 'M. Friedman / A. Miller',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '每月给每个公民发钱？',
    summaryJa: '毎月すべての市民に支払っていますか？',
    summaryEs: 'RBU Ensayo a gran escala a largo plazo: Cubierto ≥ 1000 personas, ≥ 5 años aleatorizado controlado; medido (a) cambio en las tasas de empleo ≥ -5% (disminución no significativa), (b) mejora en el bienestar subjetivo (SWLS) ≥ 10%, (c) mejora en la salud mental (PHQ-9) ≥ 15%; replicado en 3 estudios independientes.',
    summaryEn: 'UBI Large-scale long-term trial: Covered ≥ 1000 people, ≥ 5 years randomized controlled; measured (a) change in employment rates ≥ -5% (non-significant decrease), (b) improvement in subjective well-being (SWLS) ≥ 10%, (c) improvement in mental health (PHQ-9) ≥ 15%; replicated in 3 independent studies.',
    kid: '全民基本收入（UBI）让政府每月给每个公民发一笔够基本生活需要的钱。AI 取代人力后可能越来越需要。',
    formal: 'UBI 大规模长期试验：覆盖 ≥ 1000 人、≥ 5 年随机对照；测量 (a) 就业率变化 ≥ -5%（不显著下降）、(b) 主观幸福感 (SWLS) 提升 ≥ 10%、(c) 心理健康 (PHQ-9) 改善 ≥ 15%；通过 3 项独立研究复现。',
    formalJa: 'ＵＢＩ大規模長期試験： １ ０ ０ ０人以上、５年以上の無作為化対照； （ ａ ）雇用率の変化≧ ５ ％ （有意な減少なし）、（ ｂ ）主観的幸福度（ ＳＷＬＳ ）の増加≧ １ ０ ％、（ ｃ ）メンタルヘルスの改善（ ＰＨＱ － ９ ） ≧ １ ５ ％を測定し、３つの独立した研究を通じて再現した。',
    formalEs: 'RBU Ensayo a gran escala a largo plazo: Cubierto ≥ 1000 personas, ≥ 5 años aleatorizado controlado; medido (a) cambio en las tasas de empleo ≥ -5% (disminución no significativa), (b) mejora en el bienestar subjetivo (SWLS) ≥ 10%, (c) mejora en la salud mental (PHQ-9) ≥ 15%; replicado en 3 estudios independientes.',
    formalEn: 'UBI Large-scale long-term trial: Covered ≥ 1000 people, ≥ 5 years randomized controlled; measured (a) change in employment rates ≥ -5% (non-significant decrease), (b) improvement in subjective well-being (SWLS) ≥ 10%, (c) improvement in mental health (PHQ-9) ≥ 15%; replicated in 3 independent studies.',
    whyHard: '政治意愿和资金。',
    aiPrompt: '介绍芬兰实验、肯尼亚 GiveDirectly。',
    tags: ['经济', '政策', 'AI'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'UBI',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 UBI 历史' }, { type: 'discuss', label: '想法/讨论', desc: '参与辩论' }]
  },
  {
    id: 'privacy-digital',
    category: 'social',
    title: '数字时代隐私',
    titleJa: 'デジタル時代のプライバシー',
    titleEs: 'Las personas tienen un control significativo de la información en sus vidas digitales: (a) el 99% de los usuarios de Internet pueden exportar/eliminar todos los datos personales en ≤ 5 pasos (verificación del Art. 15/17 del GDPR), (b) tasa de resolución de quejas por abuso de datos ≥ 90%, (c) la coherencia del perfil de usuario entre plataformas es controlable (visible para los usuarios).',
    titleEn: 'Privacy in Digital Age',
    year: 2013,
    proposer: 'E. Snowden',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '在数据经济中保护隐私',
    summaryJa: 'データエコノミーにおけるプライバシーの保護',
    summaryEs: 'Las personas tienen un control significativo de la información en sus vidas digitales: (a) el 99% de los usuarios de Internet pueden exportar/eliminar todos los datos personales en ≤ 5 pasos (verificación del Art. 15/17 del GDPR), (b) tasa de resolución de quejas por abuso de datos ≥ 90%, (c) la coherencia del perfil de usuario entre plataformas es controlable (visible para los usuarios).',
    summaryEn: 'Individuals have meaningful information control in their digital lives: (a) 99% of Internet users can export/delete all personal data within ≤ 5 steps (GDPR Art. 15/17 verification), (b) data abuse complaint resolution rate ≥ 90%, (c) cross-platform user profile consistency is controllable (visible to users).',
    kid: '2013 年 Snowden 揭露美国 NSA 大规模监控。我们每刷一下手机都被跟踪。怎么在数据经济和隐私间平衡？',
    formal: '个人在数字生活中拥有有意义的信息控制权：(a) 99% 互联网用户能在 ≤ 5 步内导出/删除所有个人数据（GDPR Art. 15/17 验证），(b) 数据滥用投诉解决率 ≥ 90%、(c) 跨平台用户画像一致性可控（用户可见）。',
    formalJa: '個人は、デジタル生活において有意義な情報管理を行っています。（ a ）インターネットユーザーの99 ％は、5ステップ以下ですべての個人データをエクスポート/削除することができます（ GDPR第15/17条検証）。（ b ）データ不正使用の苦情解決率は90 ％以上であり、（ c ）クロスプラットフォームのユーザープロファイルの一貫性を制御できます（ユーザーが表示）。',
    formalEs: 'Las personas tienen un control significativo de la información en sus vidas digitales: (a) el 99% de los usuarios de Internet pueden exportar/eliminar todos los datos personales en ≤ 5 pasos (verificación del Art. 15/17 del GDPR), (b) tasa de resolución de quejas por abuso de datos ≥ 90%, (c) la coherencia del perfil de usuario entre plataformas es controlable (visible para los usuarios).',
    formalEn: 'Individuals have meaningful information control in their digital lives: (a) 99% of Internet users can export/delete all personal data within ≤ 5 steps (GDPR Art. 15/17 verification), (b) data abuse complaint resolution rate ≥ 90%, (c) cross-platform user profile consistency is controllable (visible to users).',
    whyHard: '商业模式依赖数据。',
    aiPrompt: '介绍 GDPR、CCPA。',
    tags: ['社会', '法', '隐私'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Digital Privacy',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 Snowden 事件' }, { type: 'community', label: '社区/组织', desc: '参与隐私倡导' }]
  },
  {
    id: 'digital-democracy',
    category: 'social',
    title: '数字民主',
    titleJa: 'デジタル民主主義',
    titleEs: 'Impacto de la democracia digital en la participación/calidad de las políticas: (a) la participación ciudadana aumentó en ≥ 20% (frente al grupo de control), (b) el puntaje de calidad de las políticas (revisión ciega de expertos) mejoró en ≥ 15%, (c) la brecha de participación de los grupos desfavorecidos se redujo en ≥ 30%, verificado por ≥ 5 ciudades/estados reales durante 5 años de investigación.',
    titleEn: 'Digital Democracy',
    year: 2010,
    proposer: '—',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '用技术改进民主决策',
    summaryJa: 'テクノロジーによる民主的意思決定の改善',
    summaryEs: 'Impacto de la democracia digital en la participación/calidad de las políticas: (a) la participación ciudadana aumentó en ≥ 20% (frente al grupo de control), (b) el puntaje de calidad de las políticas (revisión ciega de expertos) mejoró en ≥ 15%, (c) la brecha de participación de los grupos desfavorecidos se redujo en ≥ 30%, verificado por ≥ 5 ciudades/estados reales durante 5 años de investigación.',
    summaryEn: 'Impact of digital democracy on participation/policy quality: (a) citizen turnout increased by ≥ 20% (vs control group), (b) policy quality score (blind expert review) improved by ≥ 15%, (c) participation gap of disadvantaged groups reduced by ≥ 30%, verified by ≥ 5 real cities/states for 5 years of research.',
    kid: '现在民主是"投票—选人—等人决定"，大多数人不参与。能不能用技术（在线讨论、抽签议会、AI 辅助审议）让民主更直接？',
    formal: '数字民主对参与度/政策质量的影响：(a) 公民投票率提升 ≥ 20%（vs 对照组），(b) 政策质量评分 (专家盲评) 提升 ≥ 15%，(c) 弱势群体参与差距减小 ≥ 30%，通过 ≥ 5 个真实城市/州 5 年研究验证。',
    formalJa: '参加/政策の質に対するデジタル民主主義の影響： （ a ）投票率の20 ％以上の増加（対照群との比較）、（ b ）政策の質スコアの15 ％以上の増加（専門家による盲目評価）、および（ c ）脆弱なグループの参加ギャップの30 ％以上の減少。これは、5年以上の実際の都市/州の研究によって検証されています。',
    formalEs: 'Impacto de la democracia digital en la participación/calidad de las políticas: (a) la participación ciudadana aumentó en ≥ 20% (frente al grupo de control), (b) el puntaje de calidad de las políticas (revisión ciega de expertos) mejoró en ≥ 15%, (c) la brecha de participación de los grupos desfavorecidos se redujo en ≥ 30%, verificado por ≥ 5 ciudades/estados reales durante 5 años de investigación.',
    formalEn: 'Impact of digital democracy on participation/policy quality: (a) citizen turnout increased by ≥ 20% (vs control group), (b) policy quality score (blind expert review) improved by ≥ 15%, (c) participation gap of disadvantaged groups reduced by ≥ 30%, verified by ≥ 5 real cities/states for 5 years of research.',
    whyHard: '安全性和规模。',
    aiPrompt: '介绍 vTaiwan、Decidim、Pol.is。',
    tags: ['社会', '政治', '技术'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Digital Democracy',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '开源民主工具' }, { type: 'community', label: '社区/组织', desc: '参与公民审议' }]
  },
  {
    id: 'open-data',
    category: 'social',
    title: '开放政府数据',
    titleJa: '政府データを開く',
    titleEs: '≥ 80 % de los conjuntos de datos clave del gobierno nacional (Finanzas/Medio ambiente/Salud/Educación/Estadísticas) en tiempo real (latencia de actualización < 24 h) disponibles públicamente, legibles por máquina (RDF/JSON/CSV) con metadatos completos (DCAT), validados por Open Data Barometer o índice equivalente ≥ 80/100.',
    titleEn: 'Open Government Data',
    year: 2009,
    proposer: 'B. Obama',
    difficulty: 2,
    reward: 0,
    status: 'partially_solved',
    summary: '让政府数据公开',
    summaryJa: '政府のデータを公開する',
    summaryEs: '≥ 80 % de los conjuntos de datos clave del gobierno nacional (Finanzas/Medio ambiente/Salud/Educación/Estadísticas) en tiempo real (latencia de actualización < 24 h) disponibles públicamente, legibles por máquina (RDF/JSON/CSV) con metadatos completos (DCAT), validados por Open Data Barometer o índice equivalente ≥ 80/100.',
    summaryEn: '≥ 80% of key national government data sets (Finance/Environment/Health/Education/Statistics) real-time (update latency < 24h) publicly available, machine-readable (RDF/JSON/CSV) with complete metadata (DCAT), validated by Open Data Barometer or equivalent index ≥ 80/100.',
    kid: '政府掌握大量数据（预算、空气质量、交通）。能不能全部公开让公众监督？data.gov 已经是先例。',
    formal: '≥ 80% 国家级政府关键数据集（财政/环境/健康/教育/统计）实时（更新延迟 < 24h）公开、机器可读 (RDF/JSON/CSV)、且含完整元数据 (DCAT)、由 Open Data Barometer 或同等指数 ≥ 80/100 验证。',
    formalJa: '国家政府の重要なデータセット（財政/環境/健康/教育/統計）の80 ％以上がリアルタイムで公開されており（更新遅延< 24時間）、機械可読性（ RDF/JSON/CSV ）、完全なメタデータ（ DCAT ）が含まれており、Open Data Barometerまたは同等の80/100以上で検証されています。',
    formalEs: '≥ 80 % de los conjuntos de datos clave del gobierno nacional (Finanzas/Medio ambiente/Salud/Educación/Estadísticas) en tiempo real (latencia de actualización < 24 h) disponibles públicamente, legibles por máquina (RDF/JSON/CSV) con metadatos completos (DCAT), validados por Open Data Barometer o índice equivalente ≥ 80/100.',
    formalEn: '≥ 80% of key national government data sets (Finance/Environment/Health/Education/Statistics) real-time (update latency < 24h) publicly available, machine-readable (RDF/JSON/CSV) with complete metadata (DCAT), validated by Open Data Barometer or equivalent index ≥ 80/100.',
    whyHard: '安全和效率。',
    aiPrompt: '介绍 Open Data Charter。',
    tags: ['社会', '政府', '数据'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Open Data',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用政府数据做 app' }, { type: 'community', label: '社区/组织', desc: '参与公民项目' }]
  },
  {
    id: 'universal-health',
    category: 'social',
    title: '全民医保',
    titleJa: 'すべての人のためのメディケア',
    titleEs: '≥ 80% de los países logran la CSU: (a) cobertura de seguro médico ≥ 90% de la población, (b) gasto de bolsillo < 30% del gasto total en salud, (c) acceso a servicios médicos esenciales ≥ 80%, (d) dificultades financieras (gasto empobrecedor) < 10% de los hogares; verificado por el índice de cobertura de servicios UHC de la OMS ≥ 80.',
    titleEn: 'Universal Healthcare',
    year: 1948,
    proposer: 'WHO',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '让每个人都能看病',
    summaryJa: '誰もが医者に診てもらえるようにする',
    summaryEs: '≥ 80% de los países logran la CSU: (a) cobertura de seguro médico ≥ 90% de la población, (b) gasto de bolsillo < 30% del gasto total en salud, (c) acceso a servicios médicos esenciales ≥ 80%, (d) dificultades financieras (gasto empobrecedor) < 10% de los hogares; verificado por el índice de cobertura de servicios UHC de la OMS ≥ 80.',
    summaryEn: '≥ 80% of countries achieve UHC: (a) health insurance coverage ≥ 90% of the population, (b) out-of-pocket expenditure < 30% of total health expenditure, (c) access to essential medical services ≥ 80%, (d) financial hardship (impoverishing expenditure) < 10% of households; verified by WHO UHC Service Coverage Index ≥ 80.',
    kid: '美国是发达国家中唯一没有全民医保的。每年有几十万人因费用放弃治疗。其他国家怎么做？中国新农合/医保是哪种？',
    formal: '≥ 80% 国家实现 UHC：(a) 医保覆盖 ≥ 90% 人口、(b) 自费支出 < 30% 总医疗支出、(c) 必需医疗服务可及性 ≥ 80%、(d) 财务困难 (impoverishing expenditure) < 10% 家庭；由 WHO UHC Service Coverage Index ≥ 80 验证。',
    formalJa: '国の80 ％以上がUHCを達成している： （ a ）健康保険の適用範囲が人口の90 ％以上、（ b ）自己負担支出が総医療費の30 ％未満、（ c ）必須医療サービスの利用可能性が80 ％以上、（ d ）経済的困難（貧困化支出）が世帯の10 ％未満。WHO UHCサービスカバレッジインデックス80以上によって検証されています。',
    formalEs: '≥ 80% de los países logran la CSU: (a) cobertura de seguro médico ≥ 90% de la población, (b) gasto de bolsillo < 30% del gasto total en salud, (c) acceso a servicios médicos esenciales ≥ 80%, (d) dificultades financieras (gasto empobrecedor) < 10% de los hogares; verificado por el índice de cobertura de servicios UHC de la OMS ≥ 80.',
    formalEn: '≥ 80% of countries achieve UHC: (a) health insurance coverage ≥ 90% of the population, (b) out-of-pocket expenditure < 30% of total health expenditure, (c) access to essential medical services ≥ 80%, (d) financial hardship (impoverishing expenditure) < 10% of households; verified by WHO UHC Service Coverage Index ≥ 80.',
    whyHard: '政治意愿和资金。',
    aiPrompt: '介绍 NHS、加拿大 Medicare、台湾全民健保。',
    tags: ['社会', '医学', '政策'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Universal Healthcare',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍各国医保制度' }, { type: 'community', label: '社区/组织', desc: '参与公益医疗' }]
  },
  {
    id: 'affordable-housing',
    category: 'social',
    title: '可负担住房',
    titleJa: '手頃な価格の住宅',
    titleEs: 'Asequibilidad de la vivienda: ≥ 80 % del ingreso medio de los hogares, costos de vivienda ≤ 30 % del ingreso mensual (definición de la ONU), tasa de personas sin hogar < 0,1 % y verificado por la base de datos de vivienda asequible de la OCDE.',
    titleEn: 'Affordable Housing',
    year: 2020,
    proposer: '—',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '让每个家庭都有体面住房',
    summaryJa: 'すべての家族のためのまともな家',
    summaryEs: 'Asequibilidad de la vivienda: ≥ 80 % del ingreso medio de los hogares, costos de vivienda ≤ 30 % del ingreso mensual (definición de la ONU), tasa de personas sin hogar < 0,1 % y verificado por la base de datos de vivienda asequible de la OCDE.',
    summaryEn: 'Housing Affordability: ≥ 80% of median income household housing costs ≤ 30% of monthly income (UN definition), homelessness rate < 0.1%, and verified by the OECD Affordable Housing Database.',
    kid: '北上广深、香港、纽约、伦敦……大城市房价高得离谱。怎么让住房可负担？',
    formal: '住房可负担：≥ 80% 中位数收入家庭住房成本 ≤ 30% 月收入（联合国定义）、无家可归率 < 0.1%、且由 OECD Affordable Housing Database 验证。',
    formalJa: '住宅の手頃な価格：所得中央値の世帯の80 ％以上が、月収（国連定義）の30 ％以下の住宅コスト、0.1 ％未満のホームレス率を有し、OECD手頃な価格の住宅データベースによって検証されています。',
    formalEs: 'Asequibilidad de la vivienda: ≥ 80 % del ingreso medio de los hogares, costos de vivienda ≤ 30 % del ingreso mensual (definición de la ONU), tasa de personas sin hogar < 0,1 % y verificado por la base de datos de vivienda asequible de la OCDE.',
    formalEn: 'Housing Affordability: ≥ 80% of median income household housing costs ≤ 30% of monthly income (UN definition), homelessness rate < 0.1%, and verified by the OECD Affordable Housing Database.',
    whyHard: '土地稀缺和资本。',
    aiPrompt: '介绍 Singapore HDB、Vienna social housing。',
    tags: ['社会', '城市', '政策'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Housing',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍各国住房政策' }, { type: 'community', label: '社区/组织', desc: '参与住房 NGO' }]
  },
  {
    id: 'remote-work',
    category: 'social',
    title: '远程工作未来',
    titleJa: 'リモートワークの未来',
    titleEs: 'Impacto de los sistemas de trabajo remoto en la productividad/cohesión social: (a) productividad del equipo remoto ≥ equipo in situ (control aleatorio d ≥ 0,0), (b) disminución del indicador de cohesión social (Índice de capital social de Putnam) < 10 %, (c) deterioro del indicador de salud mental (GHQ-12) < 5 %; validado por ≥ 5 estudios independientes.',
    titleEn: 'Future of Remote Work',
    year: 2020,
    proposer: '—',
    difficulty: 3,
    reward: 0,
    status: 'partially_solved',
    summary: '远程工作是新常态',
    summaryJa: 'リモートワークは新しい常識です',
    summaryEs: 'Impacto de los sistemas de trabajo remoto en la productividad/cohesión social: (a) productividad del equipo remoto ≥ equipo in situ (control aleatorio d ≥ 0,0), (b) disminución del indicador de cohesión social (Índice de capital social de Putnam) < 10 %, (c) deterioro del indicador de salud mental (GHQ-12) < 5 %; validado por ≥ 5 estudios independientes.',
    summaryEn: 'Impact of remote working systems on productivity/social cohesion: (a) remote team productivity ≥ onsite team (randomized control d ≥ 0.0), (b) decrease in social cohesion indicator (Putnam Social Capital Index) < 10%, (c) deterioration in mental health indicator (GHQ-12) < 5%; validated by ≥ 5 independent studies.',
    kid: '2020 年新冠让远程工作爆发。三年后，是"回归办公室"还是"永远远程"？',
    formal: '远程工作系统对生产率/社会凝聚的影响：(a) 远程团队生产率 ≥ 现场团队 (随机对照 d ≥ 0.0)、(b) 社会凝聚指标 (Putnam 社会资本指数) 下降 < 10%、(c) 心理健康指标 (GHQ-12) 恶化 < 5%；通过 ≥ 5 项独立研究验证。',
    formalJa: '生産性/社会的結束に対するテレワーキングシステムの影響： （ a ）リモートチームの生産性≥フィールドチーム（ランダム化対照d ≥ 0.0 ）、（ b ）社会的結束指標（パットナム社会資本指標）の10 ％未満の低下、（ c ）メンタルヘルス指標（ GHQ -12 ）の5 ％未満の低下。5件以上の独立した研究によって検証されています。',
    formalEs: 'Impacto de los sistemas de trabajo remoto en la productividad/cohesión social: (a) productividad del equipo remoto ≥ equipo in situ (control aleatorio d ≥ 0,0), (b) disminución del indicador de cohesión social (Índice de capital social de Putnam) < 10 %, (c) deterioro del indicador de salud mental (GHQ-12) < 5 %; validado por ≥ 5 estudios independientes.',
    formalEn: 'Impact of remote working systems on productivity/social cohesion: (a) remote team productivity ≥ onsite team (randomized control d ≥ 0.0), (b) decrease in social cohesion indicator (Putnam Social Capital Index) < 10%, (c) deterioration in mental health indicator (GHQ-12) < 5%; validated by ≥ 5 independent studies.',
    whyHard: '管理和社会资本。',
    aiPrompt: '介绍 Microsoft Work Trend、Stanford WFH Research。',
    tags: ['社会', '工作', '技术'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Remote Work',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍远程工作研究' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'ai-governance',
    category: 'social',
    title: 'AI 治理',
    titleJa: 'AIガバナンス',
    titleEs: 'Establecer un marco de gobernanza de la IA vinculante y coordinado a nivel mundial: (a) firmado por al menos el G20 + las principales potencias de la IA, (b) evaluación de seguridad obligatoria + pruebas del equipo rojo + notificación de incidentes para los requisitos de capacitación para potencia informática ≥ 10²⁶ FLOP, (c) establecimiento de una agencia internacional independiente de seguridad de la IA (similar a la OIEA), (d) implementado por ≥ 3 años y vinculante.',
    titleEn: 'AI Governance',
    year: 2023,
    proposer: '—',
    difficulty: 5,
    reward: 0,
    status: 'open',
    summary: '如何让全球 AI 安全？',
    summaryJa: 'グローバルなAIを安全にするにはどうすればよいですか？',
    summaryEs: 'Establecer un marco de gobernanza de la IA vinculante y coordinado a nivel mundial: (a) firmado por al menos el G20 + las principales potencias de la IA, (b) evaluación de seguridad obligatoria + pruebas del equipo rojo + notificación de incidentes para los requisitos de capacitación para potencia informática ≥ 10²⁶ FLOP, (c) establecimiento de una agencia internacional independiente de seguridad de la IA (similar a la OIEA), (d) implementado por ≥ 3 años y vinculante.',
    summaryEn: 'Establish a globally coordinated, binding AI governance framework: (a) signed by at least the G20 + major AI powers, (b) mandatory security assessment + red team testing + incident reporting for training requirements for computing power ≥ 10²⁶ FLOP, (c) establishment of an independent international AI safety agency (similar to the IAEA), (d) implemented for ≥ 3 years and binding.',
    kid: 'AI 越来越强大。欧盟 AI Act、美国行政令、中国生成式 AI 管理办法——全球都在抢着立法。什么样的治理能真正让 AI 安全？',
    formal: '建立全球协调、有约束力的 AI 治理框架：(a) 至少 G20 + 主要 AI 大国签署、(b) 对算力 ≥ 10²⁶ FLOP 训练要求强制安全评估 + 红队测试 + 事故报告、(c) 设立独立国际 AI 安全机构（类似 IAEA）、(d) 实施 ≥ 3 年且有约束力。',
    formalJa: 'グローバルに調整され、拘束力のあるAIガバナンスフレームワークを確立する： （ a ）少なくともG 20 +主要なAI大国によって署名された、（ b ）ハッシュレート≥ 10 ² ² FLOPトレーニングのための必須の安全性評価+レッドチームテスト+インシデント報告、（ c ）独立した国際的なAI安全機関（ IAEAと同様）の設立、および（ d ） 3年以上の実装と拘束力。',
    formalEs: 'Establecer un marco de gobernanza de la IA vinculante y coordinado a nivel mundial: (a) firmado por al menos el G20 + las principales potencias de la IA, (b) evaluación de seguridad obligatoria + pruebas del equipo rojo + notificación de incidentes para los requisitos de capacitación para potencia informática ≥ 10²⁶ FLOP, (c) establecimiento de una agencia internacional independiente de seguridad de la IA (similar a la OIEA), (d) implementado por ≥ 3 años y vinculante.',
    formalEn: 'Establish a globally coordinated, binding AI governance framework: (a) signed by at least the G20 + major AI powers, (b) mandatory security assessment + red team testing + incident reporting for training requirements for computing power ≥ 10²⁶ FLOP, (c) establishment of an independent international AI safety agency (similar to the IAEA), (d) implemented for ≥ 3 years and binding.',
    whyHard: '地缘政治和快速变化的技术。',
    aiPrompt: '介绍 EU AI Act、Bletchley Declaration。',
    tags: ['社会', '政策', 'AI'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'AI Governance',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍 AI 治理' }, { type: 'community', label: '社区/组织', desc: '参与公民倡导' }]
  },
  {
    id: 'bio-enhancement',
    category: 'social',
    title: '生物增强伦理',
    titleJa: 'バイオエンハンスドエシックス',
    titleEs: 'Establecer un marco ético y de gobernanza para la mejora biológica (genética/neural/cognitiva): (a) al menos 50 legislaciones nacionales, (b) mecanismo de consentimiento + acceso justo + no discriminación + mecanismo claro de revisión de seguridad, (c) sistema de registro de seguimiento a largo plazo ≥ 10 años, (d) mecanismo de consulta pública.',
    titleEn: 'Bioenhancement Ethics',
    year: 2000,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '能让自己更聪明、更强、更长寿？',
    summaryJa: 'あなたは自分自身をより賢く、より強く、より長く生きることができますか？',
    summaryEs: 'Establecer un marco ético y de gobernanza para la mejora biológica (genética/neural/cognitiva): (a) al menos 50 legislaciones nacionales, (b) mecanismo de consentimiento + acceso justo + no discriminación + mecanismo claro de revisión de seguridad, (c) sistema de registro de seguimiento a largo plazo ≥ 10 años, (d) mecanismo de consulta pública.',
    summaryEn: 'Establish an ethical and governance framework for biological enhancement (genetic/neural/cognitive): (a) at least 50 national legislations, (b) consent mechanism + fair access + non-discrimination + clear safety review mechanism, (c) long-term tracking registration system ≥ 10 years, (d) public consultation mechanism.',
    kid: 'CRISPR、Nootropics、脑刺激……能让人变得超常。但如果只有富人用得起，社会不平等更严重。',
    formal: '对生物增强（基因/神经/认知）建立伦理与治理框架：(a) 至少 50 国家立法，(b) 同意机制 + 公平获取 + 不歧视 + 安全审查机制明确、(c) 长期跟踪登记制度 ≥ 10 年、(d) 公众咨询机制。',
    formalJa: 'バイオエンハンスメント（遺伝的/神経学的/認知的）のための倫理的およびガバナンスの枠組みを確立する： （ a ）少なくとも50の国の法律、（ b ）明確な同意メカニズム+公平なアクセス+非差別+安全性レビューメカニズム、（ c ） 10年以上の長期フォローアップ登録システム、および（ d ）パブリックコンサルテーションメカニズム。',
    formalEs: 'Establecer un marco ético y de gobernanza para la mejora biológica (genética/neural/cognitiva): (a) al menos 50 legislaciones nacionales, (b) mecanismo de consentimiento + acceso justo + no discriminación + mecanismo claro de revisión de seguridad, (c) sistema de registro de seguimiento a largo plazo ≥ 10 años, (d) mecanismo de consulta pública.',
    formalEn: 'Establish an ethical and governance framework for biological enhancement (genetic/neural/cognitive): (a) at least 50 national legislations, (b) consent mechanism + fair access + non-discrimination + clear safety review mechanism, (c) long-term tracking registration system ≥ 10 years, (d) public consultation mechanism.',
    whyHard: '定义、风险。',
    aiPrompt: '介绍 Bostrom、Sandel。',
    tags: ['社会', '伦理', '生物'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Bioenhancement',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍增强伦理' }, { type: 'discuss', label: '想法/讨论', desc: '参与讨论' }]
  },
  {
    id: 'climate-migration',
    category: 'social',
    title: '气候移民',
    titleJa: '気候変動への移行',
    titleEs: 'Marco de migración climática digna y coordinado a nivel mundial: (a) estatus legal internacional claro (uno de refugiado/protección suplementaria/protección temporal), (b) firmado por ≥ 50 países, (c) cuotas de reasentamiento justas (basadas en emisiones históricas + capacidad de recepción), (d) derechos garantizados de los migrantes (trabajo/educación/atención médica).',
    titleEn: 'Climate Migration',
    year: 2050,
    proposer: '—',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '2050 年 10 亿人因气候背井离乡',
    summaryJa: '2050年までに気候変動により10億人が避難を余儀なくされる',
    summaryEs: 'Marco de migración climática digna y coordinado a nivel mundial: (a) estatus legal internacional claro (uno de refugiado/protección suplementaria/protección temporal), (b) firmado por ≥ 50 países, (c) cuotas de reasentamiento justas (basadas en emisiones históricas + capacidad de recepción), (d) derechos garantizados de los migrantes (trabajo/educación/atención médica).',
    summaryEn: 'Globally coordinated, dignified climate migration framework: (a) clear international legal status (one of refugee/supplementary protection/temporary protection), (b) signed by ≥ 50 countries, (c) fair resettlement quotas (based on historical emissions + reception capacity), (d) guaranteed migrants’ rights (work/education/health care).',
    kid: '到 2050 年，世界银行估计有 2 亿人因海平面上升、干旱、极端天气成为"气候难民"。人类如何应对？',
    formal: '全球协调、有尊严的气候移民框架：(a) 国际法律地位明确 (难民/补充保护/临时保护 之一)、(b) ≥ 50 国家签署、(c) 安置配额公平 (基于历史排放 + 接收能力)、(d) 移民权利保障 (工作/教育/医疗)。',
    formalJa: 'グローバルに調整された、尊厳のある気候移民の枠組み： （ a ）明確な国際的な法的地位（難民/補完的保護/一時的保護の1つ）、（ b ） 50か国以上が署名した、（ c ）再定住クォータの公平性（過去の排出量+受入能力に基づく）、および（ d ）移民の権利の保証（仕事/教育/健康）。',
    formalEs: 'Marco de migración climática digna y coordinado a nivel mundial: (a) estatus legal internacional claro (uno de refugiado/protección suplementaria/protección temporal), (b) firmado por ≥ 50 países, (c) cuotas de reasentamiento justas (basadas en emisiones históricas + capacidad de recepción), (d) derechos garantizados de los migrantes (trabajo/educación/atención médica).',
    formalEn: 'Globally coordinated, dignified climate migration framework: (a) clear international legal status (one of refugee/supplementary protection/temporary protection), (b) signed by ≥ 50 countries, (c) fair resettlement quotas (based on historical emissions + reception capacity), (d) guaranteed migrants’ rights (work/education/health care).',
    whyHard: '规模、政治。',
    aiPrompt: '介绍 World Bank Groundswell 报告。',
    tags: ['社会', '气候', '移民'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Climate Migration',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍气候移民' }, { type: 'community', label: '社区/组织', desc: '参与援助' }]
  },
  {
    id: 'refugee',
    category: 'social',
    title: '难民危机',
    titleJa: '難民危機',
    titleEs: 'Reasentamiento global de refugiados: (a) tasa anual de satisfacción de las necesidades de reasentamiento del ACNUR ≥ 80%, (b) países de reasentamiento ≥ 40 en el primer año con distribución justa (relación per cápita refugiado/país receptor σ/μ ≤ 0,3), (c) tasa de autosuficiencia económica de los refugiados en 5 años ≥ 70%, (d) indicadores de salud física y mental (OMS-5) ≥ 90% de la población de control.',
    titleEn: 'Refugee Crisis',
    year: 2015,
    proposer: '—',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '让难民得到尊严',
    summaryJa: '難民に尊厳を与える',
    summaryEs: 'Reasentamiento global de refugiados: (a) tasa anual de satisfacción de las necesidades de reasentamiento del ACNUR ≥ 80%, (b) países de reasentamiento ≥ 40 en el primer año con distribución justa (relación per cápita refugiado/país receptor σ/μ ≤ 0,3), (c) tasa de autosuficiencia económica de los refugiados en 5 años ≥ 70%, (d) indicadores de salud física y mental (OMS-5) ≥ 90% de la población de control.',
    summaryEn: 'Global refugee resettlement: (a) UNHCR’s annual resettlement needs satisfaction rate ≥ 80%, (b) resettlement countries ≥ 40 in the first year with fair distribution (per capita refugee/receiving country ratio σ/μ ≤ 0.3), (c) refugees’ economic self-sufficiency rate within 5 years ≥ 70%, (d) physical and mental health indicators (WHO-5) ≥ 90% of the control population.',
    kid: '2023 年全球 1.1 亿人流离失所（UNHCR）。叙利亚、乌克兰、缅甸……他们如何重新开始？',
    formal: '全球难民安置：(a) 联合国难民署年安置需求满足率 ≥ 80%、(b) 第一年安置国家 ≥ 40 个且分配公平 (人均难民/接收国比例 σ/μ ≤ 0.3)、(c) 难民 5 年内经济自给率 ≥ 70%、(d) 身心健康指标 (WHO-5) ≥ 对照人群 90%。',
    formalJa: '世界的な難民の再定住： （ a ） UNHCRの年間の再定住には80 ％以上の満足度が必要であり、（ b ）最初の1年間に40か国以上の再定住国と公平な分布（一人当たりの難民/受入国の比率σ/μ ≤ 0.3 ）、（ c ） 5年以内に70 ％以上の難民の経済的自給率、（ d ）対照人口の90 ％以上の身体的および精神的健康指標（ WHO -5 ）。',
    formalEs: 'Reasentamiento global de refugiados: (a) tasa anual de satisfacción de las necesidades de reasentamiento del ACNUR ≥ 80%, (b) países de reasentamiento ≥ 40 en el primer año con distribución justa (relación per cápita refugiado/país receptor σ/μ ≤ 0,3), (c) tasa de autosuficiencia económica de los refugiados en 5 años ≥ 70%, (d) indicadores de salud física y mental (OMS-5) ≥ 90% de la población de control.',
    formalEn: 'Global refugee resettlement: (a) UNHCR’s annual resettlement needs satisfaction rate ≥ 80%, (b) resettlement countries ≥ 40 in the first year with fair distribution (per capita refugee/receiving country ratio σ/μ ≤ 0.3), (c) refugees’ economic self-sufficiency rate within 5 years ≥ 70%, (d) physical and mental health indicators (WHO-5) ≥ 90% of the control population.',
    whyHard: '政治意愿。',
    aiPrompt: '介绍 UNHCR、UN Global Compact on Refugees。',
    tags: ['社会', '人道', '法'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Refugee',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'fund', label: '资助/投资', desc: '给 UNHCR 捐' }, { type: 'community', label: '社区/组织', desc: '参与志愿活动' }]
  },
  {
    id: 'aging-population',
    category: 'social',
    title: '人口老龄化',
    titleJa: '人口の高齢化',
    titleEs: '> 65+ mejora de la esperanza de vida saludable (HALE) ≥ 3 años/10 años; tasa de reemplazo de pensiones ≥ 60% y sostenibilidad fiscal; El gasto médico + atención a largo plazo como porcentaje del PIB se mantiene estable ≤ 8%, mientras que HALE continúa creciendo (sin paradoja de compensación entre "compresión" y "expansión").',
    titleEn: 'Aging Population',
    year: 2015,
    proposer: 'UN / WHO',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '让 10 亿老人活得健康、有尊严',
    summaryJa: '10億人の高齢者が健康で尊厳のある生活を送れるように',
    summaryEs: '> 65+ mejora de la esperanza de vida saludable (HALE) ≥ 3 años/10 años; tasa de reemplazo de pensiones ≥ 60% y sostenibilidad fiscal; El gasto médico + atención a largo plazo como porcentaje del PIB se mantiene estable ≤ 8%, mientras que HALE continúa creciendo (sin paradoja de compensación entre "compresión" y "expansión").',
    summaryEn: '> 65+ healthy life expectancy (HALE) improvement ≥ 3 years/10 years; pension replacement rate ≥ 60% and fiscal sustainability; medical + long-term care spending as a share of GDP stable ≤ 8% while HALE continues to grow (no "compression" vs. "expansion" trade-off paradox).',
    kid: '2025 年全球 65 岁以上老人首次超过 5 岁以下儿童。活得久是好消息，但养老金、医疗、陪伴怎么办？日本、德国、中国都面对这个问题。',
    formal: '> 65+ 健康预期寿命 (HALE) 提升 ≥ 3 年 / 10 年；养老金替代率 ≥ 60% 且财政可持续；医疗 + 长期照护支出占 GDP 比例稳定 ≤ 8% 同时 HALE 继续增长（不存在"压缩" vs "扩张" 的权衡悖论）。',
    formalJa: '> 65 +健康寿命（ Hale ）は3年/10年以上増加します。年金置換率は60 ％以上で財政的に持続可能です。ヘイルが成長し続けている間、GDPの安定したパーセンテージとしてのヘルスケア+長期ケア支出は8 ％以下です（「圧縮」対「拡大」トレードオフパラドックスはありません）。',
    formalEs: '> 65+ mejora de la esperanza de vida saludable (HALE) ≥ 3 años/10 años; tasa de reemplazo de pensiones ≥ 60% y sostenibilidad fiscal; El gasto médico + atención a largo plazo como porcentaje del PIB se mantiene estable ≤ 8%, mientras que HALE continúa creciendo (sin paradoja de compensación entre "compresión" y "expansión").',
    formalEn: '> 65+ healthy life expectancy (HALE) improvement ≥ 3 years/10 years; pension replacement rate ≥ 60% and fiscal sustainability; medical + long-term care spending as a share of GDP stable ≤ 8% while HALE continues to grow (no "compression" vs. "expansion" trade-off paradox).',
    whyHard: '生育率下行不可逆；劳动力-赡养比恶化；痴呆/慢病缺乏根治手段。',
    aiPrompt: '介绍 WHO HALE、养老金三支柱、机器人护理、延缓衰老研究。',
    tags: ['人口', '健康', '经济'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Aging Population',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'community', label: '社区/组织', desc: '陪伴独居老人' }, { type: 'data', label: '数据收集/标注', desc: '收集身边老人生活状况数据' }, { type: 'essay', label: '写文章/论文', desc: '介绍 HALE 指标' }]
  },
  {
    id: 'education-access',
    category: 'social',
    title: '教育公平',
    titleJa: '教育における公平性',
    titleEs: 'Equidad educativa global: (a) tasa de no escolarización < 5%, (b) tasa de cumplimiento de la calidad del aprendizaje (PISA/PIAAC, etc.) ≥ 80%, (c) reducción de la brecha de género/urbano-rural/ingresos ≥ 50%, (d) verificado por datos del UIS de la UNESCO.',
    titleEn: 'Education Access',
    year: 2000,
    proposer: 'UN Millennium',
    difficulty: 3,
    reward: 0,
    status: 'partially_solved',
    summary: '让所有孩子都能上好学',
    summaryJa: 'すべての子供が簡単に学校に行けるようにする',
    summaryEs: 'Equidad educativa global: (a) tasa de no escolarización < 5%, (b) tasa de cumplimiento de la calidad del aprendizaje (PISA/PIAAC, etc.) ≥ 80%, (c) reducción de la brecha de género/urbano-rural/ingresos ≥ 50%, (d) verificado por datos del UIS de la UNESCO.',
    summaryEn: 'Global education equity: (a) out-of-school rate < 5%, (b) learning quality compliance rate (PISA/PIAAC, etc.) ≥ 80%, (c) gender/urban-rural/income gap reduction ≥ 50%, (d) verified by UNESCO UIS data.',
    kid: '联合国目标 4：到 2030 年所有孩子都能上完免费、公平、优质的初等和中等教育。2600 万失学儿童中 59% 是撒哈拉以南的。',
    formal: '全球教育公平：(a) 失学率 < 5%、(b) 学习质量达标率 (PISA/PIAAC 等) ≥ 80%、(c) 性别/城乡/收入差距缩小 ≥ 50%、(d) 由 UNESCO UIS 数据验证。',
    formalJa: '世界的な教育の公平性： （ a ） 5 ％未満の中退率、（ b ） 80 ％以上の学習品質の達成率（ PISA/PIAACなど）、（ c ）ジェンダー/都市-農村/所得格差の50 ％以上の減少、（ d ）ユネスコUISデータによって検証された。',
    formalEs: 'Equidad educativa global: (a) tasa de no escolarización < 5%, (b) tasa de cumplimiento de la calidad del aprendizaje (PISA/PIAAC, etc.) ≥ 80%, (c) reducción de la brecha de género/urbano-rural/ingresos ≥ 50%, (d) verificado por datos del UIS de la UNESCO.',
    formalEn: 'Global education equity: (a) out-of-school rate < 5%, (b) learning quality compliance rate (PISA/PIAAC, etc.) ≥ 80%, (c) gender/urban-rural/income gap reduction ≥ 50%, (d) verified by UNESCO UIS data.',
    whyHard: '战争、贫困、性别。',
    aiPrompt: '介绍 UNESCO UIS、BRAC。',
    tags: ['社会', '教育', '儿童'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Education Access',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'fund', label: '资助/投资', desc: '给 Room to Read 捐' }, { type: 'community', label: '社区/组织', desc: '参与支教' }]
  },
  {
    id: 'gender-equity',
    category: 'social',
    title: '性别平等',
    titleJa: '男女平等',
    titleEs: 'Igualdad de género global: (a) Brecha salarial de género < 10%, (b) Representación parlamentaria ≥ 40%, (c) Mujeres en campos STEM ≥ 40%, (d) Violencia de género reducida en ≥ 50%; verificado por el Índice Global de Brecha de Género del WEF ≥ 0,9.',
    titleEn: 'Gender Equity',
    year: 1995,
    proposer: 'Beijing Declaration',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '让所有人性别平等',
    summaryJa: 'すべての人のためのジェンダー平等',
    summaryEs: 'Igualdad de género global: (a) Brecha salarial de género < 10%, (b) Representación parlamentaria ≥ 40%, (c) Mujeres en campos STEM ≥ 40%, (d) Violencia de género reducida en ≥ 50%; verificado por el Índice Global de Brecha de Género del WEF ≥ 0,9.',
    summaryEn: 'Global gender equality: (a) Gender pay gap < 10%, (b) Parliamentary representation ≥ 40%, (c) Women in STEM fields ≥ 40%, (d) Gender-based violence reduced by ≥ 50%; verified by WEF Global Gender Gap Index ≥ 0.9.',
    kid: '全球女性平均收入比男性少 23%，政治代表不到 30%，STEM 领域更少。SDG 5 致力于 2030 年实现性别平等。',
    formal: '全球性别平等：(a) 性别收入差 < 10%、(b) 议会代表 ≥ 40%、(c) STEM 领域女性比例 ≥ 40%、(d) 性别暴力发生率下降 ≥ 50%；由 WEF Global Gender Gap Index ≥ 0.9 验证。',
    formalJa: '世界的なジェンダー平等： （ a ）ジェンダー賃金格差< 10 ％、（ b ）議会代表≥ 40 ％、（ c ） STEMにおける女性の割合≥ 40 ％、（ d ）ジェンダーに基づく暴力の発生率の減少≥ 50 ％。WEFグローバルジェンダー格差指数≥ 0.9によって検証されています。',
    formalEs: 'Igualdad de género global: (a) Brecha salarial de género < 10%, (b) Representación parlamentaria ≥ 40%, (c) Mujeres en campos STEM ≥ 40%, (d) Violencia de género reducida en ≥ 50%; verificado por el Índice Global de Brecha de Género del WEF ≥ 0,9.',
    formalEn: 'Global gender equality: (a) Gender pay gap < 10%, (b) Parliamentary representation ≥ 40%, (c) Women in STEM fields ≥ 40%, (d) Gender-based violence reduced by ≥ 50%; verified by WEF Global Gender Gap Index ≥ 0.9.',
    whyHard: '文化和法律。',
    aiPrompt: '介绍 UN Women、WEF Gender Gap。',
    tags: ['社会', '性别', '人权'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Gender Equity',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍性别研究' }, { type: 'community', label: '社区/组织', desc: '参与倡导' }]
  },
  {
    id: 'digital-divide',
    category: 'social',
    title: '数字鸿沟',
    titleJa: 'デジタルデバイド',
    titleEs: '> Índice IDI de la UIT < 0,1 (brecha "conectados versus no conectados"), IDI para todos los subgrupos interseccionales por dimensiones de edad/ingresos/urbano/rural/género/discapacidad ≥ mediana global - 1σ.',
    titleEn: 'Digital Divide',
    year: 2000,
    proposer: 'OECD / ITU',
    difficulty: 3,
    reward: 800,
    status: 'open',
    summary: '让 AI 红利不只属于会用的人',
    summaryJa: 'AI配当を活用できる人だけでなく、',
    summaryEs: '> Índice IDI de la UIT < 0,1 (brecha "conectados versus no conectados"), IDI para todos los subgrupos interseccionales por dimensiones de edad/ingresos/urbano/rural/género/discapacidad ≥ mediana global - 1σ.',
    summaryEn: '> ITU IDI index < 0.1 ("connected vs. unconnected" gap), IDI for all intersectional subgroups by age/income/urban/rural/gender/disability dimensions ≥ global median - 1σ.',
    kid: '有的老人不会用健康码、有的孩子家里没电脑上网课、有的山区连 4G 信号都没有。世界越数字化，不会用的人就越被甩开。怎么让所有人都能搭上数字化的车？',
    formal: '> ITU IDI 指数 < 0.1（"已连接 vs 未连接"差距），按年龄/收入/城乡/性别/残障维度所有交叉子群的 IDI 都 ≥ 全球中位数 - 1σ。',
    formalJa: '> ITU IDI Index < 0.1 (" Connected vs. Disconnected "Gap), IDI by age/income/urban/rural/gender/disability dimension for all crossover subgroups ≥ global median - 1 σ.',
    formalEs: '> Índice IDI de la UIT < 0,1 (brecha "conectados versus no conectados"), IDI para todos los subgrupos interseccionales por dimensiones de edad/ingresos/urbano/rural/género/discapacidad ≥ mediana global - 1σ.',
    formalEn: '> ITU IDI index < 0.1 ("connected vs. unconnected" gap), IDI for all intersectional subgroups by age/income/urban/rural/gender/disability dimensions ≥ global median - 1σ.',
    whyHard: '硬件成本、内容可达性、用户能力（不只是接入）、算法偏见。',
    aiPrompt: '介绍 ITU IDI、可负担宽带 (USD/GDP)、数字扫盲、辅助技术 (a11y)、AI 公平性。',
    tags: ['数字', '公平', 'AI'],
    videoUrl: 'https://www.youtube.com/embed/feature_video_placeholder',
    videoTitle: 'Digital Divide',
    videoChannel: 'Kurzgesagt',
    participate: [{ type: 'community', label: '社区/组织', desc: '教长辈用智能手机' }, { type: 'code', label: '写代码/算法', desc: '无障碍网页工具' }, { type: 'essay', label: '写文章/论文', desc: '介绍 ITU IDI 指数' }]
  },
  {
    id: 'levy-cuckoo',
    category: 'mathematics',
    title: 'Lévy 猜想',
    titleJa: 'レヴィ予想',
    titleEs: 'Si cada operador lineal de ℓ₂ → ℓ₂ tiene un selector Borel.',
    titleEn: 'Lévy\'s Conjecture',
    year: 1955,
    proposer: 'P. Lévy',
    difficulty: 3,
    reward: 500,
    status: 'refuted',
    summary: '某些泛函有 Borel 可测选择吗？',
    summaryJa: '一部の関数には、ボレルのテスト可能なオプションがありますか？',
    summaryEs: 'Si cada operador lineal de ℓ₂ → ℓ₂ tiene un selector Borel.',
    summaryEn: 'Whether every linear operator of ℓ₂ → ℓ₂ has a Borel selector.',
    kid: 'Lévy 1955 年猜想：所有 Hilbert 空间之间的连续线性算子都有可测的右逆。已经被证明是错的，但相关变种仍有价值。',
    formal: '每个 ℓ₂ → ℓ₂ 的线性算子是否有 Borel 选择子。',
    formalJa: '→ ℓ ₂ ℓ ₂の各線形演算子は、ボレルセレクターを有する。',
    formalEs: 'Si cada operador lineal de ℓ₂ → ℓ₂ tiene un selector Borel.',
    formalEn: 'Whether every linear operator of ℓ₂ → ℓ₂ has a Borel selector.',
    whyHard: '需要集合论与泛函分析工具。',
    aiPrompt: '介绍选择子与 Banach-Mazur 游戏。',
    tags: ['分析', '泛函', '反驳'],
    videoUrl: '',
    videoTitle: '',
    videoChannel: '',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明反例的简化' }, { type: 'survey', label: '文献综述', desc: '读经典反驳论文' }, { type: 'essay', label: '写文章/论文', desc: '介绍选择子' }]
  },
  {
    id: 'union-closed',
    category: 'mathematics',
    title: '并封闭集族猜想',
    titleJa: 'クランの推測を囲みます。',
    titleEs: 'Y el conjunto cerrado F debe tener un ∈ ∪F tal que |{S ∈ F: a ∈ S}| ≥ |F|/2.',
    titleEn: 'Union-Closed Sets Conjecture',
    year: 1979,
    proposer: 'P. Frankl',
    difficulty: 4,
    reward: 0,
    status: 'open',
    summary: '并封闭集族必有一个"多数元素"在过半集合里？',
    summaryJa: 'セットファミリーを囲むには、セットの半分に「過半数要素」が必要ですか？',
    summaryEs: 'Y el conjunto cerrado F debe tener un ∈ ∪F tal que |{S ∈ F: a ∈ S}| ≥ |F|/2.',
    summaryEn: 'And the closed set F must have a ∈ ∪F such that |{S ∈ F: a ∈ S}| ≥ |F|/2.',
    kid: '给定一个"并封闭"的集合族 F（F 中任意两个集合的并还在 F 中），总存在一个元素 a 出现在至少一半的集合里。2015 年后部分进展。',
    formal: '并封闭集族 F 必有 a ∈ ∪F 使 |{S ∈ F: a ∈ S}| ≥ |F|/2。',
    formalJa: 'そして、閉集合群Fは、|{ S ∈ F: a ∈ S }|≥| F |/ 2への∈ Fを持たなければならない。',
    formalEs: 'Y el conjunto cerrado F debe tener un ∈ ∪F tal que |{S ∈ F: a ∈ S}| ≥ |F|/2.',
    formalEn: 'And the closed set F must have a ∈ ∪F such that |{S ∈ F: a ∈ S}| ≥ |F|/2.',
    whyHard: '看似组合直觉，但很难严格证明。',
    aiPrompt: '介绍 Frankl 猜想。',
    tags: ['组合', '集合', '猜想'],
    videoUrl: '',
    videoTitle: '',
    videoChannel: '',
    participate: [{ type: 'solve', label: '尝试求解/证明', desc: '尝试证明 Frankl 猜想' }, { type: 'code', label: '写代码/算法', desc: '用 SageMath 验证小例子' }, { type: 'essay', label: '写文章/论文', desc: '介绍近年进展' }]
  },
  {
    id: 'smooth-4d-poincare',
    category: 'mathematics',
    title: '光滑 4 维庞加莱猜想',
    titleJa: 'スムーズな4 Dポアンカレ予想',
    titleEs: '¿S ^ 4 tiene una estructura suave solo en el sentido de difeomorfismo?',
    titleEn: 'Smooth 4D Poincaré Conjecture',
    year: 1982,
    proposer: 'M. Freedman',
    difficulty: 5,
    reward: 0,
    status: 'solved',
    summary: '4 维光滑庞加莱猜想在维数上有点不同',
    summaryJa: '4次元の滑らかなポアンカレ予想は、次元が少し異なります',
    summaryEs: '¿S ^ 4 tiene una estructura suave solo en el sentido de difeomorfismo?',
    summaryEn: 'Does S^4 have a smooth structure only in the diffeomorphism sense.',
    kid: 'Freedman 1982 年证明拓扑版本的 4 维庞加莱猜想，但光滑版本仍未解。',
    formal: 'S^4 是否只在微分同胚意义下有光滑结构。',
    formalJa: 'S ^ 4が微分準同型の意味でのみ滑らかな構造を有するかどうか。',
    formalEs: '¿S ^ 4 tiene una estructura suave solo en el sentido de difeomorfismo?',
    formalEn: 'Does S^4 have a smooth structure only in the diffeomorphism sense.',
    whyHard: '4 维有无穷多"奇异光滑结构"。',
    aiPrompt: '介绍 Freedman、Casson handle。',
    tags: ['拓扑', '4 维', '光滑'],
    videoUrl: '',
    videoTitle: '',
    videoChannel: '',
    participate: [{ type: 'survey', label: '文献综述', desc: '读 Freedman 工作' }, { type: 'essay', label: '写文章/论文', desc: '介绍奇异光滑结构' }]
  },
  {
    id: 'rearrangement',
    category: 'chemistry',
    title: '生物催化重排反应',
    titleJa: '生体触媒再配列',
    titleEs: 'Desarrollar reordenamientos catalizados por enzimas con tasas de rotación >1000 y carga de sustrato >100 g/L.',
    titleEn: 'Biocatalytic Rearrangement',
    year: 2010,
    proposer: '—',
    difficulty: 3,
    reward: 1000,
    status: 'open',
    summary: '用酶实现工业级重排反应',
    summaryJa: '酵素との工業用グレードの再配列反応',
    summaryEs: 'Desarrollar reordenamientos catalizados por enzimas con tasas de rotación >1000 y carga de sustrato >100 g/L.',
    summaryEn: 'Develop enzyme-catalyzed rearrangements with >1000 turnovers rates and >100 g/L substrate loading.',
    kid: 'Claisen 重排、Cope 重排等是有机合成重要反应，传统需要高温或重金属催化剂。酶能在室温水溶液中进行。',
    formal: '开发 > 1000 turnovers 速率、> 100 g/L 底物负载的酶催化重排。',
    formalJa: '酵素触媒による転換> 1000ターンオーバー率、> 100 g/L基質負荷を開発する。',
    formalEs: 'Desarrollar reordenamientos catalizados por enzimas con tasas de rotación >1000 y carga de sustrato >100 g/L.',
    formalEn: 'Develop enzyme-catalyzed rearrangements with >1000 turnovers rates and >100 g/L substrate loading.',
    whyHard: '酶活性位点设计。',
    aiPrompt: '介绍生物催化与定向进化。',
    tags: ['生物', '催化', '有机'],
    videoUrl: '',
    videoTitle: '',
    videoChannel: '',
    participate: [{ type: 'experiment', label: '动手实验', desc: '定向进化酶' }, { type: 'essay', label: '写文章/论文', desc: '介绍生物催化优势' }]
  },
  {
    id: 'ai-protein-halluc',
    category: 'biology',
    title: 'AI 蛋白质"幻觉"',
    titleJa: 'AIタンパク質「幻覚」',
    titleEs: 'Las proteínas diseñadas por IA tienen una tasa de éxito superior al 50 % en experimentos húmedos.',
    titleEn: 'AI Protein Hallucination',
    year: 2024,
    proposer: '—',
    difficulty: 3,
    reward: 1000,
    status: 'open',
    summary: '让 AI 设计自然界不存在的全新蛋白质',
    summaryJa: 'AIが自然界に存在しない新しいタンパク質を設計できるようにする',
    summaryEs: 'Las proteínas diseñadas por IA tienen una tasa de éxito superior al 50 % en experimentos húmedos.',
    summaryEn: 'AI-designed proteins have >50% success rate in wet experiments.',
    kid: 'AlphaFold 预测结构，但 RFdiffusion 真正"发明"全新蛋白质。2024 年 Baker 团队用 AI 设计了前所未有的功能蛋白质。',
    formal: 'AI 设计的蛋白质在湿实验中有 > 50% 的成功率。',
    formalJa: 'Ａ Ｉ設計タンパク質は、湿式実験において５ ０ ％超の成功率を有する。',
    formalEs: 'Las proteínas diseñadas por IA tienen una tasa de éxito superior al 50 % en experimentos húmedos.',
    formalEn: 'AI-designed proteins have >50% success rate in wet experiments.',
    whyHard: '设计-表达-折叠-功能链条。',
    aiPrompt: '介绍 RFdiffusion、Chroma。',
    tags: ['AI', '蛋白质', '设计'],
    videoUrl: '',
    videoTitle: '',
    videoChannel: '',
    participate: [{ type: 'code', label: '写代码/算法', desc: '用 RFdiffusion 设计' }, { type: 'experiment', label: '动手实验', desc: '表达验证' }, { type: 'essay', label: '写文章/论文', desc: '介绍 Baker 工作' }]
  },
  {
    id: 'voice-cloning-rights',
    category: 'social',
    title: '语音克隆权',
    titleJa: '音声クローニング権',
    titleEs: 'El marco legal y técnico de los derechos de voz: (a) ≥ 30 legislaciones nacionales aclaran claramente la voz como un derecho de la personalidad, (b) mecanismo de consentimiento + estándar de autorización comercial (marca de tiempo de blockchain + marca de agua digital), (c) precisión de detección de deepfake ≥ 95%, (d) mecanismo claro de reparación judicial (eliminación/compensación/penal).',
    titleEn: 'Voice Cloning Rights',
    year: 2024,
    proposer: '—',
    difficulty: 3,
    reward: 0,
    status: 'open',
    summary: '谁能用你的声音？',
    summaryJa: '誰があなたの声を使うことができますか？',
    summaryEs: 'El marco legal y técnico de los derechos de voz: (a) ≥ 30 legislaciones nacionales aclaran claramente la voz como un derecho de la personalidad, (b) mecanismo de consentimiento + estándar de autorización comercial (marca de tiempo de blockchain + marca de agua digital), (c) precisión de detección de deepfake ≥ 95%, (d) mecanismo claro de reparación judicial (eliminación/compensación/penal).',
    summaryEn: 'The legal and technical framework of voice rights: (a) ≥ 30 national legislation clearly clarifies voice as a personality right, (b) consent mechanism + commercial authorization standard (blockchain timestamp + digital watermark), (c) deepfake detection accuracy ≥ 95%, (d) clear judicial relief mechanism (deletion/compensation/criminal).',
    kid: 'AI 能在 3 秒音频就克隆你的声音。诈骗、假新闻、个人权利都受威胁。需要法律和技术保护。',
    formal: '声音权利的法律和技术框架：(a) ≥ 30 国家立法明确声音作为人格权、(b) 同意机制 + 商用授权标准 (区块链时间戳 + 数字水印)、(c) 深度伪造检测准确率 ≥ 95%、(d) 司法救济机制（删除/赔偿/刑事）明确。',
    formalJa: '声の権利のための法的および技術的枠組み： （ a ） 30以上の国の法律は、声を人格権として定義しています。（ b ）同意メカニズム+商業承認基準（ブロックチェーンタイムスタンプ+デジタルウォーターマーク）。（ c ）深い偽造検出精度95 ％以上。（ d ）司法救済メカニズム（削除/補償/犯罪）が明確です。',
    formalEs: 'El marco legal y técnico de los derechos de voz: (a) ≥ 30 legislaciones nacionales aclaran claramente la voz como un derecho de la personalidad, (b) mecanismo de consentimiento + estándar de autorización comercial (marca de tiempo de blockchain + marca de agua digital), (c) precisión de detección de deepfake ≥ 95%, (d) mecanismo claro de reparación judicial (eliminación/compensación/penal).',
    formalEn: 'The legal and technical framework of voice rights: (a) ≥ 30 national legislation clearly clarifies voice as a personality right, (b) consent mechanism + commercial authorization standard (blockchain timestamp + digital watermark), (c) deepfake detection accuracy ≥ 95%, (d) clear judicial relief mechanism (deletion/compensation/criminal).',
    whyHard: '法律滞后于技术。',
    aiPrompt: '介绍 deepfake voice、SAG-AFTRA 罢工。',
    tags: ['社会', 'AI', '权利'],
    videoUrl: '',
    videoTitle: '',
    videoChannel: '',
    participate: [{ type: 'essay', label: '写文章/论文', desc: '介绍声音权' }, { type: 'discuss', label: '想法/讨论', desc: '参与立法讨论' }, { type: 'community', label: '社区/组织', desc: '保护亲友不受 deepfake 诈骗' }]
  },
  {
    id: 'continual-learning',
    category: 'cs',
    title: '持续学习',
    titleJa: '継続的学習',
    titleEs: 'Los sistemas de inteligencia artificial pueden aprender nuevas tareas sin olvidar significativamente las antiguas.',
    titleEn: 'Continual Learning',
    year: 2010,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: 'AI 能不能一直学习不忘记？',
    summaryJa: 'AIは学習を続け、忘れないことができますか？',
    summaryEs: 'Los sistemas de inteligencia artificial pueden aprender nuevas tareas sin olvidar significativamente las antiguas.',
    summaryEn: 'AI systems can learn new tasks without significantly forgetting old tasks.',
    kid: '现在的 AI 学新东西会"灾难性遗忘"（比如学完法语忘英语）。持续学习让 AI 像人一样一辈子学。',
    formal: 'AI 系统能在学习新任务时不显著遗忘旧任务。',
    formalJa: 'AIシステムは、古いタスクを大幅に忘れることなく、新しいタスクを学習することができます。',
    formalEs: 'Los sistemas de inteligencia artificial pueden aprender nuevas tareas sin olvidar significativamente las antiguas.',
    formalEn: 'AI systems can learn new tasks without significantly forgetting old tasks.',
    whyHard: '需要平衡可塑性与稳定性。',
    aiPrompt: '介绍 Elastic Weight Consolidation。',
    tags: ['AI', '学习', '记忆'],
    videoUrl: '',
    videoTitle: '',
    videoChannel: '',
    participate: [{ type: 'code', label: '写代码/算法', desc: '实现 EWC' }, { type: 'essay', label: '写文章/论文', desc: '介绍持续学习挑战' }]
  },
  {
    id: 'molecular-medicine',
    category: 'chemistry',
    title: '分子医学',
    titleJa: '分子医学',
    titleEs: 'Para los pacientes con cualquier variante genética, se diseñan medicamentos personalizados o tratamientos de ARN basados ​​en genoma/proteómica, y ≥ 80% de los pacientes en ensayos clínicos de fase III lograron una eficacia significativa (RECIST o indicadores equivalentes), y la tasa de reacciones adversas graves fue < 5%.',
    titleEn: 'Precision Medicine',
    year: 2015,
    proposer: '—',
    difficulty: 4,
    reward: 2000,
    status: 'open',
    summary: '让药对每个人都精准',
    summaryJa: 'すべての人にとって薬が正確になるようにしましょう',
    summaryEs: 'Para los pacientes con cualquier variante genética, se diseñan medicamentos personalizados o tratamientos de ARN basados ​​en genoma/proteómica, y ≥ 80% de los pacientes en ensayos clínicos de fase III lograron una eficacia significativa (RECIST o indicadores equivalentes), y la tasa de reacciones adversas graves fue < 5%.',
    summaryEn: 'For patients with any genetic variant, personalized drugs or RNA treatments are designed based on genome/proteomics, and ≥ 80% of patients in phase III clinical trials achieved significant efficacy (RECIST or equivalent indicators), and the serious adverse reaction rate was < 5%.',
    kid: '同样的药在 1000 个人里 800 人有效，200 人无效或副作用。能不能根据基因、肠道菌群精准开药？',
    formal: '对任意基因变异型患者，基于基因组/蛋白质组学设计个性化药物或 RNA 治疗，在 III 期临床试验中 ≥ 80% 患者获得显著疗效 (RECIST 或等效指标)，且严重不良反应率 < 5%。',
    formalJa: '任意の遺伝的変異体を有する患者において、個別化された薬物またはＲＮＡ療法は、ゲノミクス／プロテオミクスに基づいて設計され、有意な有効性（ ＲＥＣＩＳＴまたは同等物）は、第ＩＩＩ相臨床試験の患者の８ ０ ％以上で達成され、重篤な有害反応率は５ ％未満である。',
    formalEs: 'Para los pacientes con cualquier variante genética, se diseñan medicamentos personalizados o tratamientos de ARN basados ​​en genoma/proteómica, y ≥ 80% de los pacientes en ensayos clínicos de fase III lograron una eficacia significativa (RECIST o indicadores equivalentes), y la tasa de reacciones adversas graves fue < 5%.',
    formalEn: 'For patients with any genetic variant, personalized drugs or RNA treatments are designed based on genome/proteomics, and ≥ 80% of patients in phase III clinical trials achieved significant efficacy (RECIST or equivalent indicators), and the serious adverse reaction rate was < 5%.',
    whyHard: '多基因 + 环境因素。',
    aiPrompt: '介绍 pharmacogenomics。',
    tags: ['医学', '基因', '精准'],
    videoUrl: '',
    videoTitle: '',
    videoChannel: '',
    participate: [{ type: 'code', label: '写代码/算法', desc: '基因组分析' }, { type: 'essay', label: '写文章/论文', desc: '介绍精准医疗' }]
  },
  {
    id: 'sustainable-concrete',
    category: 'engineering',
    title: '可持续混凝土',
    titleJa: '持続可能なコンクリート',
    titleEs: 'Cemento/hormigón: La producción de emisiones de CO₂ se reduce en ≥ 50%, el costo es ≤ 1,2 veces el del cemento tradicional, la resistencia es ≥ la misma calidad que el cemento ordinario y se puede sustituir a gran escala (capacidad de producción anual ≥ 10⁸ toneladas).',
    titleEn: 'Sustainable Concrete',
    year: 2010,
    proposer: '—',
    difficulty: 3,
    reward: 1500,
    status: 'partially_solved',
    summary: '让水泥行业去碳化',
    summaryJa: 'セメント産業の脱炭素化',
    summaryEs: 'Cemento/hormigón: La producción de emisiones de CO₂ se reduce en ≥ 50%, el costo es ≤ 1,2 veces el del cemento tradicional, la resistencia es ≥ la misma calidad que el cemento ordinario y se puede sustituir a gran escala (capacidad de producción anual ≥ 10⁸ toneladas).',
    summaryEn: 'Cement/concrete: The production of CO₂ emissions is reduced by ≥ 50%, the cost is ≤ 1.2 times that of traditional cement, the strength is ≥ the same grade of ordinary cement, and it can be substituted on a large scale (annual production capacity ≥ 10⁸ tons).',
    kid: '水泥生产贡献全球 7% CO₂。能用工业副产品（粉煤灰、矿渣）替代或用电弧炉？',
    formal: '水泥/混凝土：生产 CO₂ 排放减少 ≥ 50%、成本 ≤ 传统水泥 1.2 倍、强度 ≥ 同等级普通水泥、且能大规模替代 (年产能 ≥ 10⁸ 吨)。',
    formalJa: 'セメント/コンクリート： CO ₂排出量削減≥ 50 ％、コスト≤従来のセメントの1.2倍、強度≥通常のセメントと同じグレード、および大規模に交換することができます（年間生産能力≥ 10トン）。',
    formalEs: 'Cemento/hormigón: La producción de emisiones de CO₂ se reduce en ≥ 50%, el costo es ≤ 1,2 veces el del cemento tradicional, la resistencia es ≥ la misma calidad que el cemento ordinario y se puede sustituir a gran escala (capacidad de producción anual ≥ 10⁸ toneladas).',
    formalEn: 'Cement/concrete: The production of CO₂ emissions is reduced by ≥ 50%, the cost is ≤ 1.2 times that of traditional cement, the strength is ≥ the same grade of ordinary cement, and it can be substituted on a large scale (annual production capacity ≥ 10⁸ tons).',
    whyHard: '材料性能。',
    aiPrompt: '介绍 LC3、CarbonCure。',
    tags: ['建筑', '工程', '气候'],
    videoUrl: '',
    videoTitle: '',
    videoChannel: '',
    participate: [{ type: 'experiment', label: '动手实验', desc: '新型混凝土配方' }, { type: 'essay', label: '写文章/论文', desc: '介绍 LC3 项目' }]
  }
,
  {
    id: 'phys-roomtemp-sc-cuprate',
    category: 'physics',
    title: '铜氧化物高温超导的微观机制',
    titleJa: 'オックス銅の高温超電導の顕微鏡的機構',
    titleEs: 'Mecanismo microscópico de la superconductividad del cuprato de alta Tc: propuesto por Bednorz & Müller / Anderson / varios equipos en 1986, los experimentos / teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Microscopic mechanism of cuprate high-Tc superconductivity',
    year: 1986,
    proposer: 'Bednorz & Müller / Anderson / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：铜氧化物高温超导的微观机制。',
    summaryJa: '物理学の分野における特定の困難な問題：酸化銅の高温超電導の顕微鏡的メカニズム。',
    summaryEs: 'Mecanismo microscópico de la superconductividad del cuprato de alta Tc: propuesto por Bednorz & Müller / Anderson / varios equipos en 1986, los experimentos / teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Microscopic mechanism of cuprate high-Tc superconductivity.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 铜氧化物高温超导的微观机制 是这样一个问题：「铜氧化物高温超导的微观机制」是 物理 领域的 超导 方向，涉及 超导, 强关联, d波 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「铜氧化物高温超导的微观机制」是 物理 领域的 超导 方向，涉及 超导, 强关联, d波 等方面。',
    formal: '铜氧化物高温超导的微观机制（Microscopic mechanism of cuprate high-Tc superconductivity）：Bednorz & Müller / Anderson / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    formalJa: '銅酸塩高Tc超電導の顕微鏡的メカニズム： 1986年にBednorz ＆ Müller/Anderson/複数チームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo microscópico de la superconductividad del cuprato de alta Tc: propuesto por Bednorz & Müller / Anderson / varios equipos en 1986, los experimentos / teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Microscopic mechanism of cuprate high-Tc superconductivity: proposed by Bednorz & Müller / Anderson / 多团队 in 1986; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超导', '强关联', 'd波'],
  },
  {
    id: 'phys-iron-pnictide-sc',
    category: 'physics',
    title: '铁基超导体中的 s± 配对对称性',
    titleJa: '鉄系超伝導体におけるs ±対称性',
    titleEs: 'Simetría de emparejamiento s± en superconductores de hierro-pnictida: propuesta por Hosono/múltiples equipos en 2008, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 's± pairing symmetry in iron-pnictide superconductors',
    year: 2008,
    proposer: 'Hosono / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：铁基超导体中的 s± 配对对称性。',
    summaryJa: '物理学の分野における特定の難題：鉄系超伝導体における対合の±対称性。',
    summaryEs: 'Simetría de emparejamiento s± en superconductores de hierro-pnictida: propuesta por Hosono/múltiples equipos en 2008, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: s± pairing symmetry in iron-pnictide superconductors.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 铁基超导体中的 s± 配对对称性 的问题。它可以简单描述为 「铁基超导体中的 s± 配对对称性」是 物理 领域的 超导 方向，涉及 超导, 多带 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「铁基超导体中的 s± 配对对称性」是 物理 领域的 超导 方向，涉及 超导, 多带 等方面。',
    formal: '铁基超导体中的 s± 配对对称性（s± pairing symmetry in iron-pnictide superconductors）：Hosono / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalJa: '鉄-ピクチド超伝導体のs ±ペアリング対称性：細野/マルチチームは2008年に提案され、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Simetría de emparejamiento s± en superconductores de hierro-pnictida: propuesta por Hosono/múltiples equipos en 2008, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 's± pairing symmetry in iron-pnictide superconductors: proposed by Hosono / 多团队 in 2008; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超导', '多带'],
  },
  {
    id: 'phys-rvb-spin-liquid',
    category: 'physics',
    title: '量子自旋液体 (RVB) 的实验实现',
    titleJa: '量子スピン液体（ RVB ）の実験的実装',
    titleEs: 'Realización experimental del líquido de espín cuántico (RVB): propuesto por Anderson/varios equipos en 1973, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Experimental realization of quantum spin liquid (RVB)',
    year: 1973,
    proposer: 'Anderson / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：量子自旋液体 (RVB) 的实验实现。',
    summaryJa: '物理学の分野における特定の難題：量子スピン液体（ RVB ）の実験的実現。',
    summaryEs: 'Realización experimental del líquido de espín cuántico (RVB): propuesto por Anderson/varios equipos en 1973, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Experimental realization of quantum spin liquid (RVB).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 量子自旋液体 (RVB) 的实验实现 的核心问题是：「量子自旋液体 (RVB) 的实验实现」是 物理 领域的 自旋液体 方向，涉及 自旋液体, 阻挫 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「量子自旋液体 (RVB) 的实验实现」是 物理 领域的 自旋液体 方向，涉及 自旋液体, 阻挫 等方面。',
    formal: '量子自旋液体 (RVB) 的实验实现（Experimental realization of quantum spin liquid (RVB)）：Anderson / 多团队 在 1973 年提出，相关实验/理论至今未完全解决。',
    formalJa: '量子スピン液体（ RVB ）の実験的実現： 1973年にAnderson/Multipleチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Realización experimental del líquido de espín cuántico (RVB): propuesto por Anderson/varios equipos en 1973, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Experimental realization of quantum spin liquid (RVB): proposed by Anderson / 多团队 in 1973; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Anderson / 多团队 等人在 1973 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自旋液体', '阻挫'],
  },
  {
    id: 'phys-mbl-eth',
    category: 'physics',
    title: '多体局域化 (MBL) 是否真正破坏遍历性',
    titleJa: 'マルチボディローカライゼーション（ MBL ）は本当にエルゴジティを破壊しているのでしょうか？',
    titleEs: '¿La localización de muchos cuerpos (MBL) realmente rompe ETH?: Los equipos Pal/Huse/Múltiples propuestos en 2006, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Does many-body localization truly break ETH?',
    year: 2006,
    proposer: 'Pal / Huse / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：多体局域化 (MBL) 是否真正破坏遍历性。',
    summaryJa: '物理学の分野における特定の困難な問題：マルチボディローカライゼーション（ MBL ）が本当にエルゴディシスを破壊するかどうか。',
    summaryEs: '¿La localización de muchos cuerpos (MBL) realmente rompe ETH?: Los equipos Pal/Huse/Múltiples propuestos en 2006, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Does many-body localization truly break ETH?.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 多体局域化 (MBL) 是否真正破坏遍历性 的问题。它可以简单描述为 「多体局域化 (MBL) 是否真正破坏遍历性」是 物理 领域的 MBL 方向，涉及 MBL, 遍历性 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「多体局域化 (MBL) 是否真正破坏遍历性」是 物理 领域的 MBL 方向，涉及 MBL, 遍历性 等方面。',
    formal: '多体局域化 (MBL) 是否真正破坏遍历性（Does many-body localization truly break ETH?）：Pal / Huse / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalJa: '多本体ローカライゼーションは本当にETHを壊しますか？ ） ： PAL/HUSE/マルチチームは2006年に、関連する実験/理論はまだ完全に解決されていないと提案した。',
    formalEs: '¿La localización de muchos cuerpos (MBL) realmente rompe ETH?: Los equipos Pal/Huse/Múltiples propuestos en 2006, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Does many-body localization truly break ETH?: proposed by Pal / Huse / 多团队 in 2006; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MBL', '遍历性'],
  },
  {
    id: 'phys-floquet-topo',
    category: 'physics',
    title: 'Floquet 拓扑绝缘体的边态寿命',
    titleJa: 'Floquetトポロジカル絶縁体のエッジ寿命',
    titleEs: 'Vida útil de los estados de los bordes en los aisladores topológicos Floquet: propuesto por Kitagawa/Lindner/varios equipos en 2011, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Lifetime of edge states in Floquet topological insulators',
    year: 2011,
    proposer: 'Kitagawa / Lindner / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：Floquet 拓扑绝缘体的边态寿命。',
    summaryJa: '物理学の分野における特定の困難な問題： Floquetトポロジカル絶縁体のエッジ寿命。',
    summaryEs: 'Vida útil de los estados de los bordes en los aisladores topológicos Floquet: propuesto por Kitagawa/Lindner/varios equipos en 2011, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Lifetime of edge states in Floquet topological insulators.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 Floquet 拓扑绝缘体的边态寿命 是这样一个问题：「Floquet 拓扑绝缘体的边态寿命」是 物理 领域的 拓扑 方向，涉及 拓扑, 周期驱动 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Floquet 拓扑绝缘体的边态寿命」是 物理 领域的 拓扑 方向，涉及 拓扑, 周期驱动 等方面。',
    formal: 'Floquet 拓扑绝缘体的边态寿命（Lifetime of edge states in Floquet topological insulators）：Kitagawa / Lindner / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Floquetトポロジカル絶縁体のエッジ状態の寿命： 2011年にKitagawa/Lindner/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Vida útil de los estados de los bordes en los aisladores topológicos Floquet: propuesto por Kitagawa/Lindner/varios equipos en 2011, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Lifetime of edge states in Floquet topological insulators: proposed by Kitagawa / Lindner / 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '尽管 Kitagawa / Lindner / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['拓扑', '周期驱动'],
  },
  {
    id: 'phys-majorana-wire',
    category: 'physics',
    title: '半导体纳米线中 Majorana 零模的明确证据',
    titleJa: '半導体ナノワイヤにおけるMajoranaゼロモジュールの明確な証拠',
    titleEs: 'Evidencia definitiva de los modos cero de Majorana en nanocables semiconductores: propuesto por Lutchyn/Sau/varios equipos en 2010, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Definitive evidence of Majorana zero modes in semiconductor nanowires',
    year: 2010,
    proposer: 'Lutchyn / Sau / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：半导体纳米线中 Majorana 零模的明确证据。',
    summaryJa: '物理学の分野における特定の困難な問題：半導体ナノワイヤにおけるマヨラーナのゼロモードの明確な証拠。',
    summaryEs: 'Evidencia definitiva de los modos cero de Majorana en nanocables semiconductores: propuesto por Lutchyn/Sau/varios equipos en 2010, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Definitive evidence of Majorana zero modes in semiconductor nanowires.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 半导体纳米线中 Majorana 零模的明确证据 的核心问题是：「半导体纳米线中 Majorana 零模的明确证据」是 物理 领域的 Majorana 方向，涉及 Majorana, 拓扑 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「半导体纳米线中 Majorana 零模的明确证据」是 物理 领域的 Majorana 方向，涉及 Majorana, 拓扑 等方面。',
    formal: '半导体纳米线中 Majorana 零模的明确证据（Definitive evidence of Majorana zero modes in semiconductor nanowires）：Lutchyn / Sau / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '半導体ナノワイヤにおけるマヨラーナのゼロモードの決定的な証拠： 2010年にLutchyn/SAU/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Evidencia definitiva de los modos cero de Majorana en nanocables semiconductores: propuesto por Lutchyn/Sau/varios equipos en 2010, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Definitive evidence of Majorana zero modes in semiconductor nanowires: proposed by Lutchyn / Sau / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['Majorana', '拓扑'],
  },
  {
    id: 'phys-twisted-graphene-sc',
    category: 'physics',
    title: '魔角双层/三层石墨烯超导的配对机制',
    titleJa: 'マジックホーン二層/三層グラフェン超伝導のペアリング機構',
    titleEs: 'Mecanismo de emparejamiento en grafeno bicapa/tricapa retorcido de ángulo mágico: propuesto por Cao/Jarillo-Herrero/varios equipos en 2018, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Pairing mechanism in magic-angle twisted bilayer/trilayer graphene',
    year: 2018,
    proposer: 'Cao / Jarillo-Herrero / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：魔角双层/三层石墨烯超导的配对机制。',
    summaryJa: '物理学の分野における特定の困難な問題：魔法の角度の二重/三重層グラフェン超伝導性のペアリング機構。',
    summaryEs: 'Mecanismo de emparejamiento en grafeno bicapa/tricapa retorcido de ángulo mágico: propuesto por Cao/Jarillo-Herrero/varios equipos en 2018, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Pairing mechanism in magic-angle twisted bilayer/trilayer graphene.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 魔角双层/三层石墨烯超导的配对机制 的问题。它可以简单描述为 「魔角双层/三层石墨烯超导的配对机制」是 物理 领域的 超导 方向，涉及 超导, 魔角 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「魔角双层/三层石墨烯超导的配对机制」是 物理 领域的 超导 方向，涉及 超导, 魔角 等方面。',
    formal: '魔角双层/三层石墨烯超导的配对机制（Pairing mechanism in magic-angle twisted bilayer/trilayer graphene）：Cao / Jarillo-Herrero / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'マジックアングルツイスト二層/三層グラフェンのペアリング機構： 2018年にCao/Jarillo - Herrero/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de emparejamiento en grafeno bicapa/tricapa retorcido de ángulo mágico: propuesto por Cao/Jarillo-Herrero/varios equipos en 2018, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Pairing mechanism in magic-angle twisted bilayer/trilayer graphene: proposed by Cao / Jarillo-Herrero / 多团队 in 2018; related experiments/theory remain incomplete.',
    whyHard: '尽管 Cao / Jarillo-Herrero / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超导', '魔角'],
  },
  {
    id: 'phys-magic-graphene-insulator',
    category: 'physics',
    title: '魔角石墨烯关联绝缘态的起源',
    titleJa: 'マジックホーングラフェン関連絶縁状態の起源',
    titleEs: 'Origen de los estados aislantes correlacionados en el grafeno de ángulo mágico: propuesto por Cao/varios equipos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Origin of correlated insulating states in magic-angle graphene',
    year: 2018,
    proposer: 'Cao / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：魔角石墨烯关联绝缘态的起源。',
    summaryJa: '物理学の分野における特定の困難な問題：マジックアングルグラフェンの関連する絶縁状態の起源。',
    summaryEs: 'Origen de los estados aislantes correlacionados en el grafeno de ángulo mágico: propuesto por Cao/varios equipos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Origin of correlated insulating states in magic-angle graphene.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 魔角石墨烯关联绝缘态的起源 的核心问题是：「魔角石墨烯关联绝缘态的起源」是 物理 领域的 莫特 方向，涉及 莫特, 强关联 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「魔角石墨烯关联绝缘态的起源」是 物理 领域的 莫特 方向，涉及 莫特, 强关联 等方面。',
    formal: '魔角石墨烯关联绝缘态的起源（Origin of correlated insulating states in magic-angle graphene）：Cao / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    formalJa: '魔法角グラフェンにおける相関絶縁状態の起源： Cao/Multiチームは、関連する実験/理論が完全に解決されていないことを2018年に提案しました。',
    formalEs: 'Origen de los estados aislantes correlacionados en el grafeno de ángulo mágico: propuesto por Cao/varios equipos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Origin of correlated insulating states in magic-angle graphene: proposed by Cao / 多团队 in 2018; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Cao / 多团队 等人在 2018 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['莫特', '强关联'],
  },
  {
    id: 'phys-qah-effect',
    category: 'physics',
    title: '量子反常霍尔效应的微观机制',
    titleJa: '量子異常ホール効果の顕微鏡的メカニズム',
    titleEs: 'Mecanismo microscópico del efecto Hall anómalo cuántico: propuesto por Xue Qikun/varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Microscopic mechanism of quantum anomalous Hall effect',
    year: 2013,
    proposer: '薛其坤 / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：量子反常霍尔效应的微观机制。',
    summaryJa: '物理学の分野における特定の難題：量子異常ホール効果の顕微鏡的メカニズム。',
    summaryEs: 'Mecanismo microscópico del efecto Hall anómalo cuántico: propuesto por Xue Qikun/varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Microscopic mechanism of quantum anomalous Hall effect.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 量子反常霍尔效应的微观机制 的核心问题是：「量子反常霍尔效应的微观机制」是 物理 领域的 拓扑 方向，涉及 拓扑, 磁性 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「量子反常霍尔效应的微观机制」是 物理 领域的 拓扑 方向，涉及 拓扑, 磁性 等方面。',
    formal: '量子反常霍尔效应的微观机制（Microscopic mechanism of quantum anomalous Hall effect）：薛其坤 / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalJa: '量子異常ホール効果の顕微鏡的メカニズム： 2013年にXue Qikun/Duoチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo microscópico del efecto Hall anómalo cuántico: propuesto por Xue Qikun/varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Microscopic mechanism of quantum anomalous Hall effect: proposed by 薛其坤 / 多团队 in 2013; related experiments/theory remain incomplete.',
    whyHard: '「量子反常霍尔效应的微观机制」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['拓扑', '磁性'],
  },
  {
    id: 'phys-skyrmion-stability',
    category: 'physics',
    title: '室温下稳定的磁性斯格明子',
    titleJa: '室温で安定した磁気骨格',
    titleEs: 'Skyrmions magnéticos estables a temperatura ambiente: propuestos por Mühlbauer/varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Room-temperature stable magnetic skyrmions',
    year: 2009,
    proposer: 'Mühlbauer / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：室温下稳定的磁性斯格明子。',
    summaryJa: '物理学の分野における特定の困難な問題：室温で安定した磁気チョウザメ。',
    summaryEs: 'Skyrmions magnéticos estables a temperatura ambiente: propuestos por Mühlbauer/varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Room-temperature stable magnetic skyrmions.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 室温下稳定的磁性斯格明子 是这样一个问题：「室温下稳定的磁性斯格明子」是 物理 领域的 自旋 方向，涉及 自旋, 存储 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「室温下稳定的磁性斯格明子」是 物理 领域的 自旋 方向，涉及 自旋, 存储 等方面。',
    formal: '室温下稳定的磁性斯格明子（Room-temperature stable magnetic skyrmions）：Mühlbauer / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: '室温安定した磁気スカイミオン： Mühlbauer/Multiチームは2009年に提案し、関連する実験/理論は完全には解決されていません。',
    formalEs: 'Skyrmions magnéticos estables a temperatura ambiente: propuestos por Mühlbauer/varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Room-temperature stable magnetic skyrmions: proposed by Mühlbauer / 多团队 in 2009; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Mühlbauer / 多团队 等人在 2009 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自旋', '存储'],
  },
  {
    id: 'phys-3d-topo-classify',
    category: 'physics',
    title: '三维拓扑绝缘体的完整分类',
    titleJa: '3 Dトポロジカル絶縁体の完全な分類',
    titleEs: 'Clasificación completa de aislantes topológicos 3D: propuesta por Fu / Kane / Mele / varios equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Complete classification of 3D topological insulators',
    year: 2005,
    proposer: 'Fu / Kane / Mele / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：三维拓扑绝缘体的完整分类。',
    summaryJa: '物理学の分野における特定の難題：三次元位相絶縁体の完全な分類。',
    summaryEs: 'Clasificación completa de aislantes topológicos 3D: propuesta por Fu / Kane / Mele / varios equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Complete classification of 3D topological insulators.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 三维拓扑绝缘体的完整分类 的核心问题是：「三维拓扑绝缘体的完整分类」是 物理 领域的 拓扑 方向，涉及 拓扑, 分类 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「三维拓扑绝缘体的完整分类」是 物理 领域的 拓扑 方向，涉及 拓扑, 分类 等方面。',
    formal: '三维拓扑绝缘体的完整分类（Complete classification of 3D topological insulators）：Fu / Kane / Mele / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: '3 Dトポロジカル絶縁体の完全な分類： 2005年にFu/Kane/Mele/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Clasificación completa de aislantes topológicos 3D: propuesta por Fu / Kane / Mele / varios equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Complete classification of 3D topological insulators: proposed by Fu / Kane / Mele / 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '尽管 Fu / Kane / Mele / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['拓扑', '分类'],
  },
  {
    id: 'phys-dirac-weyl-metal',
    category: 'physics',
    title: 'Dirac/Weyl 半金属费米弧的完整描述',
    titleJa: 'ディラック/ワイル半金属フェルミ弧の完全な説明',
    titleEs: 'Descripción completa de los arcos de Fermi en semimetales de Dirac/Weyl: propuesto por Wan/Turner/varios equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Complete description of Fermi arcs in Dirac/Weyl semimetals',
    year: 2012,
    proposer: 'Wan / Turner / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：Dirac/Weyl 半金属费米弧的完整描述。',
    summaryJa: '物理学の分野における特定の困難な問題：ディラック/ワイル半金属フェルミアークの完全な説明。',
    summaryEs: 'Descripción completa de los arcos de Fermi en semimetales de Dirac/Weyl: propuesto por Wan/Turner/varios equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Complete description of Fermi arcs in Dirac/Weyl semimetals.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 Dirac/Weyl 半金属费米弧的完整描述 的问题。它可以简单描述为 「Dirac/Weyl 半金属费米弧的完整描述」是 物理 领域的 拓扑 方向，涉及 拓扑, 半金属 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Dirac/Weyl 半金属费米弧的完整描述」是 物理 领域的 拓扑 方向，涉及 拓扑, 半金属 等方面。',
    formal: 'Dirac/Weyl 半金属费米弧的完整描述（Complete description of Fermi arcs in Dirac/Weyl semimetals）：Wan / Turner / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Dirac/Weyl半金属のフェルミアークの完全な説明： 2012年にWan/Turner/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Descripción completa de los arcos de Fermi en semimetales de Dirac/Weyl: propuesto por Wan/Turner/varios equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Complete description of Fermi arcs in Dirac/Weyl semimetals: proposed by Wan / Turner / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['拓扑', '半金属'],
  },
  {
    id: 'phys-cft-classify',
    category: 'physics',
    title: 'd>2 共形场论的完整分类',
    titleJa: 'd > 2共形場理論の完全分類',
    titleEs: 'Clasificación completa de teorías de campos conformes d>2 (Clasificación completa de teorías de campos conformes d>2): propuesta por Beem/Lemos/varios equipos en 2014, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Complete classification of d>2 conformal field theories',
    year: 2014,
    proposer: 'Beem / Lemos / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：d>2 共形场论的完整分类。',
    summaryJa: '物理学の分野における特定の難しい問題： d > 2コンフォーマル場理論の完全な分類。',
    summaryEs: 'Clasificación completa de teorías de campos conformes d>2 (Clasificación completa de teorías de campos conformes d>2): propuesta por Beem/Lemos/varios equipos en 2014, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Complete classification of d>2 conformal field theories.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 d>2 共形场论的完整分类。它说的是 「d>2 共形场论的完整分类」是 物理 领域的 CFT 方向，涉及 CFT, Bootstrap 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「d>2 共形场论的完整分类」是 物理 领域的 CFT 方向，涉及 CFT, Bootstrap 等方面。',
    formal: 'd>2 共形场论的完整分类（Complete classification of d>2 conformal field theories）：Beem / Lemos / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'd > 2 d > 2コンフォーマルフィールド理論の完全な分類： 2014年にBeem/Lemos/複数のチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Clasificación completa de teorías de campos conformes d>2 (Clasificación completa de teorías de campos conformes d>2): propuesta por Beem/Lemos/varios equipos en 2014, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Complete classification of d>2 conformal field theories: proposed by Beem / Lemos / 多团队 in 2014; related experiments/theory remain incomplete.',
    whyHard: '「d>2 共形场论的完整分类」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CFT', 'Bootstrap'],
  },
  {
    id: 'phys-quantum-gravity',
    category: 'physics',
    title: '量子引力的统一描述',
    titleJa: '量子重力の統一的な説明',
    titleEs: 'Descripción unificada de la gravedad cuántica: propuesta por Einstein/múltiples generaciones de físicos en 1930, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Unified description of quantum gravity',
    year: 1930,
    proposer: 'Einstein / 多代物理学家',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：量子引力的统一描述。',
    summaryJa: '物理学の分野における特定の困難な問題：量子重力の統一された記述。',
    summaryEs: 'Descripción unificada de la gravedad cuántica: propuesta por Einstein/múltiples generaciones de físicos en 1930, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Unified description of quantum gravity.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 量子引力的统一描述 是这样一个问题：「量子引力的统一描述」是 物理 领域的 引力 方向，涉及 引力, 量子 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「量子引力的统一描述」是 物理 领域的 引力 方向，涉及 引力, 量子 等方面。',
    formal: '量子引力的统一描述（Unified description of quantum gravity）：Einstein / 多代物理学家 在 1930 年提出，相关实验/理论至今未完全解决。',
    formalJa: '量子重力の統一記述： 1930年にアインシュタイン/多世代物理学者が提唱したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Descripción unificada de la gravedad cuántica: propuesta por Einstein/múltiples generaciones de físicos en 1930, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Unified description of quantum gravity: proposed by Einstein / 多代物理学家 in 1930; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Einstein / 多代物理学家 等人在 1930 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['引力', '量子'],
  },
  {
    id: 'phys-string-landscape',
    category: 'physics',
    title: '弦论景观 (landscape) vs 沼泽地 (swampland)',
    titleJa: '弦理論の風景対スワンプランド',
    titleEs: 'Paisaje de la teoría de cuerdas versus tierra pantanosa (paisaje de la teoría de cuerdas versus tierra pantanosa): propuesto por Vafa/varios equipos en 2003, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'String theory landscape vs swampland',
    year: 2003,
    proposer: 'Vafa / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：弦论景观 (landscape) vs 沼泽地 (swampland)。',
    summaryJa: '物理学の分野における特定の困難な問題：弦理論的風景対沼地。',
    summaryEs: 'Paisaje de la teoría de cuerdas versus tierra pantanosa (paisaje de la teoría de cuerdas versus tierra pantanosa): propuesto por Vafa/varios equipos en 2003, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: String theory landscape vs swampland.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 弦论景观 (landscape) vs 沼泽地 (swampland)。它说的是 「弦论景观 (landscape) vs 沼泽地 (swampland)」是 物理 领域的 弦论 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「弦论景观 (landscape) vs 沼泽地 (swampland)」是 物理 领域的 弦论 方向。',
    formal: '弦论景观 (landscape) vs 沼泽地 (swampland)（String theory landscape vs swampland）：Vafa / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalJa: '弦理論の風景vs沼地： VAFA/Multiチームは2003年に提案され、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Paisaje de la teoría de cuerdas versus tierra pantanosa (paisaje de la teoría de cuerdas versus tierra pantanosa): propuesto por Vafa/varios equipos en 2003, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'String theory landscape vs swampland: proposed by Vafa / 多团队 in 2003; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['弦论'],
  },
  {
    id: 'phys-holographic-principle',
    category: 'physics',
    title: 'AdS/CFT 对偶的实验验证',
    titleJa: 'AdS/CFTペアの実験的検証',
    titleEs: 'Prueba experimental de la dualidad AdS/CFT: Maldacena/múltiples equipos lo propusieron en 1997, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Experimental test of AdS/CFT duality',
    year: 1997,
    proposer: 'Maldacena / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：AdS/CFT 对偶的实验验证。',
    summaryJa: '物理学の分野における特定の難しい問題： AdS/CFT双対性の実験的検証。',
    summaryEs: 'Prueba experimental de la dualidad AdS/CFT: Maldacena/múltiples equipos lo propusieron en 1997, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Experimental test of AdS/CFT duality.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 AdS/CFT 对偶的实验验证 的问题。它可以简单描述为 「AdS/CFT 对偶的实验验证」是 物理 领域的 全息 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「AdS/CFT 对偶的实验验证」是 物理 领域的 全息 方向。',
    formal: 'AdS/CFT 对偶的实验验证（Experimental test of AdS/CFT duality）：Maldacena / 多团队 在 1997 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'AdS/CFT二重性の実験的検定： 1997年に提案されたマルダセナ/複数のチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: 'Prueba experimental de la dualidad AdS/CFT: Maldacena/múltiples equipos lo propusieron en 1997, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Experimental test of AdS/CFT duality: proposed by Maldacena / 多团队 in 1997; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['全息'],
  },
  {
    id: 'phys-blackhole-info',
    category: 'physics',
    title: '黑洞信息悖论的解决',
    titleJa: 'ブラックホール情報パラドックスの解決',
    titleEs: 'Resolución de la paradoja de la información del agujero negro: propuesta por Hawking/varios equipos en 1976, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Resolution of the black hole information paradox',
    year: 1976,
    proposer: 'Hawking / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：黑洞信息悖论的解决。',
    summaryJa: '物理学の分野における特定の難しい問題：ブラックホール情報パラドックスの解決。',
    summaryEs: 'Resolución de la paradoja de la información del agujero negro: propuesta por Hawking/varios equipos en 1976, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Resolution of the black hole information paradox.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 黑洞信息悖论的解决。它说的是 「黑洞信息悖论的解决」是 物理 领域的 黑洞 方向，涉及 黑洞, 信息 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「黑洞信息悖论的解决」是 物理 领域的 黑洞 方向，涉及 黑洞, 信息 等方面。',
    formal: '黑洞信息悖论的解决（Resolution of the black hole information paradox）：Hawking / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ブラックホール情報パラドックスの解決： 1976年にホーキング/マルチプルチームが提案し、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Resolución de la paradoja de la información del agujero negro: propuesta por Hawking/varios equipos en 1976, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Resolution of the black hole information paradox: proposed by Hawking / 多团队 in 1976; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['黑洞', '信息'],
  },
  {
    id: 'phys-firewall',
    category: 'physics',
    title: '黑洞火墙 (firewall) 悖论',
    titleJa: 'ブラックホールファイアウォールのパラドックス',
    titleEs: 'Paradoja del firewall del agujero negro: propuesta por AMPS/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Black hole firewall paradox',
    year: 2012,
    proposer: 'AMPS / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：黑洞火墙 (firewall) 悖论。',
    summaryJa: '物理学の分野における特定の困難な問題：ブラックホールファイアウォールのパラドックス。',
    summaryEs: 'Paradoja del firewall del agujero negro: propuesta por AMPS/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Black hole firewall paradox.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 黑洞火墙 (firewall) 悖论 的问题。它可以简单描述为 「黑洞火墙 (firewall) 悖论」是 物理 领域的 黑洞 方向，涉及 黑洞, 量子 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「黑洞火墙 (firewall) 悖论」是 物理 领域的 黑洞 方向，涉及 黑洞, 量子 等方面。',
    formal: '黑洞火墙 (firewall) 悖论（Black hole firewall paradox）：AMPS / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ブラックホールファイアウォールパラドックス： 2012年にAMPS/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Paradoja del firewall del agujero negro: propuesta por AMPS/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Black hole firewall paradox: proposed by AMPS / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['黑洞', '量子'],
  },
  {
    id: 'phys-dark-matter',
    category: 'physics',
    title: '暗物质的本质 (WIMP, axion, sterile neutrino, ...)',
    titleJa: '暗黒物質の性質（ WIMP、AXION、滅菌ニュートリノなど）',
    titleEs: 'Naturaleza de la materia oscura (WIMP, axión, neutrino estéril,...): propuesta por Zwicky/múltiples equipos en 1933, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Nature of dark matter',
    year: 1933,
    proposer: 'Zwicky / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：暗物质的本质 (WIMP, axion, sterile neutrino, ...)。',
    summaryJa: '物理学の分野における特定の難題：暗黒物質の性質（ WIMP、AXION、滅菌ニュートリノなど）。',
    summaryEs: 'Naturaleza de la materia oscura (WIMP, axión, neutrino estéril,...): propuesta por Zwicky/múltiples equipos en 1933, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Nature of dark matter.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 暗物质的本质 (WIMP, axion, sterile neutrino, ...)。它说的是 「暗物质的本质 (WIMP, axion, sterile neutrino, ...)」是 物理 领域的 暗物质 方向，涉及 暗物质, 宇宙学 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「暗物质的本质 (WIMP, axion, sterile neutrino, ...)」是 物理 领域的 暗物质 方向，涉及 暗物质, 宇宙学 等方面。',
    formal: '暗物质的本质 (WIMP, axion, sterile neutrino, ...)（Nature of dark matter）：Zwicky / 多团队 在 1933 年提出，相关实验/理论至今未完全解决。',
    formalJa: '暗黒物質（ WIMP、AXION、滅菌ニュートリノなど）の性質： Zwicky/Multiチームは1933年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Naturaleza de la materia oscura (WIMP, axión, neutrino estéril,...): propuesta por Zwicky/múltiples equipos en 1933, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Nature of dark matter: proposed by Zwicky / 多团队 in 1933; related experiments/theory remain incomplete.',
    whyHard: '尽管 Zwicky / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['暗物质', '宇宙学'],
  },
  {
    id: 'phys-dark-energy',
    category: 'physics',
    title: '暗能量的本质 (宇宙学常数 vs quintessence)',
    titleJa: 'ダークエネルギーの性質（宇宙定数対真髄）',
    titleEs: 'Naturaleza de la energía oscura (constante cosmológica versus quintaesencia): propuesta por Perlmutter/Riess/Schmidt en 1998, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Nature of dark energy',
    year: 1998,
    proposer: 'Perlmutter / Riess / Schmidt',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：暗能量的本质 (宇宙学常数 vs quintessence)。',
    summaryJa: '物理学の分野における特定の困難な問題：ダークエネルギーの性質（宇宙定数対精髄）。',
    summaryEs: 'Naturaleza de la energía oscura (constante cosmológica versus quintaesencia): propuesta por Perlmutter/Riess/Schmidt en 1998, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Nature of dark energy.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 暗能量的本质 (宇宙学常数 vs quintessence)。它说的是 「暗能量的本质 (宇宙学常数 vs quintessence)」是 物理 领域的 暗能量 方向，涉及 暗能量, 加速膨胀 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「暗能量的本质 (宇宙学常数 vs quintessence)」是 物理 领域的 暗能量 方向，涉及 暗能量, 加速膨胀 等方面。',
    formal: '暗能量的本质 (宇宙学常数 vs quintessence)（Nature of dark energy）：Perlmutter / Riess / Schmidt 在 1998 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ダークエネルギーの性質（宇宙定数対精髄） ： 1998年にPerlmutter/Riess/Schmidtによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Naturaleza de la energía oscura (constante cosmológica versus quintaesencia): propuesta por Perlmutter/Riess/Schmidt en 1998, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Nature of dark energy: proposed by Perlmutter / Riess / Schmidt in 1998; related experiments/theory remain incomplete.',
    whyHard: '「暗能量的本质 (宇宙学常数 vs quintessence)」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['暗能量', '加速膨胀'],
  },
  {
    id: 'phys-cosmological-constant',
    category: 'physics',
    title: '宇宙学常数问题 (120 个数量级)',
    titleJa: '宇宙論的絶え間ない問題（ 120桁）',
    titleEs: 'Problema cosmológico constante (120 órdenes de magnitud): propuesto por Weinberg/varios equipos en 1989, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Cosmological constant problem',
    year: 1989,
    proposer: 'Weinberg / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：宇宙学常数问题 (120 个数量级)。',
    summaryJa: '物理学の分野における特定の困難な問題：宇宙定数問題（ 120桁）。',
    summaryEs: 'Problema cosmológico constante (120 órdenes de magnitud): propuesto por Weinberg/varios equipos en 1989, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Cosmological constant problem.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 宇宙学常数问题 (120 个数量级)。它说的是 「宇宙学常数问题 (120 个数量级)」是 物理 领域的 真空能 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「宇宙学常数问题 (120 个数量级)」是 物理 领域的 真空能 方向。',
    formal: '宇宙学常数问题 (120 个数量级)（Cosmological constant problem）：Weinberg / 多团队 在 1989 年提出，相关实验/理论至今未完全解决。',
    formalJa: '宇宙定数問題（ 120桁） ： 1989年、Weinberg/Multiple teamsは、関連する実験/理論がまだ完全に解決されていないと提案した。',
    formalEs: 'Problema cosmológico constante (120 órdenes de magnitud): propuesto por Weinberg/varios equipos en 1989, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Cosmological constant problem: proposed by Weinberg / 多团队 in 1989; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['真空能'],
  },
  {
    id: 'phys-hubble-tension',
    category: 'physics',
    title: 'Hubble 张力 (H0 早期 vs 晚期测量差异)',
    titleJa: 'ハッブルテンション（ H 0早期と後期の測定の違い）',
    titleEs: 'Tensión de Hubble (diferencia de medición temprana versus tardía de H0) (tensión de Hubble): propuesta por Riess/Planck/varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Hubble tension',
    year: 2013,
    proposer: 'Riess / Planck / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：Hubble 张力 (H0 早期 vs 晚期测量差异)。',
    summaryJa: '物理学の分野における特定の困難な問題：ハッブルテンション（ H 0の初期と後期の測定の差）。',
    summaryEs: 'Tensión de Hubble (diferencia de medición temprana versus tardía de H0) (tensión de Hubble): propuesta por Riess/Planck/varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Hubble tension.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 Hubble 张力 (H0 早期 vs 晚期测量差异) 的问题。它可以简单描述为 「Hubble 张力 (H0 早期 vs 晚期测量差异)」是 物理 领域的 H0 方向，涉及 H0, 宇宙学 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Hubble 张力 (H0 早期 vs 晚期测量差异)」是 物理 领域的 H0 方向，涉及 H0, 宇宙学 等方面。',
    formal: 'Hubble 张力 (H0 早期 vs 晚期测量差异)（Hubble tension）：Riess / Planck / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ハッブル張力（ H 0早期と後期の測定差） （ハッブル張力） ： 2013年にRiess/Planck/複数のチームが提案され、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Tensión de Hubble (diferencia de medición temprana versus tardía de H0) (tensión de Hubble): propuesta por Riess/Planck/varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Hubble tension: proposed by Riess / Planck / 多团队 in 2013; related experiments/theory remain incomplete.',
    whyHard: '尽管 Riess / Planck / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['H0', '宇宙学'],
  },
  {
    id: 'phys-s8-tension',
    category: 'physics',
    title: 'S8 张力 (σ8 早期 vs 晚期)',
    titleJa: 'S 8張力（ σ 8早期対遅期）',
    titleEs: 'Tensión S8 (σ8 temprano vs tarde) (tensión S8): propuesta por DES/KiDS/múltiples equipos en 2020, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'S8 tension',
    year: 2020,
    proposer: 'DES / KiDS / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：S8 张力 (σ8 早期 vs 晚期)。',
    summaryJa: '物理学の分野における特定の困難な問題： S 8張力（ σ 8早期対遅期）。',
    summaryEs: 'Tensión S8 (σ8 temprano vs tarde) (tensión S8): propuesta por DES/KiDS/múltiples equipos en 2020, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: S8 tension.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 S8 张力 (σ8 早期 vs 晚期) 的问题。它可以简单描述为 「S8 张力 (σ8 早期 vs 晚期)」是 物理 领域的 σ8 方向，涉及 σ8, 宇宙学 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「S8 张力 (σ8 早期 vs 晚期)」是 物理 领域的 σ8 方向，涉及 σ8, 宇宙学 等方面。',
    formal: 'S8 张力 (σ8 早期 vs 晚期)（S8 tension）：DES / KiDS / 多团队 在 2020 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'S 8張力（ σ 8早期対遅期） （ S 8張力） ： 2020年にDES/KiDS/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Tensión S8 (σ8 temprano vs tarde) (tensión S8): propuesta por DES/KiDS/múltiples equipos en 2020, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'S8 tension: proposed by DES / KiDS / 多团队 in 2020; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['σ8', '宇宙学'],
  },
  {
    id: 'phys-frb-origin',
    category: 'physics',
    title: '快速射电暴 (FRB) 的起源',
    titleJa: '高速ラジオバースト（ FRB ）の起源',
    titleEs: 'El origen de las ráfagas de radio rápidas (FRB): Lorimer y varios equipos lo propusieron en 2007, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Origin of fast radio bursts',
    year: 2007,
    proposer: 'Lorimer / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：快速射电暴 (FRB) 的起源。',
    summaryJa: '物理学の分野における特定の困難な問題：高速電波バースト（ FRB ）の起源。',
    summaryEs: 'El origen de las ráfagas de radio rápidas (FRB): Lorimer y varios equipos lo propusieron en 2007, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Origin of fast radio bursts.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 快速射电暴 (FRB) 的起源。它说的是 「快速射电暴 (FRB) 的起源」是 物理 领域的 射电 方向，涉及 射电, 天体 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「快速射电暴 (FRB) 的起源」是 物理 领域的 射电 方向，涉及 射电, 天体 等方面。',
    formal: '快速射电暴 (FRB) 的起源（Origin of fast radio bursts）：Lorimer / 多团队 在 2007 年提出，相关实验/理论至今未完全解决。',
    formalJa: '高速ラジオバースト（ FRB ）の起源： Lorimer/Multiチームは、関連する実験/理論がまだ完全に解決されていないことを2007年に提案しました。',
    formalEs: 'El origen de las ráfagas de radio rápidas (FRB): Lorimer y varios equipos lo propusieron en 2007, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Origin of fast radio bursts: proposed by Lorimer / 多团队 in 2007; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['射电', '天体'],
  },
  {
    id: 'phys-grb-jet',
    category: 'physics',
    title: '伽马射线暴 (GRB) 的中心引擎',
    titleJa: 'ガンマ線バースト（ GRB ）のセントラルエンジン',
    titleEs: 'Motor central de explosiones de rayos gamma (GRB): propuesto por Klebesadel/Piran/varios equipos en 1967, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Central engine of gamma-ray bursts',
    year: 1967,
    proposer: 'Klebesadel / Piran / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：伽马射线暴 (GRB) 的中心引擎。',
    summaryJa: '物理学の分野における特定の難題：ガンマ線バースト（ GRB ）の中心エンジン。',
    summaryEs: 'Motor central de explosiones de rayos gamma (GRB): propuesto por Klebesadel/Piran/varios equipos en 1967, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Central engine of gamma-ray bursts.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 伽马射线暴 (GRB) 的中心引擎 的问题。它可以简单描述为 「伽马射线暴 (GRB) 的中心引擎」是 物理 领域的 GRB 方向，涉及 GRB, 天体 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「伽马射线暴 (GRB) 的中心引擎」是 物理 领域的 GRB 方向，涉及 GRB, 天体 等方面。',
    formal: '伽马射线暴 (GRB) 的中心引擎（Central engine of gamma-ray bursts）：Klebesadel / Piran / 多团队 在 1967 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ガンマ線バースト（ GRB ）の中心エンジン： 1967年にKlebesadel/Piran/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Motor central de explosiones de rayos gamma (GRB): propuesto por Klebesadel/Piran/varios equipos en 1967, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Central engine of gamma-ray bursts: proposed by Klebesadel / Piran / 多团队 in 1967; related experiments/theory remain incomplete.',
    whyHard: '「伽马射线暴 (GRB) 的中心引擎」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['GRB', '天体'],
  },
  {
    id: 'phys-cmb-lowl',
    category: 'physics',
    title: '宇宙微波背景低 l 功率异常',
    titleJa: '宇宙マイクロ波背景低l電力異常',
    titleEs: 'Anomalía de potencia de baja l del fondo cósmico de microondas (anomalía de potencia de baja l del CMB): Planck/múltiples equipos propuestos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'CMB low-l power anomaly',
    year: 2010,
    proposer: 'Planck / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：宇宙微波背景低 l 功率异常。',
    summaryJa: '物理学の分野における特定の困難な問題：宇宙マイクロ波背景における低l電力異常。',
    summaryEs: 'Anomalía de potencia de baja l del fondo cósmico de microondas (anomalía de potencia de baja l del CMB): Planck/múltiples equipos propuestos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: CMB low-l power anomaly.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 宇宙微波背景低 l 功率异常 的核心问题是：「宇宙微波背景低 l 功率异常」是 物理 领域的 CMB 方向，涉及 CMB, 异常 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「宇宙微波背景低 l 功率异常」是 物理 领域的 CMB 方向，涉及 CMB, 异常 等方面。',
    formal: '宇宙微波背景低 l 功率异常（CMB low-l power anomaly）：Planck / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '宇宙マイクロ波背景低l電力異常（ CMB低l電力異常） ： 2010年にPlanck/複数のチームが提案され、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Anomalía de potencia de baja l del fondo cósmico de microondas (anomalía de potencia de baja l del CMB): Planck/múltiples equipos propuestos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'CMB low-l power anomaly: proposed by Planck / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CMB', '异常'],
  },
  {
    id: 'phys-21cm-edanomaly',
    category: 'physics',
    title: '21cm 信号异常 (EDGES 吸收坑)',
    titleJa: '21 cm信号異常（ EDGES吸収ピット）',
    titleEs: 'Anomalía de señal de 21 cm (canal de absorción EDGES): Bowman/múltiples equipos propuestos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: '21cm signal anomaly (EDGES absorption trough)',
    year: 2018,
    proposer: 'Bowman / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：21cm 信号异常 (EDGES 吸收坑)。',
    summaryJa: '物理学の分野における特定の困難な問題： 21 cm信号異常（ EDGES吸収ピット）。',
    summaryEs: 'Anomalía de señal de 21 cm (canal de absorción EDGES): Bowman/múltiples equipos propuestos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: 21cm signal anomaly (EDGES absorption trough).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 21cm 信号异常 (EDGES 吸收坑) 是这样一个问题：「21cm 信号异常 (EDGES 吸收坑)」是 物理 领域的 21cm 方向，涉及 21cm, 再电离 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「21cm 信号异常 (EDGES 吸收坑)」是 物理 领域的 21cm 方向，涉及 21cm, 再电离 等方面。',
    formal: '21cm 信号异常 (EDGES 吸收坑)（21cm signal anomaly (EDGES absorption trough)）：Bowman / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    formalJa: '21 cmシグナル異常（ EDGES吸収ピット） （ 21 cmシグナル異常（ EDGES吸収トラフ） ） ： 2018年にBowman/複数のチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Anomalía de señal de 21 cm (canal de absorción EDGES): Bowman/múltiples equipos propuestos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: '21cm signal anomaly (EDGES absorption trough): proposed by Bowman / 多团队 in 2018; related experiments/theory remain incomplete.',
    whyHard: '尽管 Bowman / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['21cm', '再电离'],
  },
  {
    id: 'phys-cp-violation-b',
    category: 'physics',
    title: 'B 介子 CP 破缺新源是否存在',
    titleJa: 'Ｂ中間子ＣＰ破損の新たな発生源の有無',
    titleEs: '¿Existen nuevas fuentes de violación de CP en los mesones B? (¿Existen nuevas fuentes de violación de CP en los mesones B?): BaBar/Belle/LHCb propuesto en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Are there new sources of CP violation in B mesons?',
    year: 2001,
    proposer: 'BaBar / Belle / LHCb',
    difficulty: 5,
    reward: 2500,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：B 介子 CP 破缺新源是否存在。',
    summaryJa: '物理学の分野における特定の困難な問題： B中間子CP破損の新しい原因があるかどうか。',
    summaryEs: '¿Existen nuevas fuentes de violación de CP en los mesones B? (¿Existen nuevas fuentes de violación de CP en los mesones B?): BaBar/Belle/LHCb propuesto en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Are there new sources of CP violation in B mesons?.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 B 介子 CP 破缺新源是否存在 的核心问题是：「B 介子 CP 破缺新源是否存在」是 物理 领域的 CP 方向，涉及 CP, B介子 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「B 介子 CP 破缺新源是否存在」是 物理 领域的 CP 方向，涉及 CP, B介子 等方面。',
    formal: 'B 介子 CP 破缺新源是否存在（Are there new sources of CP violation in B mesons?）：BaBar / Belle / LHCb 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'B中間子におけるCP違反の新しい原因はありますか？ ） ： BaBar/Belle/LHCbは2001年に提案され、関連する実験/理論は完全には解決されていない。',
    formalEs: '¿Existen nuevas fuentes de violación de CP en los mesones B? (¿Existen nuevas fuentes de violación de CP en los mesones B?): BaBar/Belle/LHCb propuesto en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Are there new sources of CP violation in B mesons?: proposed by BaBar / Belle / LHCb in 2001; related experiments/theory remain incomplete.',
    whyHard: '尽管 BaBar / Belle / LHCb 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CP', 'B介子'],
  },
  {
    id: 'phys-b-anomalies',
    category: 'physics',
    title: 'B 物理 R(K) R(K*) 异常',
    titleJa: 'B物理R (K) R (K *)異常',
    titleEs: 'Anomalías de física B R(K) R(K*) (anomalías de física B R(K), R(K*): propuesta por LHCb/múltiples equipos en 2014, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'B physics R(K), R(K*) anomalies',
    year: 2014,
    proposer: 'LHCb / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：B 物理 R(K) R(K*) 异常。',
    summaryJa: '物理学の分野における特定の難題： B Physics R (K) R (K *) Anomaly。',
    summaryEs: 'Anomalías de física B R(K) R(K*) (anomalías de física B R(K), R(K*): propuesta por LHCb/múltiples equipos en 2014, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: B physics R(K), R(K*) anomalies.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 B 物理 R(K) R(K*) 异常 是这样一个问题：「B 物理 R(K) R(K*) 异常」是 物理 领域的 B介子 方向，涉及 B介子, 轻子普适性 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「B 物理 R(K) R(K*) 异常」是 物理 领域的 B介子 方向，涉及 B介子, 轻子普适性 等方面。',
    formal: 'B 物理 R(K) R(K*) 异常（B physics R(K), R(K*) anomalies）：LHCb / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'B physics R (K) R (K *) abnormalities (B physics R (K), R (K *) anomalies): 2014年にLHCb/multi - teamによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Anomalías de física B R(K) R(K*) (anomalías de física B R(K), R(K*): propuesta por LHCb/múltiples equipos en 2014, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'B physics R(K), R(K*) anomalies: proposed by LHCb / 多团队 in 2014; related experiments/theory remain incomplete.',
    whyHard: '尽管 LHCb / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['B介子', '轻子普适性'],
  },
  {
    id: 'phys-muon-g-2',
    category: 'physics',
    title: 'μ 子的 g-2 异常',
    titleJa: 'g -2ミューオンの異常',
    titleEs: 'Anomalía del muón g-2 (anomalía del muón g-2): propuesta por BNL/Fermilab/varios equipos en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Muon g-2 anomaly',
    year: 2001,
    proposer: 'BNL / Fermilab / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：μ 子的 g-2 异常。',
    summaryJa: '物理学の分野における特定の困難な問題：ミューオンのG -2異常。',
    summaryEs: 'Anomalía del muón g-2 (anomalía del muón g-2): propuesta por BNL/Fermilab/varios equipos en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Muon g-2 anomaly.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 μ 子的 g-2 异常 的问题。它可以简单描述为 「μ 子的 g-2 异常」是 物理 领域的 μ子 方向，涉及 μ子, g-2 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「μ 子的 g-2 异常」是 物理 领域的 μ子 方向，涉及 μ子, g-2 等方面。',
    formal: 'μ 子的 g-2 异常（Muon g-2 anomaly）：BNL / Fermilab / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'muon g -2 anomaly ： 2001年に提案されたBNL/Fermilab/複数のチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: 'Anomalía del muón g-2 (anomalía del muón g-2): propuesta por BNL/Fermilab/varios equipos en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Muon g-2 anomaly: proposed by BNL / Fermilab / 多团队 in 2001; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['μ子', 'g-2'],
  },
  {
    id: 'phys-neutrino-mass',
    category: 'physics',
    title: '中微子质量起源 (Dirac vs Majorana)',
    titleJa: 'ニュートリノ質量の起源（ディラック対マヨラーナ）',
    titleEs: 'Origen de la masa del neutrino (Dirac vs Majorana): Propuesto por Pauli/Majorana/múltiples equipos en 1930, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Origin of neutrino mass',
    year: 1930,
    proposer: 'Pauli / Majorana / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：中微子质量起源 (Dirac vs Majorana)。',
    summaryJa: '物理学の分野における特定の困難な問題：ニュートリノ質量の起源（ディラック対マヨラーナ）。',
    summaryEs: 'Origen de la masa del neutrino (Dirac vs Majorana): Propuesto por Pauli/Majorana/múltiples equipos en 1930, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Origin of neutrino mass.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 中微子质量起源 (Dirac vs Majorana)。它说的是 「中微子质量起源 (Dirac vs Majorana)」是 物理 领域的 中微子 方向，涉及 中微子, 质量 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「中微子质量起源 (Dirac vs Majorana)」是 物理 领域的 中微子 方向，涉及 中微子, 质量 等方面。',
    formal: '中微子质量起源 (Dirac vs Majorana)（Origin of neutrino mass）：Pauli / Majorana / 多团队 在 1930 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ディラック対マヨラーナ（ニュートリノ質量の起源） ： 1930年にパウリ/マヨラーナ/複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Origen de la masa del neutrino (Dirac vs Majorana): Propuesto por Pauli/Majorana/múltiples equipos en 1930, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Origin of neutrino mass: proposed by Pauli / Majorana / 多团队 in 1930; related experiments/theory remain incomplete.',
    whyHard: '「中微子质量起源 (Dirac vs Majorana)」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['中微子', '质量'],
  },
  {
    id: 'phys-neutrino-0nubb',
    category: 'physics',
    title: '无中微子双 β 衰变 (0νββ) 探测',
    titleJa: 'ニュートリノフリーダブルベータ減衰（ 0 ν β β ）検出',
    titleEs: 'Detección de desintegración beta doble sin neutrinos (0νββ): propuesta por Goeppert-Mayer/varios equipos en 1935, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Detection of neutrinoless double beta decay',
    year: 1935,
    proposer: 'Goeppert-Mayer / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：无中微子双 β 衰变 (0νββ) 探测。',
    summaryJa: '物理学の分野における特定の困難な問題：ニュートリノフリーのダブルベータ崩壊（ 0 ν β β ）検出。',
    summaryEs: 'Detección de desintegración beta doble sin neutrinos (0νββ): propuesta por Goeppert-Mayer/varios equipos en 1935, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Detection of neutrinoless double beta decay.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 无中微子双 β 衰变 (0νββ) 探测。它说的是 「无中微子双 β 衰变 (0νββ) 探测」是 物理 领域的 中微子 方向，涉及 中微子, 双β 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「无中微子双 β 衰变 (0νββ) 探测」是 物理 领域的 中微子 方向，涉及 中微子, 双β 等方面。',
    formal: '无中微子双 β 衰变 (0νββ) 探测（Detection of neutrinoless double beta decay）：Goeppert-Mayer / 多团队 在 1935 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ニュートリノールレスダブルベータ崩壊の検出： 1935年にGoeppert - Mayer/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Detección de desintegración beta doble sin neutrinos (0νββ): propuesta por Goeppert-Mayer/varios equipos en 1935, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Detection of neutrinoless double beta decay: proposed by Goeppert-Mayer / 多团队 in 1935; related experiments/theory remain incomplete.',
    whyHard: '尽管 Goeppert-Mayer / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['中微子', '双β'],
  },
  {
    id: 'phys-sterile-neutrino',
    category: 'physics',
    title: '惰性中微子 (sterile neutrino) 的存在',
    titleJa: '滅菌ニュートリノの存在',
    titleEs: 'Existencia de neutrinos estériles: Propuesto por varios equipos en 1990, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Existence of sterile neutrinos',
    year: 1990,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：惰性中微子 (sterile neutrino) 的存在。',
    summaryJa: '物理学の分野における特定の困難な問題：滅菌ニュートリノの存在。',
    summaryEs: 'Existencia de neutrinos estériles: Propuesto por varios equipos en 1990, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Existence of sterile neutrinos.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 惰性中微子 (sterile neutrino) 的存在 是这样一个问题：「惰性中微子 (sterile neutrino) 的存在」是 物理 领域的 中微子 方向，涉及 中微子, BSM 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「惰性中微子 (sterile neutrino) 的存在」是 物理 领域的 中微子 方向，涉及 中微子, BSM 等方面。',
    formal: '惰性中微子 (sterile neutrino) 的存在（Existence of sterile neutrinos）：多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '無菌ニュートリノの存在：無菌ニュートリノの存在は1990年に複数のチームによって提唱され、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Existencia de neutrinos estériles: Propuesto por varios equipos en 1990, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Existence of sterile neutrinos: proposed by 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['中微子', 'BSM'],
  },
  {
    id: 'phys-proton-decay',
    category: 'physics',
    title: '质子衰变的探测',
    titleJa: '陽子崩壊の検出',
    titleEs: 'Detección de la desintegración de protones: GUT/Super-Kamiokande se propuso en 1974, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Detection of proton decay',
    year: 1974,
    proposer: 'GUT / Super-Kamiokande',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：质子衰变的探测。',
    summaryJa: '物理学の分野における特定の困難な問題：陽子崩壊の検出。',
    summaryEs: 'Detección de la desintegración de protones: GUT/Super-Kamiokande se propuso en 1974, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Detection of proton decay.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 质子衰变的探测 是这样一个问题：「质子衰变的探测」是 物理 领域的 GUT 方向，涉及 GUT, 质子 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「质子衰变的探测」是 物理 领域的 GUT 方向，涉及 GUT, 质子 等方面。',
    formal: '质子衰变的探测（Detection of proton decay）：GUT / Super-Kamiokande 在 1974 年提出，相关实验/理论至今未完全解决。',
    formalJa: '陽子崩壊の検出： 1974年にGUT/Super - Kamiokandeによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Detección de la desintegración de protones: GUT/Super-Kamiokande se propuso en 1974, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Detection of proton decay: proposed by GUT / Super-Kamiokande in 1974; related experiments/theory remain incomplete.',
    whyHard: '「质子衰变的探测」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['GUT', '质子'],
  },
  {
    id: 'phys-nuclear-eos',
    category: 'physics',
    title: '中子星物质状态方程的精确确定',
    titleJa: '物質の中性子星状態方程式の正確な決定',
    titleEs: 'Determinación precisa de la ecuación de estado de la materia de las estrellas de neutrones: propuesta por varios equipos en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Precise determination of neutron star matter equation of state',
    year: 1970,
    proposer: '多团队',
    difficulty: 5,
    reward: 2500,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：中子星物质状态方程的精确确定。',
    summaryJa: '物理学の分野における特定の困難な問題：中性子星における物質の状態方程式の正確な決定。',
    summaryEs: 'Determinación precisa de la ecuación de estado de la materia de las estrellas de neutrones: propuesta por varios equipos en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Precise determination of neutron star matter equation of state.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 中子星物质状态方程的精确确定 是这样一个问题：「中子星物质状态方程的精确确定」是 物理 领域的 中子星 方向，涉及 中子星, 核物质 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「中子星物质状态方程的精确确定」是 物理 领域的 中子星 方向，涉及 中子星, 核物质 等方面。',
    formal: '中子星物质状态方程的精确确定（Precise determination of neutron star matter equation of state）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: '中性子星物質の状態方程式の正確な決定： 1970年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Determinación precisa de la ecuación de estado de la materia de las estrellas de neutrones: propuesta por varios equipos en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Precise determination of neutron star matter equation of state: proposed by 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '「中子星物质状态方程的精确确定」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['中子星', '核物质'],
  },
  {
    id: 'phys-qgp-thermalization',
    category: 'physics',
    title: 'QGP 早期热化的机制',
    titleJa: 'QGP初期熱のメカニズム',
    titleEs: 'Mecanismo de termalización temprana en QGP: propuesto por RHIC/LHC/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Mechanism of early thermalization in QGP',
    year: 2000,
    proposer: 'RHIC / LHC / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：QGP 早期热化的机制。',
    summaryJa: '物理学の分野における特定の難題： QGPの早期熱化のメカニズム。',
    summaryEs: 'Mecanismo de termalización temprana en QGP: propuesto por RHIC/LHC/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Mechanism of early thermalization in QGP.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 QGP 早期热化的机制。它说的是 「QGP 早期热化的机制」是 物理 领域的 QGP 方向，涉及 QGP, 热化 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「QGP 早期热化的机制」是 物理 领域的 QGP 方向，涉及 QGP, 热化 等方面。',
    formal: 'QGP 早期热化的机制（Mechanism of early thermalization in QGP）：RHIC / LHC / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'QGPにおける早期熱化のメカニズム： 2000年にRHIC/LHC/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de termalización temprana en QGP: propuesto por RHIC/LHC/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Mechanism of early thermalization in QGP: proposed by RHIC / LHC / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['QGP', '热化'],
  },
  {
    id: 'phys-axion-detection',
    category: 'physics',
    title: '轴子 (axion) 的实验探测',
    titleJa: '軸子の実験的検出',
    titleEs: 'Detección experimental de axiones: propuesta por Peccei-Quinn/múltiples equipos en 1977, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Experimental detection of axions',
    year: 1977,
    proposer: 'Peccei-Quinn / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：轴子 (axion) 的实验探测。',
    summaryJa: '物理学の分野における特定の困難な問題：軸子の実験的検出。',
    summaryEs: 'Detección experimental de axiones: propuesta por Peccei-Quinn/múltiples equipos en 1977, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Experimental detection of axions.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 轴子 (axion) 的实验探测。它说的是 「轴子 (axion) 的实验探测」是 物理 领域的 轴子 方向，涉及 轴子, CP 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「轴子 (axion) 的实验探测」是 物理 领域的 轴子 方向，涉及 轴子, CP 等方面。',
    formal: '轴子 (axion) 的实验探测（Experimental detection of axions）：Peccei-Quinn / 多团队 在 1977 年提出，相关实验/理论至今未完全解决。',
    formalJa: '軸子の実験的検出： 1977年にPeccei - Quinn/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Detección experimental de axiones: propuesta por Peccei-Quinn/múltiples equipos en 1977, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Experimental detection of axions: proposed by Peccei-Quinn / 多团队 in 1977; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['轴子', 'CP'],
  },
  {
    id: 'phys-magnetic-monopole',
    category: 'physics',
    title: '磁单极子的探测',
    titleJa: '磁気モノポール検出',
    titleEs: 'Detección de monopolos magnéticos: propuesto por Dirac/varios equipos en 1931, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Detection of magnetic monopoles',
    year: 1931,
    proposer: 'Dirac / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：磁单极子的探测。',
    summaryJa: '物理学の分野における特定の困難な問題：磁気モノポールの検出。',
    summaryEs: 'Detección de monopolos magnéticos: propuesto por Dirac/varios equipos en 1931, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Detection of magnetic monopoles.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 磁单极子的探测 的问题。它可以简单描述为 「磁单极子的探测」是 物理 领域的 磁单极 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「磁单极子的探测」是 物理 领域的 磁单极 方向。',
    formal: '磁单极子的探测（Detection of magnetic monopoles）：Dirac / 多团队 在 1931 年提出，相关实验/理论至今未完全解决。',
    formalJa: '磁気モノポールの検出： 1931年にDirac/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Detección de monopolos magnéticos: propuesto por Dirac/varios equipos en 1931, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Detection of magnetic monopoles: proposed by Dirac / 多团队 in 1931; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['磁单极'],
  },
  {
    id: 'phys-dark-photon',
    category: 'physics',
    title: '暗光子的存在性',
    titleJa: '暗光子の存在',
    titleEs: 'Existencia de fotones oscuros: propuestos por varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Existence of dark photons',
    year: 2009,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：暗光子的存在性。',
    summaryJa: '物理学の分野における特定の困難な問題：ダークフォトンの存在。',
    summaryEs: 'Existencia de fotones oscuros: propuestos por varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Existence of dark photons.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 暗光子的存在性 的核心问题是：「暗光子的存在性」是 物理 领域的 暗光子 方向，涉及 暗光子, BSM 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「暗光子的存在性」是 物理 领域的 暗光子 方向，涉及 暗光子, BSM 等方面。',
    formal: '暗光子的存在性（Existence of dark photons）：多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ダークフォトンの存在： 2009年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Existencia de fotones oscuros: propuestos por varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Existence of dark photons: proposed by 多团队 in 2009; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['暗光子', 'BSM'],
  },
  {
    id: 'phys-fifth-force',
    category: 'physics',
    title: '第五种力的存在性',
    titleJa: '第五の力の存在',
    titleEs: 'Existencia de una quinta fuerza: propuesta por Fischbach/múltiples equipos en 1986, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Existence of a fifth force',
    year: 1986,
    proposer: 'Fischbach / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：第五种力的存在性。',
    summaryJa: '物理学の分野における特定の困難な問題：第五の力の存在。',
    summaryEs: 'Existencia de una quinta fuerza: propuesta por Fischbach/múltiples equipos en 1986, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Existence of a fifth force.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 第五种力的存在性 是这样一个问题：「第五种力的存在性」是 物理 领域的 第五种力 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「第五种力的存在性」是 物理 领域的 第五种力 方向。',
    formal: '第五种力的存在性（Existence of a fifth force）：Fischbach / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    formalJa: '5番目の力の存在：フィッシュバッハ/マルチチームは1986年に、関連する実験/理論はまだ完全に解決されていないと提案した。',
    formalEs: 'Existencia de una quinta fuerza: propuesta por Fischbach/múltiples equipos en 1986, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Existence of a fifth force: proposed by Fischbach / 多团队 in 1986; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['第五种力'],
  },
  {
    id: 'phys-gw-background',
    category: 'physics',
    title: '随机引力波背景的起源',
    titleJa: 'ランダム重力波背景の起源',
    titleEs: 'Origen del fondo de ondas gravitacionales estocásticas: propuesto por LIGO/múltiples equipos en 2016, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Origin of stochastic gravitational wave background',
    year: 2016,
    proposer: 'LIGO / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：随机引力波背景的起源。',
    summaryJa: '物理学の分野における特定の困難な問題：ランダムな重力波の背景の起源。',
    summaryEs: 'Origen del fondo de ondas gravitacionales estocásticas: propuesto por LIGO/múltiples equipos en 2016, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Origin of stochastic gravitational wave background.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 随机引力波背景的起源。它说的是 「随机引力波背景的起源」是 物理 领域的 引力波 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「随机引力波背景的起源」是 物理 领域的 引力波 方向。',
    formal: '随机引力波背景的起源（Origin of stochastic gravitational wave background）：LIGO / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    formalJa: '確率的重力波背景の起源： 2016年、LIGO/マルチチームは、関連する実験/理論が完全に解決されていないことを提案した。',
    formalEs: 'Origen del fondo de ondas gravitacionales estocásticas: propuesto por LIGO/múltiples equipos en 2016, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Origin of stochastic gravitational wave background: proposed by LIGO / 多团队 in 2016; related experiments/theory remain incomplete.',
    whyHard: '尽管 LIGO / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['引力波'],
  },
  {
    id: 'phys-atto-second',
    category: 'physics',
    title: '阿秒物理: 电子动力学的实时观测',
    titleJa: 'アトセカンド物理学：電磁力学のリアルタイム観測',
    titleEs: 'Física de attosegundos: observación en tiempo real de la dinámica de los electrones (física de attosegundos): propuesta por Krausz/Agostini/L\'Huillier en 2001, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Real-time observation of electron dynamics (attosecond physics)',
    year: 2001,
    proposer: 'Krausz / Agostini / L’Huillier',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：阿秒物理: 电子动力学的实时观测。',
    summaryJa: '物理学の分野における特定の難題：アトセカンド物理学：電子力学のリアルタイム観測。',
    summaryEs: 'Física de attosegundos: observación en tiempo real de la dinámica de los electrones (física de attosegundos): propuesta por Krausz/Agostini/L\'Huillier en 2001, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Real-time observation of electron dynamics (attosecond physics).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 阿秒物理: 电子动力学的实时观测。它说的是 「阿秒物理: 电子动力学的实时观测」是 物理 领域的 阿秒 方向，涉及 阿秒, 激光 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「阿秒物理: 电子动力学的实时观测」是 物理 领域的 阿秒 方向，涉及 阿秒, 激光 等方面。',
    formal: '阿秒物理: 电子动力学的实时观测（Real-time observation of electron dynamics (attosecond physics)）：Krausz / Agostini / L’Huillier 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'アトセカンド物理学：電子力学のリアルタイム観測（アトセカンド物理学） ： 2001年にKrausz/Agostini/L\'Huillierが提唱したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Física de attosegundos: observación en tiempo real de la dinámica de los electrones (física de attosegundos): propuesta por Krausz/Agostini/L\'Huillier en 2001, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Real-time observation of electron dynamics (attosecond physics): proposed by Krausz / Agostini / L’Huillier in 2001; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Krausz / Agostini / L’Huillier 等人在 2001 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['阿秒', '激光'],
  },
  {
    id: 'phys-quantum-network',
    category: 'physics',
    title: '量子网络 (QKD) 长距离实际部署',
    titleJa: '量子ネットワーク（ QKD ）長距離実用展開',
    titleEs: 'Despliegue práctico a larga distancia de redes cuánticas (QKD): propuesto por Bennett/Brassard/múltiples equipos en 1984, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Long-distance practical deployment of quantum networks (QKD)',
    year: 1984,
    proposer: 'Bennett / Brassard / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：量子网络 (QKD) 长距离实际部署。',
    summaryJa: '物理学の分野における特定の難題：長距離にわたる量子ネットワーク（ QKD ）の実用的な展開。',
    summaryEs: 'Despliegue práctico a larga distancia de redes cuánticas (QKD): propuesto por Bennett/Brassard/múltiples equipos en 1984, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Long-distance practical deployment of quantum networks (QKD).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 量子网络 (QKD) 长距离实际部署。它说的是 「量子网络 (QKD) 长距离实际部署」是 物理 领域的 量子 方向，涉及 量子, QKD 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「量子网络 (QKD) 长距离实际部署」是 物理 领域的 量子 方向，涉及 量子, QKD 等方面。',
    formal: '量子网络 (QKD) 长距离实际部署（Long-distance practical deployment of quantum networks (QKD)）：Bennett / Brassard / 多团队 在 1984 年提出，相关实验/理论至今未完全解决。',
    formalJa: '量子ネットワーク（ QKD ）の長距離実用展開： 1984年にBennett/Brassard/Multipleチームが提案し、関連する実験/理論が完全に解決されていない。',
    formalEs: 'Despliegue práctico a larga distancia de redes cuánticas (QKD): propuesto por Bennett/Brassard/múltiples equipos en 1984, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Long-distance practical deployment of quantum networks (QKD): proposed by Bennett / Brassard / 多团队 in 1984; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Bennett / Brassard / 多团队 等人在 1984 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['量子', 'QKD'],
  },
  {
    id: 'phys-quantum-error-threshold',
    category: 'physics',
    title: '量子纠错码阈值 (threshold theorem) 实际值',
    titleJa: '量子誤差補正符号閾値定理実測値',
    titleEs: 'Valor práctico del umbral de corrección de errores cuánticos (teorema del umbral): Propuesto por Shor / Aharonov / Ben-Or / Kitaev en 1996, los experimentos / teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Practical value of quantum error correction threshold',
    year: 1996,
    proposer: 'Shor / Aharonov / Ben-Or / Kitaev',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：量子纠错码阈值 (threshold theorem) 实际值。',
    summaryJa: '物理学の分野における特定の難しい問題：量子誤差補正符号閾値定理の実際の値。',
    summaryEs: 'Valor práctico del umbral de corrección de errores cuánticos (teorema del umbral): Propuesto por Shor / Aharonov / Ben-Or / Kitaev en 1996, los experimentos / teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Practical value of quantum error correction threshold.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 量子纠错码阈值 (threshold theorem) 实际值 是这样一个问题：「量子纠错码阈值 (threshold theorem) 实际值」是 物理 领域的 量子 方向，涉及 量子, 纠错 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「量子纠错码阈值 (threshold theorem) 实际值」是 物理 领域的 量子 方向，涉及 量子, 纠错 等方面。',
    formal: '量子纠错码阈值 (threshold theorem) 实际值（Practical value of quantum error correction threshold）：Shor / Aharonov / Ben-Or / Kitaev 在 1996 年提出，相关实验/理论至今未完全解决。',
    formalJa: '量子誤差補正閾値の実用的な値： Shor/Aharonov/Ben - Or/Kitaevは1996年に提唱しており、関連する実験/理論はこれまで完全には解決されていない。',
    formalEs: 'Valor práctico del umbral de corrección de errores cuánticos (teorema del umbral): Propuesto por Shor / Aharonov / Ben-Or / Kitaev en 1996, los experimentos / teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Practical value of quantum error correction threshold: proposed by Shor / Aharonov / Ben-Or / Kitaev in 1996; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['量子', '纠错'],
  },
  {
    id: 'phys-quantum-simulator',
    category: 'physics',
    title: '量子模拟器 (量子退火) 优势证明',
    titleJa: '量子シミュレータ（量子アニーリング）の利点の証明',
    titleEs: 'Demostración de la ventaja cuántica en simuladores cuánticos: D-Wave/múltiples equipos lo propusieron en 2011, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Demonstrating quantum advantage in quantum simulators',
    year: 2011,
    proposer: 'D-Wave / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：量子模拟器 (量子退火) 优势证明。',
    summaryJa: '物理学の分野における特定の難題：量子シミュレータ（量子アニーリング）の利点の証明。',
    summaryEs: 'Demostración de la ventaja cuántica en simuladores cuánticos: D-Wave/múltiples equipos lo propusieron en 2011, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Demonstrating quantum advantage in quantum simulators.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 量子模拟器 (量子退火) 优势证明。它说的是 「量子模拟器 (量子退火) 优势证明」是 物理 领域的 量子模拟 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「量子模拟器 (量子退火) 优势证明」是 物理 领域的 量子模拟 方向。',
    formal: '量子模拟器 (量子退火) 优势证明（Demonstrating quantum advantage in quantum simulators）：D-Wave / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: '量子シミュレータにおける量子優位性の実証： 2011年にD - Wave/マルチチームチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Demostración de la ventaja cuántica en simuladores cuánticos: D-Wave/múltiples equipos lo propusieron en 2011, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Demonstrating quantum advantage in quantum simulators: proposed by D-Wave / 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '尽管 D-Wave / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['量子模拟'],
  },
  {
    id: 'phys-bec-strongly',
    category: 'physics',
    title: '强相互作用 BEC 的特性',
    titleJa: '強く相互作用するBECの特徴',
    titleEs: 'Propiedades de BEC que interactúan fuertemente: Propuesto por Cornell/Wieman/Ketterle en 1995, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Properties of strongly interacting BEC',
    year: 1995,
    proposer: 'Cornell / Wieman / Ketterle',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：强相互作用 BEC 的特性。',
    summaryJa: '物理学の分野における特定の難題：強く相互作用するBECの特性。',
    summaryEs: 'Propiedades de BEC que interactúan fuertemente: Propuesto por Cornell/Wieman/Ketterle en 1995, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Properties of strongly interacting BEC.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 强相互作用 BEC 的特性 是这样一个问题：「强相互作用 BEC 的特性」是 物理 领域的 BEC 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「强相互作用 BEC 的特性」是 物理 领域的 BEC 方向。',
    formal: '强相互作用 BEC 的特性（Properties of strongly interacting BEC）：Cornell / Wieman / Ketterle 在 1995 年提出，相关实验/理论至今未完全解决。',
    formalJa: '強く相互作用するBECの特性： 1995年に提案されたCornell/Wieman/Ketterle、および関連する実験/理論は完全には解決されていません。',
    formalEs: 'Propiedades de BEC que interactúan fuertemente: Propuesto por Cornell/Wieman/Ketterle en 1995, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Properties of strongly interacting BEC: proposed by Cornell / Wieman / Ketterle in 1995; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['BEC'],
  },
  {
    id: 'phys-bcs-bec-crossover',
    category: 'physics',
    title: 'BCS-BEC crossover 的统一描述',
    titleJa: 'BCS - BECクロスオーバーの統一された説明',
    titleEs: 'Descripción unificada del cruce BCS-BEC: propuesto por Leggett/varios equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Unified description of BCS-BEC crossover',
    year: 2004,
    proposer: 'Leggett / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：BCS-BEC crossover 的统一描述。',
    summaryJa: '物理学の分野における特定の難題： BCS - BECクロスオーバーの統一された説明。',
    summaryEs: 'Descripción unificada del cruce BCS-BEC: propuesto por Leggett/varios equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Unified description of BCS-BEC crossover.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 BCS-BEC crossover 的统一描述。它说的是 「BCS-BEC crossover 的统一描述」是 物理 领域的 超流 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「BCS-BEC crossover 的统一描述」是 物理 领域的 超流 方向。',
    formal: 'BCS-BEC crossover 的统一描述（Unified description of BCS-BEC crossover）：Leggett / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'BCS - BECクロスオーバーの統一的な説明： 2004年にLeggett/Multi - Teamによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Descripción unificada del cruce BCS-BEC: propuesto por Leggett/varios equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Unified description of BCS-BEC crossover: proposed by Leggett / 多团队 in 2004; related experiments/theory remain incomplete.',
    whyHard: '尽管 Leggett / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超流'],
  },
  {
    id: 'phys-frustrated-magnet',
    category: 'physics',
    title: '自旋冰 (spin ice) 中磁单极子激发',
    titleJa: 'スピンアイスでの磁気モノポール励起',
    titleEs: 'Excitaciones monopolares magnéticas en hielo giratorio: propuestas por Bramwell/varios equipos en 2008, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Magnetic monopole excitations in spin ice',
    year: 2008,
    proposer: 'Bramwell / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：自旋冰 (spin ice) 中磁单极子激发。',
    summaryJa: '物理学の分野における特定の困難な問題：スピンアイスにおける磁気モノポール励起。',
    summaryEs: 'Excitaciones monopolares magnéticas en hielo giratorio: propuestas por Bramwell/varios equipos en 2008, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Magnetic monopole excitations in spin ice.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 自旋冰 (spin ice) 中磁单极子激发 的问题。它可以简单描述为 「自旋冰 (spin ice) 中磁单极子激发」是 物理 领域的 自旋冰 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「自旋冰 (spin ice) 中磁单极子激发」是 物理 领域的 自旋冰 方向。',
    formal: '自旋冰 (spin ice) 中磁单极子激发（Magnetic monopole excitations in spin ice）：Bramwell / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'スピンアイスにおける磁気モノポール励起： Bramwell/Multiチームは2008年に提案し、関連する実験/理論はこれまで完全には解決されていません。',
    formalEs: 'Excitaciones monopolares magnéticas en hielo giratorio: propuestas por Bramwell/varios equipos en 2008, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Magnetic monopole excitations in spin ice: proposed by Bramwell / 多团队 in 2008; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自旋冰'],
  },
  {
    id: 'phys-weak-measurement',
    category: 'physics',
    title: '弱测量 (weak value) 的物理意义',
    titleJa: '弱い値の物理的意義',
    titleEs: 'Interpretación física de valores débiles (Interpretación física de valores débiles): propuesta por Aharonov/Albert/Vaidman en 1988, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Physical interpretation of weak values',
    year: 1988,
    proposer: 'Aharonov / Albert / Vaidman',
    difficulty: 3,
    reward: 300,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：弱测量 (weak value) 的物理意义。',
    summaryJa: '物理学の分野における特定の困難な問題：弱い値の物理的意味。',
    summaryEs: 'Interpretación física de valores débiles (Interpretación física de valores débiles): propuesta por Aharonov/Albert/Vaidman en 1988, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Physical interpretation of weak values.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 弱测量 (weak value) 的物理意义 的核心问题是：「弱测量 (weak value) 的物理意义」是 物理 领域的 量子测量 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「弱测量 (weak value) 的物理意义」是 物理 领域的 量子测量 方向。',
    formal: '弱测量 (weak value) 的物理意义（Physical interpretation of weak values）：Aharonov / Albert / Vaidman 在 1988 年提出，相关实验/理论至今未完全解决。',
    formalJa: '弱い値の物理的解釈： 1988年にAharonov/Albert/Vaidmanによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Interpretación física de valores débiles (Interpretación física de valores débiles): propuesta por Aharonov/Albert/Vaidman en 1988, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Physical interpretation of weak values: proposed by Aharonov / Albert / Vaidman in 1988; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Aharonov / Albert / Vaidman 等人在 1988 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['量子测量'],
  },
  {
    id: 'phys-quantum-thermo',
    category: 'physics',
    title: '不可逆过程的量子热力学基础',
    titleJa: '不可逆過程の量子熱力学の基礎',
    titleEs: 'Fundamento termodinámico cuántico de procesos irreversibles: propuesto por Jarzynski/Crooks/múltiples equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Quantum thermodynamic foundation of irreversible processes',
    year: 2010,
    proposer: 'Jarzynski / Crooks / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：不可逆过程的量子热力学基础。',
    summaryJa: '物理学の分野における特定の難題：不可逆過程の量子熱力学的基礎。',
    summaryEs: 'Fundamento termodinámico cuántico de procesos irreversibles: propuesto por Jarzynski/Crooks/múltiples equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Quantum thermodynamic foundation of irreversible processes.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 不可逆过程的量子热力学基础 的核心问题是：「不可逆过程的量子热力学基础」是 物理 领域的 量子 方向，涉及 量子, 热力学 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「不可逆过程的量子热力学基础」是 物理 领域的 量子 方向，涉及 量子, 热力学 等方面。',
    formal: '不可逆过程的量子热力学基础（Quantum thermodynamic foundation of irreversible processes）：Jarzynski / Crooks / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '不可逆過程の量子熱力学的基礎： 2010年にJarzynski/Crooks/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Fundamento termodinámico cuántico de procesos irreversibles: propuesto por Jarzynski/Crooks/múltiples equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Quantum thermodynamic foundation of irreversible processes: proposed by Jarzynski / Crooks / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Jarzynski / Crooks / 多团队 等人在 2010 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['量子', '热力学'],
  },
  {
    id: 'phys-lwfa-quality',
    category: 'physics',
    title: '激光尾场加速器 (LWFA) 电子束品质极限',
    titleJa: 'レーザーウェイクフィールドアクセラレータ（ LWFA ）電子ビーム品質制限',
    titleEs: 'Límites de la calidad del haz de electrones LWFA (Límites de la calidad del haz de electrones LWFA): Propuesto por Faure/varios equipos en 2004, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Limits of LWFA electron beam quality',
    year: 2004,
    proposer: 'Faure / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：激光尾场加速器 (LWFA) 电子束品质极限。',
    summaryJa: '物理学の分野における特定の困難な問題：レーザーウェイクフィールド加速器（ LWFA ）電子ビーム品質限界。',
    summaryEs: 'Límites de la calidad del haz de electrones LWFA (Límites de la calidad del haz de electrones LWFA): Propuesto por Faure/varios equipos en 2004, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Limits of LWFA electron beam quality.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 激光尾场加速器 (LWFA) 电子束品质极限。它说的是 「激光尾场加速器 (LWFA) 电子束品质极限」是 物理 领域的 加速器 方向，涉及 加速器, 激光 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「激光尾场加速器 (LWFA) 电子束品质极限」是 物理 领域的 加速器 方向，涉及 加速器, 激光 等方面。',
    formal: '激光尾场加速器 (LWFA) 电子束品质极限（Limits of LWFA electron beam quality）：Faure / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'レーザーウェイクフィールド加速器（ LWFA ）電子ビーム品質制限（ LWFA電子ビーム品質の制限） ： 2004年に提案されたFAURE/マルチチーム、関連する実験/理論は完全には解決されていません。',
    formalEs: 'Límites de la calidad del haz de electrones LWFA (Límites de la calidad del haz de electrones LWFA): Propuesto por Faure/varios equipos en 2004, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Limits of LWFA electron beam quality: proposed by Faure / 多团队 in 2004; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['加速器', '激光'],
  },
  {
    id: 'phys-quantum-thermo-foundation',
    category: 'physics',
    title: '玻尔兹曼方程的严格推导',
    titleJa: 'ボルツマン方程式の厳密な導出',
    titleEs: 'Derivación rigurosa de la ecuación de Boltzmann: propuesta por Boltzmann/Lanford/varios equipos en 1872, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Rigorous derivation of the Boltzmann equation',
    year: 1872,
    proposer: 'Boltzmann / Lanford / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：玻尔兹曼方程的严格推导。',
    summaryJa: '物理学の分野における特定の難題：ボルツマン方程式の厳密な導出。',
    summaryEs: 'Derivación rigurosa de la ecuación de Boltzmann: propuesta por Boltzmann/Lanford/varios equipos en 1872, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Rigorous derivation of the Boltzmann equation.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 玻尔兹曼方程的严格推导 的问题。它可以简单描述为 「玻尔兹曼方程的严格推导」是 物理 领域的 统计力学 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「玻尔兹曼方程的严格推导」是 物理 领域的 统计力学 方向。',
    formal: '玻尔兹曼方程的严格推导（Rigorous derivation of the Boltzmann equation）：Boltzmann / Lanford / 多团队 在 1872 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ボルツマン方程式の厳密な導出： 1872年にボルツマン/ランフォード/マルチチームが提案し、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Derivación rigurosa de la ecuación de Boltzmann: propuesta por Boltzmann/Lanford/varios equipos en 1872, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Rigorous derivation of the Boltzmann equation: proposed by Boltzmann / Lanford / 多团队 in 1872; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['统计力学'],
  },
  {
    id: 'phys-shear-viscosity',
    category: 'physics',
    title: '强相互作用物质的剪切粘度下限 (KSS bound)',
    titleJa: '強相互作用物質のせん断粘度下限（ KSSバインド）',
    titleEs: 'Límite inferior de la viscosidad de corte de materia que interactúa fuertemente (límite KSS): Kovtun/Son/Starinets propuesto en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Lower bound on shear viscosity of strongly interacting matter',
    year: 2005,
    proposer: 'Kovtun / Son / Starinets',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：强相互作用物质的剪切粘度下限 (KSS bound)。',
    summaryJa: '物理学の分野における特定の困難な問題：強く相互作用する物質のせん断粘度の下限（ KSSバウンド）。',
    summaryEs: 'Límite inferior de la viscosidad de corte de materia que interactúa fuertemente (límite KSS): Kovtun/Son/Starinets propuesto en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Lower bound on shear viscosity of strongly interacting matter.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 强相互作用物质的剪切粘度下限 (KSS bound) 的核心问题是：「强相互作用物质的剪切粘度下限 (KSS bound)」是 物理 领域的 QGP 方向，涉及 QGP, 全息 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「强相互作用物质的剪切粘度下限 (KSS bound)」是 物理 领域的 QGP 方向，涉及 QGP, 全息 等方面。',
    formal: '强相互作用物质的剪切粘度下限 (KSS bound)（Lower bound on shear viscosity of strongly interacting matter）：Kovtun / Son / Starinets 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: '強く相互作用する物質のせん断粘度の下限（ KSS限界） ： 2005年にKovtun/Son/Starinetsによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Límite inferior de la viscosidad de corte de materia que interactúa fuertemente (límite KSS): Kovtun/Son/Starinets propuesto en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Lower bound on shear viscosity of strongly interacting matter: proposed by Kovtun / Son / Starinets in 2005; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Kovtun / Son / Starinets 等人在 2005 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['QGP', '全息'],
  },
  {
    id: 'phys-non-hermitian',
    category: 'physics',
    title: '非厄米拓扑 (PT-symmetric) 物态',
    titleJa: '非エルミート位相（ PT対称）状態',
    titleEs: 'Estados topológicos no hermitianos (PT-simétricos): propuestos por Bender/múltiples equipos en 1998, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Non-Hermitian topological (PT-symmetric) states',
    year: 1998,
    proposer: 'Bender / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：非厄米拓扑 (PT-symmetric) 物态。',
    summaryJa: '物理学の分野における特定の難しい問題：非エルミアントポロジー（ PT対称）状態。',
    summaryEs: 'Estados topológicos no hermitianos (PT-simétricos): propuestos por Bender/múltiples equipos en 1998, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Non-Hermitian topological (PT-symmetric) states.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 非厄米拓扑 (PT-symmetric) 物态。它说的是 「非厄米拓扑 (PT-symmetric) 物态」是 物理 领域的 非厄米 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「非厄米拓扑 (PT-symmetric) 物态」是 物理 领域的 非厄米 方向。',
    formal: '非厄米拓扑 (PT-symmetric) 物态（Non-Hermitian topological (PT-symmetric) states）：Bender / 多团队 在 1998 年提出，相关实验/理论至今未完全解决。',
    formalJa: '非エルミート位相（ PT対称）状態： 1998年にBender/Multiチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Estados topológicos no hermitianos (PT-simétricos): propuestos por Bender/múltiples equipos en 1998, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Non-Hermitian topological (PT-symmetric) states: proposed by Bender / 多团队 in 1998; related experiments/theory remain incomplete.',
    whyHard: '「非厄米拓扑 (PT-symmetric) 物态」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['非厄米'],
  },
  {
    id: 'phys-time-crystal',
    category: 'physics',
    title: '时间晶体的稳定实现',
    titleJa: '時間の安定した実現クリスタル',
    titleEs: 'Realización estable de cristales de tiempo: propuesto por Wilczek/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Stable realization of time crystals',
    year: 2012,
    proposer: 'Wilczek / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：时间晶体的稳定实现。',
    summaryJa: '物理学の分野における特定の難題：時間結晶の安定した実現。',
    summaryEs: 'Realización estable de cristales de tiempo: propuesto por Wilczek/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Stable realization of time crystals.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 时间晶体的稳定实现 是这样一个问题：「时间晶体的稳定实现」是 物理 领域的 时间晶体 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「时间晶体的稳定实现」是 物理 领域的 时间晶体 方向。',
    formal: '时间晶体的稳定实现（Stable realization of time crystals）：Wilczek / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: '時間結晶の安定した実現： 2012年にWilczek/マルチチームが提案され、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Realización estable de cristales de tiempo: propuesto por Wilczek/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Stable realization of time crystals: proposed by Wilczek / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['时间晶体'],
  },
  {
    id: 'phys-bbt-crossover',
    category: 'physics',
    title: '玻色-玻色散射长度重整化',
    titleJa: 'Bose - Bose散乱長の再フォーマット',
    titleEs: 'Renormalización de la longitud de dispersión de Bose-Bose: propuesta por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Bose-Bose scattering length renormalization',
    year: 2000,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：玻色-玻色散射长度重整化。',
    summaryJa: '物理学の分野における特定の困難な問題：ボーズ・ボーズ散乱長の再構成。',
    summaryEs: 'Renormalización de la longitud de dispersión de Bose-Bose: propuesta por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Bose-Bose scattering length renormalization.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 玻色-玻色散射长度重整化 是这样一个问题：「玻色-玻色散射长度重整化」是 物理 领域的 超冷 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「玻色-玻色散射长度重整化」是 物理 领域的 超冷 方向。',
    formal: '玻色-玻色散射长度重整化（Bose-Bose scattering length renormalization）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Bose - Bose散乱長の再正規化： 2000年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Renormalización de la longitud de dispersión de Bose-Bose: propuesta por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Bose-Bose scattering length renormalization: proposed by 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超冷'],
  },
  {
    id: 'phys-rf-feshbach',
    category: 'physics',
    title: '射频 Feshbach 共振的精确控制',
    titleJa: 'RFフェッシュバッハ共振の正確な制御',
    titleEs: 'Control preciso de las resonancias RF Feshbach: propuesto por Regal/múltiples equipos en 2003, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Precise control of RF Feshbach resonances',
    year: 2003,
    proposer: 'Regal / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：射频 Feshbach 共振的精确控制。',
    summaryJa: '物理学の分野における特定の難しい問題： RFフェッシュバッハ共鳴の正確な制御。',
    summaryEs: 'Control preciso de las resonancias RF Feshbach: propuesto por Regal/múltiples equipos en 2003, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Precise control of RF Feshbach resonances.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 射频 Feshbach 共振的精确控制 的问题。它可以简单描述为 「射频 Feshbach 共振的精确控制」是 物理 领域的 超冷 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「射频 Feshbach 共振的精确控制」是 物理 领域的 超冷 方向。',
    formal: '射频 Feshbach 共振的精确控制（Precise control of RF Feshbach resonances）：Regal / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'RFフェッシュバッハ共鳴の正確な制御： 2003年にRegal/MultiTeamによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Control preciso de las resonancias RF Feshbach: propuesto por Regal/múltiples equipos en 2003, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Precise control of RF Feshbach resonances: proposed by Regal / 多团队 in 2003; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超冷'],
  },
  {
    id: 'phys-cavity-qed',
    category: 'physics',
    title: '腔 QED 强耦合区单光子非线性',
    titleJa: '空洞QED強結合領域における単一光子非線形性',
    titleEs: 'No linealidad de fotón único en el régimen de acoplamiento fuerte de QED de cavidad: propuesto por Kimble/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Single-photon nonlinearity in cavity QED strong coupling regime',
    year: 1990,
    proposer: 'Kimble / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：腔 QED 强耦合区单光子非线性。',
    summaryJa: '物理学の分野における特定の困難な問題：空洞QED強結合領域単一光子非線形性。',
    summaryEs: 'No linealidad de fotón único en el régimen de acoplamiento fuerte de QED de cavidad: propuesto por Kimble/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Single-photon nonlinearity in cavity QED strong coupling regime.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 腔 QED 强耦合区单光子非线性 是这样一个问题：「腔 QED 强耦合区单光子非线性」是 物理 领域的 腔QED 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「腔 QED 强耦合区单光子非线性」是 物理 领域的 腔QED 方向。',
    formal: '腔 QED 强耦合区单光子非线性（Single-photon nonlinearity in cavity QED strong coupling regime）：Kimble / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '空洞QED強結合レジームにおける単光子非線形性：キンブル/マルチチームは1990年に提案され、関連する実験/理論はこれまで完全には解決されていません。',
    formalEs: 'No linealidad de fotón único en el régimen de acoplamiento fuerte de QED de cavidad: propuesto por Kimble/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Single-photon nonlinearity in cavity QED strong coupling regime: proposed by Kimble / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Kimble / 多团队 等人在 1990 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['腔QED'],
  },
  {
    id: 'phys-circuit-qed',
    category: 'physics',
    title: '电路 QED 量子比特 (transmon) T1 极限',
    titleJa: '回路QEDトランスモンT 1制限',
    titleEs: 'Circuito QED qubits (transmon) Límite T1 del circuito QED qubits (transmon): propuesto por Koch / Schoelkopf / varios equipos en 2007, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'T1 limit of circuit QED qubits (transmon)',
    year: 2007,
    proposer: 'Koch / Schoelkopf / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：电路 QED 量子比特 (transmon) T1 极限。',
    summaryJa: '物理学の分野における特定の困難な問題：回路QEDキュービット（トランスモン） T 1限界。',
    summaryEs: 'Circuito QED qubits (transmon) Límite T1 del circuito QED qubits (transmon): propuesto por Koch / Schoelkopf / varios equipos en 2007, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: T1 limit of circuit QED qubits (transmon).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 电路 QED 量子比特 (transmon) T1 极限 是这样一个问题：「电路 QED 量子比特 (transmon) T1 极限」是 物理 领域的 超导量子 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「电路 QED 量子比特 (transmon) T1 极限」是 物理 领域的 超导量子 方向。',
    formal: '电路 QED 量子比特 (transmon) T1 极限（T1 limit of circuit QED qubits (transmon)）：Koch / Schoelkopf / 多团队 在 2007 年提出，相关实验/理论至今未完全解决。',
    formalJa: '回路QEDキュービット（トランスモン）回路QEDキュービット（トランスモン）のT 1限界： Koch/Schoelkopf/関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Circuito QED qubits (transmon) Límite T1 del circuito QED qubits (transmon): propuesto por Koch / Schoelkopf / varios equipos en 2007, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'T1 limit of circuit QED qubits (transmon): proposed by Koch / Schoelkopf / 多团队 in 2007; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超导量子'],
  },
  {
    id: 'phys-spin-chain-transport',
    category: 'physics',
    title: '一维自旋链中的非平衡输运',
    titleJa: '1次元スピン鎖における非平衡輸送',
    titleEs: 'Transporte sin equilibrio en cadenas de espín 1D: propuesto por Korepin/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Non-equilibrium transport in 1D spin chains',
    year: 2005,
    proposer: 'Korepin / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：一维自旋链中的非平衡输运。',
    summaryJa: '物理学の分野における特定の困難な問題： 1次元スピンチェーンにおける非平衡輸送。',
    summaryEs: 'Transporte sin equilibrio en cadenas de espín 1D: propuesto por Korepin/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Non-equilibrium transport in 1D spin chains.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 一维自旋链中的非平衡输运。它说的是 「一维自旋链中的非平衡输运」是 物理 领域的 低维 方向，涉及 低维, 输运 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「一维自旋链中的非平衡输运」是 物理 领域的 低维 方向，涉及 低维, 输运 等方面。',
    formal: '一维自旋链中的非平衡输运（Non-equilibrium transport in 1D spin chains）：Korepin / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: '1 Dスピンチェーンにおける非平衡輸送： 2005年にKorepin/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Transporte sin equilibrio en cadenas de espín 1D: propuesto por Korepin/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Non-equilibrium transport in 1D spin chains: proposed by Korepin / 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '「一维自旋链中的非平衡输运」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['低维', '输运'],
  },
  {
    id: 'phys-entanglement-condensate',
    category: 'physics',
    title: 'BEC 中的量子纠缠度量',
    titleJa: 'BECにおける量子もつれメトリック',
    titleEs: 'Cuantificación del entrelazamiento en BEC: propuesto por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Quantifying entanglement in BEC',
    year: 2000,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：BEC 中的量子纠缠度量。',
    summaryJa: '物理学の分野における特定の困難な問題： BECにおける量子もつれメトリクス。',
    summaryEs: 'Cuantificación del entrelazamiento en BEC: propuesto por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Quantifying entanglement in BEC.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 BEC 中的量子纠缠度量。它说的是 「BEC 中的量子纠缠度量」是 物理 领域的 BEC 方向，涉及 BEC, 量子 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「BEC 中的量子纠缠度量」是 物理 领域的 BEC 方向，涉及 BEC, 量子 等方面。',
    formal: 'BEC 中的量子纠缠度量（Quantifying entanglement in BEC）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'BECにおけるもつれの定量化： 2000年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Cuantificación del entrelazamiento en BEC: propuesto por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Quantifying entanglement in BEC: proposed by 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['BEC', '量子'],
  },
  {
    id: 'phys-gravitational-anomaly',
    category: 'physics',
    title: '手征磁效应 (chiral magnetic effect) 实验验证',
    titleJa: 'キラル磁気効果の実験的検証',
    titleEs: 'Verificación experimental del efecto magnético quiral: Kharzeev/varios equipos lo propusieron en 2008, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Experimental verification of chiral magnetic effect',
    year: 2008,
    proposer: 'Kharzeev / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：手征磁效应 (chiral magnetic effect) 实验验证。',
    summaryJa: '物理学の分野における特定の困難な問題：キラル磁気効果の実験的検証。',
    summaryEs: 'Verificación experimental del efecto magnético quiral: Kharzeev/varios equipos lo propusieron en 2008, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Experimental verification of chiral magnetic effect.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 手征磁效应 (chiral magnetic effect) 实验验证 的核心问题是：「手征磁效应 (chiral magnetic effect) 实验验证」是 物理 领域的 QCD 方向，涉及 QCD, 反常 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「手征磁效应 (chiral magnetic effect) 实验验证」是 物理 领域的 QCD 方向，涉及 QCD, 反常 等方面。',
    formal: '手征磁效应 (chiral magnetic effect) 实验验证（Experimental verification of chiral magnetic effect）：Kharzeev / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'キラル磁気効果の実験的検証： 2008年に提案されたKharzeev/複数のチーム、および関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Verificación experimental del efecto magnético quiral: Kharzeev/varios equipos lo propusieron en 2008, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Experimental verification of chiral magnetic effect: proposed by Kharzeev / 多团队 in 2008; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['QCD', '反常'],
  },
  {
    id: 'phys-topological-order',
    category: 'physics',
    title: '拓扑序的完整分类 (3+1D)',
    titleJa: '位相順序の完全な分類（ 3 +1 D ）',
    titleEs: 'Clasificación completa del orden topológico en 3 + 1D (Clasificación completa del orden topológico en 3 + 1D): propuesta por Wen/varios equipos en 1990, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Complete classification of topological order in 3+1D',
    year: 1990,
    proposer: 'Wen / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：拓扑序的完整分类 (3+1D)。',
    summaryJa: '物理学の分野における特定の難しい問題：位相順序の完全な分類（ 3 +1 D ）。',
    summaryEs: 'Clasificación completa del orden topológico en 3 + 1D (Clasificación completa del orden topológico en 3 + 1D): propuesta por Wen/varios equipos en 1990, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Complete classification of topological order in 3+1D.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 拓扑序的完整分类 (3+1D)。它说的是 「拓扑序的完整分类 (3+1D)」是 物理 领域的 拓扑序 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「拓扑序的完整分类 (3+1D)」是 物理 领域的 拓扑序 方向。',
    formal: '拓扑序的完整分类 (3+1D)（Complete classification of topological order in 3+1D）：Wen / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '3 +1 Dにおける位相順序の完全な分類： 1990年にWEN/複数チームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Clasificación completa del orden topológico en 3 + 1D (Clasificación completa del orden topológico en 3 + 1D): propuesta por Wen/varios equipos en 1990, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Complete classification of topological order in 3+1D: proposed by Wen / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Wen / 多团队 等人在 1990 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['拓扑序'],
  },
  {
    id: 'phys-fractional-charge',
    category: 'physics',
    title: '分数电荷 e/3 的实验探测',
    titleJa: '分数電荷の実験的検出e/3',
    titleEs: 'Detección experimental de carga fraccionaria e/3: propuesta por Laughlin/varios equipos en 1982, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Experimental detection of fractional charge e/3',
    year: 1982,
    proposer: 'Laughlin / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：分数电荷 e/3 的实验探测。',
    summaryJa: '物理学の分野における特定の難しい問題：分電荷e/3の実験的検出。',
    summaryEs: 'Detección experimental de carga fraccionaria e/3: propuesta por Laughlin/varios equipos en 1982, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Experimental detection of fractional charge e/3.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 分数电荷 e/3 的实验探测。它说的是 「分数电荷 e/3 的实验探测」是 物理 领域的 分数 方向，涉及 分数, 拓扑 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「分数电荷 e/3 的实验探测」是 物理 领域的 分数 方向，涉及 分数, 拓扑 等方面。',
    formal: '分数电荷 e/3 的实验探测（Experimental detection of fractional charge e/3）：Laughlin / 多团队 在 1982 年提出，相关实验/理论至今未完全解决。',
    formalJa: '分数電荷の実験的検出e/3 ： 1982年に提案されたLaughlin/Multiチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: 'Detección experimental de carga fraccionaria e/3: propuesta por Laughlin/varios equipos en 1982, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Experimental detection of fractional charge e/3: proposed by Laughlin / 多团队 in 1982; related experiments/theory remain incomplete.',
    whyHard: '「分数电荷 e/3 的实验探测」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['分数', '拓扑'],
  },
  {
    id: 'phys-non-abelian-fqhe',
    category: 'physics',
    title: '非阿贝尔分数量子霍尔态的编织',
    titleJa: '非アーベル量子ホール状態の織り方',
    titleEs: 'Trenzado en estados de Hall cuánticos fraccionarios no abelianos: propuesto por Moore/Read/varios equipos en 1991, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Braiding in non-Abelian fractional quantum Hall states',
    year: 1991,
    proposer: 'Moore / Read / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：非阿贝尔分数量子霍尔态的编织。',
    summaryJa: '物理学の分野における特定の難題：非アーベル量子ホール状態の織り方。',
    summaryEs: 'Trenzado en estados de Hall cuánticos fraccionarios no abelianos: propuesto por Moore/Read/varios equipos en 1991, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Braiding in non-Abelian fractional quantum Hall states.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 非阿贝尔分数量子霍尔态的编织 的问题。它可以简单描述为 「非阿贝尔分数量子霍尔态的编织」是 物理 领域的 FQHE 方向，涉及 FQHE, 非阿贝尔 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「非阿贝尔分数量子霍尔态的编织」是 物理 领域的 FQHE 方向，涉及 FQHE, 非阿贝尔 等方面。',
    formal: '非阿贝尔分数量子霍尔态的编织（Braiding in non-Abelian fractional quantum Hall states）：Moore / Read / 多团队 在 1991 年提出，相关实验/理论至今未完全解决。',
    formalJa: '非アベリアン分数量子ホール状態での編組： 1991年にMoore/Read/Multiチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Trenzado en estados de Hall cuánticos fraccionarios no abelianos: propuesto por Moore/Read/varios equipos en 1991, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Braiding in non-Abelian fractional quantum Hall states: proposed by Moore / Read / 多团队 in 1991; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['FQHE', '非阿贝尔'],
  },
  {
    id: 'phys-hall-viscosity',
    category: 'physics',
    title: '量子霍尔态的几何响应 (Hall viscosity)',
    titleJa: '量子ホール状態の幾何応答（ホール粘度）',
    titleEs: 'Respuesta geométrica (viscosidad Hall) de los estados cuánticos de Hall: leído/propuesto por varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Geometric response (Hall viscosity) of quantum Hall states',
    year: 2009,
    proposer: 'Read / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：量子霍尔态的几何响应 (Hall viscosity)。',
    summaryJa: '物理学の分野における特定の難題：量子ホール状態（ホール粘度）の幾何学的応答。',
    summaryEs: 'Respuesta geométrica (viscosidad Hall) de los estados cuánticos de Hall: leído/propuesto por varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Geometric response (Hall viscosity) of quantum Hall states.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 量子霍尔态的几何响应 (Hall viscosity)。它说的是 「量子霍尔态的几何响应 (Hall viscosity)」是 物理 领域的 FQHE 方向，涉及 FQHE, 几何 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「量子霍尔态的几何响应 (Hall viscosity)」是 物理 领域的 FQHE 方向，涉及 FQHE, 几何 等方面。',
    formal: '量子霍尔态的几何响应 (Hall viscosity)（Geometric response (Hall viscosity) of quantum Hall states）：Read / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: '量子ホール状態のホール粘度（量子ホール状態の幾何学的応答（ホール粘度） ） ： 2009年にRead/Multipleチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Respuesta geométrica (viscosidad Hall) de los estados cuánticos de Hall: leído/propuesto por varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Geometric response (Hall viscosity) of quantum Hall states: proposed by Read / 多团队 in 2009; related experiments/theory remain incomplete.',
    whyHard: '尽管 Read / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['FQHE', '几何'],
  },
  {
    id: 'phys-strong-cp-axion',
    category: 'physics',
    title: '中子电偶极矩 (nEDM) 上限意义',
    titleJa: '中性子電極モーメント（ nEDM ）上限値',
    titleEs: 'Implicación del límite superior de EDM de neutrones: Purcell/Ramsey/múltiples equipos lo propusieron en 1950, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Implication of neutron EDM upper bound',
    year: 1950,
    proposer: 'Purcell / Ramsey / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：中子电偶极矩 (nEDM) 上限意义。',
    summaryJa: '物理学の分野における特定の難題：中性子電極モーメント（ nEDM ）の上限の意味。',
    summaryEs: 'Implicación del límite superior de EDM de neutrones: Purcell/Ramsey/múltiples equipos lo propusieron en 1950, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Implication of neutron EDM upper bound.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 中子电偶极矩 (nEDM) 上限意义。它说的是 「中子电偶极矩 (nEDM) 上限意义」是 物理 领域的 CP 方向，涉及 CP, 中子 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「中子电偶极矩 (nEDM) 上限意义」是 物理 领域的 CP 方向，涉及 CP, 中子 等方面。',
    formal: '中子电偶极矩 (nEDM) 上限意义（Implication of neutron EDM upper bound）：Purcell / Ramsey / 多团队 在 1950 年提出，相关实验/理论至今未完全解决。',
    formalJa: '中性子EDM上限（ nEDM ）の含意： 1950年にPurcell/Ramsey/複数のチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Implicación del límite superior de EDM de neutrones: Purcell/Ramsey/múltiples equipos lo propusieron en 1950, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Implication of neutron EDM upper bound: proposed by Purcell / Ramsey / 多团队 in 1950; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Purcell / Ramsey / 多团队 等人在 1950 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CP', '中子'],
  },
  {
    id: 'phys-superradiance',
    category: 'physics',
    title: '超辐射不稳定性的天体物理观测',
    titleJa: '超放射線不安定性の天体物理学的観測',
    titleEs: 'Observación astrofísica de la inestabilidad de la superradiancia: propuesta por Zel\\\'dovich/Misner/varios equipos en 1972, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Astrophysical observation of superradiance instability',
    year: 1972,
    proposer: 'Zel\'dovich / Misner / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：超辐射不稳定性的天体物理观测。',
    summaryJa: '物理学の分野における特定の困難な問題：超放射線不安定性の天体物理学的観測。',
    summaryEs: 'Observación astrofísica de la inestabilidad de la superradiancia: propuesta por Zel\\\'dovich/Misner/varios equipos en 1972, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Astrophysical observation of superradiance instability.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 超辐射不稳定性的天体物理观测。它说的是 「超辐射不稳定性的天体物理观测」是 物理 领域的 黑洞 方向，涉及 黑洞, 超辐射 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「超辐射不稳定性的天体物理观测」是 物理 领域的 黑洞 方向，涉及 黑洞, 超辐射 等方面。',
    formal: '超辐射不稳定性的天体物理观测（Astrophysical observation of superradiance instability）：Zel\'dovich / Misner / 多团队 在 1972 年提出，相关实验/理论至今未完全解决。',
    formalJa: '超輻射不安定性の天体物理学的観測： 1972年にZel \'dovich/Misner/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEn: 'Astrophysical observation of superradiance instability: proposed by Zel\'dovich / Misner / 多团队 in 1972; related experiments/theory remain incomplete.',
    whyHard: '「超辐射不稳定性的天体物理观测」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['黑洞', '超辐射'],
  },
  {
    id: 'phys-boson-peak',
    category: 'physics',
    title: '玻璃中玻色峰 (boson peak) 的起源',
    titleJa: 'ガラス中のボソンピークの起源',
    titleEs: 'El origen del pico de bosones en los vidrios: propuesto por varios equipos en 1971, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Origin of boson peak in glasses',
    year: 1971,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：玻璃中玻色峰 (boson peak) 的起源。',
    summaryJa: '物理学の分野における特定の困難な問題：ガラスのボソンピークの起源。',
    summaryEs: 'El origen del pico de bosones en los vidrios: propuesto por varios equipos en 1971, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Origin of boson peak in glasses.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 玻璃中玻色峰 (boson peak) 的起源。它说的是 「玻璃中玻色峰 (boson peak) 的起源」是 物理 领域的 玻璃 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「玻璃中玻色峰 (boson peak) 的起源」是 物理 领域的 玻璃 方向。',
    formal: '玻璃中玻色峰 (boson peak) 的起源（Origin of boson peak in glasses）：多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    formalJa: '眼鏡におけるボソンピークの起源： 1971年に多くのチームが提唱したが、関連する実験・理論は完全には解明されていない。',
    formalEs: 'El origen del pico de bosones en los vidrios: propuesto por varios equipos en 1971, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Origin of boson peak in glasses: proposed by 多团队 in 1971; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['玻璃'],
  },
  {
    id: 'phys-kauzmann-paradox',
    category: 'physics',
    title: 'Kauzmann 悖论 (玻璃转变熵危机)',
    titleJa: 'カウズマンパラドックス（ガラス転移エントロピー危機）',
    titleEs: 'Paradoja de Kauzmann (crisis de entropía de transición vítrea): Kauzmann/varios equipos la propusieron en 1948, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Kauzmann paradox (glass transition entropy crisis)',
    year: 1948,
    proposer: 'Kauzmann / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：Kauzmann 悖论 (玻璃转变熵危机)。',
    summaryJa: '物理学の分野における特定の難題：カウズマンパラドックス（ガラス転移エントロピー危機）。',
    summaryEs: 'Paradoja de Kauzmann (crisis de entropía de transición vítrea): Kauzmann/varios equipos la propusieron en 1948, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Kauzmann paradox (glass transition entropy crisis).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 Kauzmann 悖论 (玻璃转变熵危机) 是这样一个问题：「Kauzmann 悖论 (玻璃转变熵危机)」是 物理 领域的 玻璃 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Kauzmann 悖论 (玻璃转变熵危机)」是 物理 领域的 玻璃 方向。',
    formal: 'Kauzmann 悖论 (玻璃转变熵危机)（Kauzmann paradox (glass transition entropy crisis)）：Kauzmann / 多团队 在 1948 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'カウズマンパラドックス（ガラス転移エントロピー危機） ：カウズマン/マルチチームは1948年に、関連する実験/理論が完全に解決されていないと提案した。',
    formalEs: 'Paradoja de Kauzmann (crisis de entropía de transición vítrea): Kauzmann/varios equipos la propusieron en 1948, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Kauzmann paradox (glass transition entropy crisis): proposed by Kauzmann / 多团队 in 1948; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['玻璃'],
  },
  {
    id: 'phys-arrhenius-nongaussian',
    category: 'physics',
    title: '玻璃弛豫的非阿伦尼乌斯行为',
    titleJa: 'ガラス弛緩のノンアレニウス挙動',
    titleEs: 'Comportamiento no Arrhenius de la relajación del vidrio: propuesto por Angell/múltiples equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Non-Arrhenius behavior of glass relaxation',
    year: 1990,
    proposer: 'Angell / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：玻璃弛豫的非阿伦尼乌斯行为。',
    summaryJa: '物理学の分野における特定の困難な問題：ガラス緩和の非アレニウス挙動。',
    summaryEs: 'Comportamiento no Arrhenius de la relajación del vidrio: propuesto por Angell/múltiples equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Non-Arrhenius behavior of glass relaxation.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 玻璃弛豫的非阿伦尼乌斯行为 的问题。它可以简单描述为 「玻璃弛豫的非阿伦尼乌斯行为」是 物理 领域的 玻璃 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「玻璃弛豫的非阿伦尼乌斯行为」是 物理 领域的 玻璃 方向。',
    formal: '玻璃弛豫的非阿伦尼乌斯行为（Non-Arrhenius behavior of glass relaxation）：Angell / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ガラス緩和の非アルレニウス挙動： Angell/Multiチームは1990年に提案し、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Comportamiento no Arrhenius de la relajación del vidrio: propuesto por Angell/múltiples equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Non-Arrhenius behavior of glass relaxation: proposed by Angell / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Angell / 多团队 等人在 1990 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['玻璃'],
  },
  {
    id: 'phys-turbulence',
    category: 'physics',
    title: '湍流的统计描述 (间歇性, 奇异性)',
    titleJa: '乱流の統計的説明（断続的、単数形）',
    titleEs: 'Descripción estadística de la turbulencia (intermitente, singularidad): propuesta por Kolmogorov/varios equipos en 1941, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Statistical description of turbulence',
    year: 1941,
    proposer: 'Kolmogorov / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：湍流的统计描述 (间歇性, 奇异性)。',
    summaryJa: '物理学の分野における特定の難題：乱流（断続性、特異点）の統計的記述。',
    summaryEs: 'Descripción estadística de la turbulencia (intermitente, singularidad): propuesta por Kolmogorov/varios equipos en 1941, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Statistical description of turbulence.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 湍流的统计描述 (间歇性, 奇异性) 是这样一个问题：「湍流的统计描述 (间歇性, 奇异性)」是 物理 领域的 湍流 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「湍流的统计描述 (间歇性, 奇异性)」是 物理 领域的 湍流 方向。',
    formal: '湍流的统计描述 (间歇性, 奇异性)（Statistical description of turbulence）：Kolmogorov / 多团队 在 1941 年提出，相关实验/理论至今未完全解决。',
    formalJa: '乱流（断続的、特異的）の統計的記述：コルモゴロフ/マルチチームは1941年に提案し、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Descripción estadística de la turbulencia (intermitente, singularidad): propuesta por Kolmogorov/varios equipos en 1941, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Statistical description of turbulence: proposed by Kolmogorov / 多团队 in 1941; related experiments/theory remain incomplete.',
    whyHard: '「湍流的统计描述 (间歇性, 奇异性)」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['湍流'],
  },
  {
    id: 'phys-navier-stokes',
    category: 'physics',
    title: 'Navier-Stokes 方程的奇点 (千禧年问题)',
    titleJa: 'Navier - Stokes方程式の特異点（ミレニアム問題）',
    titleEs: 'Singularidades de las ecuaciones de Navier-Stokes (Problema del Milenio): Propuestas por el Instituto Clay en 2000, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Singularities of Navier-Stokes equations',
    year: 2000,
    proposer: 'Clay Institute',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：Navier-Stokes 方程的奇点 (千禧年问题)。',
    summaryJa: '物理学の分野における特定の難題：ナビエ・ストークス方程式の特異点（ミレニアム問題）。',
    summaryEs: 'Singularidades de las ecuaciones de Navier-Stokes (Problema del Milenio): Propuestas por el Instituto Clay en 2000, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Singularities of Navier-Stokes equations.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 Navier-Stokes 方程的奇点 (千禧年问题) 的问题。它可以简单描述为 「Navier-Stokes 方程的奇点 (千禧年问题)」是 物理 领域的 湍流 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Navier-Stokes 方程的奇点 (千禧年问题)」是 物理 领域的 湍流 方向。',
    formal: 'Navier-Stokes 方程的奇点 (千禧年问题)（Singularities of Navier-Stokes equations）：Clay Institute 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Navier - Stokes方程式の特異点： 2000年にClay Instituteによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Singularidades de las ecuaciones de Navier-Stokes (Problema del Milenio): Propuestas por el Instituto Clay en 2000, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Singularities of Navier-Stokes equations: proposed by Clay Institute in 2000; related experiments/theory remain incomplete.',
    whyHard: '「Navier-Stokes 方程的奇点 (千禧年问题)」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['湍流'],
  },
  {
    id: 'phys-stochastic-quantum',
    category: 'physics',
    title: '量子与经典的边界 (collapse 模型)',
    titleJa: '量子と古典的境界（崩壊モデル）',
    titleEs: 'Límite clásico cuántico (modelos de colapso): propuesto por Ghirardi/Rimini/Weber/Penrose en 1986, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Quantum-classical boundary (collapse models)',
    year: 1986,
    proposer: 'Ghirardi / Rimini / Weber / Penrose',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：量子与经典的边界 (collapse 模型)。',
    summaryJa: '物理学の分野における特定の難題：量子と古典的境界（崩壊モデル）。',
    summaryEs: 'Límite clásico cuántico (modelos de colapso): propuesto por Ghirardi/Rimini/Weber/Penrose en 1986, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Quantum-classical boundary (collapse models).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 量子与经典的边界 (collapse 模型) 的核心问题是：「量子与经典的边界 (collapse 模型)」是 物理 领域的 量子 方向，涉及 量子, 基础 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「量子与经典的边界 (collapse 模型)」是 物理 领域的 量子 方向，涉及 量子, 基础 等方面。',
    formal: '量子与经典的边界 (collapse 模型)（Quantum-classical boundary (collapse models)）：Ghirardi / Rimini / Weber / Penrose 在 1986 年提出，相关实验/理论至今未完全解决。',
    formalJa: '量子古典境界（崩壊モデル） ： 1986年にGhirardi/Rimini/Weber/Penroseによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Límite clásico cuántico (modelos de colapso): propuesto por Ghirardi/Rimini/Weber/Penrose en 1986, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Quantum-classical boundary (collapse models): proposed by Ghirardi / Rimini / Weber / Penrose in 1986; related experiments/theory remain incomplete.',
    whyHard: '「量子与经典的边界 (collapse 模型)」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['量子', '基础'],
  },
  {
    id: 'phys-supersymmetry',
    category: 'physics',
    title: '超对称粒子 (SUSY) 的存在性',
    titleJa: '超対称粒子（ SUSY ）の存在',
    titleEs: 'Existencia de partículas supersimétricas (SUSY): Propuesta por Wess/Zumino/múltiples equipos en 1970, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Existence of supersymmetric particles',
    year: 1970,
    proposer: 'Wess / Zumino / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：超对称粒子 (SUSY) 的存在性。',
    summaryJa: '物理学の分野における特定の難題：超対称粒子（ SUSY ）の存在。',
    summaryEs: 'Existencia de partículas supersimétricas (SUSY): Propuesta por Wess/Zumino/múltiples equipos en 1970, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Existence of supersymmetric particles.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 超对称粒子 (SUSY) 的存在性 的问题。它可以简单描述为 「超对称粒子 (SUSY) 的存在性」是 物理 领域的 SUSY 方向，涉及 SUSY, BSM 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「超对称粒子 (SUSY) 的存在性」是 物理 领域的 SUSY 方向，涉及 SUSY, BSM 等方面。',
    formal: '超对称粒子 (SUSY) 的存在性（Existence of supersymmetric particles）：Wess / Zumino / 多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: '超対称粒子の存在（ SUSY ） ： 1970年に提唱されたWess/Zumino/multi - teamであり、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Existencia de partículas supersimétricas (SUSY): Propuesta por Wess/Zumino/múltiples equipos en 1970, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Existence of supersymmetric particles: proposed by Wess / Zumino / 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '尽管 Wess / Zumino / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SUSY', 'BSM'],
  },
  {
    id: 'phys-susy-naturalness',
    category: 'physics',
    title: '等级问题 / hierarchy problem',
    titleJa: '/hierarchyの問題',
    titleEs: 'Problema de jerarquía (Problema de jerarquía): propuesto por Susskind/múltiples equipos en 1975, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Hierarchy problem',
    year: 1975,
    proposer: 'Susskind / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：等级问题 / hierarchy problem。',
    summaryJa: '物理学の分野における特定の難しい問題：階層問題。',
    summaryEs: 'Problema de jerarquía (Problema de jerarquía): propuesto por Susskind/múltiples equipos en 1975, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Hierarchy problem.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 等级问题 / hierarchy problem 的核心问题是：「等级问题 / hierarchy problem」是 物理 领域的 等级 方向，涉及 等级, BSM 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「等级问题 / hierarchy problem」是 物理 领域的 等级 方向，涉及 等级, BSM 等方面。',
    formal: '等级问题 / hierarchy problem（Hierarchy problem）：Susskind / 多团队 在 1975 年提出，相关实验/理论至今未完全解决。',
    formalJa: '階層問題（ Hierarchy problem ） ：サスキンド/1975年に複数のチームが提案され、関連する実験/理論が完全に解決されていない。',
    formalEs: 'Problema de jerarquía (Problema de jerarquía): propuesto por Susskind/múltiples equipos en 1975, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Hierarchy problem: proposed by Susskind / 多团队 in 1975; related experiments/theory remain incomplete.',
    whyHard: '「等级问题 / hierarchy problem」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['等级', 'BSM'],
  },
  {
    id: 'phys-vacuum-stability',
    category: 'physics',
    title: '标准模型真空的稳定性 (Higgs 势)',
    titleJa: '標準型真空安定性（ヒッグス電位）',
    titleEs: 'Estabilidad del vacío del modelo estándar (potencial de Higgs): propuesto por Buttazzo/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Stability of the Standard Model vacuum',
    year: 2012,
    proposer: 'Buttazzo / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：标准模型真空的稳定性 (Higgs 势)。',
    summaryJa: '物理学の分野における特定の困難な問題：標準モデル真空の安定性（ヒッグスポテンシャル）。',
    summaryEs: 'Estabilidad del vacío del modelo estándar (potencial de Higgs): propuesto por Buttazzo/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Stability of the Standard Model vacuum.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 标准模型真空的稳定性 (Higgs 势) 是这样一个问题：「标准模型真空的稳定性 (Higgs 势)」是 物理 领域的 真空 方向，涉及 真空, Higgs 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「标准模型真空的稳定性 (Higgs 势)」是 物理 领域的 真空 方向，涉及 真空, Higgs 等方面。',
    formal: '标准模型真空的稳定性 (Higgs 势)（Stability of the Standard Model vacuum）：Buttazzo / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: '標準モデルの真空の安定性（ヒッグスポテンシャル） ： 2012年にButtazzo/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Estabilidad del vacío del modelo estándar (potencial de Higgs): propuesto por Buttazzo/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Stability of the Standard Model vacuum: proposed by Buttazzo / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '尽管 Buttazzo / 多团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['真空', 'Higgs'],
  },
  {
    id: 'phys-muonium-antimuonium',
    category: 'physics',
    title: 'μ 子素-反 μ 子素振荡的探测',
    titleJa: 'ミューオン-アンチムゾン振動の検出',
    titleEs: 'Búsqueda de oscilación de muonio-antimuonio (búsqueda de oscilación de muonio-antimuonio): propuesta por Feinberg / Weinberg / varios equipos en 1957, los experimentos / teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Muonium-antimuonium oscillation search',
    year: 1957,
    proposer: 'Feinberg / Weinberg / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：μ 子素-反 μ 子素振荡的探测。',
    summaryJa: '物理学の分野における特定の困難な問題：ミューオン対ミューオン元素の振動の検出。',
    summaryEs: 'Búsqueda de oscilación de muonio-antimuonio (búsqueda de oscilación de muonio-antimuonio): propuesta por Feinberg / Weinberg / varios equipos en 1957, los experimentos / teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Muonium-antimuonium oscillation search.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 μ 子素-反 μ 子素振荡的探测 的核心问题是：「μ 子素-反 μ 子素振荡的探测」是 物理 领域的 μ子 方向，涉及 μ子, 轻子 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「μ 子素-反 μ 子素振荡的探测」是 物理 领域的 μ子 方向，涉及 μ子, 轻子 等方面。',
    formal: 'μ 子素-反 μ 子素振荡的探测（Muonium-antimuonium oscillation search）：Feinberg / Weinberg / 多团队 在 1957 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ムオニウム-アンチムオニウム振動探索： 1957年にFeinberg/Weinberg/複数のチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Búsqueda de oscilación de muonio-antimuonio (búsqueda de oscilación de muonio-antimuonio): propuesta por Feinberg / Weinberg / varios equipos en 1957, los experimentos / teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Muonium-antimuonium oscillation search: proposed by Feinberg / Weinberg / 多团队 in 1957; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['μ子', '轻子'],
  },
  {
    id: 'phys-electron-edm',
    category: 'physics',
    title: '电子电偶极矩 (eEDM) 精确测量',
    titleJa: '電子ダイポールモーメント（ eEDM ）正確な測定',
    titleEs: 'Medición precisa del momento dipolar eléctrico del electrón (eEDM): propuesta por el equipo Purcell/Ramsey/ACME en 1950, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Precise measurement of electron EDM',
    year: 1950,
    proposer: 'Purcell / Ramsey / ACME 团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：电子电偶极矩 (eEDM) 精确测量。',
    summaryJa: '物理学の分野における特定の難題：電子双極子モーメント（ eEDM ）の正確な測定。',
    summaryEs: 'Medición precisa del momento dipolar eléctrico del electrón (eEDM): propuesta por el equipo Purcell/Ramsey/ACME en 1950, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Precise measurement of electron EDM.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 电子电偶极矩 (eEDM) 精确测量 的核心问题是：「电子电偶极矩 (eEDM) 精确测量」是 物理 领域的 CP 方向，涉及 CP, eEDM 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「电子电偶极矩 (eEDM) 精确测量」是 物理 领域的 CP 方向，涉及 CP, eEDM 等方面。',
    formal: '电子电偶极矩 (eEDM) 精确测量（Precise measurement of electron EDM）：Purcell / Ramsey / ACME 团队 在 1950 年提出，相关实验/理论至今未完全解决。',
    formalJa: '電子双極子モーメント（ eEDM ）の正確な測定（電子EDMの正確な測定） ： 1950年にPurcell/Ramsey/ACMEチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Medición precisa del momento dipolar eléctrico del electrón (eEDM): propuesta por el equipo Purcell/Ramsey/ACME en 1950, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Precise measurement of electron EDM: proposed by Purcell / Ramsey / ACME 团队 in 1950; related experiments/theory remain incomplete.',
    whyHard: '尽管 Purcell / Ramsey / ACME 团队 等人在过去几十年里推动了很多进展，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 这道问题仍然开放。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CP', 'eEDM'],
  },
  {
    id: 'phys-birefringence-vacuum',
    category: 'physics',
    title: '真空双折射 (QED 修正) 的实验探测',
    titleJa: '真空複屈折の実験的検出（ QED補正）',
    titleEs: 'Detección experimental de birrefringencia en el vacío (corrección QED): propuesta por Euler/Heisenberg/múltiples equipos en 1934, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Experimental detection of vacuum birefringence (QED correction)',
    year: 1934,
    proposer: 'Euler / Heisenberg / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：真空双折射 (QED 修正) 的实验探测。',
    summaryJa: '物理学の分野における特定の困難な問題：真空複屈折（ QED補正）の実験的検出。',
    summaryEs: 'Detección experimental de birrefringencia en el vacío (corrección QED): propuesta por Euler/Heisenberg/múltiples equipos en 1934, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Experimental detection of vacuum birefringence (QED correction).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 真空双折射 (QED 修正) 的实验探测 是这样一个问题：「真空双折射 (QED 修正) 的实验探测」是 物理 领域的 QED 方向，涉及 QED, 真空 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「真空双折射 (QED 修正) 的实验探测」是 物理 领域的 QED 方向，涉及 QED, 真空 等方面。',
    formal: '真空双折射 (QED 修正) 的实验探测（Experimental detection of vacuum birefringence (QED correction)）：Euler / Heisenberg / 多团队 在 1934 年提出，相关实验/理论至今未完全解决。',
    formalJa: '真空二重屈折の実験的検出（ QED補正） ： 1934年にEuler/Heisenberg/multi - teamによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Detección experimental de birrefringencia en el vacío (corrección QED): propuesta por Euler/Heisenberg/múltiples equipos en 1934, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Experimental detection of vacuum birefringence (QED correction): proposed by Euler / Heisenberg / 多团队 in 1934; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Euler / Heisenberg / 多团队 等人在 1934 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['QED', '真空'],
  },
  {
    id: 'phys-laser-cooling-limit',
    category: 'physics',
    title: '激光冷却的极限 (光子反冲)',
    titleJa: 'レーザー冷却の限界（光子反動）',
    titleEs: 'Límite de enfriamiento del láser (retroceso del fotón): propuesto por Phillips/Cohen-Tannoudji/Chu en 1988, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Limit of laser cooling (photon recoil)',
    year: 1988,
    proposer: 'Phillips / Cohen-Tannoudji / Chu',
    difficulty: 3,
    reward: 300,
    status: 'solved',
    summary: '一道 物理 领域的具体硬问题：激光冷却的极限 (光子反冲)。',
    summaryJa: '物理学の分野における特定の困難な問題：レーザー冷却の限界（光子反動）。',
    summaryEs: 'Límite de enfriamiento del láser (retroceso del fotón): propuesto por Phillips/Cohen-Tannoudji/Chu en 1988, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Limit of laser cooling (photon recoil).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 激光冷却的极限 (光子反冲)。它说的是 「激光冷却的极限 (光子反冲)」是 物理 领域的 激光 方向，涉及 激光, 超冷 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「激光冷却的极限 (光子反冲)」是 物理 领域的 激光 方向，涉及 激光, 超冷 等方面。',
    formal: '激光冷却的极限 (光子反冲)（Limit of laser cooling (photon recoil)）：Phillips / Cohen-Tannoudji / Chu 在 1988 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'レーザー冷却の限界（光子反動） ： Phillips/Cohen - Tannoudji/Chuは1988年に提案しており、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Límite de enfriamiento del láser (retroceso del fotón): propuesto por Phillips/Cohen-Tannoudji/Chu en 1988, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Limit of laser cooling (photon recoil): proposed by Phillips / Cohen-Tannoudji / Chu in 1988; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['激光', '超冷'],
  },
  {
    id: 'phys-cavity-cooling',
    category: 'physics',
    title: '腔内冷却 (cavity cooling) 的机理',
    titleJa: '空洞冷却機構',
    titleEs: 'Mecanismo de enfriamiento de la cavidad: propuesto por Koch y varios equipos en 2003, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Mechanism of cavity cooling',
    year: 2003,
    proposer: 'Koch / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：腔内冷却 (cavity cooling) 的机理。',
    summaryJa: '物理学の分野における特定の困難な問題：空洞冷却のメカニズム。',
    summaryEs: 'Mecanismo de enfriamiento de la cavidad: propuesto por Koch y varios equipos en 2003, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Mechanism of cavity cooling.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 腔内冷却 (cavity cooling) 的机理 是这样一个问题：「腔内冷却 (cavity cooling) 的机理」是 物理 领域的 腔 方向，涉及 腔, 超冷 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「腔内冷却 (cavity cooling) 的机理」是 物理 领域的 腔 方向，涉及 腔, 超冷 等方面。',
    formal: '腔内冷却 (cavity cooling) 的机理（Mechanism of cavity cooling）：Koch / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalJa: '空洞冷却のメカニズム： Koch/multi - teamは2003年に提案され、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de enfriamiento de la cavidad: propuesto por Koch y varios equipos en 2003, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Mechanism of cavity cooling: proposed by Koch / 多团队 in 2003; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Koch / 多团队 等人在 2003 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['腔', '超冷'],
  },
  {
    id: 'phys-anyonic-braiding',
    category: 'physics',
    title: '非阿贝尔任意子编织的明确实验演示',
    titleJa: '非アーベル任意織りの明示的な実験的実証',
    titleEs: 'Clara demostración experimental del trenzado Anyon no abeliano: Das Sarma/múltiples equipos propuestos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Clear experimental demonstration of non-Abelian anyon braiding',
    year: 2005,
    proposer: 'Das Sarma / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：非阿贝尔任意子编织的明确实验演示。',
    summaryJa: '物理学の分野における特定の困難な問題：非アーベル任意織りの明確な実験的実証。',
    summaryEs: 'Clara demostración experimental del trenzado Anyon no abeliano: Das Sarma/múltiples equipos propuestos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Clear experimental demonstration of non-Abelian anyon braiding.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 非阿贝尔任意子编织的明确实验演示 是这样一个问题：「非阿贝尔任意子编织的明确实验演示」是 物理 领域的 拓扑 方向，涉及 拓扑, 量子 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「非阿贝尔任意子编织的明确实验演示」是 物理 领域的 拓扑 方向，涉及 拓扑, 量子 等方面。',
    formal: '非阿贝尔任意子编织的明确实验演示（Clear experimental demonstration of non-Abelian anyon braiding）：Das Sarma / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: '非アベリアンアニオン編組の明確な実験的実証： Das Sarma/Multiチームは2005年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Clara demostración experimental del trenzado Anyon no abeliano: Das Sarma/múltiples equipos propuestos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Clear experimental demonstration of non-Abelian anyon braiding: proposed by Das Sarma / 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['拓扑', '量子'],
  },
  {
    id: 'phys-ito-ito-ito',
    category: 'physics',
    title: 'Ising 任意子 (ν=5/2 FQHE) 的编织统计',
    titleJa: 'Isingの任意の織り統計（ ν = 5/2 FQHE ）',
    titleEs: 'Estadísticas de trenzado de Ising anyons (ν = 5/2 FQHE): propuesto por Willett/varios equipos en 2009, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Braiding statistics of Ising anyons (ν=5/2 FQHE)',
    year: 2009,
    proposer: 'Willett / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：Ising 任意子 (ν=5/2 FQHE) 的编织统计。',
    summaryJa: '物理学の分野における特定の困難な問題： Isingの任意の織り統計（ ν = 5/2 FQHE ）。',
    summaryEs: 'Estadísticas de trenzado de Ising anyons (ν = 5/2 FQHE): propuesto por Willett/varios equipos en 2009, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Braiding statistics of Ising anyons (ν=5/2 FQHE).',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 Ising 任意子 (ν=5/2 FQHE) 的编织统计 的核心问题是：「Ising 任意子 (ν=5/2 FQHE) 的编织统计」是 物理 领域的 FQHE 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Ising 任意子 (ν=5/2 FQHE) 的编织统计」是 物理 领域的 FQHE 方向。',
    formal: 'Ising 任意子 (ν=5/2 FQHE) 的编织统计（Braiding statistics of Ising anyons (ν=5/2 FQHE)）：Willett / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Ising anyons （ ν = 5/2 FQHE ）の編組統計： Willett/Multiple teamsは2009年に提案され、関連する実験/理論はこれまで完全には解決されていない。',
    formalEs: 'Estadísticas de trenzado de Ising anyons (ν = 5/2 FQHE): propuesto por Willett/varios equipos en 2009, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Braiding statistics of Ising anyons (ν=5/2 FQHE): proposed by Willett / 多团队 in 2009; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['FQHE'],
  },
  {
    id: 'phys-cep-sr86',
    category: 'physics',
    title: 'Sr-86 BEC 连续蒸发冷却的效率极限',
    titleJa: 'Sr -86 BEC連続蒸発冷却効率制限',
    titleEs: 'Límite de eficiencia del enfriamiento evaporativo continuo en Sr-86 BEC: propuesto por Stellmer/varios equipos en 2003, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Efficiency limit of continuous evaporative cooling in Sr-86 BEC',
    year: 2003,
    proposer: 'Stellmer / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：Sr-86 BEC 连续蒸发冷却的效率极限。',
    summaryJa: '物理学の分野における特定の困難な問題： Sr -86 BECの連続蒸発冷却の効率限界。',
    summaryEs: 'Límite de eficiencia del enfriamiento evaporativo continuo en Sr-86 BEC: propuesto por Stellmer/varios equipos en 2003, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Efficiency limit of continuous evaporative cooling in Sr-86 BEC.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 Sr-86 BEC 连续蒸发冷却的效率极限 是这样一个问题：「Sr-86 BEC 连续蒸发冷却的效率极限」是 物理 领域的 BEC 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Sr-86 BEC 连续蒸发冷却的效率极限」是 物理 领域的 BEC 方向。',
    formal: 'Sr-86 BEC 连续蒸发冷却的效率极限（Efficiency limit of continuous evaporative cooling in Sr-86 BEC）：Stellmer / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Sr -86 BECにおける連続蒸発冷却の効率限界： 2003年にStellmer/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Límite de eficiencia del enfriamiento evaporativo continuo en Sr-86 BEC: propuesto por Stellmer/varios equipos en 2003, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Efficiency limit of continuous evaporative cooling in Sr-86 BEC: proposed by Stellmer / 多团队 in 2003; related experiments/theory remain incomplete.',
    whyHard: '「Sr-86 BEC 连续蒸发冷却的效率极限」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['BEC'],
  },
  {
    id: 'phys-rogue-waves',
    category: 'physics',
    title: '怪波 (rogue waves) 的可预测性',
    titleJa: '不正な波の予測可能性',
    titleEs: 'Previsibilidad de las ondas rebeldes: Solli/múltiples equipos lo propusieron en 2007, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Predictability of rogue waves',
    year: 2007,
    proposer: 'Solli / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：怪波 (rogue waves) 的可预测性。',
    summaryJa: '物理学の分野における特定の困難な問題：不正な波の予測可能性。',
    summaryEs: 'Previsibilidad de las ondas rebeldes: Solli/múltiples equipos lo propusieron en 2007, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Predictability of rogue waves.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 怪波 (rogue waves) 的可预测性。它说的是 「怪波 (rogue waves) 的可预测性」是 物理 领域的 非线性 方向，涉及 非线性, 光学 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「怪波 (rogue waves) 的可预测性」是 物理 领域的 非线性 方向，涉及 非线性, 光学 等方面。',
    formal: '怪波 (rogue waves) 的可预测性（Predictability of rogue waves）：Solli / 多团队 在 2007 年提出，相关实验/理论至今未完全解决。',
    formalJa: '不正な波の予測可能性： Solli/Multiチームは、関連する実験/理論がまだ完全に解決されていないことを2007年に提案しました。',
    formalEs: 'Previsibilidad de las ondas rebeldes: Solli/múltiples equipos lo propusieron en 2007, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Predictability of rogue waves: proposed by Solli / 多团队 in 2007; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Solli / 多团队 等人在 2007 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['非线性', '光学'],
  },
  {
    id: 'phys-xenon-double-beta',
    category: 'physics',
    title: 'Xenon-136 双 β 衰变精确半衰期',
    titleJa: 'キセノン-136二重ベータ崩壊の正確な半減期',
    titleEs: 'Vida media precisa de la desintegración doble beta del Xenón-136: propuesta por KamLAND-Zen/varios equipos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Precise half-life of Xenon-136 double beta decay',
    year: 2011,
    proposer: 'KamLAND-Zen / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：Xenon-136 双 β 衰变精确半衰期。',
    summaryJa: '物理学の分野における特定の困難な問題：キセノン136二重ベータ崩壊の正確な半減期。',
    summaryEs: 'Vida media precisa de la desintegración doble beta del Xenón-136: propuesta por KamLAND-Zen/varios equipos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Precise half-life of Xenon-136 double beta decay.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 Xenon-136 双 β 衰变精确半衰期。它说的是 「Xenon-136 双 β 衰变精确半衰期」是 物理 领域的 双β 方向，涉及 双β, 中微子 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Xenon-136 双 β 衰变精确半衰期」是 物理 领域的 双β 方向，涉及 双β, 中微子 等方面。',
    formal: 'Xenon-136 双 β 衰变精确半衰期（Precise half-life of Xenon-136 double beta decay）：KamLAND-Zen / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'キセノン-136二重ベータ崩壊の正確な半減期： 2011年にKamLAND - Zen/マルチチームチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Vida media precisa de la desintegración doble beta del Xenón-136: propuesta por KamLAND-Zen/varios equipos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Precise half-life of Xenon-136 double beta decay: proposed by KamLAND-Zen / 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['双β', '中微子'],
  },
  {
    id: 'phys-silicon-spin-qubit',
    category: 'physics',
    title: '硅自旋量子比特的两比特门保真度',
    titleJa: 'シリコンスピンキュービットの2ビットゲート忠実度',
    titleEs: 'Fidelidad de puerta de dos qubits en qubits de espín de silicio: propuesta por Veldhorst/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Two-qubit gate fidelity in silicon spin qubits',
    year: 2012,
    proposer: 'Veldhorst / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：硅自旋量子比特的两比特门保真度。',
    summaryJa: '物理学の分野における特定の難しい問題：シリコンスピン量子ビットの2ビットゲート忠実度。',
    summaryEs: 'Fidelidad de puerta de dos qubits en qubits de espín de silicio: propuesta por Veldhorst/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Two-qubit gate fidelity in silicon spin qubits.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 硅自旋量子比特的两比特门保真度 是这样一个问题：「硅自旋量子比特的两比特门保真度」是 物理 领域的 量子 方向，涉及 量子, 硅 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「硅自旋量子比特的两比特门保真度」是 物理 领域的 量子 方向，涉及 量子, 硅 等方面。',
    formal: '硅自旋量子比特的两比特门保真度（Two-qubit gate fidelity in silicon spin qubits）：Veldhorst / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'シリコンスピン量子ビットにおける2キュビットゲートの忠実度： 2012年にVeldhorst/Multiチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Fidelidad de puerta de dos qubits en qubits de espín de silicio: propuesta por Veldhorst/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Two-qubit gate fidelity in silicon spin qubits: proposed by Veldhorst / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Veldhorst / 多团队 等人在 2012 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['量子', '硅'],
  },
  {
    id: 'phys-thz-plasmon',
    category: 'physics',
    title: '太赫兹等离激元 (THz plasmon) 调制',
    titleJa: 'THzプラズモン変調',
    titleEs: 'Modulación de plasmones THz: propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Modulation of THz plasmons',
    year: 2010,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：太赫兹等离激元 (THz plasmon) 调制。',
    summaryJa: '物理学の分野における特定の困難な問題：テラヘルツプラズモン変調。',
    summaryEs: 'Modulación de plasmones THz: propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Modulation of THz plasmons.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 太赫兹等离激元 (THz plasmon) 调制 的问题。它可以简单描述为 「太赫兹等离激元 (THz plasmon) 调制」是 物理 领域的 THz 方向，涉及 THz, 等离激元 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「太赫兹等离激元 (THz plasmon) 调制」是 物理 领域的 THz 方向，涉及 THz, 等离激元 等方面。',
    formal: '太赫兹等离激元 (THz plasmon) 调制（Modulation of THz plasmons）：多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'THzプラズモンのTHzプラズモンの変調： 2010年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Modulación de plasmones THz: propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Modulation of THz plasmons: proposed by 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 2010 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['THz', '等离激元'],
  },
  {
    id: 'phys-magnon-bose-einstein',
    category: 'physics',
    title: '磁振子 BEC 的实验实现',
    titleJa: '磁気発振器BECの実験的実現',
    titleEs: 'Realización experimental del magnón BEC: propuesto por Demokritov/múltiples equipos en 2006, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Experimental realization of magnon BEC',
    year: 2006,
    proposer: 'Demokritov / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：磁振子 BEC 的实验实现。',
    summaryJa: '物理学の分野における特定の難題：磁気発振器BECの実験的実現。',
    summaryEs: 'Realización experimental del magnón BEC: propuesto por Demokritov/múltiples equipos en 2006, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Experimental realization of magnon BEC.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 磁振子 BEC 的实验实现 是这样一个问题：「磁振子 BEC 的实验实现」是 物理 领域的 BEC 方向，涉及 BEC, 磁振子 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「磁振子 BEC 的实验实现」是 物理 领域的 BEC 方向，涉及 BEC, 磁振子 等方面。',
    formal: '磁振子 BEC 的实验实现（Experimental realization of magnon BEC）：Demokritov / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'マグノンBECの実験的実現： Demokritov/マルチチームは、関連する実験/理論がまだ完全に解決されていないことを2006年に提案しました。',
    formalEs: 'Realización experimental del magnón BEC: propuesto por Demokritov/múltiples equipos en 2006, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Experimental realization of magnon BEC: proposed by Demokritov / 多团队 in 2006; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Demokritov / 多团队 等人在 2006 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['BEC', '磁振子'],
  },
  {
    id: 'phys-cavity-polariton',
    category: 'physics',
    title: '腔极化激元 (polariton) BEC 与超流',
    titleJa: 'キャビティポラリトンBECとスーパーフロー',
    titleEs: 'Cavidad polariton BEC y superfluidez: Kasprzak/varios equipos lo propusieron en 2006, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Cavity polariton BEC and superfluidity',
    year: 2006,
    proposer: 'Kasprzak / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：腔极化激元 (polariton) BEC 与超流。',
    summaryJa: '物理学の分野における特定の困難な問題：キャビティポラリトンBECとスーパーフロー。',
    summaryEs: 'Cavidad polariton BEC y superfluidez: Kasprzak/varios equipos lo propusieron en 2006, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Cavity polariton BEC and superfluidity.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 腔极化激元 (polariton) BEC 与超流 的问题。它可以简单描述为 「腔极化激元 (polariton) BEC 与超流」是 物理 领域的 极化激元 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「腔极化激元 (polariton) BEC 与超流」是 物理 领域的 极化激元 方向。',
    formal: '腔极化激元 (polariton) BEC 与超流（Cavity polariton BEC and superfluidity）：Kasprzak / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalJa: '空洞ポラリトンBECと超流動性： 2006年にKasprzak/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Cavidad polariton BEC y superfluidez: Kasprzak/varios equipos lo propusieron en 2006, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Cavity polariton BEC and superfluidity: proposed by Kasprzak / 多团队 in 2006; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Kasprzak / 多团队 等人在 2006 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['极化激元'],
  },
  {
    id: 'phys-polariton-bose',
    category: 'physics',
    title: '极化激元 BEC 室温运行',
    titleJa: '室温でのポラリメタルBEC動作',
    titleEs: 'Operación BEC de polariton a temperatura ambiente: propuesta por Plumhof/varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Room-temperature polariton BEC operation',
    year: 2013,
    proposer: 'Plumhof / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：极化激元 BEC 室温运行。',
    summaryJa: '物理学の分野における特定の困難な問題：室温での偏波励起BEC動作。',
    summaryEs: 'Operación BEC de polariton a temperatura ambiente: propuesta por Plumhof/varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Room-temperature polariton BEC operation.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 极化激元 BEC 室温运行 的核心问题是：「极化激元 BEC 室温运行」是 物理 领域的 极化激元 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「极化激元 BEC 室温运行」是 物理 领域的 极化激元 方向。',
    formal: '极化激元 BEC 室温运行（Room-temperature polariton BEC operation）：Plumhof / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalJa: '室温ポラリトンBEC運転： 2013年にPlumhof/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Operación BEC de polariton a temperatura ambiente: propuesta por Plumhof/varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Room-temperature polariton BEC operation: proposed by Plumhof / 多团队 in 2013; related experiments/theory remain incomplete.',
    whyHard: '「极化激元 BEC 室温运行」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['极化激元'],
  },
  {
    id: 'phys-laser-wakefield-100gev',
    category: 'physics',
    title: '激光尾场加速器 TeV 电子束',
    titleJa: 'レーザーテールフィールドアクセラレータTeV電子ビーム',
    titleEs: 'Haz de electrones TeV del acelerador de campo de estela láser (LWFA que alcanza haces de electrones TeV): propuesto por varios equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'LWFA reaching TeV electron beams',
    year: 2004,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 物理 领域的具体硬问题：激光尾场加速器 TeV 电子束。',
    summaryJa: '物理学の分野における特定の困難な問題：レーザーテールフィールドアクセラレータTeV電子ビーム。',
    summaryEs: 'Haz de electrones TeV del acelerador de campo de estela láser (LWFA que alcanza haces de electrones TeV): propuesto por varios equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: LWFA reaching TeV electron beams.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 激光尾场加速器 TeV 电子束 的核心问题是：「激光尾场加速器 TeV 电子束」是 物理 领域的 加速器 方向，涉及 加速器, 激光 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「激光尾场加速器 TeV 电子束」是 物理 领域的 加速器 方向，涉及 加速器, 激光 等方面。',
    formal: '激光尾场加速器 TeV 电子束（LWFA reaching TeV electron beams）：多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'レーザーウェイクフィールド加速器TeV電子ビーム（ TeV電子ビームに到達するLWFA ） ： 2004年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Haz de electrones TeV del acelerador de campo de estela láser (LWFA que alcanza haces de electrones TeV): propuesto por varios equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'LWFA reaching TeV electron beams: proposed by 多团队 in 2004; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['加速器', '激光'],
  },
  {
    id: 'phys-plasma-wakefield',
    category: 'physics',
    title: '等离子尾场加速器品质',
    titleJa: 'プラズマテールフィールドアクセラレータ品質',
    titleEs: 'Calidad de los aceleradores de plasma de wakefield: propuestos por Blumenfeld/múltiples equipos en 2007, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Quality of plasma wakefield accelerators',
    year: 2007,
    proposer: 'Blumenfeld / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：等离子尾场加速器品质。',
    summaryJa: '物理学の分野における特定の難題：プラズマテールフィールドアクセラレータの品質。',
    summaryEs: 'Calidad de los aceleradores de plasma de wakefield: propuestos por Blumenfeld/múltiples equipos en 2007, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Quality of plasma wakefield accelerators.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这是一道关于 等离子尾场加速器品质 的问题。它可以简单描述为 「等离子尾场加速器品质」是 物理 领域的 加速器 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「等离子尾场加速器品质」是 物理 领域的 加速器 方向。',
    formal: '等离子尾场加速器品质（Quality of plasma wakefield accelerators）：Blumenfeld / 多团队 在 2007 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'プラズマウェイクフィールド加速器の品質： 2007年にBlumenfeld/MultiTeamによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Calidad de los aceleradores de plasma de wakefield: propuestos por Blumenfeld/múltiples equipos en 2007, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Quality of plasma wakefield accelerators: proposed by Blumenfeld / 多团队 in 2007; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Blumenfeld / 多团队 等人在 2007 年提出，但至今未完全解决。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['加速器'],
  },
  {
    id: 'mat-roomtemp-sc-hydride',
    category: 'materials',
    title: '室温常压超导材料',
    titleJa: '常温大気超電導材料',
    titleEs: 'Superconductor de presión ambiental a temperatura ambiente: propuesto por Drozdov/Eremets/varios equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Room-temperature ambient-pressure superconductor',
    year: 2015,
    proposer: 'Drozdov / Eremets / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：室温常压超导材料。',
    summaryJa: '材料分野における特定の難題：室温大気超伝導材料。',
    summaryEs: 'Superconductor de presión ambiental a temperatura ambiente: propuesto por Drozdov/Eremets/varios equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Room-temperature ambient-pressure superconductor.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 室温常压超导材料。它说的是 「室温常压超导材料」是 材料 领域的 超导 方向，涉及 超导, 氢化物 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「室温常压超导材料」是 材料 领域的 超导 方向，涉及 超导, 氢化物 等方面。',
    formal: '室温常压超导材料（Room-temperature ambient-pressure superconductor）：Drozdov / Eremets / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: '室温周囲圧力超伝導体： Drozdov/Eremets/複数のチームが2015年に提案され、関連する実験/理論が完全に解決されていない。',
    formalEs: 'Superconductor de presión ambiental a temperatura ambiente: propuesto por Drozdov/Eremets/varios equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Room-temperature ambient-pressure superconductor: proposed by Drozdov / Eremets / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '「室温常压超导材料」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超导', '氢化物'],
  },
  {
    id: 'mat-cubic-h3s',
    category: 'physics',
    title: 'H3S 超导 200 K 的完整相图',
    titleJa: 'H 3 S超電導200 Kの完全な位相図',
    titleEs: 'Diagrama de fase completo del superconductor H3S 200K: Drozdov/varios equipos lo propusieron en 2015, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Complete phase diagram of H3S 200K superconductor',
    year: 2015,
    proposer: 'Drozdov / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'partially_solved',
    summary: '一道 物理 领域的具体硬问题：H3S 超导 200 K 的完整相图。',
    summaryJa: '物理学の分野における特定の困難な問題： H 3 S超電導200 Kの完全な位相図。',
    summaryEs: 'Diagrama de fase completo del superconductor H3S 200K: Drozdov/varios equipos lo propusieron en 2015, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in physics: Complete phase diagram of H3S 200K superconductor.',
    kid: '想象你在一个很冷很冷的实验室里，看着看不见的粒子在高速运动。 这就是 H3S 超导 200 K 的完整相图。它说的是 「H3S 超导 200 K 的完整相图」是 物理 领域的 超导 方向，涉及 超导, 氢 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「H3S 超导 200 K 的完整相图」是 物理 领域的 超导 方向，涉及 超导, 氢 等方面。',
    formal: 'H3S 超导 200 K 的完整相图（Complete phase diagram of H3S 200K superconductor）：Drozdov / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'H 3 S 200 K超伝導体の完全な位相図： Drozdov/マルチチームは2015年に提案され、関連する実験/理論はこれまで完全には解決されていません。',
    formalEs: 'Diagrama de fase completo del superconductor H3S 200K: Drozdov/varios equipos lo propusieron en 2015, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Complete phase diagram of H3S 200K superconductor: proposed by Drozdov / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '「H3S 超导 200 K 的完整相图」是 物理 领域一个被广泛认可的核心难题。它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '它涉及多个物理分支的交叉，从量子到相对论，实验上极难直接观测，理论上又需要统一框架。',
    aiPrompt: '你是一位严谨的物理学教授，向一个 12 岁的小朋友用比喻解释这道物理问题，然后给出形式化陈述、当前实验和理论状态、关键文献。',
    aiPromptEn: 'You are a rigorous 物理 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超导', '氢'],
  },
  {
    id: 'mat-ambient-hydride-sc',
    category: 'materials',
    title: '常压下 >0 °C 的氢化物超导',
    titleJa: '大気圧で> 0 ℃の水素化物超電導',
    titleEs: 'Superconductividad de hidruro por encima de 0 °C a presión ambiental: Dias/múltiples equipos (controversia) propuestos en 2022, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Hydride superconductivity above 0°C at ambient pressure',
    year: 2022,
    proposer: 'Dias / 多团队 (争议)',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：常压下 >0 °C 的氢化物超导。',
    summaryJa: '材料分野における特定の困難な問題：大気圧での水素化物超電導> 0 ℃。',
    summaryEs: 'Superconductividad de hidruro por encima de 0 °C a presión ambiental: Dias/múltiples equipos (controversia) propuestos en 2022, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Hydride superconductivity above 0°C at ambient pressure.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 常压下 >0 °C 的氢化物超导 是这样一个问题：「常压下 >0 °C 的氢化物超导」是 材料 领域的 超导 方向，涉及 超导, 氢 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「常压下 >0 °C 的氢化物超导」是 材料 领域的 超导 方向，涉及 超导, 氢 等方面。',
    formal: '常压下 >0 °C 的氢化物超导（Hydride superconductivity above 0°C at ambient pressure）：Dias / 多团队 (争议) 在 2022 年提出，相关实验/理论至今未完全解决。',
    formalJa: '大気圧下の周囲圧で0 ℃を超える水素化超電導： 2022年にDIAS/マルチチーム（物議を醸している）が提案され、これまでのところ関連する実験/理論は完全に解決されていません。',
    formalEs: 'Superconductividad de hidruro por encima de 0 °C a presión ambiental: Dias/múltiples equipos (controversia) propuestos en 2022, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Hydride superconductivity above 0°C at ambient pressure: proposed by Dias / 多团队 (争议) in 2022; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超导', '氢'],
  },
  {
    id: 'mat-lao-sto-mechanism',
    category: 'materials',
    title: 'LaAlO3/SrTiO3 界面 2DEG 的起源',
    titleJa: 'LaAlO 3/SrTiO 3インターフェース2 DEGの起源',
    titleEs: 'Origen de 2DEG en la interfaz LaAlO3/SrTiO3: propuesto por Ohtomo/Hwang en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Origin of 2DEG at LaAlO3/SrTiO3 interface',
    year: 2004,
    proposer: 'Ohtomo / Hwang',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：LaAlO3/SrTiO3 界面 2DEG 的起源。',
    summaryJa: '材料分野における特定の困難な問題： LaAlO 3/SrTiO 3インターフェース2 DEGの起源。',
    summaryEs: 'Origen de 2DEG en la interfaz LaAlO3/SrTiO3: propuesto por Ohtomo/Hwang en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Origin of 2DEG at LaAlO3/SrTiO3 interface.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 LaAlO3/SrTiO3 界面 2DEG 的起源。它说的是 「LaAlO3/SrTiO3 界面 2DEG 的起源」是 材料 领域的 氧化物 方向，涉及 氧化物, 界面 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「LaAlO3/SrTiO3 界面 2DEG 的起源」是 材料 领域的 氧化物 方向，涉及 氧化物, 界面 等方面。',
    formal: 'LaAlO3/SrTiO3 界面 2DEG 的起源（Origin of 2DEG at LaAlO3/SrTiO3 interface）：Ohtomo / Hwang 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'LaAlO 3/SrTiO 3インターフェースLaAlO 3/SrTiO 3インターフェースにおける2 DEGの起源： 2004年にOhtomo/Hwangによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Origen de 2DEG en la interfaz LaAlO3/SrTiO3: propuesto por Ohtomo/Hwang en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Origin of 2DEG at LaAlO3/SrTiO3 interface: proposed by Ohtomo / Hwang in 2004; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['氧化物', '界面'],
  },
  {
    id: 'mat-roomtemp-ferri-semi',
    category: 'materials',
    title: '室温铁磁半导体 (自旋电子学核心)',
    titleJa: '室温強磁性半導体（スピントロニクスコア）',
    titleEs: 'Semiconductor ferromagnético a temperatura ambiente (núcleo de la espintrónica): propuesto por Dietl/Ohno/varios equipos en 2000, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Room-temperature ferromagnetic semiconductor',
    year: 2000,
    proposer: 'Dietl / Ohno / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：室温铁磁半导体 (自旋电子学核心)。',
    summaryJa: '材料分野における特定の難題：室温強磁性半導体（スピントロニクスコア）。',
    summaryEs: 'Semiconductor ferromagnético a temperatura ambiente (núcleo de la espintrónica): propuesto por Dietl/Ohno/varios equipos en 2000, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Room-temperature ferromagnetic semiconductor.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 室温铁磁半导体 (自旋电子学核心) 的核心问题是：「室温铁磁半导体 (自旋电子学核心)」是 材料 领域的 自旋 方向，涉及 自旋, 半导体 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「室温铁磁半导体 (自旋电子学核心)」是 材料 领域的 自旋 方向，涉及 自旋, 半导体 等方面。',
    formal: '室温铁磁半导体 (自旋电子学核心)（Room-temperature ferromagnetic semiconductor）：Dietl / Ohno / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '室温強磁性半導体（スピントロニクスコア） ： 2000年にDietl/Ohno/マルチチームが提案され、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Semiconductor ferromagnético a temperatura ambiente (núcleo de la espintrónica): propuesto por Dietl/Ohno/varios equipos en 2000, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Room-temperature ferromagnetic semiconductor: proposed by Dietl / Ohno / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自旋', '半导体'],
  },
  {
    id: 'mat-topological-thermal',
    category: 'materials',
    title: '拓扑热电材料 (高 ZT)',
    titleJa: 'トポロジー熱電材料（高ZT ）',
    titleEs: 'Materiales termoeléctricos topológicos con alto ZT (materiales termoeléctricos topológicos con alto ZT): propuestos por Xu/varios equipos en 2016, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Topological thermoelectric materials with high ZT',
    year: 2016,
    proposer: 'Xu / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：拓扑热电材料 (高 ZT)。',
    summaryJa: '材料の分野における特定の困難な問題：トポロジー熱電材料（高ZT ）。',
    summaryEs: 'Materiales termoeléctricos topológicos con alto ZT (materiales termoeléctricos topológicos con alto ZT): propuestos por Xu/varios equipos en 2016, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Topological thermoelectric materials with high ZT.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 拓扑热电材料 (高 ZT) 的问题。它可以简单描述为 「拓扑热电材料 (高 ZT)」是 材料 领域的 拓扑 方向，涉及 拓扑, 热电 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「拓扑热电材料 (高 ZT)」是 材料 领域的 拓扑 方向，涉及 拓扑, 热电 等方面。',
    formal: '拓扑热电材料 (高 ZT)（Topological thermoelectric materials with high ZT）：Xu / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    formalJa: '高ZTの位相熱電材料（ Topological thermoelectric materials with high ZT ） ： Xu/multi - teamは2016年に、これまでのところ関連する実験/理論が完全に解決されていないことを提案した。',
    formalEs: 'Materiales termoeléctricos topológicos con alto ZT (materiales termoeléctricos topológicos con alto ZT): propuestos por Xu/varios equipos en 2016, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Topological thermoelectric materials with high ZT: proposed by Xu / 多团队 in 2016; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Xu / 多团队 等人在 2016 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['拓扑', '热电'],
  },
  {
    id: 'mat-perovskite-stability',
    category: 'materials',
    title: '钙钛矿太阳能电池 25 年稳定性',
    titleJa: 'ペロブスカイト太陽電池25年安定性',
    titleEs: 'Estabilidad de 25 años de las células solares de perovskita: propuesta por Miyasaka/Park/Snaith en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: '25-year stability of perovskite solar cells',
    year: 2009,
    proposer: 'Miyasaka / Park / Snaith',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：钙钛矿太阳能电池 25 年稳定性。',
    summaryJa: '材料分野における特定の困難な問題：ペロブスカイト太陽電池の25年間の安定性。',
    summaryEs: 'Estabilidad de 25 años de las células solares de perovskita: propuesta por Miyasaka/Park/Snaith en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: 25-year stability of perovskite solar cells.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 钙钛矿太阳能电池 25 年稳定性 的核心问题是：「钙钛矿太阳能电池 25 年稳定性」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 光伏 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「钙钛矿太阳能电池 25 年稳定性」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 光伏 等方面。',
    formal: '钙钛矿太阳能电池 25 年稳定性（25-year stability of perovskite solar cells）：Miyasaka / Park / Snaith 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ペロブスカイト系太陽電池の25年安定性： 2009年にMiyasaka/Park/Snaithが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Estabilidad de 25 años de las células solares de perovskita: propuesta por Miyasaka/Park/Snaith en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: '25-year stability of perovskite solar cells: proposed by Miyasaka / Park / Snaith in 2009; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿', '光伏'],
  },
  {
    id: 'mat-perovskite-tandem',
    category: 'materials',
    title: '钙钛矿/硅叠层电池 >30% 效率 + 寿命',
    titleJa: 'ペロブスカイト/シリコン積層電池> 30%効率+寿命',
    titleEs: 'Batería en tándem de perovskita/Si >30 % de eficiencia + vida útil (Tándem de perovskita/Si >30 % de eficiencia + vida útil): propuesta por Snaith/varios equipos en 2015, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Perovskite/Si tandem >30% efficiency + lifetime',
    year: 2015,
    proposer: 'Snaith / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：钙钛矿/硅叠层电池 >30% 效率 + 寿命。',
    summaryJa: '材料の分野における特定の困難な問題：ペロブスカイト/シリコン積層電池> 30 ％の効率+寿命。',
    summaryEs: 'Batería en tándem de perovskita/Si >30 % de eficiencia + vida útil (Tándem de perovskita/Si >30 % de eficiencia + vida útil): propuesta por Snaith/varios equipos en 2015, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Perovskite/Si tandem >30% efficiency + lifetime.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 钙钛矿/硅叠层电池 >30% 效率 + 寿命 的问题。它可以简单描述为 「钙钛矿/硅叠层电池 >30% 效率 + 寿命」是 材料 领域的 叠层 方向，涉及 叠层, 光伏 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「钙钛矿/硅叠层电池 >30% 效率 + 寿命」是 材料 领域的 叠层 方向，涉及 叠层, 光伏 等方面。',
    formal: '钙钛矿/硅叠层电池 >30% 效率 + 寿命（Perovskite/Si tandem >30% efficiency + lifetime）：Snaith / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ペロブスカイト/Siタンデム電池> 30 ％の効率+寿命（ペロブスカイト/Siタンデム> 30 ％の効率+寿命） ： 2015年に提案されたスネイス/複数のチーム、および関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Batería en tándem de perovskita/Si >30 % de eficiencia + vida útil (Tándem de perovskita/Si >30 % de eficiencia + vida útil): propuesta por Snaith/varios equipos en 2015, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Perovskite/Si tandem >30% efficiency + lifetime: proposed by Snaith / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['叠层', '光伏'],
  },
  {
    id: 'mat-perovskite-pb-free',
    category: 'materials',
    title: '无铅钙钛矿太阳能电池 (>20%)',
    titleJa: '鉛フリーのペロブスカイト太陽電池（> 20 ％ ）',
    titleEs: 'Células solares de perovskita sin plomo (>20%) (células solares de perovskita sin plomo por encima del 20%): propuestas por Snaith/varios equipos en 2018, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Lead-free perovskite solar cells above 20%',
    year: 2018,
    proposer: 'Snaith / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：无铅钙钛矿太阳能电池 (>20%)。',
    summaryJa: '材料分野における特定の困難な問題：鉛フリーのペロブスカイト太陽電池（> 20 ％ ）。',
    summaryEs: 'Células solares de perovskita sin plomo (>20%) (células solares de perovskita sin plomo por encima del 20%): propuestas por Snaith/varios equipos en 2018, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Lead-free perovskite solar cells above 20%.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 无铅钙钛矿太阳能电池 (>20%) 的问题。它可以简单描述为 「无铅钙钛矿太阳能电池 (>20%)」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 无铅 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「无铅钙钛矿太阳能电池 (>20%)」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 无铅 等方面。',
    formal: '无铅钙钛矿太阳能电池 (>20%)（Lead-free perovskite solar cells above 20%）：Snaith / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    formalJa: '無鉛ペロブスカイト太陽電池（> 20 ％ ） （無鉛ペロブスカイト太陽電池が20 ％以上） ： 2018年にスネイス/複数のチームが提案され、関連する実験/理論はこれまでに完全に解決されていません。',
    formalEs: 'Células solares de perovskita sin plomo (>20%) (células solares de perovskita sin plomo por encima del 20%): propuestas por Snaith/varios equipos en 2018, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Lead-free perovskite solar cells above 20%: proposed by Snaith / 多团队 in 2018; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿', '无铅'],
  },
  {
    id: 'mat-mof-h2-storage',
    category: 'materials',
    title: 'MOF 室温储氢 (DOE 目标)',
    titleJa: 'MOF室温水素貯蔵（ DOEターゲット）',
    titleEs: 'Almacenamiento de hidrógeno a temperatura ambiente del MOF (objetivo del DOE): propuesto por Yaghi/múltiples equipos en 2003, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'MOF room-temperature hydrogen storage (DOE target)',
    year: 2003,
    proposer: 'Yaghi / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：MOF 室温储氢 (DOE 目标)。',
    summaryJa: '材料分野における特定の困難な問題： MOF室温水素貯蔵（ DOEターゲット）。',
    summaryEs: 'Almacenamiento de hidrógeno a temperatura ambiente del MOF (objetivo del DOE): propuesto por Yaghi/múltiples equipos en 2003, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: MOF room-temperature hydrogen storage (DOE target).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 MOF 室温储氢 (DOE 目标) 的核心问题是：「MOF 室温储氢 (DOE 目标)」是 材料 领域的 MOF 方向，涉及 MOF, 储氢 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「MOF 室温储氢 (DOE 目标)」是 材料 领域的 MOF 方向，涉及 MOF, 储氢 等方面。',
    formal: 'MOF 室温储氢 (DOE 目标)（MOF room-temperature hydrogen storage (DOE target)）：Yaghi / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'MOF室温水素貯蔵（ DOE目標） ： 2003年にYaghi/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Almacenamiento de hidrógeno a temperatura ambiente del MOF (objetivo del DOE): propuesto por Yaghi/múltiples equipos en 2003, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'MOF room-temperature hydrogen storage (DOE target): proposed by Yaghi / 多团队 in 2003; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MOF', '储氢'],
  },
  {
    id: 'mat-mof-co2',
    category: 'materials',
    title: 'MOF 高效 CO2 捕集 (湿气稳定性)',
    titleJa: 'MOF高効率CO 2回収（水分安定性）',
    titleEs: 'MOF para la captura eficiente de CO2 (estabilidad húmeda): propuesto por Yaghi/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'MOF for efficient CO2 capture (humid stability)',
    year: 2005,
    proposer: 'Yaghi / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：MOF 高效 CO2 捕集 (湿气稳定性)。',
    summaryJa: '材料分野における特定の困難な問題： MOF効率的なCO 2回収（水分安定性）。',
    summaryEs: 'MOF para la captura eficiente de CO2 (estabilidad húmeda): propuesto por Yaghi/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: MOF for efficient CO2 capture (humid stability).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 MOF 高效 CO2 捕集 (湿气稳定性) 的问题。它可以简单描述为 「MOF 高效 CO2 捕集 (湿气稳定性)」是 材料 领域的 MOF 方向，涉及 MOF, CO2 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「MOF 高效 CO2 捕集 (湿气稳定性)」是 材料 领域的 MOF 方向，涉及 MOF, CO2 等方面。',
    formal: 'MOF 高效 CO2 捕集 (湿气稳定性)（MOF for efficient CO2 capture (humid stability)）：Yaghi / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: '効率的なCO 2回収（湿潤安定性）のためのMOF ： 2005年にYaghi/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'MOF para la captura eficiente de CO2 (estabilidad húmeda): propuesto por Yaghi/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'MOF for efficient CO2 capture (humid stability): proposed by Yaghi / 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '「MOF 高效 CO2 捕集 (湿气稳定性)」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MOF', 'CO2'],
  },
  {
    id: 'mat-cof-single-crystal',
    category: 'materials',
    title: '共价有机框架 (COF) 单晶合成',
    titleJa: '共価有機フレームワーク（ COF ）単結晶合成',
    titleEs: 'Síntesis monocristalina de estructuras orgánicas covalentes (COF): propuesta por Yaghi/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Single crystal synthesis of covalent organic frameworks (COF)',
    year: 2005,
    proposer: 'Yaghi / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：共价有机框架 (COF) 单晶合成。',
    summaryJa: '材料分野における特定の困難な問題：共有結合有機フレームワーク（ COF ）単結晶合成。',
    summaryEs: 'Síntesis monocristalina de estructuras orgánicas covalentes (COF): propuesta por Yaghi/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Single crystal synthesis of covalent organic frameworks (COF).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 共价有机框架 (COF) 单晶合成 的核心问题是：「共价有机框架 (COF) 单晶合成」是 材料 领域的 COF 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「共价有机框架 (COF) 单晶合成」是 材料 领域的 COF 方向。',
    formal: '共价有机框架 (COF) 单晶合成（Single crystal synthesis of covalent organic frameworks (COF)）：Yaghi / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: '共有有機フレームワーク（ COF ）の単結晶合成： 2005年にYaghi/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Síntesis monocristalina de estructuras orgánicas covalentes (COF): propuesta por Yaghi/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Single crystal synthesis of covalent organic frameworks (COF): proposed by Yaghi / 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '尽管 Yaghi / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['COF'],
  },
  {
    id: 'mat-ssb-solid-state',
    category: 'materials',
    title: '全固态电池界面阻抗',
    titleJa: 'フルソリッドステートバッテリーインターフェースインピーダンス',
    titleEs: 'Impedancia interfacial en baterías totalmente de estado sólido: propuesta por Janek/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Interfacial impedance in all-solid-state batteries',
    year: 2010,
    proposer: 'Janek / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：全固态电池界面阻抗。',
    summaryJa: '材料分野における特定の困難な問題：全ソリッドステートバッテリーのインターフェースインピーダンス。',
    summaryEs: 'Impedancia interfacial en baterías totalmente de estado sólido: propuesta por Janek/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Interfacial impedance in all-solid-state batteries.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 全固态电池界面阻抗。它说的是 「全固态电池界面阻抗」是 材料 领域的 电池 方向，涉及 电池, 固态 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「全固态电池界面阻抗」是 材料 领域的 电池 方向，涉及 电池, 固态 等方面。',
    formal: '全固态电池界面阻抗（Interfacial impedance in all-solid-state batteries）：Janek / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '全固体電池の界面インピーダンス： Janek/マルチチームは、関連する実験/理論がまだ完全に解決されていないことを2010年に提案しました。',
    formalEs: 'Impedancia interfacial en baterías totalmente de estado sólido: propuesta por Janek/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Interfacial impedance in all-solid-state batteries: proposed by Janek / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Janek / 多团队 等人在 2010 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['电池', '固态'],
  },
  {
    id: 'mat-li-s-shuttle',
    category: 'materials',
    title: '锂硫电池多硫化物穿梭效应抑制',
    titleJa: 'リチウム硫黄電池ポリ硫化物シャトル効果阻害',
    titleEs: 'Supresión de la lanzadera de polisulfuro en baterías Li-S: propuesta por Nazar/varios equipos en 2009, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Suppressing polysulfide shuttle in Li-S batteries',
    year: 2009,
    proposer: 'Nazar / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：锂硫电池多硫化物穿梭效应抑制。',
    summaryJa: '材料分野における特定の困難な問題：リチウム硫黄電池のポリ硫化物シャトル効果の阻害。',
    summaryEs: 'Supresión de la lanzadera de polisulfuro en baterías Li-S: propuesta por Nazar/varios equipos en 2009, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Suppressing polysulfide shuttle in Li-S batteries.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 锂硫电池多硫化物穿梭效应抑制 是这样一个问题：「锂硫电池多硫化物穿梭效应抑制」是 材料 领域的 电池 方向，涉及 电池, 硫 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「锂硫电池多硫化物穿梭效应抑制」是 材料 领域的 电池 方向，涉及 电池, 硫 等方面。',
    formal: '锂硫电池多硫化物穿梭效应抑制（Suppressing polysulfide shuttle in Li-S batteries）：Nazar / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Li - S電池におけるポリスルフィドシャトルの抑制： Nazar/Multiチームは2009年に提案し、関連する実験/理論はこれまで完全には解決されていません。',
    formalEs: 'Supresión de la lanzadera de polisulfuro en baterías Li-S: propuesta por Nazar/varios equipos en 2009, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Suppressing polysulfide shuttle in Li-S batteries: proposed by Nazar / 多团队 in 2009; related experiments/theory remain incomplete.',
    whyHard: '尽管 Nazar / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['电池', '硫'],
  },
  {
    id: 'mat-li-air',
    category: 'materials',
    title: '锂空气电池实际能量密度',
    titleJa: 'リチウム空気電池の実際のエネルギー密度',
    titleEs: 'Densidad de energía práctica de las baterías de Li-aire: propuesta por Abraham/varios equipos en 1996, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Practical energy density of Li-air batteries',
    year: 1996,
    proposer: 'Abraham / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：锂空气电池实际能量密度。',
    summaryJa: '材料分野における特定の困難な問題：リチウム空気電池の実際のエネルギー密度。',
    summaryEs: 'Densidad de energía práctica de las baterías de Li-aire: propuesta por Abraham/varios equipos en 1996, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Practical energy density of Li-air batteries.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 锂空气电池实际能量密度 的核心问题是：「锂空气电池实际能量密度」是 材料 领域的 电池 方向，涉及 电池, 锂 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「锂空气电池实际能量密度」是 材料 领域的 电池 方向，涉及 电池, 锂 等方面。',
    formal: '锂空气电池实际能量密度（Practical energy density of Li-air batteries）：Abraham / 多团队 在 1996 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'リチウムエアバッテリーの実用的なエネルギー密度：エイブラハム/マルチチームは1996年に提案され、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Densidad de energía práctica de las baterías de Li-aire: propuesta por Abraham/varios equipos en 1996, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Practical energy density of Li-air batteries: proposed by Abraham / 多团队 in 1996; related experiments/theory remain incomplete.',
    whyHard: '「锂空气电池实际能量密度」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['电池', '锂'],
  },
  {
    id: 'mat-na-ion',
    category: 'materials',
    title: '钠离子电池长寿命正极材料',
    titleJa: 'ナトリウムイオン電池長寿命正極材料',
    titleEs: 'Cátodo de larga duración para baterías de iones de sodio: propuesto por Hwang/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Long-life cathode for sodium-ion batteries',
    year: 2010,
    proposer: 'Hwang / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：钠离子电池长寿命正极材料。',
    summaryJa: 'ナトリウムイオン電池用長寿命正極材料。',
    summaryEs: 'Cátodo de larga duración para baterías de iones de sodio: propuesto por Hwang/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Long-life cathode for sodium-ion batteries.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 钠离子电池长寿命正极材料。它说的是 「钠离子电池长寿命正极材料」是 材料 领域的 电池 方向，涉及 电池, 钠 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「钠离子电池长寿命正极材料」是 材料 领域的 电池 方向，涉及 电池, 钠 等方面。',
    formal: '钠离子电池长寿命正极材料（Long-life cathode for sodium-ion batteries）：Hwang / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ナトリウムイオン電池の長寿命カソード： Hwang/Multiチームは2010年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Cátodo de larga duración para baterías de iones de sodio: propuesto por Hwang/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Long-life cathode for sodium-ion batteries: proposed by Hwang / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Hwang / 多团队 等人在 2010 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['电池', '钠'],
  },
  {
    id: 'mat-graphene-industrial',
    category: 'materials',
    title: '石墨烯工业级大规模生产',
    titleJa: 'グラフェンの工業量産',
    titleEs: 'Producción de grafeno a escala industrial: propuesta por Geim/varios equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Industrial-scale graphene production',
    year: 2004,
    proposer: 'Geim / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：石墨烯工业级大规模生产。',
    summaryJa: '材料分野における特定の困難な問題：グラフェンの工業グレードの大量生産。',
    summaryEs: 'Producción de grafeno a escala industrial: propuesta por Geim/varios equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Industrial-scale graphene production.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 石墨烯工业级大规模生产。它说的是 「石墨烯工业级大规模生产」是 材料 领域的 石墨烯 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「石墨烯工业级大规模生产」是 材料 领域的 石墨烯 方向。',
    formal: '石墨烯工业级大规模生产（Industrial-scale graphene production）：Geim / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: '工業規模のグラフェン生産： 2004年にGEIM/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Producción de grafeno a escala industrial: propuesta por Geim/varios equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Industrial-scale graphene production: proposed by Geim / 多团队 in 2004; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Geim / 多团队 等人在 2004 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['石墨烯'],
  },
  {
    id: 'mat-gan-p-type',
    category: 'materials',
    title: '氮化镓 (GaN) 高质量 p 型掺杂',
    titleJa: 'GaN高品質p型ドーピング',
    titleEs: 'Dopaje de GaN tipo p de alta calidad: propuesto por Amano/Akasaki/múltiples equipos en 1986, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'High-quality p-type doping of GaN',
    year: 1986,
    proposer: 'Amano / Akasaki / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'solved',
    summary: '一道 材料 领域的具体硬问题：氮化镓 (GaN) 高质量 p 型掺杂。',
    summaryJa: '材料分野における特定の困難な問題：高品質の窒化ガリウム（ GaN ）のp型ドーピング。',
    summaryEs: 'Dopaje de GaN tipo p de alta calidad: propuesto por Amano/Akasaki/múltiples equipos en 1986, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: High-quality p-type doping of GaN.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 氮化镓 (GaN) 高质量 p 型掺杂 是这样一个问题：「氮化镓 (GaN) 高质量 p 型掺杂」是 材料 领域的 半导体 方向，涉及 半导体, GaN 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「氮化镓 (GaN) 高质量 p 型掺杂」是 材料 领域的 半导体 方向，涉及 半导体, GaN 等方面。',
    formal: '氮化镓 (GaN) 高质量 p 型掺杂（High-quality p-type doping of GaN）：Amano / Akasaki / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'GaNの高品質p型ドーピング： 1986年にAmano/Akasaki/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Dopaje de GaN tipo p de alta calidad: propuesto por Amano/Akasaki/múltiples equipos en 1986, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'High-quality p-type doping of GaN: proposed by Amano / Akasaki / 多团队 in 1986; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['半导体', 'GaN'],
  },
  {
    id: 'mat-gan-2deg',
    category: 'materials',
    title: 'GaN 高电子迁移率晶体管 (HEMT) 击穿电压极限',
    titleJa: 'GaN高電子移動度トランジスタ（ HEMT ）ブレイクダウン電圧リミット',
    titleEs: 'Límite de voltaje de ruptura del transistor de alta movilidad de electrones (HEMT) de GaN (límite de voltaje de ruptura de GaN HEMT): propuesto por Khan/varios equipos en 1993, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Breakdown voltage limit of GaN HEMT',
    year: 1993,
    proposer: 'Khan / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：GaN 高电子迁移率晶体管 (HEMT) 击穿电压极限。',
    summaryJa: '材料分野における特定の困難な問題： GaN高電子移動度トランジスタ（ HEMT ）の破壊電圧制限。',
    summaryEs: 'Límite de voltaje de ruptura del transistor de alta movilidad de electrones (HEMT) de GaN (límite de voltaje de ruptura de GaN HEMT): propuesto por Khan/varios equipos en 1993, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Breakdown voltage limit of GaN HEMT.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 GaN 高电子迁移率晶体管 (HEMT) 击穿电压极限 的核心问题是：「GaN 高电子迁移率晶体管 (HEMT) 击穿电压极限」是 材料 领域的 GaN 方向，涉及 GaN, 功率 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「GaN 高电子迁移率晶体管 (HEMT) 击穿电压极限」是 材料 领域的 GaN 方向，涉及 GaN, 功率 等方面。',
    formal: 'GaN 高电子迁移率晶体管 (HEMT) 击穿电压极限（Breakdown voltage limit of GaN HEMT）：Khan / 多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＧａＮ ＨＥＭＴのＧａＮ高電子移動度トランジスタ（ ＨＥＭＴ ）ブレイクダウン電圧限界： Ｋｈａｎ ／マルチチームは１ ９ ９ ３年に提案され、関連する実験／理論はこれまで完全には解決されていない。',
    formalEs: 'Límite de voltaje de ruptura del transistor de alta movilidad de electrones (HEMT) de GaN (límite de voltaje de ruptura de GaN HEMT): propuesto por Khan/varios equipos en 1993, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Breakdown voltage limit of GaN HEMT: proposed by Khan / 多团队 in 1993; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['GaN', '功率'],
  },
  {
    id: 'mat-sic-power',
    category: 'materials',
    title: 'SiC 功率器件衬底缺陷密度',
    titleJa: 'SiCパワーデバイス基板欠陥密度',
    titleEs: 'Densidad de defectos de los sustratos de dispositivos de potencia de SiC: propuesta por varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Defect density of SiC power device substrates',
    year: 1990,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：SiC 功率器件衬底缺陷密度。',
    summaryJa: '材料分野における特定の困難な問題： SiCパワーデバイス基板の欠陥密度。',
    summaryEs: 'Densidad de defectos de los sustratos de dispositivos de potencia de SiC: propuesta por varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Defect density of SiC power device substrates.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 SiC 功率器件衬底缺陷密度 的核心问题是：「SiC 功率器件衬底缺陷密度」是 材料 领域的 SiC 方向，涉及 SiC, 功率 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「SiC 功率器件衬底缺陷密度」是 材料 领域的 SiC 方向，涉及 SiC, 功率 等方面。',
    formal: 'SiC 功率器件衬底缺陷密度（Defect density of SiC power device substrates）：多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'SiCパワーデバイス基板の欠陥密度（ SiCパワーデバイス基板の欠陥密度） ： 1990年に複数のチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Densidad de defectos de los sustratos de dispositivos de potencia de SiC: propuesta por varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Defect density of SiC power device substrates: proposed by 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '「SiC 功率器件衬底缺陷密度」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SiC', '功率'],
  },
  {
    id: 'mat-ga2o3-ohmic',
    category: 'materials',
    title: '氧化镓 (Ga2O3) 欧姆接触',
    titleJa: '酸化ガリウム（ Ga 2 O 3 ）オーム接触',
    titleEs: 'Óxido de galio (Ga2O3) Contactos óhmicos con Ga2O3: propuesto por Higashiwaki/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Ohmic contacts to Ga2O3',
    year: 2012,
    proposer: 'Higashiwaki / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：氧化镓 (Ga2O3) 欧姆接触。',
    summaryJa: '材料分野における特定の困難な問題：酸化ガリウム（ Ga 2 O 3 ）のオーム接触。',
    summaryEs: 'Óxido de galio (Ga2O3) Contactos óhmicos con Ga2O3: propuesto por Higashiwaki/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Ohmic contacts to Ga2O3.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 氧化镓 (Ga2O3) 欧姆接触 的问题。它可以简单描述为 「氧化镓 (Ga2O3) 欧姆接触」是 材料 领域的 Ga2O3 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「氧化镓 (Ga2O3) 欧姆接触」是 材料 领域的 Ga2O3 方向。',
    formal: '氧化镓 (Ga2O3) 欧姆接触（Ohmic contacts to Ga2O3）：Higashiwaki / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Ga 2 O 3への酸化ガリウム（ Ga 2 O 3 ）オーム接触： 2012年に提案されたHigashiwaki/Multiチームでは、これまでのところ関連する実験/理論は完全に解決されていません。',
    formalEs: 'Óxido de galio (Ga2O3) Contactos óhmicos con Ga2O3: propuesto por Higashiwaki/múltiples equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Ohmic contacts to Ga2O3: proposed by Higashiwaki / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '尽管 Higashiwaki / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['Ga2O3'],
  },
  {
    id: 'mat-diamond-doping',
    category: 'materials',
    title: '金刚石半导体 n 型掺杂',
    titleJa: 'ダイヤモンド半導体n型ドーピング',
    titleEs: 'Dopaje tipo n de semiconductores de diamante: propuesto por Koizumi/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'n-type doping of diamond semiconductor',
    year: 2005,
    proposer: 'Koizumi / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：金刚石半导体 n 型掺杂。',
    summaryJa: '材料分野における特定の難題：ダイヤモンド半導体のn型ドーピング。',
    summaryEs: 'Dopaje tipo n de semiconductores de diamante: propuesto por Koizumi/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: n-type doping of diamond semiconductor.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 金刚石半导体 n 型掺杂 的核心问题是：「金刚石半导体 n 型掺杂」是 材料 领域的 金刚石 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「金刚石半导体 n 型掺杂」是 材料 领域的 金刚石 方向。',
    formal: '金刚石半导体 n 型掺杂（n-type doping of diamond semiconductor）：Koizumi / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ダイヤモンド半導体のn型ドーピング： 2005年に提案された小泉/マルチチーム、および関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Dopaje tipo n de semiconductores de diamante: propuesto por Koizumi/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'n-type doping of diamond semiconductor: proposed by Koizumi / 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Koizumi / 多团队 等人在 2005 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['金刚石'],
  },
  {
    id: 'mat-cbn-synthesis',
    category: 'materials',
    title: '立方氮化硼 (c-BN) 单晶大尺寸生长',
    titleJa: '立方窒化ホウ素（ c - BN ）単結晶大型成長',
    titleEs: 'Gran crecimiento monocristalino de nitruro de boro cúbico (c-BN): propuesto por Wentorf/múltiples equipos en 1957, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Large single crystal growth of cubic boron nitride (c-BN)',
    year: 1957,
    proposer: 'Wentorf / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：立方氮化硼 (c-BN) 单晶大尺寸生长。',
    summaryJa: '材料分野における特定の困難な問題：立方窒化ホウ素（ c - BN ）単結晶大型成長。',
    summaryEs: 'Gran crecimiento monocristalino de nitruro de boro cúbico (c-BN): propuesto por Wentorf/múltiples equipos en 1957, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Large single crystal growth of cubic boron nitride (c-BN).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 立方氮化硼 (c-BN) 单晶大尺寸生长 的问题。它可以简单描述为 「立方氮化硼 (c-BN) 单晶大尺寸生长」是 材料 领域的 c-BN 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「立方氮化硼 (c-BN) 单晶大尺寸生长」是 材料 领域的 c-BN 方向。',
    formal: '立方氮化硼 (c-BN) 单晶大尺寸生长（Large single crystal growth of cubic boron nitride (c-BN)）：Wentorf / 多团队 在 1957 年提出，相关实验/理论至今未完全解决。',
    formalJa: '立方窒化ホウ素（ c - BN ）の大単結晶成長： 1957年にWentorf/Multi - Teamによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Gran crecimiento monocristalino de nitruro de boro cúbico (c-BN): propuesto por Wentorf/múltiples equipos en 1957, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Large single crystal growth of cubic boron nitride (c-BN): proposed by Wentorf / 多团队 in 1957; related experiments/theory remain incomplete.',
    whyHard: '「立方氮化硼 (c-BN) 单晶大尺寸生长」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['c-BN'],
  },
  {
    id: 'mat-2d-ferro',
    category: 'materials',
    title: '二维铁电材料 (In2Se3, SnTe) 室温',
    titleJa: '2 D強誘電体材料（ In 2 Se 3、SnTe ）室温',
    titleEs: 'Materiales ferroeléctricos bidimensionales (In2Se3, SnTe) a temperatura ambiente (materiales ferroeléctricos 2D a temperatura ambiente): propuestos por Chang/varios equipos en 2016, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: '2D ferroelectric materials at room temperature',
    year: 2016,
    proposer: 'Chang / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：二维铁电材料 (In2Se3, SnTe) 室温。',
    summaryJa: '材料分野における特定の難題：二次元強誘電体材料（ In 2 Se 3、SnTe ）の室温。',
    summaryEs: 'Materiales ferroeléctricos bidimensionales (In2Se3, SnTe) a temperatura ambiente (materiales ferroeléctricos 2D a temperatura ambiente): propuestos por Chang/varios equipos en 2016, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: 2D ferroelectric materials at room temperature.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 二维铁电材料 (In2Se3, SnTe) 室温 的问题。它可以简单描述为 「二维铁电材料 (In2Se3, SnTe) 室温」是 材料 领域的 2D 方向，涉及 2D, 铁电 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「二维铁电材料 (In2Se3, SnTe) 室温」是 材料 领域的 2D 方向，涉及 2D, 铁电 等方面。',
    formal: '二维铁电材料 (In2Se3, SnTe) 室温（2D ferroelectric materials at room temperature）：Chang / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    formalJa: '室温での2 D強誘電体材料（ In 2 Se 3、SnTe ） ： 2016年にChang/マルチチームが提案され、これまでのところ関連する実験/理論は完全に解決されていません。',
    formalEs: 'Materiales ferroeléctricos bidimensionales (In2Se3, SnTe) a temperatura ambiente (materiales ferroeléctricos 2D a temperatura ambiente): propuestos por Chang/varios equipos en 2016, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: '2D ferroelectric materials at room temperature: proposed by Chang / 多团队 in 2016; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Chang / 多团队 等人在 2016 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['2D', '铁电'],
  },
  {
    id: 'mat-tmd-monolayer',
    category: 'materials',
    title: '过渡金属硫族化物 (TMD) 单层晶圆级生长',
    titleJa: '遷移金属カルコゲン化物（ TMD ）単層ウェーハレベルの成長',
    titleEs: 'Crecimiento a escala de oblea de monocapas TMD: propuesto por varios equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Wafer-scale growth of TMD monolayers',
    year: 2012,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：过渡金属硫族化物 (TMD) 单层晶圆级生长。',
    summaryJa: '材料分野における特定の困難な問題：遷移金属カルコゲニド（ TMD ）の単層ウェーハレベルの成長。',
    summaryEs: 'Crecimiento a escala de oblea de monocapas TMD: propuesto por varios equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Wafer-scale growth of TMD monolayers.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 过渡金属硫族化物 (TMD) 单层晶圆级生长 的问题。它可以简单描述为 「过渡金属硫族化物 (TMD) 单层晶圆级生长」是 材料 领域的 TMD 方向，涉及 TMD, 2D 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「过渡金属硫族化物 (TMD) 单层晶圆级生长」是 材料 领域的 TMD 方向，涉及 TMD, 2D 等方面。',
    formal: '过渡金属硫族化物 (TMD) 单层晶圆级生长（Wafer-scale growth of TMD monolayers）：多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'TMD単層の遷移金属カルコゲニド（ TMD ）単層ウェーハスケール成長： 2012年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Crecimiento a escala de oblea de monocapas TMD: propuesto por varios equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Wafer-scale growth of TMD monolayers: proposed by 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['TMD', '2D'],
  },
  {
    id: 'mat-mxene-thermal',
    category: 'materials',
    title: 'MXenes 的长期稳定性 (氧化)',
    titleJa: 'MXenesの長期安定性（酸化）',
    titleEs: 'Estabilidad a largo plazo de MXenes (oxidación): Naguib/múltiples equipos propuestos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Long-term stability of MXenes (oxidation)',
    year: 2011,
    proposer: 'Naguib / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：MXenes 的长期稳定性 (氧化)。',
    summaryJa: '材料分野における特定の困難な問題： MXenesの長期安定性（酸化）。',
    summaryEs: 'Estabilidad a largo plazo de MXenes (oxidación): Naguib/múltiples equipos propuestos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Long-term stability of MXenes (oxidation).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 MXenes 的长期稳定性 (氧化)。它说的是 「MXenes 的长期稳定性 (氧化)」是 材料 领域的 MXene 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「MXenes 的长期稳定性 (氧化)」是 材料 领域的 MXene 方向。',
    formal: 'MXenes 的长期稳定性 (氧化)（Long-term stability of MXenes (oxidation)）：Naguib / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'MXenesの長期安定性（酸化） ： Naguib/マルチチームは2011年に提案され、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Estabilidad a largo plazo de MXenes (oxidación): Naguib/múltiples equipos propuestos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Long-term stability of MXenes (oxidation): proposed by Naguib / 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '「MXenes 的长期稳定性 (氧化)」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MXene'],
  },
  {
    id: 'mat-bp-fet',
    category: 'materials',
    title: '黑磷场效应管 (空气中稳定)',
    titleJa: '黒リン場効果チューブ（空気中で安定）',
    titleEs: 'FET de fósforo negro (estabilidad del aire): propuesto por Li/varios equipos en 2014, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Black phosphorus FET (air stability)',
    year: 2014,
    proposer: 'Li / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：黑磷场效应管 (空气中稳定)。',
    summaryJa: '材料分野の特定の難題：黒リン電界効果チューブ（空気中で安定）。',
    summaryEs: 'FET de fósforo negro (estabilidad del aire): propuesto por Li/varios equipos en 2014, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Black phosphorus FET (air stability).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 黑磷场效应管 (空气中稳定) 的核心问题是：「黑磷场效应管 (空气中稳定)」是 材料 领域的 黑磷 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「黑磷场效应管 (空气中稳定)」是 材料 领域的 黑磷 方向。',
    formal: '黑磷场效应管 (空气中稳定)（Black phosphorus FET (air stability)）：Li / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    formalJa: '黒リン場効果チューブ（黒リンFET （空気安定性） ） ： 2014年にLi/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'FET de fósforo negro (estabilidad del aire): propuesto por Li/varios equipos en 2014, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Black phosphorus FET (air stability): proposed by Li / 多团队 in 2014; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['黑磷'],
  },
  {
    id: 'mat-hbn-substrate',
    category: 'materials',
    title: '六角氮化硼 (hBN) 大面积单晶生长',
    titleJa: '六角形窒化ホウ素（ hBN ）の大面積単結晶成長',
    titleEs: 'Crecimiento monocristalino de gran superficie de nitruro de boro hexagonal (hBN): propuesto por Watanabe/Taniguchi/múltiples equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Large-area single crystal growth of hexagonal boron nitride (hBN)',
    year: 2004,
    proposer: 'Watanabe / Taniguchi / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：六角氮化硼 (hBN) 大面积单晶生长。',
    summaryJa: '材料分野における特定の困難な問題：六角形窒化ホウ素（ hBN ）の大面積単結晶成長。',
    summaryEs: 'Crecimiento monocristalino de gran superficie de nitruro de boro hexagonal (hBN): propuesto por Watanabe/Taniguchi/múltiples equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Large-area single crystal growth of hexagonal boron nitride (hBN).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 六角氮化硼 (hBN) 大面积单晶生长。它说的是 「六角氮化硼 (hBN) 大面积单晶生长」是 材料 领域的 hBN 方向，涉及 hBN, 2D 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「六角氮化硼 (hBN) 大面积单晶生长」是 材料 领域的 hBN 方向，涉及 hBN, 2D 等方面。',
    formal: '六角氮化硼 (hBN) 大面积单晶生长（Large-area single crystal growth of hexagonal boron nitride (hBN)）：Watanabe / Taniguchi / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: '六角形窒化ホウ素（ hBN ）の大面積単結晶成長： 2004年に渡辺/谷口/複数チームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Crecimiento monocristalino de gran superficie de nitruro de boro hexagonal (hBN): propuesto por Watanabe/Taniguchi/múltiples equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Large-area single crystal growth of hexagonal boron nitride (hBN): proposed by Watanabe / Taniguchi / 多团队 in 2004; related experiments/theory remain incomplete.',
    whyHard: '尽管 Watanabe / Taniguchi / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['hBN', '2D'],
  },
  {
    id: 'mat-vdw-hetero',
    category: 'materials',
    title: '范德瓦尔斯异质结 (twistronics) 精确转角控制',
    titleJa: 'Van der Waalsツイストロニクス精密コーナーコントロール',
    titleEs: 'Control preciso del ángulo de torsión en heteroestructuras de van der Waals (twistrónica): propuesto por Geim/múltiples equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Precise twist-angle control in van der Waals heterostructures',
    year: 2013,
    proposer: 'Geim / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：范德瓦尔斯异质结 (twistronics) 精确转角控制。',
    summaryJa: '材料分野における特定の困難な問題：ファンデルワールス異種接合（ツイストロニクス）の正確な角制御。',
    summaryEs: 'Control preciso del ángulo de torsión en heteroestructuras de van der Waals (twistrónica): propuesto por Geim/múltiples equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Precise twist-angle control in van der Waals heterostructures.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 范德瓦尔斯异质结 (twistronics) 精确转角控制 是这样一个问题：「范德瓦尔斯异质结 (twistronics) 精确转角控制」是 材料 领域的 异质结 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「范德瓦尔斯异质结 (twistronics) 精确转角控制」是 材料 领域的 异质结 方向。',
    formal: '范德瓦尔斯异质结 (twistronics) 精确转角控制（Precise twist-angle control in van der Waals heterostructures）：Geim / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ファンデルワールスヘテロ構造（ツイストロニクス）における正確なツイストアングル制御： 2013年にGEIM/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Control preciso del ángulo de torsión en heteroestructuras de van der Waals (twistrónica): propuesto por Geim/múltiples equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Precise twist-angle control in van der Waals heterostructures: proposed by Geim / 多团队 in 2013; related experiments/theory remain incomplete.',
    whyHard: '「范德瓦尔斯异质结 (twistronics) 精确转角控制」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['异质结'],
  },
  {
    id: 'mat-2d-half-metal',
    category: 'materials',
    title: '二维半金属材料',
    titleJa: '2 Dセミメタルマテリアル',
    titleEs: 'Materiales semimetálicos 2D: propuestos por varios equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: '2D half-metallic materials',
    year: 2015,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：二维半金属材料。',
    summaryJa: '材料の分野における特定の困難な問題：二次元半金属材料。',
    summaryEs: 'Materiales semimetálicos 2D: propuestos por varios equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: 2D half-metallic materials.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 二维半金属材料 的问题。它可以简单描述为 「二维半金属材料」是 材料 领域的 2D 方向，涉及 2D, 半金属 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「二维半金属材料」是 材料 领域的 2D 方向，涉及 2D, 半金属 等方面。',
    formal: '二维半金属材料（2D half-metallic materials）：多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: '2 D半金属材料： 2015年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Materiales semimetálicos 2D: propuestos por varios equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: '2D half-metallic materials: proposed by 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['2D', '半金属'],
  },
  {
    id: 'mat-hea-design',
    category: 'materials',
    title: '高熵合金 (HEA) 的合理设计原则',
    titleJa: '高エントロピー合金（ HEA ）の合理的な設計原則',
    titleEs: 'Principios de diseño racional para aleaciones de alta entropía (HEA): propuestos por Cantor/Yeh/varios equipos en 2004, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Rational design principles for high-entropy alloys',
    year: 2004,
    proposer: 'Cantor / Yeh / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：高熵合金 (HEA) 的合理设计原则。',
    summaryJa: '材料分野における特定の難題：高エントロピー合金（ HEA ）の合理的な設計原理。',
    summaryEs: 'Principios de diseño racional para aleaciones de alta entropía (HEA): propuestos por Cantor/Yeh/varios equipos en 2004, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Rational design principles for high-entropy alloys.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 高熵合金 (HEA) 的合理设计原则 的核心问题是：「高熵合金 (HEA) 的合理设计原则」是 材料 领域的 HEA 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「高熵合金 (HEA) 的合理设计原则」是 材料 领域的 HEA 方向。',
    formal: '高熵合金 (HEA) 的合理设计原则（Rational design principles for high-entropy alloys）：Cantor / Yeh / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: '高エントロピー合金（ HEA ）の合理的設計原理： 2004年にCantor/Yeh/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Principios de diseño racional para aleaciones de alta entropía (HEA): propuestos por Cantor/Yeh/varios equipos en 2004, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Rational design principles for high-entropy alloys: proposed by Cantor / Yeh / 多团队 in 2004; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['HEA'],
  },
  {
    id: 'mat-quasicrystal-mech',
    category: 'materials',
    title: '准晶 (quasicrystal) 的形成机制',
    titleJa: '準結晶の形成機構',
    titleEs: 'Mecanismo de formación de cuasicristales: Shechtman y varios equipos lo propusieron en 1982, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Formation mechanism of quasicrystals',
    year: 1982,
    proposer: 'Shechtman / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：准晶 (quasicrystal) 的形成机制。',
    summaryJa: '材料分野における特定の困難な問題：準結晶の形成メカニズム。',
    summaryEs: 'Mecanismo de formación de cuasicristales: Shechtman y varios equipos lo propusieron en 1982, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Formation mechanism of quasicrystals.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 准晶 (quasicrystal) 的形成机制 的核心问题是：「准晶 (quasicrystal) 的形成机制」是 材料 领域的 准晶 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「准晶 (quasicrystal) 的形成机制」是 材料 领域的 准晶 方向。',
    formal: '准晶 (quasicrystal) 的形成机制（Formation mechanism of quasicrystals）：Shechtman / 多团队 在 1982 年提出，相关实验/理论至今未完全解决。',
    formalJa: '準結晶の形成メカニズム（準結晶の形成メカニズム） ：シェヒトマン/マルチチームは1982年に提案され、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de formación de cuasicristales: Shechtman y varios equipos lo propusieron en 1982, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Formation mechanism of quasicrystals: proposed by Shechtman / 多团队 in 1982; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['准晶'],
  },
  {
    id: 'mat-bmg-forming',
    category: 'materials',
    title: '非晶合金 (BMG) 大尺寸临界厚度',
    titleJa: '非晶質合金（ BMG ）大型臨界厚',
    titleEs: 'Tamaño crítico del vidrio metálico a granel (BMG): propuesto por Inoue/Johnson/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Critical size of bulk metallic glass (BMG)',
    year: 1990,
    proposer: 'Inoue / Johnson / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：非晶合金 (BMG) 大尺寸临界厚度。',
    summaryJa: '材料分野における特定の困難な問題：アモルファス合金（ BMG ）の大きなサイズの臨界厚さ。',
    summaryEs: 'Tamaño crítico del vidrio metálico a granel (BMG): propuesto por Inoue/Johnson/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Critical size of bulk metallic glass (BMG).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 非晶合金 (BMG) 大尺寸临界厚度 的核心问题是：「非晶合金 (BMG) 大尺寸临界厚度」是 材料 领域的 BMG 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「非晶合金 (BMG) 大尺寸临界厚度」是 材料 领域的 BMG 方向。',
    formal: '非晶合金 (BMG) 大尺寸临界厚度（Critical size of bulk metallic glass (BMG)）：Inoue / Johnson / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'バルクメタリックガラス（ BMG ）の臨界サイズ： 1990年に井上/ジョンソン/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Tamaño crítico del vidrio metálico a granel (BMG): propuesto por Inoue/Johnson/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Critical size of bulk metallic glass (BMG): proposed by Inoue / Johnson / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['BMG'],
  },
  {
    id: 'mat-ndfeb-temperature',
    category: 'materials',
    title: 'NdFeB 永磁高温 (200°C) 矫顽力稳定性',
    titleJa: 'NdFeB永久磁石高温（ 200 ℃）耐磁性安定性',
    titleEs: 'Estabilidad de coercitividad de imán permanente de NdFeB a alta temperatura (200 °C) (estabilidad de coercitividad de imanes de NdFeB a 200 °C): propuesta por Sagawa/varios equipos en 1984, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Coercivity stability of NdFeB magnets at 200°C',
    year: 1984,
    proposer: 'Sagawa / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：NdFeB 永磁高温 (200°C) 矫顽力稳定性。',
    summaryJa: '材料分野における特定の困難な問題： NdFeB永久磁石高温（ 200 ℃）の強制安定性。',
    summaryEs: 'Estabilidad de coercitividad de imán permanente de NdFeB a alta temperatura (200 °C) (estabilidad de coercitividad de imanes de NdFeB a 200 °C): propuesta por Sagawa/varios equipos en 1984, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Coercivity stability of NdFeB magnets at 200°C.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 NdFeB 永磁高温 (200°C) 矫顽力稳定性 是这样一个问题：「NdFeB 永磁高温 (200°C) 矫顽力稳定性」是 材料 领域的 永磁 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「NdFeB 永磁高温 (200°C) 矫顽力稳定性」是 材料 领域的 永磁 方向。',
    formal: 'NdFeB 永磁高温 (200°C) 矫顽力稳定性（Coercivity stability of NdFeB magnets at 200°C）：Sagawa / 多团队 在 1984 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＮｄＦｅＢ永久磁石高温（ ２ ０ ０ ℃） ２ ０ ０ ℃におけるＮｄＦｅＢ磁石の矯正安定性： １ ９ ８ ４年に佐川氏／マルチチームが提案されたが、これまでのところ関連する実験／理論は完全には解決されていない。',
    formalEs: 'Estabilidad de coercitividad de imán permanente de NdFeB a alta temperatura (200 °C) (estabilidad de coercitividad de imanes de NdFeB a 200 °C): propuesta por Sagawa/varios equipos en 1984, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Coercivity stability of NdFeB magnets at 200°C: proposed by Sagawa / 多团队 in 1984; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['永磁'],
  },
  {
    id: 'mat-smfen-magnet',
    category: 'materials',
    title: 'SmFeN 永磁材料 (>1.2 T 各向异性场)',
    titleJa: 'SmFeN永久磁石材料（> 1.2 T異方性磁場）',
    titleEs: 'Materiales de imán permanente SmFeN (campo anisotrópico> 1,2 T) (materiales de imán permanente SmFeN): propuestos por varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'SmFeN permanent magnet materials',
    year: 1990,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：SmFeN 永磁材料 (>1.2 T 各向异性场)。',
    summaryJa: '材料分野における特定の困難な問題： SmFeN永久磁石材料（> 1.2 T異方性磁場）。',
    summaryEs: 'Materiales de imán permanente SmFeN (campo anisotrópico> 1,2 T) (materiales de imán permanente SmFeN): propuestos por varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: SmFeN permanent magnet materials.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 SmFeN 永磁材料 (>1.2 T 各向异性场) 的问题。它可以简单描述为 「SmFeN 永磁材料 (>1.2 T 各向异性场)」是 材料 领域的 永磁 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「SmFeN 永磁材料 (>1.2 T 各向异性场)」是 材料 领域的 永磁 方向。',
    formal: 'SmFeN 永磁材料 (>1.2 T 各向异性场)（SmFeN permanent magnet materials）：多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'SmFeN永久磁石材料（> 1.2 T異方性磁場） ： 1990年に複数のチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Materiales de imán permanente SmFeN (campo anisotrópico> 1,2 T) (materiales de imán permanente SmFeN): propuestos por varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'SmFeN permanent magnet materials: proposed by 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 1990 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['永磁'],
  },
  {
    id: 'mat-nanocrystal-soft',
    category: 'materials',
    title: '纳米晶软磁材料高频损耗机制',
    titleJa: 'ナノ結晶軟磁性材料の高周波損失機構',
    titleEs: 'Mecanismo de pérdida de alta frecuencia de materiales magnéticos blandos nanocristalinos: propuesto por Yoshizawa/varios equipos en 1988, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'High-frequency loss mechanism of nanocrystalline soft magnetic materials',
    year: 1988,
    proposer: 'Yoshizawa / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：纳米晶软磁材料高频损耗机制。',
    summaryJa: '材料分野における特定の難題：ナノ結晶軟磁性材料の高周波損失メカニズム。',
    summaryEs: 'Mecanismo de pérdida de alta frecuencia de materiales magnéticos blandos nanocristalinos: propuesto por Yoshizawa/varios equipos en 1988, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: High-frequency loss mechanism of nanocrystalline soft magnetic materials.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 纳米晶软磁材料高频损耗机制。它说的是 「纳米晶软磁材料高频损耗机制」是 材料 领域的 软磁 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「纳米晶软磁材料高频损耗机制」是 材料 领域的 软磁 方向。',
    formal: '纳米晶软磁材料高频损耗机制（High-frequency loss mechanism of nanocrystalline soft magnetic materials）：Yoshizawa / 多团队 在 1988 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ナノ結晶軟磁性材料の高周波損失メカニズム： 1988年に吉沢/マルチチームが提案し、関連する実験/理論が完全に解決されていない。',
    formalEs: 'Mecanismo de pérdida de alta frecuencia de materiales magnéticos blandos nanocristalinos: propuesto por Yoshizawa/varios equipos en 1988, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'High-frequency loss mechanism of nanocrystalline soft magnetic materials: proposed by Yoshizawa / 多团队 in 1988; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['软磁'],
  },
  {
    id: 'mat-half-heusler',
    category: 'materials',
    title: '半 Heusler 合金热电性能 (ZT>1)',
    titleJa: 'セミヒューズラー合金の熱電特性（ ZT > 1 ）',
    titleEs: 'Rendimiento termoeléctrico de aleación Half-Heusler (ZT>1): propuesto por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Half-Heusler alloy thermoelectric performance',
    year: 2000,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：半 Heusler 合金热电性能 (ZT>1)。',
    summaryJa: '材料分野における特定の困難な問題：セミヒューズラー合金（ ZT > 1 ）の熱電特性。',
    summaryEs: 'Rendimiento termoeléctrico de aleación Half-Heusler (ZT>1): propuesto por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Half-Heusler alloy thermoelectric performance.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 半 Heusler 合金热电性能 (ZT>1) 是这样一个问题：「半 Heusler 合金热电性能 (ZT>1)」是 材料 领域的 热电 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「半 Heusler 合金热电性能 (ZT>1)」是 材料 领域的 热电 方向。',
    formal: '半 Heusler 合金热电性能 (ZT>1)（Half-Heusler alloy thermoelectric performance）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ハーフハウスラー合金熱電性能（ ZT > 1 ） ： 2000年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Rendimiento termoeléctrico de aleación Half-Heusler (ZT>1): propuesto por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Half-Heusler alloy thermoelectric performance: proposed by 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '「半 Heusler 合金热电性能 (ZT>1)」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['热电'],
  },
  {
    id: 'mat-skutterudite',
    category: 'materials',
    title: '方钴矿 (skutterudite) 热电填充',
    titleJa: 'Skutterudite熱電充填',
    titleEs: 'Materiales termoeléctricos de skutterudita rellenos: propuestos por Ventas/múltiples equipos en 1990, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Filled skutterudite thermoelectric materials',
    year: 1990,
    proposer: 'Sales / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：方钴矿 (skutterudite) 热电填充。',
    summaryJa: '材料分野における特定の困難な問題： skutteruditeの熱電充填。',
    summaryEs: 'Materiales termoeléctricos de skutterudita rellenos: propuestos por Ventas/múltiples equipos en 1990, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Filled skutterudite thermoelectric materials.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 方钴矿 (skutterudite) 热电填充 的问题。它可以简单描述为 「方钴矿 (skutterudite) 热电填充」是 材料 领域的 热电 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「方钴矿 (skutterudite) 热电填充」是 材料 领域的 热电 方向。',
    formal: '方钴矿 (skutterudite) 热电填充（Filled skutterudite thermoelectric materials）：Sales / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '充填されたskutterudite熱電材料： 1990年にセールス/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Materiales termoeléctricos de skutterudita rellenos: propuestos por Ventas/múltiples equipos en 1990, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Filled skutterudite thermoelectric materials: proposed by Sales / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '尽管 Sales / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['热电'],
  },
  {
    id: 'mat-zintl-thermo',
    category: 'materials',
    title: 'Zintl 相热电材料',
    titleJa: 'Zintl相熱電材料',
    titleEs: 'Materiales termoeléctricos de fase Zintl: propuestos por varios equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Zintl phase thermoelectric materials',
    year: 2005,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：Zintl 相热电材料。',
    summaryJa: '材料分野における特定の困難な問題： Zintl相熱電材料。',
    summaryEs: 'Materiales termoeléctricos de fase Zintl: propuestos por varios equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Zintl phase thermoelectric materials.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 Zintl 相热电材料 是这样一个问题：「Zintl 相热电材料」是 材料 领域的 热电 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Zintl 相热电材料」是 材料 领域的 热电 方向。',
    formal: 'Zintl 相热电材料（Zintl phase thermoelectric materials）：多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Zintl相熱電材料： 2005年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Materiales termoeléctricos de fase Zintl: propuestos por varios equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Zintl phase thermoelectric materials: proposed by 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['热电'],
  },
  {
    id: 'mat-cmr-mechanism',
    category: 'materials',
    title: '庞磁电阻 (CMR) 锰氧化物的机制',
    titleJa: '磁気抵抗（ CMR ）酸化マンガンのメカニズム',
    titleEs: 'Mecanismo de las manganitas de magnetorresistencia colosal (CMR): propuesto por von Helmolt / Millis / varios equipos en 1994, y los experimentos / teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Mechanism of colossal magnetoresistance (CMR) manganites',
    year: 1994,
    proposer: 'von Helmolt / Millis / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：庞磁电阻 (CMR) 锰氧化物的机制。',
    summaryJa: '材料分野における特定の困難な問題： CMRマンガン酸化物のメカニズム。',
    summaryEs: 'Mecanismo de las manganitas de magnetorresistencia colosal (CMR): propuesto por von Helmolt / Millis / varios equipos en 1994, y los experimentos / teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Mechanism of colossal magnetoresistance (CMR) manganites.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 庞磁电阻 (CMR) 锰氧化物的机制 是这样一个问题：「庞磁电阻 (CMR) 锰氧化物的机制」是 材料 领域的 CMR 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「庞磁电阻 (CMR) 锰氧化物的机制」是 材料 领域的 CMR 方向。',
    formal: '庞磁电阻 (CMR) 锰氧化物的机制（Mechanism of colossal magnetoresistance (CMR) manganites）：von Helmolt / Millis / 多团队 在 1994 年提出，相关实验/理论至今未完全解决。',
    formalJa: '巨大磁気抵抗（ CMR ）マンガナイトのメカニズム： 1994年にvon Helmolt/Millis/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Mecanismo de las manganitas de magnetorresistencia colosal (CMR): propuesto por von Helmolt / Millis / varios equipos en 1994, y los experimentos / teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Mechanism of colossal magnetoresistance (CMR) manganites: proposed by von Helmolt / Millis / 多团队 in 1994; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CMR'],
  },
  {
    id: 'mat-mram-speed',
    category: 'materials',
    title: '自旋转移力矩 MRAM (STT-MRAM) 切换速度极限',
    titleJa: 'スピントランスファートルクMRAM （ STT - MRAM ）スイッチング速度制限',
    titleEs: 'Límite de velocidad de conmutación de par de transferencia de giro MRAM (STT-MRAM) (límite de velocidad de conmutación STT-MRAM): propuesto por Slonczewski / Berger / varios equipos en 1996, y los experimentos / teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Speed limit of STT-MRAM switching',
    year: 1996,
    proposer: 'Slonczewski / Berger / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：自旋转移力矩 MRAM (STT-MRAM) 切换速度极限。',
    summaryJa: '材料分野の特定の難しい問題：スピントランスファートルクMRAM （ STT - MRAM ）スイッチング速度制限。',
    summaryEs: 'Límite de velocidad de conmutación de par de transferencia de giro MRAM (STT-MRAM) (límite de velocidad de conmutación STT-MRAM): propuesto por Slonczewski / Berger / varios equipos en 1996, y los experimentos / teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Speed limit of STT-MRAM switching.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 自旋转移力矩 MRAM (STT-MRAM) 切换速度极限 是这样一个问题：「自旋转移力矩 MRAM (STT-MRAM) 切换速度极限」是 材料 领域的 自旋 方向，涉及 自旋, 存储 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「自旋转移力矩 MRAM (STT-MRAM) 切换速度极限」是 材料 领域的 自旋 方向，涉及 自旋, 存储 等方面。',
    formal: '自旋转移力矩 MRAM (STT-MRAM) 切换速度极限（Speed limit of STT-MRAM switching）：Slonczewski / Berger / 多团队 在 1996 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'スピントランスファートルクMRAM （ STT - MRAM ） STT - MRAMスイッチングの速度制限： 1996年にSlonczewski/Berger/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Límite de velocidad de conmutación de par de transferencia de giro MRAM (STT-MRAM) (límite de velocidad de conmutación STT-MRAM): propuesto por Slonczewski / Berger / varios equipos en 1996, y los experimentos / teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Speed limit of STT-MRAM switching: proposed by Slonczewski / Berger / 多团队 in 1996; related experiments/theory remain incomplete.',
    whyHard: '尽管 Slonczewski / Berger / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自旋', '存储'],
  },
  {
    id: 'mat-sot-mram',
    category: 'materials',
    title: '自旋轨道力矩 MRAM (SOT-MRAM) 实用化',
    titleJa: 'スピン軌道トルクMRAM （ SOT - MRAM ）の実用化',
    titleEs: 'Dispositivos prácticos SOT-MRAM: Miron/varios equipos lo propusieron en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Practical SOT-MRAM devices',
    year: 2011,
    proposer: 'Miron / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：自旋轨道力矩 MRAM (SOT-MRAM) 实用化。',
    summaryJa: '材料分野における特定の難題：スピン軌道モーメントMRAM （ SOT - MRAM ）の実用化。',
    summaryEs: 'Dispositivos prácticos SOT-MRAM: Miron/varios equipos lo propusieron en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Practical SOT-MRAM devices.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 自旋轨道力矩 MRAM (SOT-MRAM) 实用化。它说的是 「自旋轨道力矩 MRAM (SOT-MRAM) 实用化」是 材料 领域的 自旋 方向，涉及 自旋, 存储 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「自旋轨道力矩 MRAM (SOT-MRAM) 实用化」是 材料 领域的 自旋 方向，涉及 自旋, 存储 等方面。',
    formal: '自旋轨道力矩 MRAM (SOT-MRAM) 实用化（Practical SOT-MRAM devices）：Miron / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'スピンオービタルモーメントMRAM （ SOT - MRAM ）実用的なSOT - MRAMデバイス： 2011年に提案されたMiron/マルチチーム、および関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Dispositivos prácticos SOT-MRAM: Miron/varios equipos lo propusieron en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Practical SOT-MRAM devices: proposed by Miron / 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自旋', '存储'],
  },
  {
    id: 'mat-mtj-tunnel',
    category: 'materials',
    title: '磁性隧道结 (MTJ) TMR 比室温极限',
    titleJa: '磁気トンネル接合部（ MTJ ） TMR比室温制限',
    titleEs: 'Límite TMR a temperatura ambiente de las uniones de túneles magnéticos (MTJ): propuesto por Miyazaki/Moodera/múltiples equipos en 1995, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Room-temperature TMR limit of magnetic tunnel junctions (MTJ)',
    year: 1995,
    proposer: 'Miyazaki / Moodera / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：磁性隧道结 (MTJ) TMR 比室温极限。',
    summaryJa: '材料分野における特定の困難な問題：室温での磁気トンネル接合（ MTJ ） TMR比の制限。',
    summaryEs: 'Límite TMR a temperatura ambiente de las uniones de túneles magnéticos (MTJ): propuesto por Miyazaki/Moodera/múltiples equipos en 1995, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Room-temperature TMR limit of magnetic tunnel junctions (MTJ).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 磁性隧道结 (MTJ) TMR 比室温极限 的问题。它可以简单描述为 「磁性隧道结 (MTJ) TMR 比室温极限」是 材料 领域的 自旋 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「磁性隧道结 (MTJ) TMR 比室温极限」是 材料 领域的 自旋 方向。',
    formal: '磁性隧道结 (MTJ) TMR 比室温极限（Room-temperature TMR limit of magnetic tunnel junctions (MTJ)）：Miyazaki / Moodera / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    formalJa: '磁気トンネル接合部（ MTJ ）の室温TMR限界： 1995年に宮崎/ムーデラ/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Límite TMR a temperatura ambiente de las uniones de túneles magnéticos (MTJ): propuesto por Miyazaki/Moodera/múltiples equipos en 1995, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Room-temperature TMR limit of magnetic tunnel junctions (MTJ): proposed by Miyazaki / Moodera / 多团队 in 1995; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自旋'],
  },
  {
    id: 'mat-mbe-gaas',
    category: 'materials',
    title: 'MBE 生长的 GaAs/AlGaAs 2DEG 高迁移率极限',
    titleJa: 'MBE成長GaAs/AlGaAs 2 DEG高モビリティリミット',
    titleEs: 'Límite de alta movilidad de GaAs/AlGaAs 2DEG cultivado en MBE (Límite de alta movilidad de GaAs/AlGaAs 2DEG cultivado en MBE): propuesto por Dingle/Stormer/múltiples equipos en 1978, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'High-mobility limit of MBE-grown GaAs/AlGaAs 2DEG',
    year: 1978,
    proposer: 'Dingle / Stormer / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：MBE 生长的 GaAs/AlGaAs 2DEG 高迁移率极限。',
    summaryJa: '材料分野における特定の困難な問題： MBEによって成長したGaAs/AlGaAs 2 DEG高モビリティリミット。',
    summaryEs: 'Límite de alta movilidad de GaAs/AlGaAs 2DEG cultivado en MBE (Límite de alta movilidad de GaAs/AlGaAs 2DEG cultivado en MBE): propuesto por Dingle/Stormer/múltiples equipos en 1978, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: High-mobility limit of MBE-grown GaAs/AlGaAs 2DEG.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 MBE 生长的 GaAs/AlGaAs 2DEG 高迁移率极限 的核心问题是：「MBE 生长的 GaAs/AlGaAs 2DEG 高迁移率极限」是 材料 领域的 2DEG 方向，涉及 2DEG, 半导体 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「MBE 生长的 GaAs/AlGaAs 2DEG 高迁移率极限」是 材料 领域的 2DEG 方向，涉及 2DEG, 半导体 等方面。',
    formal: 'MBE 生长的 GaAs/AlGaAs 2DEG 高迁移率极限（High-mobility limit of MBE-grown GaAs/AlGaAs 2DEG）：Dingle / Stormer / 多团队 在 1978 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'MBE成長GaAs/AlGaAs 2 DEG （ MBE成長GaAs/AlGaAs 2 DEGの高移動限界） ： 1978年に提案されたDingle/Stormer/multi - teamであり、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Límite de alta movilidad de GaAs/AlGaAs 2DEG cultivado en MBE (Límite de alta movilidad de GaAs/AlGaAs 2DEG cultivado en MBE): propuesto por Dingle/Stormer/múltiples equipos en 1978, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'High-mobility limit of MBE-grown GaAs/AlGaAs 2DEG: proposed by Dingle / Stormer / 多团队 in 1978; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['2DEG', '半导体'],
  },
  {
    id: 'mat-bismuthene',
    category: 'materials',
    title: '锑烯 (antimonene) 空气稳定性',
    titleJa: 'アンチモネン空気安定性',
    titleEs: 'Antimoneno Estabilidad del aire (Estabilidad del antimoneno en el aire): propuesto por Ares/varios equipos en 2015, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Air stability of antimonene',
    year: 2015,
    proposer: 'Ares / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：锑烯 (antimonene) 空气稳定性。',
    summaryJa: '材料分野における特定の困難な問題：アンチモネン空気の安定性。',
    summaryEs: 'Antimoneno Estabilidad del aire (Estabilidad del antimoneno en el aire): propuesto por Ares/varios equipos en 2015, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Air stability of antimonene.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 锑烯 (antimonene) 空气稳定性 的问题。它可以简单描述为 「锑烯 (antimonene) 空气稳定性」是 材料 领域的 2D 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「锑烯 (antimonene) 空气稳定性」是 材料 领域的 2D 方向。',
    formal: '锑烯 (antimonene) 空气稳定性（Air stability of antimonene）：Ares / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'アンチモネンアンチモネンの空気安定性： ARES/Multi - teamは2015年に提案され、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Antimoneno Estabilidad del aire (Estabilidad del antimoneno en el aire): propuesto por Ares/varios equipos en 2015, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Air stability of antimonene: proposed by Ares / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '「锑烯 (antimonene) 空气稳定性」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['2D'],
  },
  {
    id: 'mat-tmd-moiré',
    category: 'materials',
    title: '扭转 TMD 同质/异质结莫尔激子态',
    titleJa: '逆TMD均一/不均一接合モイレ励起状態',
    titleEs: 'Estados excitónicos de muaré en homo/heteroestructuras retorcidas de TMD: propuesto por Tran/múltiples equipos en 2019, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Moiré excitonic states in twisted TMD homo/heterostructures',
    year: 2019,
    proposer: 'Tran / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：扭转 TMD 同质/异质结莫尔激子态。',
    summaryJa: '材料分野における特定の困難な問題： TMD均一/不均一接合モアレエキシトン状態を逆転させる。',
    summaryEs: 'Estados excitónicos de muaré en homo/heteroestructuras retorcidas de TMD: propuesto por Tran/múltiples equipos en 2019, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Moiré excitonic states in twisted TMD homo/heterostructures.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 扭转 TMD 同质/异质结莫尔激子态 的核心问题是：「扭转 TMD 同质/异质结莫尔激子态」是 材料 领域的 TMD 方向，涉及 TMD, 莫尔 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「扭转 TMD 同质/异质结莫尔激子态」是 材料 领域的 TMD 方向，涉及 TMD, 莫尔 等方面。',
    formal: '扭转 TMD 同质/异质结莫尔激子态（Moiré excitonic states in twisted TMD homo/heterostructures）：Tran / 多团队 在 2019 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ねじれたTMDホモ/ヘテロ構造におけるモアレ興奮状態の逆転： 2019年に提案されたTran/複数のチーム、および関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Estados excitónicos de muaré en homo/heteroestructuras retorcidas de TMD: propuesto por Tran/múltiples equipos en 2019, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Moiré excitonic states in twisted TMD homo/heterostructures: proposed by Tran / 多团队 in 2019; related experiments/theory remain incomplete.',
    whyHard: '尽管 Tran / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['TMD', '莫尔'],
  },
  {
    id: 'mat-perovskite-phase',
    category: 'materials',
    title: '卤化物钙钛矿的相稳定性',
    titleJa: 'ハロゲン化物ペロブスカイトの相安定性',
    titleEs: 'Estabilidad de fase de perovskitas de haluro: propuesta por Snaith/múltiples equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Phase stability of halide perovskites',
    year: 2013,
    proposer: 'Snaith / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：卤化物钙钛矿的相稳定性。',
    summaryJa: '材料分野における特定の困難な問題：ハロゲン化物ペロブスカイトの相安定性。',
    summaryEs: 'Estabilidad de fase de perovskitas de haluro: propuesta por Snaith/múltiples equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Phase stability of halide perovskites.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 卤化物钙钛矿的相稳定性 的问题。它可以简单描述为 「卤化物钙钛矿的相稳定性」是 材料 领域的 钙钛矿 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「卤化物钙钛矿的相稳定性」是 材料 领域的 钙钛矿 方向。',
    formal: '卤化物钙钛矿的相稳定性（Phase stability of halide perovskites）：Snaith / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ハロゲン化物ペロブスカイトの相安定性： 2013年にSnaith/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Estabilidad de fase de perovskitas de haluro: propuesta por Snaith/múltiples equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Phase stability of halide perovskites: proposed by Snaith / 多团队 in 2013; related experiments/theory remain incomplete.',
    whyHard: '尽管 Snaith / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿'],
  },
  {
    id: 'mat-double-perovskite',
    category: 'materials',
    title: '双钙钛矿 (Cs2AgBiBr6) 太阳能电池',
    titleJa: '双钙钛矿 (Cs2AgBiBr6) 太阳能电池',
    titleEs: 'Células solares de doble perovskita (Cs2AgBiBr6): propuestas por Mączka/varios equipos en 2016, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Double perovskite (Cs2AgBiBr6) solar cells',
    year: 2016,
    proposer: 'Mączka / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：双钙钛矿 (Cs2AgBiBr6) 太阳能电池。',
    summaryJa: '一道 材料 领域的具体硬问题：双钙钛矿 (Cs2AgBiBr6) 太阳能电池。',
    summaryEs: 'Células solares de doble perovskita (Cs2AgBiBr6): propuestas por Mączka/varios equipos en 2016, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Double perovskite (Cs2AgBiBr6) solar cells.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 双钙钛矿 (Cs2AgBiBr6) 太阳能电池。它说的是 「双钙钛矿 (Cs2AgBiBr6) 太阳能电池」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 无铅 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「双钙钛矿 (Cs2AgBiBr6) 太阳能电池」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 无铅 等方面。',
    formal: '双钙钛矿 (Cs2AgBiBr6) 太阳能电池（Double perovskite (Cs2AgBiBr6) solar cells）：Mączka / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    formalJa: '双钙钛矿 (Cs2AgBiBr6) 太阳能电池（Double perovskite (Cs2AgBiBr6) solar cells）：Mączka / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    formalEs: 'Células solares de doble perovskita (Cs2AgBiBr6): propuestas por Mączka/varios equipos en 2016, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Double perovskite (Cs2AgBiBr6) solar cells: proposed by Mączka / 多团队 in 2016; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿', '无铅'],
  },
  {
    id: 'mat-organic-spintronics',
    category: 'materials',
    title: '有机自旋电子学 (Alq3 注入)',
    titleJa: '有机自旋电子学 (Alq3 注入)',
    titleEs: 'Espintrónica orgánica (inyección de Alq3): propuesta por Xiong/múltiples equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Organic spintronics (Alq3 injection)',
    year: 2004,
    proposer: 'Xiong / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：有机自旋电子学 (Alq3 注入)。',
    summaryJa: '材料分野における特定の困難な問題：有機スピントロニクス（ Alq 3インプラント）。',
    summaryEs: 'Espintrónica orgánica (inyección de Alq3): propuesta por Xiong/múltiples equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Organic spintronics (Alq3 injection).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 有机自旋电子学 (Alq3 注入)。它说的是 「有机自旋电子学 (Alq3 注入)」是 材料 领域的 有机 方向，涉及 有机, 自旋 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「有机自旋电子学 (Alq3 注入)」是 材料 领域的 有机 方向，涉及 有机, 自旋 等方面。',
    formal: '有机自旋电子学 (Alq3 注入)（Organic spintronics (Alq3 injection)）：Xiong / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: '有機スピントロニクス（Alq3注入）：2004年に熊氏とそのチームによって提案されたが、関連する実験と理論はまだ完全には解明されていない。',
    formalEs: 'Espintrónica orgánica (inyección de Alq3): propuesta por Xiong/múltiples equipos en 2004, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Organic spintronics (Alq3 injection): proposed by Xiong / 多团队 in 2004; related experiments/theory remain incomplete.',
    whyHard: '「有机自旋电子学 (Alq3 注入)」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '自旋'],
  },
  {
    id: 'mat-organic-tft',
    category: 'materials',
    title: '有机薄膜晶体管 (OTFT) 高迁移率',
    titleJa: '高移動度有機薄膜トランジスタ（OTFT）',
    titleEs: 'Transistores orgánicos de película delgada (OTFT) de alta movilidad: propuestos por Tsumura/varios equipos en 1986, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'High-mobility organic thin-film transistors (OTFT)',
    year: 1986,
    proposer: 'Tsumura / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：有机薄膜晶体管 (OTFT) 高迁移率。',
    summaryJa: '材料分野における特定の困難な問題：有機薄膜トランジスタ（ OTFT ）の高移動度。',
    summaryEs: 'Transistores orgánicos de película delgada (OTFT) de alta movilidad: propuestos por Tsumura/varios equipos en 1986, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: High-mobility organic thin-film transistors (OTFT).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 有机薄膜晶体管 (OTFT) 高迁移率 的核心问题是：「有机薄膜晶体管 (OTFT) 高迁移率」是 材料 领域的 有机 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「有机薄膜晶体管 (OTFT) 高迁移率」是 材料 领域的 有机 方向。',
    formal: '有机薄膜晶体管 (OTFT) 高迁移率（High-mobility organic thin-film transistors (OTFT)）：Tsumura / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    formalJa: '有機薄膜トランジスタ（ OTFT ）高移動性有機薄膜トランジスタ（ OTFT ） ： TSUMURA/MULTIチームは1986年に提案したが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Transistores orgánicos de película delgada (OTFT) de alta movilidad: propuestos por Tsumura/varios equipos en 1986, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'High-mobility organic thin-film transistors (OTFT): proposed by Tsumura / 多团队 in 1986; related experiments/theory remain incomplete.',
    whyHard: '尽管 Tsumura / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'mat-conducting-polymer',
    category: 'materials',
    title: '导电聚合物 (PEDOT:PSS) 高电导率 + 拉伸',
    titleJa: '導電性ポリマー(PEDOT: PSS)高導電性＋伸縮性',
    titleEs: 'Polímero conductor (PEDOT:PSS) Alta conductividad + polímero conductor estirable (PEDOT:PSS): Propuesto por Heeger/varios equipos en 1980, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'High conductivity + stretchable conducting polymer (PEDOT:PSS)',
    year: 1980,
    proposer: 'Heeger / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：导电聚合物 (PEDOT:PSS) 高电导率 + 拉伸。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：導電性ポリマー（PEDOT:PSS）の高い電気伝導率と引張強度の両立。',
    summaryEs: 'Polímero conductor (PEDOT:PSS) Alta conductividad + polímero conductor estirable (PEDOT:PSS): Propuesto por Heeger/varios equipos en 1980, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: High conductivity + stretchable conducting polymer (PEDOT:PSS).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 导电聚合物 (PEDOT:PSS) 高电导率 + 拉伸 的问题。它可以简单描述为 「导电聚合物 (PEDOT:PSS) 高电导率 + 拉伸」是 材料 领域的 导电聚合物 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「导电聚合物 (PEDOT:PSS) 高电导率 + 拉伸」是 材料 领域的 导电聚合物 方向。',
    formal: '导电聚合物 (PEDOT:PSS) 高电导率 + 拉伸（High conductivity + stretchable conducting polymer (PEDOT:PSS)）：Heeger / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: '高導電性＋伸縮性導電性ポリマー（PEDOT:PSS）：1980年にヒーガーや複数のチームによって提案されたが、関連する実験や理論はまだ完全に解明されていない。',
    formalEs: 'Polímero conductor (PEDOT:PSS) Alta conductividad + polímero conductor estirable (PEDOT:PSS): Propuesto por Heeger/varios equipos en 1980, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'High conductivity + stretchable conducting polymer (PEDOT:PSS): proposed by Heeger / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Heeger / 多团队 等人在 1980 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['导电聚合物'],
  },
  {
    id: 'mat-p3ht-bulk',
    category: 'materials',
    title: 'P3HT 异质结太阳能电池效率上限',
    titleJa: 'P3HTヘテロ接合型太陽電池の効率の上限',
    titleEs: 'Límite de eficiencia de la célula solar de heterounión masiva P3HT (límite de eficiencia de la célula solar de heterounión masiva P3HT): propuesto por Yu/varios equipos en 1995, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'P3HT bulk heterojunction solar cell efficiency limit',
    year: 1995,
    proposer: 'Yu / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：P3HT 异质结太阳能电池效率上限。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：P3HTヘテロ接合型太陽電池の効率の上限。',
    summaryEs: 'Límite de eficiencia de la célula solar de heterounión masiva P3HT (límite de eficiencia de la célula solar de heterounión masiva P3HT): propuesto por Yu/varios equipos en 1995, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: P3HT bulk heterojunction solar cell efficiency limit.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 P3HT 异质结太阳能电池效率上限 的核心问题是：「P3HT 异质结太阳能电池效率上限」是 材料 领域的 有机 方向，涉及 有机, 光伏 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「P3HT 异质结太阳能电池效率上限」是 材料 领域的 有机 方向，涉及 有机, 光伏 等方面。',
    formal: 'P3HT 异质结太阳能电池效率上限（P3HT bulk heterojunction solar cell efficiency limit）：Yu / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'P3HTバルクヘテロ接合型太陽電池の効率限界：1995年にYu氏とそのチームによって提唱されたが、関連する実験と理論は今日まで完全には解明されていない。',
    formalEs: 'Límite de eficiencia de la célula solar de heterounión masiva P3HT (límite de eficiencia de la célula solar de heterounión masiva P3HT): propuesto por Yu/varios equipos en 1995, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'P3HT bulk heterojunction solar cell efficiency limit: proposed by Yu / 多团队 in 1995; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Yu / 多团队 等人在 1995 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '光伏'],
  },
  {
    id: 'mat-non-fullerene',
    category: 'materials',
    title: '非富勒烯受体 (ITIC, Y6) 机理',
    titleJa: '非フラーレン受容体（ ＩＴＩＣ、Ｙ ６ ）機構',
    titleEs: 'Mecanismo de aceptores no fullerenos (ITIC, Y6): propuesto por Zhan/Yuan/múltiples equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Mechanism of non-fullerene acceptors (ITIC, Y6)',
    year: 2015,
    proposer: 'Zhan / Yuan / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：非富勒烯受体 (ITIC, Y6) 机理。',
    summaryJa: '材料分野における特定の難題：非フラーレン受容体のメカニズム（ ITIC、Y 6 ）。',
    summaryEs: 'Mecanismo de aceptores no fullerenos (ITIC, Y6): propuesto por Zhan/Yuan/múltiples equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Mechanism of non-fullerene acceptors (ITIC, Y6).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 非富勒烯受体 (ITIC, Y6) 机理。它说的是 「非富勒烯受体 (ITIC, Y6) 机理」是 材料 领域的 有机 方向，涉及 有机, 光伏 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「非富勒烯受体 (ITIC, Y6) 机理」是 材料 领域的 有机 方向，涉及 有机, 光伏 等方面。',
    formal: '非富勒烯受体 (ITIC, Y6) 机理（Mechanism of non-fullerene acceptors (ITIC, Y6)）：Zhan / Yuan / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: '非フラーレンアクセプター（ITIC、Y6）のメカニズムは、2015年にZhan/Yuan/複数のチームによって提案されたが、関連する実験や理論はまだ完全に解明されていない。',
    formalEs: 'Mecanismo de aceptores no fullerenos (ITIC, Y6): propuesto por Zhan/Yuan/múltiples equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Mechanism of non-fullerene acceptors (ITIC, Y6): proposed by Zhan / Yuan / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '尽管 Zhan / Yuan / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '光伏'],
  },
  {
    id: 'mat-quantum-dot-display',
    category: 'materials',
    title: '量子点 (Cd-free, Perovskite) 显示',
    titleJa: '量子ドット（カドミウムフリー、ペロブスカイト）ディスプレイ',
    titleEs: 'Pantalla de puntos cuánticos (sin CD, perovskita) (pantallas de puntos cuánticos sin cadmio/perovskita): propuesta por Ekimov/varios equipos en 2010, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Cadmium-free / perovskite quantum dot displays',
    year: 2010,
    proposer: 'Ekimov / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：量子点 (Cd-free, Perovskite) 显示。',
    summaryJa: '材料科学分野における特定の難問：量子ドット（カドミウムフリー、ペロブスカイト）の挙動。',
    summaryEs: 'Pantalla de puntos cuánticos (sin CD, perovskita) (pantallas de puntos cuánticos sin cadmio/perovskita): propuesta por Ekimov/varios equipos en 2010, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Cadmium-free / perovskite quantum dot displays.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 量子点 (Cd-free, Perovskite) 显示 的问题。它可以简单描述为 「量子点 (Cd-free, Perovskite) 显示」是 材料 领域的 量子点 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「量子点 (Cd-free, Perovskite) 显示」是 材料 领域的 量子点 方向。',
    formal: '量子点 (Cd-free, Perovskite) 显示（Cadmium-free / perovskite quantum dot displays）：Ekimov / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '量子ドット（カドミウムフリー、ペロブスカイト）ディスプレイ：2010年にエキモフと複数のチームによって提案されたが、関連する実験や理論はまだ完全には解明されていない。',
    formalEs: 'Pantalla de puntos cuánticos (sin CD, perovskita) (pantallas de puntos cuánticos sin cadmio/perovskita): propuesta por Ekimov/varios equipos en 2010, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Cadmium-free / perovskite quantum dot displays: proposed by Ekimov / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Ekimov / 多团队 等人在 2010 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['量子点'],
  },
  {
    id: 'mat-pb-qdot',
    category: 'materials',
    title: 'PbS 量子点太阳能电池 (>18%)',
    titleJa: 'PbS量子ドット太陽電池（18%超）',
    titleEs: 'Células solares de puntos cuánticos de PbS (>18%) (células solares de puntos cuánticos de PbS por encima del 18%): propuestas por Nozik/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'PbS quantum dot solar cells above 18%',
    year: 2005,
    proposer: 'Nozik / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：PbS 量子点太阳能电池 (>18%)。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：PbS量子ドット太陽電池（18%以上）。',
    summaryEs: 'Células solares de puntos cuánticos de PbS (>18%) (células solares de puntos cuánticos de PbS por encima del 18%): propuestas por Nozik/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: PbS quantum dot solar cells above 18%.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 PbS 量子点太阳能电池 (>18%)。它说的是 「PbS 量子点太阳能电池 (>18%)」是 材料 领域的 量子点 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「PbS 量子点太阳能电池 (>18%)」是 材料 领域的 量子点 方向。',
    formal: 'PbS 量子点太阳能电池 (>18%)（PbS quantum dot solar cells above 18%）：Nozik / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＰｂＳ量子ドット太陽電池（ ＞ １ ８ ％ ） （ ＰｂＳ量子ドット太陽電池は１ ８ ％以上） ： ２ ０ ０ ５年にＮｏｚｉｋ ／ Ｍｕｌｔｉチームが提案し、関連する実験／理論は今のところ完全には解決されていない。',
    formalEs: 'Células solares de puntos cuánticos de PbS (>18%) (células solares de puntos cuánticos de PbS por encima del 18%): propuestas por Nozik/múltiples equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'PbS quantum dot solar cells above 18%: proposed by Nozik / 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '尽管 Nozik / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['量子点'],
  },
  {
    id: 'mat-aerogel-strength',
    category: 'materials',
    title: '石墨烯气凝胶的强度极限',
    titleJa: 'グラフェンエアロゲルの強度限界',
    titleEs: 'Límite de fuerza de los aerogeles de grafeno: Worsley/varios equipos lo propusieron en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Strength limit of graphene aerogels',
    year: 2011,
    proposer: 'Worsley / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：石墨烯气凝胶的强度极限。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：グラフェンエアロゲルの強度限界。',
    summaryEs: 'Límite de fuerza de los aerogeles de grafeno: Worsley/varios equipos lo propusieron en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Strength limit of graphene aerogels.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 石墨烯气凝胶的强度极限 的问题。它可以简单描述为 「石墨烯气凝胶的强度极限」是 材料 领域的 气凝胶 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「石墨烯气凝胶的强度极限」是 材料 领域的 气凝胶 方向。',
    formal: '石墨烯气凝胶的强度极限（Strength limit of graphene aerogels）：Worsley / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'グラフェンエアロゲルの強度限界：2011年にウォーズリーとそのチームによって提唱されたが、関連する実験的および理論的な解決策はまだ完全には解明されていない。',
    formalEs: 'Límite de fuerza de los aerogeles de grafeno: Worsley/varios equipos lo propusieron en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Strength limit of graphene aerogels: proposed by Worsley / 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['气凝胶'],
  },
  {
    id: 'mat-sio2-aerogel',
    category: 'materials',
    title: 'SiO2 气凝胶透明性 vs 隔热优化',
    titleJa: 'SiO 2エアロゲルの透明性と断熱性の最適化',
    titleEs: 'Transparencia versus optimización del aislamiento en aerogeles de SiO2: propuesto por Kistler/múltiples equipos en 1931, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Transparency vs insulation optimization in SiO2 aerogels',
    year: 1931,
    proposer: 'Kistler / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：SiO2 气凝胶透明性 vs 隔热优化。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：SiO2エアロゲルの透明性と断熱性能の最適化。',
    summaryEs: 'Transparencia versus optimización del aislamiento en aerogeles de SiO2: propuesto por Kistler/múltiples equipos en 1931, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Transparency vs insulation optimization in SiO2 aerogels.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 SiO2 气凝胶透明性 vs 隔热优化 的问题。它可以简单描述为 「SiO2 气凝胶透明性 vs 隔热优化」是 材料 领域的 气凝胶 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「SiO2 气凝胶透明性 vs 隔热优化」是 材料 领域的 气凝胶 方向。',
    formal: 'SiO2 气凝胶透明性 vs 隔热优化（Transparency vs insulation optimization in SiO2 aerogels）：Kistler / 多团队 在 1931 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'SiO2エアロゲルにおける透明性と断熱性の最適化：このテーマは1931年にキーストラーとそのチームによって提唱されましたが、関連する実験と理論はまだ完全に解決されていません。',
    formalEs: 'Transparencia versus optimización del aislamiento en aerogeles de SiO2: propuesto por Kistler/múltiples equipos en 1931, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Transparency vs insulation optimization in SiO2 aerogels: proposed by Kistler / 多团队 in 1931; related experiments/theory remain incomplete.',
    whyHard: '尽管 Kistler / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['气凝胶'],
  },
  {
    id: 'mat-cf-pan',
    category: 'materials',
    title: 'PAN 基碳纤维高模量 (>600 GPa)',
    titleJa: 'PANベースの炭素繊維高弾性率（> 600 GPa ）',
    titleEs: 'Fibra de carbono basada en PAN de alto módulo (>600 GPa): propuesta por Watt/varios equipos en 1964, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'High-modulus (>600 GPa) PAN-based carbon fiber',
    year: 1964,
    proposer: 'Watt / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：PAN 基碳纤维高模量 (>600 GPa)。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：PAN系炭素繊維の高弾性率（600 GPa以上）。',
    summaryEs: 'Fibra de carbono basada en PAN de alto módulo (>600 GPa): propuesta por Watt/varios equipos en 1964, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: High-modulus (>600 GPa) PAN-based carbon fiber.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 PAN 基碳纤维高模量 (>600 GPa) 的问题。它可以简单描述为 「PAN 基碳纤维高模量 (>600 GPa)」是 材料 领域的 碳纤维 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「PAN 基碳纤维高模量 (>600 GPa)」是 材料 领域的 碳纤维 方向。',
    formal: 'PAN 基碳纤维高模量 (>600 GPa)（High-modulus (>600 GPa) PAN-based carbon fiber）：Watt / 多团队 在 1964 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'PAN系炭素繊維高弾性率（ 600 GPa超） PAN系炭素繊維： 1964年にワット/マルチチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Fibra de carbono basada en PAN de alto módulo (>600 GPa): propuesta por Watt/varios equipos en 1964, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'High-modulus (>600 GPa) PAN-based carbon fiber: proposed by Watt / 多团队 in 1964; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['碳纤维'],
  },
  {
    id: 'mat-sic-fiber',
    category: 'materials',
    title: 'SiC 纤维高温抗氧化 (>1200°C)',
    titleJa: 'SiC繊維は高温酸化耐性（1200℃以上）を有する。',
    titleEs: 'Resistencia a la oxidación a alta temperatura de la fibra de SiC (resistencia a la oxidación a alta temperatura de la fibra de SiC): propuesta por Yajima/varios equipos en 1975, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'SiC fiber high-temperature oxidation resistance',
    year: 1975,
    proposer: 'Yajima / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：SiC 纤维高温抗氧化 (>1200°C)。',
    summaryJa: '材料分野の特定の難しい問題： SiC繊維の高温耐酸化性（> 1200°C ）。',
    summaryEs: 'Resistencia a la oxidación a alta temperatura de la fibra de SiC (resistencia a la oxidación a alta temperatura de la fibra de SiC): propuesta por Yajima/varios equipos en 1975, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: SiC fiber high-temperature oxidation resistance.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 SiC 纤维高温抗氧化 (>1200°C)。它说的是 「SiC 纤维高温抗氧化 (>1200°C)」是 材料 领域的 SiC 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「SiC 纤维高温抗氧化 (>1200°C)」是 材料 领域的 SiC 方向。',
    formal: 'SiC 纤维高温抗氧化 (>1200°C)（SiC fiber high-temperature oxidation resistance）：Yajima / 多团队 在 1975 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'SiC繊維の高温酸化耐性（&gt;1200℃）：この概念は1975年に矢島氏とそのチームによって提唱されましたが、関連する実験や理論はまだ完全に解明されていません。',
    formalEs: 'Resistencia a la oxidación a alta temperatura de la fibra de SiC (resistencia a la oxidación a alta temperatura de la fibra de SiC): propuesta por Yajima/varios equipos en 1975, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'SiC fiber high-temperature oxidation resistance: proposed by Yajima / 多团队 in 1975; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SiC'],
  },
  {
    id: 'mat-transparent-armor',
    category: 'materials',
    title: 'AlON / Spinel 透明陶瓷装甲',
    titleJa: 'AlON/スピネル透明セラミックアーマー',
    titleEs: 'Armadura de cerámica transparente AlON / Spinel: propuesta por varios equipos en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'AlON / Spinel transparent ceramic armor',
    year: 1970,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：AlON / Spinel 透明陶瓷装甲。',
    summaryJa: '材料科学分野における、具体的かつ困難な課題：AlON/スピネル透明セラミック装甲。',
    summaryEs: 'Armadura de cerámica transparente AlON / Spinel: propuesta por varios equipos en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: AlON / Spinel transparent ceramic armor.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 AlON / Spinel 透明陶瓷装甲 的问题。它可以简单描述为 「AlON / Spinel 透明陶瓷装甲」是 材料 领域的 陶瓷 方向，涉及 陶瓷, 透明 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「AlON / Spinel 透明陶瓷装甲」是 材料 领域的 陶瓷 方向，涉及 陶瓷, 透明 等方面。',
    formal: 'AlON / Spinel 透明陶瓷装甲（AlON / Spinel transparent ceramic armor）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'アロン/スピネル透明セラミックアーマー（アロン/スピネル透明セラミックアーマー） ： 1970年に複数のチームが提案したが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Armadura de cerámica transparente AlON / Spinel: propuesta por varios equipos en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'AlON / Spinel transparent ceramic armor: proposed by 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['陶瓷', '透明'],
  },
  {
    id: 'mat-self-healing',
    category: 'materials',
    title: '自愈材料 (self-healing) 循环次数',
    titleJa: '自己修復サイクル数',
    titleEs: 'Número de ciclo de materiales de autocuración: propuesto por White / Sottos / varios equipos en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Cycle number of self-healing materials',
    year: 2001,
    proposer: 'White / Sottos / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：自愈材料 (self-healing) 循环次数。',
    summaryJa: '材料科学分野における具体的かつ困難な課題の一つは、自己修復材料に必要なサイクル数である。',
    summaryEs: 'Número de ciclo de materiales de autocuración: propuesto por White / Sottos / varios equipos en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Cycle number of self-healing materials.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 自愈材料 (self-healing) 循环次数 的问题。它可以简单描述为 「自愈材料 (self-healing) 循环次数」是 材料 领域的 自愈 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「自愈材料 (self-healing) 循环次数」是 材料 领域的 自愈 方向。',
    formal: '自愈材料 (self-healing) 循环次数（Cycle number of self-healing materials）：White / Sottos / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: '自己修復材料のサイクル数： 2001年に提案されたWhite/Sottos/Multipleチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: 'Número de ciclo de materiales de autocuración: propuesto por White / Sottos / varios equipos en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Cycle number of self-healing materials: proposed by White / Sottos / 多团队 in 2001; related experiments/theory remain incomplete.',
    whyHard: '尽管 White / Sottos / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自愈'],
  },
  {
    id: 'mat-spider-silk',
    category: 'materials',
    title: '重组蜘蛛丝蛋白大规模生产',
    titleJa: '組換えスパイダーシルクタンパク質量産',
    titleEs: 'Producción a gran escala de seda de araña recombinante: propuesta por Spider Silk Team/Spiber en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Large-scale production of recombinant spider silk',
    year: 2010,
    proposer: 'Spider Silk Team / Spiber',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：重组蜘蛛丝蛋白大规模生产。',
    summaryJa: '材料分野における特定の困難な問題：組換えスパイダーシルクタンパク質の大量生産。',
    summaryEs: 'Producción a gran escala de seda de araña recombinante: propuesta por Spider Silk Team/Spiber en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Large-scale production of recombinant spider silk.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 重组蜘蛛丝蛋白大规模生产 的问题。它可以简单描述为 「重组蜘蛛丝蛋白大规模生产」是 材料 领域的 仿生 方向，涉及 仿生, 蛋白 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「重组蜘蛛丝蛋白大规模生产」是 材料 领域的 仿生 方向，涉及 仿生, 蛋白 等方面。',
    formal: '重组蜘蛛丝蛋白大规模生产（Large-scale production of recombinant spider silk）：Spider Silk Team / Spiber 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '組換えスパイダーシルクの大規模生産： Spider Silk Team/Spiberは2010年に提案され、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Producción a gran escala de seda de araña recombinante: propuesta por Spider Silk Team/Spiber en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Large-scale production of recombinant spider silk: proposed by Spider Silk Team / Spiber in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Spider Silk Team / Spiber 等人在 2010 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['仿生', '蛋白'],
  },
  {
    id: 'mat-superhydrophobic',
    category: 'materials',
    title: '可逆超疏水/超亲水切换表面',
    titleJa: '可逆的な超疎水性/超親水性スイッチング表面',
    titleEs: 'Superficies de conmutación reversibles superhidrófobas/superhidrófilas: propuestas por Jiang/varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Reversible superhydrophobic / superhydrophilic switching surfaces',
    year: 2000,
    proposer: 'Jiang / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：可逆超疏水/超亲水切换表面。',
    summaryJa: '材料の分野における特定の難しい問題：可逆的な超疎水性/超親水性スイッチング表面。',
    summaryEs: 'Superficies de conmutación reversibles superhidrófobas/superhidrófilas: propuestas por Jiang/varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Reversible superhydrophobic / superhydrophilic switching surfaces.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 可逆超疏水/超亲水切换表面 是这样一个问题：「可逆超疏水/超亲水切换表面」是 材料 领域的 超疏水 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「可逆超疏水/超亲水切换表面」是 材料 领域的 超疏水 方向。',
    formal: '可逆超疏水/超亲水切换表面（Reversible superhydrophobic / superhydrophilic switching surfaces）：Jiang / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '可逆的な超疎水性/超親水性スイッチング表面： Jiang/複数のチームが2000年に提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Superficies de conmutación reversibles superhidrófobas/superhidrófilas: propuestas por Jiang/varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Reversible superhydrophobic / superhydrophilic switching surfaces: proposed by Jiang / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '「可逆超疏水/超亲水切换表面」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超疏水'],
  },
  {
    id: 'mat-electrochromic',
    category: 'materials',
    title: '电致变色智能窗 (大面积)',
    titleJa: 'エレクトロクロミックスマートウィンドウ（大面積）',
    titleEs: 'Ventanas inteligentes electrocrómicas de gran superficie (Ventanas inteligentes electrocrómicas de gran superficie): propuestas por Lampert/Granqvist en 1984, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Large-area electrochromic smart windows',
    year: 1984,
    proposer: 'Lampert / Granqvist',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：电致变色智能窗 (大面积)。',
    summaryJa: '材料分野における特定の困難な問題：エレクトロクロミックスマートウィンドウ（大面積）。',
    summaryEs: 'Ventanas inteligentes electrocrómicas de gran superficie (Ventanas inteligentes electrocrómicas de gran superficie): propuestas por Lampert/Granqvist en 1984, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Large-area electrochromic smart windows.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 电致变色智能窗 (大面积)。它说的是 「电致变色智能窗 (大面积)」是 材料 领域的 电致变色 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「电致变色智能窗 (大面积)」是 材料 领域的 电致变色 方向。',
    formal: '电致变色智能窗 (大面积)（Large-area electrochromic smart windows）：Lampert / Granqvist 在 1984 年提出，相关实验/理论至今未完全解决。',
    formalJa: '大面積エレクトロクロミックスマートウィンドウ： 1984年にLampert/Granqvistが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Ventanas inteligentes electrocrómicas de gran superficie (Ventanas inteligentes electrocrómicas de gran superficie): propuestas por Lampert/Granqvist en 1984, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Large-area electrochromic smart windows: proposed by Lampert / Granqvist in 1984; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Lampert / Granqvist 等人在 1984 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['电致变色'],
  },
  {
    id: 'mat-camouflage-meta',
    category: 'materials',
    title: '可见光隐身超材料 (宽带)',
    titleJa: '可視ステルスメタマテリアル（ブロードバンド）',
    titleEs: 'Metamaterial de encubrimiento de banda ancha de luz visible (Metamaterial de encubrimiento de banda ancha de luz visible): propuesto por Pendry / Schurig / Smith en 2006, y los experimentos / teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Visible-light broadband cloaking metamaterial',
    year: 2006,
    proposer: 'Pendry / Schurig / Smith',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 材料 领域的具体硬问题：可见光隐身超材料 (宽带)。',
    summaryJa: '材料の分野における特定の困難な問題：可視光ステルスメタマテリアル（ブロードバンド）。',
    summaryEs: 'Metamaterial de encubrimiento de banda ancha de luz visible (Metamaterial de encubrimiento de banda ancha de luz visible): propuesto por Pendry / Schurig / Smith en 2006, y los experimentos / teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Visible-light broadband cloaking metamaterial.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 可见光隐身超材料 (宽带)。它说的是 「可见光隐身超材料 (宽带)」是 材料 领域的 超材料 方向，涉及 超材料, 隐身 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「可见光隐身超材料 (宽带)」是 材料 领域的 超材料 方向，涉及 超材料, 隐身 等方面。',
    formal: '可见光隐身超材料 (宽带)（Visible-light broadband cloaking metamaterial）：Pendry / Schurig / Smith 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalJa: '可視光ブロードバンド遮へいメタマテリアル： 2006年にPendry/Schurig/Smithによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Metamaterial de encubrimiento de banda ancha de luz visible (Metamaterial de encubrimiento de banda ancha de luz visible): propuesto por Pendry / Schurig / Smith en 2006, y los experimentos / teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Visible-light broadband cloaking metamaterial: proposed by Pendry / Schurig / Smith in 2006; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超材料', '隐身'],
  },
  {
    id: 'mat-negative-index',
    category: 'materials',
    title: '可见光波段负折射率材料',
    titleJa: '可視光バンド内の負の屈折率材料',
    titleEs: 'Material de índice negativo de longitud de onda visible: propuesto por Shelby/Smith/varios equipos en 2000, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Visible-wavelength negative index material',
    year: 2000,
    proposer: 'Shelby / Smith / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：可见光波段负折射率材料。',
    summaryJa: '材料の分野における特定の困難な問題：可視光帯における負の屈折率材料。',
    summaryEs: 'Material de índice negativo de longitud de onda visible: propuesto por Shelby/Smith/varios equipos en 2000, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Visible-wavelength negative index material.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 可见光波段负折射率材料 的核心问题是：「可见光波段负折射率材料」是 材料 领域的 超材料 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「可见光波段负折射率材料」是 材料 领域的 超材料 方向。',
    formal: '可见光波段负折射率材料（Visible-wavelength negative index material）：Shelby / Smith / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '可視波長陰性指標材料： 2000年にShelby/Smith/複数チームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Material de índice negativo de longitud de onda visible: propuesto por Shelby/Smith/varios equipos en 2000, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Visible-wavelength negative index material: proposed by Shelby / Smith / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Shelby / Smith / 多团队 等人在 2000 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超材料'],
  },
  {
    id: 'mat-acoustic-meta',
    category: 'materials',
    title: '声学超材料 (亚波长成像)',
    titleJa: '音響メタマテリアル（サブ波長イメージング）',
    titleEs: 'Metamateriales acústicos (imágenes por debajo de la longitud de onda): propuestos por Pendry/varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Acoustic metamaterials (subwavelength imaging)',
    year: 2000,
    proposer: 'Pendry / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：声学超材料 (亚波长成像)。',
    summaryJa: '材料分野における特定の困難な問題：音響メタマテリアル（サブ波長イメージング）。',
    summaryEs: 'Metamateriales acústicos (imágenes por debajo de la longitud de onda): propuestos por Pendry/varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Acoustic metamaterials (subwavelength imaging).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 声学超材料 (亚波长成像) 的问题。它可以简单描述为 「声学超材料 (亚波长成像)」是 材料 领域的 声学 方向，涉及 声学, 超材料 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「声学超材料 (亚波长成像)」是 材料 领域的 声学 方向，涉及 声学, 超材料 等方面。',
    formal: '声学超材料 (亚波长成像)（Acoustic metamaterials (subwavelength imaging)）：Pendry / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '音響メタマテリアル（サブ波長イメージング） ： 2000年にPendry/複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Metamateriales acústicos (imágenes por debajo de la longitud de onda): propuestos por Pendry/varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Acoustic metamaterials (subwavelength imaging): proposed by Pendry / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['声学', '超材料'],
  },
  {
    id: 'mat-auxetic',
    category: 'materials',
    title: 'Auxetic (负泊松比) 材料应用',
    titleJa: '補助（負のポアソン比）材料用途',
    titleEs: 'Aplicaciones de materiales auxéticos (relación de Poisson negativa): propuestas por Lakes/múltiples equipos en 1987, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Applications of auxetic (negative Poisson ratio) materials',
    year: 1987,
    proposer: 'Lakes / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：Auxetic (负泊松比) 材料应用。',
    summaryJa: '材料分野における特定の困難な問題：補助（負のポアソン比）材料用途。',
    summaryEs: 'Aplicaciones de materiales auxéticos (relación de Poisson negativa): propuestas por Lakes/múltiples equipos en 1987, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Applications of auxetic (negative Poisson ratio) materials.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 Auxetic (负泊松比) 材料应用 的问题。它可以简单描述为 「Auxetic (负泊松比) 材料应用」是 材料 领域的 超材料 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Auxetic (负泊松比) 材料应用」是 材料 领域的 超材料 方向。',
    formal: 'Auxetic (负泊松比) 材料应用（Applications of auxetic (negative Poisson ratio) materials）：Lakes / 多团队 在 1987 年提出，相关实验/理论至今未完全解决。',
    formalJa: '補助（負のポアソン比）材料補助（負のポアソン比）材料の応用： 1987年に提案されたLakes/複数のチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: 'Aplicaciones de materiales auxéticos (relación de Poisson negativa): propuestas por Lakes/múltiples equipos en 1987, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Applications of auxetic (negative Poisson ratio) materials: proposed by Lakes / 多团队 in 1987; related experiments/theory remain incomplete.',
    whyHard: '「Auxetic (负泊松比) 材料应用」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['超材料'],
  },
  {
    id: 'mat-tin-pvp',
    category: 'materials',
    title: '锡基钙钛矿太阳能电池',
    titleJa: 'スズ系ペロブスカイト太陽電池',
    titleEs: 'Células solares de perovskita a base de estaño: propuestas por Kanatzidis/varios equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Tin-based perovskite solar cells',
    year: 2012,
    proposer: 'Kanatzidis / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：锡基钙钛矿太阳能电池。',
    summaryJa: '材料の分野における特定の困難な問題：スズ系ペロブスカイト太陽電池。',
    summaryEs: 'Células solares de perovskita a base de estaño: propuestas por Kanatzidis/varios equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Tin-based perovskite solar cells.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 锡基钙钛矿太阳能电池 的核心问题是：「锡基钙钛矿太阳能电池」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 无铅 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「锡基钙钛矿太阳能电池」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 无铅 等方面。',
    formal: '锡基钙钛矿太阳能电池（Tin-based perovskite solar cells）：Kanatzidis / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'スズ系ペロブスカイト太陽電池：2012年にカナツィディス氏とそのチームによって提案されたが、関連する実験や理論はまだ完全に解明されていない。',
    formalEs: 'Células solares de perovskita a base de estaño: propuestas por Kanatzidis/varios equipos en 2012, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Tin-based perovskite solar cells: proposed by Kanatzidis / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Kanatzidis / 多团队 等人在 2012 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿', '无铅'],
  },
  {
    id: 'mat-sic-power-3kV',
    category: 'materials',
    title: 'SiC MOSFET 10 kV 击穿',
    titleJa: 'SiC MOSFET 10 kV故障',
    titleEs: 'Desglose de SiC MOSFET de 10 kV (desglose de SiC MOSFET de 10 kV): propuesto por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'SiC MOSFET 10 kV breakdown',
    year: 2000,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：SiC MOSFET 10 kV 击穿。',
    summaryJa: '材料分野における特定の困難な問題： SiC MOSFET 10 kV破壊。',
    summaryEs: 'Desglose de SiC MOSFET de 10 kV (desglose de SiC MOSFET de 10 kV): propuesto por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: SiC MOSFET 10 kV breakdown.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 SiC MOSFET 10 kV 击穿 的核心问题是：「SiC MOSFET 10 kV 击穿」是 材料 领域的 SiC 方向，涉及 SiC, 功率 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「SiC MOSFET 10 kV 击穿」是 材料 领域的 SiC 方向，涉及 SiC, 功率 等方面。',
    formal: 'SiC MOSFET 10 kV 击穿（SiC MOSFET 10 kV breakdown）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'SiC MOSFETの10kVブレークダウン：この問題は2000年に複数のチームによって提起されましたが、関連する実験的・理論的な解決策はまだ完全には解決されていません。',
    formalEs: 'Desglose de SiC MOSFET de 10 kV (desglose de SiC MOSFET de 10 kV): propuesto por varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'SiC MOSFET 10 kV breakdown: proposed by 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 2000 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SiC', '功率'],
  },
  {
    id: 'mat-mishmash-mos2',
    category: 'materials',
    title: 'MoS2 沟道 MOSFET 大面积集成',
    titleJa: 'MoS 2チャネルMOSFET大面積統合',
    titleEs: 'Integración de área grande MOSFET de canal MoS2 (integración MOSFET de canal MoS2 a escala de oblea): propuesta por varios equipos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Wafer-scale MoS2 channel MOSFET integration',
    year: 2011,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：MoS2 沟道 MOSFET 大面积集成。',
    summaryJa: '材料分野における特定の困難な問題： MoS 2チャネルMOSFETの大面積統合。',
    summaryEs: 'Integración de área grande MOSFET de canal MoS2 (integración MOSFET de canal MoS2 a escala de oblea): propuesta por varios equipos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Wafer-scale MoS2 channel MOSFET integration.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 MoS2 沟道 MOSFET 大面积集成 的问题。它可以简单描述为 「MoS2 沟道 MOSFET 大面积集成」是 材料 领域的 2D 方向，涉及 2D, 晶体管 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「MoS2 沟道 MOSFET 大面积集成」是 材料 领域的 2D 方向，涉及 2D, 晶体管 等方面。',
    formal: 'MoS2 沟道 MOSFET 大面积集成（Wafer-scale MoS2 channel MOSFET integration）：多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ウェハスケールMoS2チャネルMOSFET集積：この概念は2011年に複数のチームによって提案されましたが、関連する実験的および理論的な解決策はまだ完全には解決されていません。',
    formalEs: 'Integración de área grande MOSFET de canal MoS2 (integración MOSFET de canal MoS2 a escala de oblea): propuesta por varios equipos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Wafer-scale MoS2 channel MOSFET integration: proposed by 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '「MoS2 沟道 MOSFET 大面积集成」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['2D', '晶体管'],
  },
  {
    id: 'mat-2d-heterostructure',
    category: 'materials',
    title: '2D 异质结光电器件 (响应度)',
    titleJa: '2 Dヘテロ接合光電子デバイス（応答性）',
    titleEs: 'Capacidad de respuesta del fotodetector de heterounión 2D: propuesto por varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: '2D heterojunction photodetector responsivity',
    year: 2013,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：2D 异质结光电器件 (响应度)。',
    summaryJa: '材料分野における特定の困難な問題： 2 Dヘテロ接合光電デバイス（応答性）。',
    summaryEs: 'Capacidad de respuesta del fotodetector de heterounión 2D: propuesto por varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: 2D heterojunction photodetector responsivity.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 2D 异质结光电器件 (响应度) 是这样一个问题：「2D 异质结光电器件 (响应度)」是 材料 领域的 2D 方向，涉及 2D, 光电 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「2D 异质结光电器件 (响应度)」是 材料 领域的 2D 方向，涉及 2D, 光电 等方面。',
    formal: '2D 异质结光电器件 (响应度)（2D heterojunction photodetector responsivity）：多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalJa: '2Dヘテロ接合型光検出器の応答性：2013年に複数のチームによって提案されたが、関連する実験や理論はまだ完全には解明されていない。',
    formalEs: 'Capacidad de respuesta del fotodetector de heterounión 2D: propuesto por varios equipos en 2013, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: '2D heterojunction photodetector responsivity: proposed by 多团队 in 2013; related experiments/theory remain incomplete.',
    whyHard: '尽管 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['2D', '光电'],
  },
  {
    id: 'mat-2d-spintronic',
    category: 'materials',
    title: '二维磁体 (CrI3, Cr2Ge2Te6) 居里温度',
    titleJa: '2 D磁石のキュリー温度（ CrI 3、Cr 2 Ge 2 Te 6 ）',
    titleEs: 'Temperatura de Curie de imanes 2D (CrI3, Cr2Ge2Te6): propuesta por Huang/varios equipos en 2017, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Curie temperature of 2D magnets (CrI3, Cr2Ge2Te6)',
    year: 2017,
    proposer: 'Huang / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：二维磁体 (CrI3, Cr2Ge2Te6) 居里温度。',
    summaryJa: '材料科学分野における具体的かつ困難な問題：二次元磁性体（CrI3、Cr2Ge2Te6）のキュリー温度。',
    summaryEs: 'Temperatura de Curie de imanes 2D (CrI3, Cr2Ge2Te6): propuesta por Huang/varios equipos en 2017, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Curie temperature of 2D magnets (CrI3, Cr2Ge2Te6).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 二维磁体 (CrI3, Cr2Ge2Te6) 居里温度 是这样一个问题：「二维磁体 (CrI3, Cr2Ge2Te6) 居里温度」是 材料 领域的 2D 方向，涉及 2D, 磁 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「二维磁体 (CrI3, Cr2Ge2Te6) 居里温度」是 材料 领域的 2D 方向，涉及 2D, 磁 等方面。',
    formal: '二维磁体 (CrI3, Cr2Ge2Te6) 居里温度（Curie temperature of 2D magnets (CrI3, Cr2Ge2Te6)）：Huang / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    formalJa: '2 D磁石（ CrI 3、Cr 2 Ge 2 Te 6 ） 2 D磁石（ CrI 3、Cr 2 Ge 2 Te 6 ）のキュリー温度： 2017年に提案されたHuang/マルチチーム、および関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Temperatura de Curie de imanes 2D (CrI3, Cr2Ge2Te6): propuesta por Huang/varios equipos en 2017, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Curie temperature of 2D magnets (CrI3, Cr2Ge2Te6): proposed by Huang / 多团队 in 2017; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['2D', '磁'],
  },
  {
    id: 'mat-mbe-sic-4h',
    category: 'materials',
    title: '4H-SiC 单晶衬底 (>6 英寸)',
    titleJa: '4H-SiC単結晶基板（6インチ以上）',
    titleEs: 'Sustrato monocristalino 4H-SiC de más de 6 pulgadas: propuesto por Tairov/varios equipos en 1978, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: '4H-SiC single crystal substrate above 6 inch',
    year: 1978,
    proposer: 'Tairov / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：4H-SiC 单晶衬底 (>6 英寸)。',
    summaryJa: '材料の分野における特定の困難な問題： 4 H - SiC単結晶基板（> 6インチ）。',
    summaryEs: 'Sustrato monocristalino 4H-SiC de más de 6 pulgadas: propuesto por Tairov/varios equipos en 1978, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: 4H-SiC single crystal substrate above 6 inch.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 4H-SiC 单晶衬底 (>6 英寸) 的核心问题是：「4H-SiC 单晶衬底 (>6 英寸)」是 材料 领域的 SiC 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「4H-SiC 单晶衬底 (>6 英寸)」是 材料 领域的 SiC 方向。',
    formal: '4H-SiC 单晶衬底 (>6 英寸)（4H-SiC single crystal substrate above 6 inch）：Tairov / 多团队 在 1978 年提出，相关实验/理论至今未完全解决。',
    formalJa: '4 H - SiC単結晶基板（> 6インチ） ： Tairov/Multiチームは1978年に提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Sustrato monocristalino 4H-SiC de más de 6 pulgadas: propuesto por Tairov/varios equipos en 1978, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: '4H-SiC single crystal substrate above 6 inch: proposed by Tairov / 多团队 in 1978; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Tairov / 多团队 等人在 1978 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SiC'],
  },
  {
    id: 'mat-gan-vertical',
    category: 'materials',
    title: '垂直 GaN 功率器件 (p-GaN 衬底)',
    titleJa: '垂直GaNパワーデバイス（ p - GaN基板）',
    titleEs: 'Dispositivos verticales de potencia de GaN sobre sustrato p-GaN: propuestos por Fujikura/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Vertical GaN power devices on p-GaN substrate',
    year: 2000,
    proposer: 'Fujikura / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：垂直 GaN 功率器件 (p-GaN 衬底)。',
    summaryJa: '材料分野における特定の困難な問題：垂直GaNパワーデバイス（ p - GaN基板）。',
    summaryEs: 'Dispositivos verticales de potencia de GaN sobre sustrato p-GaN: propuestos por Fujikura/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Vertical GaN power devices on p-GaN substrate.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 垂直 GaN 功率器件 (p-GaN 衬底) 是这样一个问题：「垂直 GaN 功率器件 (p-GaN 衬底)」是 材料 领域的 GaN 方向，涉及 GaN, 功率 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「垂直 GaN 功率器件 (p-GaN 衬底)」是 材料 领域的 GaN 方向，涉及 GaN, 功率 等方面。',
    formal: '垂直 GaN 功率器件 (p-GaN 衬底)（Vertical GaN power devices on p-GaN substrate）：Fujikura / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'p - GaN基板上の垂直GaNパワーデバイス： 2000年にフジクラ/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Dispositivos verticales de potencia de GaN sobre sustrato p-GaN: propuestos por Fujikura/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Vertical GaN power devices on p-GaN substrate: proposed by Fujikura / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '「垂直 GaN 功率器件 (p-GaN 衬底)」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['GaN', '功率'],
  },
  {
    id: 'mat-bto-pv',
    category: 'materials',
    title: 'BaTiO3 光伏效应 (大电流)',
    titleJa: 'BaTiO 3光起電効果（大電流）',
    titleEs: 'Efecto fotovoltaico a granel en BaTiO3 (Efecto fotovoltaico a granel en BaTiO3): propuesto por Choi/varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Bulk photovoltaic effect in BaTiO3',
    year: 2009,
    proposer: 'Choi / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：BaTiO3 光伏效应 (大电流)。',
    summaryJa: '材料分野における特定の困難な問題： BaTiO 3光起電効果（大電流）。',
    summaryEs: 'Efecto fotovoltaico a granel en BaTiO3 (Efecto fotovoltaico a granel en BaTiO3): propuesto por Choi/varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Bulk photovoltaic effect in BaTiO3.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 BaTiO3 光伏效应 (大电流) 的核心问题是：「BaTiO3 光伏效应 (大电流)」是 材料 领域的 铁电 方向，涉及 铁电, 光伏 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「BaTiO3 光伏效应 (大电流)」是 材料 领域的 铁电 方向，涉及 铁电, 光伏 等方面。',
    formal: 'BaTiO3 光伏效应 (大电流)（Bulk photovoltaic effect in BaTiO3）：Choi / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'BaTiO 3光起電効果（大電流） （ BaTiO 3におけるバルク光起電効果） ： 2009年にCHOI/マルチチームが提案され、関連する実験/理論はこれまで完全には解決されていない。',
    formalEs: 'Efecto fotovoltaico a granel en BaTiO3 (Efecto fotovoltaico a granel en BaTiO3): propuesto por Choi/varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Bulk photovoltaic effect in BaTiO3: proposed by Choi / 多团队 in 2009; related experiments/theory remain incomplete.',
    whyHard: '尽管 Choi / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['铁电', '光伏'],
  },
  {
    id: 'mat-bismuth-telluride',
    category: 'materials',
    title: 'Bi2Te3 基室温热电材料 (ZT>1.5)',
    titleJa: 'Bi 2 Te 3ベースの室温熱電材料（ ZT > 1.5 ）',
    titleEs: 'Termoeléctricos a temperatura ambiente basados ​​en Bi2Te3 (termoeléctricos a temperatura ambiente basados ​​en Bi2Te3): propuestos por Goldsmid/varios equipos en 1954, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Bi2Te3-based room-temperature thermoelectrics',
    year: 1954,
    proposer: 'Goldsmid / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：Bi2Te3 基室温热电材料 (ZT>1.5)。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：Bi2Te3をベースとした室温熱電材料（ZT&gt;1.5）。',
    summaryEs: 'Termoeléctricos a temperatura ambiente basados ​​en Bi2Te3 (termoeléctricos a temperatura ambiente basados ​​en Bi2Te3): propuestos por Goldsmid/varios equipos en 1954, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Bi2Te3-based room-temperature thermoelectrics.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 Bi2Te3 基室温热电材料 (ZT>1.5) 是这样一个问题：「Bi2Te3 基室温热电材料 (ZT>1.5)」是 材料 领域的 热电 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Bi2Te3 基室温热电材料 (ZT>1.5)」是 材料 领域的 热电 方向。',
    formal: 'Bi2Te3 基室温热电材料 (ZT>1.5)（Bi2Te3-based room-temperature thermoelectrics）：Goldsmid / 多团队 在 1954 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Bi2Te3をベースとした室温熱電材料（ZT&gt;1.5）：1954年にゴールドスミッドと複数のチームによって提案されたが、関連する実験と理論はまだ完全には解明されていない。',
    formalEs: 'Termoeléctricos a temperatura ambiente basados ​​en Bi2Te3 (termoeléctricos a temperatura ambiente basados ​​en Bi2Te3): propuestos por Goldsmid/varios equipos en 1954, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Bi2Te3-based room-temperature thermoelectrics: proposed by Goldsmid / 多团队 in 1954; related experiments/theory remain incomplete.',
    whyHard: '尽管 Goldsmid / 多团队 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['热电'],
  },
  {
    id: 'mat-llzo-electrolyte',
    category: 'materials',
    title: '石榴石型 LLZO 固态电解质 (锂枝晶)',
    titleJa: 'ガーネットタイプLLZO固体電解質（樹枝状リチウム）',
    titleEs: 'Electrolito sólido Garnet LLZO (supresión de dendritas de Li): propuesto por Murugan/varios equipos en 2007, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Garnet LLZO solid electrolyte (Li dendrite suppression)',
    year: 2007,
    proposer: 'Murugan / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：石榴石型 LLZO 固态电解质 (锂枝晶)。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：ガーネット型LLZO固​​体電解質（リチウムデンドライト）。',
    summaryEs: 'Electrolito sólido Garnet LLZO (supresión de dendritas de Li): propuesto por Murugan/varios equipos en 2007, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Garnet LLZO solid electrolyte (Li dendrite suppression).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 石榴石型 LLZO 固态电解质 (锂枝晶) 是这样一个问题：「石榴石型 LLZO 固态电解质 (锂枝晶)」是 材料 领域的 固态 方向，涉及 固态, 电池 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「石榴石型 LLZO 固态电解质 (锂枝晶)」是 材料 领域的 固态 方向，涉及 固态, 电池 等方面。',
    formal: '石榴石型 LLZO 固态电解质 (锂枝晶)（Garnet LLZO solid electrolyte (Li dendrite suppression)）：Murugan / 多团队 在 2007 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ガーネットLLZO固体電解質（ Li樹枝状結晶抑制） ： 2007年にMurugan/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Electrolito sólido Garnet LLZO (supresión de dendritas de Li): propuesto por Murugan/varios equipos en 2007, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Garnet LLZO solid electrolyte (Li dendrite suppression): proposed by Murugan / 多团队 in 2007; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Murugan / 多团队 等人在 2007 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['固态', '电池'],
  },
  {
    id: 'mat-sulfide-electrolyte',
    category: 'materials',
    title: '硫化物固态电解质 (Li6PS5Cl) 空气稳定',
    titleJa: '硫化物固体電解質（ Li 6 PS 5 Cl ）空気安定化',
    titleEs: 'Estabilidad del aire del electrolito sólido de sulfuro (estabilidad del aire del electrolito sólido de sulfuro): propuesta por Adeli/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Sulfide solid electrolyte air stability',
    year: 2010,
    proposer: 'Adeli / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：硫化物固态电解质 (Li6PS5Cl) 空气稳定。',
    summaryJa: '材料分野における特定の困難な問題：硫化物固体電解質（ Li 6 PS 5 Cl ）の空気安定性。',
    summaryEs: 'Estabilidad del aire del electrolito sólido de sulfuro (estabilidad del aire del electrolito sólido de sulfuro): propuesta por Adeli/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Sulfide solid electrolyte air stability.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 硫化物固态电解质 (Li6PS5Cl) 空气稳定。它说的是 「硫化物固态电解质 (Li6PS5Cl) 空气稳定」是 材料 领域的 固态 方向，涉及 固态, 电池 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「硫化物固态电解质 (Li6PS5Cl) 空气稳定」是 材料 领域的 固态 方向，涉及 固态, 电池 等方面。',
    formal: '硫化物固态电解质 (Li6PS5Cl) 空气稳定（Sulfide solid electrolyte air stability）：Adeli / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '硫化物固体電解質空気安定性（ Li 6 PS 5 Cl ） ： 2010年にADELI/マルチチームが提案され、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Estabilidad del aire del electrolito sólido de sulfuro (estabilidad del aire del electrolito sólido de sulfuro): propuesta por Adeli/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Sulfide solid electrolyte air stability: proposed by Adeli / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['固态', '电池'],
  },
  {
    id: 'mat-peo-electrolyte',
    category: 'materials',
    title: 'PEO 基聚合物固态电解质室温电导率',
    titleJa: 'PEO系ポリマー固体電解質の室温導電率',
    titleEs: 'Conductividad a temperatura ambiente del electrolito de polímero PEO: Fenton y varios equipos lo propusieron en 1973, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'PEO polymer electrolyte room-temperature conductivity',
    year: 1973,
    proposer: 'Fenton / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：PEO 基聚合物固态电解质室温电导率。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：PEO系高分子固体電解質の室温における導電率。',
    summaryEs: 'Conductividad a temperatura ambiente del electrolito de polímero PEO: Fenton y varios equipos lo propusieron en 1973, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: PEO polymer electrolyte room-temperature conductivity.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 PEO 基聚合物固态电解质室温电导率 的核心问题是：「PEO 基聚合物固态电解质室温电导率」是 材料 领域的 固态 方向，涉及 固态, 电池 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「PEO 基聚合物固态电解质室温电导率」是 材料 领域的 固态 方向，涉及 固态, 电池 等方面。',
    formal: 'PEO 基聚合物固态电解质室温电导率（PEO polymer electrolyte room-temperature conductivity）：Fenton / 多团队 在 1973 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'PEO高分子電解液室温伝導度（ PEO高分子電解液室温伝導度） ： 1973年にフェントン/マルチチームが提案され、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Conductividad a temperatura ambiente del electrolito de polímero PEO: Fenton y varios equipos lo propusieron en 1973, y los experimentos y teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'PEO polymer electrolyte room-temperature conductivity: proposed by Fenton / 多团队 in 1973; related experiments/theory remain incomplete.',
    whyHard: '「PEO 基聚合物固态电解质室温电导率」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['固态', '电池'],
  },
  {
    id: 'mat-licoo2-degradation',
    category: 'materials',
    title: 'LiCoO2 高电压 (>4.5V) 循环衰减',
    titleJa: 'LiCoO 2高電圧（> 4.5V ）サイクル減衰',
    titleEs: 'Degradación cíclica de LiCoO2 a alto voltaje (degradación cíclica de LiCoO2 a alto voltaje): propuesta por Goodenough/varios equipos en 1980, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'LiCoO2 cycling degradation at high voltage',
    year: 1980,
    proposer: 'Goodenough / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：LiCoO2 高电压 (>4.5V) 循环衰减。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：LiCoO2の高電圧（&gt;4.5V）サイクル劣化。',
    summaryEs: 'Degradación cíclica de LiCoO2 a alto voltaje (degradación cíclica de LiCoO2 a alto voltaje): propuesta por Goodenough/varios equipos en 1980, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: LiCoO2 cycling degradation at high voltage.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 LiCoO2 高电压 (>4.5V) 循环衰减 的核心问题是：「LiCoO2 高电压 (>4.5V) 循环衰减」是 材料 领域的 正极 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「LiCoO2 高电压 (>4.5V) 循环衰减」是 材料 领域的 正极 方向。',
    formal: 'LiCoO2 高电压 (>4.5V) 循环衰减（LiCoO2 cycling degradation at high voltage）：Goodenough / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: '高電圧（> 4.5V ）でのLiCoO 2サイクル分解： 1980年にGoodenough/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Degradación cíclica de LiCoO2 a alto voltaje (degradación cíclica de LiCoO2 a alto voltaje): propuesta por Goodenough/varios equipos en 1980, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'LiCoO2 cycling degradation at high voltage: proposed by Goodenough / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Goodenough / 多团队 等人在 1980 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['正极'],
  },
  {
    id: 'mat-nmc811-degradation',
    category: 'materials',
    title: 'NMC811 高镍正极颗粒裂纹',
    titleJa: 'NMC811高ニッケルカソード粒子の亀裂',
    titleEs: 'Cracking de partículas NMC811 en cátodos con alto contenido de Ni: propuesto por Ohzuku/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'NMC811 particle cracking in high-Ni cathodes',
    year: 2000,
    proposer: 'Ohzuku / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：NMC811 高镍正极颗粒裂纹。',
    summaryJa: '材料科学分野における具体的かつ困難な課題：NMC811高ニッケル正極粒子の亀裂発生。',
    summaryEs: 'Cracking de partículas NMC811 en cátodos con alto contenido de Ni: propuesto por Ohzuku/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: NMC811 particle cracking in high-Ni cathodes.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 NMC811 高镍正极颗粒裂纹 的问题。它可以简单描述为 「NMC811 高镍正极颗粒裂纹」是 材料 领域的 正极 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「NMC811 高镍正极颗粒裂纹」是 材料 领域的 正极 方向。',
    formal: 'NMC811 高镍正极颗粒裂纹（NMC811 particle cracking in high-Ni cathodes）：Ohzuku / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '高ニッケルカソードにおけるNMC811粒子の亀裂：この問題は2000年に大津久氏らのチームによって提起され、関連する実験的・理論的な解決策はまだ完全には解明されていない。',
    formalEs: 'Cracking de partículas NMC811 en cátodos con alto contenido de Ni: propuesto por Ohzuku/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'NMC811 particle cracking in high-Ni cathodes: proposed by Ohzuku / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['正极'],
  },
  {
    id: 'mat-li-rich-fade',
    category: 'materials',
    title: '富锂锰基正极电压衰减',
    titleJa: 'リチウムリッチマンガン系正極の電圧低下',
    titleEs: 'Desvanecimiento de voltaje en cátodos basados ​​en Mn ricos en Li: propuesto por Thackeray/múltiples equipos en 1999, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Voltage fade in Li-rich Mn-based cathodes',
    year: 1999,
    proposer: 'Thackeray / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：富锂锰基正极电压衰减。',
    summaryJa: '材料分野における特定の困難な問題：リチウムリッチマンガンベースの正極電圧減衰。',
    summaryEs: 'Desvanecimiento de voltaje en cátodos basados ​​en Mn ricos en Li: propuesto por Thackeray/múltiples equipos en 1999, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Voltage fade in Li-rich Mn-based cathodes.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 富锂锰基正极电压衰减。它说的是 「富锂锰基正极电压衰减」是 材料 领域的 正极 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「富锂锰基正极电压衰减」是 材料 领域的 正极 方向。',
    formal: '富锂锰基正极电压衰减（Voltage fade in Li-rich Mn-based cathodes）：Thackeray / 多团队 在 1999 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'LiリッチMnベースのカソードでの電圧フェード： Thackeray/Multiチームは1999年に提案し、関連する実験/理論はこれまで完全には解決されていません。',
    formalEs: 'Desvanecimiento de voltaje en cátodos basados ​​en Mn ricos en Li: propuesto por Thackeray/múltiples equipos en 1999, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Voltage fade in Li-rich Mn-based cathodes: proposed by Thackeray / 多团队 in 1999; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Thackeray / 多团队 等人在 1999 年提出，但至今未完全解决。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['正极'],
  },
  {
    id: 'mat-si-anode',
    category: 'materials',
    title: '硅负极体积膨胀 (>300%) 抑制',
    titleJa: 'シリコン負極体積膨張（> 300 ％ ）阻害',
    titleEs: 'Supresión de la expansión del volumen del ánodo de Si (>300%): propuesto por Sharma/múltiples equipos en 1976, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Suppression of Si anode volume expansion (>300%)',
    year: 1976,
    proposer: 'Sharma / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：硅负极体积膨胀 (>300%) 抑制。',
    summaryJa: '材料分野の特定の難題：シリコンアノードボリュームエクスパンション（> 300 ％ ）抑制。',
    summaryEs: 'Supresión de la expansión del volumen del ánodo de Si (>300%): propuesto por Sharma/múltiples equipos en 1976, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Suppression of Si anode volume expansion (>300%).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 硅负极体积膨胀 (>300%) 抑制 的问题。它可以简单描述为 「硅负极体积膨胀 (>300%) 抑制」是 材料 领域的 负极 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「硅负极体积膨胀 (>300%) 抑制」是 材料 领域的 负极 方向。',
    formal: '硅负极体积膨胀 (>300%) 抑制（Suppression of Si anode volume expansion (>300%)）：Sharma / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Si陽極体積膨張の抑制（> 300 ％ ） ： Sharma/Multiチームは1976年に提案し、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Supresión de la expansión del volumen del ánodo de Si (>300%): propuesto por Sharma/múltiples equipos en 1976, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Suppression of Si anode volume expansion (>300%): proposed by Sharma / 多团队 in 1976; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['负极'],
  },
  {
    id: 'mat-prussian-blue',
    category: 'materials',
    title: '普鲁士蓝类钠电正极稳定性',
    titleJa: 'プロイセンブルーナトリウム電極の安定性',
    titleEs: 'Estabilidad del cátodo de Na azul de Prusia: propuesta por Lu/varios equipos en 2012, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Prussian blue Na cathode stability',
    year: 2012,
    proposer: 'Lu / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：普鲁士蓝类钠电正极稳定性。',
    summaryJa: '材料分野における特定の難題：プロシアンブルーナトリウム電極の安定性。',
    summaryEs: 'Estabilidad del cátodo de Na azul de Prusia: propuesta por Lu/varios equipos en 2012, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Prussian blue Na cathode stability.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 普鲁士蓝类钠电正极稳定性 是这样一个问题：「普鲁士蓝类钠电正极稳定性」是 材料 领域的 钠电 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「普鲁士蓝类钠电正极稳定性」是 材料 领域的 钠电 方向。',
    formal: '普鲁士蓝类钠电正极稳定性（Prussian blue Na cathode stability）：Lu / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'プロシアンブルーのNaカソード安定性： Lu/Multiチームは2012年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Estabilidad del cátodo de Na azul de Prusia: propuesta por Lu/varios equipos en 2012, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Prussian blue Na cathode stability: proposed by Lu / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钠电'],
  },
  {
    id: 'mat-zn-air',
    category: 'materials',
    title: '可充锌空气电池往返效率',
    titleJa: '充電式亜鉛空気電池の往復効率',
    titleEs: 'Eficiencia de ida y vuelta de baterías recargables de Zn-aire: propuesta por varios equipos en 1996, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Round-trip efficiency of rechargeable Zn-air batteries',
    year: 1996,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：可充锌空气电池往返效率。',
    summaryJa: '材料分野の特定の困難な問題：充電式亜鉛空気電池の往復効率。',
    summaryEs: 'Eficiencia de ida y vuelta de baterías recargables de Zn-aire: propuesta por varios equipos en 1996, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Round-trip efficiency of rechargeable Zn-air batteries.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 可充锌空气电池往返效率 的问题。它可以简单描述为 「可充锌空气电池往返效率」是 材料 领域的 锌 方向，涉及 锌, 电池 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「可充锌空气电池往返效率」是 材料 领域的 锌 方向，涉及 锌, 电池 等方面。',
    formal: '可充锌空气电池往返效率（Round-trip efficiency of rechargeable Zn-air batteries）：多团队 在 1996 年提出，相关实验/理论至今未完全解决。',
    formalJa: '充電式Zn - air電池の往復効率： 1996年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Eficiencia de ida y vuelta de baterías recargables de Zn-aire: propuesta por varios equipos en 1996, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Round-trip efficiency of rechargeable Zn-air batteries: proposed by 多团队 in 1996; related experiments/theory remain incomplete.',
    whyHard: '「可充锌空气电池往返效率」是 材料 领域一个被广泛认可的核心难题。材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['锌', '电池'],
  },
  {
    id: 'mat-vanadium-flow',
    category: 'materials',
    title: '全钒液流电池能量密度',
    titleJa: '総バナジウム流量電池エネルギー密度',
    titleEs: 'Densidad de energía de las baterías de flujo redox de vanadio: propuesta por Skyllas-Kazacos/varios equipos en 1985, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    titleEn: 'Energy density of vanadium redox flow batteries',
    year: 1985,
    proposer: 'Skyllas-Kazacos / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：全钒液流电池能量密度。',
    summaryJa: '材料分野における特定の困難な問題：全バナジウムフローバッテリーのエネルギー密度。',
    summaryEs: 'Densidad de energía de las baterías de flujo redox de vanadio: propuesta por Skyllas-Kazacos/varios equipos en 1985, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Energy density of vanadium redox flow batteries.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这就是 全钒液流电池能量密度。它说的是 「全钒液流电池能量密度」是 材料 领域的 液流 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「全钒液流电池能量密度」是 材料 领域的 液流 方向。',
    formal: '全钒液流电池能量密度（Energy density of vanadium redox flow batteries）：Skyllas-Kazacos / 多团队 在 1985 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'バナジウム酸化還元フロー電池のエネルギー密度： 1985年にSkyllas - Kazacos/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Densidad de energía de las baterías de flujo redox de vanadio: propuesta por Skyllas-Kazacos/varios equipos en 1985, los experimentos/teorías relacionadas aún no se han resuelto por completo.',
    formalEn: 'Energy density of vanadium redox flow batteries: proposed by Skyllas-Kazacos / 多团队 in 1985; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['液流'],
  },
  {
    id: 'mat-perovskite-pv-25',
    category: 'materials',
    title: '卤化物钙钛矿串联 III-V 电池效率纪录',
    titleJa: 'ハロゲン化物ペロブスカイトシリーズIII - V電池効率記録',
    titleEs: 'Registro de eficiencia de celda en tándem III-V de perovskita de haluro (récord de eficiencia de celda en tándem de perovskita/III-V): propuesto por Snaith/varios equipos en 2015, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Perovskite / III-V tandem cell efficiency record',
    year: 2015,
    proposer: 'Snaith / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：卤化物钙钛矿串联 III-V 电池效率纪录。',
    summaryJa: '材料分野における特定の困難な問題：ハロゲン化物ペロブスカイトシリーズIII - V電池効率記録。',
    summaryEs: 'Registro de eficiencia de celda en tándem III-V de perovskita de haluro (récord de eficiencia de celda en tándem de perovskita/III-V): propuesto por Snaith/varios equipos en 2015, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Perovskite / III-V tandem cell efficiency record.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 这是一道关于 卤化物钙钛矿串联 III-V 电池效率纪录 的问题。它可以简单描述为 「卤化物钙钛矿串联 III-V 电池效率纪录」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 串联 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「卤化物钙钛矿串联 III-V 电池效率纪录」是 材料 领域的 钙钛矿 方向，涉及 钙钛矿, 串联 等方面。',
    formal: '卤化物钙钛矿串联 III-V 电池效率纪录（Perovskite / III-V tandem cell efficiency record）：Snaith / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ペロブスカイト/III - Vタンデムセル効率記録： 2015年にスナイス/マルチチームが提案し、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Registro de eficiencia de celda en tándem III-V de perovskita de haluro (récord de eficiencia de celda en tándem de perovskita/III-V): propuesto por Snaith/varios equipos en 2015, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Perovskite / III-V tandem cell efficiency record: proposed by Snaith / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿', '串联'],
  },
  {
    id: 'mat-organolead-bromide',
    category: 'materials',
    title: '有机-无机杂化钙钛矿的离子迁移',
    titleJa: '有機-無機ハイブリッドペロブスカイトのイオン移動',
    titleEs: 'Migración de iones en perovskitas híbridas orgánico-inorgánicas: propuesta por Yuan/varios equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Ion migration in organic-inorganic hybrid perovskites',
    year: 2015,
    proposer: 'Yuan / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：有机-无机杂化钙钛矿的离子迁移。',
    summaryJa: '材料分野における特定の困難な問題：有機-無機ハイブリッドペロブスカイトのイオン移動。',
    summaryEs: 'Migración de iones en perovskitas híbridas orgánico-inorgánicas: propuesta por Yuan/varios equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Ion migration in organic-inorganic hybrid perovskites.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 有机-无机杂化钙钛矿的离子迁移 的核心问题是：「有机-无机杂化钙钛矿的离子迁移」是 材料 领域的 钙钛矿 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「有机-无机杂化钙钛矿的离子迁移」是 材料 领域的 钙钛矿 方向。',
    formal: '有机-无机杂化钙钛矿的离子迁移（Ion migration in organic-inorganic hybrid perovskites）：Yuan / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: '有機-無機ハイブリッドペロブスカイトのイオン移動： 2015年にYuan/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Migración de iones en perovskitas híbridas orgánico-inorgánicas: propuesta por Yuan/varios equipos en 2015, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Ion migration in organic-inorganic hybrid perovskites: proposed by Yuan / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿'],
  },
  {
    id: 'mat-fapi-perovskite',
    category: 'materials',
    title: '甲脒铅碘 (FAPbI3) 钙钛矿相稳定',
    titleJa: 'ヨウ化鉛ホルムアミジン（ ＦＡＰｂＩ ３ ）ペロブスカイトの相安定化',
    titleEs: 'Estabilidad de fase de la perovskita de yoduro de plomo de formamidinio (FAPbI3): propuesta por Snaith/varios equipos en 2014, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Phase stability of formamidinium lead iodide (FAPbI3) perovskite',
    year: 2014,
    proposer: 'Snaith / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：甲脒铅碘 (FAPbI3) 钙钛矿相稳定。',
    summaryJa: '材料分野における特定の困難な問題：ホルムアミジン－鉛－ヨウ素（ ＦＡＰｂＩ ３ ）のペロブスカイト相の安定性。',
    summaryEs: 'Estabilidad de fase de la perovskita de yoduro de plomo de formamidinio (FAPbI3): propuesta por Snaith/varios equipos en 2014, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in materials: Phase stability of formamidinium lead iodide (FAPbI3) perovskite.',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 甲脒铅碘 (FAPbI3) 钙钛矿相稳定 的核心问题是：「甲脒铅碘 (FAPbI3) 钙钛矿相稳定」是 材料 领域的 钙钛矿 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「甲脒铅碘 (FAPbI3) 钙钛矿相稳定」是 材料 领域的 钙钛矿 方向。',
    formal: '甲脒铅碘 (FAPbI3) 钙钛矿相稳定（Phase stability of formamidinium lead iodide (FAPbI3) perovskite）：Snaith / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ホルムアミジニウムヨウ化鉛（ FAPbI 3 ）ペロブスカイトの相安定性： 2014年に提案されたスナイス/マルチチーム、および関連する実験/理論はこれまで完全には解決されていません。',
    formalEs: 'Estabilidad de fase de la perovskita de yoduro de plomo de formamidinio (FAPbI3): propuesta por Snaith/varios equipos en 2014, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Phase stability of formamidinium lead iodide (FAPbI3) perovskite: proposed by Snaith / 多团队 in 2014; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿'],
  },
  {
    id: 'mat-gratzel-dsc',
    category: 'materials',
    title: '染料敏化电池 (Grätzel) 长期稳定性',
    titleJa: '染料増感電池（ Grätzel ）の長期安定性',
    titleEs: 'Estabilidad a largo plazo de las células solares sensibilizadas con colorante (célula de Grätzel): propuesta por O\\\'Regan/Grätzel en 1991, los experimentos/teorías relevantes aún no se han resuelto completamente.',
    titleEn: 'Long-term stability of dye-sensitized solar cells (Grätzel cell)',
    year: 1991,
    proposer: 'O\'Regan / Grätzel',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 材料 领域的具体硬问题：染料敏化电池 (Grätzel) 长期稳定性。',
    summaryJa: '材料分野における特定の困難な問題：染料増感電池（ Grätzel ）の長期安定性。',
    summaryEs: 'Estabilidad a largo plazo de las células solares sensibilizadas con colorante (célula de Grätzel): propuesta por O\\\'Regan/Grätzel en 1991, los experimentos/teorías relevantes aún no se han resuelto completamente.',
    summaryEn: 'A specific hard problem in materials: Long-term stability of dye-sensitized solar cells (Grätzel cell).',
    kid: '想象你把不同的元素像积木一样搭在一起，会出现意想不到的新材料。 染料敏化电池 (Grätzel) 长期稳定性 的核心问题是：「染料敏化电池 (Grätzel) 长期稳定性」是 材料 领域的 DSC 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「染料敏化电池 (Grätzel) 长期稳定性」是 材料 领域的 DSC 方向。',
    formal: '染料敏化电池 (Grätzel) 长期稳定性（Long-term stability of dye-sensitized solar cells (Grätzel cell)）：O\'Regan / Grätzel 在 1991 年提出，相关实验/理论至今未完全解决。',
    formalJa: '色素増感太陽電池（グレーツェルセル）の長期安定性：1991年にオレガンとグレーツェルによって提案されたが、関連する実験的・理論的な問題はまだ完全には解決されていない。',
    formalEn: 'Long-term stability of dye-sensitized solar cells (Grätzel cell): proposed by O\'Regan / Grätzel in 1991; related experiments/theory remain incomplete.',
    whyHard: '尽管 O\'Regan / Grätzel 等人在过去几十年里推动了很多进展，材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。 这道问题仍然开放。',
    whyHardEn: '材料的行为是原子尺度相互作用 + 宏观加工 + 缺陷共同决定的，目前缺少 ab initio 到工业级的可预测模型。',
    aiPrompt: '你是一位材料科学教授，向一个 12 岁的小朋友用日常物品比喻解释这道材料问题，然后说明结构-性能关系、当前最好结果、关键挑战。',
    aiPromptEn: 'You are a rigorous 材料 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['DSC'],
  },
  {
    id: 'chem-c-h-activation',
    category: 'chemistry',
    title: '过渡金属催化 C-H 键活化的区域选择性控制',
    titleJa: '遷移金属触媒によるC - H結合活性化の局所選択的制御',
    titleEs: 'Control regioselectivo de la activación de C-H catalizada por metales de transición: propuesto por Murai/Yu/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Regioselective control of transition metal-catalyzed C-H activation',
    year: 2000,
    proposer: 'Murai / Yu / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 化学 领域的具体硬问题：过渡金属催化 C-H 键活化的区域选择性控制。',
    summaryJa: '化学分野における特定の難題：遷移金属によって触媒されるC - H結合活性化の領域選択的制御。',
    summaryEs: 'Control regioselectivo de la activación de C-H catalizada por metales de transición: propuesto por Murai/Yu/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Regioselective control of transition metal-catalyzed C-H activation.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 过渡金属催化 C-H 键活化的区域选择性控制 的核心问题是：「过渡金属催化 C-H 键活化的区域选择性控制」是 化学 领域的 有机 方向，涉及 有机, 催化 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「过渡金属催化 C-H 键活化的区域选择性控制」是 化学 领域的 有机 方向，涉及 有机, 催化 等方面。',
    formal: '过渡金属催化 C-H 键活化的区域选择性控制（Regioselective control of transition metal-catalyzed C-H activation）：Murai / Yu / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '遷移金属触媒C - H活性化の領域選択的制御： 2000年にMurai/Yu/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Control regioselectivo de la activación de C-H catalizada por metales de transición: propuesto por Murai/Yu/múltiples equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Regioselective control of transition metal-catalyzed C-H activation: proposed by Murai / Yu / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Murai / Yu / 多团队 等人在 2000 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '催化'],
  },
  {
    id: 'chem-asymmetric-cat',
    category: 'chemistry',
    title: '普适性手性催化 (>99% ee)',
    titleJa: '普遍的なキラル触媒作用（> 99 ％ ee ）',
    titleEs: 'Catálisis asimétrica universal (alcance del sustrato) (Catálisis asimétrica universal (alcance del sustrato)): propuesta por Sharpless/Noyori/Knowles en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Universal asymmetric catalysis (substrate scope)',
    year: 2001,
    proposer: 'Sharpless / Noyori / Knowles',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：普适性手性催化 (>99% ee)。',
    summaryJa: '化学分野における特定の難題：普遍的なキラル触媒作用（> 99 ％ ee ）。',
    summaryEs: 'Catálisis asimétrica universal (alcance del sustrato) (Catálisis asimétrica universal (alcance del sustrato)): propuesta por Sharpless/Noyori/Knowles en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Universal asymmetric catalysis (substrate scope).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 普适性手性催化 (>99% ee) 的核心问题是：「普适性手性催化 (>99% ee)」是 化学 领域的 催化 方向，涉及 催化, 手性 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「普适性手性催化 (>99% ee)」是 化学 领域的 催化 方向，涉及 催化, 手性 等方面。',
    formal: '普适性手性催化 (>99% ee)（Universal asymmetric catalysis (substrate scope)）：Sharpless / Noyori / Knowles 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: '普遍的な非対称触媒作用（基質範囲） ： 2001年にSharpless/Noyori/Knowlesによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Catálisis asimétrica universal (alcance del sustrato) (Catálisis asimétrica universal (alcance del sustrato)): propuesta por Sharpless/Noyori/Knowles en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Universal asymmetric catalysis (substrate scope): proposed by Sharpless / Noyori / Knowles in 2001; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Sharpless / Noyori / Knowles 等人在 2001 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['催化', '手性'],
  },
  {
    id: 'chem-olefin-metathesis',
    category: 'chemistry',
    title: '烯烃复分解的 Z/E 选择性',
    titleJa: 'オレフィンメタセシスに対するＺ ／ Ｅ選択性',
    titleEs: 'Selectividad Z/E en metátesis de olefinas: propuesta por Grubbs/Schrock/Chauvin en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Z/E selectivity in olefin metathesis',
    year: 1970,
    proposer: 'Grubbs / Schrock / Chauvin',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：烯烃复分解的 Z/E 选择性。',
    summaryJa: '化学分野における特定の困難な問題：オレフィンメタセシスのZ/E選択性。',
    summaryEs: 'Selectividad Z/E en metátesis de olefinas: propuesta por Grubbs/Schrock/Chauvin en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Z/E selectivity in olefin metathesis.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 烯烃复分解的 Z/E 选择性 的核心问题是：「烯烃复分解的 Z/E 选择性」是 化学 领域的 有机 方向，涉及 有机, 催化 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「烯烃复分解的 Z/E 选择性」是 化学 领域的 有机 方向，涉及 有机, 催化 等方面。',
    formal: '烯烃复分解的 Z/E 选择性（Z/E selectivity in olefin metathesis）：Grubbs / Schrock / Chauvin 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'オレフィンメタセシスにおけるZ/E選択性： 1970年にGrubbs/Schrock/Chauvinによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Selectividad Z/E en metátesis de olefinas: propuesta por Grubbs/Schrock/Chauvin en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Z/E selectivity in olefin metathesis: proposed by Grubbs / Schrock / Chauvin in 1970; related experiments/theory remain incomplete.',
    whyHard: '「烯烃复分解的 Z/E 选择性」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '催化'],
  },
  {
    id: 'chem-suzuki-mechanism',
    category: 'chemistry',
    title: 'Suzuki-Miyaura 偶联的活性物种',
    titleJa: 'Suzuki - Miyaura Coupled Active Species',
    titleEs: 'Especies activas en el acoplamiento Suzuki-Miyaura: propuesta por Suzuki/Miyaura en 1981, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Active species in Suzuki-Miyaura coupling',
    year: 1981,
    proposer: 'Suzuki / Miyaura',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：Suzuki-Miyaura 偶联的活性物种。',
    summaryJa: '化学分野における具体的な難題は、鈴木宮浦が活性種を結合したことである。',
    summaryEs: 'Especies activas en el acoplamiento Suzuki-Miyaura: propuesta por Suzuki/Miyaura en 1981, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Active species in Suzuki-Miyaura coupling.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 Suzuki-Miyaura 偶联的活性物种 的核心问题是：「Suzuki-Miyaura 偶联的活性物种」是 化学 领域的 有机 方向，涉及 有机, 偶联 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Suzuki-Miyaura 偶联的活性物种」是 化学 领域的 有机 方向，涉及 有机, 偶联 等方面。',
    formal: 'Suzuki-Miyaura 偶联的活性物种（Active species in Suzuki-Miyaura coupling）：Suzuki / Miyaura 在 1981 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Suzuki - MiyauraカップリングSuzuki - Miyauraカップリングの活性種： 1981年にSuzuki/Miyauraによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Especies activas en el acoplamiento Suzuki-Miyaura: propuesta por Suzuki/Miyaura en 1981, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Active species in Suzuki-Miyaura coupling: proposed by Suzuki / Miyaura in 1981; related experiments/theory remain incomplete.',
    whyHard: '「Suzuki-Miyaura 偶联的活性物种」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '偶联'],
  },
  {
    id: 'chem-pd-cat-recycle',
    category: 'chemistry',
    title: '钯催化偶联催化剂回收 (>99% / cycle)',
    titleJa: 'パラジウム触媒カップリング触媒回収率（> 99 ％/サイクル）',
    titleEs: 'Recuperación del catalizador de Pd en acoplamiento cruzado (>99 % por ciclo): propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Pd catalyst recovery in cross-coupling (>99% per cycle)',
    year: 2010,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：钯催化偶联催化剂回收 (>99% / cycle)。',
    summaryJa: '化学分野における特定の難題：パラジウム触媒カップリング触媒回収（> 99 ％/サイクル）。',
    summaryEs: 'Recuperación del catalizador de Pd en acoplamiento cruzado (>99 % por ciclo): propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Pd catalyst recovery in cross-coupling (>99% per cycle).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 钯催化偶联催化剂回收 (>99% / cycle)。它说的是 「钯催化偶联催化剂回收 (>99% / cycle)」是 化学 领域的 有机 方向，涉及 有机, 钯 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「钯催化偶联催化剂回收 (>99% / cycle)」是 化学 领域的 有机 方向，涉及 有机, 钯 等方面。',
    formal: '钯催化偶联催化剂回收 (>99% / cycle)（Pd catalyst recovery in cross-coupling (>99% per cycle)）：多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '交差カップリングにおけるPd触媒回収（サイクルあたり> 99 ％ ） ： 2010年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Recuperación del catalizador de Pd en acoplamiento cruzado (>99 % por ciclo): propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Pd catalyst recovery in cross-coupling (>99% per cycle): proposed by 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 2010 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '钯'],
  },
  {
    id: 'chem-photo-water-split',
    category: 'chemistry',
    title: '可见光全分解水的稳定光催化剂',
    titleJa: '可視光による水の全分解のための安定した光触媒',
    titleEs: 'Fotocatalizador estable de luz visible para la división general del agua: propuesto por Fujishima/Honda/varios equipos en 1972, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Stable visible-light photocatalyst for overall water splitting',
    year: 1972,
    proposer: 'Fujishima / Honda / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 化学 领域的具体硬问题：可见光全分解水的稳定光催化剂。',
    summaryJa: '化学分野における特定の困難な問題：可視光による水の全分解のための安定した光触媒。',
    summaryEs: 'Fotocatalizador estable de luz visible para la división general del agua: propuesto por Fujishima/Honda/varios equipos en 1972, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Stable visible-light photocatalyst for overall water splitting.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 可见光全分解水的稳定光催化剂 的核心问题是：「可见光全分解水的稳定光催化剂」是 化学 领域的 光催化 方向，涉及 光催化, 水 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「可见光全分解水的稳定光催化剂」是 化学 领域的 光催化 方向，涉及 光催化, 水 等方面。',
    formal: '可见光全分解水的稳定光催化剂（Stable visible-light photocatalyst for overall water splitting）：Fujishima / Honda / 多团队 在 1972 年提出，相关实验/理论至今未完全解决。',
    formalJa: '全体的な水の分解のための安定した可視光光触媒： 1972年にFujishima/Honda/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Fotocatalizador estable de luz visible para la división general del agua: propuesto por Fujishima/Honda/varios equipos en 1972, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Stable visible-light photocatalyst for overall water splitting: proposed by Fujishima / Honda / 多团队 in 1972; related experiments/theory remain incomplete.',
    whyHard: '「可见光全分解水的稳定光催化剂」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['光催化', '水'],
  },
  {
    id: 'chem-z-scheme',
    category: 'chemistry',
    title: 'Z-scheme 人工光合作用量子效率',
    titleJa: 'Zスキーム人工光合成量子効率',
    titleEs: 'Eficiencia cuántica de la fotosíntesis artificial del esquema Z (Eficiencia cuántica de la fotosíntesis artificial del esquema Z): propuesta por Sayama/varios equipos en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Quantum efficiency of Z-scheme artificial photosynthesis',
    year: 2001,
    proposer: 'Sayama / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：Z-scheme 人工光合作用量子效率。',
    summaryJa: '化学分野における特定の困難な問題： Zスキーム人工光合成の量子効率。',
    summaryEs: 'Eficiencia cuántica de la fotosíntesis artificial del esquema Z (Eficiencia cuántica de la fotosíntesis artificial del esquema Z): propuesta por Sayama/varios equipos en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Quantum efficiency of Z-scheme artificial photosynthesis.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 Z-scheme 人工光合作用量子效率。它说的是 「Z-scheme 人工光合作用量子效率」是 化学 领域的 人工光合 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Z-scheme 人工光合作用量子效率」是 化学 领域的 人工光合 方向。',
    formal: 'Z-scheme 人工光合作用量子效率（Quantum efficiency of Z-scheme artificial photosynthesis）：Sayama / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Zスキーム人工光合成量子効率（ Zスキーム人工光合成の量子効率） ： 2001年にSAYAMA/MULTI - TEAMが提案したが、これまでのところ関連する実験・理論は完全には解決されていない。',
    formalEs: 'Eficiencia cuántica de la fotosíntesis artificial del esquema Z (Eficiencia cuántica de la fotosíntesis artificial del esquema Z): propuesta por Sayama/varios equipos en 2001, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Quantum efficiency of Z-scheme artificial photosynthesis: proposed by Sayama / 多团队 in 2001; related experiments/theory remain incomplete.',
    whyHard: '尽管 Sayama / 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['人工光合'],
  },
  {
    id: 'chem-co2rr-c2',
    category: 'chemistry',
    title: 'CO2 电还原 C2+ 产物 (>70% 法拉第效率)',
    titleJa: 'CO 2電気還元C 2 +製品（ファラデー効率> 70 ％ ）',
    titleEs: 'Reducción de CO2 a productos C2+ con >70 % de eficiencia faradaica: propuesto por Hori/Jaramillo/múltiples equipos en 1985, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'CO2 reduction to C2+ products with >70% Faradaic efficiency',
    year: 1985,
    proposer: 'Hori / Jaramillo / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：CO2 电还原 C2+ 产物 (>70% 法拉第效率)。',
    summaryJa: '化学分野における特定の難題： C 2 +生成物のCO 2電気還元（ファラデー効率> 70 ％ ）。',
    summaryEs: 'Reducción de CO2 a productos C2+ con >70 % de eficiencia faradaica: propuesto por Hori/Jaramillo/múltiples equipos en 1985, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: CO2 reduction to C2+ products with >70% Faradaic efficiency.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 CO2 电还原 C2+ 产物 (>70% 法拉第效率)。它说的是 「CO2 电还原 C2+ 产物 (>70% 法拉第效率)」是 化学 领域的 CO2 方向，涉及 CO2, 电催化 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「CO2 电还原 C2+ 产物 (>70% 法拉第效率)」是 化学 领域的 CO2 方向，涉及 CO2, 电催化 等方面。',
    formal: 'CO2 电还原 C2+ 产物 (>70% 法拉第效率)（CO2 reduction to C2+ products with >70% Faradaic efficiency）：Hori / Jaramillo / 多团队 在 1985 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ファラデー効率70 ％超のC 2 +製品へのCO 2削減（ファラデー効率70 ％超のC 2 +製品へのCO 2削減） ： 1985年にHORI/JARAMILLO/MULTI TEAMが提案され、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Reducción de CO2 a productos C2+ con >70 % de eficiencia faradaica: propuesto por Hori/Jaramillo/múltiples equipos en 1985, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'CO2 reduction to C2+ products with >70% Faradaic efficiency: proposed by Hori / Jaramillo / 多团队 in 1985; related experiments/theory remain incomplete.',
    whyHard: '「CO2 电还原 C2+ 产物 (>70% 法拉第效率)」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CO2', '电催化'],
  },
  {
    id: 'chem-nrr-ambient',
    category: 'chemistry',
    title: '常温常压 N2 电还原合成氨',
    titleJa: '周囲温度および圧力N 2でのアンモニア電気還元合成',
    titleEs: 'Reducción electroquímica de N2 a amoníaco en condiciones ambientales: propuesta por Pickett/varios equipos en 1998, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Ambient-condition electrochemical N2 reduction to ammonia',
    year: 1998,
    proposer: 'Pickett / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 化学 领域的具体硬问题：常温常压 N2 电还原合成氨。',
    summaryJa: '化学分野における特定の困難な問題：アンモニアの周囲温度と圧力N 2電気還元合成。',
    summaryEs: 'Reducción electroquímica de N2 a amoníaco en condiciones ambientales: propuesta por Pickett/varios equipos en 1998, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Ambient-condition electrochemical N2 reduction to ammonia.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 常温常压 N2 电还原合成氨。它说的是 「常温常压 N2 电还原合成氨」是 化学 领域的 NRR 方向，涉及 NRR, 催化 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「常温常压 N2 电还原合成氨」是 化学 领域的 NRR 方向，涉及 NRR, 催化 等方面。',
    formal: '常温常压 N2 电还原合成氨（Ambient-condition electrochemical N2 reduction to ammonia）：Pickett / 多团队 在 1998 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Ambient - condition electrochemical N 2 reduction to ammonia （アンモニアへのAmbient - condition electrochemical N 2 reduction to ammonia ） ： 1998年にPickett/Multi - teamによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Reducción electroquímica de N2 a amoníaco en condiciones ambientales: propuesta por Pickett/varios equipos en 1998, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Ambient-condition electrochemical N2 reduction to ammonia: proposed by Pickett / 多团队 in 1998; related experiments/theory remain incomplete.',
    whyHard: '尽管 Pickett / 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['NRR', '催化'],
  },
  {
    id: 'chem-her-pt-free',
    category: 'chemistry',
    title: '替代 Pt 的析氢反应 (HER) 催化剂',
    titleJa: 'Ptを置き換える水素進化反応（ HER ）触媒',
    titleEs: 'Catalizador sin Pt para la reacción de evolución de hidrógeno (HER) en lugar de Pt: Jaramillo/varios equipos lo propusieron en 2005, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Pt-free catalyst for hydrogen evolution reaction',
    year: 2005,
    proposer: 'Jaramillo / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：替代 Pt 的析氢反应 (HER) 催化剂。',
    summaryJa: '化学分野における特定の困難な問題： Ptの代わりに水素進化反応（ HER ）触媒。',
    summaryEs: 'Catalizador sin Pt para la reacción de evolución de hidrógeno (HER) en lugar de Pt: Jaramillo/varios equipos lo propusieron en 2005, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Pt-free catalyst for hydrogen evolution reaction.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 替代 Pt 的析氢反应 (HER) 催化剂 的核心问题是：「替代 Pt 的析氢反应 (HER) 催化剂」是 化学 领域的 HER 方向，涉及 HER, 催化 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「替代 Pt 的析氢反应 (HER) 催化剂」是 化学 领域的 HER 方向，涉及 HER, 催化 等方面。',
    formal: '替代 Pt 的析氢反应 (HER) 催化剂（Pt-free catalyst for hydrogen evolution reaction）：Jaramillo / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: '２ ０ ０ ５年に提案されたＰｔ ： Ｊａｒａｍｉｌｌｏ ／マルチチームを置き換えるための水素進化反応（ ＨＥＲ ）のためのＰｔフリー触媒であり、関連する実験／理論は完全には解決されていない。',
    formalEs: 'Catalizador sin Pt para la reacción de evolución de hidrógeno (HER) en lugar de Pt: Jaramillo/varios equipos lo propusieron en 2005, y los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Pt-free catalyst for hydrogen evolution reaction: proposed by Jaramillo / 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '「替代 Pt 的析氢反应 (HER) 催化剂」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['HER', '催化'],
  },
  {
    id: 'chem-oer-cheap',
    category: 'chemistry',
    title: '廉价 OER 催化剂 (10 mA/cm² @ 1.5V)',
    titleJa: '安価なOER触媒（ 10 mA/cm ² @ 1.5V ）',
    titleEs: 'Catalizador REA barato a 10 mA/cm² con sobrepotencial de 1,5 V: propuesto por Markovic/varios equipos en 2008, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Cheap OER catalyst at 10 mA/cm² with 1.5V overpotential',
    year: 2008,
    proposer: 'Markovic / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：廉价 OER 催化剂 (10 mA/cm² @ 1.5V)。',
    summaryJa: '化学分野における特定の困難な問題：安価なOER触媒（ 10 mA/cm 2 @ 1.5V ）。',
    summaryEs: 'Catalizador REA barato a 10 mA/cm² con sobrepotencial de 1,5 V: propuesto por Markovic/varios equipos en 2008, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Cheap OER catalyst at 10 mA/cm² with 1.5V overpotential.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 廉价 OER 催化剂 (10 mA/cm² @ 1.5V) 是这样一个问题：「廉价 OER 催化剂 (10 mA/cm² @ 1.5V)」是 化学 领域的 OER 方向，涉及 OER, 催化 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「廉价 OER 催化剂 (10 mA/cm² @ 1.5V)」是 化学 领域的 OER 方向，涉及 OER, 催化 等方面。',
    formal: '廉价 OER 催化剂 (10 mA/cm² @ 1.5V)（Cheap OER catalyst at 10 mA/cm² with 1.5V overpotential）：Markovic / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalJa: '1.5V過電位（ 10 mA/cm ² @ 1.5V ）で10 mA/cm ²の安価なOER触媒： 2008年にMarkovic/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Catalizador REA barato a 10 mA/cm² con sobrepotencial de 1,5 V: propuesto por Markovic/varios equipos en 2008, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Cheap OER catalyst at 10 mA/cm² with 1.5V overpotential: proposed by Markovic / 多团队 in 2008; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['OER', '催化'],
  },
  {
    id: 'chem-orr-kinetics',
    category: 'chemistry',
    title: '氧还原反应 (ORR) 动力学瓶颈',
    titleJa: '酸素還元反応（ ORR ）動態ボトルネック',
    titleEs: 'Cuello de botella cinético de la reacción de reducción de oxígeno (ORR): propuesto por Damjanovic/varios equipos en 1960, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Kinetic bottleneck of oxygen reduction reaction (ORR)',
    year: 1960,
    proposer: 'Damjanovic / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：氧还原反应 (ORR) 动力学瓶颈。',
    summaryJa: '化学における特定の難しい問題：酸素還元反応（ ORR ）の動態ボトルネック。',
    summaryEs: 'Cuello de botella cinético de la reacción de reducción de oxígeno (ORR): propuesto por Damjanovic/varios equipos en 1960, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Kinetic bottleneck of oxygen reduction reaction (ORR).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 氧还原反应 (ORR) 动力学瓶颈 是这样一个问题：「氧还原反应 (ORR) 动力学瓶颈」是 化学 领域的 ORR 方向，涉及 ORR, 催化 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「氧还原反应 (ORR) 动力学瓶颈」是 化学 领域的 ORR 方向，涉及 ORR, 催化 等方面。',
    formal: '氧还原反应 (ORR) 动力学瓶颈（Kinetic bottleneck of oxygen reduction reaction (ORR)）：Damjanovic / 多团队 在 1960 年提出，相关实验/理论至今未完全解决。',
    formalJa: '酸素還元反応（ ORR ）の動力学的ボトルネック： 1960年にDamjanovic/複数のチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Cuello de botella cinético de la reacción de reducción de oxígeno (ORR): propuesto por Damjanovic/varios equipos en 1960, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Kinetic bottleneck of oxygen reduction reaction (ORR): proposed by Damjanovic / 多团队 in 1960; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['ORR', '催化'],
  },
  {
    id: 'chem-sac-synthesis',
    category: 'chemistry',
    title: '单原子催化剂 (SAC) 通用合成',
    titleJa: '単原子触媒（ SAC ）ユニバーサル合成',
    titleEs: 'Síntesis generalizada de catalizadores de un solo átomo (SAC): propuesta por Zhang/varios equipos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Generalized synthesis of single-atom catalysts (SAC)',
    year: 2011,
    proposer: 'Zhang / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：单原子催化剂 (SAC) 通用合成。',
    summaryJa: '化学分野における特定の困難な問題：単原子触媒（ ＳＡＣ ）の一般的な合成。',
    summaryEs: 'Síntesis generalizada de catalizadores de un solo átomo (SAC): propuesta por Zhang/varios equipos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Generalized synthesis of single-atom catalysts (SAC).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 单原子催化剂 (SAC) 通用合成 的核心问题是：「单原子催化剂 (SAC) 通用合成」是 化学 领域的 SAC 方向，涉及 SAC, 催化 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「单原子催化剂 (SAC) 通用合成」是 化学 领域的 SAC 方向，涉及 SAC, 催化 等方面。',
    formal: '单原子催化剂 (SAC) 通用合成（Generalized synthesis of single-atom catalysts (SAC)）：Zhang / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: '単原子触媒の一般化合成（ SAC ） ： 2011年にZhang/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Síntesis generalizada de catalizadores de un solo átomo (SAC): propuesta por Zhang/varios equipos en 2011, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Generalized synthesis of single-atom catalysts (SAC): proposed by Zhang / 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '「单原子催化剂 (SAC) 通用合成」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SAC', '催化'],
  },
  {
    id: 'chem-mof-co2-cyclo',
    category: 'chemistry',
    title: 'MOF 催化 CO2 环加成反应',
    titleJa: 'MOFはCO 2環付加反応を触媒する',
    titleEs: 'Cicloadición de CO2 catalizada por MOF: propuesta por Cohen/varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'MOF-catalyzed CO2 cycloaddition',
    year: 2009,
    proposer: 'Cohen / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：MOF 催化 CO2 环加成反应。',
    summaryJa: '化学分野における特定の難題： MOFはCO 2環付加反応を触媒する。',
    summaryEs: 'Cicloadición de CO2 catalizada por MOF: propuesta por Cohen/varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: MOF-catalyzed CO2 cycloaddition.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 MOF 催化 CO2 环加成反应 的核心问题是：「MOF 催化 CO2 环加成反应」是 化学 领域的 MOF 方向，涉及 MOF, CO2 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「MOF 催化 CO2 环加成反应」是 化学 领域的 MOF 方向，涉及 MOF, CO2 等方面。',
    formal: 'MOF 催化 CO2 环加成反应（MOF-catalyzed CO2 cycloaddition）：Cohen / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＭＯＦ触媒ＣＯ２環付加（ ＭＯＦ触媒ＣＯ２環付加） ： ２ ０ ０ ９年にＣｏｈｅｎ ／マルチチームによって提案されたが、これまでのところ関連する実験／理論は完全に解決されていない。',
    formalEs: 'Cicloadición de CO2 catalizada por MOF: propuesta por Cohen/varios equipos en 2009, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'MOF-catalyzed CO2 cycloaddition: proposed by Cohen / 多团队 in 2009; related experiments/theory remain incomplete.',
    whyHard: '「MOF 催化 CO2 环加成反应」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MOF', 'CO2'],
  },
  {
    id: 'chem-cyp450-mech',
    category: 'chemistry',
    title: 'CYP450 酶的 C-H 羟化机制',
    titleJa: 'CYP 450酵素のC - Hヒドロキシル化機構',
    titleEs: 'Mecanismo de hidroxilación C-H de la enzima CYP450: Ortiz de Montellano/varios equipos lo propusieron en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'C-H hydroxylation mechanism of CYP450',
    year: 1970,
    proposer: 'Ortiz de Montellano / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：CYP450 酶的 C-H 羟化机制。',
    summaryJa: '化学分野における特定の難題： CYP 450酵素のC - Hヒドロキシル化機構。',
    summaryEs: 'Mecanismo de hidroxilación C-H de la enzima CYP450: Ortiz de Montellano/varios equipos lo propusieron en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: C-H hydroxylation mechanism of CYP450.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 CYP450 酶的 C-H 羟化机制 的问题。它可以简单描述为 「CYP450 酶的 C-H 羟化机制」是 化学 领域的 酶 方向，涉及 酶, 催化 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「CYP450 酶的 C-H 羟化机制」是 化学 领域的 酶 方向，涉及 酶, 催化 等方面。',
    formal: 'CYP450 酶的 C-H 羟化机制（C-H hydroxylation mechanism of CYP450）：Ortiz de Montellano / 多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'CYP 450酵素のC - Hヒドロキシル化メカニズム（ CYP 450のC - Hヒドロキシル化メカニズム） ： 1970年にOrtiz de Montellano/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de hidroxilación C-H de la enzima CYP450: Ortiz de Montellano/varios equipos lo propusieron en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'C-H hydroxylation mechanism of CYP450: proposed by Ortiz de Montellano / 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '尽管 Ortiz de Montellano / 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['酶', '催化'],
  },
  {
    id: 'chem-adc-linker',
    category: 'chemistry',
    title: 'ADC (抗体偶联药物) 稳定链接化学',
    titleJa: 'ＡＤＣ （抗体結合薬）安定化リンク化学',
    titleEs: 'Química del conector estable ADC (conjugado de fármaco-anticuerpo) (Química del conector estable para conjugados anticuerpo-fármaco (ADC)): propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Stable linker chemistry for antibody-drug conjugates (ADC)',
    year: 2010,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：ADC (抗体偶联药物) 稳定链接化学。',
    summaryJa: '化学の分野における特定の困難な問題： ADCS （抗体コンジュゲート薬物）は、リンク化学を安定させる。',
    summaryEs: 'Química del conector estable ADC (conjugado de fármaco-anticuerpo) (Química del conector estable para conjugados anticuerpo-fármaco (ADC)): propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Stable linker chemistry for antibody-drug conjugates (ADC).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 ADC (抗体偶联药物) 稳定链接化学 的问题。它可以简单描述为 「ADC (抗体偶联药物) 稳定链接化学」是 化学 领域的 ADC 方向，涉及 ADC, 药物 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「ADC (抗体偶联药物) 稳定链接化学」是 化学 领域的 ADC 方向，涉及 ADC, 药物 等方面。',
    formal: 'ADC (抗体偶联药物) 稳定链接化学（Stable linker chemistry for antibody-drug conjugates (ADC)）：多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ADC （抗体-薬物コンジュゲート）抗体-薬物コンジュゲートのための安定したリンカー化学（ ADC ） ： 2010年に複数のチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Química del conector estable ADC (conjugado de fármaco-anticuerpo) (Química del conector estable para conjugados anticuerpo-fármaco (ADC)): propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Stable linker chemistry for antibody-drug conjugates (ADC): proposed by 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 2010 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['ADC', '药物'],
  },
  {
    id: 'chem-protac-selectivity',
    category: 'chemistry',
    title: 'PROTAC 三元复合物的稳定性与选择性',
    titleJa: 'ＰＲＯＴＡＣ三元複合体の安定性及び選択性',
    titleEs: 'Estabilidad compleja ternaria y selectividad de los degradadores PROTAC: propuesto por Sakamoto/Tripulaciones/múltiples equipos en 2001, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Ternary complex stability and selectivity of PROTAC degraders',
    year: 2001,
    proposer: 'Sakamoto / Crews / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：PROTAC 三元复合物的稳定性与选择性。',
    summaryJa: '化学分野における特定の難題： PROTAC三元複合体の安定性と選択性。',
    summaryEs: 'Estabilidad compleja ternaria y selectividad de los degradadores PROTAC: propuesto por Sakamoto/Tripulaciones/múltiples equipos en 2001, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Ternary complex stability and selectivity of PROTAC degraders.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 PROTAC 三元复合物的稳定性与选择性。它说的是 「PROTAC 三元复合物的稳定性与选择性」是 化学 领域的 PROTAC 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「PROTAC 三元复合物的稳定性与选择性」是 化学 领域的 PROTAC 方向。',
    formal: 'PROTAC 三元复合物的稳定性与选择性（Ternary complex stability and selectivity of PROTAC degraders）：Sakamoto / Crews / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'PROTAC分解物質の三元複合体安定性と選択性： 2001年にSakamoto/Crews/multi - teamによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Estabilidad compleja ternaria y selectividad de los degradadores PROTAC: propuesto por Sakamoto/Tripulaciones/múltiples equipos en 2001, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Ternary complex stability and selectivity of PROTAC degraders: proposed by Sakamoto / Crews / 多团队 in 2001; related experiments/theory remain incomplete.',
    whyHard: '尽管 Sakamoto / Crews / 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['PROTAC'],
  },
  {
    id: 'chem-mol-glue',
    category: 'chemistry',
    title: '分子胶 (molecular glue) 设计原则',
    titleJa: '分子接着剤の設計原理',
    titleEs: 'Principios de diseño de pegamentos moleculares: propuestos por Ito/varios equipos en 1992, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Design principles of molecular glues',
    year: 1992,
    proposer: 'Ito / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：分子胶 (molecular glue) 设计原则。',
    summaryJa: '化学分野における特定の難題：分子接着剤設計原理。',
    summaryEs: 'Principios de diseño de pegamentos moleculares: propuestos por Ito/varios equipos en 1992, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Design principles of molecular glues.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 分子胶 (molecular glue) 设计原则 的核心问题是：「分子胶 (molecular glue) 设计原则」是 化学 领域的 药物 方向，涉及 药物, 胶 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「分子胶 (molecular glue) 设计原则」是 化学 领域的 药物 方向，涉及 药物, 胶 等方面。',
    formal: '分子胶 (molecular glue) 设计原则（Design principles of molecular glues）：Ito / 多团队 在 1992 年提出，相关实验/理论至今未完全解决。',
    formalJa: '分子接着剤分子接着剤の設計原理： 1992年に提唱されたITO/マルチチームであり、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Principios de diseño de pegamentos moleculares: propuestos por Ito/varios equipos en 1992, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Design principles of molecular glues: proposed by Ito / 多团队 in 1992; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['药物', '胶'],
  },
  {
    id: 'chem-del-library',
    category: 'chemistry',
    title: 'DNA 编码化合物库 (DEL) 通用筛选方法',
    titleJa: 'ＤＮＡコード化合物ライブラリ（ ｄｅｌ ）の一般的スクリーニング方法',
    titleEs: 'Detección generalizada de bibliotecas codificadas por ADN (DEL): propuesta por Brenner/Lerner/múltiples equipos en 1992, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Generalized screening of DNA-encoded libraries (DEL)',
    year: 1992,
    proposer: 'Brenner / Lerner / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：DNA 编码化合物库 (DEL) 通用筛选方法。',
    summaryJa: '化学分野における特定の困難な問題： ＤＮＡコード化合物ライブラリ（ ＤＥＬ ）ユニバーサルスクリーニング法。',
    summaryEs: 'Detección generalizada de bibliotecas codificadas por ADN (DEL): propuesta por Brenner/Lerner/múltiples equipos en 1992, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Generalized screening of DNA-encoded libraries (DEL).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 DNA 编码化合物库 (DEL) 通用筛选方法 的问题。它可以简单描述为 「DNA 编码化合物库 (DEL) 通用筛选方法」是 化学 领域的 DEL 方向，涉及 DEL, 筛选 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「DNA 编码化合物库 (DEL) 通用筛选方法」是 化学 领域的 DEL 方向，涉及 DEL, 筛选 等方面。',
    formal: 'DNA 编码化合物库 (DEL) 通用筛选方法（Generalized screening of DNA-encoded libraries (DEL)）：Brenner / Lerner / 多团队 在 1992 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＤＮＡコード化ライブラリー（ ＤＥＬ ）の一般化スクリーニング： Ｂｒｅｎｎｅｒ ／ Ｌｅｒｎｅｒ ／ Ｍｕｌｔｉチームは１ ９ ９ ２年に提案し、関連する実験／理論は完全には解決されていない。',
    formalEs: 'Detección generalizada de bibliotecas codificadas por ADN (DEL): propuesta por Brenner/Lerner/múltiples equipos en 1992, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Generalized screening of DNA-encoded libraries (DEL): proposed by Brenner / Lerner / 多团队 in 1992; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['DEL', '筛选'],
  },
  {
    id: 'chem-automated-synth',
    category: 'chemistry',
    title: '化学机器人 (chemputation) 自动化全合成',
    titleJa: '化学ロボットの自動全合成（ chemputation ）',
    titleEs: 'Robot químico (chemputation) para síntesis totalmente automatizada: propuesto por Cronin/varios equipos en 2018, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Chemical robot (chemputation) for full automated synthesis',
    year: 2018,
    proposer: 'Cronin / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：化学机器人 (chemputation) 自动化全合成。',
    summaryJa: '化学分野における特定の難題：化学ロボットの自動全合成（ chemputation ）。',
    summaryEs: 'Robot químico (chemputation) para síntesis totalmente automatizada: propuesto por Cronin/varios equipos en 2018, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Chemical robot (chemputation) for full automated synthesis.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 化学机器人 (chemputation) 自动化全合成 的问题。它可以简单描述为 「化学机器人 (chemputation) 自动化全合成」是 化学 领域的 自动化 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「化学机器人 (chemputation) 自动化全合成」是 化学 领域的 自动化 方向。',
    formal: '化学机器人 (chemputation) 自动化全合成（Chemical robot (chemputation) for full automated synthesis）：Cronin / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    formalJa: '完全自動合成のための化学ロボット（ chemputation ） ： 2018年にCronin/Multi - teamによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Robot químico (chemputation) para síntesis totalmente automatizada: propuesto por Cronin/varios equipos en 2018, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Chemical robot (chemputation) for full automated synthesis: proposed by Cronin / 多团队 in 2018; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自动化'],
  },
  {
    id: 'chem-flow-chem',
    category: 'chemistry',
    title: '流动化学的通用平台',
    titleJa: 'フローケミストリーのための共通プラットフォーム',
    titleEs: 'Plataforma universal de química de flujo: propuesta por Bavand/múltiples equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Universal flow chemistry platform',
    year: 1990,
    proposer: 'Bavand / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：流动化学的通用平台。',
    summaryJa: '化学分野における特定の困難な問題：フロー化学のためのユニバーサルプラットフォーム。',
    summaryEs: 'Plataforma universal de química de flujo: propuesta por Bavand/múltiples equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Universal flow chemistry platform.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 流动化学的通用平台 的核心问题是：「流动化学的通用平台」是 化学 领域的 流动 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「流动化学的通用平台」是 化学 领域的 流动 方向。',
    formal: '流动化学的通用平台（Universal flow chemistry platform）：Bavand / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ユニバーサルフローケミストリープラットフォーム： Bavand/マルチチームは1990年に、関連する実験/理論がまだ完全に解決されていないことを提案しました。',
    formalEs: 'Plataforma universal de química de flujo: propuesta por Bavand/múltiples equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Universal flow chemistry platform: proposed by Bavand / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Bavand / 多团队 等人在 1990 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['流动'],
  },
  {
    id: 'chem-rotaxane',
    category: 'chemistry',
    title: '轮烷 (rotaxane) 与索烃大规模合成',
    titleJa: 'ロタキサンとソーダ炭化水素の大規模合成',
    titleEs: 'Síntesis a gran escala de rotaxanos y catenanos: propuesta por Stoddart y varios equipos en 1994, los experimentos y teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Large-scale synthesis of rotaxanes and catenanes',
    year: 1994,
    proposer: 'Stoddart / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：轮烷 (rotaxane) 与索烃大规模合成。',
    summaryJa: '化学分野における特定の難題：ロタキサンとソーダ炭化水素の大規模な合成。',
    summaryEs: 'Síntesis a gran escala de rotaxanos y catenanos: propuesta por Stoddart y varios equipos en 1994, los experimentos y teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Large-scale synthesis of rotaxanes and catenanes.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 轮烷 (rotaxane) 与索烃大规模合成 是这样一个问题：「轮烷 (rotaxane) 与索烃大规模合成」是 化学 领域的 机械互锁 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「轮烷 (rotaxane) 与索烃大规模合成」是 化学 领域的 机械互锁 方向。',
    formal: '轮烷 (rotaxane) 与索烃大规模合成（Large-scale synthesis of rotaxanes and catenanes）：Stoddart / 多团队 在 1994 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ロタキサンとロタキサンおよびカテナンの大規模合成： 1994年にStoddart/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Síntesis a gran escala de rotaxanos y catenanos: propuesta por Stoddart y varios equipos en 1994, los experimentos y teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Large-scale synthesis of rotaxanes and catenanes: proposed by Stoddart / 多团队 in 1994; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['机械互锁'],
  },
  {
    id: 'chem-molecular-motor',
    category: 'chemistry',
    title: '单向旋转分子马达的实际工作频率',
    titleJa: '単方向回転分子モータの実際の動作周波数',
    titleEs: 'Frecuencia de trabajo práctica del motor molecular unidireccional: propuesta por Feringa/múltiples equipos en 1999, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Practical working frequency of unidirectional molecular motor',
    year: 1999,
    proposer: 'Feringa / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：单向旋转分子马达的实际工作频率。',
    summaryJa: '化学分野における特定の困難な問題：単方向回転分子モータの実際の動作周波数。',
    summaryEs: 'Frecuencia de trabajo práctica del motor molecular unidireccional: propuesta por Feringa/múltiples equipos en 1999, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Practical working frequency of unidirectional molecular motor.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 单向旋转分子马达的实际工作频率 的核心问题是：「单向旋转分子马达的实际工作频率」是 化学 领域的 分子马达 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「单向旋转分子马达的实际工作频率」是 化学 领域的 分子马达 方向。',
    formal: '单向旋转分子马达的实际工作频率（Practical working frequency of unidirectional molecular motor）：Feringa / 多团队 在 1999 年提出，相关实验/理论至今未完全解决。',
    formalJa: '単方向分子モータの実用動作周波数： Feringa/multi - teamは1999年に提案され、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Frecuencia de trabajo práctica del motor molecular unidireccional: propuesta por Feringa/múltiples equipos en 1999, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Practical working frequency of unidirectional molecular motor: proposed by Feringa / 多团队 in 1999; related experiments/theory remain incomplete.',
    whyHard: '「单向旋转分子马达的实际工作频率」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['分子马达'],
  },
  {
    id: 'chem-mech-polymer',
    category: 'chemistry',
    title: '机械互锁聚合物的宏观性质',
    titleJa: '機械的連結ポリマーのマクロ特性',
    titleEs: 'Propiedades macroscópicas de polímeros entrelazados mecánicamente: propuestas por Stoddart/varios equipos en 2002, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Macroscopic properties of mechanically interlocked polymers',
    year: 2002,
    proposer: 'Stoddart / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：机械互锁聚合物的宏观性质。',
    summaryJa: '化学分野における特定の困難な問題：機械的に連結するポリマーの巨視的性質。',
    summaryEs: 'Propiedades macroscópicas de polímeros entrelazados mecánicamente: propuestas por Stoddart/varios equipos en 2002, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Macroscopic properties of mechanically interlocked polymers.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 机械互锁聚合物的宏观性质 是这样一个问题：「机械互锁聚合物的宏观性质」是 化学 领域的 聚合物 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「机械互锁聚合物的宏观性质」是 化学 领域的 聚合物 方向。',
    formal: '机械互锁聚合物的宏观性质（Macroscopic properties of mechanically interlocked polymers）：Stoddart / 多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    formalJa: '機械的に連結されたポリマーの巨視的特性： Stoddart/Multiチームは2002年に提案し、関連する実験/理論は完全には解決されていません。',
    formalEs: 'Propiedades macroscópicas de polímeros entrelazados mecánicamente: propuestas por Stoddart/varios equipos en 2002, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Macroscopic properties of mechanically interlocked polymers: proposed by Stoddart / 多团队 in 2002; related experiments/theory remain incomplete.',
    whyHard: '尽管 Stoddart / 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['聚合物'],
  },
  {
    id: 'chem-stimu-polymer',
    category: 'chemistry',
    title: '刺激响应聚合物 (PNIPAM) 的相变机制',
    titleJa: '刺激応答性ポリマー（ ＰＮＩＰＡＭ ）の相転移機構',
    titleEs: 'Mecanismo de transición de fase de polímeros que responden a estímulos (PNIPAM): propuesto por Heskins/Guillet/múltiples equipos en 1968, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Phase transition mechanism of stimuli-responsive polymers (PNIPAM)',
    year: 1968,
    proposer: 'Heskins / Guillet / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：刺激响应聚合物 (PNIPAM) 的相变机制。',
    summaryJa: '化学分野における特定の難題：刺激応答性ポリマーの相転移機構（ PNIPAM ）。',
    summaryEs: 'Mecanismo de transición de fase de polímeros que responden a estímulos (PNIPAM): propuesto por Heskins/Guillet/múltiples equipos en 1968, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Phase transition mechanism of stimuli-responsive polymers (PNIPAM).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 刺激响应聚合物 (PNIPAM) 的相变机制 的问题。它可以简单描述为 「刺激响应聚合物 (PNIPAM) 的相变机制」是 化学 领域的 聚合物 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「刺激响应聚合物 (PNIPAM) 的相变机制」是 化学 领域的 聚合物 方向。',
    formal: '刺激响应聚合物 (PNIPAM) 的相变机制（Phase transition mechanism of stimuli-responsive polymers (PNIPAM)）：Heskins / Guillet / 多团队 在 1968 年提出，相关实验/理论至今未完全解决。',
    formalJa: '刺激応答性ポリマー（ PNIPAM ）の相転移機構： 1968年にHeskins/Guillet/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de transición de fase de polímeros que responden a estímulos (PNIPAM): propuesto por Heskins/Guillet/múltiples equipos en 1968, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Phase transition mechanism of stimuli-responsive polymers (PNIPAM): proposed by Heskins / Guillet / 多团队 in 1968; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Heskins / Guillet / 多团队 等人在 1968 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['聚合物'],
  },
  {
    id: 'chem-conductive-stretch',
    category: 'chemistry',
    title: 'PEDOT:PSS 拉伸电导率 (>1000 S/cm 拉伸 100%)',
    titleJa: 'PEDOT ： PSSストレッチ伝導率（> 1000 S/cmストレッチ100 ％ ）',
    titleEs: 'PEDOT: Conductividad de PSS al 100 % de tensión (>1000 S/cm estiramiento 100 %): propuesto por Bao/varios equipos en 2017, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'PEDOT:PSS conductivity at 100% strain',
    year: 2017,
    proposer: 'Bao / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：PEDOT:PSS 拉伸电导率 (>1000 S/cm 拉伸 100%)。',
    summaryJa: '化学分野の特定の難しい問題： PEDOT ： PSS引張伝導率（> 1000 S/cm引張100 ％ ）。',
    summaryEs: 'PEDOT: Conductividad de PSS al 100 % de tensión (>1000 S/cm estiramiento 100 %): propuesto por Bao/varios equipos en 2017, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: PEDOT:PSS conductivity at 100% strain.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 PEDOT:PSS 拉伸电导率 (>1000 S/cm 拉伸 100%) 是这样一个问题：「PEDOT:PSS 拉伸电导率 (>1000 S/cm 拉伸 100%)」是 化学 领域的 导电 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「PEDOT:PSS 拉伸电导率 (>1000 S/cm 拉伸 100%)」是 化学 领域的 导电 方向。',
    formal: 'PEDOT:PSS 拉伸电导率 (>1000 S/cm 拉伸 100%)（PEDOT:PSS conductivity at 100% strain）：Bao / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'PEDOT ： 100 ％ひずみでのPSS伝導率（ PEDOT ： 100 ％ひずみでのPSS伝導率） ： 2017年にBAO/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'PEDOT: Conductividad de PSS al 100 % de tensión (>1000 S/cm estiramiento 100 %): propuesto por Bao/varios equipos en 2017, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'PEDOT:PSS conductivity at 100% strain: proposed by Bao / 多团队 in 2017; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Bao / 多团队 等人在 2017 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['导电'],
  },
  {
    id: 'chem-block-copolymer',
    category: 'chemistry',
    title: '嵌段共聚物自组装的精确相图',
    titleJa: 'ブロックコポリマー自己組立の正確な位相図',
    titleEs: 'Diagrama de fase preciso del autoensamblaje de copolímeros en bloque: propuesto por Bates/múltiples equipos en 1995, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Precise phase diagram of block copolymer self-assembly',
    year: 1995,
    proposer: 'Bates / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：嵌段共聚物自组装的精确相图。',
    summaryJa: '化学分野における特定の困難な問題：ブロックコポリマー自己組織化の正確な位相図。',
    summaryEs: 'Diagrama de fase preciso del autoensamblaje de copolímeros en bloque: propuesto por Bates/múltiples equipos en 1995, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Precise phase diagram of block copolymer self-assembly.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 嵌段共聚物自组装的精确相图 的核心问题是：「嵌段共聚物自组装的精确相图」是 化学 领域的 自组装 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「嵌段共聚物自组装的精确相图」是 化学 领域的 自组装 方向。',
    formal: '嵌段共聚物自组装的精确相图（Precise phase diagram of block copolymer self-assembly）：Bates / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ブロックコポリマー自己組織化の正確な位相図： 1995年に提案されたBates/複数のチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: 'Diagrama de fase preciso del autoensamblaje de copolímeros en bloque: propuesto por Bates/múltiples equipos en 1995, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Precise phase diagram of block copolymer self-assembly: proposed by Bates / 多团队 in 1995; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自组装'],
  },
  {
    id: 'chem-mof-defect',
    category: 'chemistry',
    title: 'MOF 缺陷工程的精准控制',
    titleJa: 'MOF欠陥エンジニアリングの正確な制御',
    titleEs: 'Control preciso de la ingeniería de defectos MOF: propuesto por Yaghi/Farha/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Precise control of MOF defect engineering',
    year: 2010,
    proposer: 'Yaghi / Farha / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：MOF 缺陷工程的精准控制。',
    summaryJa: '化学分野における特定の困難な問題： MOF欠陥エンジニアリングの正確な制御。',
    summaryEs: 'Control preciso de la ingeniería de defectos MOF: propuesto por Yaghi/Farha/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Precise control of MOF defect engineering.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 MOF 缺陷工程的精准控制 是这样一个问题：「MOF 缺陷工程的精准控制」是 化学 领域的 MOF 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「MOF 缺陷工程的精准控制」是 化学 领域的 MOF 方向。',
    formal: 'MOF 缺陷工程的精准控制（Precise control of MOF defect engineering）：Yaghi / Farha / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'MOF欠陥エンジニアリングの正確な制御： 2010年にYaghi/Farha/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Control preciso de la ingeniería de defectos MOF: propuesto por Yaghi/Farha/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Precise control of MOF defect engineering: proposed by Yaghi / Farha / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Yaghi / Farha / 多团队 等人在 2010 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MOF'],
  },
  {
    id: 'chem-cof-single-crystal',
    category: 'chemistry',
    title: 'COF 单晶 X 射线结构',
    titleJa: 'COF単結晶X線構造',
    titleEs: 'Estructura de rayos X monocristalino de COF: propuesta por Yaghi/Dichtel/varios equipos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'COF single-crystal X-ray structure',
    year: 2018,
    proposer: 'Yaghi / Dichtel / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：COF 单晶 X 射线结构。',
    summaryJa: '化学分野における特定の困難な問題： COF単結晶X線構造。',
    summaryEs: 'Estructura de rayos X monocristalino de COF: propuesta por Yaghi/Dichtel/varios equipos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: COF single-crystal X-ray structure.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 COF 单晶 X 射线结构 是这样一个问题：「COF 单晶 X 射线结构」是 化学 领域的 COF 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「COF 单晶 X 射线结构」是 化学 领域的 COF 方向。',
    formal: 'COF 单晶 X 射线结构（COF single-crystal X-ray structure）：Yaghi / Dichtel / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'COF単結晶X線構造： 2018年にYaghi/Dichtel/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'Estructura de rayos X monocristalino de COF: propuesta por Yaghi/Dichtel/varios equipos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'COF single-crystal X-ray structure: proposed by Yaghi / Dichtel / 多团队 in 2018; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['COF'],
  },
  {
    id: 'chem-h-bond-cat',
    category: 'chemistry',
    title: '氢键供体催化 (hydrogen bonding catalysis)',
    titleJa: '水素結合触媒作用',
    titleEs: 'Catálisis de donantes de enlaces de hidrógeno (catálisis de donantes de enlaces de hidrógeno): propuesta por Takemoto/Schreiner/varios equipos en 2003, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Hydrogen bonding donor catalysis',
    year: 2003,
    proposer: 'Takemoto / Schreiner / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：氢键供体催化 (hydrogen bonding catalysis)。',
    summaryJa: '化学分野における特定の困難な問題：水素結合触媒作用。',
    summaryEs: 'Catálisis de donantes de enlaces de hidrógeno (catálisis de donantes de enlaces de hidrógeno): propuesta por Takemoto/Schreiner/varios equipos en 2003, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Hydrogen bonding donor catalysis.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 氢键供体催化 (hydrogen bonding catalysis) 的核心问题是：「氢键供体催化 (hydrogen bonding catalysis)」是 化学 领域的 有机 方向，涉及 有机, 催化 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「氢键供体催化 (hydrogen bonding catalysis)」是 化学 领域的 有机 方向，涉及 有机, 催化 等方面。',
    formal: '氢键供体催化 (hydrogen bonding catalysis)（Hydrogen bonding donor catalysis）：Takemoto / Schreiner / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalJa: '水素結合ドナー触媒（ Hydrogen bonding donor catalysis ） ： 2003年にTakemoto/Schreiner/multi - teamが提案されたが、これまでのところ関連する実験・理論は完全には解決されていない。',
    formalEs: 'Catálisis de donantes de enlaces de hidrógeno (catálisis de donantes de enlaces de hidrógeno): propuesta por Takemoto/Schreiner/varios equipos en 2003, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Hydrogen bonding donor catalysis: proposed by Takemoto / Schreiner / 多团队 in 2003; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '催化'],
  },
  {
    id: 'chem-ptc',
    category: 'chemistry',
    title: '相转移催化 (PTC) 通用机理',
    titleJa: '相移動触媒（ PTC ）の一般的なメカニズム',
    titleEs: 'Mecanismo general de catálisis por transferencia de fase (PTC): propuesto por Starks/Makosza/múltiples equipos en 1971, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'General mechanism of phase-transfer catalysis (PTC)',
    year: 1971,
    proposer: 'Starks / Makosza / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：相转移催化 (PTC) 通用机理。',
    summaryJa: '化学分野における特定の困難な問題：相転移触媒作用（ PTC ）の一般的なメカニズム。',
    summaryEs: 'Mecanismo general de catálisis por transferencia de fase (PTC): propuesto por Starks/Makosza/múltiples equipos en 1971, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: General mechanism of phase-transfer catalysis (PTC).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 相转移催化 (PTC) 通用机理。它说的是 「相转移催化 (PTC) 通用机理」是 化学 领域的 有机 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「相转移催化 (PTC) 通用机理」是 化学 领域的 有机 方向。',
    formal: '相转移催化 (PTC) 通用机理（General mechanism of phase-transfer catalysis (PTC)）：Starks / Makosza / 多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    formalJa: '相転移触媒作用（ PTC ）の一般的なメカニズム： 1971年にStarks/Makosza/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Mecanismo general de catálisis por transferencia de fase (PTC): propuesto por Starks/Makosza/múltiples equipos en 1971, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'General mechanism of phase-transfer catalysis (PTC): proposed by Starks / Makosza / 多团队 in 1971; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'chem-artificial-enzyme',
    category: 'chemistry',
    title: '人工酶 (酶模拟) 通用设计',
    titleJa: '人工酵素（酵素シミュレーション）ユニバーサルデザイン',
    titleEs: 'Diseño generalizado de enzimas artificiales (simulación de enzimas): propuesto por Breslow/múltiples equipos en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Generalized design of artificial enzymes',
    year: 1970,
    proposer: 'Breslow / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：人工酶 (酶模拟) 通用设计。',
    summaryJa: '化学分野における特定の難題：人工酵素の一般的な設計（酵素シミュレーション）。',
    summaryEs: 'Diseño generalizado de enzimas artificiales (simulación de enzimas): propuesto por Breslow/múltiples equipos en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Generalized design of artificial enzymes.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 人工酶 (酶模拟) 通用设计 是这样一个问题：「人工酶 (酶模拟) 通用设计」是 化学 领域的 酶 方向，涉及 酶, 模拟 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「人工酶 (酶模拟) 通用设计」是 化学 领域的 酶 方向，涉及 酶, 模拟 等方面。',
    formal: '人工酶 (酶模拟) 通用设计（Generalized design of artificial enzymes）：Breslow / 多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: '人工酵素の一般化された設計： 1970年に提案されたBreslow/multi - teamであり、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Diseño generalizado de enzimas artificiales (simulación de enzimas): propuesto por Breslow/múltiples equipos en 1970, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Generalized design of artificial enzymes: proposed by Breslow / 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '「人工酶 (酶模拟) 通用设计」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['酶', '模拟'],
  },
  {
    id: 'chem-dft-accuracy',
    category: 'chemistry',
    title: 'DFT 通用精度极限 (化学精度 1 kcal/mol)',
    titleJa: 'DFT一般精度限界（化学精度1 kcal/mol ）',
    titleEs: 'Límite de precisión generalizado de DFT (precisión química 1 kcal/mol): propuesto por Perdew/Burke/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Generalized DFT accuracy limit (chemical accuracy 1 kcal/mol)',
    year: 1990,
    proposer: 'Perdew / Burke / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：DFT 通用精度极限 (化学精度 1 kcal/mol)。',
    summaryJa: '化学分野における特定の困難な問題： DFT普遍的精度制限（化学精度1 kcal/mol ）。',
    summaryEs: 'Límite de precisión generalizado de DFT (precisión química 1 kcal/mol): propuesto por Perdew/Burke/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Generalized DFT accuracy limit (chemical accuracy 1 kcal/mol).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 DFT 通用精度极限 (化学精度 1 kcal/mol) 是这样一个问题：「DFT 通用精度极限 (化学精度 1 kcal/mol)」是 化学 领域的 计算 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「DFT 通用精度极限 (化学精度 1 kcal/mol)」是 化学 领域的 计算 方向。',
    formal: 'DFT 通用精度极限 (化学精度 1 kcal/mol)（Generalized DFT accuracy limit (chemical accuracy 1 kcal/mol)）：Perdew / Burke / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '一般化されたDFT精度限界（化学精度1 kcal/mol ） ： 1990年にPerdew/Burke/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Límite de precisión generalizado de DFT (precisión química 1 kcal/mol): propuesto por Perdew/Burke/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Generalized DFT accuracy limit (chemical accuracy 1 kcal/mol): proposed by Perdew / Burke / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '「DFT 通用精度极限 (化学精度 1 kcal/mol)」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['计算'],
  },
  {
    id: 'chem-multireference',
    category: 'chemistry',
    title: '强关联体系的 CASSCF/MRCI 准确度',
    titleJa: '強相関システムのCASSCF/MRCI精度',
    titleEs: 'Precisión de CASSCF/MRCI para sistemas fuertemente correlacionados (precisión de CASSCF/MRCI para sistemas fuertemente correlacionados): propuesta por Roos/múltiples equipos en 1980, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'CASSCF/MRCI accuracy for strongly correlated systems',
    year: 1980,
    proposer: 'Roos / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：强关联体系的 CASSCF/MRCI 准确度。',
    summaryJa: '化学分野における特定の困難な問題：強く相関するシステムのCASSCF/MRCI精度。',
    summaryEs: 'Precisión de CASSCF/MRCI para sistemas fuertemente correlacionados (precisión de CASSCF/MRCI para sistemas fuertemente correlacionados): propuesta por Roos/múltiples equipos en 1980, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: CASSCF/MRCI accuracy for strongly correlated systems.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 强关联体系的 CASSCF/MRCI 准确度 的核心问题是：「强关联体系的 CASSCF/MRCI 准确度」是 化学 领域的 计算 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「强关联体系的 CASSCF/MRCI 准确度」是 化学 领域的 计算 方向。',
    formal: '强关联体系的 CASSCF/MRCI 准确度（CASSCF/MRCI accuracy for strongly correlated systems）：Roos / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: '強相関システムのCASSCF/MRCI精度（強相関システムのCASSCF/MRCI精度） ： 1980年にRoos/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Precisión de CASSCF/MRCI para sistemas fuertemente correlacionados (precisión de CASSCF/MRCI para sistemas fuertemente correlacionados): propuesta por Roos/múltiples equipos en 1980, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'CASSCF/MRCI accuracy for strongly correlated systems: proposed by Roos / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Roos / 多团队 等人在 1980 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['计算'],
  },
  {
    id: 'chem-md-force-field',
    category: 'chemistry',
    title: '通用分子动力学力场 (蛋白/有机)',
    titleJa: 'ユニバーサル分子力学力場（タンパク質/有機）',
    titleEs: 'Campo de fuerza MD universal (proteína/orgánico): propuesto por Jorgensen/Kollman/múltiples equipos en 1983, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Universal MD force field (protein / organic)',
    year: 1983,
    proposer: 'Jorgensen / Kollman / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：通用分子动力学力场 (蛋白/有机)。',
    summaryJa: '化学分野における特定の困難な問題：一般的な分子力学力場（タンパク質/有機）。',
    summaryEs: 'Campo de fuerza MD universal (proteína/orgánico): propuesto por Jorgensen/Kollman/múltiples equipos en 1983, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Universal MD force field (protein / organic).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 通用分子动力学力场 (蛋白/有机) 是这样一个问题：「通用分子动力学力场 (蛋白/有机)」是 化学 领域的 计算 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「通用分子动力学力场 (蛋白/有机)」是 化学 领域的 计算 方向。',
    formal: '通用分子动力学力场 (蛋白/有机)（Universal MD force field (protein / organic)）：Jorgensen / Kollman / 多团队 在 1983 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ユニバーサルMD力場（タンパク質/有機） ： 1983年に提案されたJorgensen/Kollman/マルチチームで、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Campo de fuerza MD universal (proteína/orgánico): propuesto por Jorgensen/Kollman/múltiples equipos en 1983, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Universal MD force field (protein / organic): proposed by Jorgensen / Kollman / 多团队 in 1983; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['计算'],
  },
  {
    id: 'chem-tst-search',
    category: 'chemistry',
    title: '化学反应过渡态的全局搜索算法',
    titleJa: '化学反応遷移状態のグローバル検索アルゴリズム',
    titleEs: 'Algoritmos de búsqueda de estados de transición globales para estados de transición de reacciones químicas: propuestos por varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Global transition state search algorithms',
    year: 1990,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：化学反应过渡态的全局搜索算法。',
    summaryJa: '化学分野における特定の困難な問題：化学反応の遷移状態のグローバル検索アルゴリズム。',
    summaryEs: 'Algoritmos de búsqueda de estados de transición globales para estados de transición de reacciones químicas: propuestos por varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Global transition state search algorithms.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 化学反应过渡态的全局搜索算法 的核心问题是：「化学反应过渡态的全局搜索算法」是 化学 领域的 计算 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「化学反应过渡态的全局搜索算法」是 化学 领域的 计算 方向。',
    formal: '化学反应过渡态的全局搜索算法（Global transition state search algorithms）：多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'グローバル遷移状態検索アルゴリズム： 1990年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Algoritmos de búsqueda de estados de transición globales para estados de transición de reacciones químicas: propuestos por varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Global transition state search algorithms: proposed by 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['计算'],
  },
  {
    id: 'chem-stereoelectronic',
    category: 'chemistry',
    title: '立体电子效应 (stereoelectronic) 量化',
    titleJa: '立体電子量子化',
    titleEs: 'Cuantificación de efectos estereoelectrónicos: propuesto por Deslongchamps/múltiples equipos en 1970, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Quantification of stereoelectronic effects',
    year: 1970,
    proposer: 'Deslongchamps / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：立体电子效应 (stereoelectronic) 量化。',
    summaryJa: '化学における特定の困難な問題：立体電子定量化。',
    summaryEs: 'Cuantificación de efectos estereoelectrónicos: propuesto por Deslongchamps/múltiples equipos en 1970, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Quantification of stereoelectronic effects.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 立体电子效应 (stereoelectronic) 量化。它说的是 「立体电子效应 (stereoelectronic) 量化」是 化学 领域的 有机 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「立体电子效应 (stereoelectronic) 量化」是 化学 领域的 有机 方向。',
    formal: '立体电子效应 (stereoelectronic) 量化（Quantification of stereoelectronic effects）：Deslongchamps / 多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: '立体電子効果の定量化： 1970年に提唱されたDeslongchamps/Multi - teamで、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Cuantificación de efectos estereoelectrónicos: propuesto por Deslongchamps/múltiples equipos en 1970, los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Quantification of stereoelectronic effects: proposed by Deslongchamps / 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Deslongchamps / 多团队 等人在 1970 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'chem-anchimeric',
    category: 'chemistry',
    title: '邻位参与 (anchimeric assistance) 的预测力',
    titleJa: 'アンキメリックアシストの予測力',
    titleEs: 'Poder predictivo de la asistencia anquimérica: Winstein/varios equipos lo propusieron en 1950, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Predictive power of anchimeric assistance',
    year: 1950,
    proposer: 'Winstein / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：邻位参与 (anchimeric assistance) 的预测力。',
    summaryJa: '化学の分野における特定の困難な問題：アンキメリックアシストの予測力。',
    summaryEs: 'Poder predictivo de la asistencia anquimérica: Winstein/varios equipos lo propusieron en 1950, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Predictive power of anchimeric assistance.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 邻位参与 (anchimeric assistance) 的预测力。它说的是 「邻位参与 (anchimeric assistance) 的预测力」是 化学 领域的 有机 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「邻位参与 (anchimeric assistance) 的预测力」是 化学 领域的 有机 方向。',
    formal: '邻位参与 (anchimeric assistance) 的预测力（Predictive power of anchimeric assistance）：Winstein / 多团队 在 1950 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'アンキメラアシストの予測力： 1950年にWinstein/MultiTeamによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Poder predictivo de la asistencia anquimérica: Winstein/varios equipos lo propusieron en 1950, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Predictive power of anchimeric assistance: proposed by Winstein / 多团队 in 1950; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'chem-curtius',
    category: 'chemistry',
    title: 'Curtius 重排的迁移能力定量',
    titleJa: 'Curtius再編成の可動性定量化',
    titleEs: 'Cuantificación de la aptitud migratoria en el reordenamiento de Curtius: Curtius/varios equipos lo propusieron en 1894, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Migratory aptitude quantification in Curtius rearrangement',
    year: 1894,
    proposer: 'Curtius / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：Curtius 重排的迁移能力定量。',
    summaryJa: '化学における特定の困難な問題： Curtius再編成の可動性を定量化する。',
    summaryEs: 'Cuantificación de la aptitud migratoria en el reordenamiento de Curtius: Curtius/varios equipos lo propusieron en 1894, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Migratory aptitude quantification in Curtius rearrangement.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 Curtius 重排的迁移能力定量。它说的是 「Curtius 重排的迁移能力定量」是 化学 领域的 有机 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Curtius 重排的迁移能力定量」是 化学 领域的 有机 方向。',
    formal: 'Curtius 重排的迁移能力定量（Migratory aptitude quantification in Curtius rearrangement）：Curtius / 多团队 在 1894 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Curtius再編成における移動適性定量化： 1894年にCurtius/複数のチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Cuantificación de la aptitud migratoria en el reordenamiento de Curtius: Curtius/varios equipos lo propusieron en 1894, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Migratory aptitude quantification in Curtius rearrangement: proposed by Curtius / 多团队 in 1894; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'chem-ugi',
    category: 'chemistry',
    title: 'Ugi 多组分反应的收敛性',
    titleJa: 'Ugi多成分反応の収束',
    titleEs: 'Convergencia de la reacción multicomponente de Ugi: Ugi/equipo múltiple propuesto en 1959, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Convergence of Ugi multi-component reaction',
    year: 1959,
    proposer: 'Ugi / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：Ugi 多组分反应的收敛性。',
    summaryJa: '化学分野における特定の困難な問題： Ugiの多成分反応の収束。',
    summaryEs: 'Convergencia de la reacción multicomponente de Ugi: Ugi/equipo múltiple propuesto en 1959, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Convergence of Ugi multi-component reaction.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 Ugi 多组分反应的收敛性 是这样一个问题：「Ugi 多组分反应的收敛性」是 化学 领域的 有机 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Ugi 多组分反应的收敛性」是 化学 领域的 有机 方向。',
    formal: 'Ugi 多组分反应的收敛性（Convergence of Ugi multi-component reaction）：Ugi / 多团队 在 1959 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＵＧＩ多成分反応（ ＵＧＩ多成分反応の収束） ： １ ９ ５ ９年にＵＧＩ ／多成分反応が提案され、関連する実験・理論が完全に解決されていない。',
    formalEs: 'Convergencia de la reacción multicomponente de Ugi: Ugi/equipo múltiple propuesto en 1959, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Convergence of Ugi multi-component reaction: proposed by Ugi / 多团队 in 1959; related experiments/theory remain incomplete.',
    whyHard: '「Ugi 多组分反应的收敛性」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'chem-diels-alder-imda',
    category: 'chemistry',
    title: '分子内 Diels-Alder (IMDA) 区域选择性',
    titleJa: '分子内ディールス－アルダー（ ＩＭＤＡ ）領域選択性',
    titleEs: 'Regioselectividad intramolecular de Diels-Alder (IMDA) (Regioselectividad en Diels-Alder intramolecular): propuesta por Alder/múltiples equipos en 1956, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Regioselectivity in intramolecular Diels-Alder',
    year: 1956,
    proposer: 'Alder / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：分子内 Diels-Alder (IMDA) 区域选择性。',
    summaryJa: '化学における特定の困難な問題：分子内Diels - Alder （ IMDA ）局所選択性。',
    summaryEs: 'Regioselectividad intramolecular de Diels-Alder (IMDA) (Regioselectividad en Diels-Alder intramolecular): propuesta por Alder/múltiples equipos en 1956, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Regioselectivity in intramolecular Diels-Alder.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 分子内 Diels-Alder (IMDA) 区域选择性 是这样一个问题：「分子内 Diels-Alder (IMDA) 区域选择性」是 化学 领域的 有机 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「分子内 Diels-Alder (IMDA) 区域选择性」是 化学 领域的 有机 方向。',
    formal: '分子内 Diels-Alder (IMDA) 区域选择性（Regioselectivity in intramolecular Diels-Alder）：Alder / 多团队 在 1956 年提出，相关实验/理论至今未完全解决。',
    formalJa: '分子内ディールス-アルダー（ IMDA ）における位置選択性： 1956年にアルダー/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Regioselectividad intramolecular de Diels-Alder (IMDA) (Regioselectividad en Diels-Alder intramolecular): propuesta por Alder/múltiples equipos en 1956, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Regioselectivity in intramolecular Diels-Alder: proposed by Alder / 多团队 in 1956; related experiments/theory remain incomplete.',
    whyHard: '尽管 Alder / 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'chem-1-3-dipolar',
    category: 'chemistry',
    title: '1,3-偶极环加成的立体控制',
    titleJa: '1,3 -双極子環付加立体制御',
    titleEs: 'Control estéreo en cicloadición 1,3-dipolar: propuesto por Huisgen/múltiples equipos en 1960, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Stereo control in 1,3-dipolar cycloaddition',
    year: 1960,
    proposer: 'Huisgen / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：1,3-偶极环加成的立体控制。',
    summaryJa: '化学分野における特定の難題： 1,3 -双極子環付加の立体制御。',
    summaryEs: 'Control estéreo en cicloadición 1,3-dipolar: propuesto por Huisgen/múltiples equipos en 1960, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Stereo control in 1,3-dipolar cycloaddition.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 1,3-偶极环加成的立体控制 的问题。它可以简单描述为 「1,3-偶极环加成的立体控制」是 化学 领域的 有机 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「1,3-偶极环加成的立体控制」是 化学 领域的 有机 方向。',
    formal: '1,3-偶极环加成的立体控制（Stereo control in 1,3-dipolar cycloaddition）：Huisgen / 多团队 在 1960 年提出，相关实验/理论至今未完全解决。',
    formalJa: '1,3 -双極環付加の立体制御： 1960年にHuisgen/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Control estéreo en cicloadición 1,3-dipolar: propuesto por Huisgen/múltiples equipos en 1960, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Stereo control in 1,3-dipolar cycloaddition: proposed by Huisgen / 多团队 in 1960; related experiments/theory remain incomplete.',
    whyHard: '「1,3-偶极环加成的立体控制」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'chem-azetidine',
    category: 'chemistry',
    title: '氮杂环丁烷 (azetidine) 合成的一般方法',
    titleJa: 'アゼチジンの合成のための一般的な方法',
    titleEs: 'Síntesis general de azetidinas (Síntesis general de azetidinas): propuesta por varios equipos en 1888, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'General synthesis of azetidines',
    year: 1888,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：氮杂环丁烷 (azetidine) 合成的一般方法。',
    summaryJa: '化学分野における特定の困難な問題：アゼチジンの合成の一般的な方法。',
    summaryEs: 'Síntesis general de azetidinas (Síntesis general de azetidinas): propuesta por varios equipos en 1888, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: General synthesis of azetidines.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 氮杂环丁烷 (azetidine) 合成的一般方法 的核心问题是：「氮杂环丁烷 (azetidine) 合成的一般方法」是 化学 领域的 有机 方向，涉及 有机, 杂环 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「氮杂环丁烷 (azetidine) 合成的一般方法」是 化学 领域的 有机 方向，涉及 有机, 杂环 等方面。',
    formal: '氮杂环丁烷 (azetidine) 合成的一般方法（General synthesis of azetidines）：多团队 在 1888 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'アゼチジンの一般的な合成： 1888年にいくつかのチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Síntesis general de azetidinas (Síntesis general de azetidinas): propuesta por varios equipos en 1888, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'General synthesis of azetidines: proposed by 多团队 in 1888; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '杂环'],
  },
  {
    id: 'chem-pfas-degrade',
    category: 'chemistry',
    title: 'PFAS (全氟化合物) 通用降解方法',
    titleJa: 'PFAS （過フッ素化合物）万能分解法',
    titleEs: 'Degradación generalizada de PFAS (compuestos perfluorados): propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Generalized degradation of PFAS',
    year: 2010,
    proposer: '多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 化学 领域的具体硬问题：PFAS (全氟化合物) 通用降解方法。',
    summaryJa: '化学分野における特定の困難な問題： PFAS （過フッ素化化合物）の一般的な分解方法。',
    summaryEs: 'Degradación generalizada de PFAS (compuestos perfluorados): propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Generalized degradation of PFAS.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 PFAS (全氟化合物) 通用降解方法。它说的是 「PFAS (全氟化合物) 通用降解方法」是 化学 领域的 环境 方向，涉及 环境, 降解 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「PFAS (全氟化合物) 通用降解方法」是 化学 领域的 环境 方向，涉及 环境, 降解 等方面。',
    formal: 'PFAS (全氟化合物) 通用降解方法（Generalized degradation of PFAS）：多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'PFAS （過フッ素化化合物）の全般的な分解： 2010年に複数のチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Degradación generalizada de PFAS (compuestos perfluorados): propuesta por varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Generalized degradation of PFAS: proposed by 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['环境', '降解'],
  },
  {
    id: 'chem-microplastic-degrade',
    category: 'chemistry',
    title: '微塑料降解的化学方法',
    titleJa: 'マイクロプラスチックの分解のための化学的方法',
    titleEs: 'Métodos químicos para la degradación de microplásticos: propuestos por varios equipos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Chemical methods for microplastic degradation',
    year: 2018,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 化学 领域的具体硬问题：微塑料降解的化学方法。',
    summaryJa: '化学分野における特定の困難な問題：マイクロプラスチックの分解のための化学的方法。',
    summaryEs: 'Métodos químicos para la degradación de microplásticos: propuestos por varios equipos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Chemical methods for microplastic degradation.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 微塑料降解的化学方法 是这样一个问题：「微塑料降解的化学方法」是 化学 领域的 环境 方向，涉及 环境, 降解 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「微塑料降解的化学方法」是 化学 领域的 环境 方向，涉及 环境, 降解 等方面。',
    formal: '微塑料降解的化学方法（Chemical methods for microplastic degradation）：多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'マイクロプラスチック分解のための化学的方法： 2018年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Métodos químicos para la degradación de microplásticos: propuestos por varios equipos en 2018, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Chemical methods for microplastic degradation: proposed by 多团队 in 2018; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['环境', '降解'],
  },
  {
    id: 'chem-li-ion-electrolyte',
    category: 'chemistry',
    title: '高电压 (>4.5V) 锂离子电池电解液',
    titleJa: '高電圧（ 4.5V以上）リチウムイオン電池電解質',
    titleEs: 'Electrolito de batería de iones de litio de alto voltaje (>4,5 V): propuesto por Goodenough/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'High-voltage (>4.5V) Li-ion battery electrolyte',
    year: 1990,
    proposer: 'Goodenough / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：高电压 (>4.5V) 锂离子电池电解液。',
    summaryJa: '化学分野の特定の難題：高電圧（> 4.5V ）リチウムイオン電池電解質。',
    summaryEs: 'Electrolito de batería de iones de litio de alto voltaje (>4,5 V): propuesto por Goodenough/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: High-voltage (>4.5V) Li-ion battery electrolyte.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 高电压 (>4.5V) 锂离子电池电解液 是这样一个问题：「高电压 (>4.5V) 锂离子电池电解液」是 化学 领域的 电池 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「高电压 (>4.5V) 锂离子电池电解液」是 化学 领域的 电池 方向。',
    formal: '高电压 (>4.5V) 锂离子电池电解液（High-voltage (>4.5V) Li-ion battery electrolyte）：Goodenough / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '高電圧（ 4.5V超）リチウムイオン電池電解液： 1990年にGoodenough/マルチチームが提案したが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Electrolito de batería de iones de litio de alto voltaje (>4,5 V): propuesto por Goodenough/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'High-voltage (>4.5V) Li-ion battery electrolyte: proposed by Goodenough / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '「高电压 (>4.5V) 锂离子电池电解液」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['电池'],
  },
  {
    id: 'chem-na-hard-carbon',
    category: 'chemistry',
    title: '钠离子电池硬碳负极储钠机制',
    titleJa: 'ナトリウムイオンバッテリーハードカーボンネガティブナトリウム貯蔵メカニズム',
    titleEs: 'Mecanismo de almacenamiento de Na en ánodos de carbono duro para baterías de iones de Na: propuesto por Stevens/Dahn/varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Na storage mechanism in hard carbon anodes for Na-ion batteries',
    year: 2000,
    proposer: 'Stevens / Dahn / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：钠离子电池硬碳负极储钠机制。',
    summaryJa: '化学分野における特定の難題：ナトリウムイオン電池の硬質炭素負極のナトリウム貯蔵機構。',
    summaryEs: 'Mecanismo de almacenamiento de Na en ánodos de carbono duro para baterías de iones de Na: propuesto por Stevens/Dahn/varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Na storage mechanism in hard carbon anodes for Na-ion batteries.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 钠离子电池硬碳负极储钠机制 的核心问题是：「钠离子电池硬碳负极储钠机制」是 化学 领域的 钠电 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「钠离子电池硬碳负极储钠机制」是 化学 领域的 钠电 方向。',
    formal: '钠离子电池硬碳负极储钠机制（Na storage mechanism in hard carbon anodes for Na-ion batteries）：Stevens / Dahn / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Naイオン電池のハードカーボン陽極におけるNa貯蔵メカニズム： 2000年にStevens/Dahn/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de almacenamiento de Na en ánodos de carbono duro para baterías de iones de Na: propuesto por Stevens/Dahn/varios equipos en 2000, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Na storage mechanism in hard carbon anodes for Na-ion batteries: proposed by Stevens / Dahn / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钠电'],
  },
  {
    id: 'chem-pem-fuelcell',
    category: 'chemistry',
    title: 'PEM 燃料电池膜 (Nafion) 高温 (>100°C) 运行',
    titleJa: 'ＰＥＭ燃料電池膜（ Ｎａｆｉｏｎ ）高温（ ＞ １ ０ ０ ℃）動作',
    titleEs: 'Funcionamiento de membrana de pila de combustible PEM (Nafion) a alta temperatura (>100 °C) (funcionamiento de membrana de pila de combustible PEM por encima de 100 °C): Nafion/DuPont/múltiples equipos propuestos en 1966, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'PEM fuel cell membrane operation above 100°C',
    year: 1966,
    proposer: 'Nafion / DuPont / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：PEM 燃料电池膜 (Nafion) 高温 (>100°C) 运行。',
    summaryJa: '化学分野における特定の困難な問題： ＰＥＭ燃料電池膜（ Ｎａｆｉｏｎ ）は、高温（ ＞ １ ０ ０ ℃）で動作する。',
    summaryEs: 'Funcionamiento de membrana de pila de combustible PEM (Nafion) a alta temperatura (>100 °C) (funcionamiento de membrana de pila de combustible PEM por encima de 100 °C): Nafion/DuPont/múltiples equipos propuestos en 1966, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: PEM fuel cell membrane operation above 100°C.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 PEM 燃料电池膜 (Nafion) 高温 (>100°C) 运行。它说的是 「PEM 燃料电池膜 (Nafion) 高温 (>100°C) 运行」是 化学 领域的 燃料电池 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「PEM 燃料电池膜 (Nafion) 高温 (>100°C) 运行」是 化学 领域的 燃料电池 方向。',
    formal: 'PEM 燃料电池膜 (Nafion) 高温 (>100°C) 运行（PEM fuel cell membrane operation above 100°C）：Nafion / DuPont / 多团队 在 1966 年提出，相关实验/理论至今未完全解决。',
    formalJa: '１ ０ ０ ℃を超えるＰＥＭ燃料電池膜の動作（ １ ０ ０ ℃を超えるＰＥＭ燃料電池膜の動作） ： １ ９ ６ ６年にＮａｆｉｏｎ ／ ＤｕＰｏｎｔ ／マルチチームが提案され、関連する実験／理論が完全に解決されていない。',
    formalEs: 'Funcionamiento de membrana de pila de combustible PEM (Nafion) a alta temperatura (>100 °C) (funcionamiento de membrana de pila de combustible PEM por encima de 100 °C): Nafion/DuPont/múltiples equipos propuestos en 1966, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'PEM fuel cell membrane operation above 100°C: proposed by Nafion / DuPont / 多团队 in 1966; related experiments/theory remain incomplete.',
    whyHard: '「PEM 燃料电池膜 (Nafion) 高温 (>100°C) 运行」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['燃料电池'],
  },
  {
    id: 'chem-aem-fuelcell',
    category: 'chemistry',
    title: '阴离子交换膜 (AEM) 燃料电池寿命',
    titleJa: '陰イオン交換膜（ AEM ）燃料電池寿命',
    titleEs: 'Vida útil de las pilas de combustible de membrana de intercambio aniónico (AEM): propuesta por Pivovar/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Lifetime of anion exchange membrane (AEM) fuel cells',
    year: 2010,
    proposer: 'Pivovar / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：阴离子交换膜 (AEM) 燃料电池寿命。',
    summaryJa: '化学における特定の困難な問題：陰イオン交換膜（ AEM ）燃料電池の寿命。',
    summaryEs: 'Vida útil de las pilas de combustible de membrana de intercambio aniónico (AEM): propuesta por Pivovar/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Lifetime of anion exchange membrane (AEM) fuel cells.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 阴离子交换膜 (AEM) 燃料电池寿命 是这样一个问题：「阴离子交换膜 (AEM) 燃料电池寿命」是 化学 领域的 燃料电池 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「阴离子交换膜 (AEM) 燃料电池寿命」是 化学 领域的 燃料电池 方向。',
    formal: '阴离子交换膜 (AEM) 燃料电池寿命（Lifetime of anion exchange membrane (AEM) fuel cells）：Pivovar / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '陰イオン交換膜（ AEM ）燃料電池の寿命： 2010年にPivovar/MultiTeamによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Vida útil de las pilas de combustible de membrana de intercambio aniónico (AEM): propuesta por Pivovar/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Lifetime of anion exchange membrane (AEM) fuel cells: proposed by Pivovar / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '「阴离子交换膜 (AEM) 燃料电池寿命」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['燃料电池'],
  },
  {
    id: 'chem-sei-formation',
    category: 'chemistry',
    title: 'SEI (固体电解质界面) 形成机制',
    titleJa: 'SEI （固体電解質インターフェース）形成機構',
    titleEs: 'Mecanismo de formación de SEI (interfase de electrolito sólido): propuesto por Peled/múltiples equipos en 1979, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Mechanism of SEI (solid electrolyte interphase) formation',
    year: 1979,
    proposer: 'Peled / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：SEI (固体电解质界面) 形成机制。',
    summaryJa: '化学分野における特定の困難な問題： SEI （固体電解質界面）の形成メカニズム。',
    summaryEs: 'Mecanismo de formación de SEI (interfase de electrolito sólido): propuesto por Peled/múltiples equipos en 1979, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Mechanism of SEI (solid electrolyte interphase) formation.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 SEI (固体电解质界面) 形成机制 的问题。它可以简单描述为 「SEI (固体电解质界面) 形成机制」是 化学 领域的 电池 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「SEI (固体电解质界面) 形成机制」是 化学 领域的 电池 方向。',
    formal: 'SEI (固体电解质界面) 形成机制（Mechanism of SEI (solid electrolyte interphase) formation）：Peled / 多团队 在 1979 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'SEI （固体電解質インターフェーズ）形成のメカニズム： 1979年に提案されたPeled/マルチチームであり、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de formación de SEI (interfase de electrolito sólido): propuesto por Peled/múltiples equipos en 1979, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Mechanism of SEI (solid electrolyte interphase) formation: proposed by Peled / 多团队 in 1979; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['电池'],
  },
  {
    id: 'chem-li-dendrite',
    category: 'chemistry',
    title: '锂金属负极枝晶抑制',
    titleJa: 'リチウム陰性樹枝状結晶抑制',
    titleEs: 'Supresión del crecimiento de dendritas de Li metálico: propuesto por Aurbach/varios equipos en 1970, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Suppression of Li metal dendrite growth',
    year: 1970,
    proposer: 'Aurbach / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：锂金属负极枝晶抑制。',
    summaryJa: '化学分野における特定の困難な問題：リチウム金属負極樹枝状結晶抑制。',
    summaryEs: 'Supresión del crecimiento de dendritas de Li metálico: propuesto por Aurbach/varios equipos en 1970, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Suppression of Li metal dendrite growth.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 锂金属负极枝晶抑制 是这样一个问题：「锂金属负极枝晶抑制」是 化学 领域的 锂 方向，涉及 锂, 电池 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「锂金属负极枝晶抑制」是 化学 领域的 锂 方向，涉及 锂, 电池 等方面。',
    formal: '锂金属负极枝晶抑制（Suppression of Li metal dendrite growth）：Aurbach / 多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Li金属樹枝状結晶成長の抑制： Aurbach/Multiチームは1970年に提案し、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Supresión del crecimiento de dendritas de Li metálico: propuesto por Aurbach/varios equipos en 1970, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Suppression of Li metal dendrite growth: proposed by Aurbach / 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['锂', '电池'],
  },
  {
    id: 'chem-ionic-liquid',
    category: 'chemistry',
    title: '离子液体在大规模电化学应用',
    titleJa: '大規模な電気化学用途におけるイオン液体',
    titleEs: 'Líquidos iónicos para aplicaciones electroquímicas a gran escala: propuestos por Wilkes/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Ionic liquids for large-scale electrochemical applications',
    year: 1990,
    proposer: 'Wilkes / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：离子液体在大规模电化学应用。',
    summaryJa: '化学分野における特定の困難な問題：大規模な電気化学応用におけるイオン液体。',
    summaryEs: 'Líquidos iónicos para aplicaciones electroquímicas a gran escala: propuestos por Wilkes/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Ionic liquids for large-scale electrochemical applications.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 离子液体在大规模电化学应用。它说的是 「离子液体在大规模电化学应用」是 化学 领域的 离子液体 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「离子液体在大规模电化学应用」是 化学 领域的 离子液体 方向。',
    formal: '离子液体在大规模电化学应用（Ionic liquids for large-scale electrochemical applications）：Wilkes / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '大規模な電気化学用途のためのイオン液： 1990年にWilkes/Multi - teamが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Líquidos iónicos para aplicaciones electroquímicas a gran escala: propuestos por Wilkes/varios equipos en 1990, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Ionic liquids for large-scale electrochemical applications: proposed by Wilkes / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '「离子液体在大规模电化学应用」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['离子液体'],
  },
  {
    id: 'chem-des',
    category: 'chemistry',
    title: '深共熔溶剂 (DES) 的物性预测',
    titleJa: '深層共晶溶媒（ DES ）の物理的性質予測',
    titleEs: 'Predicción de propiedades de disolventes eutécticos profundos (DES): propuesta por Abbott/varios equipos en 2003, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Property prediction of deep eutectic solvents (DES)',
    year: 2003,
    proposer: 'Abbott / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：深共熔溶剂 (DES) 的物性预测。',
    summaryJa: '化学分野における特定の難題：深層共晶溶媒（ DES ）の物理的性質予測。',
    summaryEs: 'Predicción de propiedades de disolventes eutécticos profundos (DES): propuesta por Abbott/varios equipos en 2003, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Property prediction of deep eutectic solvents (DES).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 深共熔溶剂 (DES) 的物性预测 是这样一个问题：「深共熔溶剂 (DES) 的物性预测」是 化学 领域的 溶剂 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「深共熔溶剂 (DES) 的物性预测」是 化学 领域的 溶剂 方向。',
    formal: '深共熔溶剂 (DES) 的物性预测（Property prediction of deep eutectic solvents (DES)）：Abbott / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalJa: '深共晶溶媒（ DES ）の特性予測： 2003年にAbbott/MultiTeamによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Predicción de propiedades de disolventes eutécticos profundos (DES): propuesta por Abbott/varios equipos en 2003, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Property prediction of deep eutectic solvents (DES): proposed by Abbott / 多团队 in 2003; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['溶剂'],
  },
  {
    id: 'chem-supercritical-co2',
    category: 'chemistry',
    title: '超临界 CO2 在工业规模的应用',
    titleJa: '超臨界CO 2の工業規模の応用',
    titleEs: 'Aplicación a escala industrial del CO2 supercrítico: propuesta por varios equipos en 1978, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Industrial-scale application of supercritical CO2',
    year: 1978,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：超临界 CO2 在工业规模的应用。',
    summaryJa: '化学分野における特定の困難な問題：産業規模での超臨界CO 2の適用。',
    summaryEs: 'Aplicación a escala industrial del CO2 supercrítico: propuesta por varios equipos en 1978, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Industrial-scale application of supercritical CO2.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 超临界 CO2 在工业规模的应用 是这样一个问题：「超临界 CO2 在工业规模的应用」是 化学 领域的 SC-CO2 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「超临界 CO2 在工业规模的应用」是 化学 领域的 SC-CO2 方向。',
    formal: '超临界 CO2 在工业规模的应用（Industrial-scale application of supercritical CO2）：多团队 在 1978 年提出，相关实验/理论至今未完全解决。',
    formalJa: '超臨界CO 2の産業規模の適用： 1978年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Aplicación a escala industrial del CO2 supercrítico: propuesta por varios equipos en 1978, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Industrial-scale application of supercritical CO2: proposed by 多团队 in 1978; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SC-CO2'],
  },
  {
    id: 'chem-il-cellulose',
    category: 'chemistry',
    title: '离子液体溶解纤维素机制',
    titleJa: 'イオン性液体溶解セルロースのメカニズム',
    titleEs: 'Mecanismo de disolución de celulosa en líquidos iónicos: propuesto por Rogers/varios equipos en 2002, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Mechanism of cellulose dissolution in ionic liquids',
    year: 2002,
    proposer: 'Rogers / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：离子液体溶解纤维素机制。',
    summaryJa: '化学分野における特定の困難な問題：イオン液体がセルロースを溶解するメカニズム。',
    summaryEs: 'Mecanismo de disolución de celulosa en líquidos iónicos: propuesto por Rogers/varios equipos en 2002, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Mechanism of cellulose dissolution in ionic liquids.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 离子液体溶解纤维素机制 是这样一个问题：「离子液体溶解纤维素机制」是 化学 领域的 纤维素 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「离子液体溶解纤维素机制」是 化学 领域的 纤维素 方向。',
    formal: '离子液体溶解纤维素机制（Mechanism of cellulose dissolution in ionic liquids）：Rogers / 多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'イオン液体中のセルロース溶解のメカニズム： Rogers/Multiple teamsは2002年に提案しており、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de disolución de celulosa en líquidos iónicos: propuesto por Rogers/varios equipos en 2002, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Mechanism of cellulose dissolution in ionic liquids: proposed by Rogers / 多团队 in 2002; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['纤维素'],
  },
  {
    id: 'chem-li-rich-mn-fade',
    category: 'chemistry',
    title: '富锂锰基正极电压衰减机理',
    titleJa: 'リチウムリッチマンガン系正極電圧減衰機構',
    titleEs: 'Mecanismo de desvanecimiento de voltaje en cátodos de Mn ricos en Li: propuesto por Croy/varios equipos en 2010, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Voltage fade mechanism in Li-rich Mn cathodes',
    year: 2010,
    proposer: 'Croy / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：富锂锰基正极电压衰减机理。',
    summaryJa: '化学分野における特定の困難な問題：リチウムリッチマンガンベースの正極電圧減衰機構。',
    summaryEs: 'Mecanismo de desvanecimiento de voltaje en cátodos de Mn ricos en Li: propuesto por Croy/varios equipos en 2010, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Voltage fade mechanism in Li-rich Mn cathodes.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 富锂锰基正极电压衰减机理 的核心问题是：「富锂锰基正极电压衰减机理」是 化学 领域的 正极 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「富锂锰基正极电压衰减机理」是 化学 领域的 正极 方向。',
    formal: '富锂锰基正极电压衰减机理（Voltage fade mechanism in Li-rich Mn cathodes）：Croy / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'LiリッチMnカソードの電圧フェード機構： 2010年にCROY/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Mecanismo de desvanecimiento de voltaje en cátodos de Mn ricos en Li: propuesto por Croy/varios equipos en 2010, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Voltage fade mechanism in Li-rich Mn cathodes: proposed by Croy / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['正极'],
  },
  {
    id: 'chem-li-air-cat',
    category: 'chemistry',
    title: '锂空气电池氧电极催化剂',
    titleJa: 'リチウム空気電池酸素電極触媒',
    titleEs: 'Catalizadores de electrodos de oxígeno para baterías de Li-aire: propuestos por Bruce/varios equipos en 2006, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Oxygen electrode catalysts for Li-air batteries',
    year: 2006,
    proposer: 'Bruce / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：锂空气电池氧电极催化剂。',
    summaryJa: '化学分野における特定の難題：リチウム空気電池用酸素電極触媒。',
    summaryEs: 'Catalizadores de electrodos de oxígeno para baterías de Li-aire: propuestos por Bruce/varios equipos en 2006, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Oxygen electrode catalysts for Li-air batteries.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 锂空气电池氧电极催化剂 的问题。它可以简单描述为 「锂空气电池氧电极催化剂」是 化学 领域的 锂 方向，涉及 锂, 空气 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「锂空气电池氧电极催化剂」是 化学 领域的 锂 方向，涉及 锂, 空气 等方面。',
    formal: '锂空气电池氧电极催化剂（Oxygen electrode catalysts for Li-air batteries）：Bruce / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'リチウムエアバッテリー用酸素電極触媒：ブルース/マルチチームは2006年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: 'Catalizadores de electrodos de oxígeno para baterías de Li-aire: propuestos por Bruce/varios equipos en 2006, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Oxygen electrode catalysts for Li-air batteries: proposed by Bruce / 多团队 in 2006; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['锂', '空气'],
  },
  {
    id: 'chem-mg-battery',
    category: 'chemistry',
    title: '可充镁电池电解液',
    titleJa: '充電式マグネシウム電池電解質',
    titleEs: 'Electrolito de batería de magnesio recargable: propuesto por Aurbach/Gregory en 1990, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Rechargeable Mg battery electrolyte',
    year: 1990,
    proposer: 'Aurbach / Gregory',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：可充镁电池电解液。',
    summaryJa: '化学分野における特定の困難な問題：充電式マグネシウム電池電解質。',
    summaryEs: 'Electrolito de batería de magnesio recargable: propuesto por Aurbach/Gregory en 1990, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Rechargeable Mg battery electrolyte.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 可充镁电池电解液 的核心问题是：「可充镁电池电解液」是 化学 领域的 镁 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「可充镁电池电解液」是 化学 领域的 镁 方向。',
    formal: '可充镁电池电解液（Rechargeable Mg battery electrolyte）：Aurbach / Gregory 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '充電式Mg電池電解液： Aurbach/Gregoryは1990年に提案しており、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Electrolito de batería de magnesio recargable: propuesto por Aurbach/Gregory en 1990, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Rechargeable Mg battery electrolyte: proposed by Aurbach / Gregory in 1990; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Aurbach / Gregory 等人在 1990 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['镁'],
  },
  {
    id: 'chem-al-ion',
    category: 'chemistry',
    title: '可充铝离子电池电解液 (AlCl3)',
    titleJa: '充電式アルミニウムイオン電池電解液（ AlCl 3 ）',
    titleEs: 'Electrolito de batería recargable de iones de Al (AlCl3): propuesto por Archer/Dai/varios equipos en 2015, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Rechargeable Al-ion battery electrolyte (AlCl3)',
    year: 2015,
    proposer: 'Archer / Dai / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：可充铝离子电池电解液 (AlCl3)。',
    summaryJa: '化学分野における特定の困難な問題：充電式アルミニウムイオン電池電解質（ AlCl 3 ）。',
    summaryEs: 'Electrolito de batería recargable de iones de Al (AlCl3): propuesto por Archer/Dai/varios equipos en 2015, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Rechargeable Al-ion battery electrolyte (AlCl3).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 可充铝离子电池电解液 (AlCl3) 的问题。它可以简单描述为 「可充铝离子电池电解液 (AlCl3)」是 化学 领域的 铝 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「可充铝离子电池电解液 (AlCl3)」是 化学 领域的 铝 方向。',
    formal: '可充铝离子电池电解液 (AlCl3)（Rechargeable Al-ion battery electrolyte (AlCl3)）：Archer / Dai / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: '充電式Alイオン電池電解液（ AlCl 3 ） ： 2015年にArcher/Dai/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Electrolito de batería recargable de iones de Al (AlCl3): propuesto por Archer/Dai/varios equipos en 2015, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Rechargeable Al-ion battery electrolyte (AlCl3): proposed by Archer / Dai / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Archer / Dai / 多团队 等人在 2015 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['铝'],
  },
  {
    id: 'chem-li-s-cat',
    category: 'chemistry',
    title: '锂硫电池硫正极催化剂 (Co-N-C)',
    titleJa: 'リチウム硫黄電池硫黄陰極触媒（ Co - N - C ）',
    titleEs: 'Catalizador de cátodo de azufre (Co-N-C) para baterías Li-S: propuesto por Nazar/varios equipos en 2014, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Sulfur cathode catalyst (Co-N-C) for Li-S batteries',
    year: 2014,
    proposer: 'Nazar / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：锂硫电池硫正极催化剂 (Co-N-C)。',
    summaryJa: '化学分野における特定の難題：リチウム硫黄電池硫黄陰極触媒（ Co - N - C ）。',
    summaryEs: 'Catalizador de cátodo de azufre (Co-N-C) para baterías Li-S: propuesto por Nazar/varios equipos en 2014, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Sulfur cathode catalyst (Co-N-C) for Li-S batteries.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 锂硫电池硫正极催化剂 (Co-N-C) 是这样一个问题：「锂硫电池硫正极催化剂 (Co-N-C)」是 化学 领域的 硫 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「锂硫电池硫正极催化剂 (Co-N-C)」是 化学 领域的 硫 方向。',
    formal: '锂硫电池硫正极催化剂 (Co-N-C)（Sulfur cathode catalyst (Co-N-C) for Li-S batteries）：Nazar / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Li - S電池用硫黄陰極触媒（ Co - N - C ） ： Nazar/マルチチームは2014年に、これまでのところ関連する実験/理論が完全に解決されていないことを提案しました。',
    formalEs: 'Catalizador de cátodo de azufre (Co-N-C) para baterías Li-S: propuesto por Nazar/varios equipos en 2014, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Sulfur cathode catalyst (Co-N-C) for Li-S batteries: proposed by Nazar / 多团队 in 2014; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['硫'],
  },
  {
    id: 'chem-cn-fiber-anion',
    category: 'chemistry',
    title: '阴离子交换膜 AEM 的化学稳定性',
    titleJa: '陰イオン交換膜AEMの化学的安定性',
    titleEs: 'Estabilidad química de las membranas de intercambio aniónico AEM: propuesta por Bae/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Chemical stability of AEM anion exchange membranes',
    year: 2010,
    proposer: 'Bae / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：阴离子交换膜 AEM 的化学稳定性。',
    summaryJa: '化学分野における特定の困難な問題：陰イオン交換膜AEMの化学的安定性。',
    summaryEs: 'Estabilidad química de las membranas de intercambio aniónico AEM: propuesta por Bae/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Chemical stability of AEM anion exchange membranes.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 阴离子交换膜 AEM 的化学稳定性 的问题。它可以简单描述为 「阴离子交换膜 AEM 的化学稳定性」是 化学 领域的 膜 方向，涉及 膜, 稳定性 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「阴离子交换膜 AEM 的化学稳定性」是 化学 领域的 膜 方向，涉及 膜, 稳定性 等方面。',
    formal: '阴离子交换膜 AEM 的化学稳定性（Chemical stability of AEM anion exchange membranes）：Bae / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'AEM陰イオン交換膜の化学的安定性： 2010年にBAE/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Estabilidad química de las membranas de intercambio aniónico AEM: propuesta por Bae/varios equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Chemical stability of AEM anion exchange membranes: proposed by Bae / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '尽管 Bae / 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['膜', '稳定性'],
  },
  {
    id: 'chem-fmof-chem',
    category: 'chemistry',
    title: '功能性 MOF (FMOF) 普适设计',
    titleJa: '機能的MOF （ FMOF ）ユニバーサルデザイン',
    titleEs: '功能性 MOF (FMOF) 普适设计（Universal design of functional MOFs (FMOF)）：Yaghi / Farha / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Universal design of functional MOFs (FMOF)',
    year: 2010,
    proposer: 'Yaghi / Farha / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：功能性 MOF (FMOF) 普适设计。',
    summaryJa: '化学における特定の難しい問題：機能的MOF （ FMOF ）ユニバーサルデザイン。',
    summaryEs: '功能性 MOF (FMOF) 普适设计（Universal design of functional MOFs (FMOF)）：Yaghi / Farha / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Universal design of functional MOFs (FMOF).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 功能性 MOF (FMOF) 普适设计 的问题。它可以简单描述为 「功能性 MOF (FMOF) 普适设计」是 化学 领域的 MOF 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「功能性 MOF (FMOF) 普适设计」是 化学 领域的 MOF 方向。',
    formal: '功能性 MOF (FMOF) 普适设计（Universal design of functional MOFs (FMOF)）：Yaghi / Farha / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '機能的MOF （ FMOF ）機能的MOF （ FMOF ）のユニバーサルデザイン： 2010年にYaghi/Farha/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: '功能性 MOF (FMOF) 普适设计（Universal design of functional MOFs (FMOF)）：Yaghi / Farha / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Universal design of functional MOFs (FMOF): proposed by Yaghi / Farha / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '「功能性 MOF (FMOF) 普适设计」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MOF'],
  },
  {
    id: 'chem-mof-water-stable',
    category: 'chemistry',
    title: '水稳定 MOF 的通用设计原则',
    titleJa: '水安定化MOFの一般設計原則',
    titleEs: 'Principios generales de diseño para MOF hidroestables: propuestos por Yaghi/múltiples equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'General design principles for water-stable MOFs',
    year: 2010,
    proposer: 'Yaghi / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：水稳定 MOF 的通用设计原则。',
    summaryJa: '化学分野における特定の困難な問題：水安定化MOFの一般的な設計原理。',
    summaryEs: 'Principios generales de diseño para MOF hidroestables: propuestos por Yaghi/múltiples equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: General design principles for water-stable MOFs.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 水稳定 MOF 的通用设计原则。它说的是 「水稳定 MOF 的通用设计原则」是 化学 领域的 MOF 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「水稳定 MOF 的通用设计原则」是 化学 领域的 MOF 方向。',
    formal: '水稳定 MOF 的通用设计原则（General design principles for water-stable MOFs）：Yaghi / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '水安定性MOFの一般的な設計原則： 2010年にYaghi/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Principios generales de diseño para MOF hidroestables: propuestos por Yaghi/múltiples equipos en 2010, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'General design principles for water-stable MOFs: proposed by Yaghi / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Yaghi / 多团队 等人在 2010 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MOF'],
  },
  {
    id: 'chem-zr-mof-stability',
    category: 'chemistry',
    title: 'Zr-MOF (UiO-66) 水解稳定性',
    titleJa: 'Zr - MOF (UiO -66)加水分解安定性',
    titleEs: 'Estabilidad hidrolítica de Zr-MOF (UiO-66): propuesta por Lillerud/múltiples equipos en 2008, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Hydrolytic stability of Zr-MOF (UiO-66)',
    year: 2008,
    proposer: 'Lillerud / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：Zr-MOF (UiO-66) 水解稳定性。',
    summaryJa: '化学分野における特定の難題： Zr - MOF （ UiO -66 ）加水分解安定性。',
    summaryEs: 'Estabilidad hidrolítica de Zr-MOF (UiO-66): propuesta por Lillerud/múltiples equipos en 2008, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Hydrolytic stability of Zr-MOF (UiO-66).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 Zr-MOF (UiO-66) 水解稳定性 的问题。它可以简单描述为 「Zr-MOF (UiO-66) 水解稳定性」是 化学 领域的 MOF 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Zr-MOF (UiO-66) 水解稳定性」是 化学 领域的 MOF 方向。',
    formal: 'Zr-MOF (UiO-66) 水解稳定性（Hydrolytic stability of Zr-MOF (UiO-66)）：Lillerud / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Zr - MOF （ UiO -66 ） Zr - MOF （ UiO -66 ）の加水分解安定性： 2008年にLillerud/Multi - teamによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Estabilidad hidrolítica de Zr-MOF (UiO-66): propuesta por Lillerud/múltiples equipos en 2008, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Hydrolytic stability of Zr-MOF (UiO-66): proposed by Lillerud / 多团队 in 2008; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Lillerud / 多团队 等人在 2008 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MOF'],
  },
  {
    id: 'chem-csp-amide',
    category: 'chemistry',
    title: '酰胺键的精准催化合成 (CSP)',
    titleJa: 'アミド結合の精密触媒合成（ CSP ）',
    titleEs: 'Síntesis catalítica de enlaces amida con selectividad precisa (CSP): propuesta por varios equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Catalytic synthesis of amide bonds with precise selectivity',
    year: 2005,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：酰胺键的精准催化合成 (CSP)。',
    summaryJa: '化学分野における特定の難題：アミド結合の正確な触媒合成（ ＣＳＰ ）。',
    summaryEs: 'Síntesis catalítica de enlaces amida con selectividad precisa (CSP): propuesta por varios equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Catalytic synthesis of amide bonds with precise selectivity.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 酰胺键的精准催化合成 (CSP) 是这样一个问题：「酰胺键的精准催化合成 (CSP)」是 化学 领域的 有机 方向，涉及 有机, 催化 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「酰胺键的精准催化合成 (CSP)」是 化学 领域的 有机 方向，涉及 有机, 催化 等方面。',
    formal: '酰胺键的精准催化合成 (CSP)（Catalytic synthesis of amide bonds with precise selectivity）：多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: '精密選択性（ ＣＳＰ ）を有するアミド結合の触媒合成： ２ ０ ０ ５年に複数のチームによって提案されたが、関連する実験／理論はまだ完全に解決されていない。',
    formalEs: 'Síntesis catalítica de enlaces amida con selectividad precisa (CSP): propuesta por varios equipos en 2005, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Catalytic synthesis of amide bonds with precise selectivity: proposed by 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 2005 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', '催化'],
  },
  {
    id: 'chem-csp-sp3',
    category: 'chemistry',
    title: 'sp3 C-H 直接不对称催化',
    titleJa: 'sp 3 C - H直接非対称触媒作用',
    titleEs: 'catálisis asimétrica directa sp3 C-H de enlaces sp3 C-H: propuesta por varios equipos en 2008, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    titleEn: 'Direct asymmetric catalysis of sp3 C-H bonds',
    year: 2008,
    proposer: '多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 化学 领域的具体硬问题：sp3 C-H 直接不对称催化。',
    summaryJa: '化学分野における特定の困難な問題： sp 3 C - H直接非対称触媒作用。',
    summaryEs: 'catálisis asimétrica directa sp3 C-H de enlaces sp3 C-H: propuesta por varios equipos en 2008, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Direct asymmetric catalysis of sp3 C-H bonds.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 sp3 C-H 直接不对称催化 是这样一个问题：「sp3 C-H 直接不对称催化」是 化学 领域的 不对称 方向，涉及 不对称, C-H 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「sp3 C-H 直接不对称催化」是 化学 领域的 不对称 方向，涉及 不对称, C-H 等方面。',
    formal: 'sp3 C-H 直接不对称催化（Direct asymmetric catalysis of sp3 C-H bonds）：多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'sp 3 C - Hの直接非対称触媒作用： 2008年に複数のチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'catálisis asimétrica directa sp3 C-H de enlaces sp3 C-H: propuesta por varios equipos en 2008, los experimentos/teorías relevantes aún no se han resuelto por completo.',
    formalEn: 'Direct asymmetric catalysis of sp3 C-H bonds: proposed by 多团队 in 2008; related experiments/theory remain incomplete.',
    whyHard: '尽管 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['不对称', 'C-H'],
  },
  {
    id: 'chem-perovskite-halide',
    category: 'chemistry',
    title: '卤化物钙钛矿的离子缺陷化学',
    titleJa: 'ハロゲン化物ペロブスカイトのイオン欠陥化学',
    titleEs: 'Química de defectos iónicos de perovskitas de haluro: propuesta por Yin/múltiples equipos en 2014, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    titleEn: 'Ionic defect chemistry of halide perovskites',
    year: 2014,
    proposer: 'Yin / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：卤化物钙钛矿的离子缺陷化学。',
    summaryJa: '化学分野における特定の困難な問題：ハロゲン化物ペロブスカイトのイオン欠陥化学。',
    summaryEs: 'Química de defectos iónicos de perovskitas de haluro: propuesta por Yin/múltiples equipos en 2014, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    summaryEn: 'A specific hard problem in chemistry: Ionic defect chemistry of halide perovskites.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 卤化物钙钛矿的离子缺陷化学。它说的是 「卤化物钙钛矿的离子缺陷化学」是 化学 领域的 钙钛矿 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「卤化物钙钛矿的离子缺陷化学」是 化学 领域的 钙钛矿 方向。',
    formal: '卤化物钙钛矿的离子缺陷化学（Ionic defect chemistry of halide perovskites）：Yin / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ハロゲン化物ペロブスカイトのイオン欠陥化学： 2014年にYin/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'Química de defectos iónicos de perovskitas de haluro: propuesta por Yin/múltiples equipos en 2014, y los experimentos/teorías relacionados aún no se han resuelto por completo.',
    formalEn: 'Ionic defect chemistry of halide perovskites: proposed by Yin / 多团队 in 2014; related experiments/theory remain incomplete.',
    whyHard: '尽管 Yin / 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿'],
  },
  {
    id: 'chem-perovskite-qd',
    category: 'chemistry',
    title: 'CsPbI3 钙钛矿量子点稳定性',
    titleJa: 'CsPbI 3ペロブスカイト量子ドット安定性',
    titleEs: 'CsPbI3 钙钛矿量子点稳定性（Stability of CsPbI3 perovskite quantum dots）：Kovalenko / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Stability of CsPbI3 perovskite quantum dots',
    year: 2015,
    proposer: 'Kovalenko / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：CsPbI3 钙钛矿量子点稳定性。',
    summaryJa: '化学分野における特定の難題： CsPbI 3ペロブスカイト量子ドットの安定性。',
    summaryEs: 'CsPbI3 钙钛矿量子点稳定性（Stability of CsPbI3 perovskite quantum dots）：Kovalenko / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Stability of CsPbI3 perovskite quantum dots.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 CsPbI3 钙钛矿量子点稳定性 的问题。它可以简单描述为 「CsPbI3 钙钛矿量子点稳定性」是 化学 领域的 钙钛矿 方向，涉及 钙钛矿, 量子点 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「CsPbI3 钙钛矿量子点稳定性」是 化学 领域的 钙钛矿 方向，涉及 钙钛矿, 量子点 等方面。',
    formal: 'CsPbI3 钙钛矿量子点稳定性（Stability of CsPbI3 perovskite quantum dots）：Kovalenko / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'CsPbI 3ペロブスカイト量子ドットの安定性： 2015年にKovalenko/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'CsPbI3 钙钛矿量子点稳定性（Stability of CsPbI3 perovskite quantum dots）：Kovalenko / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Stability of CsPbI3 perovskite quantum dots: proposed by Kovalenko / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Kovalenko / 多团队 等人在 2015 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['钙钛矿', '量子点'],
  },
  {
    id: 'chem-csp-electrophile',
    category: 'chemistry',
    title: '电亲核催化的对映选择性',
    titleJa: '求電子触媒作用の鏡像選択性',
    titleEs: '电亲核催化的对映选择性（Enantioselectivity of electrophilic catalysis）：MacMillan / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Enantioselectivity of electrophilic catalysis',
    year: 2000,
    proposer: 'MacMillan / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：电亲核催化的对映选择性。',
    summaryJa: '化学分野における特定の難題：求核触媒作用の鏡像選択性。',
    summaryEs: '电亲核催化的对映选择性（Enantioselectivity of electrophilic catalysis）：MacMillan / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Enantioselectivity of electrophilic catalysis.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 电亲核催化的对映选择性。它说的是 「电亲核催化的对映选择性」是 化学 领域的 催化 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「电亲核催化的对映选择性」是 化学 领域的 催化 方向。',
    formal: '电亲核催化的对映选择性（Enantioselectivity of electrophilic catalysis）：MacMillan / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '求電子触媒の鏡像選択性： 2000年にMacMillan/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '电亲核催化的对映选择性（Enantioselectivity of electrophilic catalysis）：MacMillan / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Enantioselectivity of electrophilic catalysis: proposed by MacMillan / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 MacMillan / 多团队 等人在 2000 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['催化'],
  },
  {
    id: 'chem-organocat-sp3',
    category: 'chemistry',
    title: 'sp3 C-H 官能化的有机小分子催化',
    titleJa: 'sp 3 C - H官能化有機小分子触媒作用',
    titleEs: 'sp3 C-H 官能化的有机小分子催化（Organocatalytic sp3 C-H functionalization）：MacMillan / List / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Organocatalytic sp3 C-H functionalization',
    year: 2010,
    proposer: 'MacMillan / List / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 化学 领域的具体硬问题：sp3 C-H 官能化的有机小分子催化。',
    summaryJa: '化学分野における特定の難題： sp 3 C - H官能化有機小分子触媒作用。',
    summaryEs: 'sp3 C-H 官能化的有机小分子催化（Organocatalytic sp3 C-H functionalization）：MacMillan / List / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Organocatalytic sp3 C-H functionalization.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 sp3 C-H 官能化的有机小分子催化 的问题。它可以简单描述为 「sp3 C-H 官能化的有机小分子催化」是 化学 领域的 有机 方向，涉及 有机, C-H 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「sp3 C-H 官能化的有机小分子催化」是 化学 领域的 有机 方向，涉及 有机, C-H 等方面。',
    formal: 'sp3 C-H 官能化的有机小分子催化（Organocatalytic sp3 C-H functionalization）：MacMillan / List / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'sp 3 C - H官能化有機小分子触媒（有機触媒sp 3 C - H官能化） ： 2010年にマクミラン/リスト/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全には解決されていない。',
    formalEs: 'sp3 C-H 官能化的有机小分子催化（Organocatalytic sp3 C-H functionalization）：MacMillan / List / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Organocatalytic sp3 C-H functionalization: proposed by MacMillan / List / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机', 'C-H'],
  },
  {
    id: 'chem-csp-vinyl',
    category: 'chemistry',
    title: '烯烃的氢胺化 (hydroamination) 不对称催化',
    titleJa: 'オレフィンのヒドロアミノ化非対称触媒作用',
    titleEs: '烯烃的氢胺化 (hydroamination) 不对称催化（Asymmetric hydroamination of olefins）：Hartwig / Marks / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Asymmetric hydroamination of olefins',
    year: 2000,
    proposer: 'Hartwig / Marks / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：烯烃的氢胺化 (hydroamination) 不对称催化。',
    summaryJa: '化学分野における特定の難題：オレフィンのヒドロアミネーションの非対称触媒作用。',
    summaryEs: '烯烃的氢胺化 (hydroamination) 不对称催化（Asymmetric hydroamination of olefins）：Hartwig / Marks / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Asymmetric hydroamination of olefins.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 烯烃的氢胺化 (hydroamination) 不对称催化 的核心问题是：「烯烃的氢胺化 (hydroamination) 不对称催化」是 化学 领域的 催化 方向，涉及 催化, 有机 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「烯烃的氢胺化 (hydroamination) 不对称催化」是 化学 领域的 催化 方向，涉及 催化, 有机 等方面。',
    formal: '烯烃的氢胺化 (hydroamination) 不对称催化（Asymmetric hydroamination of olefins）：Hartwig / Marks / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'オレフィンの非対称ヒドロアミネーション： Hartwig/Marks/Multiチームは2000年に提案しており、関連する実験/理論は完全には解決されていない。',
    formalEs: '烯烃的氢胺化 (hydroamination) 不对称催化（Asymmetric hydroamination of olefins）：Hartwig / Marks / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Asymmetric hydroamination of olefins: proposed by Hartwig / Marks / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Hartwig / Marks / 多团队 等人在 2000 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['催化', '有机'],
  },
  {
    id: 'chem-click-chem',
    category: 'chemistry',
    title: '点击化学的生物正交反应通量',
    titleJa: '化学の生物学的直交反応フラックスをクリックします',
    titleEs: '点击化学的生物正交反应通量（Throughput of bioorthogonal click chemistry reactions）：Sharpless / Bertozzi / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Throughput of bioorthogonal click chemistry reactions',
    year: 2001,
    proposer: 'Sharpless / Bertozzi / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：点击化学的生物正交反应通量。',
    summaryJa: '化学の分野における特定の難しい問題：化学の生物学的直交反応フラックスをクリックします。',
    summaryEs: '点击化学的生物正交反应通量（Throughput of bioorthogonal click chemistry reactions）：Sharpless / Bertozzi / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Throughput of bioorthogonal click chemistry reactions.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 点击化学的生物正交反应通量 的问题。它可以简单描述为 「点击化学的生物正交反应通量」是 化学 领域的 点击 方向，涉及 点击, 生物正交 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「点击化学的生物正交反应通量」是 化学 领域的 点击 方向，涉及 点击, 生物正交 等方面。',
    formal: '点击化学的生物正交反应通量（Throughput of bioorthogonal click chemistry reactions）：Sharpless / Bertozzi / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: '生体直交クリック化学反応のスループット： 2001年に提案されたSharpless/Bertozzi/複数のチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: '点击化学的生物正交反应通量（Throughput of bioorthogonal click chemistry reactions）：Sharpless / Bertozzi / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Throughput of bioorthogonal click chemistry reactions: proposed by Sharpless / Bertozzi / 多团队 in 2001; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Sharpless / Bertozzi / 多团队 等人在 2001 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['点击', '生物正交'],
  },
  {
    id: 'chem-rxn-barrier',
    category: 'chemistry',
    title: '酶催化过渡态的精确能量学',
    titleJa: '酵素触媒遷移状態の正確なエネルギー学',
    titleEs: '酶催化过渡态的精确能量学（Precise energetics of enzyme catalytic transition states）：Wolfenden / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise energetics of enzyme catalytic transition states',
    year: 1976,
    proposer: 'Wolfenden / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：酶催化过渡态的精确能量学。',
    summaryJa: '化学における特定の難しい問題：酵素触媒遷移状態の正確なエネルギー学。',
    summaryEs: '酶催化过渡态的精确能量学（Precise energetics of enzyme catalytic transition states）：Wolfenden / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Precise energetics of enzyme catalytic transition states.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 酶催化过渡态的精确能量学 的核心问题是：「酶催化过渡态的精确能量学」是 化学 领域的 酶 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「酶催化过渡态的精确能量学」是 化学 领域的 酶 方向。',
    formal: '酶催化过渡态的精确能量学（Precise energetics of enzyme catalytic transition states）：Wolfenden / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    formalJa: '酵素触媒遷移状態の正確なエネルギー学： Wolfenden/Multiチームは1976年に提案し、関連する実験/理論は完全には解決されていません。',
    formalEs: '酶催化过渡态的精确能量学（Precise energetics of enzyme catalytic transition states）：Wolfenden / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise energetics of enzyme catalytic transition states: proposed by Wolfenden / 多团队 in 1976; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['酶'],
  },
  {
    id: 'chem-tm-cat-oer',
    category: 'chemistry',
    title: '过渡金属单原子 OER 催化剂设计',
    titleJa: '遷移金属単原子OER触媒設計',
    titleEs: '过渡金属单原子 OER 催化剂设计（Design of TM single-atom OER catalysts）：Li / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Design of TM single-atom OER catalysts',
    year: 2017,
    proposer: 'Li / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：过渡金属单原子 OER 催化剂设计。',
    summaryJa: '化学分野における特定の難題：遷移金属単原子OER触媒の設計。',
    summaryEs: '过渡金属单原子 OER 催化剂设计（Design of TM single-atom OER catalysts）：Li / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Design of TM single-atom OER catalysts.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这是一道关于 过渡金属单原子 OER 催化剂设计 的问题。它可以简单描述为 「过渡金属单原子 OER 催化剂设计」是 化学 领域的 OER 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「过渡金属单原子 OER 催化剂设计」是 化学 领域的 OER 方向。',
    formal: '过渡金属单原子 OER 催化剂设计（Design of TM single-atom OER catalysts）：Li / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    formalJa: '遷移金属単原子OER触媒（ TM単原子OER触媒の設計） ： 2017年にLi/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: '过渡金属单原子 OER 催化剂设计（Design of TM single-atom OER catalysts）：Li / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Design of TM single-atom OER catalysts: proposed by Li / 多团队 in 2017; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Li / 多团队 等人在 2017 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['OER'],
  },
  {
    id: 'chem-csp-photo',
    category: 'chemistry',
    title: '光催化不对称有机合成',
    titleJa: '光触媒非対称有機合成',
    titleEs: '光催化不对称有机合成（Photocatalytic asymmetric organic synthesis）：MacMillan / Yoon / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Photocatalytic asymmetric organic synthesis',
    year: 2008,
    proposer: 'MacMillan / Yoon / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：光催化不对称有机合成。',
    summaryJa: '化学分野における特定の難題：光触媒非対称有機合成。',
    summaryEs: '光催化不对称有机合成（Photocatalytic asymmetric organic synthesis）：MacMillan / Yoon / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Photocatalytic asymmetric organic synthesis.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 光催化不对称有机合成 是这样一个问题：「光催化不对称有机合成」是 化学 领域的 光 方向，涉及 光, 有机 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「光催化不对称有机合成」是 化学 领域的 光 方向，涉及 光, 有机 等方面。',
    formal: '光催化不对称有机合成（Photocatalytic asymmetric organic synthesis）：MacMillan / Yoon / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalJa: '光触媒非対称有機合成（ Photocatalytic asymmetric organic synthesis ） ： 2008年にMacMillan/Yoon/multi - teamが提案され、関連する実験・理論が完全に解決されていない。',
    formalEs: '光催化不对称有机合成（Photocatalytic asymmetric organic synthesis）：MacMillan / Yoon / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Photocatalytic asymmetric organic synthesis: proposed by MacMillan / Yoon / 多团队 in 2008; related experiments/theory remain incomplete.',
    whyHard: '「光催化不对称有机合成」是 化学 领域一个被广泛认可的核心难题。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['光', '有机'],
  },
  {
    id: 'chem-electro-csp',
    category: 'chemistry',
    title: '电催化不对称合成',
    titleJa: '電気触媒非対称合成',
    titleEs: '电催化不对称合成（Electrocatalytic asymmetric synthesis）：Lin / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Electrocatalytic asymmetric synthesis',
    year: 2018,
    proposer: 'Lin / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：电催化不对称合成。',
    summaryJa: '化学分野における特定の難題：電気触媒非対称合成。',
    summaryEs: '电催化不对称合成（Electrocatalytic asymmetric synthesis）：Lin / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Electrocatalytic asymmetric synthesis.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 电催化不对称合成 是这样一个问题：「电催化不对称合成」是 化学 领域的 电 方向，涉及 电, 不对称 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「电催化不对称合成」是 化学 领域的 电 方向，涉及 电, 不对称 等方面。',
    formal: '电催化不对称合成（Electrocatalytic asymmetric synthesis）：Lin / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    formalJa: '電気触媒非対称合成（ Electrocatalytic asymmetric synthesis ） ： 2018年にLIN/multi - teamが提案され、関連する実験/理論はこれまで完全に解決されていない。',
    formalEs: '电催化不对称合成（Electrocatalytic asymmetric synthesis）：Lin / 多团队 在 2018 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Electrocatalytic asymmetric synthesis: proposed by Lin / 多团队 in 2018; related experiments/theory remain incomplete.',
    whyHard: '尽管 Lin / 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['电', '不对称'],
  },
  {
    id: 'chem-hydride-cat',
    category: 'chemistry',
    title: '氢化物迁移反应机理',
    titleJa: '水素移動反応機構',
    titleEs: '氢化物迁移反应机理（Mechanism of hydride migration reactions）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of hydride migration reactions',
    year: 1970,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：氢化物迁移反应机理。',
    summaryJa: '化学分野における特定の困難な問題：水素化物移動反応のメカニズム。',
    summaryEs: '氢化物迁移反应机理（Mechanism of hydride migration reactions）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Mechanism of hydride migration reactions.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 氢化物迁移反应机理 的核心问题是：「氢化物迁移反应机理」是 化学 领域的 有机 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「氢化物迁移反应机理」是 化学 领域的 有机 方向。',
    formal: '氢化物迁移反应机理（Mechanism of hydride migration reactions）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: '水素移動反応のメカニズム： 1970年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '氢化物迁移反应机理（Mechanism of hydride migration reactions）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of hydride migration reactions: proposed by 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 1970 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'chem-electrophile-amide',
    category: 'chemistry',
    title: '亲电酰胺化反应 (electrophilic amidation)',
    titleJa: '親電性アミド化',
    titleEs: '亲电酰胺化反应 (electrophilic amidation)（Electrophilic amidation reactions）：多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Electrophilic amidation reactions',
    year: 2005,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：亲电酰胺化反应 (electrophilic amidation)。',
    summaryJa: '化学分野における特定の難題：求電子性アミド化。',
    summaryEs: '亲电酰胺化反应 (electrophilic amidation)（Electrophilic amidation reactions）：多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Electrophilic amidation reactions.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 亲电酰胺化反应 (electrophilic amidation)。它说的是 「亲电酰胺化反应 (electrophilic amidation)」是 化学 领域的 有机 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「亲电酰胺化反应 (electrophilic amidation)」是 化学 领域的 有机 方向。',
    formal: '亲电酰胺化反应 (electrophilic amidation)（Electrophilic amidation reactions）：多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: '親電性アミド化反応： 2005年にいくつかのチームが親電性アミド化反応を提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '亲电酰胺化反应 (electrophilic amidation)（Electrophilic amidation reactions）：多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Electrophilic amidation reactions: proposed by 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['有机'],
  },
  {
    id: 'chem-nox-stor',
    category: 'chemistry',
    title: 'NOx 存储-还原 (NSR) 催化剂机理',
    titleJa: 'NOx貯蔵削減（ NSR ）触媒メカニズム',
    titleEs: 'NOx 存储-还原 (NSR) 催化剂机理（Mechanism of NOx storage-reduction (NSR) catalysts）：Takahashi / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of NOx storage-reduction (NSR) catalysts',
    year: 1995,
    proposer: 'Takahashi / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：NOx 存储-还原 (NSR) 催化剂机理。',
    summaryJa: '化学分野における特定の難題： NOx貯蔵還元（ NSR ）触媒メカニズム。',
    summaryEs: 'NOx 存储-还原 (NSR) 催化剂机理（Mechanism of NOx storage-reduction (NSR) catalysts）：Takahashi / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Mechanism of NOx storage-reduction (NSR) catalysts.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 NOx 存储-还原 (NSR) 催化剂机理 的核心问题是：「NOx 存储-还原 (NSR) 催化剂机理」是 化学 领域的 催化 方向，涉及 催化, NOx 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「NOx 存储-还原 (NSR) 催化剂机理」是 化学 领域的 催化 方向，涉及 催化, NOx 等方面。',
    formal: 'NOx 存储-还原 (NSR) 催化剂机理（Mechanism of NOx storage-reduction (NSR) catalysts）：Takahashi / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'NOx貯蔵還元（ NSR ）触媒（ NOx貯蔵還元（ NSR ）触媒のメカニズム） ： Takahashi/Multiチームは1995年に提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'NOx 存储-还原 (NSR) 催化剂机理（Mechanism of NOx storage-reduction (NSR) catalysts）：Takahashi / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of NOx storage-reduction (NSR) catalysts: proposed by Takahashi / 多团队 in 1995; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['催化', 'NOx'],
  },
  {
    id: 'chem-scr-mech',
    category: 'chemistry',
    title: 'SCR (选择性催化还原) 低温活性',
    titleJa: 'SCR （選択的触媒還元）低温活性',
    titleEs: 'SCR (选择性催化还原) 低温活性（Low-temperature activity of SCR (selective catalytic reduction)）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Low-temperature activity of SCR (selective catalytic reduction)',
    year: 1970,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：SCR (选择性催化还原) 低温活性。',
    summaryJa: '化学分野における特定の難題： SCR （選択的触媒還元）低温活性。',
    summaryEs: 'SCR (选择性催化还原) 低温活性（Low-temperature activity of SCR (selective catalytic reduction)）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Low-temperature activity of SCR (selective catalytic reduction).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 SCR (选择性催化还原) 低温活性 是这样一个问题：「SCR (选择性催化还原) 低温活性」是 化学 领域的 SCR 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「SCR (选择性催化还原) 低温活性」是 化学 领域的 SCR 方向。',
    formal: 'SCR (选择性催化还原) 低温活性（Low-temperature activity of SCR (selective catalytic reduction)）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'SCR （選択的触媒還元） SCR （選択的触媒還元）の低温活性： 1970年に複数のチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'SCR (选择性催化还原) 低温活性（Low-temperature activity of SCR (selective catalytic reduction)）：多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Low-temperature activity of SCR (selective catalytic reduction): proposed by 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 1970 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SCR'],
  },
  {
    id: 'chem-pem-electrolysis',
    category: 'chemistry',
    title: 'PEM 电解水催化剂 (Ir 替代)',
    titleJa: 'ＰＥＭ電解水触媒（ Ｉｒ置換）',
    titleEs: 'PEM 电解水催化剂 (Ir 替代)（PEM water electrolysis catalyst (Ir replacement)）：Markovic / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'PEM water electrolysis catalyst (Ir replacement)',
    year: 2010,
    proposer: 'Markovic / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：PEM 电解水催化剂 (Ir 替代)。',
    summaryJa: '化学分野における特定の難題： ＰＥＭ電気分解水触媒（ Ｉｒ置換）。',
    summaryEs: 'PEM 电解水催化剂 (Ir 替代)（PEM water electrolysis catalyst (Ir replacement)）：Markovic / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: PEM water electrolysis catalyst (Ir replacement).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 PEM 电解水催化剂 (Ir 替代) 的核心问题是：「PEM 电解水催化剂 (Ir 替代)」是 化学 领域的 PEM 方向，涉及 PEM, 电解 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「PEM 电解水催化剂 (Ir 替代)」是 化学 领域的 PEM 方向，涉及 PEM, 电解 等方面。',
    formal: 'PEM 电解水催化剂 (Ir 替代)（PEM water electrolysis catalyst (Ir replacement)）：Markovic / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＰＥＭ水電解触媒（ Ｉｒ置換） ： ２ ０ １ ０年に提案されたマルコヴィッチ／マルチチームであり、関連する実験／理論は完全には解決されていない。',
    formalEs: 'PEM 电解水催化剂 (Ir 替代)（PEM water electrolysis catalyst (Ir replacement)）：Markovic / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'PEM water electrolysis catalyst (Ir replacement): proposed by Markovic / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Markovic / 多团队 等人在 2010 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['PEM', '电解'],
  },
  {
    id: 'chem-bio-mimetic',
    category: 'chemistry',
    title: '仿生催化 (生物矿化) 通用方法',
    titleJa: 'バイオニック触媒作用（バイオミネラル化）の一般的な方法',
    titleEs: '仿生催化 (生物矿化) 通用方法（Generalized bio-inspired catalytic methods (biomineralization)）：Aizenberg / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Generalized bio-inspired catalytic methods (biomineralization)',
    year: 2000,
    proposer: 'Aizenberg / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：仿生催化 (生物矿化) 通用方法。',
    summaryJa: '化学分野における特定の困難な問題：バイオニック触媒作用（バイオミネラル化）の一般的な方法。',
    summaryEs: '仿生催化 (生物矿化) 通用方法（Generalized bio-inspired catalytic methods (biomineralization)）：Aizenberg / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: Generalized bio-inspired catalytic methods (biomineralization).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 仿生催化 (生物矿化) 通用方法 的核心问题是：「仿生催化 (生物矿化) 通用方法」是 化学 领域的 仿生 方向，涉及 仿生, 催化 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「仿生催化 (生物矿化) 通用方法」是 化学 领域的 仿生 方向，涉及 仿生, 催化 等方面。',
    formal: '仿生催化 (生物矿化) 通用方法（Generalized bio-inspired catalytic methods (biomineralization)）：Aizenberg / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '一般化されたバイオインスパイアされた触媒法（バイオミネラル化） ： 2000年にアイゼンバーグ/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '仿生催化 (生物矿化) 通用方法（Generalized bio-inspired catalytic methods (biomineralization)）：Aizenberg / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Generalized bio-inspired catalytic methods (biomineralization): proposed by Aizenberg / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Aizenberg / 多团队 等人在 2000 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['仿生', '催化'],
  },
  {
    id: 'chem-dna-templated',
    category: 'chemistry',
    title: 'DNA 模板化有机合成',
    titleJa: 'DNAテンプレート有機合成',
    titleEs: 'DNA 模板化有机合成（DNA-templated organic synthesis）：Liu / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'DNA-templated organic synthesis',
    year: 2001,
    proposer: 'Liu / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：DNA 模板化有机合成。',
    summaryJa: '化学分野における特定の困難な問題：有機合成をテンプレート化するDNA。',
    summaryEs: 'DNA 模板化有机合成（DNA-templated organic synthesis）：Liu / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: DNA-templated organic synthesis.',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 这就是 DNA 模板化有机合成。它说的是 「DNA 模板化有机合成」是 化学 领域的 DNA 方向，涉及 DNA, 有机 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「DNA 模板化有机合成」是 化学 领域的 DNA 方向，涉及 DNA, 有机 等方面。',
    formal: 'DNA 模板化有机合成（DNA-templated organic synthesis）：Liu / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'DNA - templated organic synthesis （ DNA - templated organic synthesis ） ： 2001年にLiu/multi - teamが提案され、関連する実験/理論が完全に解決されていない。',
    formalEs: 'DNA 模板化有机合成（DNA-templated organic synthesis）：Liu / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'DNA-templated organic synthesis: proposed by Liu / 多团队 in 2001; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Liu / 多团队 等人在 2001 年提出，但至今未完全解决。化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['DNA', '有机'],
  },
  {
    id: 'chem-3d-print-cat',
    category: 'chemistry',
    title: '3D 打印催化剂 (结构与性能)',
    titleJa: '3 Dプリント触媒（構造と性能）',
    titleEs: '3D 打印催化剂 (结构与性能)（3D-printed catalysts (structure and performance)）：多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    titleEn: '3D-printed catalysts (structure and performance)',
    year: 2015,
    proposer: '多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 化学 领域的具体硬问题：3D 打印催化剂 (结构与性能)。',
    summaryJa: '化学分野における特定の難題： 3 Dプリント触媒（構造と性能）。',
    summaryEs: '3D 打印催化剂 (结构与性能)（3D-printed catalysts (structure and performance)）：多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in chemistry: 3D-printed catalysts (structure and performance).',
    kid: '想象分子像乐高积木，你能精确控制它们怎么拼在一起。 3D 打印催化剂 (结构与性能) 是这样一个问题：「3D 打印催化剂 (结构与性能)」是 化学 领域的 催化 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「3D 打印催化剂 (结构与性能)」是 化学 领域的 催化 方向。',
    formal: '3D 打印催化剂 (结构与性能)（3D-printed catalysts (structure and performance)）：多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: '3 Dプリントされた触媒（構造と性能） ： 2015年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '3D 打印催化剂 (结构与性能)（3D-printed catalysts (structure and performance)）：多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalEn: '3D-printed catalysts (structure and performance): proposed by 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '尽管 多团队 等人在过去几十年里推动了很多进展，化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。 这道问题仍然开放。',
    whyHardEn: '化学反应的过渡态难以直接观测，催化剂设计需要理解电子结构和反应动力学的精确耦合。',
    aiPrompt: '你是一位化学教授，向一个 12 岁的小朋友用比喻解释这道化学问题，然后给出反应机理、当前催化/合成状态、关键参考文献。',
    aiPromptEn: 'You are a rigorous 化学 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['催化'],
  },
  {
    id: 'bio-protein-folding',
    category: 'biology',
    title: '蛋白质折叠的物理机制 (Levinthal 悖论)',
    titleJa: 'タンパク質折り畳みの物理的メカニズム（ Levinthalパラドックス）',
    titleEs: '蛋白质折叠的物理机制 (Levinthal 悖论)（Physical mechanism of protein folding (Levinthal paradox)）：Levinthal / Anfinsen / 多团队 在 1969 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Physical mechanism of protein folding (Levinthal paradox)',
    year: 1969,
    proposer: 'Levinthal / Anfinsen / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：蛋白质折叠的物理机制 (Levinthal 悖论)。',
    summaryJa: '生物学的分野における特定の難題：タンパク質折り畳みの物理的メカニズム（ Levinthal paradox ）。',
    summaryEs: '蛋白质折叠的物理机制 (Levinthal 悖论)（Physical mechanism of protein folding (Levinthal paradox)）：Levinthal / Anfinsen / 多团队 在 1969 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Physical mechanism of protein folding (Levinthal paradox).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 蛋白质折叠的物理机制 (Levinthal 悖论) 是这样一个问题：「蛋白质折叠的物理机制 (Levinthal 悖论)」是 生物 领域的 蛋白 方向，涉及 蛋白, 折叠 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「蛋白质折叠的物理机制 (Levinthal 悖论)」是 生物 领域的 蛋白 方向，涉及 蛋白, 折叠 等方面。',
    formal: '蛋白质折叠的物理机制 (Levinthal 悖论)（Physical mechanism of protein folding (Levinthal paradox)）：Levinthal / Anfinsen / 多团队 在 1969 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Levinthal paradox (Physical mechanism of protein folding (Levinthal paradox ))： 1969年にLevinthal/Anfinsen/Multiple teamsが提唱され、関連する実験・理論が完全に解決されていない。',
    formalEs: '蛋白质折叠的物理机制 (Levinthal 悖论)（Physical mechanism of protein folding (Levinthal paradox)）：Levinthal / Anfinsen / 多团队 在 1969 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Physical mechanism of protein folding (Levinthal paradox): proposed by Levinthal / Anfinsen / 多团队 in 1969; related experiments/theory remain incomplete.',
    whyHard: '「蛋白质折叠的物理机制 (Levinthal 悖论)」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['蛋白', '折叠'],
  },
  {
    id: 'bio-alphafold-limit',
    category: 'biology',
    title: 'AlphaFold 准确性的物理极限',
    titleJa: 'AlphaFold精度の物理的限界',
    titleEs: 'AlphaFold 准确性的物理极限（Physical limits of AlphaFold accuracy）：DeepMind / John Jumper / 多团队 在 2020 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Physical limits of AlphaFold accuracy',
    year: 2020,
    proposer: 'DeepMind / John Jumper / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：AlphaFold 准确性的物理极限。',
    summaryJa: '生物学分野における特定の難題： AlphaFold精度の物理的限界。',
    summaryEs: 'AlphaFold 准确性的物理极限（Physical limits of AlphaFold accuracy）：DeepMind / John Jumper / 多团队 在 2020 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Physical limits of AlphaFold accuracy.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 AlphaFold 准确性的物理极限。它说的是 「AlphaFold 准确性的物理极限」是 生物 领域的 AI 方向，涉及 AI, 蛋白 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「AlphaFold 准确性的物理极限」是 生物 领域的 AI 方向，涉及 AI, 蛋白 等方面。',
    formal: 'AlphaFold 准确性的物理极限（Physical limits of AlphaFold accuracy）：DeepMind / John Jumper / 多团队 在 2020 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'AlphaFold精度の物理的限界： 2020年にDeepMind/John Jumper/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: 'AlphaFold 准确性的物理极限（Physical limits of AlphaFold accuracy）：DeepMind / John Jumper / 多团队 在 2020 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Physical limits of AlphaFold accuracy: proposed by DeepMind / John Jumper / 多团队 in 2020; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['AI', '蛋白'],
  },
  {
    id: 'bio-de-novo-design',
    category: 'biology',
    title: '蛋白质从头设计 (de novo protein design)',
    titleJa: 'de novoタンパク質デザイン',
    titleEs: '蛋白质从头设计 (de novo protein design)（De novo protein design）：Baker / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'De novo protein design',
    year: 2003,
    proposer: 'Baker / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：蛋白质从头设计 (de novo protein design)。',
    summaryJa: '生物学的分野における特定の困難な問題：新規タンパク質設計。',
    summaryEs: '蛋白质从头设计 (de novo protein design)（De novo protein design）：Baker / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: De novo protein design.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 蛋白质从头设计 (de novo protein design) 是这样一个问题：「蛋白质从头设计 (de novo protein design)」是 生物 领域的 蛋白 方向，涉及 蛋白, 设计 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「蛋白质从头设计 (de novo protein design)」是 生物 领域的 蛋白 方向，涉及 蛋白, 设计 等方面。',
    formal: '蛋白质从头设计 (de novo protein design)（De novo protein design）：Baker / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalJa: '新規タンパク質設計（新規タンパク質設計） ： Baker/Multiチームは、関連する実験/理論がまだ完全に解決されていないことを2003年に提案しました。',
    formalEs: '蛋白质从头设计 (de novo protein design)（De novo protein design）：Baker / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'De novo protein design: proposed by Baker / 多团队 in 2003; related experiments/theory remain incomplete.',
    whyHard: '「蛋白质从头设计 (de novo protein design)」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['蛋白', '设计'],
  },
  {
    id: 'bio-enzyme-cat-mech',
    category: 'biology',
    title: '酶催化 (CYP450) 的精确机制',
    titleJa: '酵素触媒作用の正確なメカニズム（ CYP 450 ）',
    titleEs: '酶催化 (CYP450) 的精确机制（Precise mechanism of enzyme catalysis (CYP450)）：Ortiz de Montellano / 多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise mechanism of enzyme catalysis (CYP450)',
    year: 1970,
    proposer: 'Ortiz de Montellano / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：酶催化 (CYP450) 的精确机制。',
    summaryJa: '生物学的分野における特定の難題：酵素触媒作用の正確なメカニズム（ CYP 450 ）。',
    summaryEs: '酶催化 (CYP450) 的精确机制（Precise mechanism of enzyme catalysis (CYP450)）：Ortiz de Montellano / 多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Precise mechanism of enzyme catalysis (CYP450).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 酶催化 (CYP450) 的精确机制 的核心问题是：「酶催化 (CYP450) 的精确机制」是 生物 领域的 酶 方向，涉及 酶, 机制 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「酶催化 (CYP450) 的精确机制」是 生物 领域的 酶 方向，涉及 酶, 机制 等方面。',
    formal: '酶催化 (CYP450) 的精确机制（Precise mechanism of enzyme catalysis (CYP450)）：Ortiz de Montellano / 多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalJa: '酵素触媒の正確なメカニズム（ CYP 450 ） ： 1970年にOrtiz de Montellano/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: '酶催化 (CYP450) 的精确机制（Precise mechanism of enzyme catalysis (CYP450)）：Ortiz de Montellano / 多团队 在 1970 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise mechanism of enzyme catalysis (CYP450): proposed by Ortiz de Montellano / 多团队 in 1970; related experiments/theory remain incomplete.',
    whyHard: '「酶催化 (CYP450) 的精确机制」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['酶', '机制'],
  },
  {
    id: 'bio-membrane-prot-struct',
    category: 'biology',
    title: '膜蛋白的天然构象冷冻电镜',
    titleJa: '膜タンパク質の天然立体構造凍結電子顕微鏡検査',
    titleEs: '膜蛋白的天然构象冷冻电镜（Native conformation of membrane proteins by cryo-EM）：Cheng / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Native conformation of membrane proteins by cryo-EM',
    year: 2010,
    proposer: 'Cheng / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：膜蛋白的天然构象冷冻电镜。',
    summaryJa: '生物学的分野における特定の困難な問題：電子顕微鏡で凍結された膜タンパク質の自然なコンフォメーション。',
    summaryEs: '膜蛋白的天然构象冷冻电镜（Native conformation of membrane proteins by cryo-EM）：Cheng / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Native conformation of membrane proteins by cryo-EM.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 膜蛋白的天然构象冷冻电镜 是这样一个问题：「膜蛋白的天然构象冷冻电镜」是 生物 领域的 膜 方向，涉及 膜, cryo-EM 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「膜蛋白的天然构象冷冻电镜」是 生物 领域的 膜 方向，涉及 膜, cryo-EM 等方面。',
    formal: '膜蛋白的天然构象冷冻电镜（Native conformation of membrane proteins by cryo-EM）：Cheng / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'cryo - EMによる膜タンパク質の天然コンフォメーション： 2010年にCheng/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: '膜蛋白的天然构象冷冻电镜（Native conformation of membrane proteins by cryo-EM）：Cheng / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Native conformation of membrane proteins by cryo-EM: proposed by Cheng / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '「膜蛋白的天然构象冷冻电镜」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['膜', 'cryo-EM'],
  },
  {
    id: 'bio-gpcr-bias',
    category: 'biology',
    title: 'GPCR 偏向性信号 (biased agonism)',
    titleJa: 'GPCRバイアスアゴニズム',
    titleEs: 'GPCR 偏向性信号 (biased agonism)（GPCR biased signaling (functional selectivity)）：Kenakin / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'GPCR biased signaling (functional selectivity)',
    year: 2000,
    proposer: 'Kenakin / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：GPCR 偏向性信号 (biased agonism)。',
    summaryJa: '生物学的分野における特定の困難な問題： GPCRバイアスアゴニズム。',
    summaryEs: 'GPCR 偏向性信号 (biased agonism)（GPCR biased signaling (functional selectivity)）：Kenakin / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: GPCR biased signaling (functional selectivity).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 GPCR 偏向性信号 (biased agonism) 的核心问题是：「GPCR 偏向性信号 (biased agonism)」是 生物 领域的 GPCR 方向，涉及 GPCR, 药理 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「GPCR 偏向性信号 (biased agonism)」是 生物 领域的 GPCR 方向，涉及 GPCR, 药理 等方面。',
    formal: 'GPCR 偏向性信号 (biased agonism)（GPCR biased signaling (functional selectivity)）：Kenakin / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＧＰＣＲバイアスアゴニズム（ ＧＰＣＲバイアスシグナル伝達（機能選択性） ） ： ２ ０ ０ ０年にケナキン／マルチチームが提案され、関連する実験／理論は完全に解決されていない。',
    formalEs: 'GPCR 偏向性信号 (biased agonism)（GPCR biased signaling (functional selectivity)）：Kenakin / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'GPCR biased signaling (functional selectivity): proposed by Kenakin / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '「GPCR 偏向性信号 (biased agonism)」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['GPCR', '药理'],
  },
  {
    id: 'bio-rtk-dimer',
    category: 'biology',
    title: '受体酪氨酸激酶二聚化的动态机制',
    titleJa: '受容体チロシンキナーゼ二量体化の動態',
    titleEs: '受体酪氨酸激酶二聚化的动态机制（Dynamic mechanism of receptor tyrosine kinase dimerization）：Ullrich / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Dynamic mechanism of receptor tyrosine kinase dimerization',
    year: 2000,
    proposer: 'Ullrich / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：受体酪氨酸激酶二聚化的动态机制。',
    summaryJa: '生物学的分野における特定の難題：受容体チロシンキナーゼ二量体化の動的メカニズム。',
    summaryEs: '受体酪氨酸激酶二聚化的动态机制（Dynamic mechanism of receptor tyrosine kinase dimerization）：Ullrich / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Dynamic mechanism of receptor tyrosine kinase dimerization.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 受体酪氨酸激酶二聚化的动态机制 是这样一个问题：「受体酪氨酸激酶二聚化的动态机制」是 生物 领域的 RTK 方向，涉及 RTK, 信号 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「受体酪氨酸激酶二聚化的动态机制」是 生物 领域的 RTK 方向，涉及 RTK, 信号 等方面。',
    formal: '受体酪氨酸激酶二聚化的动态机制（Dynamic mechanism of receptor tyrosine kinase dimerization）：Ullrich / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '受容体チロシンキナーゼ二量体化の動的メカニズム： Ullrich/Multiチームは2000年に提案し、関連する実験/理論は完全には解決されていない。',
    formalEs: '受体酪氨酸激酶二聚化的动态机制（Dynamic mechanism of receptor tyrosine kinase dimerization）：Ullrich / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Dynamic mechanism of receptor tyrosine kinase dimerization: proposed by Ullrich / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '尽管 Ullrich / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['RTK', '信号'],
  },
  {
    id: 'bio-ion-channel-gate',
    category: 'biology',
    title: '电压门控离子通道 (Kv1.2) 的开关机制',
    titleJa: '電圧ゲートイオンチャネルの切り替え機構（ Kv1.2 ）',
    titleEs: '电压门控离子通道 (Kv1.2) 的开关机制（Gating mechanism of voltage-gated ion channels (Kv1.2)）：MacKinnon / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Gating mechanism of voltage-gated ion channels (Kv1.2)',
    year: 2010,
    proposer: 'MacKinnon / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：电压门控离子通道 (Kv1.2) 的开关机制。',
    summaryJa: '生物学分野における特定の難題：電圧ゲートイオンチャネルの切り替え機構（ Kv1.2 ）。',
    summaryEs: '电压门控离子通道 (Kv1.2) 的开关机制（Gating mechanism of voltage-gated ion channels (Kv1.2)）：MacKinnon / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Gating mechanism of voltage-gated ion channels (Kv1.2).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 电压门控离子通道 (Kv1.2) 的开关机制。它说的是 「电压门控离子通道 (Kv1.2) 的开关机制」是 生物 领域的 通道 方向，涉及 通道, 电生理 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「电压门控离子通道 (Kv1.2) 的开关机制」是 生物 领域的 通道 方向，涉及 通道, 电生理 等方面。',
    formal: '电压门控离子通道 (Kv1.2) 的开关机制（Gating mechanism of voltage-gated ion channels (Kv1.2)）：MacKinnon / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '電圧ゲートイオンチャネル（ Kv1.2 ）のゲーティング機構： 2010年にマッキノン/マルチチームが提案され、関連する実験/理論はこれまで完全には解決されていない。',
    formalEs: '电压门控离子通道 (Kv1.2) 的开关机制（Gating mechanism of voltage-gated ion channels (Kv1.2)）：MacKinnon / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Gating mechanism of voltage-gated ion channels (Kv1.2): proposed by MacKinnon / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['通道', '电生理'],
  },
  {
    id: 'bio-snare-fusion',
    category: 'biology',
    title: '突触 SNARE 介导的囊泡融合机制',
    titleJa: 'シナプススネア媒介小胞融合機構',
    titleEs: '突触 SNARE 介导的囊泡融合机制（Mechanism of synaptic SNARE-mediated vesicle fusion）：Rothman / Südhof / 多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of synaptic SNARE-mediated vesicle fusion',
    year: 1993,
    proposer: 'Rothman / Südhof / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：突触 SNARE 介导的囊泡融合机制。',
    summaryJa: '生物学的分野における特定の困難な問題：シナプススネア媒介小胞融合機構。',
    summaryEs: '突触 SNARE 介导的囊泡融合机制（Mechanism of synaptic SNARE-mediated vesicle fusion）：Rothman / Südhof / 多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of synaptic SNARE-mediated vesicle fusion.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 突触 SNARE 介导的囊泡融合机制。它说的是 「突触 SNARE 介导的囊泡融合机制」是 生物 领域的 突触 方向，涉及 突触, 囊泡 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「突触 SNARE 介导的囊泡融合机制」是 生物 领域的 突触 方向，涉及 突触, 囊泡 等方面。',
    formal: '突触 SNARE 介导的囊泡融合机制（Mechanism of synaptic SNARE-mediated vesicle fusion）：Rothman / Südhof / 多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'シナプスSNARE媒介小胞融合のメカニズム： 1993年にRothman/Südhof/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: '突触 SNARE 介导的囊泡融合机制（Mechanism of synaptic SNARE-mediated vesicle fusion）：Rothman / Südhof / 多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of synaptic SNARE-mediated vesicle fusion: proposed by Rothman / Südhof / 多团队 in 1993; related experiments/theory remain incomplete.',
    whyHard: '尽管 Rothman / Südhof / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['突触', '囊泡'],
  },
  {
    id: 'bio-ltp-ltd',
    category: 'biology',
    title: '长时程增强 (LTP) 与抑制 (LTD) 的分子机制',
    titleJa: '長期増強（ ＬＴＰ ）及び阻害（ ＬＴＤ ）の分子機構',
    titleEs: '长时程增强 (LTP) 与抑制 (LTD) 的分子机制（Molecular mechanism of LTP and LTD）：Bliss / Lømo / 多团队 在 1973 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Molecular mechanism of LTP and LTD',
    year: 1973,
    proposer: 'Bliss / Lømo / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：长时程增强 (LTP) 与抑制 (LTD) 的分子机制。',
    summaryJa: '生物学的分野における特定の難題：長距離増強（ LTP ）および阻害（ LTD ）の分子機構。',
    summaryEs: '长时程增强 (LTP) 与抑制 (LTD) 的分子机制（Molecular mechanism of LTP and LTD）：Bliss / Lømo / 多团队 在 1973 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Molecular mechanism of LTP and LTD.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 长时程增强 (LTP) 与抑制 (LTD) 的分子机制。它说的是 「长时程增强 (LTP) 与抑制 (LTD) 的分子机制」是 生物 领域的 突触 方向，涉及 突触, 记忆 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「长时程增强 (LTP) 与抑制 (LTD) 的分子机制」是 生物 领域的 突触 方向，涉及 突触, 记忆 等方面。',
    formal: '长时程增强 (LTP) 与抑制 (LTD) 的分子机制（Molecular mechanism of LTP and LTD）：Bliss / Lømo / 多团队 在 1973 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'LTPとLTDの分子メカニズム： 1973年にBliss/Lømo/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '长时程增强 (LTP) 与抑制 (LTD) 的分子机制（Molecular mechanism of LTP and LTD）：Bliss / Lømo / 多团队 在 1973 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Molecular mechanism of LTP and LTD: proposed by Bliss / Lømo / 多团队 in 1973; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['突触', '记忆'],
  },
  {
    id: 'bio-memory-engram',
    category: 'biology',
    title: '记忆痕迹 (engram) 的物理位置',
    titleJa: 'エングラムの物理的位置',
    titleEs: '记忆痕迹 (engram) 的物理位置（Physical location of memory engrams）：Tonegawa / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Physical location of memory engrams',
    year: 2010,
    proposer: 'Tonegawa / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：记忆痕迹 (engram) 的物理位置。',
    summaryJa: '生物学的分野における特定の困難な問題：エングラムの物理的位置。',
    summaryEs: '记忆痕迹 (engram) 的物理位置（Physical location of memory engrams）：Tonegawa / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Physical location of memory engrams.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 记忆痕迹 (engram) 的物理位置 是这样一个问题：「记忆痕迹 (engram) 的物理位置」是 生物 领域的 记忆 方向，涉及 记忆, 脑 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「记忆痕迹 (engram) 的物理位置」是 生物 领域的 记忆 方向，涉及 记忆, 脑 等方面。',
    formal: '记忆痕迹 (engram) 的物理位置（Physical location of memory engrams）：Tonegawa / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '記憶エングラムの物理的位置：利根川/マルチチームは2010年に、これまでのところ関連する実験/理論が完全に解決されていないことを提案した。',
    formalEs: '记忆痕迹 (engram) 的物理位置（Physical location of memory engrams）：Tonegawa / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Physical location of memory engrams: proposed by Tonegawa / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['记忆', '脑'],
  },
  {
    id: 'bio-connectome',
    category: 'biology',
    title: '哺乳动物脑功能连接组',
    titleJa: '哺乳類脳機能コネクトーム',
    titleEs: '哺乳动物脑功能连接组（Mammalian brain functional connectome）：Sporns / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mammalian brain functional connectome',
    year: 2010,
    proposer: 'Sporns / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：哺乳动物脑功能连接组。',
    summaryJa: '生物学的分野における特定の困難な問題：哺乳類の脳機能コネクトーム。',
    summaryEs: '哺乳动物脑功能连接组（Mammalian brain functional connectome）：Sporns / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mammalian brain functional connectome.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 哺乳动物脑功能连接组 的问题。它可以简单描述为 「哺乳动物脑功能连接组」是 生物 领域的 脑 方向，涉及 脑, 连接组 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「哺乳动物脑功能连接组」是 生物 领域的 脑 方向，涉及 脑, 连接组 等方面。',
    formal: '哺乳动物脑功能连接组（Mammalian brain functional connectome）：Sporns / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '哺乳類の脳機能コネクトーム： 2010年に提案されたSporns/複数のチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: '哺乳动物脑功能连接组（Mammalian brain functional connectome）：Sporns / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mammalian brain functional connectome: proposed by Sporns / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Sporns / 多团队 等人在 2010 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['脑', '连接组'],
  },
  {
    id: 'bio-dmn',
    category: 'biology',
    title: '默认模式网络 (DMN) 的功能',
    titleJa: 'デフォルトモードネットワーク（ DMN ）の機能',
    titleEs: '默认模式网络 (DMN) 的功能（Function of default mode network (DMN)）：Raichle / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Function of default mode network (DMN)',
    year: 2001,
    proposer: 'Raichle / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：默认模式网络 (DMN) 的功能。',
    summaryJa: '生物学の分野における特定の困難な問題：デフォルトモードネットワーク（ DMN ）の機能。',
    summaryEs: '默认模式网络 (DMN) 的功能（Function of default mode network (DMN)）：Raichle / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Function of default mode network (DMN).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 默认模式网络 (DMN) 的功能 的核心问题是：「默认模式网络 (DMN) 的功能」是 生物 领域的 脑 方向，涉及 脑, 网络 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「默认模式网络 (DMN) 的功能」是 生物 领域的 脑 方向，涉及 脑, 网络 等方面。',
    formal: '默认模式网络 (DMN) 的功能（Function of default mode network (DMN)）：Raichle / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'デフォルトモードネットワーク（ DMN ）の機能： Raichle/マルチチームは、関連する実験/理論が完全に解決されていないことを2001年に提案しました。',
    formalEs: '默认模式网络 (DMN) 的功能（Function of default mode network (DMN)）：Raichle / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Function of default mode network (DMN): proposed by Raichle / 多团队 in 2001; related experiments/theory remain incomplete.',
    whyHard: '尽管 Raichle / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['脑', '网络'],
  },
  {
    id: 'bio-consciousness',
    category: 'biology',
    title: '意识的神经基础 (IIT vs GNW)',
    titleJa: '意識の神経基盤（ IIT対GNW ）',
    titleEs: '意识的神经基础 (IIT vs GNW)（Neural basis of consciousness (IIT vs GNW)）：Tononi / Dehaene / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Neural basis of consciousness (IIT vs GNW)',
    year: 2004,
    proposer: 'Tononi / Dehaene / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：意识的神经基础 (IIT vs GNW)。',
    summaryJa: '生物学的分野における特定の難題：意識の神経的基盤（ IIT対GNW ）。',
    summaryEs: '意识的神经基础 (IIT vs GNW)（Neural basis of consciousness (IIT vs GNW)）：Tononi / Dehaene / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Neural basis of consciousness (IIT vs GNW).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 意识的神经基础 (IIT vs GNW) 是这样一个问题：「意识的神经基础 (IIT vs GNW)」是 生物 领域的 意识 方向，涉及 意识, 哲学 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「意识的神经基础 (IIT vs GNW)」是 生物 领域的 意识 方向，涉及 意识, 哲学 等方面。',
    formal: '意识的神经基础 (IIT vs GNW)（Neural basis of consciousness (IIT vs GNW)）：Tononi / Dehaene / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: '意識の神経基盤（ IIT対GNW ） ： Tononi/Dehaene/Multiチームは、関連する実験/理論はまだ完全に解決されていないと2004年に提案した。',
    formalEs: '意识的神经基础 (IIT vs GNW)（Neural basis of consciousness (IIT vs GNW)）：Tononi / Dehaene / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Neural basis of consciousness (IIT vs GNW): proposed by Tononi / Dehaene / 多团队 in 2004; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['意识', '哲学'],
  },
  {
    id: 'bio-sleep-function',
    category: 'biology',
    title: '睡眠的功能 (为何需要睡眠)',
    titleJa: '睡眠機能（なぜ睡眠が必要なのか）',
    titleEs: '睡眠的功能 (为何需要睡眠)（Function of sleep (why we need to sleep)）：Berger / 多团队 在 1920 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Function of sleep (why we need to sleep)',
    year: 1920,
    proposer: 'Berger / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：睡眠的功能 (为何需要睡眠)。',
    summaryJa: '生物学の分野における特定の困難な問題：睡眠の機能（なぜ睡眠が必要なのか）。',
    summaryEs: '睡眠的功能 (为何需要睡眠)（Function of sleep (why we need to sleep)）：Berger / 多团队 在 1920 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Function of sleep (why we need to sleep).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 睡眠的功能 (为何需要睡眠) 的问题。它可以简单描述为 「睡眠的功能 (为何需要睡眠)」是 生物 领域的 睡眠 方向，涉及 睡眠, 脑 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「睡眠的功能 (为何需要睡眠)」是 生物 领域的 睡眠 方向，涉及 睡眠, 脑 等方面。',
    formal: '睡眠的功能 (为何需要睡眠)（Function of sleep (why we need to sleep)）：Berger / 多团队 在 1920 年提出，相关实验/理论至今未完全解决。',
    formalJa: '睡眠の機能（なぜ睡眠が必要なのか） ： 1920年にBerger/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '睡眠的功能 (为何需要睡眠)（Function of sleep (why we need to sleep)）：Berger / 多团队 在 1920 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Function of sleep (why we need to sleep): proposed by Berger / 多团队 in 1920; related experiments/theory remain incomplete.',
    whyHard: '「睡眠的功能 (为何需要睡眠)」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['睡眠', '脑'],
  },
  {
    id: 'bio-circadian-mol',
    category: 'biology',
    title: '昼夜节律的分子振荡器机制',
    titleJa: '概日分子発振機構',
    titleEs: '昼夜节律的分子振荡器机制（Molecular oscillator mechanism of circadian rhythm）：Hall / Rosbash / Young 在 1994 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Molecular oscillator mechanism of circadian rhythm',
    year: 1994,
    proposer: 'Hall / Rosbash / Young',
    difficulty: 3,
    reward: 300,
    status: 'solved',
    summary: '一道 生物 领域的具体硬问题：昼夜节律的分子振荡器机制。',
    summaryJa: '生物学分野における特定の困難な問題：概日リズムの分子発振器メカニズム。',
    summaryEs: '昼夜节律的分子振荡器机制（Molecular oscillator mechanism of circadian rhythm）：Hall / Rosbash / Young 在 1994 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Molecular oscillator mechanism of circadian rhythm.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 昼夜节律的分子振荡器机制。它说的是 「昼夜节律的分子振荡器机制」是 生物 领域的 节律 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「昼夜节律的分子振荡器机制」是 生物 领域的 节律 方向。',
    formal: '昼夜节律的分子振荡器机制（Molecular oscillator mechanism of circadian rhythm）：Hall / Rosbash / Young 在 1994 年提出，相关实验/理论至今未完全解决。',
    formalJa: '概日リズムの分子発振機構： Hall/Rosbash/Youngは1994年に提唱しており、関連する実験・理論は完全には解明されていない。',
    formalEs: '昼夜节律的分子振荡器机制（Molecular oscillator mechanism of circadian rhythm）：Hall / Rosbash / Young 在 1994 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Molecular oscillator mechanism of circadian rhythm: proposed by Hall / Rosbash / Young in 1994; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['节律'],
  },
  {
    id: 'bio-stem-cell-pluripotent',
    category: 'biology',
    title: '干细胞全能性 (pluripotency) 维持机制',
    titleJa: '幹細胞多能性維持機構',
    titleEs: '干细胞全能性 (pluripotency) 维持机制（Maintenance of pluripotency in stem cells）：Yamanaka / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Maintenance of pluripotency in stem cells',
    year: 2006,
    proposer: 'Yamanaka / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：干细胞全能性 (pluripotency) 维持机制。',
    summaryJa: '生物学分野における特定の難題：幹細胞多能性の維持メカニズム。',
    summaryEs: '干细胞全能性 (pluripotency) 维持机制（Maintenance of pluripotency in stem cells）：Yamanaka / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Maintenance of pluripotency in stem cells.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 干细胞全能性 (pluripotency) 维持机制。它说的是 「干细胞全能性 (pluripotency) 维持机制」是 生物 领域的 干细胞 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「干细胞全能性 (pluripotency) 维持机制」是 生物 领域的 干细胞 方向。',
    formal: '干细胞全能性 (pluripotency) 维持机制（Maintenance of pluripotency in stem cells）：Yamanaka / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalJa: '幹細胞における多能性の維持：山中/マルチチームは2006年に提案され、関連する実験/理論は完全には解決されていない。',
    formalEs: '干细胞全能性 (pluripotency) 维持机制（Maintenance of pluripotency in stem cells）：Yamanaka / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Maintenance of pluripotency in stem cells: proposed by Yamanaka / 多团队 in 2006; related experiments/theory remain incomplete.',
    whyHard: '「干细胞全能性 (pluripotency) 维持机制」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['干细胞'],
  },
  {
    id: 'bio-ipsc-reprogram',
    category: 'biology',
    title: 'iPSC 重编程的分子机制',
    titleJa: 'iPSCリプログラミングの分子機序',
    titleEs: 'iPSC 重编程的分子机制（Molecular mechanism of iPSC reprogramming）：Takahashi / Yamanaka 在 2006 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Molecular mechanism of iPSC reprogramming',
    year: 2006,
    proposer: 'Takahashi / Yamanaka',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：iPSC 重编程的分子机制。',
    summaryJa: '生物学的分野における特定の困難な問題： iPSCリプログラミングの分子メカニズム。',
    summaryEs: 'iPSC 重编程的分子机制（Molecular mechanism of iPSC reprogramming）：Takahashi / Yamanaka 在 2006 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Molecular mechanism of iPSC reprogramming.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 iPSC 重编程的分子机制 是这样一个问题：「iPSC 重编程的分子机制」是 生物 领域的 iPSC 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「iPSC 重编程的分子机制」是 生物 领域的 iPSC 方向。',
    formal: 'iPSC 重编程的分子机制（Molecular mechanism of iPSC reprogramming）：Takahashi / Yamanaka 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'iPSCリプログラミングの分子機構： 2006年にTakahashi/Yamanakaが提唱したが、関連する実験・理論は完全には解明されていない。',
    formalEs: 'iPSC 重编程的分子机制（Molecular mechanism of iPSC reprogramming）：Takahashi / Yamanaka 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Molecular mechanism of iPSC reprogramming: proposed by Takahashi / Yamanaka in 2006; related experiments/theory remain incomplete.',
    whyHard: '尽管 Takahashi / Yamanaka 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['iPSC'],
  },
  {
    id: 'bio-scnt-efficiency',
    category: 'biology',
    title: '体细胞克隆 (SCNT) 效率的瓶颈',
    titleJa: '体細胞クローニング（ SCNT ）効率のボトルネック',
    titleEs: '体细胞克隆 (SCNT) 效率的瓶颈（Bottleneck of SCNT cloning efficiency）：Wilmut / 多团队 在 1996 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Bottleneck of SCNT cloning efficiency',
    year: 1996,
    proposer: 'Wilmut / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：体细胞克隆 (SCNT) 效率的瓶颈。',
    summaryJa: '生物学的分野における特定の難題：体細胞クローニング（ SCNT ）効率のボトルネック。',
    summaryEs: '体细胞克隆 (SCNT) 效率的瓶颈（Bottleneck of SCNT cloning efficiency）：Wilmut / 多团队 在 1996 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Bottleneck of SCNT cloning efficiency.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 体细胞克隆 (SCNT) 效率的瓶颈 的问题。它可以简单描述为 「体细胞克隆 (SCNT) 效率的瓶颈」是 生物 领域的 克隆 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「体细胞克隆 (SCNT) 效率的瓶颈」是 生物 领域的 克隆 方向。',
    formal: '体细胞克隆 (SCNT) 效率的瓶颈（Bottleneck of SCNT cloning efficiency）：Wilmut / 多团队 在 1996 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'SCNTクローニング効率のボトルネック： Wilmut/Multiチームは1996年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: '体细胞克隆 (SCNT) 效率的瓶颈（Bottleneck of SCNT cloning efficiency）：Wilmut / 多团队 在 1996 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Bottleneck of SCNT cloning efficiency: proposed by Wilmut / 多团队 in 1996; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Wilmut / 多团队 等人在 1996 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['克隆'],
  },
  {
    id: 'bio-crispr-offtarget',
    category: 'biology',
    title: 'CRISPR-Cas9 脱靶效应预测',
    titleJa: 'CRISPR - Cas 9オフターゲット効果予測',
    titleEs: 'CRISPR-Cas9 脱靶效应预测（CRISPR-Cas9 off-target prediction）：Zhang / Doudna / Charpentier 在 2012 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'CRISPR-Cas9 off-target prediction',
    year: 2012,
    proposer: 'Zhang / Doudna / Charpentier',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：CRISPR-Cas9 脱靶效应预测。',
    summaryJa: '生物学的分野における特定の難題： CRISPR - Cas 9オフターゲット効果予測。',
    summaryEs: 'CRISPR-Cas9 脱靶效应预测（CRISPR-Cas9 off-target prediction）：Zhang / Doudna / Charpentier 在 2012 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: CRISPR-Cas9 off-target prediction.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 CRISPR-Cas9 脱靶效应预测 的问题。它可以简单描述为 「CRISPR-Cas9 脱靶效应预测」是 生物 领域的 CRISPR 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「CRISPR-Cas9 脱靶效应预测」是 生物 领域的 CRISPR 方向。',
    formal: 'CRISPR-Cas9 脱靶效应预测（CRISPR-Cas9 off-target prediction）：Zhang / Doudna / Charpentier 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'CRISPR - Cas 9オフターゲット予測： Zhang/Doudna/Charpentierは2012年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: 'CRISPR-Cas9 脱靶效应预测（CRISPR-Cas9 off-target prediction）：Zhang / Doudna / Charpentier 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'CRISPR-Cas9 off-target prediction: proposed by Zhang / Doudna / Charpentier in 2012; related experiments/theory remain incomplete.',
    whyHard: '「CRISPR-Cas9 脱靶效应预测」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CRISPR'],
  },
  {
    id: 'bio-base-editor',
    category: 'biology',
    title: '碱基编辑器 (Base Editor) 准确度',
    titleJa: 'ベースエディターの精度',
    titleEs: '碱基编辑器 (Base Editor) 准确度（Accuracy of base editors (CBE, ABE)）：Liu / Komor / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Accuracy of base editors (CBE, ABE)',
    year: 2016,
    proposer: 'Liu / Komor / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：碱基编辑器 (Base Editor) 准确度。',
    summaryJa: '生物学分野の特定の難しい問題：ベースエディタの精度。',
    summaryEs: '碱基编辑器 (Base Editor) 准确度（Accuracy of base editors (CBE, ABE)）：Liu / Komor / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Accuracy of base editors (CBE, ABE).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 碱基编辑器 (Base Editor) 准确度 是这样一个问题：「碱基编辑器 (Base Editor) 准确度」是 生物 领域的 基因编辑 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「碱基编辑器 (Base Editor) 准确度」是 生物 领域的 基因编辑 方向。',
    formal: '碱基编辑器 (Base Editor) 准确度（Accuracy of base editors (CBE, ABE)）：Liu / Komor / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ベースエディタ（ CBE、ABE ）の精度： 2016年にLiu/Komor/複数のチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: '碱基编辑器 (Base Editor) 准确度（Accuracy of base editors (CBE, ABE)）：Liu / Komor / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Accuracy of base editors (CBE, ABE): proposed by Liu / Komor / 多团队 in 2016; related experiments/theory remain incomplete.',
    whyHard: '尽管 Liu / Komor / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['基因编辑'],
  },
  {
    id: 'bio-prime-editor',
    category: 'biology',
    title: '先导编辑 (Prime Editor) 通用性',
    titleJa: 'プライムエディターの共通性',
    titleEs: '先导编辑 (Prime Editor) 通用性（Versatility of prime editing）：Liu / Anzalone / 多团队 在 2019 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Versatility of prime editing',
    year: 2019,
    proposer: 'Liu / Anzalone / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：先导编辑 (Prime Editor) 通用性。',
    summaryJa: '生物学の分野における特定の困難な問題：プライムエディターの一般性。',
    summaryEs: '先导编辑 (Prime Editor) 通用性（Versatility of prime editing）：Liu / Anzalone / 多团队 在 2019 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Versatility of prime editing.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 先导编辑 (Prime Editor) 通用性 的核心问题是：「先导编辑 (Prime Editor) 通用性」是 生物 领域的 基因编辑 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「先导编辑 (Prime Editor) 通用性」是 生物 领域的 基因编辑 方向。',
    formal: '先导编辑 (Prime Editor) 通用性（Versatility of prime editing）：Liu / Anzalone / 多团队 在 2019 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'プライム編集者プライム編集の汎用性： 2019年にLiu/Anzalone/マルチチームによって提案されたが、これまでのところ関連する実験/理論は完全に解決されていない。',
    formalEs: '先导编辑 (Prime Editor) 通用性（Versatility of prime editing）：Liu / Anzalone / 多团队 在 2019 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Versatility of prime editing: proposed by Liu / Anzalone / 多团队 in 2019; related experiments/theory remain incomplete.',
    whyHard: '尽管 Liu / Anzalone / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['基因编辑'],
  },
  {
    id: 'bio-dna-methylation',
    category: 'biology',
    title: 'DNA 甲基化动态调控 (5mC, 6mA)',
    titleJa: 'DNAメチル化の動的調節（ 5 mC、6 mA ）',
    titleEs: 'DNA 甲基化动态调控 (5mC, 6mA)（Dynamic regulation of DNA methylation (5mC, 6mA)）：Razin / 多团队 在 1975 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Dynamic regulation of DNA methylation (5mC, 6mA)',
    year: 1975,
    proposer: 'Razin / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：DNA 甲基化动态调控 (5mC, 6mA)。',
    summaryJa: '生物学的分野における特定の難題： ＤＮＡメチル化（ ５ ｍＣ、６ ｍＡ ）の動的調節。',
    summaryEs: 'DNA 甲基化动态调控 (5mC, 6mA)（Dynamic regulation of DNA methylation (5mC, 6mA)）：Razin / 多团队 在 1975 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Dynamic regulation of DNA methylation (5mC, 6mA).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 DNA 甲基化动态调控 (5mC, 6mA) 是这样一个问题：「DNA 甲基化动态调控 (5mC, 6mA)」是 生物 领域的 表观 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「DNA 甲基化动态调控 (5mC, 6mA)」是 生物 领域的 表观 方向。',
    formal: 'DNA 甲基化动态调控 (5mC, 6mA)（Dynamic regulation of DNA methylation (5mC, 6mA)）：Razin / 多团队 在 1975 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＤＮＡメチル化の動的調節（ ５ ｍＣ、６ ｍＡ ） ： １ ９ ７ ５年に提案されたＲａｚｉｎ ／ Ｍｕｌｔｉチームでは、関連する実験／理論が完全に解決されていない。',
    formalEs: 'DNA 甲基化动态调控 (5mC, 6mA)（Dynamic regulation of DNA methylation (5mC, 6mA)）：Razin / 多团队 在 1975 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Dynamic regulation of DNA methylation (5mC, 6mA): proposed by Razin / 多团队 in 1975; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Razin / 多团队 等人在 1975 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['表观'],
  },
  {
    id: 'bio-x-inactivation',
    category: 'biology',
    title: 'X 染色体失活 (XCI) 机制',
    titleJa: 'X染色体不活性化（ XCI ）機構',
    titleEs: 'X 染色体失活 (XCI) 机制（Mechanism of X chromosome inactivation (XCI)）：Lyon / 多团队 在 1961 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of X chromosome inactivation (XCI)',
    year: 1961,
    proposer: 'Lyon / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：X 染色体失活 (XCI) 机制。',
    summaryJa: '生物学的分野における特定の困難な問題： X染色体不活性化（ XCI ）メカニズム。',
    summaryEs: 'X 染色体失活 (XCI) 机制（Mechanism of X chromosome inactivation (XCI)）：Lyon / 多团队 在 1961 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of X chromosome inactivation (XCI).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 X 染色体失活 (XCI) 机制 的核心问题是：「X 染色体失活 (XCI) 机制」是 生物 领域的 染色体 方向，涉及 染色体, XCI 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「X 染色体失活 (XCI) 机制」是 生物 领域的 染色体 方向，涉及 染色体, XCI 等方面。',
    formal: 'X 染色体失活 (XCI) 机制（Mechanism of X chromosome inactivation (XCI)）：Lyon / 多团队 在 1961 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'X染色体不活性化（ XCI ） X染色体不活性化のメカニズム（ XCI ） ： 1961年にLyon/Multiチームが提案し、関連する実験/理論は完全には解決されていない。',
    formalEs: 'X 染色体失活 (XCI) 机制（Mechanism of X chromosome inactivation (XCI)）：Lyon / 多团队 在 1961 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of X chromosome inactivation (XCI): proposed by Lyon / 多团队 in 1961; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['染色体', 'XCI'],
  },
  {
    id: 'bio-lncrna-func',
    category: 'biology',
    title: '长链非编码 RNA (lncRNA) 的功能',
    titleJa: '長い非コードＲＮＡ （ ｌｎｃＲＮＡ ）の機能',
    titleEs: '长链非编码 RNA (lncRNA) 的功能（Function of long non-coding RNAs (lncRNA)）：多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Function of long non-coding RNAs (lncRNA)',
    year: 2002,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：长链非编码 RNA (lncRNA) 的功能。',
    summaryJa: '生物学的分野における特定の難題：長い非コードＲＮＡ （ ｌｎｃＲＮＡ ）の機能。',
    summaryEs: '长链非编码 RNA (lncRNA) 的功能（Function of long non-coding RNAs (lncRNA)）：多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Function of long non-coding RNAs (lncRNA).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 长链非编码 RNA (lncRNA) 的功能。它说的是 「长链非编码 RNA (lncRNA) 的功能」是 生物 领域的 ncRNA 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「长链非编码 RNA (lncRNA) 的功能」是 生物 领域的 ncRNA 方向。',
    formal: '长链非编码 RNA (lncRNA) 的功能（Function of long non-coding RNAs (lncRNA)）：多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    formalJa: '長い非コードＲＮＡ （ ｌｎｃＲＮＡ ）の機能： ２ ０ ０ ２年に複数のチームによって提案されたが、関連する実験／理論はまだ完全に解決されていない。',
    formalEs: '长链非编码 RNA (lncRNA) 的功能（Function of long non-coding RNAs (lncRNA)）：多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Function of long non-coding RNAs (lncRNA): proposed by 多团队 in 2002; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['ncRNA'],
  },
  {
    id: 'bio-mirna-network',
    category: 'biology',
    title: 'miRNA 调控网络的动态',
    titleJa: 'miRNA調節ネットワークのダイナミクス',
    titleEs: 'miRNA 调控网络的动态（Dynamics of miRNA regulatory networks）：Ambros / Bartel / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Dynamics of miRNA regulatory networks',
    year: 2001,
    proposer: 'Ambros / Bartel / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：miRNA 调控网络的动态。',
    summaryJa: '生物学的分野における特定の困難な問題： miRNA調節ネットワークのダイナミクス。',
    summaryEs: 'miRNA 调控网络的动态（Dynamics of miRNA regulatory networks）：Ambros / Bartel / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Dynamics of miRNA regulatory networks.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 miRNA 调控网络的动态 的核心问题是：「miRNA 调控网络的动态」是 生物 领域的 miRNA 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「miRNA 调控网络的动态」是 生物 领域的 miRNA 方向。',
    formal: 'miRNA 调控网络的动态（Dynamics of miRNA regulatory networks）：Ambros / Bartel / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'miRNA調節ネットワークのダイナミクス： 2001年にAmbros/Bartel/マルチチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'miRNA 调控网络的动态（Dynamics of miRNA regulatory networks）：Ambros / Bartel / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Dynamics of miRNA regulatory networks: proposed by Ambros / Bartel / 多团队 in 2001; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['miRNA'],
  },
  {
    id: 'bio-rna-splicing',
    category: 'biology',
    title: 'RNA 可变剪接的调控网络',
    titleJa: 'ＲＮＡ可変スプライシングのための調節ネットワーク',
    titleEs: 'RNA 可变剪接的调控网络（Regulatory network of alternative RNA splicing）：Sharp / Roberts / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Regulatory network of alternative RNA splicing',
    year: 1980,
    proposer: 'Sharp / Roberts / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：RNA 可变剪接的调控网络。',
    summaryJa: '生物学的分野における特定の困難な問題： RNA可変スプライシングの調節ネットワーク。',
    summaryEs: 'RNA 可变剪接的调控网络（Regulatory network of alternative RNA splicing）：Sharp / Roberts / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Regulatory network of alternative RNA splicing.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 RNA 可变剪接的调控网络 的核心问题是：「RNA 可变剪接的调控网络」是 生物 领域的 剪接 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「RNA 可变剪接的调控网络」是 生物 领域的 剪接 方向。',
    formal: 'RNA 可变剪接的调控网络（Regulatory network of alternative RNA splicing）：Sharp / Roberts / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: '代替RNAスプライシングの規制ネットワーク： 1980年にシャープ/ロバーツ/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'RNA 可变剪接的调控网络（Regulatory network of alternative RNA splicing）：Sharp / Roberts / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Regulatory network of alternative RNA splicing: proposed by Sharp / Roberts / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '「RNA 可变剪接的调控网络」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['剪接'],
  },
  {
    id: 'bio-m6a-rna',
    category: 'biology',
    title: 'mRNA m6A 修饰的动态调控',
    titleJa: 'ｍＲＮＡ ｍ ６ Ａ修飾の動的調節',
    titleEs: 'mRNA m6A 修饰的动态调控（Dynamic regulation of mRNA m6A modification）：He / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Dynamic regulation of mRNA m6A modification',
    year: 2012,
    proposer: 'He / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：mRNA m6A 修饰的动态调控。',
    summaryJa: '生物学的分野における特定の難題： ｍＲＮＡ ｍ ６ Ａ修飾の動的調節。',
    summaryEs: 'mRNA m6A 修饰的动态调控（Dynamic regulation of mRNA m6A modification）：He / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Dynamic regulation of mRNA m6A modification.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 mRNA m6A 修饰的动态调控 是这样一个问题：「mRNA m6A 修饰的动态调控」是 生物 领域的 m6A 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「mRNA m6A 修饰的动态调控」是 生物 领域的 m6A 方向。',
    formal: 'mRNA m6A 修饰的动态调控（Dynamic regulation of mRNA m6A modification）：He / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'mRNAのm 6 A修飾の動的調節： 2012年に提案された彼/複数のチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: 'mRNA m6A 修饰的动态调控（Dynamic regulation of mRNA m6A modification）：He / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Dynamic regulation of mRNA m6A modification: proposed by He / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '尽管 He / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['m6A'],
  },
  {
    id: 'bio-ptm-crosstalk',
    category: 'biology',
    title: '翻译后修饰 (PTM) 串扰',
    titleJa: '翻訳後修飾（ PTM ）クロストーク',
    titleEs: '翻译后修饰 (PTM) 串扰（Post-translational modification (PTM) crosstalk）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Post-translational modification (PTM) crosstalk',
    year: 2000,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：翻译后修饰 (PTM) 串扰。',
    summaryJa: '生物学的分野における特定の困難な問題：翻訳後修飾（ ＰＴＭ ）クロストーク。',
    summaryEs: '翻译后修饰 (PTM) 串扰（Post-translational modification (PTM) crosstalk）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Post-translational modification (PTM) crosstalk.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 翻译后修饰 (PTM) 串扰 的核心问题是：「翻译后修饰 (PTM) 串扰」是 生物 领域的 PTM 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「翻译后修饰 (PTM) 串扰」是 生物 领域的 PTM 方向。',
    formal: '翻译后修饰 (PTM) 串扰（Post-translational modification (PTM) crosstalk）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '翻訳後修飾（ PTM ）クロストーク： 2000年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '翻译后修饰 (PTM) 串扰（Post-translational modification (PTM) crosstalk）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Post-translational modification (PTM) crosstalk: proposed by 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '尽管 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['PTM'],
  },
  {
    id: 'bio-amyloid-aggregation',
    category: 'biology',
    title: '淀粉样蛋白 (amyloid) 聚集机制',
    titleJa: 'アミロイド凝集のメカニズム',
    titleEs: '淀粉样蛋白 (amyloid) 聚集机制（Mechanism of amyloid protein aggregation）：Prusiner / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of amyloid protein aggregation',
    year: 1980,
    proposer: 'Prusiner / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：淀粉样蛋白 (amyloid) 聚集机制。',
    summaryJa: '生物学的分野における特定の難題：アミロイド凝集のメカニズム。',
    summaryEs: '淀粉样蛋白 (amyloid) 聚集机制（Mechanism of amyloid protein aggregation）：Prusiner / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of amyloid protein aggregation.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 淀粉样蛋白 (amyloid) 聚集机制。它说的是 「淀粉样蛋白 (amyloid) 聚集机制」是 生物 领域的 淀粉样 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「淀粉样蛋白 (amyloid) 聚集机制」是 生物 领域的 淀粉样 方向。',
    formal: '淀粉样蛋白 (amyloid) 聚集机制（Mechanism of amyloid protein aggregation）：Prusiner / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'アミロイドタンパク質凝集のメカニズム（アミロイドタンパク質凝集のメカニズム） ： 1980年に提案されたPrusiner/multi - teamであり、関連する実験/理論は完全には解決されていない。',
    formalEs: '淀粉样蛋白 (amyloid) 聚集机制（Mechanism of amyloid protein aggregation）：Prusiner / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of amyloid protein aggregation: proposed by Prusiner / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '「淀粉样蛋白 (amyloid) 聚集机制」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['淀粉样'],
  },
  {
    id: 'bio-alzheimers',
    category: 'biology',
    title: '阿尔茨海默病病因 (Aβ vs Tau 假说)',
    titleJa: 'アルツハイマー病の原因（ A β対タウ仮説）',
    titleEs: '阿尔茨海默病病因 (Aβ vs Tau 假说)（Alzheimer\\\'s etiology (Aβ vs Tau hypothesis)）：Goedert / 多团队 在 1991 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Alzheimer\'s etiology (Aβ vs Tau hypothesis)',
    year: 1991,
    proposer: 'Goedert / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：阿尔茨海默病病因 (Aβ vs Tau 假说)。',
    summaryJa: '生物学的分野における特定の難題：アルツハイマー病の病因（ Ａ β対Ｔａｕ仮説）。',
    summaryEs: '阿尔茨海默病病因 (Aβ vs Tau 假说)（Alzheimer\\\'s etiology (Aβ vs Tau hypothesis)）：Goedert / 多团队 在 1991 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Alzheimer\'s etiology (Aβ vs Tau hypothesis).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 阿尔茨海默病病因 (Aβ vs Tau 假说)。它说的是 「阿尔茨海默病病因 (Aβ vs Tau 假说)」是 生物 领域的 AD 方向，涉及 AD, 淀粉样 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「阿尔茨海默病病因 (Aβ vs Tau 假说)」是 生物 领域的 AD 方向，涉及 AD, 淀粉样 等方面。',
    formal: '阿尔茨海默病病因 (Aβ vs Tau 假说)（Alzheimer\'s etiology (Aβ vs Tau hypothesis)）：Goedert / 多团队 在 1991 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'アルツハイマー病の病因（ A β対Tau仮説） ： Goedert/Multiチームは1991年に提案され、関連する実験/理論は完全には解決されていません。',
    formalEn: 'Alzheimer\'s etiology (Aβ vs Tau hypothesis): proposed by Goedert / 多团队 in 1991; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Goedert / 多团队 等人在 1991 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['AD', '淀粉样'],
  },
  {
    id: 'bio-parkinsons',
    category: 'biology',
    title: '帕金森病 α-synuclein 传播机制',
    titleJa: 'パーキンソン病α -シヌクレイン伝達機構',
    titleEs: '帕金森病 α-synuclein 传播机制（α-synuclein propagation in Parkinson\\\'s disease）：Braak / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'α-synuclein propagation in Parkinson\'s disease',
    year: 2003,
    proposer: 'Braak / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：帕金森病 α-synuclein 传播机制。',
    summaryJa: '生物学的分野における特定の困難な問題：パーキンソン病におけるα -シヌクレイン伝達のメカニズム。',
    summaryEs: '帕金森病 α-synuclein 传播机制（α-synuclein propagation in Parkinson\\\'s disease）：Braak / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: α-synuclein propagation in Parkinson\'s disease.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 帕金森病 α-synuclein 传播机制 是这样一个问题：「帕金森病 α-synuclein 传播机制」是 生物 领域的 PD 方向，涉及 PD, 突触核 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「帕金森病 α-synuclein 传播机制」是 生物 领域的 PD 方向，涉及 PD, 突触核 等方面。',
    formal: '帕金森病 α-synuclein 传播机制（α-synuclein propagation in Parkinson\'s disease）：Braak / 多团队 在 2003 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'パーキンソン病におけるα -シヌクレインの増殖： Braak/Multiチームは2003年に提案し、関連する実験/理論は完全には解決されていません。',
    formalEn: 'α-synuclein propagation in Parkinson\'s disease: proposed by Braak / 多团队 in 2003; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['PD', '突触核'],
  },
  {
    id: 'bio-huntingtons',
    category: 'biology',
    title: '亨廷顿病 HTT 蛋白聚集起始',
    titleJa: 'ハンチントン病HTTタンパク質凝集開始',
    titleEs: '亨廷顿病 HTT 蛋白聚集起始（Initiation of HTT protein aggregation in Huntington\\\'s）：MacDonald / 多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Initiation of HTT protein aggregation in Huntington\'s',
    year: 1993,
    proposer: 'MacDonald / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：亨廷顿病 HTT 蛋白聚集起始。',
    summaryJa: '生物学的分野における特定の困難な問題：ハンチントン病におけるHTTタンパク質の凝集の開始。',
    summaryEs: '亨廷顿病 HTT 蛋白聚集起始（Initiation of HTT protein aggregation in Huntington\\\'s）：MacDonald / 多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Initiation of HTT protein aggregation in Huntington\'s.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 亨廷顿病 HTT 蛋白聚集起始 是这样一个问题：「亨廷顿病 HTT 蛋白聚集起始」是 生物 领域的 HD 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「亨廷顿病 HTT 蛋白聚集起始」是 生物 领域的 HD 方向。',
    formal: '亨廷顿病 HTT 蛋白聚集起始（Initiation of HTT protein aggregation in Huntington\'s）：MacDonald / 多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ハンチントン病におけるHTTタンパク質凝集の開始： 1993年にマクドナルド/複数のチームが提案され、関連する実験/理論は完全には解決されていません。',
    formalEn: 'Initiation of HTT protein aggregation in Huntington\'s: proposed by MacDonald / 多团队 in 1993; related experiments/theory remain incomplete.',
    whyHard: '尽管 MacDonald / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['HD'],
  },
  {
    id: 'bio-als-c9orf72',
    category: 'biology',
    title: 'ALS C9orf72 六核苷酸重复的毒性机制',
    titleJa: 'ＡＬＳ Ｃ ９ ｏｒｆ ７ ２ヘキサヌクレオチド反復の毒性機序',
    titleEs: 'ALS C9orf72 六核苷酸重复的毒性机制（Toxicity of C9orf72 hexanucleotide repeats in ALS）：Renton / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Toxicity of C9orf72 hexanucleotide repeats in ALS',
    year: 2011,
    proposer: 'Renton / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：ALS C9orf72 六核苷酸重复的毒性机制。',
    summaryJa: '生物学的分野における特定の難題： ＡＬＳ Ｃ ９ ｏｒｆ ７ ２ヘキサヌクレオチド反復の毒性メカニズム。',
    summaryEs: 'ALS C9orf72 六核苷酸重复的毒性机制（Toxicity of C9orf72 hexanucleotide repeats in ALS）：Renton / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Toxicity of C9orf72 hexanucleotide repeats in ALS.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 ALS C9orf72 六核苷酸重复的毒性机制 的核心问题是：「ALS C9orf72 六核苷酸重复的毒性机制」是 生物 领域的 ALS 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「ALS C9orf72 六核苷酸重复的毒性机制」是 生物 领域的 ALS 方向。',
    formal: 'ALS C9orf72 六核苷酸重复的毒性机制（Toxicity of C9orf72 hexanucleotide repeats in ALS）：Renton / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ＡＬＳにおけるＣ ９ ｏｒｆ ７ ２ヘキサヌクレオチド反復の毒性： Ｒｅｎｔｏｎ ／ Ｍｕｌｔｉチームは、関連する実験／理論が完全に解決されていないことを２ ０ １ １年に提案した。',
    formalEs: 'ALS C9orf72 六核苷酸重复的毒性机制（Toxicity of C9orf72 hexanucleotide repeats in ALS）：Renton / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Toxicity of C9orf72 hexanucleotide repeats in ALS: proposed by Renton / 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '尽管 Renton / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['ALS'],
  },
  {
    id: 'bio-prion-spread',
    category: 'biology',
    title: '朊病毒跨神经传播机制',
    titleJa: 'プリオン経神経伝達機構',
    titleEs: '朊病毒跨神经传播机制（Mechanism of prion trans-neuronal spread）：Prusiner 在 1982 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of prion trans-neuronal spread',
    year: 1982,
    proposer: 'Prusiner',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：朊病毒跨神经传播机制。',
    summaryJa: '生物学的分野における特定の困難な問題：ニューロン間のプリオン伝達のメカニズム。',
    summaryEs: '朊病毒跨神经传播机制（Mechanism of prion trans-neuronal spread）：Prusiner 在 1982 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of prion trans-neuronal spread.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 朊病毒跨神经传播机制 的问题。它可以简单描述为 「朊病毒跨神经传播机制」是 生物 领域的 朊病毒 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「朊病毒跨神经传播机制」是 生物 领域的 朊病毒 方向。',
    formal: '朊病毒跨神经传播机制（Mechanism of prion trans-neuronal spread）：Prusiner 在 1982 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'プリオン経ニューロン拡散のメカニズム： 1982年にPrusinerが提唱したが、関連する実験・理論は完全には解明されていない。',
    formalEs: '朊病毒跨神经传播机制（Mechanism of prion trans-neuronal spread）：Prusiner 在 1982 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of prion trans-neuronal spread: proposed by Prusiner in 1982; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['朊病毒'],
  },
  {
    id: 'bio-car-t-solid',
    category: 'biology',
    title: 'CAR-T 治疗实体瘤的瓶颈',
    titleJa: '固形腫瘍のCAR - T治療におけるボトルネック',
    titleEs: 'CAR-T 治疗实体瘤的瓶颈（Bottleneck of CAR-T therapy for solid tumors）：June / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Bottleneck of CAR-T therapy for solid tumors',
    year: 2010,
    proposer: 'June / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：CAR-T 治疗实体瘤的瓶颈。',
    summaryJa: '生物学的分野における特定の困難な問題：固形腫瘍のCAR - T治療のボトルネック。',
    summaryEs: 'CAR-T 治疗实体瘤的瓶颈（Bottleneck of CAR-T therapy for solid tumors）：June / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Bottleneck of CAR-T therapy for solid tumors.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 CAR-T 治疗实体瘤的瓶颈 的核心问题是：「CAR-T 治疗实体瘤的瓶颈」是 生物 领域的 CAR-T 方向，涉及 CAR-T, 肿瘤 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「CAR-T 治疗实体瘤的瓶颈」是 生物 领域的 CAR-T 方向，涉及 CAR-T, 肿瘤 等方面。',
    formal: 'CAR-T 治疗实体瘤的瓶颈（Bottleneck of CAR-T therapy for solid tumors）：June / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '固形腫瘍に対するCAR - T療法のボトルネック： 6月/2010年に複数のチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'CAR-T 治疗实体瘤的瓶颈（Bottleneck of CAR-T therapy for solid tumors）：June / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Bottleneck of CAR-T therapy for solid tumors: proposed by June / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '尽管 June / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CAR-T', '肿瘤'],
  },
  {
    id: 'bio-tme',
    category: 'biology',
    title: '肿瘤微环境 (TME) 的免疫抑制机制',
    titleJa: '腫瘍微小環境（ ＴＭＥ ）の免疫抑制機構',
    titleEs: '肿瘤微环境 (TME) 的免疫抑制机制（Immunosuppressive mechanism of tumor microenvironment (TME)）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Immunosuppressive mechanism of tumor microenvironment (TME)',
    year: 2000,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：肿瘤微环境 (TME) 的免疫抑制机制。',
    summaryJa: '生物学的分野における特定の困難な問題：腫瘍微小環境（ ＴＭＥ ）の免疫抑制メカニズム。',
    summaryEs: '肿瘤微环境 (TME) 的免疫抑制机制（Immunosuppressive mechanism of tumor microenvironment (TME)）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Immunosuppressive mechanism of tumor microenvironment (TME).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 肿瘤微环境 (TME) 的免疫抑制机制 是这样一个问题：「肿瘤微环境 (TME) 的免疫抑制机制」是 生物 领域的 TME 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「肿瘤微环境 (TME) 的免疫抑制机制」是 生物 领域的 TME 方向。',
    formal: '肿瘤微环境 (TME) 的免疫抑制机制（Immunosuppressive mechanism of tumor microenvironment (TME)）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '腫瘍微小環境（ TME ）の免疫抑制メカニズム： 2000年に複数のチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: '肿瘤微环境 (TME) 的免疫抑制机制（Immunosuppressive mechanism of tumor microenvironment (TME)）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Immunosuppressive mechanism of tumor microenvironment (TME): proposed by 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 2000 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['TME'],
  },
  {
    id: 'bio-tumor-heterogeneity',
    category: 'biology',
    title: '肿瘤异质性的演化机制',
    titleJa: '腫瘍の不均一性の進化メカニズム',
    titleEs: '肿瘤异质性的演化机制（Evolutionary mechanism of tumor heterogeneity）：Greaves / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Evolutionary mechanism of tumor heterogeneity',
    year: 2010,
    proposer: 'Greaves / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：肿瘤异质性的演化机制。',
    summaryJa: '生物学分野における特定の難題：腫瘍の不均一性の進化メカニズム。',
    summaryEs: '肿瘤异质性的演化机制（Evolutionary mechanism of tumor heterogeneity）：Greaves / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Evolutionary mechanism of tumor heterogeneity.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 肿瘤异质性的演化机制 的问题。它可以简单描述为 「肿瘤异质性的演化机制」是 生物 领域的 肿瘤 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「肿瘤异质性的演化机制」是 生物 领域的 肿瘤 方向。',
    formal: '肿瘤异质性的演化机制（Evolutionary mechanism of tumor heterogeneity）：Greaves / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '腫瘍の不均一性の進化メカニズム： Greaves/multi - teamは2010年に提案され、関連する実験/理論は完全には解決されていない。',
    formalEs: '肿瘤异质性的演化机制（Evolutionary mechanism of tumor heterogeneity）：Greaves / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Evolutionary mechanism of tumor heterogeneity: proposed by Greaves / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['肿瘤'],
  },
  {
    id: 'bio-warburg',
    category: 'biology',
    title: 'Warburg 效应 (肿瘤有氧糖酵解)',
    titleJa: 'ワーバーグ効果（腫瘍好気性解糖）',
    titleEs: 'Warburg 效应 (肿瘤有氧糖酵解)（Warburg effect (aerobic glycolysis in tumors)）：Warburg / 多团队 在 1924 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Warburg effect (aerobic glycolysis in tumors)',
    year: 1924,
    proposer: 'Warburg / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Warburg 效应 (肿瘤有氧糖酵解)。',
    summaryJa: '生物学的分野における特定の困難な問題：ウォーバーグ効果（腫瘍の好気性解糖）。',
    summaryEs: 'Warburg 效应 (肿瘤有氧糖酵解)（Warburg effect (aerobic glycolysis in tumors)）：Warburg / 多团队 在 1924 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Warburg effect (aerobic glycolysis in tumors).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 Warburg 效应 (肿瘤有氧糖酵解) 的核心问题是：「Warburg 效应 (肿瘤有氧糖酵解)」是 生物 领域的 代谢 方向，涉及 代谢, 肿瘤 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Warburg 效应 (肿瘤有氧糖酵解)」是 生物 领域的 代谢 方向，涉及 代谢, 肿瘤 等方面。',
    formal: 'Warburg 效应 (肿瘤有氧糖酵解)（Warburg effect (aerobic glycolysis in tumors)）：Warburg / 多团队 在 1924 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ウォーバーグ効果（腫瘍における好気性解糖） ： 1924年にウォーバーグ/複数のチームが提案され、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Warburg 效应 (肿瘤有氧糖酵解)（Warburg effect (aerobic glycolysis in tumors)）：Warburg / 多团队 在 1924 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Warburg effect (aerobic glycolysis in tumors): proposed by Warburg / 多团队 in 1924; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['代谢', '肿瘤'],
  },
  {
    id: 'bio-metastasis',
    category: 'biology',
    title: '肿瘤转移 (metastasis) 的分子机制',
    titleJa: '転移の分子機序',
    titleEs: '肿瘤转移 (metastasis) 的分子机制（Molecular mechanism of tumor metastasis）：Fidler / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Molecular mechanism of tumor metastasis',
    year: 1980,
    proposer: 'Fidler / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：肿瘤转移 (metastasis) 的分子机制。',
    summaryJa: '生物学的分野における特定の困難な問題：転移の分子メカニズム。',
    summaryEs: '肿瘤转移 (metastasis) 的分子机制（Molecular mechanism of tumor metastasis）：Fidler / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Molecular mechanism of tumor metastasis.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 肿瘤转移 (metastasis) 的分子机制 是这样一个问题：「肿瘤转移 (metastasis) 的分子机制」是 生物 领域的 转移 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「肿瘤转移 (metastasis) 的分子机制」是 生物 领域的 转移 方向。',
    formal: '肿瘤转移 (metastasis) 的分子机制（Molecular mechanism of tumor metastasis）：Fidler / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: '腫瘍転移の分子機序（ Molecular mechanism of tumor metastasis ） ： 1980年にFidler/multi - teamが提唱され、関連する実験・理論が完全に解明されていない。',
    formalEs: '肿瘤转移 (metastasis) 的分子机制（Molecular mechanism of tumor metastasis）：Fidler / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Molecular mechanism of tumor metastasis: proposed by Fidler / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['转移'],
  },
  {
    id: 'bio-angiogenesis',
    category: 'biology',
    title: '肿瘤血管生成的机制',
    titleJa: '腫瘍血管新生のメカニズム',
    titleEs: '肿瘤血管生成的机制（Mechanism of tumor angiogenesis）：Folkman / 多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of tumor angiogenesis',
    year: 1971,
    proposer: 'Folkman / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：肿瘤血管生成的机制。',
    summaryJa: '生物学的分野における特定の難題：腫瘍血管新生のメカニズム。',
    summaryEs: '肿瘤血管生成的机制（Mechanism of tumor angiogenesis）：Folkman / 多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of tumor angiogenesis.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 肿瘤血管生成的机制 的问题。它可以简单描述为 「肿瘤血管生成的机制」是 生物 领域的 血管生成 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「肿瘤血管生成的机制」是 生物 领域的 血管生成 方向。',
    formal: '肿瘤血管生成的机制（Mechanism of tumor angiogenesis）：Folkman / 多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    formalJa: '腫瘍血管新生のメカニズム： 1971年にFolkman/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '肿瘤血管生成的机制（Mechanism of tumor angiogenesis）：Folkman / 多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of tumor angiogenesis: proposed by Folkman / 多团队 in 1971; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['血管生成'],
  },
  {
    id: 'bio-immune-checkpoint',
    category: 'biology',
    title: '免疫检查点 (PD-1/PD-L1) 耐药机制',
    titleJa: '免疫チェックポイント（ PD -1/PD - L 1 ）耐性メカニズム',
    titleEs: '免疫检查点 (PD-1/PD-L1) 耐药机制（Resistance mechanism to PD-1/PD-L1 immune checkpoint）：Honjo / Allison / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Resistance mechanism to PD-1/PD-L1 immune checkpoint',
    year: 2006,
    proposer: 'Honjo / Allison / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：免疫检查点 (PD-1/PD-L1) 耐药机制。',
    summaryJa: '生物学的分野における特定の難題：免疫チェックポイントにおける抵抗性のメカニズム（ PD -1/PD - L 1 ）。',
    summaryEs: '免疫检查点 (PD-1/PD-L1) 耐药机制（Resistance mechanism to PD-1/PD-L1 immune checkpoint）：Honjo / Allison / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Resistance mechanism to PD-1/PD-L1 immune checkpoint.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 免疫检查点 (PD-1/PD-L1) 耐药机制 是这样一个问题：「免疫检查点 (PD-1/PD-L1) 耐药机制」是 生物 领域的 免疫检查点 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「免疫检查点 (PD-1/PD-L1) 耐药机制」是 生物 领域的 免疫检查点 方向。',
    formal: '免疫检查点 (PD-1/PD-L1) 耐药机制（Resistance mechanism to PD-1/PD-L1 immune checkpoint）：Honjo / Allison / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'PD -1/PD - L 1免疫チェックポイントに対する耐性メカニズム： 2006年にHonjo/Allison/複数のチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: '免疫检查点 (PD-1/PD-L1) 耐药机制（Resistance mechanism to PD-1/PD-L1 immune checkpoint）：Honjo / Allison / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Resistance mechanism to PD-1/PD-L1 immune checkpoint: proposed by Honjo / Allison / 多团队 in 2006; related experiments/theory remain incomplete.',
    whyHard: '尽管 Honjo / Allison / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['免疫检查点'],
  },
  {
    id: 'bio-sle-trigger',
    category: 'biology',
    title: '系统性红斑狼疮 (SLE) 触发因素',
    titleJa: '全身性エリテマトーデス（ SLE ）トリガー',
    titleEs: '系统性红斑狼疮 (SLE) 触发因素（Triggers of systemic lupus erythematosus (SLE)）：多团队 在 1948 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Triggers of systemic lupus erythematosus (SLE)',
    year: 1948,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：系统性红斑狼疮 (SLE) 触发因素。',
    summaryJa: '生物学的分野における特定の困難な問題：全身性エリテマトーデス（ SLE ）トリガー。',
    summaryEs: '系统性红斑狼疮 (SLE) 触发因素（Triggers of systemic lupus erythematosus (SLE)）：多团队 在 1948 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Triggers of systemic lupus erythematosus (SLE).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 系统性红斑狼疮 (SLE) 触发因素 的问题。它可以简单描述为 「系统性红斑狼疮 (SLE) 触发因素」是 生物 领域的 SLE 方向，涉及 SLE, 自身免疫 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「系统性红斑狼疮 (SLE) 触发因素」是 生物 领域的 SLE 方向，涉及 SLE, 自身免疫 等方面。',
    formal: '系统性红斑狼疮 (SLE) 触发因素（Triggers of systemic lupus erythematosus (SLE)）：多团队 在 1948 年提出，相关实验/理论至今未完全解决。',
    formalJa: '全身性エリテマトーデス（ SLE ）の引き金： 1948年に複数のチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: '系统性红斑狼疮 (SLE) 触发因素（Triggers of systemic lupus erythematosus (SLE)）：多团队 在 1948 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Triggers of systemic lupus erythematosus (SLE): proposed by 多团队 in 1948; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 1948 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SLE', '自身免疫'],
  },
  {
    id: 'bio-cytokine-storm',
    category: 'biology',
    title: '细胞因子风暴 (cytokine storm) 启动机制',
    titleJa: 'サイトカインストーム開始メカニズム',
    titleEs: '细胞因子风暴 (cytokine storm) 启动机制（Initiation of cytokine storm）：多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Initiation of cytokine storm',
    year: 1993,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：细胞因子风暴 (cytokine storm) 启动机制。',
    summaryJa: '生物学的分野における特定の困難な問題：サイトカインストームの開始メカニズム。',
    summaryEs: '细胞因子风暴 (cytokine storm) 启动机制（Initiation of cytokine storm）：多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Initiation of cytokine storm.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 细胞因子风暴 (cytokine storm) 启动机制 的问题。它可以简单描述为 「细胞因子风暴 (cytokine storm) 启动机制」是 生物 领域的 细胞因子 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「细胞因子风暴 (cytokine storm) 启动机制」是 生物 领域的 细胞因子 方向。',
    formal: '细胞因子风暴 (cytokine storm) 启动机制（Initiation of cytokine storm）：多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'サイトカインストームの開始：関連する実験/理論は、1993年に複数のチームによって提案され、完全に解決されていません。',
    formalEs: '细胞因子风暴 (cytokine storm) 启动机制（Initiation of cytokine storm）：多团队 在 1993 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Initiation of cytokine storm: proposed by 多团队 in 1993; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['细胞因子'],
  },
  {
    id: 'bio-il6-signal',
    category: 'biology',
    title: 'IL-6 反式信号通路在炎症中的作用',
    titleJa: '炎症におけるIL -6トランスシグナル伝達経路の役割',
    titleEs: 'IL-6 反式信号通路在炎症中的作用（Role of IL-6 trans-signaling in inflammation）：Rose-John / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Role of IL-6 trans-signaling in inflammation',
    year: 1990,
    proposer: 'Rose-John / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：IL-6 反式信号通路在炎症中的作用。',
    summaryJa: '生物学的分野における特定の困難な問題：炎症におけるIL -6トランスシグナル伝達経路の役割。',
    summaryEs: 'IL-6 反式信号通路在炎症中的作用（Role of IL-6 trans-signaling in inflammation）：Rose-John / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Role of IL-6 trans-signaling in inflammation.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 IL-6 反式信号通路在炎症中的作用 的问题。它可以简单描述为 「IL-6 反式信号通路在炎症中的作用」是 生物 领域的 IL-6 方向，涉及 IL-6, 炎症 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「IL-6 反式信号通路在炎症中的作用」是 生物 领域的 IL-6 方向，涉及 IL-6, 炎症 等方面。',
    formal: 'IL-6 反式信号通路在炎症中的作用（Role of IL-6 trans-signaling in inflammation）：Rose-John / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '炎症におけるIL -6トランスシグナル伝達の役割： Rose - John/Multiple teamsは1990年に提案され、関連する実験/理論は完全に解決されていません。',
    formalEs: 'IL-6 反式信号通路在炎症中的作用（Role of IL-6 trans-signaling in inflammation）：Rose-John / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Role of IL-6 trans-signaling in inflammation: proposed by Rose-John / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['IL-6', '炎症'],
  },
  {
    id: 'bio-ifn-pathway',
    category: 'biology',
    title: '干扰素信号通路的失调',
    titleJa: 'インターフェロンシグナル伝達経路の調節不全',
    titleEs: '干扰素信号通路的失调（Dysregulation of interferon signaling pathway）：Isaacs / Lindenmann / 多团队 在 1957 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Dysregulation of interferon signaling pathway',
    year: 1957,
    proposer: 'Isaacs / Lindenmann / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：干扰素信号通路的失调。',
    summaryJa: '生物学的分野における特定の困難な問題：インターフェロンシグナル伝達経路の調節不全。',
    summaryEs: '干扰素信号通路的失调（Dysregulation of interferon signaling pathway）：Isaacs / Lindenmann / 多团队 在 1957 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Dysregulation of interferon signaling pathway.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 干扰素信号通路的失调。它说的是 「干扰素信号通路的失调」是 生物 领域的 干扰素 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「干扰素信号通路的失调」是 生物 领域的 干扰素 方向。',
    formal: '干扰素信号通路的失调（Dysregulation of interferon signaling pathway）：Isaacs / Lindenmann / 多团队 在 1957 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'インターフェロンシグナル伝達経路の調節障害： 1957年にIsaacs/Lindenmann/複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '干扰素信号通路的失调（Dysregulation of interferon signaling pathway）：Isaacs / Lindenmann / 多团队 在 1957 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Dysregulation of interferon signaling pathway: proposed by Isaacs / Lindenmann / 多团队 in 1957; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Isaacs / Lindenmann / 多团队 等人在 1957 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['干扰素'],
  },
  {
    id: 'bio-tlr-ligands',
    category: 'biology',
    title: 'Toll 样受体 (TLR) 配体识别机制',
    titleJa: 'Toll様受容体（ TLR ）リガンド認識機構',
    titleEs: 'Toll 样受体 (TLR) 配体识别机制（Ligand recognition mechanism of Toll-like receptors (TLR)）：Beutler / 多团队 在 1997 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Ligand recognition mechanism of Toll-like receptors (TLR)',
    year: 1997,
    proposer: 'Beutler / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Toll 样受体 (TLR) 配体识别机制。',
    summaryJa: '生物学的分野における特定の困難な問題： Toll様受容体（ TLR ）リガンド認識機構。',
    summaryEs: 'Toll 样受体 (TLR) 配体识别机制（Ligand recognition mechanism of Toll-like receptors (TLR)）：Beutler / 多团队 在 1997 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Ligand recognition mechanism of Toll-like receptors (TLR).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 Toll 样受体 (TLR) 配体识别机制。它说的是 「Toll 样受体 (TLR) 配体识别机制」是 生物 领域的 TLR 方向，涉及 TLR, 免疫 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Toll 样受体 (TLR) 配体识别机制」是 生物 领域的 TLR 方向，涉及 TLR, 免疫 等方面。',
    formal: 'Toll 样受体 (TLR) 配体识别机制（Ligand recognition mechanism of Toll-like receptors (TLR)）：Beutler / 多团队 在 1997 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Toll - like receptor (TLR)のToll - like receptor (TLR)リガンド認識メカニズム： 1997年にBeutler/multi - teamによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Toll 样受体 (TLR) 配体识别机制（Ligand recognition mechanism of Toll-like receptors (TLR)）：Beutler / 多团队 在 1997 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Ligand recognition mechanism of Toll-like receptors (TLR): proposed by Beutler / 多团队 in 1997; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Beutler / 多团队 等人在 1997 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['TLR', '免疫'],
  },
  {
    id: 'bio-gut-brain',
    category: 'biology',
    title: '肠脑轴 (gut-brain axis) 机制',
    titleJa: '腸脳軸メカニズム',
    titleEs: '肠脑轴 (gut-brain axis) 机制（Mechanism of gut-brain axis）：Cryan / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of gut-brain axis',
    year: 2004,
    proposer: 'Cryan / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：肠脑轴 (gut-brain axis) 机制。',
    summaryJa: '生物学的分野における特定の困難な問題：腸脳軸のメカニズム。',
    summaryEs: '肠脑轴 (gut-brain axis) 机制（Mechanism of gut-brain axis）：Cryan / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of gut-brain axis.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 肠脑轴 (gut-brain axis) 机制 是这样一个问题：「肠脑轴 (gut-brain axis) 机制」是 生物 领域的 肠 方向，涉及 肠, 脑 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「肠脑轴 (gut-brain axis) 机制」是 生物 领域的 肠 方向，涉及 肠, 脑 等方面。',
    formal: '肠脑轴 (gut-brain axis) 机制（Mechanism of gut-brain axis）：Cryan / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalJa: '腸脳軸のメカニズム： 2004年に提唱されたCRYAN/MULTI TEAMでは、関連する実験/理論が完全に解決されていない。',
    formalEs: '肠脑轴 (gut-brain axis) 机制（Mechanism of gut-brain axis）：Cryan / 多团队 在 2004 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of gut-brain axis: proposed by Cryan / 多团队 in 2004; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['肠', '脑'],
  },
  {
    id: 'bio-microbiome-dynamic',
    category: 'biology',
    title: '人体微生物组的动态平衡',
    titleJa: 'ヒトマイクロバイオームの動的バランス',
    titleEs: '人体微生物组的动态平衡（Dynamic homeostasis of human microbiome）：MetaHIT / HMP / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Dynamic homeostasis of human microbiome',
    year: 2010,
    proposer: 'MetaHIT / HMP / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：人体微生物组的动态平衡。',
    summaryJa: '生物学分野における特定の困難な問題：ヒトマイクロバイオームの動的バランス。',
    summaryEs: '人体微生物组的动态平衡（Dynamic homeostasis of human microbiome）：MetaHIT / HMP / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Dynamic homeostasis of human microbiome.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 人体微生物组的动态平衡 的核心问题是：「人体微生物组的动态平衡」是 生物 领域的 微生物组 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「人体微生物组的动态平衡」是 生物 领域的 微生物组 方向。',
    formal: '人体微生物组的动态平衡（Dynamic homeostasis of human microbiome）：MetaHIT / HMP / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ヒトマイクロバイオームのダイナミックホメオスタシス： 2010年に提案されたMetaHIT/HMP/マルチチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: '人体微生物组的动态平衡（Dynamic homeostasis of human microbiome）：MetaHIT / HMP / 多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Dynamic homeostasis of human microbiome: proposed by MetaHIT / HMP / 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['微生物组'],
  },
  {
    id: 'bio-arg-spread',
    category: 'biology',
    title: '抗生素耐药基因 (ARG) 跨物种传播',
    titleJa: '種間の抗生物質耐性遺伝子（ ARG ）伝達',
    titleEs: '抗生素耐药基因 (ARG) 跨物种传播（Cross-species spread of antibiotic resistance genes (ARG)）：Watanabe / 多团队 在 1960 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Cross-species spread of antibiotic resistance genes (ARG)',
    year: 1960,
    proposer: 'Watanabe / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：抗生素耐药基因 (ARG) 跨物种传播。',
    summaryJa: '生物学的分野における特定の困難な問題：種にわたる抗生物質耐性遺伝子（ ARG ）の拡散。',
    summaryEs: '抗生素耐药基因 (ARG) 跨物种传播（Cross-species spread of antibiotic resistance genes (ARG)）：Watanabe / 多团队 在 1960 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Cross-species spread of antibiotic resistance genes (ARG).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 抗生素耐药基因 (ARG) 跨物种传播 是这样一个问题：「抗生素耐药基因 (ARG) 跨物种传播」是 生物 领域的 耐药 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「抗生素耐药基因 (ARG) 跨物种传播」是 生物 领域的 耐药 方向。',
    formal: '抗生素耐药基因 (ARG) 跨物种传播（Cross-species spread of antibiotic resistance genes (ARG)）：Watanabe / 多团队 在 1960 年提出，相关实验/理论至今未完全解决。',
    formalJa: '抗生物質耐性遺伝子（ ARG ）の異種拡散：渡辺/複数のチームが1960年に提案し、関連する実験/理論が完全に解決されていない。',
    formalEs: '抗生素耐药基因 (ARG) 跨物种传播（Cross-species spread of antibiotic resistance genes (ARG)）：Watanabe / 多团队 在 1960 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Cross-species spread of antibiotic resistance genes (ARG): proposed by Watanabe / 多团队 in 1960; related experiments/theory remain incomplete.',
    whyHard: '尽管 Watanabe / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['耐药'],
  },
  {
    id: 'bio-phage-therapy',
    category: 'biology',
    title: '噬菌体疗法在临床的通用性',
    titleJa: 'ファージ療法の臨床的多様性',
    titleEs: '噬菌体疗法在临床的通用性（Generalizability of phage therapy in clinic）：Schooley / Strathdee / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Generalizability of phage therapy in clinic',
    year: 2016,
    proposer: 'Schooley / Strathdee / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：噬菌体疗法在临床的通用性。',
    summaryJa: '生物学的分野における特定の困難な問題：ファージ療法の臨床的多様性。',
    summaryEs: '噬菌体疗法在临床的通用性（Generalizability of phage therapy in clinic）：Schooley / Strathdee / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Generalizability of phage therapy in clinic.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 噬菌体疗法在临床的通用性 是这样一个问题：「噬菌体疗法在临床的通用性」是 生物 领域的 噬菌体 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「噬菌体疗法在临床的通用性」是 生物 领域的 噬菌体 方向。',
    formal: '噬菌体疗法在临床的通用性（Generalizability of phage therapy in clinic）：Schooley / Strathdee / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    formalJa: '臨床におけるファージ療法の一般化可能性： 2016年にSchooley/Strathdee/multi - teamが提案され、関連する実験/理論は完全には解決されていない。',
    formalEs: '噬菌体疗法在临床的通用性（Generalizability of phage therapy in clinic）：Schooley / Strathdee / 多团队 在 2016 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Generalizability of phage therapy in clinic: proposed by Schooley / Strathdee / 多团队 in 2016; related experiments/theory remain incomplete.',
    whyHard: '尽管 Schooley / Strathdee / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['噬菌体'],
  },
  {
    id: 'bio-amp-design',
    category: 'biology',
    title: '抗菌肽 (AMPs) 的理性设计',
    titleJa: '抗菌ペプチド（ AMP ）の合理的な設計',
    titleEs: '抗菌肽 (AMPs) 的理性设计（Rational design of antimicrobial peptides (AMPs)）：Hancock / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Rational design of antimicrobial peptides (AMPs)',
    year: 1980,
    proposer: 'Hancock / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：抗菌肽 (AMPs) 的理性设计。',
    summaryJa: '生物学的分野における特定の難題：抗菌ペプチド（ AMP ）の合理的な設計。',
    summaryEs: '抗菌肽 (AMPs) 的理性设计（Rational design of antimicrobial peptides (AMPs)）：Hancock / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Rational design of antimicrobial peptides (AMPs).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 抗菌肽 (AMPs) 的理性设计 的问题。它可以简单描述为 「抗菌肽 (AMPs) 的理性设计」是 生物 领域的 AMPs 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「抗菌肽 (AMPs) 的理性设计」是 生物 领域的 AMPs 方向。',
    formal: '抗菌肽 (AMPs) 的理性设计（Rational design of antimicrobial peptides (AMPs)）：Hancock / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: '抗菌ペプチド（ AMP ）の合理的な設計： Hancock/Multiチームは1980年に提案し、関連する実験/理論は完全には解決されていません。',
    formalEs: '抗菌肽 (AMPs) 的理性设计（Rational design of antimicrobial peptides (AMPs)）：Hancock / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Rational design of antimicrobial peptides (AMPs): proposed by Hancock / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['AMPs'],
  },
  {
    id: 'bio-leca',
    category: 'biology',
    title: '真核生物共同祖先 (LECA) 的起源',
    titleJa: '真核生物共通祖先（ LECA ）の起源',
    titleEs: '真核生物共同祖先 (LECA) 的起源（Origin of Last Eukaryotic Common Ancestor (LECA)）：多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Origin of Last Eukaryotic Common Ancestor (LECA)',
    year: 1990,
    proposer: '多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：真核生物共同祖先 (LECA) 的起源。',
    summaryJa: '生物学的分野における特定の難題：真核生物共通祖先（ LECA ）の起源。',
    summaryEs: '真核生物共同祖先 (LECA) 的起源（Origin of Last Eukaryotic Common Ancestor (LECA)）：多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Origin of Last Eukaryotic Common Ancestor (LECA).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 真核生物共同祖先 (LECA) 的起源 的核心问题是：「真核生物共同祖先 (LECA) 的起源」是 生物 领域的 进化 方向，涉及 进化, 真核 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「真核生物共同祖先 (LECA) 的起源」是 生物 领域的 进化 方向，涉及 进化, 真核 等方面。',
    formal: '真核生物共同祖先 (LECA) 的起源（Origin of Last Eukaryotic Common Ancestor (LECA)）：多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '最後の真核生物共通祖先（ LECA ）の起源： 1990年に複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '真核生物共同祖先 (LECA) 的起源（Origin of Last Eukaryotic Common Ancestor (LECA)）：多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Origin of Last Eukaryotic Common Ancestor (LECA): proposed by 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['进化', '真核'],
  },
  {
    id: 'bio-endocytosis-origin',
    category: 'biology',
    title: '真核细胞内吞作用的进化起源',
    titleJa: '真核細胞におけるエンドサイトーシスの進化的起源',
    titleEs: '真核细胞内吞作用的进化起源（Evolutionary origin of eukaryotic endocytosis）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Evolutionary origin of eukaryotic endocytosis',
    year: 2000,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：真核细胞内吞作用的进化起源。',
    summaryJa: '生物学的分野における特定の困難な問題：真核細胞におけるエンドサイトーシスの進化的起源。',
    summaryEs: '真核细胞内吞作用的进化起源（Evolutionary origin of eukaryotic endocytosis）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Evolutionary origin of eukaryotic endocytosis.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 真核细胞内吞作用的进化起源 的问题。它可以简单描述为 「真核细胞内吞作用的进化起源」是 生物 领域的 进化 方向，涉及 进化, 内吞 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「真核细胞内吞作用的进化起源」是 生物 领域的 进化 方向，涉及 进化, 内吞 等方面。',
    formal: '真核细胞内吞作用的进化起源（Evolutionary origin of eukaryotic endocytosis）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '真核エンドサイトーシスの進化起源： 2000年に複数のチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: '真核细胞内吞作用的进化起源（Evolutionary origin of eukaryotic endocytosis）：多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Evolutionary origin of eukaryotic endocytosis: proposed by 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '「真核细胞内吞作用的进化起源」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['进化', '内吞'],
  },
  {
    id: 'bio-mito-origin',
    category: 'biology',
    title: '线粒体内共生起源的精确机制',
    titleJa: 'ミトコンドリアにおける共生の起源の正確なメカニズム',
    titleEs: '线粒体内共生起源的精确机制（Precise mechanism of mitochondrial endosymbiosis）：Margulis / 多团队 在 1967 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise mechanism of mitochondrial endosymbiosis',
    year: 1967,
    proposer: 'Margulis / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：线粒体内共生起源的精确机制。',
    summaryJa: '生物学分野における特定の難題：ミトコンドリア内の共生起源の正確なメカニズム。',
    summaryEs: '线粒体内共生起源的精确机制（Precise mechanism of mitochondrial endosymbiosis）：Margulis / 多团队 在 1967 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Precise mechanism of mitochondrial endosymbiosis.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 线粒体内共生起源的精确机制。它说的是 「线粒体内共生起源的精确机制」是 生物 领域的 线粒体 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「线粒体内共生起源的精确机制」是 生物 领域的 线粒体 方向。',
    formal: '线粒体内共生起源的精确机制（Precise mechanism of mitochondrial endosymbiosis）：Margulis / 多团队 在 1967 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ミトコンドリアエンドシンビオシスの正確なメカニズム： 1967年にMargulis/Multiチームが提案し、関連する実験/理論は完全には解決されていません。',
    formalEs: '线粒体内共生起源的精确机制（Precise mechanism of mitochondrial endosymbiosis）：Margulis / 多团队 在 1967 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise mechanism of mitochondrial endosymbiosis: proposed by Margulis / 多团队 in 1967; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['线粒体'],
  },
  {
    id: 'bio-multicellular',
    category: 'biology',
    title: '多细胞生物的起源机制',
    titleJa: '多細胞生物の起源のメカニズム',
    titleEs: '多细胞生物的起源机制（Origin mechanism of multicellularity）：Bonner / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Origin mechanism of multicellularity',
    year: 1990,
    proposer: 'Bonner / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：多细胞生物的起源机制。',
    summaryJa: '生物学分野における特定の困難な問題：多細胞生物の起源のメカニズム。',
    summaryEs: '多细胞生物的起源机制（Origin mechanism of multicellularity）：Bonner / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Origin mechanism of multicellularity.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 多细胞生物的起源机制 的问题。它可以简单描述为 「多细胞生物的起源机制」是 生物 领域的 多细胞 方向，涉及 多细胞, 进化 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「多细胞生物的起源机制」是 生物 领域的 多细胞 方向，涉及 多细胞, 进化 等方面。',
    formal: '多细胞生物的起源机制（Origin mechanism of multicellularity）：Bonner / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '多細胞性の起源メカニズム： Bonner/Multiチームは1990年に、関連する実験/理論はまだ完全に解決されていないと提案した。',
    formalEs: '多细胞生物的起源机制（Origin mechanism of multicellularity）：Bonner / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Origin mechanism of multicellularity: proposed by Bonner / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Bonner / 多团队 等人在 1990 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['多细胞', '进化'],
  },
  {
    id: 'bio-cambrian',
    category: 'biology',
    title: '寒武纪大爆发的驱动因素',
    titleJa: 'カンブリア大流行の推進要因',
    titleEs: '寒武纪大爆发的驱动因素（Drivers of the Cambrian explosion）：Darwin / 多团队 在 1840 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Drivers of the Cambrian explosion',
    year: 1840,
    proposer: 'Darwin / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：寒武纪大爆发的驱动因素。',
    summaryJa: '生物学分野における特定の困難な問題：カンブリア爆発の原動力。',
    summaryEs: '寒武纪大爆发的驱动因素（Drivers of the Cambrian explosion）：Darwin / 多团队 在 1840 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Drivers of the Cambrian explosion.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 寒武纪大爆发的驱动因素 的核心问题是：「寒武纪大爆发的驱动因素」是 生物 领域的 进化 方向，涉及 进化, 寒武纪 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「寒武纪大爆发的驱动因素」是 生物 领域的 进化 方向，涉及 进化, 寒武纪 等方面。',
    formal: '寒武纪大爆发的驱动因素（Drivers of the Cambrian explosion）：Darwin / 多团队 在 1840 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'カンブリア爆発の原因： 1840年にダーウィン/複数のチームが提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: '寒武纪大爆发的驱动因素（Drivers of the Cambrian explosion）：Darwin / 多团队 在 1840 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Drivers of the Cambrian explosion: proposed by Darwin / 多团队 in 1840; related experiments/theory remain incomplete.',
    whyHard: '尽管 Darwin / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['进化', '寒武纪'],
  },
  {
    id: 'bio-cochlear-amp',
    category: 'biology',
    title: '哺乳动物耳蜗放大机制',
    titleJa: '哺乳類における蝸牛の増大機構',
    titleEs: '哺乳动物耳蜗放大机制（Mechanism of mammalian cochlear amplification）：Davis / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of mammalian cochlear amplification',
    year: 1980,
    proposer: 'Davis / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：哺乳动物耳蜗放大机制。',
    summaryJa: '生物学的分野における特定の困難な問題：哺乳類の蝸牛の拡大機構。',
    summaryEs: '哺乳动物耳蜗放大机制（Mechanism of mammalian cochlear amplification）：Davis / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of mammalian cochlear amplification.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 哺乳动物耳蜗放大机制 的问题。它可以简单描述为 「哺乳动物耳蜗放大机制」是 生物 领域的 听觉 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「哺乳动物耳蜗放大机制」是 生物 领域的 听觉 方向。',
    formal: '哺乳动物耳蜗放大机制（Mechanism of mammalian cochlear amplification）：Davis / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: '哺乳類の蝸牛増幅のメカニズム：デイビス/マルチチームは1980年に提案され、関連する実験/理論は完全には解決されていません。',
    formalEs: '哺乳动物耳蜗放大机制（Mechanism of mammalian cochlear amplification）：Davis / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of mammalian cochlear amplification: proposed by Davis / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['听觉'],
  },
  {
    id: 'bio-rhodopsin',
    category: 'biology',
    title: '视紫红质 (rhodopsin) 视觉转导机制',
    titleJa: 'ロドプシンの視覚伝達機構',
    titleEs: '视紫红质 (rhodopsin) 视觉转导机制（Mechanism of rhodopsin visual transduction）：Kühne / Wald / 多团队 在 1876 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of rhodopsin visual transduction',
    year: 1876,
    proposer: 'Kühne / Wald / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：视紫红质 (rhodopsin) 视觉转导机制。',
    summaryJa: '生物学的分野における特定の困難な問題：ロドプシンの視覚形質導入メカニズム。',
    summaryEs: '视紫红质 (rhodopsin) 视觉转导机制（Mechanism of rhodopsin visual transduction）：Kühne / Wald / 多团队 在 1876 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of rhodopsin visual transduction.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 视紫红质 (rhodopsin) 视觉转导机制。它说的是 「视紫红质 (rhodopsin) 视觉转导机制」是 生物 领域的 视觉 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「视紫红质 (rhodopsin) 视觉转导机制」是 生物 领域的 视觉 方向。',
    formal: '视紫红质 (rhodopsin) 视觉转导机制（Mechanism of rhodopsin visual transduction）：Kühne / Wald / 多团队 在 1876 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ロドプシン視覚形質導入のメカニズム： 1876年にKühne/Wald/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '视紫红质 (rhodopsin) 视觉转导机制（Mechanism of rhodopsin visual transduction）：Kühne / Wald / 多团队 在 1876 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of rhodopsin visual transduction: proposed by Kühne / Wald / 多团队 in 1876; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Kühne / Wald / 多团队 等人在 1876 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['视觉'],
  },
  {
    id: 'bio-olfactory-code',
    category: 'biology',
    title: '嗅觉受体编码组合性的本质',
    titleJa: '嗅覚受容体コードの組み合わせ性の本質',
    titleEs: '嗅觉受体编码组合性的本质（Nature of olfactory receptor combinatorial coding）：Axel / Buck / 多团队 在 1991 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Nature of olfactory receptor combinatorial coding',
    year: 1991,
    proposer: 'Axel / Buck / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：嗅觉受体编码组合性的本质。',
    summaryJa: '生物学的分野における特定の困難な問題：組合せ性をコードする嗅覚受容体の性質。',
    summaryEs: '嗅觉受体编码组合性的本质（Nature of olfactory receptor combinatorial coding）：Axel / Buck / 多团队 在 1991 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Nature of olfactory receptor combinatorial coding.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 嗅觉受体编码组合性的本质 是这样一个问题：「嗅觉受体编码组合性的本质」是 生物 领域的 嗅觉 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「嗅觉受体编码组合性的本质」是 生物 领域的 嗅觉 方向。',
    formal: '嗅觉受体编码组合性的本质（Nature of olfactory receptor combinatorial coding）：Axel / Buck / 多团队 在 1991 年提出，相关实验/理论至今未完全解决。',
    formalJa: '嗅覚受容体のコンビナトリアルコーディングの性質： 1991年に提案されたAxel/Buck/複数のチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: '嗅觉受体编码组合性的本质（Nature of olfactory receptor combinatorial coding）：Axel / Buck / 多团队 在 1991 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Nature of olfactory receptor combinatorial coding: proposed by Axel / Buck / 多团队 in 1991; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['嗅觉'],
  },
  {
    id: 'bio-taste-receptor',
    category: 'biology',
    title: '味觉受体机制 (sweet, umami, bitter)',
    titleJa: '味覚受容体メカニズム（甘味、旨味、苦味）',
    titleEs: '味觉受体机制 (sweet, umami, bitter)（Taste receptor mechanisms (sweet, umami, bitter)）：Hoon / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Taste receptor mechanisms (sweet, umami, bitter)',
    year: 2000,
    proposer: 'Hoon / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：味觉受体机制 (sweet, umami, bitter)。',
    summaryJa: '生物学的分野における特定の難題：味覚受容体（甘味、うま味、苦味）のメカニズム。',
    summaryEs: '味觉受体机制 (sweet, umami, bitter)（Taste receptor mechanisms (sweet, umami, bitter)）：Hoon / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Taste receptor mechanisms (sweet, umami, bitter).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 味觉受体机制 (sweet, umami, bitter) 的问题。它可以简单描述为 「味觉受体机制 (sweet, umami, bitter)」是 生物 领域的 味觉 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「味觉受体机制 (sweet, umami, bitter)」是 生物 领域的 味觉 方向。',
    formal: '味觉受体机制 (sweet, umami, bitter)（Taste receptor mechanisms (sweet, umami, bitter)）：Hoon / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '味覚受容体メカニズム（甘味、旨味、苦味） ： 2000年にHoon/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '味觉受体机制 (sweet, umami, bitter)（Taste receptor mechanisms (sweet, umami, bitter)）：Hoon / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Taste receptor mechanisms (sweet, umami, bitter): proposed by Hoon / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['味觉'],
  },
  {
    id: 'bio-pain-nav17',
    category: 'biology',
    title: '痛觉分子机制 (Nav1.7 / Nav1.8)',
    titleJa: '疼痛意識の分子メカニズム（ Nav1.7/Nav1.8 ）',
    titleEs: '痛觉分子机制 (Nav1.7 / Nav1.8)（Molecular mechanism of pain (Nav1.7/Nav1.8)）：Cox / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Molecular mechanism of pain (Nav1.7/Nav1.8)',
    year: 2006,
    proposer: 'Cox / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：痛觉分子机制 (Nav1.7 / Nav1.8)。',
    summaryJa: '生物学分野における特定の難題：疼痛感覚の分子メカニズム（ Nav1.7/Nav1.8 ）。',
    summaryEs: '痛觉分子机制 (Nav1.7 / Nav1.8)（Molecular mechanism of pain (Nav1.7/Nav1.8)）：Cox / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Molecular mechanism of pain (Nav1.7/Nav1.8).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 痛觉分子机制 (Nav1.7 / Nav1.8)。它说的是 「痛觉分子机制 (Nav1.7 / Nav1.8)」是 生物 领域的 痛觉 方向，涉及 痛觉, 通道 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「痛觉分子机制 (Nav1.7 / Nav1.8)」是 生物 领域的 痛觉 方向，涉及 痛觉, 通道 等方面。',
    formal: '痛觉分子机制 (Nav1.7 / Nav1.8)（Molecular mechanism of pain (Nav1.7/Nav1.8)）：Cox / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalJa: '疼痛の分子メカニズム（ Nav1.7/Nav1.8 ） ： 2006年にCOX/Multipleチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '痛觉分子机制 (Nav1.7 / Nav1.8)（Molecular mechanism of pain (Nav1.7/Nav1.8)）：Cox / 多团队 在 2006 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Molecular mechanism of pain (Nav1.7/Nav1.8): proposed by Cox / 多团队 in 2006; related experiments/theory remain incomplete.',
    whyHard: '尽管 Cox / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['痛觉', '通道'],
  },
  {
    id: 'bio-itch-pathway',
    category: 'biology',
    title: '痒觉的特异神经通路',
    titleJa: '掻痒症のための特定の神経経路',
    titleEs: '痒觉的特异神经通路（Specific neural pathway for itch sensation）：Ikoma / Mishra / 多团队 在 2007 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Specific neural pathway for itch sensation',
    year: 2007,
    proposer: 'Ikoma / Mishra / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：痒觉的特异神经通路。',
    summaryJa: '生物学的分野における特定の困難な問題：掻痒症の特定の神経経路。',
    summaryEs: '痒觉的特异神经通路（Specific neural pathway for itch sensation）：Ikoma / Mishra / 多团队 在 2007 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Specific neural pathway for itch sensation.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 痒觉的特异神经通路。它说的是 「痒觉的特异神经通路」是 生物 领域的 痒觉 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「痒觉的特异神经通路」是 生物 领域的 痒觉 方向。',
    formal: '痒觉的特异神经通路（Specific neural pathway for itch sensation）：Ikoma / Mishra / 多团队 在 2007 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'かゆみ感覚のための特定の神経経路： 2007年にIkoma/Mishra/複数のチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: '痒觉的特异神经通路（Specific neural pathway for itch sensation）：Ikoma / Mishra / 多团队 在 2007 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Specific neural pathway for itch sensation: proposed by Ikoma / Mishra / 多团队 in 2007; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Ikoma / Mishra / 多团队 等人在 2007 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['痒觉'],
  },
  {
    id: 'bio-zebrafish-heart',
    category: 'biology',
    title: '斑马鱼心脏再生的分子机制',
    titleJa: 'ゼブラフィッシュの心臓再生の分子機構',
    titleEs: '斑马鱼心脏再生的分子机制（Molecular mechanism of zebrafish heart regeneration）：Poss / 多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Molecular mechanism of zebrafish heart regeneration',
    year: 2002,
    proposer: 'Poss / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：斑马鱼心脏再生的分子机制。',
    summaryJa: '生物学分野における特定の困難な問題：ゼブラフィッシュの心臓再生の分子メカニズム。',
    summaryEs: '斑马鱼心脏再生的分子机制（Molecular mechanism of zebrafish heart regeneration）：Poss / 多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Molecular mechanism of zebrafish heart regeneration.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 斑马鱼心脏再生的分子机制 的问题。它可以简单描述为 「斑马鱼心脏再生的分子机制」是 生物 领域的 再生 方向，涉及 再生, 心脏 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「斑马鱼心脏再生的分子机制」是 生物 领域的 再生 方向，涉及 再生, 心脏 等方面。',
    formal: '斑马鱼心脏再生的分子机制（Molecular mechanism of zebrafish heart regeneration）：Poss / 多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ゼブラフィッシュの心臓再生の分子機構： 2002年にPOSS/MULTIチームが提案したが、関連する実験・理論は完全には解明されていない。',
    formalEs: '斑马鱼心脏再生的分子机制（Molecular mechanism of zebrafish heart regeneration）：Poss / 多团队 在 2002 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Molecular mechanism of zebrafish heart regeneration: proposed by Poss / 多团队 in 2002; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Poss / 多团队 等人在 2002 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['再生', '心脏'],
  },
  {
    id: 'bio-mammalian-heart-regen',
    category: 'biology',
    title: '哺乳动物心脏再生 (心肌细胞增殖)',
    titleJa: '哺乳類心臓再生（心筋細胞増殖）',
    titleEs: '哺乳动物心脏再生 (心肌细胞增殖)（Mammalian heart regeneration (cardiomyocyte proliferation)）：Porrello / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mammalian heart regeneration (cardiomyocyte proliferation)',
    year: 2011,
    proposer: 'Porrello / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'open',
    summary: '一道 生物 领域的具体硬问题：哺乳动物心脏再生 (心肌细胞增殖)。',
    summaryJa: '生物学的分野における特定の困難な問題：哺乳類の心臓再生（心筋細胞増殖）。',
    summaryEs: '哺乳动物心脏再生 (心肌细胞增殖)（Mammalian heart regeneration (cardiomyocyte proliferation)）：Porrello / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mammalian heart regeneration (cardiomyocyte proliferation).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 哺乳动物心脏再生 (心肌细胞增殖) 的核心问题是：「哺乳动物心脏再生 (心肌细胞增殖)」是 生物 领域的 再生 方向，涉及 再生, 心脏 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「哺乳动物心脏再生 (心肌细胞增殖)」是 生物 领域的 再生 方向，涉及 再生, 心脏 等方面。',
    formal: '哺乳动物心脏再生 (心肌细胞增殖)（Mammalian heart regeneration (cardiomyocyte proliferation)）：Porrello / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalJa: '哺乳類の心臓再生（心筋細胞増殖） ： Porrello/Multiチームは2011年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: '哺乳动物心脏再生 (心肌细胞增殖)（Mammalian heart regeneration (cardiomyocyte proliferation)）：Porrello / 多团队 在 2011 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mammalian heart regeneration (cardiomyocyte proliferation): proposed by Porrello / 多团队 in 2011; related experiments/theory remain incomplete.',
    whyHard: '「哺乳动物心脏再生 (心肌细胞增殖)」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['再生', '心脏'],
  },
  {
    id: 'bio-liver-regen',
    category: 'biology',
    title: '肝脏再生的精确机制',
    titleJa: '肝臓再生の正確なメカニズム',
    titleEs: '肝脏再生的精确机制（Precise mechanism of liver regeneration）：Higgins / 多团队 在 1930 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise mechanism of liver regeneration',
    year: 1930,
    proposer: 'Higgins / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：肝脏再生的精确机制。',
    summaryJa: '生物学的分野における特定の困難な問題：肝臓再生の正確なメカニズム。',
    summaryEs: '肝脏再生的精确机制（Precise mechanism of liver regeneration）：Higgins / 多团队 在 1930 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Precise mechanism of liver regeneration.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 肝脏再生的精确机制 的问题。它可以简单描述为 「肝脏再生的精确机制」是 生物 领域的 再生 方向，涉及 再生, 肝 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「肝脏再生的精确机制」是 生物 领域的 再生 方向，涉及 再生, 肝 等方面。',
    formal: '肝脏再生的精确机制（Precise mechanism of liver regeneration）：Higgins / 多团队 在 1930 年提出，相关实验/理论至今未完全解决。',
    formalJa: '肝臓再生の正確なメカニズム： 1930年にヒギンズ/マルチチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '肝脏再生的精确机制（Precise mechanism of liver regeneration）：Higgins / 多团队 在 1930 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise mechanism of liver regeneration: proposed by Higgins / 多团队 in 1930; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Higgins / 多团队 等人在 1930 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['再生', '肝'],
  },
  {
    id: 'bio-salamander-limb',
    category: 'biology',
    title: '蝾螈肢体再生的细胞起源',
    titleJa: 'サラマンダーの四肢再生の細胞起源',
    titleEs: '蝾螈肢体再生的细胞起源（Cellular origin of salamander limb regeneration）：Spallanzani / 多团队 在 1774 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Cellular origin of salamander limb regeneration',
    year: 1774,
    proposer: 'Spallanzani / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：蝾螈肢体再生的细胞起源。',
    summaryJa: '生物学的分野における特定の困難な問題：サラマンダーの四肢における再生細胞の起源。',
    summaryEs: '蝾螈肢体再生的细胞起源（Cellular origin of salamander limb regeneration）：Spallanzani / 多团队 在 1774 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Cellular origin of salamander limb regeneration.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 蝾螈肢体再生的细胞起源 的核心问题是：「蝾螈肢体再生的细胞起源」是 生物 领域的 再生 方向，涉及 再生, 肢 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「蝾螈肢体再生的细胞起源」是 生物 领域的 再生 方向，涉及 再生, 肢 等方面。',
    formal: '蝾螈肢体再生的细胞起源（Cellular origin of salamander limb regeneration）：Spallanzani / 多团队 在 1774 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'サラマンダー四肢再生の細胞起源： 1774年にSpallanzani/Multiチームが提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '蝾螈肢体再生的细胞起源（Cellular origin of salamander limb regeneration）：Spallanzani / 多团队 在 1774 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Cellular origin of salamander limb regeneration: proposed by Spallanzani / 多团队 in 1774; related experiments/theory remain incomplete.',
    whyHard: '「蝾螈肢体再生的细胞起源」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['再生', '肢'],
  },
  {
    id: 'bio-aging-hallmarks',
    category: 'biology',
    title: '衰老的统一机制 (9 hallmarks)',
    titleJa: '均一なエイジング機構（ 9つの特徴）',
    titleEs: '衰老的统一机制 (9 hallmarks)（Unified mechanism of aging (9 hallmarks)）：López-Otín / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Unified mechanism of aging (9 hallmarks)',
    year: 2013,
    proposer: 'López-Otín / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：衰老的统一机制 (9 hallmarks)。',
    summaryJa: '生物学的分野における特定の困難な問題：老化の統一されたメカニズム（ 9つの特徴）。',
    summaryEs: '衰老的统一机制 (9 hallmarks)（Unified mechanism of aging (9 hallmarks)）：López-Otín / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Unified mechanism of aging (9 hallmarks).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 衰老的统一机制 (9 hallmarks)。它说的是 「衰老的统一机制 (9 hallmarks)」是 生物 领域的 衰老 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「衰老的统一机制 (9 hallmarks)」是 生物 领域的 衰老 方向。',
    formal: '衰老的统一机制 (9 hallmarks)（Unified mechanism of aging (9 hallmarks)）：López-Otín / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalJa: '9つの特徴（老化の統一されたメカニズム（ 9つの特徴） ） ： López - Otín/MultiTeamは、関連する実験/理論がまだ完全に解決されていないことを2013年に提案しました。',
    formalEs: '衰老的统一机制 (9 hallmarks)（Unified mechanism of aging (9 hallmarks)）：López-Otín / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Unified mechanism of aging (9 hallmarks): proposed by López-Otín / 多团队 in 2013; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 López-Otín / 多团队 等人在 2013 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['衰老'],
  },
  {
    id: 'bio-telomere-aging',
    category: 'biology',
    title: '端粒缩短与衰老的因果关系',
    titleJa: 'テロメア短縮と老化の因果関係',
    titleEs: '端粒缩短与衰老的因果关系（Causal link between telomere shortening and aging）：Hayflick / 多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Causal link between telomere shortening and aging',
    year: 1971,
    proposer: 'Hayflick / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：端粒缩短与衰老的因果关系。',
    summaryJa: '生物学分野における特定の難題：テロメアの短縮と老化の因果関係。',
    summaryEs: '端粒缩短与衰老的因果关系（Causal link between telomere shortening and aging）：Hayflick / 多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Causal link between telomere shortening and aging.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 端粒缩短与衰老的因果关系 的问题。它可以简单描述为 「端粒缩短与衰老的因果关系」是 生物 领域的 端粒 方向，涉及 端粒, 衰老 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「端粒缩短与衰老的因果关系」是 生物 领域的 端粒 方向，涉及 端粒, 衰老 等方面。',
    formal: '端粒缩短与衰老的因果关系（Causal link between telomere shortening and aging）：Hayflick / 多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'テロメア短縮と老化の因果関係： 1971年にHayflick/Multiチームが提案し、関連する実験/理論は完全に解決されていない。',
    formalEs: '端粒缩短与衰老的因果关系（Causal link between telomere shortening and aging）：Hayflick / 多团队 在 1971 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Causal link between telomere shortening and aging: proposed by Hayflick / 多团队 in 1971; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Hayflick / 多团队 等人在 1971 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['端粒', '衰老'],
  },
  {
    id: 'bio-senescent-cell',
    category: 'biology',
    title: '衰老细胞 (senescent cell) 清除 (senolytics)',
    titleJa: '老化細胞クリアランス（ senolytics ）',
    titleEs: '衰老细胞 (senescent cell) 清除 (senolytics)（Senescent cell clearance (senolytics)）：Baker / Robbins / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Senescent cell clearance (senolytics)',
    year: 2015,
    proposer: 'Baker / Robbins / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：衰老细胞 (senescent cell) 清除 (senolytics)。',
    summaryJa: '生物学的分野における特定の困難な問題：老化細胞クリアランス（ senolytics ）。',
    summaryEs: '衰老细胞 (senescent cell) 清除 (senolytics)（Senescent cell clearance (senolytics)）：Baker / Robbins / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Senescent cell clearance (senolytics).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 衰老细胞 (senescent cell) 清除 (senolytics) 的核心问题是：「衰老细胞 (senescent cell) 清除 (senolytics)」是 生物 领域的 衰老细胞 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「衰老细胞 (senescent cell) 清除 (senolytics)」是 生物 领域的 衰老细胞 方向。',
    formal: '衰老细胞 (senescent cell) 清除 (senolytics)（Senescent cell clearance (senolytics)）：Baker / Robbins / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'senescent cell clearance （ senolytics ） ： 2015年にBaker/Robbins/Multiチームが提案し、関連する実験・理論が完全に解決されていない。',
    formalEs: '衰老细胞 (senescent cell) 清除 (senolytics)（Senescent cell clearance (senolytics)）：Baker / Robbins / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Senescent cell clearance (senolytics): proposed by Baker / Robbins / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '「衰老细胞 (senescent cell) 清除 (senolytics)」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['衰老细胞'],
  },
  {
    id: 'bio-nad-antiaging',
    category: 'biology',
    title: 'NAD+ 补充抗衰老的有效性',
    titleJa: 'アンチエイジングのためのNAD +サプリメントの有効性',
    titleEs: 'NAD+ 补充抗衰老的有效性（Effectiveness of NAD+ supplementation in anti-aging）：Sinclair / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Effectiveness of NAD+ supplementation in anti-aging',
    year: 2013,
    proposer: 'Sinclair / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：NAD+ 补充抗衰老的有效性。',
    summaryJa: '生物学的分野における特定の困難な問題：老化に対するNAD +サプリメントの有効性。',
    summaryEs: 'NAD+ 补充抗衰老的有效性（Effectiveness of NAD+ supplementation in anti-aging）：Sinclair / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Effectiveness of NAD+ supplementation in anti-aging.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 NAD+ 补充抗衰老的有效性 是这样一个问题：「NAD+ 补充抗衰老的有效性」是 生物 领域的 NAD+ 方向，涉及 NAD+, 衰老 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「NAD+ 补充抗衰老的有效性」是 生物 领域的 NAD+ 方向，涉及 NAD+, 衰老 等方面。',
    formal: 'NAD+ 补充抗衰老的有效性（Effectiveness of NAD+ supplementation in anti-aging）：Sinclair / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'アンチエイジングにおけるNAD +サプリメントの有効性： 2013年に提案されたSinclair/マルチチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: 'NAD+ 补充抗衰老的有效性（Effectiveness of NAD+ supplementation in anti-aging）：Sinclair / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Effectiveness of NAD+ supplementation in anti-aging: proposed by Sinclair / 多团队 in 2013; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['NAD+', '衰老'],
  },
  {
    id: 'bio-metformin-tame',
    category: 'biology',
    title: '二甲双胍抗衰老 (TAME 试验)',
    titleJa: 'メトホルミンアンチエイジング（ TAME試験）',
    titleEs: '二甲双胍抗衰老 (TAME 试验)（Metformin anti-aging (TAME trial)）：Barzilai / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Metformin anti-aging (TAME trial)',
    year: 2015,
    proposer: 'Barzilai / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：二甲双胍抗衰老 (TAME 试验)。',
    summaryJa: '生物学的分野における特定の困難な問題：メトホルミンアンチエイジング（ TAME試験）。',
    summaryEs: '二甲双胍抗衰老 (TAME 试验)（Metformin anti-aging (TAME trial)）：Barzilai / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Metformin anti-aging (TAME trial).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 二甲双胍抗衰老 (TAME 试验) 的问题。它可以简单描述为 「二甲双胍抗衰老 (TAME 试验)」是 生物 领域的 二甲双胍 方向，涉及 二甲双胍, 抗衰 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「二甲双胍抗衰老 (TAME 试验)」是 生物 领域的 二甲双胍 方向，涉及 二甲双胍, 抗衰 等方面。',
    formal: '二甲双胍抗衰老 (TAME 试验)（Metformin anti-aging (TAME trial)）：Barzilai / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'メトホルミンアンチエイジング（ TAMEトライアル） ： 2015年にBarzilai/複数のチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: '二甲双胍抗衰老 (TAME 试验)（Metformin anti-aging (TAME trial)）：Barzilai / 多团队 在 2015 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Metformin anti-aging (TAME trial): proposed by Barzilai / 多团队 in 2015; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['二甲双胍', '抗衰'],
  },
  {
    id: 'bio-caloric-restriction',
    category: 'biology',
    title: '热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素)',
    titleJa: 'カロリー制限（ CR ）シミュレータ（ラパマイシン）',
    titleEs: '热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素)（Caloric restriction mimetics (rapamycin)）：Harrison / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Caloric restriction mimetics (rapamycin)',
    year: 2009,
    proposer: 'Harrison / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素)。',
    summaryJa: '生物学的分野における特定の困難な問題：カロリー制限（ ＣＲ ）シミュラント（ラパマイシン）。',
    summaryEs: '热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素)（Caloric restriction mimetics (rapamycin)）：Harrison / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Caloric restriction mimetics (rapamycin).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素) 的问题。它可以简单描述为 「热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素)」是 生物 领域的 雷帕霉素 方向，涉及 雷帕霉素, 抗衰 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素)」是 生物 领域的 雷帕霉素 方向，涉及 雷帕霉素, 抗衰 等方面。',
    formal: '热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素)（Caloric restriction mimetics (rapamycin)）：Harrison / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'カロリー制限模倣品（ CR ） （カロリー制限模倣品（ラパマイシン） ） ： 2009年に提案されたHarrison/複数のチーム、および関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: '热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素)（Caloric restriction mimetics (rapamycin)）：Harrison / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Caloric restriction mimetics (rapamycin): proposed by Harrison / 多团队 in 2009; related experiments/theory remain incomplete.',
    whyHard: '「热量限制 (CR) 模拟物 (rapamycin, 雷帕霉素)」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['雷帕霉素', '抗衰'],
  },
  {
    id: 'bio-stem-cell-aging',
    category: 'biology',
    title: '干细胞衰老 (stem cell exhaustion)',
    titleJa: '幹細胞疲労',
    titleEs: '干细胞衰老 (stem cell exhaustion)（Stem cell exhaustion in aging）：多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Stem cell exhaustion in aging',
    year: 2010,
    proposer: '多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：干细胞衰老 (stem cell exhaustion)。',
    summaryJa: '生物学的分野における特定の困難な問題：幹細胞の枯渇。',
    summaryEs: '干细胞衰老 (stem cell exhaustion)（Stem cell exhaustion in aging）：多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Stem cell exhaustion in aging.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 干细胞衰老 (stem cell exhaustion) 的问题。它可以简单描述为 「干细胞衰老 (stem cell exhaustion)」是 生物 领域的 干细胞 方向，涉及 干细胞, 衰老 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「干细胞衰老 (stem cell exhaustion)」是 生物 领域的 干细胞 方向，涉及 干细胞, 衰老 等方面。',
    formal: '干细胞衰老 (stem cell exhaustion)（Stem cell exhaustion in aging）：多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalJa: '老化における幹細胞の枯渇（ Stem cell exhaustion in aging ） ： 2010年に複数のチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: '干细胞衰老 (stem cell exhaustion)（Stem cell exhaustion in aging）：多团队 在 2010 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Stem cell exhaustion in aging: proposed by 多团队 in 2010; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 多团队 等人在 2010 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['干细胞', '衰老'],
  },
  {
    id: 'bio-proteostasis-aging',
    category: 'biology',
    title: '蛋白稳态 (proteostasis) 衰退与衰老',
    titleJa: 'プロテオスタシスの崩壊と老化',
    titleEs: '蛋白稳态 (proteostasis) 衰退与衰老（Proteostasis decline in aging）：Morimoto / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Proteostasis decline in aging',
    year: 2008,
    proposer: 'Morimoto / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：蛋白稳态 (proteostasis) 衰退与衰老。',
    summaryJa: '生物学的分野における特定の困難な問題：タンパク質の恒常性の低下と老化。',
    summaryEs: '蛋白稳态 (proteostasis) 衰退与衰老（Proteostasis decline in aging）：Morimoto / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Proteostasis decline in aging.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 蛋白稳态 (proteostasis) 衰退与衰老 是这样一个问题：「蛋白稳态 (proteostasis) 衰退与衰老」是 生物 领域的 蛋白稳态 方向，涉及 蛋白稳态, 衰老 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「蛋白稳态 (proteostasis) 衰退与衰老」是 生物 领域的 蛋白稳态 方向，涉及 蛋白稳态, 衰老 等方面。',
    formal: '蛋白稳态 (proteostasis) 衰退与衰老（Proteostasis decline in aging）：Morimoto / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalJa: '老化におけるプロテオスタシスの低下： Morimoto/Multiチームは2008年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: '蛋白稳态 (proteostasis) 衰退与衰老（Proteostasis decline in aging）：Morimoto / 多团队 在 2008 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Proteostasis decline in aging: proposed by Morimoto / 多团队 in 2008; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['蛋白稳态', '衰老'],
  },
  {
    id: 'bio-mito-dysfunction',
    category: 'biology',
    title: '线粒体功能障碍与衰老',
    titleJa: 'ミトコンドリア機能障害と老化',
    titleEs: '线粒体功能障碍与衰老（Mitochondrial dysfunction in aging）：Wallace / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mitochondrial dysfunction in aging',
    year: 2000,
    proposer: 'Wallace / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：线粒体功能障碍与衰老。',
    summaryJa: '生物学的分野における特定の困難な問題：ミトコンドリア機能障害と老化。',
    summaryEs: '线粒体功能障碍与衰老（Mitochondrial dysfunction in aging）：Wallace / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mitochondrial dysfunction in aging.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 线粒体功能障碍与衰老 的问题。它可以简单描述为 「线粒体功能障碍与衰老」是 生物 领域的 线粒体 方向，涉及 线粒体, 衰老 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「线粒体功能障碍与衰老」是 生物 领域的 线粒体 方向，涉及 线粒体, 衰老 等方面。',
    formal: '线粒体功能障碍与衰老（Mitochondrial dysfunction in aging）：Wallace / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '老化におけるミトコンドリア機能不全（老化におけるミトコンドリア機能不全） ： 2000年にWallace/Multiチームが提案し、関連する実験/理論は完全に解決されていない。',
    formalEs: '线粒体功能障碍与衰老（Mitochondrial dysfunction in aging）：Wallace / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mitochondrial dysfunction in aging: proposed by Wallace / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '尽管 Wallace / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['线粒体', '衰老'],
  },
  {
    id: 'bio-cell-cycle-checkpoint',
    category: 'biology',
    title: '细胞周期检查点 (G1/S, G2/M) 完整机制',
    titleJa: '細胞周期チェックポイント（ G 1/S、G 2/M ）の完全なメカニズム',
    titleEs: '细胞周期检查点 (G1/S, G2/M) 完整机制（Complete mechanism of cell cycle checkpoints (G1/S, G2/M)）：Hartwell / Nurse / Hunt 在 1989 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Complete mechanism of cell cycle checkpoints (G1/S, G2/M)',
    year: 1989,
    proposer: 'Hartwell / Nurse / Hunt',
    difficulty: 3,
    reward: 300,
    status: 'solved',
    summary: '一道 生物 领域的具体硬问题：细胞周期检查点 (G1/S, G2/M) 完整机制。',
    summaryJa: '生物学的分野における特定の難題：細胞周期チェックポイントの完全なメカニズム（ G 1/S、G 2/M ）。',
    summaryEs: '细胞周期检查点 (G1/S, G2/M) 完整机制（Complete mechanism of cell cycle checkpoints (G1/S, G2/M)）：Hartwell / Nurse / Hunt 在 1989 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Complete mechanism of cell cycle checkpoints (G1/S, G2/M).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 细胞周期检查点 (G1/S, G2/M) 完整机制 是这样一个问题：「细胞周期检查点 (G1/S, G2/M) 完整机制」是 生物 领域的 细胞周期 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「细胞周期检查点 (G1/S, G2/M) 完整机制」是 生物 领域的 细胞周期 方向。',
    formal: '细胞周期检查点 (G1/S, G2/M) 完整机制（Complete mechanism of cell cycle checkpoints (G1/S, G2/M)）：Hartwell / Nurse / Hunt 在 1989 年提出，相关实验/理论至今未完全解决。',
    formalJa: '細胞周期チェックポイントの完全なメカニズム（ G 1/S、G 2/M ） ： 1989年にHartwell/Nurse/Huntが提案され、関連する実験/理論は完全に解決されていない。',
    formalEs: '细胞周期检查点 (G1/S, G2/M) 完整机制（Complete mechanism of cell cycle checkpoints (G1/S, G2/M)）：Hartwell / Nurse / Hunt 在 1989 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Complete mechanism of cell cycle checkpoints (G1/S, G2/M): proposed by Hartwell / Nurse / Hunt in 1989; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Hartwell / Nurse / Hunt 等人在 1989 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['细胞周期'],
  },
  {
    id: 'bio-crispr-cas12-cas13',
    category: 'biology',
    title: 'Cas12 / Cas13 程序化核酸检测',
    titleJa: 'Cas 12/Cas 13プログラム核酸試験',
    titleEs: 'Cas12 / Cas13 程序化核酸检测（Programmable nucleic acid detection with Cas12/Cas13）：Doudna / Zhang / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Programmable nucleic acid detection with Cas12/Cas13',
    year: 2017,
    proposer: 'Doudna / Zhang / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Cas12 / Cas13 程序化核酸检测。',
    summaryJa: '生物学的分野における特定の難題： Ｃａｓ １ ２ ／ Ｃａｓ １ ３プログラムされた核酸検出。',
    summaryEs: 'Cas12 / Cas13 程序化核酸检测（Programmable nucleic acid detection with Cas12/Cas13）：Doudna / Zhang / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Programmable nucleic acid detection with Cas12/Cas13.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 Cas12 / Cas13 程序化核酸检测。它说的是 「Cas12 / Cas13 程序化核酸检测」是 生物 领域的 CRISPR 方向，涉及 CRISPR, 诊断 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Cas12 / Cas13 程序化核酸检测」是 生物 领域的 CRISPR 方向，涉及 CRISPR, 诊断 等方面。',
    formal: 'Cas12 / Cas13 程序化核酸检测（Programmable nucleic acid detection with Cas12/Cas13）：Doudna / Zhang / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Cas 12/Cas 13でのプログラム可能な核酸検出Cas 12/Cas 13: Doudna/Zhang/複数のチームが2017年に提案され、関連する実験/理論はこれまで完全に解決されていません。',
    formalEs: 'Cas12 / Cas13 程序化核酸检测（Programmable nucleic acid detection with Cas12/Cas13）：Doudna / Zhang / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Programmable nucleic acid detection with Cas12/Cas13: proposed by Doudna / Zhang / 多团队 in 2017; related experiments/theory remain incomplete.',
    whyHard: '尽管 Doudna / Zhang / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CRISPR', '诊断'],
  },
  {
    id: 'bio-cas14',
    category: 'biology',
    title: 'Cas14 (Cas12f) 的小型化优势',
    titleJa: 'Cas 14 （ Cas 12 f ）での小型化の利点',
    titleEs: 'Cas14 (Cas12f) 的小型化优势（Compact advantage of Cas14 (Cas12f)）：Zhang / 多团队 在 2019 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Compact advantage of Cas14 (Cas12f)',
    year: 2019,
    proposer: 'Zhang / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Cas14 (Cas12f) 的小型化优势。',
    summaryJa: '生物学的分野における特定の難題： Cas 14 （ Cas 12 f ）の小型化の利点。',
    summaryEs: 'Cas14 (Cas12f) 的小型化优势（Compact advantage of Cas14 (Cas12f)）：Zhang / 多团队 在 2019 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Compact advantage of Cas14 (Cas12f).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 Cas14 (Cas12f) 的小型化优势 的核心问题是：「Cas14 (Cas12f) 的小型化优势」是 生物 领域的 CRISPR 方向，涉及 CRISPR, 基因编辑 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Cas14 (Cas12f) 的小型化优势」是 生物 领域的 CRISPR 方向，涉及 CRISPR, 基因编辑 等方面。',
    formal: 'Cas14 (Cas12f) 的小型化优势（Compact advantage of Cas14 (Cas12f)）：Zhang / 多团队 在 2019 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Cas 14 （ Cas 12 f ）小型化の利点（ Cas 14 （ Cas 12 f ）のコンパクトな利点） ： Zhang/マルチチームは2019年に、これまでのところ関連する実験/理論が完全に解決されていないことを提案しました。',
    formalEs: 'Cas14 (Cas12f) 的小型化优势（Compact advantage of Cas14 (Cas12f)）：Zhang / 多团队 在 2019 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Compact advantage of Cas14 (Cas12f): proposed by Zhang / 多团队 in 2019; related experiments/theory remain incomplete.',
    whyHard: '尽管 Zhang / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CRISPR', '基因编辑'],
  },
  {
    id: 'bio-organoid',
    category: 'biology',
    title: '类器官 (organoid) 的脑功能建模',
    titleJa: 'オルガノイドの脳機能モデリング',
    titleEs: '类器官 (organoid) 的脑功能建模（Brain organoid functional modeling）：Knoblich / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Brain organoid functional modeling',
    year: 2013,
    proposer: 'Knoblich / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：类器官 (organoid) 的脑功能建模。',
    summaryJa: '生物学的分野における特定の難題：オルガノイドの脳機能のモデリング。',
    summaryEs: '类器官 (organoid) 的脑功能建模（Brain organoid functional modeling）：Knoblich / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Brain organoid functional modeling.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 类器官 (organoid) 的脑功能建模 的问题。它可以简单描述为 「类器官 (organoid) 的脑功能建模」是 生物 领域的 类器官 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「类器官 (organoid) 的脑功能建模」是 生物 领域的 类器官 方向。',
    formal: '类器官 (organoid) 的脑功能建模（Brain organoid functional modeling）：Knoblich / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalJa: '脳オルガノイド機能モデリング： 2013年にKnoblich/マルチチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: '类器官 (organoid) 的脑功能建模（Brain organoid functional modeling）：Knoblich / 多团队 在 2013 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Brain organoid functional modeling: proposed by Knoblich / 多团队 in 2013; related experiments/theory remain incomplete.',
    whyHard: '尽管 Knoblich / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['类器官'],
  },
  {
    id: 'bio-syn-bio',
    category: 'biology',
    title: '合成生物学 (SynBio) 通用基因线路',
    titleJa: '合成生物学（ SynBio ）ユニバーサル遺伝子回路',
    titleEs: '合成生物学 (SynBio) 通用基因线路（Synthetic biology universal gene circuits）：Elowitz / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Synthetic biology universal gene circuits',
    year: 2000,
    proposer: 'Elowitz / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：合成生物学 (SynBio) 通用基因线路。',
    summaryJa: '生物学の分野における特定の難題：合成生物学（ SynBio ）遺伝子回路。',
    summaryEs: '合成生物学 (SynBio) 通用基因线路（Synthetic biology universal gene circuits）：Elowitz / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Synthetic biology universal gene circuits.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 合成生物学 (SynBio) 通用基因线路。它说的是 「合成生物学 (SynBio) 通用基因线路」是 生物 领域的 SynBio 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「合成生物学 (SynBio) 通用基因线路」是 生物 领域的 SynBio 方向。',
    formal: '合成生物学 (SynBio) 通用基因线路（Synthetic biology universal gene circuits）：Elowitz / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '合成生物学ユニバーサル遺伝子回路： 2000年にElowitz/MultiTeamによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '合成生物学 (SynBio) 通用基因线路（Synthetic biology universal gene circuits）：Elowitz / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Synthetic biology universal gene circuits: proposed by Elowitz / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['SynBio'],
  },
  {
    id: 'bio-xeno',
    category: 'biology',
    title: '异种器官移植 (xenotransplantation) 免疫排斥',
    titleJa: '異種移植免疫拒絶反応',
    titleEs: '异种器官移植 (xenotransplantation) 免疫排斥（Immunological rejection in xenotransplantation）：Yang / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Immunological rejection in xenotransplantation',
    year: 1990,
    proposer: 'Yang / 多团队',
    difficulty: 5,
    reward: 2500,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：异种器官移植 (xenotransplantation) 免疫排斥。',
    summaryJa: '生物学的分野における特定の困難な問題：異種移植免疫拒絶。',
    summaryEs: '异种器官移植 (xenotransplantation) 免疫排斥（Immunological rejection in xenotransplantation）：Yang / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Immunological rejection in xenotransplantation.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 异种器官移植 (xenotransplantation) 免疫排斥 的核心问题是：「异种器官移植 (xenotransplantation) 免疫排斥」是 生物 领域的 移植 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「异种器官移植 (xenotransplantation) 免疫排斥」是 生物 领域的 移植 方向。',
    formal: '异种器官移植 (xenotransplantation) 免疫排斥（Immunological rejection in xenotransplantation）：Yang / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '異種移植異種移植における免疫学的拒絶： 1990年にYang/複数チームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: '异种器官移植 (xenotransplantation) 免疫排斥（Immunological rejection in xenotransplantation）：Yang / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Immunological rejection in xenotransplantation: proposed by Yang / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '「异种器官移植 (xenotransplantation) 免疫排斥」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['移植'],
  },
  {
    id: 'bio-crispr-genome-wide',
    category: 'biology',
    title: '全基因组 CRISPR 筛选的设计原则',
    titleJa: '全ゲノムCRISPRスクリーニングの設計原則',
    titleEs: '全基因组 CRISPR 筛选的设计原则（Design principles of genome-wide CRISPR screens）：Sanjana / Shalem / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Design principles of genome-wide CRISPR screens',
    year: 2014,
    proposer: 'Sanjana / Shalem / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：全基因组 CRISPR 筛选的设计原则。',
    summaryJa: '生物学分野における特定の難題：ゲノムワイドCRISPRスクリーニングの設計原理。',
    summaryEs: '全基因组 CRISPR 筛选的设计原则（Design principles of genome-wide CRISPR screens）：Sanjana / Shalem / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Design principles of genome-wide CRISPR screens.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 全基因组 CRISPR 筛选的设计原则 是这样一个问题：「全基因组 CRISPR 筛选的设计原则」是 生物 领域的 CRISPR 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「全基因组 CRISPR 筛选的设计原则」是 生物 领域的 CRISPR 方向。',
    formal: '全基因组 CRISPR 筛选的设计原则（Design principles of genome-wide CRISPR screens）：Sanjana / Shalem / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ゲノムワイドCRISPRスクリーンの設計原理： 2014年にSanjana/Shalem/複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '全基因组 CRISPR 筛选的设计原则（Design principles of genome-wide CRISPR screens）：Sanjana / Shalem / 多团队 在 2014 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Design principles of genome-wide CRISPR screens: proposed by Sanjana / Shalem / 多团队 in 2014; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Sanjana / Shalem / 多团队 等人在 2014 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CRISPR'],
  },
  {
    id: 'bio-rna-decay',
    category: 'biology',
    title: 'RNA 衰减 (NMD, NGD) 调控',
    titleJa: 'RNA減衰（ NMD、NGD ）調節',
    titleEs: 'RNA 衰减 (NMD, NGD) 调控（Regulation of RNA decay (NMD, NGD)）：Losson / 多团队 在 1979 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Regulation of RNA decay (NMD, NGD)',
    year: 1979,
    proposer: 'Losson / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：RNA 衰减 (NMD, NGD) 调控。',
    summaryJa: '生物学的分野における特定の難題： RNA減衰（ NMD、NGD ）調節。',
    summaryEs: 'RNA 衰减 (NMD, NGD) 调控（Regulation of RNA decay (NMD, NGD)）：Losson / 多团队 在 1979 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Regulation of RNA decay (NMD, NGD).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 RNA 衰减 (NMD, NGD) 调控。它说的是 「RNA 衰减 (NMD, NGD) 调控」是 生物 领域的 RNA 方向，涉及 RNA, 降解 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「RNA 衰减 (NMD, NGD) 调控」是 生物 领域的 RNA 方向，涉及 RNA, 降解 等方面。',
    formal: 'RNA 衰减 (NMD, NGD) 调控（Regulation of RNA decay (NMD, NGD)）：Losson / 多团队 在 1979 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'RNA崩壊（ NMD、NGD ） RNA崩壊の調節（ NMD、NGD ） ： 1979年に提案されたLosson/Multiチーム、および関連する実験/理論は完全に解決されていません。',
    formalEs: 'RNA 衰减 (NMD, NGD) 调控（Regulation of RNA decay (NMD, NGD)）：Losson / 多团队 在 1979 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Regulation of RNA decay (NMD, NGD): proposed by Losson / 多团队 in 1979; related experiments/theory remain incomplete.',
    whyHard: '「RNA 衰减 (NMD, NGD) 调控」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['RNA', '降解'],
  },
  {
    id: 'bio-rna-splicing-mach',
    category: 'biology',
    title: '剪接体 (spliceosome) 的动态组装机制',
    titleJa: 'スプライソソームの動的組立機構',
    titleEs: '剪接体 (spliceosome) 的动态组装机制（Dynamic assembly of the spliceosome）：Brody / Abelson / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Dynamic assembly of the spliceosome',
    year: 1980,
    proposer: 'Brody / Abelson / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：剪接体 (spliceosome) 的动态组装机制。',
    summaryJa: '生物学分野における特定の難題：スプライソソームの動的組立機構。',
    summaryEs: '剪接体 (spliceosome) 的动态组装机制（Dynamic assembly of the spliceosome）：Brody / Abelson / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Dynamic assembly of the spliceosome.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 剪接体 (spliceosome) 的动态组装机制 的问题。它可以简单描述为 「剪接体 (spliceosome) 的动态组装机制」是 生物 领域的 剪接 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「剪接体 (spliceosome) 的动态组装机制」是 生物 领域的 剪接 方向。',
    formal: '剪接体 (spliceosome) 的动态组装机制（Dynamic assembly of the spliceosome）：Brody / Abelson / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'スプライソソームの動的アセンブリ：ブロディ/アベルソン/マルチチームは1980年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: '剪接体 (spliceosome) 的动态组装机制（Dynamic assembly of the spliceosome）：Brody / Abelson / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Dynamic assembly of the spliceosome: proposed by Brody / Abelson / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Brody / Abelson / 多团队 等人在 1980 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['剪接'],
  },
  {
    id: 'bio-telomerase-target',
    category: 'biology',
    title: '端粒酶 (telomerase) 作为癌症靶点',
    titleJa: 'がん標的としてのテロメラーゼ',
    titleEs: '端粒酶 (telomerase) 作为癌症靶点（Telomerase as a cancer target）：Blackburn / 多团队 在 1985 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Telomerase as a cancer target',
    year: 1985,
    proposer: 'Blackburn / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：端粒酶 (telomerase) 作为癌症靶点。',
    summaryJa: '生物学的分野における特定の困難な問題：癌標的としてのテロメラーゼ。',
    summaryEs: '端粒酶 (telomerase) 作为癌症靶点（Telomerase as a cancer target）：Blackburn / 多团队 在 1985 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Telomerase as a cancer target.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 端粒酶 (telomerase) 作为癌症靶点 是这样一个问题：「端粒酶 (telomerase) 作为癌症靶点」是 生物 领域的 端粒 方向，涉及 端粒, 肿瘤 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「端粒酶 (telomerase) 作为癌症靶点」是 生物 领域的 端粒 方向，涉及 端粒, 肿瘤 等方面。',
    formal: '端粒酶 (telomerase) 作为癌症靶点（Telomerase as a cancer target）：Blackburn / 多团队 在 1985 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'がん標的としてのテロメラーゼ： 1985年にBlackburn/Multi - teamが提案され、関連する実験・理論が完全に解決されていない。',
    formalEs: '端粒酶 (telomerase) 作为癌症靶点（Telomerase as a cancer target）：Blackburn / 多团队 在 1985 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Telomerase as a cancer target: proposed by Blackburn / 多团队 in 1985; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['端粒', '肿瘤'],
  },
  {
    id: 'bio-ribosome',
    category: 'biology',
    title: '核糖体 (ribosome) 翻译的精确机制',
    titleJa: 'リボソーム翻訳の正確なメカニズム',
    titleEs: '核糖体 (ribosome) 翻译的精确机制（Precise mechanism of ribosomal translation）：Ramakrishnan / Steitz / Yonath 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise mechanism of ribosomal translation',
    year: 2000,
    proposer: 'Ramakrishnan / Steitz / Yonath',
    difficulty: 3,
    reward: 300,
    status: 'solved',
    summary: '一道 生物 领域的具体硬问题：核糖体 (ribosome) 翻译的精确机制。',
    summaryJa: '生物学分野における特定の難題：リボソーム翻訳の正確なメカニズム。',
    summaryEs: '核糖体 (ribosome) 翻译的精确机制（Precise mechanism of ribosomal translation）：Ramakrishnan / Steitz / Yonath 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Precise mechanism of ribosomal translation.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 核糖体 (ribosome) 翻译的精确机制 是这样一个问题：「核糖体 (ribosome) 翻译的精确机制」是 生物 领域的 翻译 方向，涉及 翻译, 核糖体 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「核糖体 (ribosome) 翻译的精确机制」是 生物 领域的 翻译 方向，涉及 翻译, 核糖体 等方面。',
    formal: '核糖体 (ribosome) 翻译的精确机制（Precise mechanism of ribosomal translation）：Ramakrishnan / Steitz / Yonath 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'リボソーム翻訳の正確なメカニズム： 2000年にRamakrishnan/Steitz/Yonathによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: '核糖体 (ribosome) 翻译的精确机制（Precise mechanism of ribosomal translation）：Ramakrishnan / Steitz / Yonath 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise mechanism of ribosomal translation: proposed by Ramakrishnan / Steitz / Yonath in 2000; related experiments/theory remain incomplete.',
    whyHard: '「核糖体 (ribosome) 翻译的精确机制」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['翻译', '核糖体'],
  },
  {
    id: 'bio-prot-fold-misfold',
    category: 'biology',
    title: '蛋白质错误折叠与未折叠蛋白反应 (UPR)',
    titleJa: '誤って折り畳まれ、折り畳まれていないタンパク質反応（ UPR ）',
    titleEs: '蛋白质错误折叠与未折叠蛋白反应 (UPR)（Protein misfolding and unfolded protein response (UPR)）：Walter / 多团队 在 1988 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Protein misfolding and unfolded protein response (UPR)',
    year: 1988,
    proposer: 'Walter / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：蛋白质错误折叠与未折叠蛋白反应 (UPR)。',
    summaryJa: '生物学的分野における特定の困難な問題：タンパク質のミスフォールディング及びアンフォールディングタンパク質応答（ ＵＰＲ ）。',
    summaryEs: '蛋白质错误折叠与未折叠蛋白反应 (UPR)（Protein misfolding and unfolded protein response (UPR)）：Walter / 多团队 在 1988 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Protein misfolding and unfolded protein response (UPR).',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 蛋白质错误折叠与未折叠蛋白反应 (UPR) 的问题。它可以简单描述为 「蛋白质错误折叠与未折叠蛋白反应 (UPR)」是 生物 领域的 UPR 方向，涉及 UPR, 内质网 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「蛋白质错误折叠与未折叠蛋白反应 (UPR)」是 生物 领域的 UPR 方向，涉及 UPR, 内质网 等方面。',
    formal: '蛋白质错误折叠与未折叠蛋白反应 (UPR)（Protein misfolding and unfolded protein response (UPR)）：Walter / 多团队 在 1988 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'タンパク質の誤った折り畳みと展開されたタンパク質応答（ UPR ） ： Walter/Multiチームは1988年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: '蛋白质错误折叠与未折叠蛋白反应 (UPR)（Protein misfolding and unfolded protein response (UPR)）：Walter / 多团队 在 1988 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Protein misfolding and unfolded protein response (UPR): proposed by Walter / 多团队 in 1988; related experiments/theory remain incomplete.',
    whyHard: '尽管 Walter / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['UPR', '内质网'],
  },
  {
    id: 'bio-autophagy-mech',
    category: 'biology',
    title: '自噬 (autophagy) 的选择性机制',
    titleJa: 'オートファジーの選択的メカニズム',
    titleEs: '自噬 (autophagy) 的选择性机制（Selective mechanism of autophagy）：Ohsumi / 多团队 在 1992 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Selective mechanism of autophagy',
    year: 1992,
    proposer: 'Ohsumi / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：自噬 (autophagy) 的选择性机制。',
    summaryJa: '生物学的分野における特定の困難な問題：オートファジーの選択的メカニズム。',
    summaryEs: '自噬 (autophagy) 的选择性机制（Selective mechanism of autophagy）：Ohsumi / 多团队 在 1992 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Selective mechanism of autophagy.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 自噬 (autophagy) 的选择性机制 的问题。它可以简单描述为 「自噬 (autophagy) 的选择性机制」是 生物 领域的 自噬 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「自噬 (autophagy) 的选择性机制」是 生物 领域的 自噬 方向。',
    formal: '自噬 (autophagy) 的选择性机制（Selective mechanism of autophagy）：Ohsumi / 多团队 在 1992 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'オートファジーの選択的メカニズム： 1992年にOhsumi/マルチチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: '自噬 (autophagy) 的选择性机制（Selective mechanism of autophagy）：Ohsumi / 多团队 在 1992 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Selective mechanism of autophagy: proposed by Ohsumi / 多团队 in 1992; related experiments/theory remain incomplete.',
    whyHard: '尽管 Ohsumi / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['自噬'],
  },
  {
    id: 'bio-ferroptosis',
    category: 'biology',
    title: '铁死亡 (ferroptosis) 的精确机制',
    titleJa: '鉄死（フェロプトーシス）の正確なメカニズム',
    titleEs: '铁死亡 (ferroptosis) 的精确机制（Precise mechanism of ferroptosis）：Stockwell / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise mechanism of ferroptosis',
    year: 2012,
    proposer: 'Stockwell / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：铁死亡 (ferroptosis) 的精确机制。',
    summaryJa: '生物学的分野における特定の困難な問題：鉄の死亡（フェロプトーシス）の正確なメカニズム。',
    summaryEs: '铁死亡 (ferroptosis) 的精确机制（Precise mechanism of ferroptosis）：Stockwell / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Precise mechanism of ferroptosis.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 铁死亡 (ferroptosis) 的精确机制 的问题。它可以简单描述为 「铁死亡 (ferroptosis) 的精确机制」是 生物 领域的 铁死亡 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「铁死亡 (ferroptosis) 的精确机制」是 生物 领域的 铁死亡 方向。',
    formal: '铁死亡 (ferroptosis) 的精确机制（Precise mechanism of ferroptosis）：Stockwell / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'フェロプトーシスの正確なメカニズム： Stockwell/Multi - Teamは、関連する実験/理論がまだ完全に解決されていないことを2012年に提案しました。',
    formalEs: '铁死亡 (ferroptosis) 的精确机制（Precise mechanism of ferroptosis）：Stockwell / 多团队 在 2012 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise mechanism of ferroptosis: proposed by Stockwell / 多团队 in 2012; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Stockwell / 多团队 等人在 2012 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['铁死亡'],
  },
  {
    id: 'bio-pyroptosis',
    category: 'biology',
    title: '焦亡 (pyroptosis) 炎症小体机制',
    titleJa: '発熱の炎症性体細胞メカニズム',
    titleEs: '焦亡 (pyroptosis) 炎症小体机制（Mechanism of pyroptosis inflammasome）：Cookson / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of pyroptosis inflammasome',
    year: 2001,
    proposer: 'Cookson / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：焦亡 (pyroptosis) 炎症小体机制。',
    summaryJa: '生物学的分野における特定の困難な問題：発熱症のインフラマソーム機構。',
    summaryEs: '焦亡 (pyroptosis) 炎症小体机制（Mechanism of pyroptosis inflammasome）：Cookson / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of pyroptosis inflammasome.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 焦亡 (pyroptosis) 炎症小体机制 的问题。它可以简单描述为 「焦亡 (pyroptosis) 炎症小体机制」是 生物 领域的 焦亡 方向。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「焦亡 (pyroptosis) 炎症小体机制」是 生物 领域的 焦亡 方向。',
    formal: '焦亡 (pyroptosis) 炎症小体机制（Mechanism of pyroptosis inflammasome）：Cookson / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalJa: '発熱性インフラマソームのメカニズム： 2001年にCookson/複数のチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: '焦亡 (pyroptosis) 炎症小体机制（Mechanism of pyroptosis inflammasome）：Cookson / 多团队 在 2001 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of pyroptosis inflammasome: proposed by Cookson / 多团队 in 2001; related experiments/theory remain incomplete.',
    whyHard: '「焦亡 (pyroptosis) 炎症小体机制」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['焦亡'],
  },
  {
    id: 'bio-necroptosis',
    category: 'biology',
    title: '坏死性凋亡 (necroptosis) 通路',
    titleJa: '壊死経路',
    titleEs: '坏死性凋亡 (necroptosis) 通路（Necroptosis pathway）：Yuan / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Necroptosis pathway',
    year: 2005,
    proposer: 'Yuan / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：坏死性凋亡 (necroptosis) 通路。',
    summaryJa: '生物学的分野における特定の困難な問題：ネクロプトーシス経路。',
    summaryEs: '坏死性凋亡 (necroptosis) 通路（Necroptosis pathway）：Yuan / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Necroptosis pathway.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 坏死性凋亡 (necroptosis) 通路 是这样一个问题：「坏死性凋亡 (necroptosis) 通路」是 生物 领域的 坏死性凋亡 方向。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「坏死性凋亡 (necroptosis) 通路」是 生物 领域的 坏死性凋亡 方向。',
    formal: '坏死性凋亡 (necroptosis) 通路（Necroptosis pathway）：Yuan / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Necroptosis経路： 2005年に提案されたYuan/multi - teamであり、関連する実験/理論は完全に解決されていない。',
    formalEs: '坏死性凋亡 (necroptosis) 通路（Necroptosis pathway）：Yuan / 多团队 在 2005 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Necroptosis pathway: proposed by Yuan / 多团队 in 2005; related experiments/theory remain incomplete.',
    whyHard: '「坏死性凋亡 (necroptosis) 通路」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['坏死性凋亡'],
  },
  {
    id: 'bio-apoptosis-p53',
    category: 'biology',
    title: 'p53 抑癌基因的调控网络',
    titleJa: 'p 53腫瘍抑制遺伝子の調節ネットワーク',
    titleEs: 'p53 抑癌基因的调控网络（Regulatory network of p53 tumor suppressor）：Levine / 多团队 在 1979 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Regulatory network of p53 tumor suppressor',
    year: 1979,
    proposer: 'Levine / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：p53 抑癌基因的调控网络。',
    summaryJa: '生物学的分野における特定の困難な問題： p 53腫瘍抑制遺伝子の調節ネットワーク。',
    summaryEs: 'p53 抑癌基因的调控网络（Regulatory network of p53 tumor suppressor）：Levine / 多团队 在 1979 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Regulatory network of p53 tumor suppressor.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 p53 抑癌基因的调控网络 的问题。它可以简单描述为 「p53 抑癌基因的调控网络」是 生物 领域的 p53 方向，涉及 p53, 肿瘤 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「p53 抑癌基因的调控网络」是 生物 领域的 p53 方向，涉及 p53, 肿瘤 等方面。',
    formal: 'p53 抑癌基因的调控网络（Regulatory network of p53 tumor suppressor）：Levine / 多团队 在 1979 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'p 53腫瘍サプレッサーの調節ネットワーク： 1979年にLevine/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'p53 抑癌基因的调控网络（Regulatory network of p53 tumor suppressor）：Levine / 多团队 在 1979 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Regulatory network of p53 tumor suppressor: proposed by Levine / 多团队 in 1979; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['p53', '肿瘤'],
  },
  {
    id: 'bio-rb-retinoblastoma',
    category: 'biology',
    title: 'Rb 通路在细胞命运决定中的作用',
    titleJa: '細胞の運命を決定する上でのＲｂ経路の役割',
    titleEs: 'Rb 通路在细胞命运决定中的作用（Role of Rb pathway in cell fate decisions）：Friend / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Role of Rb pathway in cell fate decisions',
    year: 1986,
    proposer: 'Friend / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Rb 通路在细胞命运决定中的作用。',
    summaryJa: '生物学的分野における特定の困難な問題：細胞の運命を決定する上でのRb経路の役割。',
    summaryEs: 'Rb 通路在细胞命运决定中的作用（Role of Rb pathway in cell fate decisions）：Friend / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Role of Rb pathway in cell fate decisions.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 Rb 通路在细胞命运决定中的作用 是这样一个问题：「Rb 通路在细胞命运决定中的作用」是 生物 领域的 Rb 方向，涉及 Rb, 细胞 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Rb 通路在细胞命运决定中的作用」是 生物 领域的 Rb 方向，涉及 Rb, 细胞 等方面。',
    formal: 'Rb 通路在细胞命运决定中的作用（Role of Rb pathway in cell fate decisions）：Friend / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    formalJa: '細胞の運命決定におけるRb経路の役割： 1986年にFriend/Multiチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Rb 通路在细胞命运决定中的作用（Role of Rb pathway in cell fate decisions）：Friend / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Role of Rb pathway in cell fate decisions: proposed by Friend / 多团队 in 1986; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['Rb', '细胞'],
  },
  {
    id: 'bio-wnt-pathway',
    category: 'biology',
    title: 'Wnt 信号通路在干细胞中的精确作用',
    titleJa: '幹細胞におけるWntシグナル伝達経路の正確な役割',
    titleEs: 'Wnt 信号通路在干细胞中的精确作用（Precise role of Wnt signaling in stem cells）：Nusse / 多团队 在 1982 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise role of Wnt signaling in stem cells',
    year: 1982,
    proposer: 'Nusse / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Wnt 信号通路在干细胞中的精确作用。',
    summaryJa: '生物学的分野における特定の困難な問題：幹細胞におけるWntシグナル伝達経路の正確な役割。',
    summaryEs: 'Wnt 信号通路在干细胞中的精确作用（Precise role of Wnt signaling in stem cells）：Nusse / 多团队 在 1982 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Precise role of Wnt signaling in stem cells.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 Wnt 信号通路在干细胞中的精确作用。它说的是 「Wnt 信号通路在干细胞中的精确作用」是 生物 领域的 Wnt 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Wnt 信号通路在干细胞中的精确作用」是 生物 领域的 Wnt 方向。',
    formal: 'Wnt 信号通路在干细胞中的精确作用（Precise role of Wnt signaling in stem cells）：Nusse / 多团队 在 1982 年提出，相关实验/理论至今未完全解决。',
    formalJa: '幹細胞におけるWntシグナル伝達の正確な役割： 1982年にNusse/マルチチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'Wnt 信号通路在干细胞中的精确作用（Precise role of Wnt signaling in stem cells）：Nusse / 多团队 在 1982 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise role of Wnt signaling in stem cells: proposed by Nusse / 多团队 in 1982; related experiments/theory remain incomplete.',
    whyHard: '尽管 Nusse / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['Wnt'],
  },
  {
    id: 'bio-notch-pathway',
    category: 'biology',
    title: 'Notch 信号通路的精确调控',
    titleJa: 'ノッチシグナル伝達経路の正確な調節',
    titleEs: 'Notch 信号通路的精确调控（Precise regulation of Notch signaling）：Dexter / 多团队 在 1917 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise regulation of Notch signaling',
    year: 1917,
    proposer: 'Dexter / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Notch 信号通路的精确调控。',
    summaryJa: '生物学的分野における特定の困難な問題：ノッチシグナル伝達経路の正確な調節。',
    summaryEs: 'Notch 信号通路的精确调控（Precise regulation of Notch signaling）：Dexter / 多团队 在 1917 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Precise regulation of Notch signaling.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 Notch 信号通路的精确调控。它说的是 「Notch 信号通路的精确调控」是 生物 领域的 Notch 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Notch 信号通路的精确调控」是 生物 领域的 Notch 方向。',
    formal: 'Notch 信号通路的精确调控（Precise regulation of Notch signaling）：Dexter / 多团队 在 1917 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ノッチシグナル伝達の正確な調節： 1917年にDexter/MultiTeamによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Notch 信号通路的精确调控（Precise regulation of Notch signaling）：Dexter / 多团队 在 1917 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise regulation of Notch signaling: proposed by Dexter / 多团队 in 1917; related experiments/theory remain incomplete.',
    whyHard: '尽管 Dexter / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['Notch'],
  },
  {
    id: 'bio-hedgehog-pathway',
    category: 'biology',
    title: 'Hedgehog 信号通路 (Hh) 调控',
    titleJa: 'ハリネズミシグナル伝達経路（ Hh ）調節',
    titleEs: 'Hedgehog 信号通路 (Hh) 调控（Hedgehog (Hh) signaling regulation）：Nüsslein-Volhard / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Hedgehog (Hh) signaling regulation',
    year: 1980,
    proposer: 'Nüsslein-Volhard / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Hedgehog 信号通路 (Hh) 调控。',
    summaryJa: '生物学的分野における特定の難題：ハリネズミシグナル伝達経路（ Hh ）調節。',
    summaryEs: 'Hedgehog 信号通路 (Hh) 调控（Hedgehog (Hh) signaling regulation）：Nüsslein-Volhard / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Hedgehog (Hh) signaling regulation.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 Hedgehog 信号通路 (Hh) 调控。它说的是 「Hedgehog 信号通路 (Hh) 调控」是 生物 领域的 Hh 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Hedgehog 信号通路 (Hh) 调控」是 生物 领域的 Hh 方向。',
    formal: 'Hedgehog 信号通路 (Hh) 调控（Hedgehog (Hh) signaling regulation）：Nüsslein-Volhard / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ヘッジホッグ（ Hh ）シグナル伝達調節： 1980年にNüsslein - Volhard/マルチチームによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Hedgehog 信号通路 (Hh) 调控（Hedgehog (Hh) signaling regulation）：Nüsslein-Volhard / 多团队 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Hedgehog (Hh) signaling regulation: proposed by Nüsslein-Volhard / 多团队 in 1980; related experiments/theory remain incomplete.',
    whyHard: '尽管 Nüsslein-Volhard / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['Hh'],
  },
  {
    id: 'bio-mapk-pathway',
    category: 'biology',
    title: 'MAPK 信号通路的精确动力学',
    titleJa: 'MAPKシグナル伝達経路の正確な動態',
    titleEs: 'MAPK 信号通路的精确动力学（Precise dynamics of MAPK signaling pathway）：Krebs / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise dynamics of MAPK signaling pathway',
    year: 1986,
    proposer: 'Krebs / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：MAPK 信号通路的精确动力学。',
    summaryJa: '生物学的分野における特定の困難な問題： MAPKシグナル伝達経路の正確なダイナミクス。',
    summaryEs: 'MAPK 信号通路的精确动力学（Precise dynamics of MAPK signaling pathway）：Krebs / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Precise dynamics of MAPK signaling pathway.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 MAPK 信号通路的精确动力学。它说的是 「MAPK 信号通路的精确动力学」是 生物 领域的 MAPK 方向。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「MAPK 信号通路的精确动力学」是 生物 领域的 MAPK 方向。',
    formal: 'MAPK 信号通路的精确动力学（Precise dynamics of MAPK signaling pathway）：Krebs / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'MAPKシグナル伝達経路の正確なダイナミクス： Krebs/Multiチームは1986年に提案し、関連する実験/理論は完全には解決されていません。',
    formalEs: 'MAPK 信号通路的精确动力学（Precise dynamics of MAPK signaling pathway）：Krebs / 多团队 在 1986 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise dynamics of MAPK signaling pathway: proposed by Krebs / 多团队 in 1986; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['MAPK'],
  },
  {
    id: 'bio-pi3k-akt',
    category: 'biology',
    title: 'PI3K/Akt/mTOR 通路在代谢中的作用',
    titleJa: '代謝におけるPI 3 K/AKT/mTOR経路の役割',
    titleEs: 'PI3K/Akt/mTOR 通路在代谢中的作用（Role of PI3K/Akt/mTOR pathway in metabolism）：Cantley / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Role of PI3K/Akt/mTOR pathway in metabolism',
    year: 1990,
    proposer: 'Cantley / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：PI3K/Akt/mTOR 通路在代谢中的作用。',
    summaryJa: '生物学的分野における特定の難題：代謝におけるPI 3 K/AKT/mTOR経路の役割。',
    summaryEs: 'PI3K/Akt/mTOR 通路在代谢中的作用（Role of PI3K/Akt/mTOR pathway in metabolism）：Cantley / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Role of PI3K/Akt/mTOR pathway in metabolism.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 PI3K/Akt/mTOR 通路在代谢中的作用 的问题。它可以简单描述为 「PI3K/Akt/mTOR 通路在代谢中的作用」是 生物 领域的 PI3K 方向，涉及 PI3K, mTOR 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「PI3K/Akt/mTOR 通路在代谢中的作用」是 生物 领域的 PI3K 方向，涉及 PI3K, mTOR 等方面。',
    formal: 'PI3K/Akt/mTOR 通路在代谢中的作用（Role of PI3K/Akt/mTOR pathway in metabolism）：Cantley / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalJa: '代謝におけるPI 3 K/AKT/mTOR経路の役割： 1990年にCantley/Multiチームによって提案されたが、関連する実験/理論は完全に解決されていない。',
    formalEs: 'PI3K/Akt/mTOR 通路在代谢中的作用（Role of PI3K/Akt/mTOR pathway in metabolism）：Cantley / 多团队 在 1990 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Role of PI3K/Akt/mTOR pathway in metabolism: proposed by Cantley / 多团队 in 1990; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Cantley / 多团队 等人在 1990 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['PI3K', 'mTOR'],
  },
  {
    id: 'bio-cell-migration',
    category: 'biology',
    title: '集体细胞迁移 (collective migration) 机制',
    titleJa: '集団細胞移動のメカニズム',
    titleEs: '集体细胞迁移 (collective migration) 机制（Mechanism of collective cell migration）：Friedl / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Mechanism of collective cell migration',
    year: 2000,
    proposer: 'Friedl / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：集体细胞迁移 (collective migration) 机制。',
    summaryJa: '生物学分野における特定の困難な問題：集団細胞移動のメカニズム。',
    summaryEs: '集体细胞迁移 (collective migration) 机制（Mechanism of collective cell migration）：Friedl / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Mechanism of collective cell migration.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 集体细胞迁移 (collective migration) 机制 的核心问题是：「集体细胞迁移 (collective migration) 机制」是 生物 领域的 迁移 方向，涉及 迁移, 发育 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「集体细胞迁移 (collective migration) 机制」是 生物 领域的 迁移 方向，涉及 迁移, 发育 等方面。',
    formal: '集体细胞迁移 (collective migration) 机制（Mechanism of collective cell migration）：Friedl / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: '集団細胞移動のメカニズム： Friedl/Multiチームは2000年に提案したが、関連する実験/理論は完全には解決されていない。',
    formalEs: '集体细胞迁移 (collective migration) 机制（Mechanism of collective cell migration）：Friedl / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Mechanism of collective cell migration: proposed by Friedl / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['迁移', '发育'],
  },
  {
    id: 'bio-morphogen',
    category: 'biology',
    title: '形态发生素 (morphogen) 梯度的精确读取',
    titleJa: 'モルフォゲン勾配の正確な読み取り',
    titleEs: '形态发生素 (morphogen) 梯度的精确读取（Precise readout of morphogen gradients）：Wolpert / 多团队 在 1969 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Precise readout of morphogen gradients',
    year: 1969,
    proposer: 'Wolpert / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：形态发生素 (morphogen) 梯度的精确读取。',
    summaryJa: '生物学的分野における特定の困難な問題：モルホーゲン勾配の正確な読み取り。',
    summaryEs: '形态发生素 (morphogen) 梯度的精确读取（Precise readout of morphogen gradients）：Wolpert / 多团队 在 1969 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Precise readout of morphogen gradients.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 形态发生素 (morphogen) 梯度的精确读取。它说的是 「形态发生素 (morphogen) 梯度的精确读取」是 生物 领域的 发育 方向，涉及 发育, 形态 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「形态发生素 (morphogen) 梯度的精确读取」是 生物 领域的 发育 方向，涉及 发育, 形态 等方面。',
    formal: '形态发生素 (morphogen) 梯度的精确读取（Precise readout of morphogen gradients）：Wolpert / 多团队 在 1969 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'モルフォジェン勾配の正確な読み出し： 1969年にWolpert/MultiTeamによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: '形态发生素 (morphogen) 梯度的精确读取（Precise readout of morphogen gradients）：Wolpert / 多团队 在 1969 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Precise readout of morphogen gradients: proposed by Wolpert / 多团队 in 1969; related experiments/theory remain incomplete.',
    whyHard: '尽管 Wolpert / 多团队 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['发育', '形态'],
  },
  {
    id: 'bio-drosophila-segmentation',
    category: 'biology',
    title: '果蝇分节基因调控网络',
    titleJa: 'ショウジョウバエセグメンテーション遺伝子調節ネットワーク',
    titleEs: '果蝇分节基因调控网络（Drosophila segmentation gene regulatory network）：Nüsslein-Volhard / Wieschaus 在 1980 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Drosophila segmentation gene regulatory network',
    year: 1980,
    proposer: 'Nüsslein-Volhard / Wieschaus',
    difficulty: 3,
    reward: 300,
    status: 'solved',
    summary: '一道 生物 领域的具体硬问题：果蝇分节基因调控网络。',
    summaryJa: '生物学的分野における特定の困難な問題：ミバエは遺伝子調節ネットワークを調節する。',
    summaryEs: '果蝇分节基因调控网络（Drosophila segmentation gene regulatory network）：Nüsslein-Volhard / Wieschaus 在 1980 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Drosophila segmentation gene regulatory network.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 果蝇分节基因调控网络 的核心问题是：「果蝇分节基因调控网络」是 生物 领域的 发育 方向。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「果蝇分节基因调控网络」是 生物 领域的 发育 方向。',
    formal: '果蝇分节基因调控网络（Drosophila segmentation gene regulatory network）：Nüsslein-Volhard / Wieschaus 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ショウジョウバエのセグメンテーション遺伝子調節ネットワーク： 1980年にNüsslein - Volhard/Wieschausによって提案されたが、関連する実験/理論は完全には解決されていない。',
    formalEs: '果蝇分节基因调控网络（Drosophila segmentation gene regulatory network）：Nüsslein-Volhard / Wieschaus 在 1980 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Drosophila segmentation gene regulatory network: proposed by Nüsslein-Volhard / Wieschaus in 1980; related experiments/theory remain incomplete.',
    whyHard: '尽管 Nüsslein-Volhard / Wieschaus 等人在过去几十年里推动了很多进展，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 这道问题仍然开放。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['发育'],
  },
  {
    id: 'bio-hox-gene',
    category: 'biology',
    title: 'Hox 基因在脊椎动物轴向模式中的作用',
    titleJa: '脊椎動物の軸方向パターンにおけるHox遺伝子の役割',
    titleEs: 'Hox 基因在脊椎动物轴向模式中的作用（Role of Hox genes in vertebrate axial patterning）：Lewis / 多团队 在 1983 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Role of Hox genes in vertebrate axial patterning',
    year: 1983,
    proposer: 'Lewis / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Hox 基因在脊椎动物轴向模式中的作用。',
    summaryJa: '生物学的分野における特定の難題：脊椎動物の軸方向パターンにおけるHOX遺伝子の役割。',
    summaryEs: 'Hox 基因在脊椎动物轴向模式中的作用（Role of Hox genes in vertebrate axial patterning）：Lewis / 多团队 在 1983 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Role of Hox genes in vertebrate axial patterning.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 Hox 基因在脊椎动物轴向模式中的作用 是这样一个问题：「Hox 基因在脊椎动物轴向模式中的作用」是 生物 领域的 Hox 方向，涉及 Hox, 发育 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Hox 基因在脊椎动物轴向模式中的作用」是 生物 领域的 Hox 方向，涉及 Hox, 发育 等方面。',
    formal: 'Hox 基因在脊椎动物轴向模式中的作用（Role of Hox genes in vertebrate axial patterning）：Lewis / 多团队 在 1983 年提出，相关实验/理论至今未完全解决。',
    formalJa: '脊椎動物の軸方向パターンにおけるHOX遺伝子の役割： Lewis/Multiチームは1983年に提案し、関連する実験/理論は完全には解決されていない。',
    formalEs: 'Hox 基因在脊椎动物轴向模式中的作用（Role of Hox genes in vertebrate axial patterning）：Lewis / 多团队 在 1983 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Role of Hox genes in vertebrate axial patterning: proposed by Lewis / 多团队 in 1983; related experiments/theory remain incomplete.',
    whyHard: '这道问题被 Lewis / 多团队 等人在 1983 年提出，但至今未完全解决。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['Hox', '发育'],
  },
  {
    id: 'bio-crispr-ykai',
    category: 'biology',
    title: 'CRISPR 转座 (transposase) 整合',
    titleJa: 'CRISPRトランスポザーゼの組み込み',
    titleEs: 'CRISPR 转座 (transposase) 整合（CRISPR-associated transposon (CAST) integration）：Peters / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'CRISPR-associated transposon (CAST) integration',
    year: 2017,
    proposer: 'Peters / 多团队',
    difficulty: 4,
    reward: 800,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：CRISPR 转座 (transposase) 整合。',
    summaryJa: '生物学的分野における特定の困難な問題： CRISPRトランスポザーゼの統合。',
    summaryEs: 'CRISPR 转座 (transposase) 整合（CRISPR-associated transposon (CAST) integration）：Peters / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: CRISPR-associated transposon (CAST) integration.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 CRISPR 转座 (transposase) 整合 是这样一个问题：「CRISPR 转座 (transposase) 整合」是 生物 领域的 CRISPR 方向，涉及 CRISPR, 转座 等方面。 这听起来可能很抽象，但想象一下你在拼一个看不见的拼图 — 你能看到的只是一些零散的碎片。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「CRISPR 转座 (transposase) 整合」是 生物 领域的 CRISPR 方向，涉及 CRISPR, 转座 等方面。',
    formal: 'CRISPR 转座 (transposase) 整合（CRISPR-associated transposon (CAST) integration）：Peters / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'CRISPR関連トランスポゾン（ CAST ）統合： Peters/Multi - teamは、関連する実験/理論がまだ完全に解決されていないことを2017年に提案した。',
    formalEs: 'CRISPR 转座 (transposase) 整合（CRISPR-associated transposon (CAST) integration）：Peters / 多团队 在 2017 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'CRISPR-associated transposon (CAST) integration: proposed by Peters / 多团队 in 2017; related experiments/theory remain incomplete.',
    whyHard: '「CRISPR 转座 (transposase) 整合」是 生物 领域一个被广泛认可的核心难题。生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。目前缺乏直接探测的实验方法或统一的理论框架。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['CRISPR', '转座'],
  },
  {
    id: 'bio-rna-splicing-tre',
    category: 'biology',
    title: 'TREX/TREX-2 mRNA 出核机制',
    titleJa: 'ＴＲＥＸ ／ ＴＲＥＸ － ２ ｍＲＮＡの核形成機構',
    titleEs: 'TREX/TREX-2 mRNA 出核机制（TREX/TREX-2 mRNA nuclear export mechanism）：Strässer / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'TREX/TREX-2 mRNA nuclear export mechanism',
    year: 2000,
    proposer: 'Strässer / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：TREX/TREX-2 mRNA 出核机制。',
    summaryJa: '生物学的分野における特定の難題： ＴＲＥＸ ／ ＴＲＥＸ － ２ ｍＲＮＡの核形成機構。',
    summaryEs: 'TREX/TREX-2 mRNA 出核机制（TREX/TREX-2 mRNA nuclear export mechanism）：Strässer / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: TREX/TREX-2 mRNA nuclear export mechanism.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这就是 TREX/TREX-2 mRNA 出核机制。它说的是 「TREX/TREX-2 mRNA 出核机制」是 生物 领域的 mRNA 方向，涉及 mRNA, 出核 等方面。 科学家们就像侦探一样，需要从各种间接的线索中找到答案。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「TREX/TREX-2 mRNA 出核机制」是 生物 领域的 mRNA 方向，涉及 mRNA, 出核 等方面。',
    formal: 'TREX/TREX-2 mRNA 出核机制（TREX/TREX-2 mRNA nuclear export mechanism）：Strässer / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'TREX/TREX -2 mRNA核輸出メカニズム（ TREX/TREX -2 mRNA核輸出メカニズム） ： 2000年にSträsser/複数のチームが提案され、関連する実験/理論が完全に解決されていない。',
    formalEs: 'TREX/TREX-2 mRNA 出核机制（TREX/TREX-2 mRNA nuclear export mechanism）：Strässer / 多团队 在 2000 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'TREX/TREX-2 mRNA nuclear export mechanism: proposed by Strässer / 多团队 in 2000; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['mRNA', '出核'],
  },
  {
    id: 'bio-r-loops',
    category: 'biology',
    title: 'R-loop 在基因组稳定性中的作用',
    titleJa: 'ゲノム安定性におけるRループの役割',
    titleEs: 'R-loop 在基因组稳定性中的作用（Role of R-loops in genome stability）：Thomas / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Role of R-loops in genome stability',
    year: 1976,
    proposer: 'Thomas / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：R-loop 在基因组稳定性中的作用。',
    summaryJa: '生物学的分野における特定の難題：ゲノム安定性におけるRループの役割。',
    summaryEs: 'R-loop 在基因组稳定性中的作用（Role of R-loops in genome stability）：Thomas / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Role of R-loops in genome stability.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 R-loop 在基因组稳定性中的作用 的核心问题是：「R-loop 在基因组稳定性中的作用」是 生物 领域的 基因组 方向，涉及 基因组, 稳定性 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「R-loop 在基因组稳定性中的作用」是 生物 领域的 基因组 方向，涉及 基因组, 稳定性 等方面。',
    formal: 'R-loop 在基因组稳定性中的作用（Role of R-loops in genome stability）：Thomas / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'ゲノム安定性におけるRループの役割： Thomas/Multiチームは1976年に提案し、関連する実験/理論は完全に解決されていません。',
    formalEs: 'R-loop 在基因组稳定性中的作用（Role of R-loops in genome stability）：Thomas / 多团队 在 1976 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Role of R-loops in genome stability: proposed by Thomas / 多团队 in 1976; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['基因组', '稳定性'],
  },
  {
    id: 'bio-sirtuins',
    category: 'biology',
    title: 'Sirtuin 家族在寿命中的作用',
    titleJa: '長寿におけるサーチュイン家の役割',
    titleEs: 'Sirtuin 家族在寿命中的作用（Role of sirtuin family in longevity）：Guarente / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Role of sirtuin family in longevity',
    year: 1995,
    proposer: 'Guarente / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Sirtuin 家族在寿命中的作用。',
    summaryJa: '生物学的分野における特定の困難な問題：長寿におけるサーチュイン家の役割。',
    summaryEs: 'Sirtuin 家族在寿命中的作用（Role of sirtuin family in longevity）：Guarente / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Role of sirtuin family in longevity.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 Sirtuin 家族在寿命中的作用 的问题。它可以简单描述为 「Sirtuin 家族在寿命中的作用」是 生物 领域的 sirtuin 方向，涉及 sirtuin, 寿命 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Sirtuin 家族在寿命中的作用」是 生物 领域的 sirtuin 方向，涉及 sirtuin, 寿命 等方面。',
    formal: 'Sirtuin 家族在寿命中的作用（Role of sirtuin family in longevity）：Guarente / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    formalJa: '長寿におけるサーチュイン家の役割： 1995年にGuarente/複数のチームによって提案されたが、関連する実験/理論はまだ完全に解決されていない。',
    formalEs: 'Sirtuin 家族在寿命中的作用（Role of sirtuin family in longevity）：Guarente / 多团队 在 1995 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Role of sirtuin family in longevity: proposed by Guarente / 多团队 in 1995; related experiments/theory remain incomplete.',
    whyHard: '它涉及多个子领域的交叉，生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 实验上极难直接测量，理论上也缺乏完整的描述。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['sirtuin', '寿命'],
  },
  {
    id: 'bio-mtor-aging',
    category: 'biology',
    title: 'mTOR 通路与寿命延长',
    titleJa: 'mTORパスウェイと寿命延長',
    titleEs: 'mTOR 通路与寿命延长（mTOR pathway and lifespan extension）：Blagosklonny / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'mTOR pathway and lifespan extension',
    year: 2009,
    proposer: 'Blagosklonny / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：mTOR 通路与寿命延长。',
    summaryJa: '生物学的分野における特定の困難な問題： mTOR経路と長寿の延長。',
    summaryEs: 'mTOR 通路与寿命延长（mTOR pathway and lifespan extension）：Blagosklonny / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: mTOR pathway and lifespan extension.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 mTOR 通路与寿命延长 的核心问题是：「mTOR 通路与寿命延长」是 生物 领域的 mTOR 方向，涉及 mTOR, 寿命 等方面。 想象你手上有一些非常微小的工具，但它们太小了看不见。你需要用聪明的办法让它们告诉你自己是什么、在做什么。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「mTOR 通路与寿命延长」是 生物 领域的 mTOR 方向，涉及 mTOR, 寿命 等方面。',
    formal: 'mTOR 通路与寿命延长（mTOR pathway and lifespan extension）：Blagosklonny / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'mTOR経路と寿命の延長： Blagosklonny/2009年に複数のチームが提案され、関連する実験/理論は完全に解決されていません。',
    formalEs: 'mTOR 通路与寿命延长（mTOR pathway and lifespan extension）：Blagosklonny / 多团队 在 2009 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'mTOR pathway and lifespan extension: proposed by Blagosklonny / 多团队 in 2009; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['mTOR', '寿命'],
  },
  {
    id: 'bio-klotho-aging',
    category: 'biology',
    title: 'Klotho 蛋白与衰老',
    titleJa: 'クロトプロテインとエイジング',
    titleEs: 'Klotho 蛋白与衰老（Klotho protein and aging）：Kuro-o / 多团队 在 1997 年提出，相关实验/理论至今未完全解决。',
    titleEn: 'Klotho protein and aging',
    year: 1997,
    proposer: 'Kuro-o / 多团队',
    difficulty: 3,
    reward: 300,
    status: 'partially_solved',
    summary: '一道 生物 领域的具体硬问题：Klotho 蛋白与衰老。',
    summaryJa: '生物学的分野における特定の困難な問題：クロトタンパク質と老化。',
    summaryEs: 'Klotho 蛋白与衰老（Klotho protein and aging）：Kuro-o / 多团队 在 1997 年提出，相关实验/理论至今未完全解决。',
    summaryEn: 'A specific hard problem in biology: Klotho protein and aging.',
    kid: '想象细胞是一个超精密的工厂，里面每时每刻都在进行上千种化学反应。 这是一道关于 Klotho 蛋白与衰老 的问题。它可以简单描述为 「Klotho 蛋白与衰老」是 生物 领域的 klotho 方向，涉及 klotho, 衰老 等方面。 想象你有一台极其复杂的机器，但说明书不完整 — 你需要靠推理和实验把说明书补齐。',
    kidEn: 'Imagine you have a very tiny tool, but it\'s too small to see. You need clever ways to make it tell you what it is and what it is doing. 「Klotho 蛋白与衰老」是 生物 领域的 klotho 方向，涉及 klotho, 衰老 等方面。',
    formal: 'Klotho 蛋白与衰老（Klotho protein and aging）：Kuro-o / 多团队 在 1997 年提出，相关实验/理论至今未完全解决。',
    formalJa: 'Klotho protein and aging (Klotho protein and aging): Kuro - o/Multiチームは1997年に提案しており、関連する実験・理論は完全には解決されていない。',
    formalEs: 'Klotho 蛋白与衰老（Klotho protein and aging）：Kuro-o / 多团队 在 1997 年提出，相关实验/理论至今未完全解决。',
    formalEn: 'Klotho protein and aging: proposed by Kuro-o / 多团队 in 1997; related experiments/theory remain incomplete.',
    whyHard: '它的核心难度在于：生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。 任何真正的突破都需要新的实验或理论范式。',
    whyHardEn: '生命系统是多个尺度、多个组分耦合的复杂网络，难以单因素因果分离。',
    aiPrompt: '你是一位生物学家，向一个 12 岁的小朋友用比喻解释这道生物问题，然后说明分子机制、当前模型和争议、关键文献。',
    aiPromptEn: 'You are a rigorous 生物 professor. Explain this problem to a 12-year-old using analogies, then give a formal statement, current status, and key references.',
    tags: ['klotho', '衰老'],
  }
];

// 派生：按类别分组
export const PROBLEMS_BY_CATEGORY = PROBLEMS.reduce((acc, p) => {
  (acc[p.category] = acc[p.category] || []).push(p);
  return acc;
}, {});

// 工具函数
export function getProblemById(id) {
  return PROBLEMS.find(p => p.id === id);
}

export function searchProblems(query) {
  if (!query) return PROBLEMS;
  const q = query.toLowerCase();
  return PROBLEMS.filter(p =>
    p.title.toLowerCase().includes(q) ||
    p.titleEn.toLowerCase().includes(q) ||
    p.summary.toLowerCase().includes(q) ||
    (p.summaryEn && p.summaryEn.toLowerCase().includes(q)) ||
    p.kid.toLowerCase().includes(q) ||
    (p.kidEn && p.kidEn.toLowerCase().includes(q)) ||
    p.tags.some(t => t.toLowerCase().includes(q))
  );
}
